var M$ = Object.defineProperty;
var L$ = (e, t, n) => t in e ? M$(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var xo = (e, t, n) => L$(e, typeof t != "symbol" ? t + "" : t, n);
import { createI18n as N$, useI18n as Ne } from "vue-i18n";
import { defineComponent as K, createElementBlock as C, openBlock as b, createElementVNode as d, createTextVNode as ne, toDisplayString as k, unref as T, computed as V, getCurrentScope as Yv, onScopeDispose as Gv, ref as R, readonly as Gu, onMounted as Re, nextTick as rn, getCurrentInstance as bo, toRef as Wo, customRef as Zv, isRef as Pt, watch as le, shallowRef as ea, reactive as tt, watchEffect as Wt, useAttrs as Xv, onBeforeUnmount as Jt, createBlock as ie, Teleport as F$, withDirectives as ot, createCommentVNode as M, mergeProps as Ta, withModifiers as Ke, withKeys as rl, createVNode as q, Transition as st, toHandlers as Nd, withCtx as he, normalizeStyle as Zu, normalizeClass as ue, vShow as Ds, renderSlot as Xe, normalizeProps as R$, guardReactiveProps as V$, inject as Ye, useCssVars as En, useSlots as B$, toRefs as Jv, createSlots as ui, resolveComponent as ut, pushScopeId as dn, popScopeId as fn, Fragment as $e, renderList as ke, mergeModels as Fd, useModel as H$, onBeforeMount as ko, markRaw as il, h as za, onUnmounted as Xu, provide as Zc, triggerRef as kr, isReactive as Xc, vModelText as Wl, vModelRadio as Cs, toValue as Bn, createStaticVNode as U$, setBlockTracking as pi, toRaw as z$ } from "vue";
import { defineStore as St, storeToRefs as Ce } from "pinia";
import * as Ju from "@sentry/vue";
import { DateTime as Me, Interval as Qv } from "luxon";
import No from "leaflet";
import { useRoute as Qu } from "vue-router";
import io from "maplibre-gl";
const jl = (e) => e && typeof e == "object" && !Array.isArray(e), Jc = (e, ...t) => {
  if (!t.length) return e;
  const n = t.shift();
  if (jl(e) && jl(n))
    for (const o in n)
      jl(n[o]) ? (e[o] || Object.assign(e, { [o]: {} }), Jc(e[o], n[o])) : Object.assign(e, { [o]: n[o] });
  return Jc(e, ...t);
}, W$ = Jc(
  {},
  { en: {
    vacvComponents: {
      common: {
        buttons: {
          open: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Open" } },
          close: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Close" } },
          select: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Select" } },
          selected: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Selected" } },
          backToTop: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Back to top of page" } },
          submit: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Submit" } },
          add: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Add" } },
          added: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Added" } },
          showOptions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Show options" } },
          hideOptions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Hide options" } }
        },
        generic: {
          loading: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Loading" } }
        },
        labels: {
          aeroplan: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Aeroplan" } },
          details: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Details" } },
          selectAnOption: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Select an option" } }
        },
        messages: {
          "go-back": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Go back to results" } },
          "fallback-img": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Image coming soon" } }
        },
        bookingsummary: {
          labels: {
            "booking-summary": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Booking Summary" } },
            package: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Package" } },
            flight: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Flight" } },
            transfers: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Transfers" } },
            hotel: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Hotel" } },
            "hotel-and-rooms": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Hotel & Room(s)" } },
            "round-trip-flight": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Round-trip flight" } },
            ancillary: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Extras" } },
            traveller: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "traveller" } },
            travellers: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "travellers" } },
            included: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Included" } },
            travelprotection: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Travel protection - " } },
            privateTransfer: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Private transfers - " } },
            "extras-included": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Including selected extras" } }
          },
          messages: {
            "see-details": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "See details" } },
            "hide-details": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Hide details" } },
            total: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Total" } },
            deposit: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Deposit" } },
            "continue-booking": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Continue" } }
          },
          errors: {
            "no-hotel-room": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "We can't load your hotel & room details right now. You'll be able to see them at the next step." } },
            "no-flights": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "We can't load your flight details right now. You'll be able to see them after you select your room." } },
            ancillary: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "We can't load your extras right now. You'll be able to see them at the next step." } }
          },
          aeroplan: {
            "use-your-points-to-save": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Use your points to save" } }
          }
        },
        pricedetails: {
          peradult: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "per adult" } },
          total: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Total" } },
          taxesincl: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Taxes & fees incl." } },
          title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Price Details" } },
          popoverLink: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Show price details" } },
          adult: { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3 }], s: "adult" }, { t: 2, i: [{ t: 3 }], s: "adults" }] } },
          child: { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3 }], s: "child" }, { t: 2, i: [{ t: 3 }], s: "children" }] } },
          taxesFees: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "taxes & fees" } },
          estimatedTotal: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Estimated Total" } },
          perNight: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "per night" } }
        },
        phoneNumber: {
          guestPhoneNumber: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "1-866-529-2079" } },
          B2CPhoneNumber: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "1-877-752-5510" } },
          B2BPhoneNumber: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "1-877-752-7710" } }
        }
      },
      wasPrice: {
        was: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Was " } },
        save: { t: 0, b: { t: 2, i: [{ t: 3, v: "Save " }, { t: 4, k: "percent" }, { t: 3, v: "%" }] } }
      },
      guestsInput: {
        label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Guests" } },
        placeholder: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Guests" } },
        insideDataGuests: { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3 }], s: "no guests" }, { t: 2, i: [{ t: 4, k: "n" }, { t: 3, v: " Guest" }] }, { t: 2, i: [{ t: 4, k: "n" }, { t: 3, v: " Guests" }] }] } },
        insideDataRooms: { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 4, k: "n" }, { t: 3, v: " Room" }] }, { t: 2, i: [{ t: 4, k: "n" }, { t: 3, v: " Rooms" }] }] } },
        adults: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Adults (Age 18+)" } },
        children: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Children (Age 2-17)" } },
        infants: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Infants (under age 2)" } },
        counter: {
          add: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Add" } },
          remove: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Remove" } }
        },
        rooms: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Rooms" } },
        childAge: { t: 0, b: { t: 2, i: [{ t: 3, v: "Child " }, { t: 4, k: "n" }, { t: 3, v: " age" }] } },
        buttonLabel: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "DONE" } },
        roomsAdvisory: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Max. 1 room for bookings with children/infants" } },
        "advisoryTravellers7+": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "<strong>For 7-9 travellers:</strong> call 1-866-529-2079." } },
        "advisoryTravellers10+": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "<strong>10+ travellers:</strong> visit our <a href='https://vacations.aircanada.com/en/group-form' target='_blank'>Group Travel page</a>." } },
        advisoryNoInfantFeature: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "<strong>Children under the age of 2:</strong> call 1-866-529-2079." } },
        infantTurns2: { t: 0, b: { t: 2, i: [{ t: 3, v: "If your infant turns 2 during your trip, they will require a return seat. Please call us at " }, { t: 4, k: "num" }, { t: 3, v: " to complete your booking." }] } },
        oneInfantPerAdult: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Max. 1 infant per adult" } },
        errors: {
          GuestsSelection: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Number of guests is invalid" } },
          RoomSelection: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "When booking multiple rooms, adults must be separated equally between rooms" } },
          ChildAgeSelection: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter the child's age at departure date" } },
          ChildUnderTwo: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "If you would like to include one or more children under the age of 2 years old, please call us at 1 866 529-2079 to complete your booking." } }
        }
      },
      dialogs: {
        cubaPopup: {
          title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Travelling to Cuba" } },
          question: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Does this booking include one or more passenger(s) who is a U.S. citizen, U.S. permanent resident, or who is otherwise subject to U.S. jurisdiction?" } },
          changeDestination: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Change Destination" } },
          yes: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Yes" } },
          no: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "No" } },
          continue: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Continue Booking" } },
          yesSelected: { t: 0, b: { t: 2, i: [{ t: 3 }], s: '<p>Travel to/from Cuba is restricted for U.S citizens, U.S permanent residents and other persons subject to U.S jurisdiction.</p><p>The Office of Foreign Assets Control (OFAC) requires that all such travelers fill out a declaration to acknowledge that they are holders of a specific travel license for Cuba, or that their travel to Cuba is related to one of the following general license categories:</p><ul><li>Family visits</li><li>Official business of the U.S. government, foreign governments, and certain intergovernmental organizations</li><li>Journalistic activity</li><li>Professional research/professional meetings and conferences</li><li>Educational activities/group people-to-people educational travel</li><li>Religious activities</li><li>Support for the Cuban people</li><li>Humanitarian projects</li><li>Activities of private foundations or research or educational institutes</li><li>Exportation, importation, or transmission of information or information materials</li><li>Certain authorized export transactions</li></li></ul><p>Before booking a trip to Cuba, U.S. travellers should consult the U.S. Department of the Treasury website for <a href="https://ofac.treasury.gov/faqs#cuba" target="_blank">more information on Cuba Sanctions</a>.</p><p>U.S. nationals (U.S. citizens or U.S. residents), even legally authorized travellers, are prohibited from engaging in direct financial transactions with certain Cuban hotels, shops, and tour agencies owned or controlled by the Cuba military or intelligence services as listed on the U.S State Department <a href="https://www.state.gov/cuba-sanctions/cuba-restricted-list/" target="_blank">Cuba Restricted List</a>. Consult the Cuba Restricted List for more information.</p><p>Recent changes in U.S. sanctions on Cuba also prohibit U.S. nationals from lodging, paying for lodging, or making reservations at certain properties in Cuba. Consult the <a href="https://www.state.gov/cuba-sanctions/cuba-prohibited-accommodations-list/cuba-prohibited-accommodations-list-initial-publication/" target="_blank">Prohibited Accommodation List</a> for more information.</p>' } }
        },
        confirmation: {
          "modal-label-accessibility": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Confirmation" } }
        }
      },
      tripAdvisor: {
        review: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "review" } },
        reviews: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "reviews" } },
        "access-rating": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Tripadvisor rating " } },
        "access-bubbles": { t: 0, b: { t: 2, i: [{ t: 3 }], s: " of 5 bubbles" } }
      },
      aeroplan: {
        aeroplan: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Aeroplan" } },
        "signin-btn": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Sign in" } },
        "cont-as-guest-btn": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Continue as Guest" } },
        "earn-or-book-and-save": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Earn on your vacation or book with points and save" } },
        "login-banner": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Book with points or earn for your next vacation." } },
        points: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "pts" } },
        "points-initial-text": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Select points" } },
        "points-zero": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "No points" } },
        redeem: {
          "aeroplan-points": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Aeroplan points" } },
          advisory: { t: 0, b: { t: 2, i: [{ t: 3, v: "You need a minimum of " }, { t: 4, k: "unitPoint" }, { t: 3, v: " points to redeem" }] } },
          description: { t: 0, b: { t: 2, i: [{ t: 3, v: 'You can redeem up to <span class="bold">' }, { t: 4, k: "points" }, { t: 3, v: ' Aeroplan pts</span> to save <span class="bold">' }, { t: 4, k: "dollars" }, { t: 3, v: "</span>" }] } },
          "description-bonus": { t: 0, b: { t: 2, i: [{ t: 3, v: 'You can redeem up to <span class="was-points bold">' }, { t: 4, k: "wasPoints" }, { t: 3, v: '</span> <span class="bold red">' }, { t: 4, k: "points" }, { t: 3, v: ' pts</span> to save <span class="bold">' }, { t: 4, k: "dollars" }, { t: 3, v: "</span>" }] } },
          "error-message": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter a valid number of points." } },
          "points-to-redeem": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Points to redeem" } },
          "use-points-btn": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Use your points" } },
          "apply-btn": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Apply" } },
          "cancel-btn": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Cancel" } },
          "change-btn": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Change" } },
          "remove-btn": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Remove" } },
          bonus: { t: 0, b: { t: 2, i: [{ t: 3, v: "Bonus " }, { t: 4, k: "percentage" }, { t: 3, v: "% added value" }] } },
          "points-applied": { t: 0, b: { t: 2, i: [{ t: 3, v: '<span class="bold">' }, { t: 4, k: "points" }, { t: 3, v: " points</span> " }, { t: 9, v: "|" }, { t: 3, v: ' <span class="bold red">' }, { t: 4, k: "amount" }, { t: 3, v: " off</span>" }] } }
        }
      },
      carousel: {
        "aria-modal": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "View image gallery" } },
        "aria-next": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Next" } },
        "aria-previous": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Previous" } },
        caption: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Image" } },
        slidenum: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "of" } },
        photo: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Photo of" } }
      },
      confirmation: {
        labels: {
          title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Booking confirmed!" } },
          bookingNumber: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Your booking number is:" } },
          bookingSummaryTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Booking summary" } },
          travellersTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Travellers" } },
          accommodationTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Hotel & Room(s)" } },
          print: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Print Confirmation" } },
          getReadyTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Get ready for your vacation" } },
          aeroplanJoin: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Join Aeroplan" } },
          aeroplanJoinLink: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "https://www.aircanada.com/aeroplan/member/enrolment" } },
          aeroplanAddNumber: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Add Aeroplan number(s)" } },
          aeroplanAddNumberLink: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "https://vacations.aircanada.com/en/travel-info/manage-your-booking" } },
          hotelTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Hotel & Room(s)" } },
          privateTransfer: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Round-trip Private Airport Transfer" } },
          sharedTransfer: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Round-trip Shared Airport Transfer (included)" } },
          checkInTime: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Check-in:" } },
          checkOutTime: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Check-out:" } },
          flightTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Round-trip flight" } },
          ancillaryTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Extras" } },
          priceDetailsTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Price Details" } },
          privateTransferDescription: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "It's not too late to add a round-trip private transfer between the airport and your resort." } },
          privateTransferButton: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Add to your booking" } },
          paymentTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Payment method(s)" } },
          uplift: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Flex Pay" } },
          CAREFLEX: {
            name: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "CareFlex" } },
            inclusions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Includes cancellation with refund or travel credit, booking changes and package transfer. Certain conditions apply." } }
          },
          CAREFREE: {
            name: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "CareFree" } },
            inclusions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Includes standard seat selection and our Price Drop Guarantee. Certain conditions apply." } }
          },
          CFCTA: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "CFCTA Contribution" } },
          insuranceTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Travel insurance" } },
          insuranceLogoTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Allianz Global Assistance" } },
          insuranceDescription: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Protect your health and finances so that you can travel with confidence in Canada and around the world. Get valuable insurance coverage with 24/7 emergency assistance from the team at Allianz Global Assistance, who are there to support you throughout your journey." } },
          insuranceContact: { t: 0, b: { t: 2, i: [{ t: 3 }], s: 'or contact Allianz Global Assistance today at <span class="tel">1-833-358-0582</span>.' } },
          insuranceNote: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Travel insurance is underwritten by CUMIS General Insurance Company, a member of The Co-operators group of companies and administered by Allianz Global Assistance, which is a registered business name of AZGA Service Canada Inc." } },
          insuranceBtn: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Get an online quote" } },
          seatSelTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Advance seat selection" } },
          seatSelOption1: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Select your seat now and/or upgrade to a preferred seat at an extra cost." } },
          seatSelOption2: { t: 0, b: { t: 2, i: [{ t: 3 }], s: 'Select your seat later via the <a href="https://vacations.aircanada.com/en/travel-info/manage-your-booking" target="_blank" class="link">Manage Your Booking</a> page.' } },
          seatSelOption3: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "If you added CareFree to your booking, select your seat via the link above or contact us at 1 866 529-2079 to upgrade to a preferred seat." } },
          seatSelBtn: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Select your seat" } },
          giftCard: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Air Canada Gift Card ending with" } },
          endingWith: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "••••" } }
        },
        messages: {
          thankYou: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Thank you for travelling with Air Canada Vacations." } },
          checkInbox: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Check your inbox soon for your booking details." } },
          aeroplanEnroll: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `<h2 class="h3style">Not an Aeroplan Member?</h2>Canada's premier travel loyalty program helps members travel more and travel better by providing access to amazing perks.` } },
          aeroplanBenefits: { t: 0, b: { t: 2, i: [{ t: 3 }], s: '<ul class="spa-list special-list details-2col"><li>Earn points on all flight-inclusive packages</li><li>Reach Aeroplan Elite&trade; Status faster on vacation packages. Earn on ALL qualifying currencies.</li><li>Earn faster when you book with eligible credit cards</li><li>Free texting while you fly with <a href="https://www.aircanada.com/ca/en/aco/home/fly/onboard/in-flight-entertainment-and-connectivity.html#/wifi" target="_blank" class="link">onboard WiFi</a>. Sponsored by Bell</li><li>Redeem for as low as 1,000 points</li><li>Exclusive discounts on activities</li><li>Combine points with family members to get rewards sooner thanks to Aeroplan Family Sharing</li></ul>' } },
          aeroplanAlready: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "<strong>Did you forget to provide Aeroplan number(s) for yourself or other travellers on your booking?</strong><br>Don't miss the Aeroplan points that can be earned!" } },
          ancillaryTravelProtectionLink: { t: 0, b: { t: 2, i: [{ t: 3 }], s: '<a href="https://vacations.aircanada.com/en/travel-info/travel-protection" target="_blank" class="link">Learn more</a>' } },
          privateTransfer: { t: 0, b: { t: 2, i: [{ t: 3, v: '<ul class="spa-list special-list"><li>Transfer service to and from ' }, { t: 4, k: "destination" }, { t: 3, v: " airport.</li><li>We'll send you transfer instructions before your trip. We'll also send a voucher with your travel documents, which you'll need to present at pick-up.</li></ul>" }] } },
          sharedTransfer: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `<ul class="spa-list special-list"><li>Transportation between the airport and your hotel is included in your package.</li><li>We'll send you transfer instructions before your trip.</li></ul>` } }
        }
      },
      filters: {
        filteredBy: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Filtered by" } },
        clearFilters: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Clear all filters" } },
        rangeSlider: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Price Range Per Adult ($)" } },
        destinations: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Destinations" } },
        moreDestinations: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "More destinations" } },
        moreAmenities: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "More amenities" } },
        deals: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Deals" } },
        starRating: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Star Rating" } },
        amenities: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Amenities" } },
        vacationType: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Vacation type" } },
        error: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Select at least one filter to apply." } },
        showLess: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Show less" } },
        showMore: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Show more" } },
        applyButton: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Apply Filters" } },
        filter: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "filter" } },
        starslabel: {
          stars: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "stars " } },
          andup: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "& up" } }
        },
        starRatingOptions: {
          2: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "2 stars & up" } },
          3: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "3 stars & up" } },
          4: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "4 stars & up" } },
          5: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "5 stars" } }
        },
        filterBy: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Filter by:" } }
      },
      hotelRating: {
        stars: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "stars" } }
      },
      productDetails: {
        bestFor: {
          title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ideal for" } },
          learnMore: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Learn more" } },
          hideDetails: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Hide Details" } }
        },
        labels: {
          accessibleAnchor: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Skip to " } },
          hotel: {
            important: {
              title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Important information" } }
            },
            facilities: {
              title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Facilities" } }
            },
            location: {
              title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Location" } }
            },
            offers: {
              title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Offers" } }
            },
            overview: {
              title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Overview" } }
            }
          }
        },
        overview: {
          title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Overview" } },
          checkin: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Check in:" } },
          checkout: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Check out:" } },
          numberRooms: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Number of rooms:" } },
          numberBars: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Number Of bars:" } },
          numberRestaurants: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Number of restaurants:" } },
          numberPoolsOutdoor: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Number of pools (outdoor):" } },
          inclusions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Inclusions" } },
          otherServices: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Other services at charge ($)" } }
        },
        map: {
          "zoom-in": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Zoom in" } },
          "zoom-out": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Zoom out" } },
          "enter-full-screen": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Full screen" } },
          "exit-full-screen": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Exit full screen" } }
        },
        important: {
          title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Important information" } }
        },
        facilities: {
          title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Facilities" } },
          showMore: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Show more" } },
          showLess: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Show less" } },
          disclaimer: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "*Additional fees may apply and service may require a reservation." } },
          foodAndDrinks: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Food & drink" } },
          activities: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Activities" } },
          otherFacilitiesAndServices: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Other facilities & services" } },
          pools: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Pool facilities" } },
          landSports: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Land activities" } },
          waterSports: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Non-motorized water sports/motorized water sports" } },
          entertainment: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Entertainment" } },
          golf: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Golf" } },
          bars: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Bars" } },
          restaurants: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Restaurants" } },
          restaurantType: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Restaurant type" } },
          restaurantCuisine: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Cuisine" } },
          restaurantNote: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Note" } },
          additionalInformation: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Additional information" } },
          health: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Health and wellness" } },
          disclaimerPetFriendly: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "**Restrictions and additional fees may apply for pets" } }
        },
        offers: {
          title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Offers" } },
          terms: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Terms and Conditions" } },
          showLess: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Hide Details" } }
        },
        rooms: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Rooms" } }
      },
      travellersTitle: {
        labels: {
          secureBooking: { t: 0, b: { t: 2, i: [{ t: 3 }], s: '<i class="fa-sharp fa-solid fa-lock-keyhole"></i><span class="sr-only">Learn more about</span> Secure booking' } },
          title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Travellers" } },
          "title-note": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "(*) Mandatory fields" } }
        },
        messages: {
          secureTooltipTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Security & Privacy" } },
          secureTooltipContent: { t: 0, b: { t: 2, i: [{ t: 3 }], s: 'Every transaction with Air Canada Vacations is secure. Any personal information you share with us will be handled according to our <a href="https://vacations.aircanada.com/en/security-privacy" target="_blank" class="link">Privacy Policy</a>.' } }
        }
      },
      traveller: {
        errors: {
          noTitleSelected: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please select your title." } },
          noFirstNameEntered: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter your first name." } },
          noLastNameEntered: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter your last name." } },
          noDOBEntered: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter your date of birth." } },
          invalidDOB: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter a valid date." } },
          invalidChildDOB: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "The age of your child or children does not correspond with the provided date of birth. Please try again by starting a new search." } },
          invalidInfantReturnDOB: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Your infant will be turning 2 during your trip." } },
          invalidInfantReturnDOBDetails: { t: 0, b: { t: 2, i: [{ t: 3, v: "Travellers aged 2 and up are required to occupy their own seat, as per Transport Canada regulations. You must purchase a return seat for your 2-year-old. <br /><strong>Please call us at " }, { t: 4, k: "num" }, { t: 3, v: " to complete your booking.</strong>" }] } },
          noEmailEntered: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter your email." } },
          noPhoneNumberEntered: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter your 10-digit phone number." } },
          noOtherTravellerDateOfBirth: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter a date of birth." } },
          noOtherTravellerTitleField: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please select a title." } },
          noOtherTravellerFirstName: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter a first name." } },
          noOtherTravellerLastName: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter a last name." } },
          nameWrongFormat: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Letters (A-Z, a-z), accented letters, hyphen or apostrophe only." } },
          ccNameWrongFormat: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Letters (A-Z, a-z), accented letters, hyphen or apostrophe only." } },
          phoneNumberWrongFormat: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Numbers (0-9) and special characters ('+', '-', '(' and ')') only." } },
          aeroplanNumberWrongFormat: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Numbers (0-9) only." } },
          employeeNamePrefilled: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "There is an issue with this name. Please call 1-877-752-5510 to complete the booking." } },
          firstNameTextLength: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Maximum of 20 characters accepted." } },
          lastNameTextLength: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Maximum of 20 characters accepted." } },
          aeroplanInvalidNumber: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter a valid Aeroplan number." } },
          phoneNumberTextLength: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Maximum of 20 characters accepted." } },
          emailTextLength: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Maximum of 50 characters accepted." } },
          emailWrongFormat: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter a valid email." } }
        },
        labels: {
          adult: { t: 0, b: { t: 2, i: [{ t: 3, v: "Adult " }, { t: 4, k: "index" }] } },
          child: { t: 0, b: { t: 2, i: [{ t: 3, v: "Child " }, { t: 4, k: "index" }, { t: 3, v: " (" }, { t: 4, k: "age" }, { t: 3, v: " years old)" }] } },
          childHideAge: { t: 0, b: { t: 2, i: [{ t: 3, v: "Child " }, { t: 4, k: "index" }] } },
          infant: { t: 0, b: { t: 2, i: [{ t: 3, v: "Infant " }, { t: 4, k: "index" }, { t: 3, v: " (under 2 years old)" }] } },
          infantHideAge: { t: 0, b: { t: 2, i: [{ t: 3, v: "Infant " }, { t: 4, k: "index" }] } },
          dateOfBirth: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Date of birth" } },
          "dateOfBirth-filled": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Date of birth:" } },
          travellerTitleField: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Title" } },
          travellerTitleMr: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Mr." } },
          travellerTitleMrs: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Mrs." } },
          travellerTitleMs: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ms." } },
          travellerFirstName: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "First name" } },
          travellerMiddleName: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Middle name" } },
          travellerLastName: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Last name" } },
          travellerEmail: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Email" } },
          "travellerEmail-filled": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Email:" } },
          travellerPhoneNumber: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Phone number" } },
          "travellerPhoneNumber-filled": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Phone number:" } },
          travellerAeroplanNumber: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Aeroplan number" } },
          "travellerAeroplanNumber-filled": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Aeroplan number:" } }
        },
        messages: {
          mainTraveller: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "(Main traveller)" } },
          travellerName: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Enter information as written on passport." } },
          travellerEmailDisclaimer: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "All travel correspondence and tickets will be sent to this email." } }
        },
        placeholders: {
          birthDay: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "DD" } },
          birthMonth: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "MM" } },
          birthYear: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "YYYY" } }
        }
      },
      pricedetails: {
        peradult: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "per adult" } },
        total: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Total" } },
        taxesincl: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Taxes & fees incl." } },
        title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Price Details" } },
        hotelOnlyTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Hotel & Room(s)" } },
        popoverLink: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Show price details" } },
        adult: { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3 }], s: "adult" }, { t: 2, i: [{ t: 3 }], s: "adults" }] } },
        child: { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3 }], s: "child" }, { t: 2, i: [{ t: 3 }], s: "children" }] } },
        infant: { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3 }], s: "infant" }, { t: 2, i: [{ t: 3 }], s: "infants" }] } },
        infantAge: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "0-2 years old" } },
        taxesFees: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "taxes & fees" } },
        estimatedTotal: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Estimated Total" } },
        paymentSubtotal: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Subtotal" } },
        "extras-included": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Including selected extras" } },
        "aeroplan-points-applied": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Aeroplan pts applied" } },
        nonRefundableRate: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Non-refundable rate" } },
        paymentAEPoints: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Aeroplan points" } },
        nights: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Night(s)" } },
        taxesAndFees: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Taxes and fees" } }
      },
      legal: {
        disclaimer: {
          price: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Prices on our website reflect applicable reductions and are valid if you purchase services in a same session. If you log off our website, prices may be different the next time you log on. Final prices will be displayed before confirming your payment." } },
          "was-price": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Struck-out price represents original market price before applicable discounts." } }
        }
      },
      plp: {
        labels: {
          recommended: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Recommended" } },
          "recommended-access": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "This hotel is " } }
        },
        messages: {
          notfound: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "It looks like we can't find exactly what you're looking for." } },
          "notfound-filters": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "There are no vacations that match the selected filters. Please try again with different options." } },
          "notfound-filters-hotels": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "There are no hotels that match the selected filters. Please try again with different options." } },
          "notfound-unavailable": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "It looks like your current destination is unavailable." } },
          packagesfound: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "packages found" } },
          "packagesfound-single": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "package found" } },
          suggest: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "We suggest:" } },
          "suggest-date": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Changing your travel dates." } },
          "suggest-nearby-airports": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Trying nearby airports." } },
          "suggest-different-airport": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Try different airports." } },
          "suggest-different-destination": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Selecting a different destination." } },
          "suggest-alternative-destination": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Selecting an alternative destination." } },
          "suggest-travellers": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Reducing the number of travellers." } },
          "specific-s214-error-tulum": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "We can't find available flights to Tulum for your selected dates." } },
          "suggest-cancun-good-news": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Good news! You can still get to our Tulum hotels by flying to Cancún." } },
          "suggest-cancun-update": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "We suggest updating your search and selecting Cancún as your destination." } },
          "something-went-wrong": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "It looks like something went wrong." } },
          "try-again-by": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Try again by:" } },
          "click-modify": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Searching again by clicking 'Modify' above" } },
          "refresh-page": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Refreshing this page" } },
          alertNoCabinSearchedAvailable: { t: 0, b: { t: 2, i: [{ t: 3, v: "There are no " }, { t: 4, k: "searchedCabin" }, { t: 3, v: " seats available for your selected dates. However, space in " }, { t: 4, k: "returnedCabin" }, { t: 3, v: " is available around those dates." }] } },
          alertAdditionalCabinsAvailable: { t: 0, b: { t: 2, i: [{ t: 3, v: "We found " }, { t: 4, k: "searchedCabin" }, { t: 3, v: " seats available on the flight for the dates selected. We also found available package(s) around those dates in " }, { t: 4, k: "returnedCabin" }, { t: 3, v: "." }] } },
          "children-more-than-one-room-error": { t: 0, b: { t: 2, i: [{ t: 3 }], s: 'To make a booking with children, select one room or <a href="https://vacations.aircanada.com/en/contact-us" target="_blank" class="link">contact us</a>.' } },
          "more-than-6-pax-error": { t: 0, b: { t: 2, i: [{ t: 3 }], s: 'For bookings with more than 6 travellers, please <a href="https://vacations.aircanada.com/en/contact-us" target="_blank" class="link">contact us</a>.' } },
          "update-your-search": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Update your search" } },
          "adults-repartition-error": { t: 0, b: { t: 2, i: [{ t: 3 }], s: 'Please distribute the number of adults equally between the number of rooms and try again. If you need help with your booking, please <a href="https://vacations.aircanada.com/en/contact-us" target="_blank" class="link">contact us</a>.' } },
          recommended: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Recommended" } },
          "recommended-access": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "This hotel is " } }
        },
        filters: {
          filter: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "filtrer" } }
        }
      },
      plpList: {
        flexibleDates: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Flexible dates" } },
        flexDates: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "More Dates and Prices" } },
        flexDatesDeparture: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Departure" } },
        flexNights: { t: 0, b: { t: 2, i: [{ t: 3, v: "(" }, { t: 4, k: "count" }, { t: 3, v: " nights)" }] } },
        roomShowDetails: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "See all details" } },
        roomOptionsInfo: { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3, v: "Up to " }, { t: 4, k: "count" }, { t: 3, v: " other room option available at this hotel" }] }, { t: 2, i: [{ t: 3, v: "Up to " }, { t: 4, k: "count" }, { t: 3, v: " other room options available at this hotel" }] }] } },
        roomOptionsButton: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "See all room options" } },
        roomDetails: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Room details" } },
        stars: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "stars" } },
        aeroplanpointsTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Terms & Conditions" } },
        flightdetails: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Flight details" } }
      },
      psytriggers: {
        "rooms-left": { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3, v: "Only " }, { t: 4, k: "count" }, { t: 3, v: " room left!" }] }, { t: 2, i: [{ t: 3, v: "Only " }, { t: 4, k: "count" }, { t: 3, v: " rooms left!" }] }] } },
        "total-bookings-24": { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3, v: "Hotel booked " }, { t: 4, k: "count" }, { t: 3, v: " time in the last 24 hours" }] }, { t: 2, i: [{ t: 3, v: "Hotel booked " }, { t: 4, k: "count" }, { t: 3, v: " times in the last 24 hours" }] }] } },
        "total-bookings-48": { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3, v: "Hotel booked " }, { t: 4, k: "count" }, { t: 3, v: " time in the last 48 hours" }] }, { t: 2, i: [{ t: 3, v: "Hotel booked " }, { t: 4, k: "count" }, { t: 3, v: " times in the last 48 hours" }] }] } },
        "last-booking-minute": { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3, v: "Hotel booked " }, { t: 4, k: "count" }, { t: 3, v: " minute ago" }] }, { t: 2, i: [{ t: 3, v: "Hotel booked " }, { t: 4, k: "count" }, { t: 3, v: " minutes ago" }] }] } },
        "last-booking-hour": { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3, v: "Hotel booked " }, { t: 4, k: "count" }, { t: 3, v: " hour ago" }] }, { t: 2, i: [{ t: 3, v: "Hotel booked " }, { t: 4, k: "count" }, { t: 3, v: " hours ago" }] }] } },
        "room-last-booking-minute": { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3, v: "Room booked " }, { t: 4, k: "count" }, { t: 3, v: " minute ago" }] }, { t: 2, i: [{ t: 3, v: "Room booked " }, { t: 4, k: "count" }, { t: 3, v: " minutes ago" }] }] } },
        "room-last-booking-hour": { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3, v: "Room booked " }, { t: 4, k: "count" }, { t: 3, v: " hour ago" }] }, { t: 2, i: [{ t: 3, v: "Room booked " }, { t: 4, k: "count" }, { t: 3, v: " hours ago" }] }] } },
        "room-total-bookings-24": { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3, v: "Room booked " }, { t: 4, k: "count" }, { t: 3, v: " time in the last 24 hours" }] }, { t: 2, i: [{ t: 3, v: "Room booked " }, { t: 4, k: "count" }, { t: 3, v: " times in the last 24 hours" }] }] } },
        "room-total-bookings-48": { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3, v: "Room booked " }, { t: 4, k: "count" }, { t: 3, v: " time in the last 48 hours" }] }, { t: 2, i: [{ t: 3, v: "Room booked " }, { t: 4, k: "count" }, { t: 3, v: " times in the last 48 hours" }] }] } },
        "rooms-left-advisory": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "This number is based on Air Canada Vacation's current inventory which can fluctuate from day to day." } },
        "bookings-advisory": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "This number is based on ACV's current booking data, which is subject to be updated every 60 minutes." } }
      },
      progressbar: {
        labels: {
          navback: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Back" } },
          stepofsteps: { t: 0, b: { t: 2, i: [{ t: 3, v: "Step " }, { t: 4, k: "step" }, { t: 3, v: " of " }, { t: 4, k: "steps" }, { t: 3, v: " - " }] } },
          hotel: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Hotel" } },
          room: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Room(s)" } },
          flight: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Flight" } },
          extras: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Extras" } },
          payment: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Payment" } }
        }
      },
      payment: {
        labels: {
          title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Travellers" } },
          "title-note": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "(*) Mandatory fields" } },
          secureBooking: { t: 0, b: { t: 2, i: [{ t: 3 }], s: '<i class="fa-sharp fa-solid fa-lock-keyhole"></i><span class="sr-only">Learn more about</span> Secure booking' } },
          paymentMethod: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Payment method" } },
          twoCreditCards: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "I want to use 2 credit cards" } },
          sameAddress: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Same as credit card 1" } },
          creditCard: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Credit card" } },
          creditCardAmount: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Amount ($)" } },
          creditCardName: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Name on card" } },
          creditCardExpiry: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Expiration date (MM-YY)" } },
          creditCardAddressTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Billing address" } },
          creditCardAddress: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Address" } },
          creditCardApartment: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Apartment" } },
          creditCardCity: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "City" } },
          creditCardCountry: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Country" } },
          creditCardProvince: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Province/State" } },
          creditCardPostCode: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Postal/ZIP code" } },
          creditCardConfirm: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Confirm payment" } },
          updateInformation: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Edit Details" } },
          passengerProtection: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Air Passenger Protection Regulations Notice" } },
          promocodeTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Promo code" } },
          promocodeApplyButton: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Apply" } },
          promocodeRemoveButton: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Remove" } },
          paymentOptions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Payment options" } },
          payInFull: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Pay total" } },
          payWithDeposit: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Book with a deposit" } },
          payWithUplift: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Pay Monthly with Flex Pay" } },
          depositModalTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Book with a deposit" } },
          note: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Note:" } },
          travellerInfoNormalizedNote: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "We've adjusted the traveller name(s) in your booking to meet our system requirements." } },
          upliftFrom: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "from $" } },
          payMonthlyOffer: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "/month" } },
          upliftWarningModalTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Are you sure you want to update your booking?" } },
          aeroplanWarningModalTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Aeroplan points will be reset" } },
          upLiftWarningModalBtnOK: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Update my booking" } },
          aeroplanWarningModalBtnOK: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ok, reset my points" } },
          upliftWarningModalBtnCancel: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Cancel" } },
          allianzTravelInsuranceTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Allianz Travel Insurance" } },
          allianzTravelInsuranceDescription: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Protect your wellbeing and finances and travel with peace of mind." } },
          allianzTravelInsuranceDescription2: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please make a selection to continue." } },
          allianzTravelInsuranceNotesTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Notes:" } },
          allianzDeclineTravelInsurance: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "I decline protection for my trip and understand I may be responsible for non-refundable expenses." } },
          allianzAddTravelInsurance: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Add" } },
          allianzAddedTravelInsurance: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Added" } },
          mostPopular: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Most Popular" } },
          allianzTermsAndConditions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: 'Terms & <span>Conditions<i class="fa-solid fa-arrow-up-right-from-square"></i></span>' } },
          allianzProductSummary: { t: 0, b: { t: 2, i: [{ t: 3 }], s: 'Product <span>Summary<i class="fa-solid fa-arrow-up-right-from-square"></i></span>' } },
          priceTitle: { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3 }], s: "Total Price for 1 passenger (plus applicable taxes)" }, { t: 2, i: [{ t: 3, v: "Total Price for " }, { t: 4, k: "count" }, { t: 3, v: " passengers (plus applicable taxes)" }] }] } },
          allianzProductChangeBtn: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Change" } },
          travelInsurance: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Travel Insurance" } },
          insuranceForXTravellers: { t: 0, b: { t: 2, i: [{ t: 3, v: "for " }, { t: 4, k: "x" }, { t: 3, v: " travellers" }] } },
          insuranceXTravellers: { t: 0, b: { t: 2, i: [{ t: 4, k: "x" }, { t: 3, v: " traveller(s)" }] } },
          plusTaxes: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Plus applicable taxes" } },
          billedSeparately: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Billed separately" } },
          allianzOptedOutInsurance: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "You have opted out of travel insurance. Please note that you may be responsible for non-refundable expenses." } },
          insuranceDOBChangeAdvisoryAccept: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ok" } },
          allianzDescriptionNotesTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please Note:" } },
          allianzDescriptionNotesNoteOne: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Your travel insurance will be billed to this credit card as a separate charge by Allianz Global Assistance." } },
          allianzDescriptionNotesNoteTwo: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "When you purchase travel insurance, you consent to Air Canada Vacations disclosing some of the personal information you provided (such as credit card information) to Allianz Global Assistance." } }
        },
        placeholders: {
          select: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Select" } }
        },
        validation: {
          paymentMethod: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please select a payment method." } }
        },
        errors: {
          ccNameWrongFormat: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Letters (A-Z, a-z), accented letters, hyphen or apostrophe only." } },
          ccAmountZero: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Amount cannot be $0.00" } },
          ccAmountEqualToTotal: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "To proceed, please select one Credit Card" } },
          ccAmountTooHighDeposit: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Amount must be less than the deposit amount" } },
          expirationWrongFormat: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter a date in the MM-YY format." } },
          expirationPastDate: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter a valid credit card expiration date" } },
          giftCardPayInFull: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Your booking will be paid in full with your Air Canada Gift Card." } },
          maxCharsAccepted: { t: 0, b: { t: 2, i: [{ t: 3, v: "Maximum of " }, { t: 4, k: "max" }, { t: 3, v: " characters accepted." }] } },
          maxTwoPaymentMethods: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "You've already selected a maximum of 2 payment methods. To use your gift card, please deselect one of your payment methods." } },
          notSupportedIframe: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Your browser does not support iframes. Please use a compatible browser to view this content." } },
          pleaseEnterCCName: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter the cardholder's name" } },
          pleaseEnterCCExpiryDate: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter the expiration date" } },
          pleaseEnterCCAddress: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter an address" } },
          pleaseEnterCCCity: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter a city" } },
          pleaseEnterCCCountry: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please select a country" } },
          pleaseEnterCCProvince: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please select a province/state" } },
          pleaseEnterCCPostalCode: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter a postal/zip code" } },
          cityWrongFormat: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Alphabetic (A-Z, a-z), spaces (' ') and special characters only." } },
          postalCodeWrongFormat: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter a valid postal code." } },
          upliftFormNotCompleted: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please complete the Flex Pay form before confirming payment, or select a different payment plan." } },
          unableGetUpliftToken: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "We're unable to complete your Flex Pay application at this time. Please try again." } },
          offerNotAvailable: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Price not available at this time" } },
          promocodeError: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Invalid Promo Code" } },
          pleaseEnterYour: { t: 0, b: { t: 2, i: [{ t: 3, v: "Please enter your " }, { t: 4, k: "field" }, { t: 3, v: "." }] } },
          noCardNumber: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter a card number" } },
          noCVV: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter the CVV" } },
          cvvWrongFormat: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter a valid CVV code" } },
          ccWrongFormat: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter a valid credit card number" } },
          ccTypeNotAccepted: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter a valid card number for an accepted card type" } },
          creditCardPaymentFailure: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "We are unable to complete your booking due to a payment error. Please contact your bank." } },
          paymentAlreadyBooked: { t: 0, b: { t: 2, i: [{ t: 3 }], s: 'Your package has already been booked. If you do not receive your confirmation email within the next 60 minutes, please <a href="https://vacations.aircanada.com/en/contact-us" target="_blank" class="link">contact us</a>.' } },
          errorHotel: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "We are unable to confirm your booking with the hotel. Please choose a different room type or hotel." } },
          paymentUserInput: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Your payment cannot be completed. Please verify your credit card details and try again." } },
          paymentFlightClientError: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Your selected flight is no longer available. Please try again with different dates or cabin classes." } },
          paymentBookingError: { t: 0, b: { t: 2, i: [{ t: 3 }], s: 'Your selected package is no longer available. Please try again with different dates or a different destination. If the error persists, please <a href="https://vacations.aircanada.com/en/contact-us" target="_blank" class="link">contact us</a>.' } },
          paymentIncorrectPaxInfo: { t: 0, b: { t: 2, i: [{ t: 3 }], s: 'Passenger information is invalid. Please verify and try again. If the error persists, please <a href="https://vacations.aircanada.com/en/contact-us" target="_blank" class="link">contact us</a>.' } },
          paymentTechnicalError: { t: 0, b: { t: 2, i: [{ t: 3 }], s: 'Sorry, an error has occurred while completing your booking. Please try again. If the error persists, please <a href="https://vacations.aircanada.com/en/contact-us" target="_blank" class="link">contact us</a>.' } },
          payment3DSError: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Sorry, an error occurred while processing your payment. Please try again. If the problem persists, please contact your bank." } },
          maxNumberOfAttempts3DSTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please be advised" } },
          maxNumberOfAttempts3DSMessage: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "<p>The maximum number of attempts has been reached. You will be redirected to the homepage.</p>" } },
          maxNumberOfAttempts3DSCta: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "OK" } },
          repeatCC: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Cannot be the same as Credit Card 1" } },
          ccAmountTooHighFull: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Amount must be less than the total amount" } },
          ccAmountValueTypeError: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Numbers (0-9) only" } },
          allianzError: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please choose a travel insurance plan, or decline travel insurance to continue." } }
        },
        messages: {
          continue: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Continue" } },
          secureTooltipTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Security & Privacy" } },
          secureTooltipContent: { t: 0, b: { t: 2, i: [{ t: 3 }], s: 'Every transaction with Air Canada Vacations is secure. Any personal information you share with us will be handled according to our <a href="https://vacations.aircanada.com/en/security-privacy" target="_blank" class="link">Privacy Policy</a>.' } },
          mainTraveller: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "(Main traveller)" } },
          termsConditions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: 'By confirming your payment, you agree to have read and understood the Air Canada Vacations <a href="https://vacations.aircanada.com/en/terms-conditions" target="_blank" class="link">Terms and Conditions</a> and <a href="https://vacations.aircanada.com/en/security-privacy" target="_blank" class="link">Privacy Policy</a>.' } },
          packageNotAvailable: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "The package you selected is no longer available." } },
          "try-again": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Try again by making a different selection." } },
          "passengerProtection-1": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "If you are denied boarding, your flight is cancelled or delayed for at least two hours, or your baggage is lost or damaged, you may be entitled to certain standards of treatment and compensation under the Air Passenger Protection Regulations. For more information about your passenger rights please contact your air carrier or visit the Canadian Transportation Agency's website." } },
          "passengerProtection-2": { t: 0, b: { t: 2, i: [{ t: 3 }], s: `General terms and conditions pertaining to flight delays, cancellations, denied boarding, seating of children and lost or damaged baggage can be found in <a href="https://www.aircanada.com/ca/en/aco/home/legal/conditions-carriage-tariffs.html#/" target="_blank" class="link">Air Canada's General Conditions of Carriage and Tariffs</a>.` } },
          "aeroplan-you-have-x-points": { t: 0, b: { t: 2, i: [{ t: 3, v: "You have <span>" }, { t: 4, k: "points" }, { t: 3, v: "</span> Aeroplan points" }] } },
          "aeroplan-you-can-redeem-x-to-save-y": { t: 0, b: { t: 2, i: [{ t: 3, v: "You can redeem a maximum of <span>" }, { t: 4, k: "points" }, { t: 3, v: "</span> points to save <span>" }, { t: 4, k: "dollars" }, { t: 3, v: "</span>" }] } },
          "waiting-message-title": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "We are completing your booking" } },
          "waiting-message-description": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "It may take a few minutes to process your request. Do not click the refresh, back or stop button." } },
          "bill96-disclaimer": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please note that all documents and transactional emails will be sent in French" } },
          "bill96-checkbox": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "I would like to receive a copy of all documents and emails in English." } },
          promocodeDiscount: { t: 0, b: { t: 2, i: [{ t: 4, k: "discount" }, { t: 3, v: " OFF" }] } },
          amountDueBy: { t: 0, b: { t: 2, i: [{ t: 3, v: "Remaining balance of <strong>" }, { t: 4, k: "amount" }, { t: 3, v: "</strong> due by <strong>" }, { t: 4, k: "date" }, { t: 3, v: "</strong>" }] } },
          giftCardCheckAmountLink: { t: 0, b: { t: 2, i: [{ t: 3 }], s: '<a href="https://www.aircanada.com/ca/en/aco/home/book/payment-methods/air-canada-gift-cards.html#/" target="_blank" class="link">Check your gift card, eVoucher or travel voucher balance.</a>' } },
          upliftWarningMessage: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Making a change to your booking may require you to restart your Flex Pay application." } },
          aeroplanWarningMessage: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "The booking total has changed, so if you proceed you'll need to apply your points again." } },
          billedSeparately: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Your trip and your travel insurance will be billed separately:" } },
          payableToVACV: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "payable to Air Canada Vacations" } },
          payableToInsuranceCompany: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "plus applicable taxes, payable to Allianz Global Assistance" } },
          insuranceDOBChangeAdvisoryTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please note" } },
          insuranceDOBChangeAdvisoryDescription: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Your travel insurance price may have changed based on the new information you provided." } },
          travelInsuranceNoOptions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Sorry, there are no travel insurance options available for your trip." } }
        }
      },
      provinces: {
        AB: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "AB - Alberta" } },
        BC: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "BC - British Columbia" } },
        MB: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "MB - Manitoba" } },
        NB: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "NB - New Brunswick" } },
        NL: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "NL - Newfoundland and Labrador" } },
        NT: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "NT - Northwest Territories" } },
        NS: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "NS - Nova Scotia" } },
        NU: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "NU - Nunavut" } },
        ON: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "ON - Ontario" } },
        PE: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "PE - Prince Edward Island" } },
        QC: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "QC - Quebec" } },
        SK: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "SK - Saskatchewan" } },
        YT: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "YT - Yukon Territory" } }
      },
      states: {
        AL: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "AL - Alabama" } },
        AK: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "AK - Alaska" } },
        AZ: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "AZ - Arizona" } },
        AR: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "AR - Arkansas" } },
        CA: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "CA - California" } },
        CO: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "CO - Colorado" } },
        CT: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "CT - Connecticut" } },
        DE: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "DE - Delaware" } },
        DC: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "DC - District Of Columbia" } },
        FL: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "FL - Florida" } },
        GA: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "GA - Georgia" } },
        HI: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "HI - Hawaii" } },
        ID: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "ID - Idaho" } },
        IL: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "IL - Illinois" } },
        IN: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "IN - Indiana" } },
        IA: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "IA - Iowa" } },
        KS: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "KS - Kansas" } },
        KY: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "KY - Kentucky" } },
        LA: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "LA - Louisiana" } },
        ME: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "ME - Maine" } },
        MD: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "MD - Maryland" } },
        MA: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "MA - Massachusetts" } },
        MI: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "MI - Michigan" } },
        MN: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "MN - Minnesota" } },
        MS: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "MS - Mississippi" } },
        MO: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "MO - Missouri" } },
        MT: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "MT - Montana" } },
        NE: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "NE - Nebraska" } },
        NV: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "NV - Nevada" } },
        NH: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "NH - New Hampshire" } },
        NJ: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "NJ - New Jersey" } },
        NM: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "NM - New Mexico" } },
        NY: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "NY - New York" } },
        NC: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "NC - North Carolina" } },
        ND: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "ND - North Dakota" } },
        OH: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "OH - Ohio" } },
        OK: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "OK - Oklahoma" } },
        OR: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "OR - Oregon" } },
        PA: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "PA - Pennsylvania" } },
        RI: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "RI - Rhode Island" } },
        SC: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "SC - South Carolina" } },
        SD: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "SD - South Dakota" } },
        TN: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "TN - Tennessee" } },
        TX: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "TX - Texas" } },
        UT: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "UT - Utah" } },
        VT: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "VT - Vermont" } },
        VA: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "VA - Virginia" } },
        WA: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "WA - Washington" } },
        WV: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "WV - West Virginia" } },
        WI: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "WI - Wisconsin" } },
        WY: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "WY - Wyoming" } }
      },
      countries: {
        CA: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Canada" } },
        US: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "United States" } }
      },
      bookingsummary: {
        labels: {
          "booking-summary": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Booking Summary" } },
          package: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Package" } },
          flight: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Flight" } },
          transfers: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Transfers" } },
          hotel: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Hotel" } },
          "hotel-and-rooms": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Hotel & Room(s)" } },
          "round-trip-flight": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Round-trip flight" } },
          ancillary: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Extras" } },
          traveller: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "traveller" } },
          travellers: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "travellers" } },
          included: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Included" } },
          travelprotection: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Travel protection - " } },
          privateTransfer: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Private transfers - " } },
          "extras-included": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Including selected extras" } }
        },
        messages: {
          "see-details": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "See details" } },
          "hide-details": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Hide details" } },
          total: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Total" } },
          deposit: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Deposit" } },
          "continue-booking": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Continue" } }
        },
        errors: {
          "no-hotel-room": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "We can't load your hotel & room details right now. You'll be able to see them at the next step." } },
          "no-flights": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "We can't load your flight details right now. You'll be able to see them after you select your room." } },
          ancillary: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "We can't load your extras right now. You'll be able to see them at the next step." } }
        },
        aeroplan: {
          "use-your-points-to-save": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Use your points to save" } }
        }
      },
      pdp: {
        labels: {
          title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Product Details Page (PDP)" } },
          accessibleAnchor: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Skip to " } },
          inclusionsButton: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Inclusions" } },
          roomDetails: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Room details" } },
          roomDescription: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Room description" } },
          roomService: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Room service" } },
          roomFacilities: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Room facilities" } },
          roomDimensions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Room size" } },
          occupancy: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Occupancy" } },
          maximumOccupancy: { t: 0, b: { t: 2, i: [{ t: 3, v: "Max Occupancy " }, { t: 4, k: "count" }] } },
          hotel: {
            overview: {
              title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Overview" } },
              checkin: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Check in:" } },
              checkout: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Check out:" } },
              numberRooms: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Number of rooms:" } },
              numberBars: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Number Of bars:" } },
              numberRestaurants: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Number of restaurants:" } },
              numberPoolsOutdoor: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Number of pools (outdoor):" } },
              inclusions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Inclusions" } },
              otherServices: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Other services at charge ($)" } }
            },
            important: {
              title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Important information" } }
            },
            location: {
              title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Location" } }
            },
            inclusions: {
              title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Inclusions" } }
            },
            facilities: {
              title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Facilities" } },
              showMore: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Show more" } },
              showLess: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Show less" } },
              disclaimer: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "*Additional fees may apply and service may require a reservation." } },
              foodAndDrinks: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Food & drink" } },
              activities: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Activities" } },
              otherFacilitiesAndServices: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Other facilities & services" } },
              pools: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Pool facilities" } },
              landSports: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Land activities" } },
              waterSports: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Non-motorized water sports/motorized water sports" } },
              entertainment: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Entertainment" } },
              golf: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Golf" } },
              bars: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Bars" } },
              restaurants: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Restaurants" } },
              restaurantType: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Restaurant type" } },
              restaurantCuisine: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Cuisine" } },
              restaurantNote: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Note" } },
              additionalInformation: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Additional information" } },
              health: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Health and wellness" } },
              disclaimerPetFriendly: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "**Restrictions and additional fees may apply for pets" } }
            }
          }
        },
        messages: {
          noRoomsAvailable: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "It looks like there are no rooms currently available." } },
          "try-again": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Choose a different hotel or resort and try again." } },
          "multiple-airport-your-choice": { t: 0, b: { t: 2, i: [{ t: 3 }], s: 'This hotel can be accessed through multiple airports. Look for the <i class="fa-solid fa-plane" aria-hidden="true"></i><span class="sr-only">airport alert</span> below to view your options. Prices may differ based on your choice.' } },
          "multiple-airport-destination": { t: 0, b: { t: 2, i: [{ t: 3, v: "Round-trip flight via " }, { t: 4, k: "name" }, { t: 3, v: " (" }, { t: 4, k: "iata" }, { t: 3, v: ")" }] } }
        },
        access: {
          "plane-icon": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Airport alert! " } }
        },
        rooms: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Rooms" } },
        map: {
          "zoom-in": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Zoom in" } },
          "zoom-out": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Zoom out" } },
          "enter-full-screen": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Full screen" } },
          "exit-full-screen": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Exit full screen" } }
        }
      },
      flight: {
        labels: {
          flightDetails: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "FLIGHT DETAILS" } },
          title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Flights" } },
          departure: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Departure" } },
          return: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Return" } },
          stops: { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3 }], s: "Direct flight" }, { t: 2, i: [{ t: 3 }], s: "1 stop" }, { t: 2, i: [{ t: 4, k: "count" }, { t: 3, v: " stops" }] }] } },
          duration: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Duration" } },
          showDetails: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "See details" } },
          hideDetails: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Hide details" } },
          layoverDuration: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Layover duration:" } },
          operatedBy: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Operated by" } },
          cabinClassEconomy: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Economy" } },
          cabinClassPremium: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Premium Economy" } },
          cabinClassBusiness: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Business Class" } },
          cabinClassMixedPremium: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Mixed cabin with Premium Economy" } },
          cabinClassMixedBusiness: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Mixed cabin with Business Class" } }
        },
        messages: {
          flightDetailsSubtitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "More flight options are available after room selection." } },
          flightDetailsError: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "We can't load your flight details right now. You'll be able to see them after you select your room." } },
          noFlightsAvailable: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "It looks like the package you selected is no longer available." } },
          "try-again": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please try again by making a different selection." } },
          flightNotAvailableCard: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Sorry, this flight option is no longer available." } },
          waitingMessageTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "We are updating your package" } },
          waitingMessageDescription: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "It may take up to 60 seconds to process your request.<br>Do not click the refresh, back or stop button." } },
          waitingScreenMessageTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Preparing your room" } },
          waitingScreenMessageDescription: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Give us a minute while we get everything ready for your stay.<br>Please don't click the refresh, back or stop button." } },
          cabinClassMixedPremiumTooltip: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "This option has multiple cabin classes, with at least one flight in Premium Economy." } },
          cabinClassMixedBusinessTooltip: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "This option has multiple cabin classes, with at least one flight in Business Class." } },
          selectedFlightNotInFilterResults: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Your selected flight is not included the filtered results, but you can view its details in the Booking Summary. " } }
        },
        access: {
          cabinClassTooltipButton: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Know more" } }
        },
        filter: {
          label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Filter by stops:" } },
          "dropdown-default": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "All stops" } },
          "dropdown-direct": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Direct flights only" } },
          "dropdown-1stop-or-less": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "1 stop or less" } },
          "flights-found": { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 4, k: "count" }, { t: 3, v: " flight found" }] }, { t: 2, i: [{ t: 4, k: "count" }, { t: 3, v: " flights found" }] }] } }
        }
      },
      ancillary: {
        labels: {
          title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Extras" } },
          travelProtection: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Travel Protection" } },
          terms: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Terms and Conditions" } },
          showDetails: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Show details" } },
          hideDetails: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Hide details" } },
          recommended: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Recommended" } },
          traveller: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "/ traveller" } },
          adult: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "/ adult" } },
          from: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "From" } },
          perTraveller: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "per traveller" } },
          perAdult: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "per adult" } },
          price: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Price" } },
          careflex: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "CareFlex" } },
          carefree: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "CareFree" } },
          travelprotection: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Travel Protection" } },
          travelprotectionNote: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Add flexibility and peace of mind to your vacation with one of our travel protection plans." } },
          privateTransfer: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Private Transfer" } },
          privateTransferNote: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Book round-trip private transfers between the airport & your resort." } },
          mealPlan: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Meal Plan" } },
          mealPlanNote: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Upgrade the meal plan with your package and treat yourself to an enhanced culinary experience." } },
          activities: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Attractions and Excursions" } },
          activitiesNote: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Transform ordinary trips into extraordinary ones. Add unique and unmissable things to do in your destination." } },
          showOptions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Show options" } },
          hideOptions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Hide options" } },
          showingMealPlanResults: { t: 0, b: { t: 2, i: [{ t: 3, v: "Showing 1-" }, { t: 4, k: "end" }, { t: 3, v: " of " }, { t: 4, k: "total" }, { t: 3, v: " Meal Plan(s)" }] } },
          showingOptionsResults: { t: 0, b: { t: 2, i: [{ t: 3, v: "Showing 1-" }, { t: 4, k: "end" }, { t: 3, v: " of " }, { t: 4, k: "total" }, { t: 3, v: " options" }] } },
          nothingToDisplay: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "It doesn't look like there are any Extras available for your trip." } },
          bookingSummary: {
            CAREFLEX: {
              name: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "CareFlex" } },
              inclusions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Includes cancellation with refund or travel credit, booking changes and package transfer. Certain conditions apply." } }
            },
            CAREFREE: {
              name: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "CareFree" } },
              inclusions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Includes standard seat selection and our Price Drop Guarantee. Certain conditions apply." } }
            }
          }
        },
        nudge: {
          taxesincl: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Taxes and fees incl." } },
          total: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Total" } }
        },
        access: {
          details: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Know more" } },
          "know-more-about": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Know more about" } },
          included: { t: 0, b: { t: 2, i: [{ t: 3 }], s: " Included with " } },
          "table-cell-empty": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Empty" } }
        },
        messages: {
          waitingScreenMessageTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Adding your flight" } },
          waitingScreenMessageDescription: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Give us a minute to process your request.<br>Please don't click the refresh, back or stop button." } }
        }
      },
      prices: {
        labels: {
          promoCode: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Promo code" } }
        },
        deposit: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Deposit" } },
        "deposit-payment-remaining-balance-message": { t: 0, b: { t: 2, i: [{ t: 3, v: "Remaining balance <br/>due by <b>" }, { t: 4, k: "date" }, { t: 3, v: "</b>" }] } },
        "deposit-payment-remaining-balance-mobile-message": { t: 0, b: { t: 2, i: [{ t: 3, v: "<b>" }, { t: 4, k: "remaining" }, { t: 3, v: "</b> due by <b>" }, { t: 4, k: "date" }, { t: 3, v: "</b>" }] } },
        hotelInclusions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Inclusions" } },
        "plane-icon": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Airport alert! " } },
        "multiple-airport-destination": { t: 0, b: { t: 2, i: [{ t: 3, v: "Round-trip flight via " }, { t: 4, k: "name" }, { t: 3, v: " (" }, { t: 4, k: "iata" }, { t: 3, v: ")" }] } }
      },
      giftCard: {
        labels: {
          giftCard: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Air Canada Gift Card, eCoupon or travel voucher" } },
          giftCardNumber: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Gift card number (15 digits)*" } },
          giftCardPIN: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "PIN (4 digits)*" } }
        },
        errors: {
          giftCardAmountZero: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter an amount." } },
          giftCardInsufficientAmount: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Your gift card balance is insufficient. Please select an additional payment method." } },
          giftCardPIN: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter a PIN." } },
          giftCardNumber: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter a gift card number." } },
          giftCardOnlyNumbers: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Only numbers are accepted." } },
          giftCardLessThanDepositWithoutInsurance: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Amount must be equal to or less than the deposit amount due without Insurance premium" } },
          giftCardSplitDeposit: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Amount must be equal to or less than the deposit amount" } },
          giftCardSplitTotal: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Amount must be equal to or less than the total amount due" } },
          giftCardSplitTotalWithoutInsurance: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Amount must be equal to or less than the total amount due without Insurance premium" } }
        },
        messages: {
          giftCardCheckAmountLink: { t: 0, b: { t: 2, i: [{ t: 3 }], s: '<a href="https://www.aircanada.com/ca/en/aco/home/book/payment-methods/air-canada-gift-cards.html#/" target="_blank" class="link">Check your gift card, eVoucher or travel voucher balance.</a>' } }
        }
      },
      showmoreresults: {
        labels: {
          moreresultsCTA: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Show More" } },
          showingresultsmessage: { t: 0, b: { t: 2, i: [{ t: 3, v: "Showing 1-" }, { t: 4, k: "end" }, { t: 3, v: " of " }, { t: 4, k: "total" }, { t: 3, v: " result(s)" }] } },
          showingRoomsResultsMessage: { t: 0, b: { t: 2, i: [{ t: 3, v: "Showing 1-" }, { t: 4, k: "end" }, { t: 3, v: " of " }, { t: 4, k: "total" }, { t: 3, v: " room(s)" }] } }
        }
      },
      alternatedates: {
        messages: {
          "not-available": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "The departure date you requested is not available" } },
          "select-available-dates": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Select the next available dates from the options below." } },
          "found-one-date": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "We found the following available date:" } }
        },
        labels: {
          "prefix-available-date": { t: 0, b: { static: "", t: 2, i: [] } }
        },
        errors: {
          "mandatory-date": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please select a date." } }
        }
      }
    }
  } },
  { fr: {
    vacvComponents: {
      common: {
        buttons: {
          open: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ouvrir" } },
          close: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Fermer" } },
          select: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Choisir" } },
          selected: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Choisi" } },
          backToTop: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Revenir au haut de la page" } },
          submit: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Soumettre" } },
          add: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ajouter" } },
          added: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ajouté" } },
          showOptions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Afficher les options" } },
          hideOptions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Masquer les options" } }
        },
        generic: {
          loading: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Chargement en cours" } }
        },
        labels: {
          aeroplan: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Aéroplan" } },
          details: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Détails" } },
          selectAnOption: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Sélectionner une option" } }
        },
        messages: {
          "go-back": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Revenir aux résultats" } },
          "fallback-img": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Image à venir" } }
        },
        bookingsummary: {
          labels: {
            "booking-summary": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Résumé de la réservation" } },
            package: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Forfait" } },
            flight: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Vol" } },
            transfers: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Transferts" } },
            hotel: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Hôtel" } },
            "hotel-and-rooms": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Hôtel et chambre(s)" } },
            "round-trip-flight": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Vol aller-retour" } },
            ancillary: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ajouts" } },
            traveller: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "voyageur" } },
            travellers: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "voyageurs" } },
            included: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Inclus" } },
            travelprotection: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Protection de voyage - " } },
            privateTransfer: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Transfert(s) privé(s) - " } },
            "extras-included": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Comprend les ajouts sélectionnés" } }
          },
          messages: {
            "see-details": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Voir plus" } },
            "hide-details": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Voir moins" } },
            total: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Total" } },
            deposit: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Dépôt" } },
            "continue-booking": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Continuer" } }
          },
          errors: {
            "no-hotel-room": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Nous ne pouvons charger les détails de votre hôtel et de votre chambre pour le moment. Vous pourrez les voir à l'étape suivante." } },
            "no-flights": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Nous ne pouvons afficher les détails de votre vol pour le moment. Vous pourrez les consulter après avoir sélectionné votre chambre." } },
            ancillary: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Nous ne pouvons charger les ajouts pour le moment. Vous pourrez les voir à l'étape suivante." } }
          },
          aeroplan: {
            "use-your-points-to-save": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Utilisez vos points pour économiser" } }
          }
        },
        pricedetails: {
          peradult: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "par adulte" } },
          total: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Total" } },
          taxesincl: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Taxes et frais inclus" } },
          title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Détails du prix" } },
          popoverLink: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Afficher détails du prix" } },
          adult: { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3 }], s: "adulte" }, { t: 2, i: [{ t: 3 }], s: "adultes" }] } },
          child: { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3 }], s: "enfant" }, { t: 2, i: [{ t: 3 }], s: "enfants" }] } },
          taxesFees: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "taxes et frais" } },
          estimatedTotal: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Total estimé" } },
          perNight: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "par nuit" } }
        },
        phoneNumber: {
          guestPhoneNumber: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "1-866-529-2079" } },
          B2CPhoneNumber: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "1-877-752-5510" } },
          B2BPhoneNumber: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "1-877-752-7710" } }
        }
      },
      wasPrice: {
        was: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Était " } },
        save: { t: 0, b: { t: 2, i: [{ t: 3, v: "Économisez " }, { t: 4, k: "percent" }, { t: 3, v: " %" }] } }
      },
      guestsInput: {
        label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Voyageurs" } },
        placeholder: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Voyageurs" } },
        insideDataGuests: { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 4, k: "n" }, { t: 3, v: " voyageur" }] }, { t: 2, i: [{ t: 4, k: "n" }, { t: 3, v: " voyageurs" }] }] } },
        insideDataRooms: { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 4, k: "n" }, { t: 3, v: " chambre" }] }, { t: 2, i: [{ t: 4, k: "n" }, { t: 3, v: " chambres" }] }] } },
        adults: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Adultes (18+)" } },
        children: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Enfants (2 à 17 ans)" } },
        infants: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Bébés (2 ans ou moins)" } },
        counter: {
          add: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ajouter" } },
          remove: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Supprimer" } }
        },
        rooms: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Chambres" } },
        childAge: { t: 0, b: { t: 2, i: [{ t: 3, v: "Âge enfant " }, { t: 4, k: "n" }] } },
        buttonLabel: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "TERMINÉ" } },
        roomsAdvisory: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Max. 1 chambre pour les réservations avec des enfants/bébé" } },
        "advisoryTravellers7+": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "<strong>Pour 7 à 9 voyageurs :</strong> appelez au 1 866 529-2079." } },
        "advisoryTravellers10+": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "<strong>Pour 10 voyageurs et plus :</strong> consultez notre page <a href='https://vacations.aircanada.com/fr/group-form' target='_blank'>Voyage en groupe</a>." } },
        advisoryNoInfantFeature: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "<strong>Enfants de moins de 2 ans :</strong> composez le 1 866 529-2079." } },
        infantTurns2: { t: 0, b: { t: 2, i: [{ t: 3, v: "Si votre enfant en bas âge atteint l'âge de 2 ans pendant votre voyage, il aura besoin d'un siège de retour. Veuillez nous appeler au " }, { t: 4, k: "num" }, { t: 3, v: " pour compléter votre réservation." }] } },
        oneInfantPerAdult: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Max. d'un (1) bébé par adulte" } },
        errors: {
          GuestsSelection: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Le nombre de voyageurs n'est pas valide" } },
          RoomSelection: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Lors de la réservation de plusieurs chambres, les adultes doivent être répartis équitablement dans les chambres." } },
          ChildAgeSelection: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez indiquer l'âge de l'enfant à la date de départ" } },
          ChildUnderTwo: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Si vous souhaitez inclure un ou plusieurs enfants de moins de 2 ans, veuillez nous appeler au 1 866 529-2079 pour compléter votre réservation." } }
        }
      },
      dialogs: {
        cubaPopup: {
          title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Vous voyagez à Cuba?" } },
          question: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Cette réservation compte-t-elle un ou plusieurs passagers qui sont des citoyens américains, des résidents permanents des États-Unis ou qui relèvent de la compétence américaine?" } },
          changeDestination: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Changer de destination" } },
          yes: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Oui" } },
          no: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Non" } },
          continue: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Poursuivre la réservation" } },
          yesSelected: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `<p>Tout voyage à destination ou en provenance de Cuba est interdit pour les citoyens et résidents permanents américains, ainsi que toute personne relevant de la compétence des États-Unis.</p><p>L'Office of Foreign Assets Control (OFAC) exige que tous les voyageurs susmentionnés remplissent une déclaration qui reconnait qu'ils sont titulaires d'un permis de voyage spécifique à Cuba, ou que leur voyage à Cuba correspond à l'une des catégories générales autorisée par un permis :</p><ul><li>Visites familiales</li><li>Activités officielles menées par le gouvernement américain, des gouvernements étrangers et certaines organisations intergouvernementales</li><li>Activités journalistiques</li><li>Recherche professionnelle/réunions et conférences professionnelles</li><li>Activités éducatives/voyages éducatifs de groupes interpersonnels</li><li>Activités religieuses</li><li>Soutien au peuple cubain</li><li>Projets humanitaires</li><li>Activités de fondations privées, ou d'instituts de recherche ou d'éducation</li><li>Exportation, importation ou transmission d'information ou de matériel d'information</li><li>Certaines transactions à l'exportation pouvant bénéficier d'une autorisation</li></ul><p>Avant de réserver un voyage à Cuba, les voyageurs américains devraient consulter le site Web du département du Trésor des États-Unis (en anglais seulement) <a href="https://ofac.treasury.gov/faqs#cuba" target="_blank">pour plus d'informations sur les sanctions relatives à Cuba</a>.</p><p>Il est interdit aux ressortissants américains (citoyens ou résidents américains), y compris les voyageurs autorisés, d'effectuer des transactions financières directes avec certains hôtels, commerces et agences de voyages cubains qui appartiennent aux services militaires ou de renseignements cubains, tels qu'ils figurent sur la Liste restrictive pour Cuba du département d'État américain. Veuillez consulter <a href="https://www.state.gov/cuba-sanctions/cuba-restricted-list/" target="_blank">la Liste restrictive pour Cuba</a> (en anglais seulement) pour en savoir plus.</p><p>De récentes modifications apportées aux sanctions américaines contre Cuba interdisent également aux ressortissants américains de se loger, de payer pour un logement ou d'effectuer une réservation auprès de certaines propriétés à Cuba. Veuillez consulter <a href="https://www.state.gov/cuba-sanctions/cuba-prohibited-accommodations-list/cuba-prohibited-accommodations-list-initial-publication/" target="_blank">la Liste d'hébergements interdits</a> (en anglais seulement) pour en savoir plus.</p>` } }
        },
        confirmation: {
          "modal-label-accessibility": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Confirmation" } }
        }
      },
      tripAdvisor: {
        review: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "avis" } },
        reviews: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "avis" } },
        "access-rating": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Note Tripadvisor " } },
        "access-bubbles": { t: 0, b: { t: 2, i: [{ t: 3 }], s: " sur 5 bulles" } }
      },
      aeroplan: {
        aeroplan: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Aeroplan" } },
        "signin-btn": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ouvrir une session" } },
        "cont-as-guest-btn": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Continuer comme invité" } },
        "earn-or-book-and-save": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Accumulez avec vos vacances ou économisez en réservant avec vos points" } },
        "login-banner": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Réservez avec des points ou accumulez pour vos prochaines vacances." } },
        points: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "pts" } },
        "points-initial-text": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Sélectionner points" } },
        "points-zero": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Aucun point" } },
        redeem: {
          "aeroplan-points": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Points Aéroplan" } },
          advisory: { t: 0, b: { t: 2, i: [{ t: 3, v: "Vous avez besoin d'un minimum de " }, { t: 4, k: "unitPoint" }, { t: 3, v: " points pour en échanger." }] } },
          description: { t: 0, b: { t: 2, i: [{ t: 3, v: 'Vous pouvez échanger jusqu’à <span class="bold">' }, { t: 4, k: "points" }, { t: 3, v: ' pts Aéroplan</span> pour économiser <span class="bold">' }, { t: 4, k: "dollars" }, { t: 3, v: "</span>" }] } },
          "description-bonus": { t: 0, b: { t: 2, i: [{ t: 3, v: 'Vous pouvez échanger jusqu’à <span class="was-points bold">' }, { t: 4, k: "wasPoints" }, { t: 3, v: '</span> <span class="bold red">' }, { t: 4, k: "points" }, { t: 3, v: ' pts</span> pour économiser <span class="bold">' }, { t: 4, k: "dollars" }, { t: 3, v: "</span>" }] } },
          "points-to-redeem": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Points à échanger" } },
          "error-message": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez saisir un nombre valide de points." } },
          "use-points-btn": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Utiliser des points" } },
          "apply-btn": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Appliquer" } },
          "cancel-btn": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Annuler" } },
          "change-btn": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Modifier" } },
          "remove-btn": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Supprimer" } },
          bonus: { t: 0, b: { t: 2, i: [{ t: 3, v: "Bonus " }, { t: 4, k: "percentage" }, { t: 3, v: "% valeur ajoutée" }] } },
          "points-applied": { t: 0, b: { t: 2, i: [{ t: 3, v: '<span class="bold">' }, { t: 4, k: "points" }, { t: 3, v: " points</span> " }, { t: 9, v: "|" }, { t: 3, v: ' <span class="bold red">' }, { t: 4, k: "amount" }, { t: 3, v: " de rabais</span>" }] } }
        }
      },
      carousel: {
        "aria-modal": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Voir galerie de photos" } },
        "aria-next": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Suivant" } },
        "aria-previous": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Précédent" } },
        caption: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Image" } },
        slidenum: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "de" } },
        photo: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Photo de" } }
      },
      confirmation: {
        labels: {
          title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Votre réservation est confirmée!" } },
          bookingNumber: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Votre numéro de réservation:" } },
          bookingSummaryTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Résumé de la réservation" } },
          travellersTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Voyageurs" } },
          accommodationTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Hôtel et chambre(s)" } },
          print: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Imprimer la confirmation" } },
          getReadyTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Préparez-vous pour vos vacances" } },
          aeroplanJoin: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Adhérez à Aéroplan" } },
          aeroplanJoinLink: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "https://www.aircanada.com/aeroplan/member/enrolment?lang=fr-CA" } },
          aeroplanAddNumber: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ajoutez le(s) numéro(s) Aéroplan" } },
          aeroplanAddNumberLink: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "https://vacations.aircanada.com/fr/infos-de-voyage/gestion-reservation" } },
          hotelTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Hôtel et chambre(s)" } },
          privateTransfer: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Transfert aéroportuaire privé aller-retour" } },
          sharedTransfer: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Transfert aéroportuaire partagé aller-retour (inclus)" } },
          checkInTime: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Enregistrement:" } },
          checkOutTime: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Départ:" } },
          flightTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Vol aller-retour" } },
          ancillaryTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ajouts" } },
          priceDetailsTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Détails du prix" } },
          privateTransferDescription: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Il n'est pas trop tard pour ajouter un transfert privé aller-retour entre l'aéroport et votre complexe hôtelier." } },
          privateTransferButton: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ajouter à votre réservation" } },
          paymentTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Mode(s) de paiement" } },
          uplift: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Flex Pay" } },
          CAREFLEX: {
            name: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "TouteTranquillité" } },
            inclusions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Comprend l'annulation avec remboursement ou crédit de voyage, les modifications de réservation et le transfert de forfait. Certaines conditions s'appliquent." } }
          },
          CAREFREE: {
            name: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "TouteFlexibilité" } },
            inclusions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Comprend la sélection standard des sièges et notre garantie ProtègePrix. Certaines conditions s'appliquent." } }
          },
          CFCTA: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Contribution FICAV" } },
          insuranceTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Protection de voyage" } },
          insuranceLogoTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Allianz Global Assistance" } },
          insuranceDescription: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Protégez votre santé et vos finances afin de pouvoir voyager en toute confiance au Canada et dans le monde entier. Bénéficiez d'une couverture d'assurance précieuse et d'une assistance d'urgence en tout temps de la part de l'équipe d'Allianz Global Assistance, qui est là pour vous aider tout au long de votre voyage." } },
          insuranceContact: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `ou appelez Allianz Global Assistance aujourd'hui au <span class="tel">1 833 358-0582</span>.` } },
          insuranceNote: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "L'assurance voyage est souscrite auprès de la Compagnie d'Assurance Générale CUMIS, l'une des sociétés du Groupe Co-operators, et est administrée par Allianz Global Assistance qui est une dénomination commerciale enregistrée d'AZGA Service Canada Inc." } },
          insuranceBtn: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Obtenez une soumission en ligne" } },
          seatSelTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Présélection des sièges" } },
          seatSelOption1: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Sélectionnez votre siège maintenant ou passez à un siège Préférence moyennant un supplément." } },
          seatSelOption2: { t: 0, b: { t: 2, i: [{ t: 3 }], s: 'Sélectionnez votre siège ultérieurement via la page <a href="https://vacations.aircanada.com/fr/infos-de-voyage/gestion-reservation" target="_blank" class="link">Gestion de votre réservation</a>.' } },
          seatSelOption3: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Si vous avez ajouté la protection TouteTranquillité à votre réservation, sélectionnez votre siège via le lien ci-dessus ou contactez-nous au 1 866 529-2079 pour passer à un siège Préférence." } },
          seatSelBtn: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Sélectionnez votre siège" } },
          giftCard: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Carte-cadeau Air Canada se terminant par" } },
          endingWith: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "••••" } }
        },
        messages: {
          thankYou: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Merci de voyager avec Vacances Air Canada." } },
          checkInbox: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Vérifiez votre boîte de réception pour les détails de votre réservation." } },
          aeroplanEnroll: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `<h2 class="h3style">Vous n'êtes pas membre d'Aéroplan?</h2>Le plus important programme de fidélité des voyageurs au Canada aide les membres à voyager plus et mieux en leur donnant accès à des avantages extraordinaires.` } },
          aeroplanBenefits: { t: 0, b: { t: 2, i: [{ t: 3 }], s: '<ul class="spa-list special-list details-2col"><li>Accumulez des points sur tous les forfaits qui incluent les vols</li><li>Atteignez le statut Aéroplan Élite<span class="sup-small">mc</span> plus rapidement grâce aux forfaits vacances. Accumulez TOUTES  les unités de qualification</li><li>Accumulez des points plus rapidement lorsque vous réservez avec des cartes de crédit admissibles</li><li>Envoyez des textos gratuitement pendant votre vol grâce au <a href="https://www.aircanada.com/ca/fr/aco/home/fly/onboard/in-flight-entertainment-and-connectivity.html#/wifi" target="_blank" class="link">Wi-Fi à bord</a>. Commandité par Bell</li><li>Échangez vos points pour aussi peu que 1 000 points</li><li>Rabais exclusifs sur les activités</li><li>Combinez vos points avec ceux des membres de votre famille pour obtenir des primes plus rapidement grâce au Partage familial Aéroplan</li></ul>' } },
          aeroplanAlready: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "<strong>Vous avez oublié d'indiquer le(s) numéro(s) Aéroplan pour vous ou pour d'autres voyageurs lors de votre réservation?</strong><br>Ne manquez pas les points Aéroplan qui peuvent être accumulés!" } },
          ancillaryTravelProtectionLink: { t: 0, b: { t: 2, i: [{ t: 3 }], s: '<a href="https://vacations.aircanada.com/fr/infos-de-voyage/protections-de-voyage" target="_blank" class="link">En savoir plus</a>' } },
          privateTransfer: { t: 0, b: { t: 2, i: [{ t: 3, v: `<ul class="spa-list special-list"><li>Service de transfert vers et depuis l'aéroport de ` }, { t: 4, k: "destination" }, { t: 3, v: ".</li><li>Nous vous enverrons les instructions de transfert avant votre voyage. Nous vous enverrons également un bon d'échange avec vos documents de voyage, que vous devrez présenter lors de la prise en charge.</li></ul>" }] } },
          sharedTransfer: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `<ul class="spa-list special-list"><li>Le transport entre l'aéroport et votre hôtel est inclus dans votre forfait.</li><li>Nous vous enverrons les instructions de transfert avant votre voyage.</li></ul>` } }
        }
      },
      filters: {
        filteredBy: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Filtré par" } },
        clearFilters: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Effacer tous les filtres" } },
        rangeSlider: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Prix par adulte ($)" } },
        destinations: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Destinations" } },
        moreDestinations: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Plus de destinations" } },
        moreAmenities: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Plus de commodités" } },
        deals: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Offres" } },
        starRating: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Classement" } },
        amenities: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Commodités" } },
        vacationType: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Type de vacances" } },
        error: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez choisir au moins un filtre pour appliquer les filtres." } },
        showLess: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Afficher moins" } },
        showMore: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Afficher plus" } },
        applyButton: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Appliquer" } },
        filter: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "filtrer" } },
        starslabel: {
          stars: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "étoiles " } },
          andup: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "et plus" } }
        },
        starRatingOptions: {
          2: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "2 étoiles et plus" } },
          3: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "3 étoiles et plus" } },
          4: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "4 étoiles et plus" } },
          5: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "5 étoiles" } }
        },
        filterBy: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Filtrer par :" } }
      },
      hotelRating: {
        stars: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "étoiles" } }
      },
      productDetails: {
        bestFor: {
          title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Idéal pour" } },
          learnMore: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "En savoir plus" } },
          hideDetails: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Voir moins" } }
        },
        labels: {
          accessibleAnchor: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Aller à la section " } },
          hotel: {
            important: {
              title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Informations importantes" } }
            },
            facilities: {
              title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Installations" } }
            },
            location: {
              title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Emplacement" } }
            },
            offers: {
              title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Offres" } }
            },
            overview: {
              title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Aperçu" } }
            }
          }
        },
        overview: {
          title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Aperçu" } },
          checkin: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Enregistrement:" } },
          checkout: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Départ:" } },
          numberRooms: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Nombre de chambres:" } },
          numberBars: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Nombre de bars:" } },
          numberRestaurants: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Nombre de restaurants:" } },
          numberPoolsOutdoor: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Nombre de piscines (extérieures):" } },
          inclusions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Inclusions" } },
          otherServices: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Autres services payants ($)" } }
        },
        map: {
          "zoom-in": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Zoom avant" } },
          "zoom-out": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Zoom arrière" } },
          "enter-full-screen": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Plein écran" } },
          "exit-full-screen": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Quitter le plein écran" } }
        },
        important: {
          title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Informations importantes" } }
        },
        facilities: {
          title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Installations" } },
          showMore: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Voir plus" } },
          showLess: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Voir moins" } },
          disclaimer: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "*Des frais supplémentaires peuvent s'appliquer et le service peut nécessiter une réservation." } },
          foodAndDrinks: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Restaurants et bars" } },
          activities: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Activités" } },
          otherFacilitiesAndServices: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Autres installations et de services" } },
          pools: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Installations de piscine" } },
          landSports: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Activités terrestres" } },
          waterSports: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Sports nautiques non motorisés et motorisés" } },
          entertainment: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Divertissement" } },
          golf: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Golf" } },
          bars: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Bars" } },
          restaurants: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Restaurants" } },
          restaurantType: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Type de restaurant" } },
          restaurantCuisine: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Type de cuisine" } },
          restaurantNote: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Note" } },
          additionalInformation: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Renseignements supplémentaires" } },
          health: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Spa et bien-être" } },
          disclaimerPetFriendly: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "**Des restrictions et des frais supplémentaires peuvent s'appliquer pour les animaux de compagnie." } }
        },
        offers: {
          title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Offres" } },
          terms: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Conditions générales" } },
          showLess: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Voir moins" } }
        },
        rooms: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Chambres" } }
      },
      travellersTitle: {
        labels: {
          secureBooking: { t: 0, b: { t: 2, i: [{ t: 3 }], s: '<i class="fa-sharp fa-solid fa-lock-keyhole"></i><span class="sr-only">Savoir plus sur la</span> Réservation sécurisée' } },
          title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Voyageurs" } },
          "title-note": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "(*) Champs obligatoires" } }
        },
        messages: {
          secureTooltipTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Sécurité et confidentialité" } },
          secureTooltipContent: { t: 0, b: { t: 2, i: [{ t: 3 }], s: 'Chaque transaction avec Vacances Air Canada est sécurisée. Toute information personnelle que vous partagez avec nous sera traitée conformément à notre <a href="https://vacations.aircanada.com/fr/securite-confidentialite" target="_blank" class="link">politique de confidentialité</a>.' } }
        }
      },
      traveller: {
        errors: {
          noTitleSelected: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez sélectionner votre titre de civilité." } },
          noFirstNameEntered: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez saisir votre prénom." } },
          noLastNameEntered: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez saisir votre nom de famille." } },
          noDOBEntered: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez saisir votre date de naissance." } },
          invalidDOB: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez saisir une date valide." } },
          invalidChildDOB: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "L'âge de votre enfant ou de vos enfants ne correspond pas à la date de naissance indiquée. Veuillez réessayer en lançant une nouvelle recherche." } },
          invalidInfantReturnDOB: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Votre bébé aura 2 ans pendant votre voyage." } },
          invalidInfantReturnDOBDetails: { t: 0, b: { t: 2, i: [{ t: 3, v: "Les voyageurs âgés de 2 ans et plus doivent occuper leur propre siège, conformément à la réglementation de Transports Canada. Vous devez acheter un siège aller-retour pour votre enfant de 2 ans. <br/><strong>Veuillez nous appeler au " }, { t: 4, k: "num" }, { t: 3, v: " pour compléter votre réservation.</strong>" }] } },
          noEmailEntered: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez saisir votre adresse courriel." } },
          noPhoneNumberEntered: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez saisir votre numéro de téléphone à 10 chiffres." } },
          noOtherTravellerDateOfBirth: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez saisir la date de naissance." } },
          noOtherTravellerTitleField: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez sélectionner le titre de civilité." } },
          noOtherTravellerFirstName: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez saisir le prénom." } },
          noOtherTravellerLastName: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez saisir le nom de famille." } },
          nameWrongFormat: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Seuls les lettres (A-Z, a-z), les lettres accentuées, les traits d'union et les apostrophes sont acceptés." } },
          ccNameWrongFormat: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Seuls les lettres (A-Z, a-z), les lettres accentuées, les traits d'union et les apostrophes sont acceptés." } },
          phoneNumberWrongFormat: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Seuls les chiffres (0-9) et les caractères spéciaux (« + », « -», « (« et ») ») sont acceptés" } },
          aeroplanNumberWrongFormat: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Seuls les chiffres (0-9) sont acceptés." } },
          employeeNamePrefilled: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Il y a un problème avec ce nom. Veuillez appeler le 1 877 752-5510 pour compléter la réservation." } },
          firstNameTextLength: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Un maximum de 20 caractères est accepté." } },
          lastNameTextLength: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Un maximum de 20 caractères est accepté." } },
          aeroplanInvalidNumber: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez entrer un numéro Aéroplan valide." } },
          phoneNumberTextLength: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Un maximum de 20 caractères est accepté." } },
          emailTextLength: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Un maximum de 50 caractères est accepté." } },
          emailWrongFormat: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez saisir un courriel valide." } }
        },
        labels: {
          adult: { t: 0, b: { t: 2, i: [{ t: 4, k: "index" }, { t: 4, k: "pos" }, { t: 3, v: " adulte" }] } },
          child: { t: 0, b: { t: 2, i: [{ t: 4, k: "index" }, { t: 4, k: "pos" }, { t: 3, v: " enfant (" }, { t: 4, k: "age" }, { t: 3, v: " ans)" }] } },
          childHideAge: { t: 0, b: { t: 2, i: [{ t: 4, k: "index" }, { t: 4, k: "pos" }, { t: 3, v: " enfant" }] } },
          infant: { t: 0, b: { t: 2, i: [{ t: 4, k: "index" }, { t: 4, k: "pos" }, { t: 3, v: " bébé(s) (2 ans ou moins)" }] } },
          infantHideAge: { t: 0, b: { t: 2, i: [{ t: 4, k: "index" }, { t: 4, k: "pos" }, { t: 3, v: " bébé(s)" }] } },
          dateOfBirth: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Date de naissance" } },
          "dateOfBirth-filled": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Date de naissance :" } },
          travellerTitleField: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Titre de civilité" } },
          travellerTitleMr: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "M." } },
          travellerTitleMrs: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Mme" } },
          travellerTitleMs: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Mlle" } },
          travellerFirstName: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Prénom" } },
          travellerMiddleName: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "2e prénom" } },
          travellerLastName: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Nom de famille" } },
          travellerEmail: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Adresse courriel" } },
          "travellerEmail-filled": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Adresse courriel :" } },
          travellerPhoneNumber: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Numéro de téléphone" } },
          "travellerPhoneNumber-filled": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Numéro de téléphone :" } },
          travellerAeroplanNumber: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Numéro Aéroplan" } },
          "travellerAeroplanNumber-filled": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Numéro Aéroplan :" } }
        },
        messages: {
          mainTraveller: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "(Voyageur principal)" } },
          travellerName: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Inscrivez les informations telles qu'elles figurent sur le passeport." } },
          travellerEmailDisclaimer: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Toute la correspondance de voyage et les billets seront envoyés à cette adresse courriel." } }
        },
        placeholders: {
          birthDay: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "JJ" } },
          birthMonth: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "MM" } },
          birthYear: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "AAAA" } }
        }
      },
      pricedetails: {
        peradult: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "par adulte" } },
        total: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Total" } },
        taxesincl: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Taxes et frais inclus" } },
        title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Détails du prix" } },
        hotelOnlyTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Hôtel et chambre(s)" } },
        popoverLink: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Afficher détails du prix" } },
        adult: { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3 }], s: "adulte" }, { t: 2, i: [{ t: 3 }], s: "adultes" }] } },
        child: { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3 }], s: "enfant" }, { t: 2, i: [{ t: 3 }], s: "enfants" }] } },
        infant: { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3 }], s: "bébé" }, { t: 2, i: [{ t: 3 }], s: "bébés" }] } },
        infantAge: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "0-2 ans" } },
        taxesFees: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "taxes et frais" } },
        estimatedTotal: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Total estimé" } },
        paymentSubtotal: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Sous-total" } },
        "extras-included": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Comprend les ajouts sélectionnés" } },
        "aeroplan-points-applied": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "points Aéroplan appliqués" } },
        nonRefundableRate: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Tarif non remboursable" } },
        paymentAEPoints: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Aeroplan Points" } },
        nights: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "nuit(s)" } },
        taxesAndFees: { t: 0, b: { t: 2, i: [{ t: 3 }], s: " Taxes et frais" } }
      },
      legal: {
        disclaimer: {
          price: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Les prix sur notre site Web reflètent les réductions applicables et sont valides lors de l'achat de services le temps d'une même session. Les prix pourraient être différents si vous ouvrez ultérieurement une nouvelle session. Le prix final sera affiché au moment de la confirmation du paiement." } },
          "was-price": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Le prix rayé représente le prix initial du marché avant les rabais applicables." } }
        }
      },
      plp: {
        labels: {
          recommended: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Recommandé" } },
          "recommended-access": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Cet hôtel est " } }
        },
        messages: {
          notfound: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Il semble que nous ne puissions pas trouver exactement ce que vous cherchez." } },
          "notfound-filters": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Il n'y a pas de vacances qui correspondent aux filtres sélectionnés. Essayez à nouveau avec d'autres options de filtre." } },
          "notfound-filters-hotels": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Il n'y a pas d'hôtels qui correspondent aux filtres sélectionnés. Essayez à nouveau avec d'autres options de filtre." } },
          "notfound-unavailable": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Il semble que votre destination actuelle ne soit pas disponible." } },
          packagesfound: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "forfaits trouvés" } },
          "packagesfound-single": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "forfait trouvé" } },
          suggest: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Voici ce que nous vous suggérons :" } },
          "suggest-date": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Modifiez vos dates de voyage." } },
          "suggest-nearby-airports": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Vérifiez les aéroports à proximité." } },
          "suggest-different-airport": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Essayez d'autres aéroports." } },
          "suggest-different-destination": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Sélectionnez une autre destination." } },
          "suggest-alternative-destination": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Sélectionnez une autre destination." } },
          "suggest-travellers": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Réduisez le nombre de voyageurs." } },
          "specific-s214-error-tulum": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Nous ne trouvons pas de vols disponibles pour Tulum pour les dates que vous avez sélectionnées." } },
          "suggest-cancun-good-news": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Bonne nouvelle! Vous pouvez toujours vous rendre à nos hôtels de Tulum en prenant un vol pour Cancún." } },
          "suggest-cancun-update": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Nous vous suggérons de mettre à jour votre recherche et de sélectionner Cancún comme destination." } },
          "something-went-wrong": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Il semble y avoir eu un problème." } },
          "try-again-by": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Essayez de nouveau avec les options suivantes :" } },
          "click-modify": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Recommencez la recherche en cliquant sur « Modifier » ci-dessus." } },
          "refresh-page": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Rafraîchissez la page." } },
          alertNoCabinSearchedAvailable: { t: 0, b: { t: 2, i: [{ t: 3, v: "Il n'y a pas de sièges " }, { t: 4, k: "searchedCabin" }, { t: 3, v: " disponibles pour les dates que vous avez sélectionnées. Cependant, des places en " }, { t: 4, k: "returnedCabin" }, { t: 3, v: " sont disponibles autour de ces dates." }] } },
          alertAdditionalCabinsAvailable: { t: 0, b: { t: 2, i: [{ t: 3, v: "Nous avons trouvé des sièges disponibles en " }, { t: 4, k: "searchedCabin" }, { t: 3, v: " sur le vol pour les dates sélectionnées. Nous avons également trouvé des forfaits disponibles autour de ces dates en " }, { t: 4, k: "returnedCabin" }, { t: 3, v: "." }] } },
          "children-more-than-one-room-error": { t: 0, b: { t: 2, i: [{ t: 3 }], s: 'Pour effectuer une réservation avec des enfants, sélectionnez une chambre ou <a href="https://vacations.aircanada.com/fr/nous-joindre" target="_blank" class="link">contactez-nous</a>.' } },
          "more-than-6-pax-error": { t: 0, b: { t: 2, i: [{ t: 3 }], s: 'Pour les réservations de plus de 6 voyageurs, <a href="https://vacations.aircanada.com/fr/nous-joindre" target="_blank" class="link">contactez-nous</a>.' } },
          "update-your-search": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Mettre à jour votre recherche" } },
          "adults-repartition-error": { t: 0, b: { t: 2, i: [{ t: 3 }], s: `Veuillez répartir le nombre d'adultes de manière égale entre le nombre de chambres et réessayer. Si vous avez besoin d'aide pour votre réservation, <a href="https://vacations.aircanada.com/fr/nous-joindre" target="_blank" class="link">contactez-nous</a>.` } },
          recommended: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Recommandé" } },
          "recommended-access": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Cet hôtel est " } }
        },
        filters: {
          filter: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "filter" } }
        }
      },
      plpList: {
        flexibleDates: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Dates flexibles" } },
        flexDates: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Plus de dates et de prix" } },
        flexDatesDeparture: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Départ" } },
        flexNights: { t: 0, b: { t: 2, i: [{ t: 3, v: "(" }, { t: 4, k: "count" }, { t: 3, v: " nuits)" }] } },
        roomShowDetails: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Afficher tous les détails" } },
        roomOptionsInfo: { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3, v: "Jusqu'à " }, { t: 4, k: "count" }, { t: 3, v: " autre option de chambre disponible dans cet hôtel" }] }, { t: 2, i: [{ t: 3, v: "Jusqu'à " }, { t: 4, k: "count" }, { t: 3, v: " autres options de chambres disponibles dans cet hôtel" }] }] } },
        roomOptionsButton: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Afficher toutes les options de chambres" } },
        roomDetails: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Détails de la chambre" } },
        stars: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "étoiles" } },
        aeroplanpointsTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Conditions générales" } },
        flightdetails: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Détails du vol" } }
      },
      psytriggers: {
        "rooms-left": { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3, v: "Plus que " }, { t: 4, k: "count" }, { t: 3, v: " chambre!" }] }, { t: 2, i: [{ t: 3, v: "Plus que " }, { t: 4, k: "count" }, { t: 3, v: " chambres!" }] }] } },
        "total-bookings-24": { t: 0, b: { t: 2, i: [{ t: 3, v: "Hôtel réservé " }, { t: 4, k: "count" }, { t: 3, v: " fois dans les dernières 24 h" }] } },
        "total-bookings-48": { t: 0, b: { t: 2, i: [{ t: 3, v: "Hôtel réservé " }, { t: 4, k: "count" }, { t: 3, v: " fois dans les dernières 48 h" }] } },
        "last-booking-minute": { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3, v: "Hôtel réservé il y a " }, { t: 4, k: "count" }, { t: 3, v: " minute" }] }, { t: 2, i: [{ t: 3, v: "Hôtel réservé il y a " }, { t: 4, k: "count" }, { t: 3, v: " minutes" }] }] } },
        "last-booking-hour": { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3, v: "Hôtel réservé il y a " }, { t: 4, k: "count" }, { t: 3, v: " heure" }] }, { t: 2, i: [{ t: 3, v: "Hôtel réservé il y a " }, { t: 4, k: "count" }, { t: 3, v: " heures" }] }] } },
        "room-last-booking-minute": { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3, v: "Chambre réservée il y a " }, { t: 4, k: "count" }, { t: 3, v: " minute" }] }, { t: 2, i: [{ t: 3, v: "Chambre réservée il y a " }, { t: 4, k: "count" }, { t: 3, v: " minutes" }] }] } },
        "room-last-booking-hour": { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3, v: "Chambre réservée il y a " }, { t: 4, k: "count" }, { t: 3, v: " heure" }] }, { t: 2, i: [{ t: 3, v: "Chambre réservée il y a " }, { t: 4, k: "count" }, { t: 3, v: " heures" }] }] } },
        "room-total-bookings-24": { t: 0, b: { t: 2, i: [{ t: 3, v: "Chambre réservée " }, { t: 4, k: "count" }, { t: 3, v: " fois dans les dernières 24 h" }] } },
        "room-total-bookings-48": { t: 0, b: { t: 2, i: [{ t: 3, v: "Chambre réservée " }, { t: 4, k: "count" }, { t: 3, v: " fois dans les dernières 48 h" }] } },
        "rooms-left-advisory": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ce nombre s'appuie sur l'inventaire actuel de Vacances Air Canada qui peut varier quotidiennement." } },
        "bookings-advisory": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ce nombre s'appuie sur les données de réservation actuelles de Vacances Air Canada, qui sont susceptibles d'être mises à jour toutes les 60 minutes." } }
      },
      progressbar: {
        labels: {
          navback: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Retour" } },
          stepofsteps: { t: 0, b: { t: 2, i: [{ t: 3, v: "Étape " }, { t: 4, k: "step" }, { t: 3, v: " de " }, { t: 4, k: "steps" }, { t: 3, v: " - " }] } },
          hotel: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Hôtel" } },
          room: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Chambre(s)" } },
          flight: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Vol" } },
          extras: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ajouts" } },
          payment: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Paiement" } }
        }
      },
      payment: {
        labels: {
          title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Voyageurs" } },
          "title-note": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "(*) Champs obligatoires" } },
          secureBooking: { t: 0, b: { t: 2, i: [{ t: 3 }], s: '<i class="fa-sharp fa-solid fa-lock-keyhole"></i><span class="sr-only">Savoir plus sur la</span> Réservation sécurisée' } },
          paymentMethod: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Mode de paiement" } },
          twoCreditCards: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Je souhaite utiliser 2 cartes de crédit" } },
          sameAddress: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Utiliser l'adresse de la carte 1" } },
          creditCard: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Carte de crédit" } },
          creditCardAmount: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Montant ($)" } },
          creditCardName: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Nom figurant sur la carte" } },
          creditCardExpiry: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Date d'expiration (MM-AA)" } },
          creditCardAddressTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Adresse de facturation" } },
          creditCardAddress: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Adresse" } },
          creditCardApartment: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Appartement" } },
          creditCardCity: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ville" } },
          creditCardCountry: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Pays" } },
          creditCardProvince: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Province/État" } },
          creditCardPostCode: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Code postal" } },
          creditCardConfirm: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Confirmer le paiement" } },
          updateInformation: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Modifier les détails" } },
          passengerProtection: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Avis concernant le Règlement sur la protection des passagers aériens" } },
          promocodeTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Code promo" } },
          promocodeApplyButton: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Appliquer" } },
          promocodeRemoveButton: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Retirer" } },
          paymentOptions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Options de paiement" } },
          payInFull: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Paiement total" } },
          payWithDeposit: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Réservez avec un dépot" } },
          depositModalTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Réservez avec un dépot" } },
          payWithUplift: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Payez mensuellement avec Flex Pay" } },
          note: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Remarque :" } },
          travellerInfoNormalizedNote: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Nous avons adapté les noms des voyageurs dans votre réservation pour répondre aux exigences de notre système." } },
          upliftFrom: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "À partir de " } },
          payMonthlyOffer: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "$/mois" } },
          upliftWarningModalTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Voulez-vous vraiment mettre à jour votre réservation?" } },
          aeroplanWarningModalTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Les points Aéroplan vont être réinitialisés" } },
          upLiftWarningModalBtnOK: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Mettre à jour ma réservation" } },
          aeroplanWarningModalBtnOK: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Oui, je veux réinitialiser mes points" } },
          upliftWarningModalBtnCancel: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Annuler" } },
          allianzTravelInsuranceTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Assurance voyage Allianz" } },
          allianzTravelInsuranceDescription: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Protégez votre bien-être et vos finances et voyagez en toute sérénité." } },
          allianzTravelInsuranceDescription2: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez faire une sélection pour continuer." } },
          allianzTravelInsuranceNotesTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Remarques:" } },
          allianzDeclineTravelInsurance: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Je refuse la protection pour mon voyage et je comprends que je peux être responsable des dépenses non remboursables." } },
          allianzAddTravelInsurance: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ajouter" } },
          allianzAddedTravelInsurance: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ajouté" } },
          mostPopular: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Le plus populaire" } },
          allianzTermsAndConditions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: 'Conditions <span>générales<i class="fa-solid fa-arrow-up-right-from-square"></i></span>' } },
          allianzProductSummary: { t: 0, b: { t: 2, i: [{ t: 3 }], s: 'Résumé du <span>produit<i class="fa-solid fa-arrow-up-right-from-square"></i></span>' } },
          priceTitle: { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3 }], s: "Prix total pour 1 voyageur plus les taxes applicables" }, { t: 2, i: [{ t: 3, v: "Prix total pour " }, { t: 4, k: "count" }, { t: 3, v: " voyageurs plus les taxes applicables" }] }] } },
          allianzProductChangeBtn: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Change" } },
          travelInsurance: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Assurance voyage" } },
          insuranceForXTravellers: { t: 0, b: { t: 2, i: [{ t: 3, v: "pour " }, { t: 4, k: "x" }, { t: 3, v: " passagers" }] } },
          insuranceXTravellers: { t: 0, b: { t: 2, i: [{ t: 4, k: "x" }, { t: 3, v: " voyageur(s)" }] } },
          plusTaxes: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Plus les taxes applicables" } },
          billedSeparately: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Facture séparée" } },
          allianzOptedOutInsurance: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Vous avez choisi de ne pas souscrire à l'assurance voyage. Veuillez noter que vous pouvez être responsable des dépenses non remboursables." } },
          insuranceDOBChangeAdvisoryAccept: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "OK" } },
          allianzDescriptionNotesTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Remarques:" } },
          allianzDescriptionNotesNoteOne: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Votre assurance voyage sera facturée séparément sur cette carte de crédit par Allianz Global Assistance." } },
          allianzDescriptionNotesNoteTwo: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Lorsque vous souscrivez une assurance voyage, vous consentez à ce que Vacances Air Canada divulgue à Allianz Global Assistance certains des renseignements personnels que vous avez fournis (tels que les renseignements relatifs à votre carte de crédit)." } }
        },
        placeholders: {
          select: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Sélectionner" } }
        },
        validation: {
          paymentMethod: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez sélectionner un mode de paiement." } }
        },
        errors: {
          ccNameWrongFormat: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Seuls les lettres (A-Z, a-z), les lettres accentuées, les traits d'union et les apostrophes sont acceptés." } },
          ccAmountZero: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Le montant ne peut être 0,00 $" } },
          ccAmountEqualToTotal: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Pour continuer, veuillez sélectionner une carte de crédit" } },
          ccAmountTooHighDeposit: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Le montant doit être inférieur au montant du dépôt" } },
          expirationWrongFormat: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez saisir la date en suivant le format MM-AA." } },
          expirationPastDate: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez saisir une date d'expiration de carte de crédit valide" } },
          giftCardPayInFull: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Votre réservation sera payée en totalité avec votre carte-cadeau Air Canada." } },
          maxCharsAccepted: { t: 0, b: { t: 2, i: [{ t: 3, v: "Un maximum de " }, { t: 4, k: "max" }, { t: 3, v: " caractères est accepté." }] } },
          maxTwoPaymentMethods: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Vous avez déjà sélectionné un maximum de 2 modes de paiement. Pour utiliser votre carte-cadeau, veuillez désélectionner l'un de vos modes de paiement." } },
          notSupportedIframe: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Votre navigateur ne prend pas en charge les iframes. Veuillez utiliser un navigateur compatible pour afficher ce contenu" } },
          pleaseEnterCCName: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez saisir le nom du titulaire de la carte" } },
          pleaseEnterCCExpiryDate: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez saisir la date d'expiration" } },
          pleaseEnterCCAddress: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez saisir l'adresse" } },
          pleaseEnterCCCity: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez saisir la ville" } },
          pleaseEnterCCCountry: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez sélectionner le pays" } },
          pleaseEnterCCProvince: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez sélectionner la province ou l'état" } },
          pleaseEnterCCPostalCode: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez saisir le code postal" } },
          cityWrongFormat: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Seuls les lettres (A-Z, a-z), les espaces (« -») et les caractères spéciaux sont acceptés" } },
          postalCodeWrongFormat: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez entrer un code postal valide." } },
          upliftFormNotCompleted: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez compléter le formulaire Flex Pay avant de confirmer le paiement, ou sélectionnez un autre plan de paiement." } },
          unableGetUpliftToken: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Nous ne sommes pas en mesure de soumettre votre demande Flex Pay pour le moment. Veuillez réessayer." } },
          offerNotAvailable: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Prix actuellement indisponible" } },
          promocodeError: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Code promo non valide" } },
          pleaseEnterYour: { t: 0, b: { t: 2, i: [{ t: 3, v: "Veuillez saisir votre " }, { t: 4, k: "field" }, { t: 3, v: "." }] } },
          noCardNumber: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez saisir le numéro de la carte" } },
          noCVV: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez saisir le code de sécurité" } },
          cvvWrongFormat: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez saisir un CVC valide" } },
          ccWrongFormat: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez saisir un numéro de carte de crédit valide" } },
          ccTypeNotAccepted: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez saisir un numéro de carte valide pour un type de carte accepté" } },
          creditCardPaymentFailure: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Nous ne sommes pas en mesure d'effectuer votre réservation en raison d'une erreur de paiement. Veuillez contacter votre banque." } },
          paymentAlreadyBooked: { t: 0, b: { t: 2, i: [{ t: 3 }], s: 'Votre forfait a déjà été réservé. Si vous ne recevez pas votre courriel de confirmation dans les 60 prochaines minutes, <a href="https://vacations.aircanada.com/fr/nous-joindre" target="_blank" class="link">veuillez nous contacter</a>.' } },
          errorHotel: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Nous ne sommes pas en mesure de confirmer votre réservation auprès de l'hôtel. Veuillez choisir un autre type de chambre ou un autre hôtel." } },
          paymentUserInput: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Votre paiement ne peut être complété. Veuillez vérifier vos informations de carte de crédit et réessayer." } },
          paymentFlightClientError: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Le vol sélectionné n'est plus disponible. Veuillez réessayer avec d'autres dates ou classes de cabine." } },
          paymentBookingError: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `Le forfait sélectionné n'est plus disponible. Veuillez réessayer avec d'autres dates ou une autre destination. Si l'erreur persiste, <a href="https://vacations.aircanada.com/fr/nous-joindre" target="_blank" class="link">veuillez nous contacter</a>.` } },
          paymentIncorrectPaxInfo: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `Les informations sur les passagers ne sont pas valides. Veuillez vérifier et réessayer. Si l'erreur persiste, <a href="https://vacations.aircanada.com/fr/nous-joindre" target="_blank" class="link">veuillez nous contacter</a>.` } },
          paymentTechnicalError: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `Désolé, une erreur s'est produite lors de votre réservation. Veuillez réessayer. Si l'erreur persiste, <a href="https://vacations.aircanada.com/fr/nous-joindre" target="_blank" class="link">veuillez nous contacter</a>.` } },
          payment3DSError: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Une erreur s'est produite lors du traitement de votre paiement. Veuillez réessayer. Si le problème persiste, veuillez contacter votre banque." } },
          maxNumberOfAttempts3DSTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Attention" } },
          maxNumberOfAttempts3DSMessage: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "<p>Le nombre maximum d'essais a été atteint. Vous allez être redirigé·e vers la page d'accueil.</p>" } },
          maxNumberOfAttempts3DSCta: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "OK" } },
          repeatCC: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ne peut être identique à la carte de crédit 1" } },
          ccAmountTooHighFull: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Le montant doit être inférieur au montant total" } },
          ccAmountValueTypeError: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Seuls les chiffres (0-9) sont acceptés" } },
          allianzError: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez sélectionner une formule d'assurance voyage ou refuser l'assurance voyage pour continuer*." } }
        },
        messages: {
          continue: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Continuer" } },
          secureTooltipTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Sécurité et confidentialité" } },
          secureTooltipContent: { t: 0, b: { t: 2, i: [{ t: 3 }], s: 'Chaque transaction avec Vacances Air Canada est sécurisée. Toute information personnelle que vous partagez avec nous sera traitée conformément à notre <a href="https://vacations.aircanada.com/fr/securite-confidentialite" target="_blank" class="link">politique de confidentialité</a>.' } },
          mainTraveller: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "(Voyageur principal)" } },
          termsConditions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: 'En confirmant votre paiement, vous reconnaissez avoir lu et compris les <a href="https://vacations.aircanada.com/fr/conditions-generales" target="_blank" class="link">conditions générales</a> et la <a href="https://vacations.aircanada.com/fr/securite-confidentialite" target="_blank" class="link">politique de confidentialité</a> de Vacances Air Canada.' } },
          packageNotAvailable: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Votre choix est actuellement indisponible." } },
          "try-again": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez réessayer en effectuant une autre sélection." } },
          "passengerProtection-1": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Si l'embarquement vous est refusé, ou si votre vol est annulé ou retardé d'au moins deux heures ou si vos bagages sont perdus ou endommagés, vous pourriez avoir droit au titre du Règlement sur la protection des passagers aériens, à certains avantages au titre des normes de traitement applicables et à une indemnité. Pour de plus amples renseignements sur vos droits, veuillez communiquer avec votre transporteur aérien ou visiter le site Web de l'Office des transports du Canada." } },
          "passengerProtection-2": { t: 0, b: { t: 2, i: [{ t: 3 }], s: `Les conditions générales de transport applicables aux retards et annulations de vols, les refus d'embarquement, à l'attribution des sièges pour les enfants et les bagages endommagés à la page des <a href="https://www.aircanada.com/ca/fr/aco/home/legal/conditions-carriage-tariffs.html#/" target="_blank" class="link">Conditions générales de transport et tarifs d'Air Canada</a>.` } },
          "aeroplan-you-have-x-points": { t: 0, b: { t: 2, i: [{ t: 3, v: "Vous avez <span>" }, { t: 4, k: "points" }, { t: 3, v: "</span> points Aéroplan" }] } },
          "aeroplan-you-can-redeem-x-to-save-y": { t: 0, b: { t: 2, i: [{ t: 3, v: "Vous pouvez échanger un maximum de <span>" }, { t: 4, k: "points" }, { t: 3, v: "</span> points pour économiser <span>" }, { t: 4, k: "dollars" }, { t: 3, v: "</span>" }] } },
          "waiting-message-title": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Nous terminons votre réservation" } },
          "waiting-message-description": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Le traitement de votre demande peut prendre quelques minutes. Ne rafraîchissez pas la page et ne cliquez pas sur le bouton d'arrêt ou « Précédent »." } },
          "bill96-disclaimer": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez noter que tous les documents et courriels transactionnels seront envoyés en français." } },
          "bill96-checkbox": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Je souhaite recevoir une copie de tous les documents et courriels en anglais." } },
          promocodeDiscount: { t: 0, b: { t: 2, i: [{ t: 3, v: "Rabais de " }, { t: 4, k: "discount" }] } },
          amountDueBy: { t: 0, b: { t: 2, i: [{ t: 3, v: "Solde restant de <strong>" }, { t: 4, k: "amount" }, { t: 3, v: "</strong> à payer d'ici le <strong>" }, { t: 4, k: "date" }, { t: 3, v: "</strong>" }] } },
          giftCardCheckAmountLink: { t: 0, b: { t: 2, i: [{ t: 3 }], s: '<a href="https://www.aircanada.com/ca/fr/aco/home/book/payment-methods/air-canada-gift-cards.html#/" target="_blank" class="link">Vérifiez le solde de votre carte-cadeau, de votre bon électronique ou de votre bon de voyage.</a>' } },
          upliftWarningMessage: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Si vous modifiez votre réservation, il se peut que vous deviez recommencer votre application Flex Pay." } },
          aeroplanWarningMessage: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Le montant total de la réservation a changé, donc si vous continuez, vous devrez à nouveau appliquer vos points." } },
          billedSeparately: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Votre voyage et votre assurance voyage seront facturés séparément :" } },
          payableToVACV: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "à payer à Vacances Air Canada" } },
          payableToInsuranceCompany: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "plus les taxes applicables à payer à Allianz Global Assistance" } },
          insuranceDOBChangeAdvisoryTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "À noter" } },
          insuranceDOBChangeAdvisoryDescription: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Le prix de votre assurance voyage peut avoir changé en fonction des nouvelles informations que vous avez fournies." } },
          travelInsuranceNoOptions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Désolé, il n'y a pas d'options d'assurance voyage disponibles pour votre voyage." } }
        }
      },
      provinces: {
        AB: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "AB - Alberta" } },
        BC: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "BC - Colombie-Brittanique" } },
        MB: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "MB - Manitoba" } },
        NB: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "NB - Nouveau-Brunswick" } },
        NL: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "NL - Terre-Neuve et Labrador" } },
        NT: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "NT - Northwest Territories" } },
        NS: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "NS - Nouvelle-Écosse" } },
        NU: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "NU - Nunavut" } },
        ON: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "ON - Ontario" } },
        PE: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "PE - Île-du-Prince-Édouard" } },
        QC: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "QC - Québec" } },
        SK: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "SK - Saskatchewan" } },
        YT: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "YT - Yukon" } }
      },
      states: {
        AL: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "AL - Alabama" } },
        AK: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "AK - Alaska" } },
        AZ: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "AZ - Arizona" } },
        AR: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "AR - Arkansas" } },
        CA: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "CA - Californie" } },
        CO: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "CO - Colorado" } },
        CT: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "CT - Connecticut" } },
        DE: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "DE - Delaware" } },
        DC: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "DC - District de Columbia" } },
        FL: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "FL - Floride" } },
        GA: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "GA - Géorgie" } },
        HI: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "HI - Hawaii" } },
        ID: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "ID - Idaho" } },
        IL: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "IL - Illinois" } },
        IN: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "IN - Indiana" } },
        IA: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "IA - Iowa" } },
        KS: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "KS - Kansas" } },
        KY: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "KY - Kentucky" } },
        LA: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "LA - Louisiane" } },
        ME: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "ME - Maine" } },
        MD: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "MD - Maryland" } },
        MA: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "MA - Massachusetts" } },
        MI: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "MI - Michigan" } },
        MN: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "MN - Minnesota" } },
        MS: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "MS - Mississippi" } },
        MO: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "MO - Missouri" } },
        MT: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "MT - Montana" } },
        NE: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "NE - Nebraska" } },
        NV: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "NV - Nevada" } },
        NH: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "NH - New Hampshire" } },
        NJ: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "NJ - New Jersey" } },
        NM: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "NM - Nouveau-Mexique" } },
        NY: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "NY - New York" } },
        NC: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "NC - Caroline du Nord" } },
        ND: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "ND - Dakota du Nors" } },
        OH: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "OH - Ohio" } },
        OK: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "OK - Oklahoma" } },
        OR: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "OR - Oregon" } },
        PA: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "PA - Pennyslvanie" } },
        RI: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "RI - Rhode Island" } },
        SC: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "SC - Caroline du Sud" } },
        SD: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "SD - Dakota du Sud" } },
        TN: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "TN - Tennessee" } },
        TX: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "TX - Texas" } },
        UT: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "UT - Utah" } },
        VT: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "VT - Vermont" } },
        VA: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "VA - Virginie" } },
        WA: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "WA - Washington" } },
        WV: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "WV - Virginie-Occidentale" } },
        WI: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "WI - Wisconsin" } },
        WY: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "WY - Wyoming" } }
      },
      countries: {
        CA: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Canada" } },
        US: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "États-Unis" } }
      },
      bookingsummary: {
        labels: {
          "booking-summary": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Résumé de la réservation" } },
          package: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Forfait" } },
          flight: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Vol" } },
          transfers: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Transferts" } },
          hotel: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Hôtel" } },
          "hotel-and-rooms": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Hôtel et chambre(s)" } },
          "round-trip-flight": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Vol aller-retour" } },
          ancillary: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ajouts" } },
          traveller: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "voyageur" } },
          travellers: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "voyageurs" } },
          included: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Inclus" } },
          travelprotection: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Protection de voyage - " } },
          privateTransfer: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Transfert(s) privé(s) - " } },
          "extras-included": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Comprend les ajouts sélectionnés" } }
        },
        messages: {
          "see-details": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Voir plus" } },
          "hide-details": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Voir moins" } },
          total: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Total" } },
          deposit: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Dépôt" } },
          "continue-booking": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Continuer" } }
        },
        errors: {
          "no-hotel-room": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Nous ne pouvons charger les détails de votre hôtel et de votre chambre pour le moment. Vous pourrez les voir à l'étape suivante." } },
          "no-flights": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Nous ne pouvons afficher les détails de votre vol pour le moment. Vous pourrez les consulter après avoir sélectionné votre chambre." } },
          ancillary: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Nous ne pouvons charger les ajouts pour le moment. Vous pourrez les voir à l'étape suivante." } }
        },
        aeroplan: {
          "use-your-points-to-save": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Utilisez vos points pour économiser" } }
        }
      },
      pdp: {
        labels: {
          title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Product Details Page (PDP)" } },
          accessibleAnchor: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Aller à la section " } },
          inclusionsButton: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Inclusions" } },
          roomDetails: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Détails de la chambre" } },
          roomDescription: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Détails de la chambre" } },
          roomService: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Service aux chambres" } },
          roomFacilities: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Installations" } },
          roomDimensions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Dimensions de la chambre" } },
          occupancy: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Occupation" } },
          maximumOccupancy: { t: 0, b: { t: 2, i: [{ t: 3, v: "Occupation maximale " }, { t: 4, k: "count" }] } },
          hotel: {
            overview: {
              title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Aperçu" } },
              checkin: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Enregistrement:" } },
              checkout: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Départ:" } },
              numberRooms: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Nombre de chambres:" } },
              numberBars: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Nombre de bars:" } },
              numberRestaurants: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Nombre de restaurants:" } },
              numberPoolsOutdoor: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Nombre de piscines (extérieures):" } },
              inclusions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Inclusions" } },
              otherServices: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Autres services payants ($)" } }
            },
            important: {
              title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Informations importantes" } }
            },
            location: {
              title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Emplacement" } }
            },
            inclusions: {
              title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Inclusions" } }
            },
            facilities: {
              title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Installations" } },
              showMore: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Voir plus" } },
              showLess: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Voir moins" } },
              disclaimer: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "*Des frais supplémentaires peuvent s'appliquer et le service peut nécessiter une réservation." } },
              foodAndDrinks: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Restaurants et bars" } },
              activities: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Activités" } },
              otherFacilitiesAndServices: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Autres installations et de services" } },
              pools: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Installations de piscine" } },
              landSports: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Activités terrestres" } },
              waterSports: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Sports nautiques non motorisés et motorisés" } },
              entertainment: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Divertissement" } },
              golf: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Golf" } },
              bars: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Bars" } },
              restaurants: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Restaurants" } },
              restaurantType: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Type de restaurant" } },
              restaurantCuisine: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Type de cuisine" } },
              restaurantNote: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Note" } },
              additionalInformation: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Renseignements supplémentaires" } },
              health: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Spa et bien-être" } },
              disclaimerPetFriendly: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "**Des restrictions et des frais supplémentaires peuvent s'appliquer pour les animaux de compagnie." } }
            }
          }
        },
        messages: {
          noRoomsAvailable: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Il semble qu'il n'y ait pas de chambres disponibles actuellement." } },
          "try-again": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Choisissez un autre hôtel ou complexe hôtelier et réessayez." } },
          "multiple-airport-your-choice": { t: 0, b: { t: 2, i: [{ t: 3 }], s: `Cet hôtel est accessible par plusieurs aéroports. Recherchez <i class="fa-solid fa-plane" aria-hidden="true"></i><span class="sr-only">l'alerte aéroport</span> ci-dessous pour consulter vos options. Les prix peuvent varier en fonction de votre choix.` } },
          "multiple-airport-destination": { t: 0, b: { t: 2, i: [{ t: 3, v: "Vol aller-retour via " }, { t: 4, k: "name" }, { t: 3, v: " (" }, { t: 4, k: "iata" }, { t: 3, v: ")" }] } }
        },
        access: {
          "plane-icon": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Alerte aéroport! " } }
        },
        rooms: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Chambres" } },
        map: {
          "zoom-in": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Zoom avant" } },
          "zoom-out": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Zoom arrière" } },
          "enter-full-screen": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Plein écran" } },
          "exit-full-screen": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Quitter le plein écran" } }
        }
      },
      flight: {
        labels: {
          flightDetails: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Détails du vol" } },
          title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Vols" } },
          departure: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Départ" } },
          return: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Retour" } },
          stops: { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3 }], s: "Vol direct" }, { t: 2, i: [{ t: 3 }], s: "1 escale" }, { t: 2, i: [{ t: 4, k: "count" }, { t: 3, v: " escales" }] }] } },
          duration: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Durée" } },
          showDetails: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Voir plus" } },
          hideDetails: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Voir moins" } },
          layoverDuration: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Durée de l'escale:" } },
          operatedBy: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Opéré par" } },
          cabinClassEconomy: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Économique" } },
          cabinClassPremium: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Économique Privilège" } },
          cabinClassBusiness: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Classe Affaires" } },
          cabinClassMixedPremium: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Cabine mixte avec Économique Privilège" } },
          cabinClassMixedBusiness: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Cabine mixte avec Classe Affaires" } }
        },
        messages: {
          flightDetailsSubtitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "D'autres options de vol sont disponibles après la sélection de chambre." } },
          flightDetailsError: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Nous ne pouvons afficher les détails de votre vol pour le moment. Vous pourrez les consulter après avoir sélectionné votre chambre." } },
          noFlightsAvailable: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Il semble que le forfait que vous avez sélectionné ne soit plus disponible." } },
          "try-again": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez réessayer en effectuant une autre sélection." } },
          flightNotAvailableCard: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Désolé, cette option de vol n'est plus disponible." } },
          waitingMessageTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Nous mettons à jour votre forfait." } },
          waitingMessageDescription: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Le traitement de votre demande peut prendre jusqu'à 60 secondes.<br>Ne rafraîchissez pas la page et ne cliquez pas sur le bouton d'arrêt ou « Précédent »." } },
          waitingScreenMessageTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Préparation de votre chambre" } },
          waitingScreenMessageDescription: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Accordez-nous une minute pendant que nous préparons tout pour votre séjour.<br>Ne rafraîchissez pas la page et ne cliquez pas sur le bouton d'arrêt ou « Précédent »." } },
          cabinClassMixedPremiumTooltip: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Cette option comporte plusieurs classes de cabine, avec au moins un vol en Économique Privilège." } },
          cabinClassMixedBusinessTooltip: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Cette option comporte plusieurs classes de cabine, avec au moins un vol en Classe affaires." } },
          selectedFlightNotInFilterResults: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Le vol sélectionné ne figure pas dans les résultats filtrés, mais vous pouvez en consulter les détails dans le Résumé de la réservation." } }
        },
        access: {
          cabinClassTooltipButton: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Savoir plus" } }
        },
        filter: {
          label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Filtrer par nombre d'escales :" } },
          "dropdown-default": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Toutes les escales" } },
          "dropdown-direct": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Vols directs seulement" } },
          "dropdown-1stop-or-less": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "1 escale ou moins" } },
          "flights-found": { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 4, k: "count" }, { t: 3, v: " vol trouvé" }] }, { t: 2, i: [{ t: 4, k: "count" }, { t: 3, v: " vols trouvés" }] }] } }
        }
      },
      ancillary: {
        labels: {
          title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ajouts" } },
          travelProtection: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Protection de voyage" } },
          terms: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Conditions générales" } },
          showDetails: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Voir plus" } },
          hideDetails: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Voir moins" } },
          recommended: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Recommandé" } },
          traveller: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "/ voyageur" } },
          adult: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "/ adulte" } },
          perTraveller: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "par voyageur" } },
          perAdult: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "par adulte" } },
          from: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "À partir de" } },
          price: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Prix" } },
          careflex: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "TouteFlexibilité" } },
          carefree: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "TouteTranquillité" } },
          travelprotection: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Protection de voyage" } },
          travelprotectionNote: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ajoutez de la flexibilité et de la tranquillité d'esprit à vos vacances avec l'une de nos solutions de protection de voyage." } },
          privateTransfer: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Transfert privé" } },
          privateTransferNote: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Réservez des transferts privés aller-retour entre l'aéroport et votre hôtel ou complexe." } },
          mealPlan: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Formule de repas" } },
          mealPlanNote: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Surclassez la formule de repas de votre forfait et offrez-vous une expérience culinaire améliorée." } },
          activities: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Attractions et excursions" } },
          activitiesNote: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Transformez un voyage ordinaire en voyage extraordinaire. Ajoutez des incontournables à visiter dans votre destination." } },
          showOptions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Afficher options" } },
          hideOptions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Masquer options" } },
          showingMealPlanResults: { t: 0, b: { t: 2, i: [{ t: 3, v: "Affichage de 1 à " }, { t: 4, k: "end" }, { t: 3, v: " sur " }, { t: 4, k: "total" }, { t: 3, v: " formule(s) de repas" }] } },
          showingOptionsResults: { t: 0, b: { t: 2, i: [{ t: 3, v: "Affichage de 1 à " }, { t: 4, k: "end" }, { t: 3, v: " sur " }, { t: 4, k: "total" }, { t: 3, v: " options" }] } },
          nothingToDisplay: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Il ne semble pas y avoir d'ajouts disponibles pour votre voyage." } },
          bookingSummary: {
            CAREFLEX: {
              name: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "TouteTranquillité" } },
              inclusions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Comprend l'annulation avec remboursement ou crédit de voyage, les modifications de réservation et le transfert de forfait. Certaines conditions s'appliquent." } }
            },
            CAREFREE: {
              name: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "TouteFlexibilité" } },
              inclusions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Comprend la sélection standard des sièges et notre garantie ProtègePrix. Certaines conditions s'appliquent." } }
            }
          }
        },
        nudge: {
          taxesincl: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Taxes et frais inclus" } },
          total: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Total" } }
        },
        access: {
          details: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Savoir plus" } },
          "know-more-about": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Savoir plus sur" } },
          included: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Inclus avec " } },
          "table-cell-empty": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Vide" } }
        },
        messages: {
          waitingScreenMessageTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ajout de votre vol" } },
          waitingScreenMessageDescription: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Accordez-nous une minute pendant que nous traitons votre demande.<br>Ne rafraîchissez pas la page et ne cliquez pas sur le bouton d'arrêt ou « Précédent »." } }
        }
      },
      prices: {
        labels: {
          promoCode: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Code promo" } }
        },
        deposit: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Dépôt" } },
        "deposit-payment-remaining-balance-message": { t: 0, b: { t: 2, i: [{ t: 3, v: "Solde restant <br/>à payer d'ici le <b>" }, { t: 4, k: "date" }, { t: 3, v: "</b>" }] } },
        "deposit-payment-remaining-balance-mobile-message": { t: 0, b: { t: 2, i: [{ t: 3, v: "<b>" }, { t: 4, k: "remaining" }, { t: 3, v: "</b> à payer d'ici le <b>" }, { t: 4, k: "date" }, { t: 3, v: "</b>" }] } },
        hotelInclusions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Inclusions" } },
        "plane-icon": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Alerte aéroport! " } },
        "multiple-airport-destination": { t: 0, b: { t: 2, i: [{ t: 3, v: "Vol aller-retour via " }, { t: 4, k: "name" }, { t: 3, v: " (" }, { t: 4, k: "iata" }, { t: 3, v: ")" }] } }
      },
      giftCard: {
        labels: {
          giftCard: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Payer par Carte-cadeau, eCoupon ou bon d'échange Air Canada" } },
          giftCardNumber: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Numéro de carte (15 chiffres)*" } },
          giftCardPIN: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "NIP (4 chiffres)*" } }
        },
        errors: {
          giftCardAmountZero: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez entrer un montant." } },
          giftCardInsufficientAmount: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Le solde de votre carte cadeau est insuffisant. Veuillez sélectionner un autre mode de paiement." } },
          giftCardPIN: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez entrer un NIP." } },
          giftCardNumber: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez entrer un numéro de carte-cadeau." } },
          giftCardOnlyNumbers: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Seuls les chiffres sont acceptés" } },
          giftCardLessThanDepositWithoutInsurance: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Le montant doit être égal ou inférieur au montant du dépôt dû, sans la prime d'assurance." } },
          giftCardSplitDeposit: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Le montant doit être égal ou inférieur au montant du dépôt" } },
          giftCardSplitTotal: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Le montant doit être égal ou inférieur au montant total dû." } },
          giftCardSplitTotalWithoutInsurance: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Le montant doit être égal ou inférieur au montant total dû, sans la prime d'assurance." } }
        },
        messages: {
          giftCardCheckAmountLink: { t: 0, b: { t: 2, i: [{ t: 3 }], s: '<a href="https://www.aircanada.com/ca/fr/aco/home/book/payment-methods/air-canada-gift-cards.html#/" target="_blank" class="link">Vérifiez le solde de votre carte-cadeau, de votre bon électronique ou de votre bon de voyage.</a>' } }
        }
      },
      showmoreresults: {
        labels: {
          moreresultsCTA: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Afficher plus" } },
          showingresultsmessage: { t: 0, b: { t: 2, i: [{ t: 3, v: "Affichage de 1 à " }, { t: 4, k: "end" }, { t: 3, v: " sur " }, { t: 4, k: "total" }, { t: 3, v: " résultat(s)" }] } },
          showingRoomsResultsMessage: { t: 0, b: { t: 2, i: [{ t: 3, v: "Affichage de 1 à " }, { t: 4, k: "end" }, { t: 3, v: " sur " }, { t: 4, k: "total" }, { t: 3, v: " chambre(s)" }] } }
        }
      },
      alternatedates: {
        messages: {
          "not-available": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "La date de départ demandée n'est pas disponible" } },
          "select-available-dates": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Sélectionnez une date parmi les options ci-dessous." } },
          "found-one-date": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Voici la prochaine date disponible :" } }
        },
        labels: {
          "prefix-available-date": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Le " } }
        },
        errors: {
          "mandatory-date": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez sélectionner une date." } }
        }
      }
    }
  } }
), ep = /* @__PURE__ */ new Map([
  ["mealPlans", "Meal Plan"],
  ["activities", "Activities"],
  ["privateTransfer", "Private Transfer"],
  ["travelProtections", "Travel Protection"]
]), di = {
  mobile: 576,
  tablet: 768,
  desktop: 992,
  largeDesktop: 1200,
  extraLargeDesktop: 1400
}, eh = /* @__PURE__ */ new Map([
  ["economy", "economyCabins"],
  ["premiumeconomy", "premiumEconomyCabins"],
  ["business", "businessCabins"],
  ["mixed", "mixedCabins"]
]), j$ = /* @__PURE__ */ new Map([
  ["economy", "Economy"],
  ["premiumeconomy", "Premium Economy"],
  ["business", "Business"]
]), th = /* @__PURE__ */ new Map([
  ["economyCabins", "economy"],
  ["premiumEconomyCabins", "premiumeconomy"],
  ["businessCabins", "business"],
  ["mixedCabins", "mixed"]
]), nh = {
  en: {
    short: {
      year: "numeric",
      month: "short",
      day: "numeric"
    },
    long: {
      year: "numeric",
      month: "short",
      day: "numeric",
      weekday: "short",
      hour: "numeric",
      minute: "numeric",
      hour12: !0
    },
    time: {
      hour: "numeric",
      minute: "numeric",
      hour12: !0
    },
    medium: {
      year: "numeric",
      month: "long",
      day: "numeric",
      weekday: "long"
    }
  },
  fr: {
    short: {
      year: "numeric",
      month: "short",
      day: "numeric"
    },
    long: {
      year: "numeric",
      month: "short",
      day: "numeric",
      weekday: "short",
      hour: "numeric",
      minute: "numeric",
      hour12: !0
    },
    time: {
      hour: "numeric",
      minute: "numeric",
      hour12: !1
    },
    medium: {
      year: "numeric",
      month: "long",
      day: "numeric",
      weekday: "long"
    }
  }
};
var Qc = /* @__PURE__ */ ((e) => (e.NOT_DEFINED = "not-defined", e.AUTH = "FWK.gZbHYSnFdC", e.CACHE_PARSE = "FWK.Q6fIgymToy", e.RESOURCE_NOT_FOUND = "FWK.tP6OWnrk3f", e.WEB_CLIENT = "FWK.Iq9P7cNBd3", e.CONCURRENCY = "FWK.Tr45gRE541", e.FORBIDDEN_GROUP = "FWK.QU4Yhpu6UX", e.USER_CHANGE = "FWK.aL6GGPIDIt", e.INIT_TASK_ERROR = "init-task-error", e.LOCAL_CACHE_ERROR = "local-cache-error", e.INCORRECT_SEARCH = "INCORRECT_SEARCH", e.INVALID_PROMO_CODE = "INVALID_PROMO_CODE", e.FLIGHT_ERROR = "FLIGHT_ERROR", e))(Qc || {});
const q$ = "ERROR_3DS", K$ = /* @__PURE__ */ new Set(["TQO", "1375", "8743"]), Rn = {
  INCORRECT_SEARCH: "INCORRECT_SEARCH",
  INVALID_NUM_ROOM_CHILD: "INVALID_NUM_ROOM_CHILD",
  INVALID_OCCUPANCY: "INVALID_OCCUPANCY",
  GENERAL_SAX_ERROR: "GENERAL_SAX_ERROR",
  ADULTS_REPARTITION_ERROR: "ADULTS_REPARTITION_ERROR"
}, Y$ = [
  "AB",
  "BC",
  "MB",
  "NB",
  "NL",
  "NT",
  "NS",
  "NU",
  "ON",
  "PE",
  "QC",
  "SK",
  "YT"
], G$ = [
  "AL",
  "AK",
  "AZ",
  "AR",
  "CA",
  "CO",
  "CT",
  "DE",
  "DC",
  "FL",
  "GA",
  "HI",
  "ID",
  "IL",
  "IN",
  "IA",
  "KS",
  "KY",
  "LA",
  "ME",
  "MD",
  "MA",
  "MI",
  "MN",
  "MS",
  "MO",
  "MT",
  "NE",
  "NV",
  "NH",
  "NJ",
  "NM",
  "NY",
  "NC",
  "ND",
  "OH",
  "OK",
  "OR",
  "PA",
  "RI",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "VT",
  "VA",
  "WA",
  "WV",
  "WI",
  "WY"
], Z$ = ["CA", "US"], tp = "4", np = "5", op = "34", sp = "37", on = "ccErrorText", Ho = "cvvErrorMessage", Hn = "ccframe1", wn = "ccframe2";
var Ns = /* @__PURE__ */ ((e) => (e.en = "en", e.fr = "fr", e))(Ns || {}), eu = /* @__PURE__ */ ((e) => (e.enCA = "en-CA", e.frCA = "fr-CA", e))(eu || {});
const oh = {
  currency: {
    style: "currency",
    currency: "CAD",
    notation: "standard",
    // "standard", "scientific", "engineering", "compact"
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  },
  decimal: {
    style: "decimal",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  },
  percent: {
    style: "percent",
    useGrouping: !1
  },
  short: {
    style: "decimal",
    notation: "compact",
    compactDisplay: "short",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  }
}, tu = {
  personName: /^[a-zA-Z\u00C0-\u017F\s'-]+$/
}, da = 20, X$ = 10, J$ = /^[A-Za-z]\d[A-Za-z]([- ]?\d[A-Za-z]\d)?$/, Q$ = /^\d{5}(?:[-\s]\d{4})?$/, vo = N$({
  legacy: !1,
  locale: "en",
  globalInjection: !0,
  fallbackLocale: "en",
  messages: W$
});
vo.global.setNumberFormat("en", oh);
vo.global.setNumberFormat("fr", oh);
vo.global.setDateTimeFormat("en", nh.en);
vo.global.setDateTimeFormat("fr", nh.fr);
function Se(e, t, n) {
  return sh(e, t, !!n, "currency");
}
function ap(e, t) {
  return sh(e, t, !1, "decimal");
}
function sh(e, t, n, o) {
  try {
    const s = n ? 0 : 2;
    return t(Number(e), o, {
      minimumFractionDigits: s,
      maximumFractionDigits: s
    }).replace("CA", "");
  } catch {
    return "";
  }
}
const e_ = { class: "was-price" }, t_ = { class: "was" }, n_ = { class: "sr-only" }, o_ = { class: "save" }, s_ = /* @__PURE__ */ K({
  __name: "VacvWasPrice",
  props: {
    percentage: {},
    wasPrice: {}
  },
  emits: ["toggle"],
  setup(e) {
    return (t, n) => (b(), C("div", e_, [
      d("button", {
        type: "button",
        class: "was-price-popover-link link",
        "aria-haspopup": "true",
        onClick: n[0] || (n[0] = (o) => t.$emit("toggle"))
      }, [
        d("del", t_, [
          d("span", n_, k(t.$t("vacvComponents.wasPrice.was")), 1),
          ne(k(T(Se)(t.wasPrice, t.$n, !1)), 1)
        ]),
        d("span", o_, " " + k(t.$t("vacvComponents.wasPrice.save", { percent: t.percentage })), 1)
      ])
    ]));
  }
}), a_ = { class: "vacv-trip-advisor" }, r_ = { class: "vacv-trip-advisor__rating" }, i_ = ["src", "alt"], l_ = { class: "vacv-trip-advisor__reviews" }, ah = /* @__PURE__ */ K({
  __name: "VacvTripAdvisor",
  props: {
    rating: {}
  },
  setup(e) {
    const { t } = Ne({ useScope: "global" }), n = e, o = V(() => n.rating.reviews === 1 ? t("vacvComponents.tripAdvisor.review") : t("vacvComponents.tripAdvisor.reviews"));
    return (s, a) => (b(), C("div", a_, [
      d("span", r_, [
        d("img", {
          src: s.rating.ratingImageUrl,
          alt: T(t)("vacvComponents.tripAdvisor.access-rating") + s.rating.value + T(t)("vacvComponents.tripAdvisor.access-bubbles")
        }, null, 8, i_)
      ]),
      d("span", l_, k(s.$n(s.rating.reviews)) + " " + k(o.value), 1)
    ]));
  }
});
function ll(e) {
  return Yv() ? (Gv(e), !0) : !1;
}
function c_(e, t) {
  if (typeof Symbol < "u") {
    const n = { ...e };
    return Object.defineProperty(n, Symbol.iterator, {
      enumerable: !1,
      value() {
        let o = 0;
        return {
          next: () => ({
            value: t[o++],
            done: o > t.length
          })
        };
      }
    }), n;
  } else
    return Object.assign([...t], e);
}
function yt(e) {
  return typeof e == "function" ? e() : T(e);
}
const rp = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const u_ = Object.prototype.toString, p_ = (e) => u_.call(e) === "[object Object]", Ut = () => {
}, d_ = /* @__PURE__ */ f_();
function f_() {
  var e, t;
  return rp && ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((t = window == null ? void 0 : window.navigator) == null ? void 0 : t.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function rh(e, t) {
  function n(...o) {
    return new Promise((s, a) => {
      Promise.resolve(e(() => t.apply(this, o), { fn: t, thisArg: this, args: o })).then(s).catch(a);
    });
  }
  return n;
}
function m_(e, t = {}) {
  let n, o, s = Ut;
  const a = (i) => {
    clearTimeout(i), s(), s = Ut;
  };
  return (i) => {
    const l = yt(e), c = yt(t.maxWait);
    return n && a(n), l <= 0 || c !== void 0 && c <= 0 ? (o && (a(o), o = null), Promise.resolve(i())) : new Promise((u, p) => {
      s = t.rejectOnCancel ? p : u, c && !o && (o = setTimeout(() => {
        n && a(n), o = null, u(i());
      }, c)), n = setTimeout(() => {
        o && a(o), o = null, u(i());
      }, l);
    });
  };
}
function v_(...e) {
  let t = 0, n, o = !0, s = Ut, a, r, i, l, c;
  !Pt(e[0]) && typeof e[0] == "object" ? { delay: r, trailing: i = !0, leading: l = !0, rejectOnCancel: c = !1 } = e[0] : [r, i = !0, l = !0, c = !1] = e;
  const u = () => {
    n && (clearTimeout(n), n = void 0, s(), s = Ut);
  };
  return (f) => {
    const m = yt(r), h = Date.now() - t, g = () => a = f();
    return u(), m <= 0 ? (t = Date.now(), g()) : (h > m && (l || !o) ? (t = Date.now(), g()) : i && (a = new Promise((_, v) => {
      s = c ? v : _, n = setTimeout(() => {
        t = Date.now(), o = !0, _(g()), u();
      }, Math.max(0, m - h));
    })), !l && !n && (n = setTimeout(() => o = !0, m)), o = !1, a);
  };
}
function h_(e) {
  const t = /* @__PURE__ */ Object.create(null);
  return (n) => t[n] || (t[n] = e(n));
}
const g_ = /-(\w)/g, b_ = h_((e) => e.replace(g_, (t, n) => n ? n.toUpperCase() : ""));
function y_(e, t) {
  var n;
  if (typeof e == "number")
    return e + t;
  const o = ((n = e.match(/^-?\d+\.?\d*/)) == null ? void 0 : n[0]) || "", s = e.slice(o.length), a = Number.parseFloat(o) + t;
  return Number.isNaN(a) ? e : a + s;
}
function $_(e) {
  return bo();
}
function __(...e) {
  if (e.length !== 1)
    return Wo(...e);
  const t = e[0];
  return typeof t == "function" ? Gu(Zv(() => ({ get: t, set: Ut }))) : R(t);
}
function ip(e, t = 200, n = {}) {
  return rh(
    m_(t, n),
    e
  );
}
function w_(e, t = 200, n = !1, o = !0, s = !1) {
  return rh(
    v_(t, n, o, s),
    e
  );
}
function ih(e, t = !0, n) {
  $_() ? Re(e, n) : t ? e() : rn(e);
}
function lp(e, t, n = {}) {
  const {
    immediate: o = !0
  } = n, s = R(!1);
  let a = null;
  function r() {
    a && (clearTimeout(a), a = null);
  }
  function i() {
    s.value = !1, r();
  }
  function l(...c) {
    r(), s.value = !0, a = setTimeout(() => {
      s.value = !1, a = null, e(...c);
    }, yt(t));
  }
  return o && (s.value = !0, rp && l()), ll(i), {
    isPending: Gu(s),
    start: l,
    stop: i
  };
}
function C_(e = {}) {
  const {
    inheritAttrs: t = !0
  } = e, n = ea(), o = /* @__PURE__ */ K({
    setup(a, { slots: r }) {
      return () => {
        n.value = r.default;
      };
    }
  }), s = /* @__PURE__ */ K({
    inheritAttrs: t,
    setup(a, { attrs: r, slots: i }) {
      return () => {
        var l;
        if (!n.value && process.env.NODE_ENV !== "production")
          throw new Error("[VueUse] Failed to find the definition of reusable template");
        const c = (l = n.value) == null ? void 0 : l.call(n, { ...k_(r), $slots: i });
        return t && (c == null ? void 0 : c.length) === 1 ? c[0] : c;
      };
    }
  });
  return c_(
    { define: o, reuse: s },
    [o, s]
  );
}
function k_(e) {
  const t = {};
  for (const n in e)
    t[b_(n)] = e[n];
  return t;
}
function Uo(e) {
  var t;
  const n = yt(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
const ns = rp ? window : void 0;
function bt(...e) {
  let t, n, o, s;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([n, o, s] = e, t = ns) : [t, n, o, s] = e, !t)
    return Ut;
  Array.isArray(n) || (n = [n]), Array.isArray(o) || (o = [o]);
  const a = [], r = () => {
    a.forEach((u) => u()), a.length = 0;
  }, i = (u, p, f, m) => (u.addEventListener(p, f, m), () => u.removeEventListener(p, f, m)), l = le(
    () => [Uo(t), yt(s)],
    ([u, p]) => {
      if (r(), !u)
        return;
      const f = p_(p) ? { ...p } : p;
      a.push(
        ...n.flatMap((m) => o.map((h) => i(u, m, h, f)))
      );
    },
    { immediate: !0, flush: "post" }
  ), c = () => {
    l(), r();
  };
  return ll(c), c;
}
let Rd = !1;
function lh(e, t, n = {}) {
  const { window: o = ns, ignore: s = [], capture: a = !0, detectIframe: r = !1 } = n;
  if (!o)
    return Ut;
  d_ && !Rd && (Rd = !0, Array.from(o.document.body.children).forEach((f) => f.addEventListener("click", Ut)), o.document.documentElement.addEventListener("click", Ut));
  let i = !0;
  const l = (f) => s.some((m) => {
    if (typeof m == "string")
      return Array.from(o.document.querySelectorAll(m)).some((h) => h === f.target || f.composedPath().includes(h));
    {
      const h = Uo(m);
      return h && (f.target === h || f.composedPath().includes(h));
    }
  }), u = [
    bt(o, "click", (f) => {
      const m = Uo(e);
      if (!(!m || m === f.target || f.composedPath().includes(m))) {
        if (f.detail === 0 && (i = !l(f)), !i) {
          i = !0;
          return;
        }
        t(f);
      }
    }, { passive: !0, capture: a }),
    bt(o, "pointerdown", (f) => {
      const m = Uo(e);
      i = !l(f) && !!(m && !f.composedPath().includes(m));
    }, { passive: !0 }),
    r && bt(o, "blur", (f) => {
      setTimeout(() => {
        var m;
        const h = Uo(e);
        ((m = o.document.activeElement) == null ? void 0 : m.tagName) === "IFRAME" && !(h != null && h.contains(o.document.activeElement)) && t(f);
      }, 0);
    })
  ].filter(Boolean);
  return () => u.forEach((f) => f());
}
function S_() {
  const e = R(!1), t = bo();
  return t && Re(() => {
    e.value = !0;
  }, t), e;
}
function T_(e) {
  const t = S_();
  return V(() => (t.value, !!e()));
}
function gs(e, t = {}) {
  const { window: n = ns } = t, o = T_(() => n && "matchMedia" in n && typeof n.matchMedia == "function");
  let s;
  const a = R(!1), r = (c) => {
    a.value = c.matches;
  }, i = () => {
    s && ("removeEventListener" in s ? s.removeEventListener("change", r) : s.removeListener(r));
  }, l = Wt(() => {
    o.value && (i(), s = n.matchMedia(yt(e)), "addEventListener" in s ? s.addEventListener("change", r) : s.addListener(r), a.value = s.matches);
  });
  return ll(() => {
    l(), i(), s = void 0;
  }), a;
}
function A_(e, t = {}) {
  function n(u, p) {
    let f = yt(e[yt(u)]);
    return p != null && (f = y_(f, p)), typeof f == "number" && (f = `${f}px`), f;
  }
  const { window: o = ns, strategy: s = "min-width" } = t;
  function a(u) {
    return o ? o.matchMedia(u).matches : !1;
  }
  const r = (u) => gs(() => `(min-width: ${n(u)})`, t), i = (u) => gs(() => `(max-width: ${n(u)})`, t), l = Object.keys(e).reduce((u, p) => (Object.defineProperty(u, p, {
    get: () => s === "min-width" ? r(p) : i(p),
    enumerable: !0,
    configurable: !0
  }), u), {});
  function c() {
    const u = Object.keys(e).map((p) => [p, r(p)]);
    return V(() => u.filter(([, p]) => p.value).map(([p]) => p));
  }
  return Object.assign(l, {
    greaterOrEqual: r,
    smallerOrEqual: i,
    greater(u) {
      return gs(() => `(min-width: ${n(u, 0.1)})`, t);
    },
    smaller(u) {
      return gs(() => `(max-width: ${n(u, -0.1)})`, t);
    },
    between(u, p) {
      return gs(() => `(min-width: ${n(u)}) and (max-width: ${n(p, -0.1)})`, t);
    },
    isGreater(u) {
      return a(`(min-width: ${n(u, 0.1)})`);
    },
    isGreaterOrEqual(u) {
      return a(`(min-width: ${n(u)})`);
    },
    isSmaller(u) {
      return a(`(max-width: ${n(u, -0.1)})`);
    },
    isSmallerOrEqual(u) {
      return a(`(max-width: ${n(u)})`);
    },
    isInBetween(u, p) {
      return a(`(min-width: ${n(u)}) and (max-width: ${n(p, -0.1)})`);
    },
    current: c,
    active() {
      const u = c();
      return V(() => u.value.length === 0 ? "" : u.value.at(-1));
    }
  });
}
function D_(e, t) {
  const n = ea(c()), o = __(e), s = V({
    get() {
      var u;
      let f = o.value.indexOf(n.value);
      return f < 0 && (f = (u = void 0) != null ? u : 0), f;
    },
    set(u) {
      a(u);
    }
  });
  function a(u) {
    const p = o.value, f = p.length, m = (u % f + f) % f, h = p[m];
    return n.value = h, h;
  }
  function r(u = 1) {
    return a(s.value + u);
  }
  function i(u = 1) {
    return r(u);
  }
  function l(u = 1) {
    return r(-u);
  }
  function c() {
    var u, p;
    return (p = yt((u = void 0) != null ? u : yt(e)[0])) != null ? p : void 0;
  }
  return le(o, () => a(s.value)), {
    state: n,
    index: s,
    next: i,
    prev: l,
    go: a
  };
}
const Vd = 1;
function P_(e, t = {}) {
  const {
    throttle: n = 0,
    idle: o = 200,
    onStop: s = Ut,
    onScroll: a = Ut,
    offset: r = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    },
    eventListenerOptions: i = {
      capture: !1,
      passive: !0
    },
    behavior: l = "auto",
    window: c = ns,
    onError: u = (I) => {
      console.error(I);
    }
  } = t, p = R(0), f = R(0), m = V({
    get() {
      return p.value;
    },
    set(I) {
      g(I, void 0);
    }
  }), h = V({
    get() {
      return f.value;
    },
    set(I) {
      g(void 0, I);
    }
  });
  function g(I, D) {
    var O, x, F, P;
    if (!c)
      return;
    const E = yt(e);
    if (!E)
      return;
    (F = E instanceof Document ? c.document.body : E) == null || F.scrollTo({
      top: (O = yt(D)) != null ? O : h.value,
      left: (x = yt(I)) != null ? x : m.value,
      behavior: yt(l)
    });
    const B = ((P = E == null ? void 0 : E.document) == null ? void 0 : P.documentElement) || (E == null ? void 0 : E.documentElement) || E;
    m != null && (p.value = B.scrollLeft), h != null && (f.value = B.scrollTop);
  }
  const _ = R(!1), v = tt({
    left: !0,
    right: !1,
    top: !0,
    bottom: !1
  }), w = tt({
    left: !1,
    right: !1,
    top: !1,
    bottom: !1
  }), y = (I) => {
    _.value && (_.value = !1, w.left = !1, w.right = !1, w.top = !1, w.bottom = !1, s(I));
  }, $ = ip(y, n + o), S = (I) => {
    var D;
    if (!c)
      return;
    const O = ((D = I == null ? void 0 : I.document) == null ? void 0 : D.documentElement) || (I == null ? void 0 : I.documentElement) || Uo(I), { display: x, flexDirection: F } = getComputedStyle(O), P = O.scrollLeft;
    w.left = P < p.value, w.right = P > p.value;
    const E = Math.abs(P) <= (r.left || 0), B = Math.abs(P) + O.clientWidth >= O.scrollWidth - (r.right || 0) - Vd;
    x === "flex" && F === "row-reverse" ? (v.left = B, v.right = E) : (v.left = E, v.right = B), p.value = P;
    let N = O.scrollTop;
    I === c.document && !N && (N = c.document.body.scrollTop), w.top = N < f.value, w.bottom = N > f.value;
    const Y = Math.abs(N) <= (r.top || 0), j = Math.abs(N) + O.clientHeight >= O.scrollHeight - (r.bottom || 0) - Vd;
    x === "flex" && F === "column-reverse" ? (v.top = j, v.bottom = Y) : (v.top = Y, v.bottom = j), f.value = N;
  }, A = (I) => {
    var D;
    if (!c)
      return;
    const O = (D = I.target.documentElement) != null ? D : I.target;
    S(O), _.value = !0, $(I), a(I);
  };
  return bt(
    e,
    "scroll",
    n ? w_(A, n, !0, !1) : A,
    i
  ), ih(() => {
    try {
      const I = yt(e);
      if (!I)
        return;
      S(I);
    } catch (I) {
      u(I);
    }
  }), bt(
    e,
    "scrollend",
    y,
    i
  ), {
    x: m,
    y: h,
    isScrolling: _,
    arrivedState: v,
    directions: w,
    measure() {
      const I = yt(e);
      c && I && S(I);
    }
  };
}
function I_(e, t = {}) {
  const {
    threshold: n = 50,
    onSwipe: o,
    onSwipeEnd: s,
    onSwipeStart: a,
    passive: r = !0,
    window: i = ns
  } = t, l = tt({ x: 0, y: 0 }), c = tt({ x: 0, y: 0 }), u = V(() => l.x - c.x), p = V(() => l.y - c.y), { max: f, abs: m } = Math, h = V(() => f(m(u.value), m(p.value)) >= n), g = R(!1), _ = V(() => h.value ? m(u.value) > m(p.value) ? u.value > 0 ? "left" : "right" : p.value > 0 ? "up" : "down" : "none"), v = (O) => [O.touches[0].clientX, O.touches[0].clientY], w = (O, x) => {
    l.x = O, l.y = x;
  }, y = (O, x) => {
    c.x = O, c.y = x;
  };
  let $;
  const S = E_(i == null ? void 0 : i.document);
  r ? $ = S ? { passive: !0 } : { capture: !1 } : $ = S ? { passive: !1, capture: !0 } : { capture: !0 };
  const A = (O) => {
    g.value && (s == null || s(O, _.value)), g.value = !1;
  }, I = [
    bt(e, "touchstart", (O) => {
      if (O.touches.length !== 1)
        return;
      $.capture && !$.passive && O.preventDefault();
      const [x, F] = v(O);
      w(x, F), y(x, F), a == null || a(O);
    }, $),
    bt(e, "touchmove", (O) => {
      if (O.touches.length !== 1)
        return;
      const [x, F] = v(O);
      y(x, F), !g.value && h.value && (g.value = !0), g.value && (o == null || o(O));
    }, $),
    bt(e, ["touchend", "touchcancel"], A, $)
  ];
  return {
    isPassiveEventSupported: S,
    isSwiping: g,
    direction: _,
    coordsStart: l,
    coordsEnd: c,
    lengthX: u,
    lengthY: p,
    stop: () => I.forEach((O) => O())
  };
}
function E_(e) {
  if (!e)
    return !1;
  let t = !1;
  const n = {
    get passive() {
      return t = !0, !1;
    }
  };
  return e.addEventListener("x", Ut, n), e.removeEventListener("x", Ut), t;
}
function cp(e = {}) {
  const {
    window: t = ns,
    initialWidth: n = Number.POSITIVE_INFINITY,
    initialHeight: o = Number.POSITIVE_INFINITY,
    listenOrientation: s = !0,
    includeScrollbar: a = !0
  } = e, r = R(n), i = R(o), l = () => {
    t && (a ? (r.value = t.innerWidth, i.value = t.innerHeight) : (r.value = t.document.documentElement.clientWidth, i.value = t.document.documentElement.clientHeight));
  };
  if (l(), ih(l), bt("resize", l, { passive: !0 }), s) {
    const c = gs("(orientation: portrait)");
    le(c, () => l());
  }
  return { width: r, height: i };
}
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var ch = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], fi = /* @__PURE__ */ ch.join(","), uh = typeof Element > "u", Yo = uh ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, mi = !uh && Element.prototype.getRootNode ? function(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
} : function(e) {
  return e == null ? void 0 : e.ownerDocument;
}, vi = function e(t, n) {
  var o;
  n === void 0 && (n = !0);
  var s = t == null || (o = t.getAttribute) === null || o === void 0 ? void 0 : o.call(t, "inert"), a = s === "" || s === "true", r = a || n && t && e(t.parentNode);
  return r;
}, O_ = function(t) {
  var n, o = t == null || (n = t.getAttribute) === null || n === void 0 ? void 0 : n.call(t, "contenteditable");
  return o === "" || o === "true";
}, ph = function(t, n, o) {
  if (vi(t))
    return [];
  var s = Array.prototype.slice.apply(t.querySelectorAll(fi));
  return n && Yo.call(t, fi) && s.unshift(t), s = s.filter(o), s;
}, dh = function e(t, n, o) {
  for (var s = [], a = Array.from(t); a.length; ) {
    var r = a.shift();
    if (!vi(r, !1))
      if (r.tagName === "SLOT") {
        var i = r.assignedElements(), l = i.length ? i : r.children, c = e(l, !0, o);
        o.flatten ? s.push.apply(s, c) : s.push({
          scopeParent: r,
          candidates: c
        });
      } else {
        var u = Yo.call(r, fi);
        u && o.filter(r) && (n || !t.includes(r)) && s.push(r);
        var p = r.shadowRoot || // check for an undisclosed shadow
        typeof o.getShadowRoot == "function" && o.getShadowRoot(r), f = !vi(p, !1) && (!o.shadowRootFilter || o.shadowRootFilter(r));
        if (p && f) {
          var m = e(p === !0 ? r.children : p.children, !0, o);
          o.flatten ? s.push.apply(s, m) : s.push({
            scopeParent: r,
            candidates: m
          });
        } else
          a.unshift.apply(a, r.children);
      }
  }
  return s;
}, fh = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, Ro = function(t) {
  if (!t)
    throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || O_(t)) && !fh(t) ? 0 : t.tabIndex;
}, x_ = function(t, n) {
  var o = Ro(t);
  return o < 0 && n && !fh(t) ? 0 : o;
}, M_ = function(t, n) {
  return t.tabIndex === n.tabIndex ? t.documentOrder - n.documentOrder : t.tabIndex - n.tabIndex;
}, mh = function(t) {
  return t.tagName === "INPUT";
}, L_ = function(t) {
  return mh(t) && t.type === "hidden";
}, N_ = function(t) {
  var n = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(o) {
    return o.tagName === "SUMMARY";
  });
  return n;
}, F_ = function(t, n) {
  for (var o = 0; o < t.length; o++)
    if (t[o].checked && t[o].form === n)
      return t[o];
}, R_ = function(t) {
  if (!t.name)
    return !0;
  var n = t.form || mi(t), o = function(i) {
    return n.querySelectorAll('input[type="radio"][name="' + i + '"]');
  }, s;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    s = o(window.CSS.escape(t.name));
  else
    try {
      s = o(t.name);
    } catch (r) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", r.message), !1;
    }
  var a = F_(s, t.form);
  return !a || a === t;
}, V_ = function(t) {
  return mh(t) && t.type === "radio";
}, B_ = function(t) {
  return V_(t) && !R_(t);
}, H_ = function(t) {
  var n, o = t && mi(t), s = (n = o) === null || n === void 0 ? void 0 : n.host, a = !1;
  if (o && o !== t) {
    var r, i, l;
    for (a = !!((r = s) !== null && r !== void 0 && (i = r.ownerDocument) !== null && i !== void 0 && i.contains(s) || t != null && (l = t.ownerDocument) !== null && l !== void 0 && l.contains(t)); !a && s; ) {
      var c, u, p;
      o = mi(s), s = (c = o) === null || c === void 0 ? void 0 : c.host, a = !!((u = s) !== null && u !== void 0 && (p = u.ownerDocument) !== null && p !== void 0 && p.contains(s));
    }
  }
  return a;
}, Bd = function(t) {
  var n = t.getBoundingClientRect(), o = n.width, s = n.height;
  return o === 0 && s === 0;
}, U_ = function(t, n) {
  var o = n.displayCheck, s = n.getShadowRoot;
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  var a = Yo.call(t, "details>summary:first-of-type"), r = a ? t.parentElement : t;
  if (Yo.call(r, "details:not([open]) *"))
    return !0;
  if (!o || o === "full" || o === "legacy-full") {
    if (typeof s == "function") {
      for (var i = t; t; ) {
        var l = t.parentElement, c = mi(t);
        if (l && !l.shadowRoot && s(l) === !0)
          return Bd(t);
        t.assignedSlot ? t = t.assignedSlot : !l && c !== t.ownerDocument ? t = c.host : t = l;
      }
      t = i;
    }
    if (H_(t))
      return !t.getClientRects().length;
    if (o !== "legacy-full")
      return !0;
  } else if (o === "non-zero-area")
    return Bd(t);
  return !1;
}, z_ = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var n = t.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var o = 0; o < n.children.length; o++) {
          var s = n.children.item(o);
          if (s.tagName === "LEGEND")
            return Yo.call(n, "fieldset[disabled] *") ? !0 : !s.contains(t);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, hi = function(t, n) {
  return !(n.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  vi(n) || L_(n) || U_(n, t) || // For a details element with a summary, the summary element gets the focus
  N_(n) || z_(n));
}, nu = function(t, n) {
  return !(B_(n) || Ro(n) < 0 || !hi(t, n));
}, W_ = function(t) {
  var n = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, j_ = function e(t) {
  var n = [], o = [];
  return t.forEach(function(s, a) {
    var r = !!s.scopeParent, i = r ? s.scopeParent : s, l = x_(i, r), c = r ? e(s.candidates) : i;
    l === 0 ? r ? n.push.apply(n, c) : n.push(i) : o.push({
      documentOrder: a,
      tabIndex: l,
      item: s,
      isScope: r,
      content: c
    });
  }), o.sort(M_).reduce(function(s, a) {
    return a.isScope ? s.push.apply(s, a.content) : s.push(a.content), s;
  }, []).concat(n);
}, q_ = function(t, n) {
  n = n || {};
  var o;
  return n.getShadowRoot ? o = dh([t], n.includeContainer, {
    filter: nu.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: W_
  }) : o = ph(t, n.includeContainer, nu.bind(null, n)), j_(o);
}, K_ = function(t, n) {
  n = n || {};
  var o;
  return n.getShadowRoot ? o = dh([t], n.includeContainer, {
    filter: hi.bind(null, n),
    flatten: !0,
    getShadowRoot: n.getShadowRoot
  }) : o = ph(t, n.includeContainer, hi.bind(null, n)), o;
}, ls = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return Yo.call(t, fi) === !1 ? !1 : nu(n, t);
}, Y_ = /* @__PURE__ */ ch.concat("iframe").join(","), ql = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return Yo.call(t, Y_) === !1 ? !1 : hi(n, t);
};
/*!
* focus-trap 7.6.5
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/
function ou(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = Array(t); n < t; n++) o[n] = e[n];
  return o;
}
function G_(e) {
  if (Array.isArray(e)) return ou(e);
}
function Z_(e, t, n) {
  return (t = tw(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function X_(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function J_() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Hd(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function Ud(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Hd(Object(n), !0).forEach(function(o) {
      Z_(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Hd(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function Q_(e) {
  return G_(e) || X_(e) || nw(e) || J_();
}
function ew(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t);
    if (typeof o != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function tw(e) {
  var t = ew(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function nw(e, t) {
  if (e) {
    if (typeof e == "string") return ou(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? ou(e, t) : void 0;
  }
}
var zd = {
  activateTrap: function(t, n) {
    if (t.length > 0) {
      var o = t[t.length - 1];
      o !== n && o._setPausedState(!0);
    }
    var s = t.indexOf(n);
    s === -1 || t.splice(s, 1), t.push(n);
  },
  deactivateTrap: function(t, n) {
    var o = t.indexOf(n);
    o !== -1 && t.splice(o, 1), t.length > 0 && !t[t.length - 1]._isManuallyPaused() && t[t.length - 1]._setPausedState(!1);
  }
}, ow = function(t) {
  return t.tagName && t.tagName.toLowerCase() === "input" && typeof t.select == "function";
}, sw = function(t) {
  return (t == null ? void 0 : t.key) === "Escape" || (t == null ? void 0 : t.key) === "Esc" || (t == null ? void 0 : t.keyCode) === 27;
}, Pa = function(t) {
  return (t == null ? void 0 : t.key) === "Tab" || (t == null ? void 0 : t.keyCode) === 9;
}, aw = function(t) {
  return Pa(t) && !t.shiftKey;
}, rw = function(t) {
  return Pa(t) && t.shiftKey;
}, Wd = function(t) {
  return setTimeout(t, 0);
}, fa = function(t) {
  for (var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), s = 1; s < n; s++)
    o[s - 1] = arguments[s];
  return typeof t == "function" ? t.apply(void 0, o) : t;
}, Sr = function(t) {
  return t.target.shadowRoot && typeof t.composedPath == "function" ? t.composedPath()[0] : t.target;
}, iw = [], lw = function(t, n) {
  var o = (n == null ? void 0 : n.document) || document, s = (n == null ? void 0 : n.trapStack) || iw, a = Ud({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0,
    isKeyForward: aw,
    isKeyBackward: rw
  }, n), r = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   posTabIndexesFound: boolean,
    //   firstTabbableNode: HTMLElement|undefined,
    //   lastTabbableNode: HTMLElement|undefined,
    //   firstDomTabbableNode: HTMLElement|undefined,
    //   lastDomTabbableNode: HTMLElement|undefined,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    manuallyPaused: !1,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0,
    // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
    recentNavEvent: void 0
  }, i, l = function(E, B, N) {
    return E && E[B] !== void 0 ? E[B] : a[N || B];
  }, c = function(E, B) {
    var N = typeof (B == null ? void 0 : B.composedPath) == "function" ? B.composedPath() : void 0;
    return r.containerGroups.findIndex(function(Y) {
      var j = Y.container, ee = Y.tabbableNodes;
      return j.contains(E) || // fall back to explicit tabbable search which will take into consideration any
      //  web components if the `tabbableOptions.getShadowRoot` option was used for
      //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
      //  look inside web components even if open)
      (N == null ? void 0 : N.includes(j)) || ee.find(function(te) {
        return te === E;
      });
    });
  }, u = function(E) {
    var B = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, N = B.hasFallback, Y = N === void 0 ? !1 : N, j = B.params, ee = j === void 0 ? [] : j, te = a[E];
    if (typeof te == "function" && (te = te.apply(void 0, Q_(ee))), te === !0 && (te = void 0), !te) {
      if (te === void 0 || te === !1)
        return te;
      throw new Error("`".concat(E, "` was specified but was not a node, or did not return a node"));
    }
    var ce = te;
    if (typeof te == "string") {
      try {
        ce = o.querySelector(te);
      } catch (H) {
        throw new Error("`".concat(E, '` appears to be an invalid selector; error="').concat(H.message, '"'));
      }
      if (!ce && !Y)
        throw new Error("`".concat(E, "` as selector refers to no known node"));
    }
    return ce;
  }, p = function() {
    var E = u("initialFocus", {
      hasFallback: !0
    });
    if (E === !1)
      return !1;
    if (E === void 0 || E && !ql(E, a.tabbableOptions))
      if (c(o.activeElement) >= 0)
        E = o.activeElement;
      else {
        var B = r.tabbableGroups[0], N = B && B.firstTabbableNode;
        E = N || u("fallbackFocus");
      }
    else E === null && (E = u("fallbackFocus"));
    if (!E)
      throw new Error("Your focus-trap needs to have at least one focusable element");
    return E;
  }, f = function() {
    if (r.containerGroups = r.containers.map(function(E) {
      var B = q_(E, a.tabbableOptions), N = K_(E, a.tabbableOptions), Y = B.length > 0 ? B[0] : void 0, j = B.length > 0 ? B[B.length - 1] : void 0, ee = N.find(function(H) {
        return ls(H);
      }), te = N.slice().reverse().find(function(H) {
        return ls(H);
      }), ce = !!B.find(function(H) {
        return Ro(H) > 0;
      });
      return {
        container: E,
        tabbableNodes: B,
        focusableNodes: N,
        /** True if at least one node with positive `tabindex` was found in this container. */
        posTabIndexesFound: ce,
        /** First tabbable node in container, __tabindex__ order; `undefined` if none. */
        firstTabbableNode: Y,
        /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */
        lastTabbableNode: j,
        // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
        //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
        //  because that API doesn't work with Shadow DOM as well as it should (@see
        //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
        //  to address an edge case related to positive tabindex support, this seems like a much easier,
        //  "close enough most of the time" alternative for positive tabindexes which should generally
        //  be avoided anyway...
        /** First tabbable node in container, __DOM__ order; `undefined` if none. */
        firstDomTabbableNode: ee,
        /** Last tabbable node in container, __DOM__ order; `undefined` if none. */
        lastDomTabbableNode: te,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function(oe) {
          var U = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, Q = B.indexOf(oe);
          return Q < 0 ? U ? N.slice(N.indexOf(oe) + 1).find(function(z) {
            return ls(z);
          }) : N.slice(0, N.indexOf(oe)).reverse().find(function(z) {
            return ls(z);
          }) : B[Q + (U ? 1 : -1)];
        }
      };
    }), r.tabbableGroups = r.containerGroups.filter(function(E) {
      return E.tabbableNodes.length > 0;
    }), r.tabbableGroups.length <= 0 && !u("fallbackFocus"))
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    if (r.containerGroups.find(function(E) {
      return E.posTabIndexesFound;
    }) && r.containerGroups.length > 1)
      throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
  }, m = function(E) {
    var B = E.activeElement;
    if (B)
      return B.shadowRoot && B.shadowRoot.activeElement !== null ? m(B.shadowRoot) : B;
  }, h = function(E) {
    if (E !== !1 && E !== m(document)) {
      if (!E || !E.focus) {
        h(p());
        return;
      }
      E.focus({
        preventScroll: !!a.preventScroll
      }), r.mostRecentlyFocusedNode = E, ow(E) && E.select();
    }
  }, g = function(E) {
    var B = u("setReturnFocus", {
      params: [E]
    });
    return B || (B === !1 ? !1 : E);
  }, _ = function(E) {
    var B = E.target, N = E.event, Y = E.isBackward, j = Y === void 0 ? !1 : Y;
    B = B || Sr(N), f();
    var ee = null;
    if (r.tabbableGroups.length > 0) {
      var te = c(B, N), ce = te >= 0 ? r.containerGroups[te] : void 0;
      if (te < 0)
        j ? ee = r.tabbableGroups[r.tabbableGroups.length - 1].lastTabbableNode : ee = r.tabbableGroups[0].firstTabbableNode;
      else if (j) {
        var H = r.tabbableGroups.findIndex(function(W) {
          var X = W.firstTabbableNode;
          return B === X;
        });
        if (H < 0 && (ce.container === B || ql(B, a.tabbableOptions) && !ls(B, a.tabbableOptions) && !ce.nextTabbableNode(B, !1)) && (H = te), H >= 0) {
          var oe = H === 0 ? r.tabbableGroups.length - 1 : H - 1, U = r.tabbableGroups[oe];
          ee = Ro(B) >= 0 ? U.lastTabbableNode : U.lastDomTabbableNode;
        } else Pa(N) || (ee = ce.nextTabbableNode(B, !1));
      } else {
        var Q = r.tabbableGroups.findIndex(function(W) {
          var X = W.lastTabbableNode;
          return B === X;
        });
        if (Q < 0 && (ce.container === B || ql(B, a.tabbableOptions) && !ls(B, a.tabbableOptions) && !ce.nextTabbableNode(B)) && (Q = te), Q >= 0) {
          var z = Q === r.tabbableGroups.length - 1 ? 0 : Q + 1, Z = r.tabbableGroups[z];
          ee = Ro(B) >= 0 ? Z.firstTabbableNode : Z.firstDomTabbableNode;
        } else Pa(N) || (ee = ce.nextTabbableNode(B));
      }
    } else
      ee = u("fallbackFocus");
    return ee;
  }, v = function(E) {
    var B = Sr(E);
    if (!(c(B, E) >= 0)) {
      if (fa(a.clickOutsideDeactivates, E)) {
        i.deactivate({
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked (and if not focusable, to "nothing"); by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node), whether the
          //  outside click was on a focusable node or not
          returnFocus: a.returnFocusOnDeactivate
        });
        return;
      }
      fa(a.allowOutsideClick, E) || E.preventDefault();
    }
  }, w = function(E) {
    var B = Sr(E), N = c(B, E) >= 0;
    if (N || B instanceof Document)
      N && (r.mostRecentlyFocusedNode = B);
    else {
      E.stopImmediatePropagation();
      var Y, j = !0;
      if (r.mostRecentlyFocusedNode)
        if (Ro(r.mostRecentlyFocusedNode) > 0) {
          var ee = c(r.mostRecentlyFocusedNode), te = r.containerGroups[ee].tabbableNodes;
          if (te.length > 0) {
            var ce = te.findIndex(function(H) {
              return H === r.mostRecentlyFocusedNode;
            });
            ce >= 0 && (a.isKeyForward(r.recentNavEvent) ? ce + 1 < te.length && (Y = te[ce + 1], j = !1) : ce - 1 >= 0 && (Y = te[ce - 1], j = !1));
          }
        } else
          r.containerGroups.some(function(H) {
            return H.tabbableNodes.some(function(oe) {
              return Ro(oe) > 0;
            });
          }) || (j = !1);
      else
        j = !1;
      j && (Y = _({
        // move FROM the MRU node, not event-related node (which will be the node that is
        //  outside the trap causing the focus escape we're trying to fix)
        target: r.mostRecentlyFocusedNode,
        isBackward: a.isKeyBackward(r.recentNavEvent)
      })), h(Y || r.mostRecentlyFocusedNode || p());
    }
    r.recentNavEvent = void 0;
  }, y = function(E) {
    var B = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    r.recentNavEvent = E;
    var N = _({
      event: E,
      isBackward: B
    });
    N && (Pa(E) && E.preventDefault(), h(N));
  }, $ = function(E) {
    (a.isKeyForward(E) || a.isKeyBackward(E)) && y(E, a.isKeyBackward(E));
  }, S = function(E) {
    sw(E) && fa(a.escapeDeactivates, E) !== !1 && (E.preventDefault(), i.deactivate());
  }, A = function(E) {
    var B = Sr(E);
    c(B, E) >= 0 || fa(a.clickOutsideDeactivates, E) || fa(a.allowOutsideClick, E) || (E.preventDefault(), E.stopImmediatePropagation());
  }, I = function() {
    if (r.active)
      return zd.activateTrap(s, i), r.delayInitialFocusTimer = a.delayInitialFocus ? Wd(function() {
        h(p());
      }) : h(p()), o.addEventListener("focusin", w, !0), o.addEventListener("mousedown", v, {
        capture: !0,
        passive: !1
      }), o.addEventListener("touchstart", v, {
        capture: !0,
        passive: !1
      }), o.addEventListener("click", A, {
        capture: !0,
        passive: !1
      }), o.addEventListener("keydown", $, {
        capture: !0,
        passive: !1
      }), o.addEventListener("keydown", S), i;
  }, D = function() {
    if (r.active)
      return o.removeEventListener("focusin", w, !0), o.removeEventListener("mousedown", v, !0), o.removeEventListener("touchstart", v, !0), o.removeEventListener("click", A, !0), o.removeEventListener("keydown", $, !0), o.removeEventListener("keydown", S), i;
  }, O = function(E) {
    var B = E.some(function(N) {
      var Y = Array.from(N.removedNodes);
      return Y.some(function(j) {
        return j === r.mostRecentlyFocusedNode;
      });
    });
    B && h(p());
  }, x = typeof window < "u" && "MutationObserver" in window ? new MutationObserver(O) : void 0, F = function() {
    x && (x.disconnect(), r.active && !r.paused && r.containers.map(function(E) {
      x.observe(E, {
        subtree: !0,
        childList: !0
      });
    }));
  };
  return i = {
    get active() {
      return r.active;
    },
    get paused() {
      return r.paused;
    },
    activate: function(E) {
      if (r.active)
        return this;
      var B = l(E, "onActivate"), N = l(E, "onPostActivate"), Y = l(E, "checkCanFocusTrap");
      Y || f(), r.active = !0, r.paused = !1, r.nodeFocusedBeforeActivation = m(o), B == null || B();
      var j = function() {
        Y && f(), I(), F(), N == null || N();
      };
      return Y ? (Y(r.containers.concat()).then(j, j), this) : (j(), this);
    },
    deactivate: function(E) {
      if (!r.active)
        return this;
      var B = Ud({
        onDeactivate: a.onDeactivate,
        onPostDeactivate: a.onPostDeactivate,
        checkCanReturnFocus: a.checkCanReturnFocus
      }, E);
      clearTimeout(r.delayInitialFocusTimer), r.delayInitialFocusTimer = void 0, D(), r.active = !1, r.paused = !1, F(), zd.deactivateTrap(s, i);
      var N = l(B, "onDeactivate"), Y = l(B, "onPostDeactivate"), j = l(B, "checkCanReturnFocus"), ee = l(B, "returnFocus", "returnFocusOnDeactivate");
      N == null || N();
      var te = function() {
        Wd(function() {
          ee && h(g(r.nodeFocusedBeforeActivation)), Y == null || Y();
        });
      };
      return ee && j ? (j(g(r.nodeFocusedBeforeActivation)).then(te, te), this) : (te(), this);
    },
    pause: function(E) {
      return r.active ? (r.manuallyPaused = !0, this._setPausedState(!0, E)) : this;
    },
    unpause: function(E) {
      return r.active ? (r.manuallyPaused = !1, s[s.length - 1] !== this ? this : this._setPausedState(!1, E)) : this;
    },
    updateContainerElements: function(E) {
      var B = [].concat(E).filter(Boolean);
      return r.containers = B.map(function(N) {
        return typeof N == "string" ? o.querySelector(N) : N;
      }), r.active && f(), F(), this;
    }
  }, Object.defineProperties(i, {
    _isManuallyPaused: {
      value: function() {
        return r.manuallyPaused;
      }
    },
    _setPausedState: {
      value: function(E, B) {
        if (r.paused === E)
          return this;
        if (r.paused = E, E) {
          var N = l(B, "onPause"), Y = l(B, "onPostPause");
          N == null || N(), D(), F(), Y == null || Y();
        } else {
          var j = l(B, "onUnpause"), ee = l(B, "onPostUnpause");
          j == null || j(), f(), I(), F(), ee == null || ee();
        }
        return this;
      }
    }
  }), i.updateContainerElements(t), i;
};
function cw(e, t = {}) {
  let n;
  const { immediate: o, ...s } = t, a = R(!1), r = R(!1), i = (p) => n && n.activate(p), l = (p) => n && n.deactivate(p), c = () => {
    n && (n.pause(), r.value = !0);
  }, u = () => {
    n && (n.unpause(), r.value = !1);
  };
  return le(
    () => Uo(e),
    (p) => {
      p && (n = lw(p, {
        ...s,
        onActivate() {
          a.value = !0, t.onActivate && t.onActivate();
        },
        onDeactivate() {
          a.value = !1, t.onDeactivate && t.onDeactivate();
        }
      }), o && i());
    },
    { flush: "post" }
  ), ll(() => l()), {
    hasFocus: a,
    isPaused: r,
    activate: i,
    deactivate: l,
    pause: c,
    unpause: u
  };
}
const uw = (e) => (...t) => {
  e && (e == null || e(...t), e = null);
}, Wa = () => {
};
function Tr(e, t, n) {
  return e > n ? n : e < t ? t : e;
}
function Kl(e, t) {
  var n;
  const o = ((n = Aa(e, t)) == null ? void 0 : n[0]) || t;
  e.push(o);
}
function Aa(e, t) {
  const n = e.indexOf(t);
  if (n !== -1)
    return e.splice(n, 1);
}
const pw = {
  /**
   * @description Set `null | false` to disable teleport.
   * @default `'body'`
   * @example
   * ```js
   * teleportTo: '#modals'
   * ```
   */
  teleportTo: {
    type: [String, null, Boolean, Object],
    default: "body"
  },
  /**
   * @description An uniq name for the open/close a modal via vfm.open/vfm.close APIs.
   * @default `undefined`
   * @example Symbol: `Symbol('MyModal')`
   * @example String: `'AUniqString'`
   * @example Number: `300`
   */
  modalId: {
    type: [String, Number, Symbol],
    default: void 0
  },
  /**
   * @description Display the modal or not.
   * @default `undefined`
   * @example
   * ```js
   * const showModal = ref(false)
   * v-model="showModal"
   * ```
   */
  modelValue: {
    type: Boolean,
    default: void 0
  },
  /**
   * @description Render the modal via `if` or `show`.
   * @default `'if'`
   * @example
   * ```js
   * displayDirective: 'if'
   * ```
   * @example
   * ```js
   * displayDirective: 'show'
   * ```
   */
  displayDirective: {
    type: String,
    default: "if",
    validator: (e) => ["if", "show", "visible"].includes(e)
  },
  /**
   * @description Hide the overlay or not.
   * @default `undefined`
   * @example
   * ```js
   * hideOverlay="true"
   * ```
   */
  hideOverlay: {
    type: Boolean,
    default: void 0
  },
  /**
   * @description Customize the overlay behavior.
   */
  overlayBehavior: {
    type: String,
    default: "auto",
    validator: (e) => ["auto", "persist"].includes(e)
  },
  /**
   * @description Customize the overlay transition.
   * @default `undefined`
   */
  overlayTransition: {
    type: [String, Object],
    default: void 0
  },
  /**
   * @description Customize the content transition.
   * @default `undefined`
   */
  contentTransition: {
    type: [String, Object],
    default: void 0
  },
  /**
   * @description Bind class to vfm__overlay.
   * @default `undefined`
   */
  overlayClass: {
    type: void 0,
    default: void 0
  },
  /**
   * @description Bind class to vfm__content.
   * @default `undefined`
   */
  contentClass: {
    type: void 0,
    default: void 0
  },
  /**
   * @description Bind style to vfm__overlay.
   * @default `undefined`
   */
  overlayStyle: {
    type: [String, Object, Array],
    default: void 0
  },
  /**
   * @description Bind style to vfm__content.
   * @default `undefined`
   */
  contentStyle: {
    type: [String, Object, Array],
    default: void 0
  },
  /**
   * @description Is it allow to close the modal by clicking the overlay.
   * @default `true`
   */
  clickToClose: {
    type: Boolean,
    default: !0
  },
  /**
   * @description Is it allow to close the modal by keypress `esc`.
   * @default `true`
   */
  escToClose: {
    type: Boolean,
    default: !0
  },
  /**
   * @description Is it allow to click outside of the vfm__content when the modal is opened
   * @default `'non-interactive'`
   */
  background: {
    type: String,
    default: "non-interactive",
    validator: (e) => ["interactive", "non-interactive"].includes(e)
  },
  /**
   * @description
   * * Use `{ disabled: true }` to disable the focusTrap.
   * * Checkout the createOptions type here https://github.com/focus-trap/focus-trap for more.
   * @default `{ allowOutsideClick: true }`
   */
  focusTrap: {
    type: [Boolean, Object],
    default: () => ({
      allowOutsideClick: !0
    })
  },
  /**
   * @description Lock body scroll or not when the modal is opened.
   * @default `true`
   */
  lockScroll: {
    type: Boolean,
    default: !0
  },
  /**
   * @description Creates a padding-right when scroll is locked to prevent the page from jumping
   * @default `true`
   */
  reserveScrollBarGap: {
    type: Boolean,
    default: !0
  },
  /**
   * @description Define how to increase the zIndex when there are nested modals
   * @default `({ index }) => 1000 + 2 * index`
   */
  zIndexFn: {
    type: Function,
    default: ({ index: e }) => 1e3 + 2 * e
  },
  /**
   * @description The direction of swiping to close the modal
   * @default `none`
   * @example
   * Set swipeToClose="none" to disable swiping to close
   * ```js
   * swipeToClose="none"
   * ```
   */
  swipeToClose: {
    type: String,
    default: "none",
    validator: (e) => ["none", "up", "right", "down", "left"].includes(e)
  },
  /**
   * @description Threshold for swipe to close
   * @default `0`
   */
  threshold: {
    type: Number,
    default: 0
  },
  /**
   * @description If set `:showSwipeBanner="true"`, only allow clicking `swipe-banner` slot to swipe to close
   * @default `undefined`
   * @example
   * ```js
   * swipeToClose="right"
   * :showSwipeBanner="true"
   * ```
   * ```html
   * <VueFinalModal
   *   ...
   *   swipeToClose="right"
   *   :showSwipeBanner="true"
   * >
   *   <template #swipe-banner>
   *     <div style="position: absolute; height: 100%; top: 0; left: 0; width: 10px;" />
   *   </template>
   *   ...modal content
   * </VueFinalModal>
   * ```
   */
  showSwipeBanner: {
    type: Boolean,
    default: void 0
  },
  /**
   * @description When set `:preventNavigationGestures="true"`, there will be two invisible bars for prevent navigation gestures including swiping back/forward on mobile webkit. For example: Safari mobile.
   * @default `undefined`
   * @example
   * Set preventNavigationGestures="true" to prevent Safari navigation gestures including swiping back/forward.
   * ```js
   * :preventNavigationGestures="true"
   * ```
   */
  preventNavigationGestures: {
    type: Boolean,
    default: void 0
  }
};
function jd(e = !1) {
  const t = R(e), n = R(t.value ? 0 : void 0);
  return [t, n, {
    beforeEnter() {
      n.value = 1;
    },
    afterEnter() {
      n.value = 0;
    },
    beforeLeave() {
      n.value = 3;
    },
    afterLeave() {
      n.value = 2;
    }
  }];
}
function dw(e, t) {
  const { modelValueLocal: n, onEntering: o, onEnter: s, onLeaving: a, onLeave: r } = t, i = R(n.value), [l, c, u] = jd(i.value), [p, f, m] = jd(i.value), h = V(() => typeof e.contentTransition == "string" ? { name: e.contentTransition, appear: !0 } : { appear: !0, ...e.contentTransition }), g = V(() => typeof e.overlayTransition == "string" ? { name: e.overlayTransition, appear: !0 } : { appear: !0, ...e.overlayTransition }), _ = V(
    () => (e.hideOverlay || f.value === 2) && c.value === 2
    /* Leave */
  );
  le(
    _,
    (y) => {
      y && (i.value = !1);
    }
  ), le(c, (y) => {
    if (y === 1) {
      if (!i.value)
        return;
      o == null || o();
    } else if (y === 0) {
      if (!i.value)
        return;
      s == null || s();
    } else
      y === 3 ? a == null || a() : y === 2 && (r == null || r());
  });
  async function v() {
    i.value = !0, await rn(), l.value = !0, p.value = !0;
  }
  function w() {
    l.value = !1, p.value = !1;
  }
  return {
    visible: i,
    contentVisible: l,
    contentListeners: u,
    contentTransition: h,
    overlayVisible: p,
    overlayListeners: m,
    overlayTransition: g,
    enterTransition: v,
    leaveTransition: w
  };
}
function fw(e, t, n) {
  const { vfmRootEl: o, vfmContentEl: s, visible: a, modelValueLocal: r } = n, i = R();
  function l() {
    a.value && e.escToClose && (r.value = !1);
  }
  function c(p) {
    i.value = p == null ? void 0 : p.target;
  }
  function u() {
    var p;
    i.value === o.value && (e.clickToClose ? r.value = !1 : ((p = s.value) == null || p.focus(), t("clickOutside")));
  }
  return {
    onEsc: l,
    onMouseupRoot: u,
    onMousedown: c
  };
}
function mw(e, t, n) {
  let o = !1;
  const { open: s, close: a } = n, r = R(!1), i = {
    get value() {
      return r.value;
    },
    set value(c) {
      l(c);
    }
  };
  function l(c) {
    (c ? s() : a()) ? (r.value = c, c !== e.modelValue && t("update:modelValue", c)) : (o = !0, t("update:modelValue", !c), rn(() => {
      o = !1;
    }));
  }
  return le(() => e.modelValue, (c) => {
    o || (i.value = !!c);
  }), {
    modelValueLocal: i
  };
}
function vw(e, t) {
  if (e.focusTrap === !1)
    return {
      focus() {
      },
      blur() {
      }
    };
  const { focusEl: n } = t, { hasFocus: o, activate: s, deactivate: a } = cw(n, e.focusTrap);
  function r() {
    requestAnimationFrame(() => {
      s();
    });
  }
  function i() {
    o.value && a();
  }
  return { focus: r, blur: i };
}
let up = !1;
if (typeof window < "u") {
  const e = {
    get passive() {
      up = !0;
    }
  };
  window.addEventListener("testPassive", null, e), window.removeEventListener("testPassive", null, e);
}
const vh = typeof window < "u" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);
let uo = [], gi = !1, Wr = 0, hh = -1, Ia, Ea;
const hw = (e) => {
  if (!e || e.nodeType !== Node.ELEMENT_NODE)
    return !1;
  const t = window.getComputedStyle(e);
  return ["auto", "scroll"].includes(t.overflowY) && e.scrollHeight > e.clientHeight;
}, gw = (e, t) => !(e.scrollTop === 0 && t < 0 || e.scrollTop + e.clientHeight + t >= e.scrollHeight && t > 0), bw = (e) => {
  const t = [];
  for (; e; ) {
    if (t.push(e), e.classList.contains("vfm"))
      return t;
    e = e.parentElement;
  }
  return t;
}, yw = (e, t) => {
  let n = !1;
  return bw(e).forEach((o) => {
    hw(o) && gw(o, t) && (n = !0);
  }), n;
}, gh = (e) => uo.some(() => yw(e, -Wr)), pp = (e) => {
  const t = e || window.event;
  return gh(t.target) || t.touches.length > 1 ? !0 : (t.preventDefault && t.preventDefault(), !1);
}, $w = (e) => {
  if (Ea === void 0) {
    const t = !!e && e.reserveScrollBarGap === !0, n = window.innerWidth - document.documentElement.clientWidth;
    if (t && n > 0) {
      const o = parseInt(getComputedStyle(document.body).getPropertyValue("padding-right"), 10);
      Ea = document.body.style.paddingRight, document.body.style.paddingRight = `${o + n}px`;
    }
  }
  Ia === void 0 && (Ia = document.body.style.overflow, document.body.style.overflow = "hidden");
}, _w = () => {
  Ea !== void 0 && (document.body.style.paddingRight = Ea, Ea = void 0), Ia !== void 0 && (document.body.style.overflow = Ia, Ia = void 0);
}, ww = (e) => e ? e.scrollHeight - e.scrollTop <= e.clientHeight : !1, Cw = (e, t) => (Wr = e.targetTouches[0].clientY - hh, gh(e.target) ? !1 : t && t.scrollTop === 0 && Wr > 0 || ww(t) && Wr < 0 ? pp(e) : (e.stopPropagation(), !0)), kw = (e, t) => {
  if (!e) {
    console.error(
      "disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices."
    );
    return;
  }
  if (uo.some((o) => o.targetElement === e))
    return;
  const n = {
    targetElement: e,
    options: t || {}
  };
  uo = [...uo, n], vh ? (e.ontouchstart = (o) => {
    o.targetTouches.length === 1 && (hh = o.targetTouches[0].clientY);
  }, e.ontouchmove = (o) => {
    o.targetTouches.length === 1 && Cw(o, e);
  }, gi || (document.addEventListener("touchmove", pp, up ? { passive: !1 } : void 0), gi = !0)) : $w(t);
}, Sw = (e) => {
  if (!e) {
    console.error(
      "enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices."
    );
    return;
  }
  uo = uo.filter((t) => t.targetElement !== e), vh ? (e.ontouchstart = null, e.ontouchmove = null, gi && uo.length === 0 && (document.removeEventListener("touchmove", pp, up ? { passive: !1 } : void 0), gi = !1)) : uo.length || _w();
};
function Tw(e, t) {
  const { lockScrollEl: n, modelValueLocal: o } = t;
  let s;
  le(n, (i) => {
    i && (s = i);
  }, { immediate: !0 }), le(() => e.lockScroll, (i) => {
    i ? r() : a();
  }), Jt(() => {
    a();
  });
  function a() {
    s && Sw(s);
  }
  function r() {
    o.value && e.lockScroll && s && kw(s, {
      reserveScrollBarGap: e.reserveScrollBarGap,
      allowTouchMove: (i) => {
        for (; i && i !== document.body; ) {
          if (i.getAttribute("vfm-scroll-lock-ignore") !== null)
            return !0;
          i = i.parentElement;
        }
        return !1;
      }
    });
  }
  return {
    enableBodyScroll: a,
    disableBodyScroll: r
  };
}
function Aw(e) {
  const t = R();
  function n(s) {
    var a;
    t.value = (a = e.zIndexFn) == null ? void 0 : a.call(e, { index: s <= -1 ? 0 : s });
  }
  function o() {
    t.value = void 0;
  }
  return {
    zIndex: t,
    refreshZIndex: n,
    resetZIndex: o
  };
}
const Yl = {
  beforeMount(e, { value: t }, { transition: n }) {
    e._vov = e.style.visibility === "hidden" ? "" : e.style.visibility, n && t ? n.beforeEnter(e) : ma(e, t);
  },
  mounted(e, { value: t }, { transition: n }) {
    n && t && n.enter(e);
  },
  updated(e, { value: t, oldValue: n }, { transition: o }) {
    !t != !n && (o ? t ? (o.beforeEnter(e), ma(e, !0), o.enter(e)) : o.leave(e, () => {
      ma(e, !1);
    }) : ma(e, t));
  },
  beforeUnmount(e, { value: t }) {
    ma(e, t);
  }
};
function ma(e, t) {
  e.style.visibility = t ? e._vov : "hidden";
}
const qd = (e) => {
  if (e instanceof MouseEvent) {
    const { clientX: t, clientY: n } = e;
    return { x: t, y: n };
  } else {
    const { clientX: t, clientY: n } = e.targetTouches[0];
    return { x: t, y: n };
  }
};
function Dw(e) {
  if (!e)
    return !1;
  let t = !1;
  const n = {
    get passive() {
      return t = !0, !1;
    }
  };
  return e.addEventListener("x", Wa, n), e.removeEventListener("x", Wa), t;
}
function Pw(e, {
  threshold: t = 0,
  onSwipeStart: n,
  onSwipe: o,
  onSwipeEnd: s,
  passive: a = !0
}) {
  const r = tt({ x: 0, y: 0 }), i = tt({ x: 0, y: 0 }), l = V(() => r.x - i.x), c = V(() => r.y - i.y), { max: u, abs: p } = Math, f = V(
    () => u(p(l.value), p(c.value)) >= t
  ), m = R(!1), h = V(() => f.value ? p(l.value) > p(c.value) ? l.value > 0 ? "left" : "right" : c.value > 0 ? "up" : "down" : "none"), g = (I, D) => {
    r.x = I, r.y = D;
  }, _ = (I, D) => {
    i.x = I, i.y = D;
  };
  let v, w;
  function y(I) {
    v.capture && !v.passive && I.preventDefault();
    const { x: D, y: O } = qd(I);
    g(D, O), _(D, O), n == null || n(I), w = [
      bt(e, "mousemove", $, v),
      bt(e, "touchmove", $, v),
      bt(e, "mouseup", S, v),
      bt(e, "touchend", S, v),
      bt(e, "touchcancel", S, v)
    ];
  }
  function $(I) {
    const { x: D, y: O } = qd(I);
    _(D, O), !m.value && f.value && (m.value = !0), m.value && (o == null || o(I));
  }
  function S(I) {
    m.value && (s == null || s(I, h.value)), m.value = !1, w.forEach((D) => D());
  }
  let A = [];
  return Re(() => {
    const I = Dw(window == null ? void 0 : window.document);
    a ? v = I ? { passive: !0 } : { capture: !1 } : v = I ? { passive: !1, capture: !0 } : { capture: !0 }, A = [
      bt(e, "mousedown", y, v),
      bt(e, "touchstart", y, v)
    ];
  }), {
    isSwiping: m,
    direction: h,
    coordsStart: r,
    coordsEnd: i,
    lengthX: l,
    lengthY: c,
    stop: () => {
      A.forEach((I) => I()), w.forEach((I) => I());
    }
  };
}
function Iw(e, t) {
  const { vfmContentEl: n, modelValueLocal: o } = t, s = 0.1, a = 300, r = R(), i = V(() => {
    if (!(e.swipeToClose === void 0 || e.swipeToClose === "none"))
      return e.showSwipeBanner ? r.value : n.value;
  }), l = R(0), c = R(!0);
  let u = Wa, p = !0, f, m = !1;
  const { lengthX: h, lengthY: g, direction: _, isSwiping: v } = Pw(i, {
    threshold: e.threshold,
    onSwipeStart(S) {
      u = bt(document, "selectionchange", () => {
        var A;
        c.value = (A = window.getSelection()) == null ? void 0 : A.isCollapsed;
      }), f = (/* @__PURE__ */ new Date()).getTime(), m = $(S == null ? void 0 : S.target);
    },
    onSwipe() {
      var S, A, I, D;
      if (m && c.value && _.value === e.swipeToClose) {
        if (_.value === "up") {
          const O = Tr(Math.abs(g.value || 0), 0, ((S = i.value) == null ? void 0 : S.offsetHeight) || 0) - (e.threshold || 0);
          l.value = O;
        } else if (_.value === "down") {
          const O = Tr(Math.abs(g.value || 0), 0, ((A = i.value) == null ? void 0 : A.offsetHeight) || 0) - (e.threshold || 0);
          l.value = -O;
        } else if (_.value === "right") {
          const O = Tr(Math.abs(h.value || 0), 0, ((I = i.value) == null ? void 0 : I.offsetWidth) || 0) - (e.threshold || 0);
          l.value = -O;
        } else if (_.value === "left") {
          const O = Tr(Math.abs(h.value || 0), 0, ((D = i.value) == null ? void 0 : D.offsetWidth) || 0) - (e.threshold || 0);
          l.value = O;
        }
      }
    },
    onSwipeEnd(S, A) {
      if (u(), !c.value) {
        c.value = !0;
        return;
      }
      const I = (/* @__PURE__ */ new Date()).getTime(), D = A === e.swipeToClose, O = (() => {
        var F, P;
        if (A === "up" || A === "down")
          return Math.abs((g == null ? void 0 : g.value) || 0) > s * (((F = i.value) == null ? void 0 : F.offsetHeight) || 0);
        if (A === "left" || A === "right")
          return Math.abs((h == null ? void 0 : h.value) || 0) > s * (((P = i.value) == null ? void 0 : P.offsetWidth) || 0);
      })(), x = I - f <= a;
      if (p && m && D && (O || x)) {
        o.value = !1;
        return;
      }
      l.value = 0;
    }
  }), w = V(() => {
    if (e.swipeToClose === "none")
      return;
    const S = (() => {
      switch (e.swipeToClose) {
        case "up":
        case "down":
          return "translateY";
        case "left":
        case "right":
          return "translateX";
      }
    })();
    return {
      class: { "vfm-bounce-back": !v.value },
      style: { transform: `${S}(${-l.value}px)` }
    };
  });
  le(
    () => c.value,
    (S) => {
      S || (l.value = 0);
    }
  ), le(
    () => o.value,
    (S) => {
      S && (l.value = 0);
    }
  ), le(
    () => l.value,
    (S, A) => {
      switch (e.swipeToClose) {
        case "down":
        case "right":
          p = S < A;
          break;
        case "up":
        case "left":
          p = S > A;
          break;
      }
    }
  );
  function y(S) {
    e.preventNavigationGestures && S.preventDefault();
  }
  function $(S) {
    const A = S == null ? void 0 : S.tagName;
    if (!A || ["INPUT", "TEXTAREA"].includes(A))
      return !1;
    const I = (() => {
      switch (e.swipeToClose) {
        case "up":
          return (S == null ? void 0 : S.scrollTop) + (S == null ? void 0 : S.clientHeight) === (S == null ? void 0 : S.scrollHeight);
        case "left":
          return (S == null ? void 0 : S.scrollLeft) + (S == null ? void 0 : S.clientWidth) === (S == null ? void 0 : S.scrollWidth);
        case "down":
          return (S == null ? void 0 : S.scrollTop) === 0;
        case "right":
          return (S == null ? void 0 : S.scrollLeft) === 0;
        default:
          return !1;
      }
    })();
    return S === i.value ? I : I && $(S == null ? void 0 : S.parentElement);
  }
  return {
    vfmContentEl: n,
    swipeBannerEl: r,
    bindSwipe: w,
    onTouchStartSwipeBanner: y
  };
}
const Ew = Symbol("vfm");
let Ow;
const xw = {
  install: Wa,
  modals: [],
  openedModals: [],
  openedModalOverlays: [],
  dynamicModals: [],
  modalsContainers: R([]),
  get: () => {
  },
  toggle: () => {
  },
  open: () => {
  },
  close: () => {
  },
  closeAll: () => Promise.allSettled([])
}, Mw = () => bo() && Ye(Ew, xw) || Ow;
function Kd(e) {
  var t;
  return (t = e == null ? void 0 : e.exposed) == null ? void 0 : t.modalExposed;
}
const Lw = K({ inheritAttrs: !1 }), Nw = /* @__PURE__ */ K({
  ...Lw,
  __name: "VueFinalModal",
  props: pw,
  emits: ["update:modelValue", "beforeOpen", "opened", "beforeClose", "closed", "clickOutside"],
  setup(e, { expose: t, emit: n }) {
    const o = e, s = n, a = Xv(), r = bo(), { modals: i, openedModals: l, openedModalOverlays: c } = Fw(), u = R(), p = R(), { focus: f, blur: m } = vw(o, { focusEl: u }), { zIndex: h, refreshZIndex: g, resetZIndex: _ } = Aw(o), { modelValueLocal: v } = mw(o, s, { open: H, close: oe }), { enableBodyScroll: w, disableBodyScroll: y } = Tw(o, {
      lockScrollEl: u,
      modelValueLocal: v
    });
    let $ = Wa;
    const {
      visible: S,
      contentVisible: A,
      contentListeners: I,
      contentTransition: D,
      overlayVisible: O,
      overlayListeners: x,
      overlayTransition: F,
      enterTransition: P,
      leaveTransition: E
    } = dw(o, {
      modelValueLocal: v,
      onEntering() {
        rn(() => {
          y(), f();
        });
      },
      onEnter() {
        s("opened"), $("opened");
      },
      onLeave() {
        Aa(l, r), _(), w(), s("closed"), $("closed");
      }
    }), { onEsc: B, onMouseupRoot: N, onMousedown: Y } = fw(o, s, { vfmRootEl: u, vfmContentEl: p, visible: S, modelValueLocal: v }), {
      swipeBannerEl: j,
      bindSwipe: ee,
      onTouchStartSwipeBanner: te
    } = Iw(o, { vfmContentEl: p, modelValueLocal: v }), ce = V(() => r ? l.indexOf(r) : -1);
    le([() => o.zIndexFn, ce], () => {
      S.value && g(ce.value);
    }), Re(() => {
      Kl(i, r);
    }), o.modelValue && (v.value = !0);
    function H() {
      let G = !1;
      return s("beforeOpen", { stop: () => G = !0 }), G ? !1 : (Kl(l, r), Kl(c, r), Q(), P(), !0);
    }
    function oe() {
      let G = !1;
      return s("beforeClose", { stop: () => G = !0 }), G ? !1 : (Aa(c, r), Q(), m(), E(), !0);
    }
    function U() {
      v.value = !1;
    }
    Jt(() => {
      w(), Aa(i, r), Aa(l, r), m(), Q();
    });
    async function Q() {
      await rn();
      const G = c.filter((se) => {
        var pe;
        const J = Kd(se);
        return (J == null ? void 0 : J.value.overlayBehavior.value) === "auto" && !((pe = J == null ? void 0 : J.value.hideOverlay) != null && pe.value);
      });
      G.forEach((se, pe) => {
        const J = Kd(se);
        J != null && J.value && (J.value.overlayVisible.value = pe === G.length - 1);
      });
    }
    const z = Wo(() => o.modalId), Z = Wo(() => o.hideOverlay), W = Wo(() => o.overlayBehavior), X = V(() => ({
      modalId: z,
      hideOverlay: Z,
      overlayBehavior: W,
      overlayVisible: O,
      toggle(G) {
        return new Promise((se) => {
          $ = uw((J) => se(J));
          const pe = typeof G == "boolean" ? G : !v.value;
          v.value = pe;
        });
      }
    }));
    return t({
      modalExposed: X
    }), (G, se) => (b(), ie(F$, {
      to: G.teleportTo ? G.teleportTo : void 0,
      disabled: !G.teleportTo
    }, [
      G.displayDirective !== "if" || T(S) ? ot((b(), C("div", Ta({ key: 0 }, T(a), {
        ref_key: "vfmRootEl",
        ref: u,
        class: ["vfm vfm--fixed vfm--inset", { "vfm--prevent-none": G.background === "interactive" }],
        style: { zIndex: T(h) },
        role: "dialog",
        "aria-modal": "true",
        onKeydown: se[7] || (se[7] = rl(() => T(B)(), ["esc"])),
        onMouseup: se[8] || (se[8] = Ke(() => T(N)(), ["self"])),
        onMousedown: se[9] || (se[9] = Ke((pe) => T(Y)(pe), ["self"]))
      }), [
        Z.value ? M("", !0) : (b(), ie(st, Ta({ key: 0 }, T(F), Nd(T(x))), {
          default: he(() => [
            G.displayDirective !== "if" || T(O) ? ot((b(), C("div", {
              key: 0,
              class: ue(["vfm__overlay vfm--overlay vfm--absolute vfm--inset vfm--prevent-none", G.overlayClass]),
              style: Zu(G.overlayStyle),
              "aria-hidden": "true"
            }, null, 6)), [
              [Ds, G.displayDirective !== "show" || T(O)],
              [T(Yl), G.displayDirective !== "visible" || T(O)]
            ]) : M("", !0)
          ]),
          _: 1
        }, 16)),
        q(st, Ta(T(D), Nd(T(I))), {
          default: he(() => [
            G.displayDirective !== "if" || T(A) ? ot((b(), C("div", Ta({
              key: 0,
              ref_key: "vfmContentEl",
              ref: p,
              class: ["vfm__content vfm--outline-none", [G.contentClass, { "vfm--prevent-auto": G.background === "interactive" }]],
              style: G.contentStyle,
              tabindex: "0"
            }, T(ee), {
              onMousedown: se[6] || (se[6] = () => T(Y)())
            }), [
              Xe(G.$slots, "default", R$(V$({ close: U }))),
              G.showSwipeBanner ? (b(), C("div", {
                key: 0,
                ref_key: "swipeBannerEl",
                ref: j,
                class: "vfm-swipe-banner-container",
                onTouchstart: se[2] || (se[2] = (pe) => T(te)(pe))
              }, [
                Xe(G.$slots, "swipe-banner", {}, () => [
                  d("div", {
                    class: "vfm-swipe-banner-back",
                    onTouchstart: se[0] || (se[0] = (pe) => G.swipeToClose === "left" && pe.preventDefault())
                  }, null, 32),
                  d("div", {
                    class: "vfm-swipe-banner-forward",
                    onTouchstart: se[1] || (se[1] = (pe) => G.swipeToClose === "right" && pe.preventDefault())
                  }, null, 32)
                ])
              ], 544)) : !G.showSwipeBanner && G.preventNavigationGestures ? (b(), C("div", {
                key: 1,
                class: "vfm-swipe-banner-container",
                onTouchstart: se[5] || (se[5] = (pe) => T(te)(pe))
              }, [
                d("div", {
                  class: "vfm-swipe-banner-back",
                  onTouchstart: se[3] || (se[3] = (pe) => G.swipeToClose === "left" && pe.preventDefault())
                }, null, 32),
                d("div", {
                  class: "vfm-swipe-banner-forward",
                  onTouchstart: se[4] || (se[4] = (pe) => G.swipeToClose === "right" && pe.preventDefault())
                }, null, 32)
              ], 32)) : M("", !0)
            ], 16)), [
              [Ds, G.displayDirective !== "show" || T(A)],
              [T(Yl), G.displayDirective !== "visible" || T(A)]
            ]) : M("", !0)
          ]),
          _: 3
        }, 16)
      ], 16)), [
        [Ds, G.displayDirective !== "show" || T(S)],
        [T(Yl), G.displayDirective !== "visible" || T(S)]
      ]) : M("", !0)
    ], 8, ["to", "disabled"]));
  }
});
function Fw() {
  const e = Mw();
  if (!e)
    throw new Error(
      `[Vue Final Modal]: getActiveVfm was called with no active Vfm. Did you forget to install vfm?
	const vfm = createVfm()
	app.use(vfm)
This will fail in production.`
    );
  return e;
}
const Rw = {
  key: 0,
  class: "vacv-modal-header"
}, Vw = ["aria-label"], Bw = { class: "vacv-modal-content-inner" }, Hw = { class: "modal__title" }, Uw = { class: "modal__content" }, zw = /* @__PURE__ */ d("div", { class: "modal__action" }, null, -1), Qt = /* @__PURE__ */ K({
  __name: "VacvCustomModal",
  props: {
    clickToClose: { type: Boolean },
    hideClose: { type: Boolean },
    size: {}
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    const n = t, o = () => {
      n("close", "click");
    }, s = (a) => {
      (a.key === "Escape" || a.key === "esc") && n("close", "escape");
    };
    return Re(() => {
      document.addEventListener("keydown", s);
    }), Jt(() => {
      document.removeEventListener("keydown", s);
    }), (a, r) => (b(), ie(T(Nw), {
      "initial-focus": !0,
      "esc-to-close": !0,
      classes: "vacv-modal-container",
      "content-class": "vacv-modal-content-outer",
      "before-close": "clickClose",
      "click-to-close": a.clickToClose,
      "data-hide-close": a.hideClose,
      "data-size": a.size && a.size === "small" ? "small" : "medium"
    }, {
      default: he(() => [
        a.hideClose ? M("", !0) : (b(), C("div", Rw, [
          d("button", {
            class: "modal__close btn-close",
            onClick: Ke(o, ["prevent"]),
            "aria-label": a.$t("vacvComponents.common.buttons.close")
          }, null, 8, Vw)
        ])),
        d("div", Bw, [
          d("span", Hw, [
            Xe(a.$slots, "title")
          ]),
          d("div", Uw, [
            Xe(a.$slots, "default")
          ]),
          zw
        ])
      ]),
      _: 3
    }, 8, ["click-to-close", "data-hide-close", "data-size"]));
  }
}), Ww = { class: "vacv-promo-badge" }, jw = { class: "vacv-promo-badge__title" }, qw = ["innerHTML"], Kw = /* @__PURE__ */ K({
  __name: "VacvPromoBadge",
  props: {
    badge: {},
    modalTitle: {},
    modalText: {},
    origin: {}
  },
  setup(e) {
    const t = e, n = R(!1), o = () => {
      var r;
      (r = window.dataLayer) == null || r.push({
        event: t.origin,
        aeroplanElement: "Aeroplan Badge",
        aeroplanElementValue: t.badge
      });
    }, s = () => {
      n.value = !0, o();
    }, a = () => {
      n.value = !1;
    };
    return (r, i) => (b(), C("div", Ww, [
      d("button", {
        onClick: s,
        class: "vacv-promo-badge__button",
        "aria-haspopup": "true"
      }, k(r.badge), 1),
      q(Qt, {
        onClose: a,
        modelValue: n.value,
        "onUpdate:modelValue": i[0] || (i[0] = (l) => n.value = l),
        class: "vacv-modal modal-fullscreen vacv-modal-centered vacv-promo-badge__modal"
      }, {
        default: he(() => [
          d("div", jw, k(r.modalTitle), 1),
          d("div", {
            class: "vacv-promo-badge__content vacv-editor",
            innerHTML: r.modalText
          }, null, 8, qw)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]));
  }
}), De = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [o, s] of t)
    n[o] = s;
  return n;
}, bh = /* @__PURE__ */ De(Kw, [["__scopeId", "data-v-acb3cd2b"]]);
function su(e, t, n) {
  var o, s, a, r, i;
  t == null && (t = 100);
  function l() {
    var u = Date.now() - r;
    u < t && u >= 0 ? o = setTimeout(l, t - u) : (o = null, n || (i = e.apply(a, s), a = s = null));
  }
  var c = function() {
    a = this, s = arguments, r = Date.now();
    var u = n && !o;
    return o || (o = setTimeout(l, t)), u && (i = e.apply(a, s), a = s = null), i;
  };
  return c.clear = function() {
    o && (clearTimeout(o), o = null);
  }, c.flush = function() {
    o && (i = e.apply(a, s), a = s = null, clearTimeout(o), o = null);
  }, c;
}
su.debounce = su;
var Gl = su;
function Yw(e, t, n) {
  Pt(e) ? le(e, (o, s) => {
    s == null || s.removeEventListener(t, n), o == null || o.addEventListener(t, n);
  }) : Re(() => {
    e.addEventListener(t, n);
  }), Jt(() => {
    var o;
    (o = T(e)) === null || o === void 0 || o.removeEventListener(t, n);
  });
}
function Gw(e, t) {
  const n = "pointerdown";
  return typeof window > "u" || !window ? void 0 : Yw(window, n, (s) => {
    const a = T(e);
    a && (a === s.target || s.composedPath().includes(a) || t(s));
  });
}
function Zw(e, t, n) {
  let o = null;
  const s = R(!1);
  Re(() => {
    (e.content !== void 0 || n.value) && (s.value = !0), o = new MutationObserver(a), o.observe(t.value, {
      childList: !0,
      subtree: !0
    });
  }), Jt(() => o.disconnect()), le(n, (r) => {
    r ? s.value = !0 : s.value = !1;
  });
  const a = () => {
    e.content ? s.value = !0 : s.value = !1;
  };
  return {
    hasContent: s
  };
}
function Fs(e, t) {
  var n = e.getBoundingClientRect(), o = 1, s = 1;
  return {
    width: n.width / o,
    height: n.height / s,
    top: n.top / s,
    right: n.right / o,
    bottom: n.bottom / s,
    left: n.left / o,
    x: n.left / o,
    y: n.top / s
  };
}
function mn(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function dp(e) {
  var t = mn(e), n = t.pageXOffset, o = t.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: o
  };
}
function ja(e) {
  var t = mn(e).Element;
  return e instanceof t || e instanceof Element;
}
function Kt(e) {
  var t = mn(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function yh(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = mn(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function Xw(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function Jw(e) {
  return e === mn(e) || !Kt(e) ? dp(e) : Xw(e);
}
function An(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function So(e) {
  return ((ja(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function fp(e) {
  return Fs(So(e)).left + dp(e).scrollLeft;
}
function Zn(e) {
  return mn(e).getComputedStyle(e);
}
function mp(e) {
  var t = Zn(e), n = t.overflow, o = t.overflowX, s = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + s + o);
}
function Qw(e) {
  var t = e.getBoundingClientRect(), n = t.width / e.offsetWidth || 1, o = t.height / e.offsetHeight || 1;
  return n !== 1 || o !== 1;
}
function eC(e, t, n) {
  n === void 0 && (n = !1);
  var o = Kt(t);
  Kt(t) && Qw(t);
  var s = So(t), a = Fs(e), r = {
    scrollLeft: 0,
    scrollTop: 0
  }, i = {
    x: 0,
    y: 0
  };
  return (o || !o && !n) && ((An(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  mp(s)) && (r = Jw(t)), Kt(t) ? (i = Fs(t), i.x += t.clientLeft, i.y += t.clientTop) : s && (i.x = fp(s))), {
    x: a.left + r.scrollLeft - i.x,
    y: a.top + r.scrollTop - i.y,
    width: a.width,
    height: a.height
  };
}
function vp(e) {
  var t = Fs(e), n = e.offsetWidth, o = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - o) <= 1 && (o = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: o
  };
}
function cl(e) {
  return An(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (yh(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    So(e)
  );
}
function $h(e) {
  return ["html", "body", "#document"].indexOf(An(e)) >= 0 ? e.ownerDocument.body : Kt(e) && mp(e) ? e : $h(cl(e));
}
function Oa(e, t) {
  var n;
  t === void 0 && (t = []);
  var o = $h(e), s = o === ((n = e.ownerDocument) == null ? void 0 : n.body), a = mn(o), r = s ? [a].concat(a.visualViewport || [], mp(o) ? o : []) : o, i = t.concat(r);
  return s ? i : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    i.concat(Oa(cl(r)))
  );
}
function tC(e) {
  return ["table", "td", "th"].indexOf(An(e)) >= 0;
}
function Yd(e) {
  return !Kt(e) || // https://github.com/popperjs/popper-core/issues/837
  Zn(e).position === "fixed" ? null : e.offsetParent;
}
function nC(e) {
  var t = navigator.userAgent.toLowerCase().indexOf("firefox") !== -1, n = navigator.userAgent.indexOf("Trident") !== -1;
  if (n && Kt(e)) {
    var o = Zn(e);
    if (o.position === "fixed")
      return null;
  }
  for (var s = cl(e); Kt(s) && ["html", "body"].indexOf(An(s)) < 0; ) {
    var a = Zn(s);
    if (a.transform !== "none" || a.perspective !== "none" || a.contain === "paint" || ["transform", "perspective"].indexOf(a.willChange) !== -1 || t && a.willChange === "filter" || t && a.filter && a.filter !== "none")
      return s;
    s = s.parentNode;
  }
  return null;
}
function sr(e) {
  for (var t = mn(e), n = Yd(e); n && tC(n) && Zn(n).position === "static"; )
    n = Yd(n);
  return n && (An(n) === "html" || An(n) === "body" && Zn(n).position === "static") ? t : n || nC(e) || t;
}
var Yt = "top", ln = "bottom", cn = "right", Gt = "left", hp = "auto", ar = [Yt, ln, cn, Gt], Rs = "start", qa = "end", oC = "clippingParents", _h = "viewport", va = "popper", sC = "reference", Gd = /* @__PURE__ */ ar.reduce(function(e, t) {
  return e.concat([t + "-" + Rs, t + "-" + qa]);
}, []), wh = /* @__PURE__ */ [].concat(ar, [hp]).reduce(function(e, t) {
  return e.concat([t, t + "-" + Rs, t + "-" + qa]);
}, []), aC = "beforeRead", rC = "read", iC = "afterRead", lC = "beforeMain", cC = "main", uC = "afterMain", pC = "beforeWrite", dC = "write", fC = "afterWrite", mC = [aC, rC, iC, lC, cC, uC, pC, dC, fC];
function vC(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), o = [];
  e.forEach(function(a) {
    t.set(a.name, a);
  });
  function s(a) {
    n.add(a.name);
    var r = [].concat(a.requires || [], a.requiresIfExists || []);
    r.forEach(function(i) {
      if (!n.has(i)) {
        var l = t.get(i);
        l && s(l);
      }
    }), o.push(a);
  }
  return e.forEach(function(a) {
    n.has(a.name) || s(a);
  }), o;
}
function hC(e) {
  var t = vC(e);
  return mC.reduce(function(n, o) {
    return n.concat(t.filter(function(s) {
      return s.phase === o;
    }));
  }, []);
}
function gC(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function kn(e) {
  return e.split("-")[0];
}
function bC(e) {
  var t = e.reduce(function(n, o) {
    var s = n[o.name];
    return n[o.name] = s ? Object.assign({}, s, o, {
      options: Object.assign({}, s.options, o.options),
      data: Object.assign({}, s.data, o.data)
    }) : o, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
function yC(e) {
  var t = mn(e), n = So(e), o = t.visualViewport, s = n.clientWidth, a = n.clientHeight, r = 0, i = 0;
  return o && (s = o.width, a = o.height, /^((?!chrome|android).)*safari/i.test(navigator.userAgent) || (r = o.offsetLeft, i = o.offsetTop)), {
    width: s,
    height: a,
    x: r + fp(e),
    y: i
  };
}
var ho = Math.max, Ka = Math.min, Ar = Math.round;
function $C(e) {
  var t, n = So(e), o = dp(e), s = (t = e.ownerDocument) == null ? void 0 : t.body, a = ho(n.scrollWidth, n.clientWidth, s ? s.scrollWidth : 0, s ? s.clientWidth : 0), r = ho(n.scrollHeight, n.clientHeight, s ? s.scrollHeight : 0, s ? s.clientHeight : 0), i = -o.scrollLeft + fp(e), l = -o.scrollTop;
  return Zn(s || n).direction === "rtl" && (i += ho(n.clientWidth, s ? s.clientWidth : 0) - a), {
    width: a,
    height: r,
    x: i,
    y: l
  };
}
function Ch(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && yh(n)) {
    var o = t;
    do {
      if (o && e.isSameNode(o))
        return !0;
      o = o.parentNode || o.host;
    } while (o);
  }
  return !1;
}
function au(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function _C(e) {
  var t = Fs(e);
  return t.top = t.top + e.clientTop, t.left = t.left + e.clientLeft, t.bottom = t.top + e.clientHeight, t.right = t.left + e.clientWidth, t.width = e.clientWidth, t.height = e.clientHeight, t.x = t.left, t.y = t.top, t;
}
function Zd(e, t) {
  return t === _h ? au(yC(e)) : Kt(t) ? _C(t) : au($C(So(e)));
}
function wC(e) {
  var t = Oa(cl(e)), n = ["absolute", "fixed"].indexOf(Zn(e).position) >= 0, o = n && Kt(e) ? sr(e) : e;
  return ja(o) ? t.filter(function(s) {
    return ja(s) && Ch(s, o) && An(s) !== "body";
  }) : [];
}
function CC(e, t, n) {
  var o = t === "clippingParents" ? wC(e) : [].concat(t), s = [].concat(o, [n]), a = s[0], r = s.reduce(function(i, l) {
    var c = Zd(e, l);
    return i.top = ho(c.top, i.top), i.right = Ka(c.right, i.right), i.bottom = Ka(c.bottom, i.bottom), i.left = ho(c.left, i.left), i;
  }, Zd(e, a));
  return r.width = r.right - r.left, r.height = r.bottom - r.top, r.x = r.left, r.y = r.top, r;
}
function Vs(e) {
  return e.split("-")[1];
}
function gp(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function kh(e) {
  var t = e.reference, n = e.element, o = e.placement, s = o ? kn(o) : null, a = o ? Vs(o) : null, r = t.x + t.width / 2 - n.width / 2, i = t.y + t.height / 2 - n.height / 2, l;
  switch (s) {
    case Yt:
      l = {
        x: r,
        y: t.y - n.height
      };
      break;
    case ln:
      l = {
        x: r,
        y: t.y + t.height
      };
      break;
    case cn:
      l = {
        x: t.x + t.width,
        y: i
      };
      break;
    case Gt:
      l = {
        x: t.x - n.width,
        y: i
      };
      break;
    default:
      l = {
        x: t.x,
        y: t.y
      };
  }
  var c = s ? gp(s) : null;
  if (c != null) {
    var u = c === "y" ? "height" : "width";
    switch (a) {
      case Rs:
        l[c] = l[c] - (t[u] / 2 - n[u] / 2);
        break;
      case qa:
        l[c] = l[c] + (t[u] / 2 - n[u] / 2);
        break;
    }
  }
  return l;
}
function Sh() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Th(e) {
  return Object.assign({}, Sh(), e);
}
function Ah(e, t) {
  return t.reduce(function(n, o) {
    return n[o] = e, n;
  }, {});
}
function bp(e, t) {
  t === void 0 && (t = {});
  var n = t, o = n.placement, s = o === void 0 ? e.placement : o, a = n.boundary, r = a === void 0 ? oC : a, i = n.rootBoundary, l = i === void 0 ? _h : i, c = n.elementContext, u = c === void 0 ? va : c, p = n.altBoundary, f = p === void 0 ? !1 : p, m = n.padding, h = m === void 0 ? 0 : m, g = Th(typeof h != "number" ? h : Ah(h, ar)), _ = u === va ? sC : va, v = e.rects.popper, w = e.elements[f ? _ : u], y = CC(ja(w) ? w : w.contextElement || So(e.elements.popper), r, l), $ = Fs(e.elements.reference), S = kh({
    reference: $,
    element: v,
    placement: s
  }), A = au(Object.assign({}, v, S)), I = u === va ? A : $, D = {
    top: y.top - I.top + g.top,
    bottom: I.bottom - y.bottom + g.bottom,
    left: y.left - I.left + g.left,
    right: I.right - y.right + g.right
  }, O = e.modifiersData.offset;
  if (u === va && O) {
    var x = O[s];
    Object.keys(D).forEach(function(F) {
      var P = [cn, ln].indexOf(F) >= 0 ? 1 : -1, E = [Yt, ln].indexOf(F) >= 0 ? "y" : "x";
      D[F] += x[E] * P;
    });
  }
  return D;
}
var Xd = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function Jd() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(o) {
    return !(o && typeof o.getBoundingClientRect == "function");
  });
}
function kC(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, o = n === void 0 ? [] : n, s = t.defaultOptions, a = s === void 0 ? Xd : s;
  return function(i, l, c) {
    c === void 0 && (c = a);
    var u = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Xd, a),
      modifiersData: {},
      elements: {
        reference: i,
        popper: l
      },
      attributes: {},
      styles: {}
    }, p = [], f = !1, m = {
      state: u,
      setOptions: function(v) {
        var w = typeof v == "function" ? v(u.options) : v;
        g(), u.options = Object.assign({}, a, u.options, w), u.scrollParents = {
          reference: ja(i) ? Oa(i) : i.contextElement ? Oa(i.contextElement) : [],
          popper: Oa(l)
        };
        var y = hC(bC([].concat(o, u.options.modifiers)));
        return u.orderedModifiers = y.filter(function($) {
          return $.enabled;
        }), h(), m.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!f) {
          var v = u.elements, w = v.reference, y = v.popper;
          if (Jd(w, y)) {
            u.rects = {
              reference: eC(w, sr(y), u.options.strategy === "fixed"),
              popper: vp(y)
            }, u.reset = !1, u.placement = u.options.placement, u.orderedModifiers.forEach(function(x) {
              return u.modifiersData[x.name] = Object.assign({}, x.data);
            });
            for (var $ = 0; $ < u.orderedModifiers.length; $++) {
              if (u.reset === !0) {
                u.reset = !1, $ = -1;
                continue;
              }
              var S = u.orderedModifiers[$], A = S.fn, I = S.options, D = I === void 0 ? {} : I, O = S.name;
              typeof A == "function" && (u = A({
                state: u,
                options: D,
                name: O,
                instance: m
              }) || u);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: gC(function() {
        return new Promise(function(_) {
          m.forceUpdate(), _(u);
        });
      }),
      destroy: function() {
        g(), f = !0;
      }
    };
    if (!Jd(i, l))
      return m;
    m.setOptions(c).then(function(_) {
      !f && c.onFirstUpdate && c.onFirstUpdate(_);
    });
    function h() {
      u.orderedModifiers.forEach(function(_) {
        var v = _.name, w = _.options, y = w === void 0 ? {} : w, $ = _.effect;
        if (typeof $ == "function") {
          var S = $({
            state: u,
            name: v,
            instance: m,
            options: y
          }), A = function() {
          };
          p.push(S || A);
        }
      });
    }
    function g() {
      p.forEach(function(_) {
        return _();
      }), p = [];
    }
    return m;
  };
}
var Dr = {
  passive: !0
};
function SC(e) {
  var t = e.state, n = e.instance, o = e.options, s = o.scroll, a = s === void 0 ? !0 : s, r = o.resize, i = r === void 0 ? !0 : r, l = mn(t.elements.popper), c = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return a && c.forEach(function(u) {
    u.addEventListener("scroll", n.update, Dr);
  }), i && l.addEventListener("resize", n.update, Dr), function() {
    a && c.forEach(function(u) {
      u.removeEventListener("scroll", n.update, Dr);
    }), i && l.removeEventListener("resize", n.update, Dr);
  };
}
var TC = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: SC,
  data: {}
};
function AC(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = kh({
    reference: t.rects.reference,
    element: t.rects.popper,
    placement: t.placement
  });
}
var DC = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: AC,
  data: {}
}, PC = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function IC(e) {
  var t = e.x, n = e.y, o = window, s = o.devicePixelRatio || 1;
  return {
    x: Ar(Ar(t * s) / s) || 0,
    y: Ar(Ar(n * s) / s) || 0
  };
}
function Qd(e) {
  var t, n = e.popper, o = e.popperRect, s = e.placement, a = e.variation, r = e.offsets, i = e.position, l = e.gpuAcceleration, c = e.adaptive, u = e.roundOffsets, p = u === !0 ? IC(r) : typeof u == "function" ? u(r) : r, f = p.x, m = f === void 0 ? 0 : f, h = p.y, g = h === void 0 ? 0 : h, _ = r.hasOwnProperty("x"), v = r.hasOwnProperty("y"), w = Gt, y = Yt, $ = window;
  if (c) {
    var S = sr(n), A = "clientHeight", I = "clientWidth";
    S === mn(n) && (S = So(n), Zn(S).position !== "static" && i === "absolute" && (A = "scrollHeight", I = "scrollWidth")), S = S, (s === Yt || (s === Gt || s === cn) && a === qa) && (y = ln, g -= S[A] - o.height, g *= l ? 1 : -1), (s === Gt || (s === Yt || s === ln) && a === qa) && (w = cn, m -= S[I] - o.width, m *= l ? 1 : -1);
  }
  var D = Object.assign({
    position: i
  }, c && PC);
  if (l) {
    var O;
    return Object.assign({}, D, (O = {}, O[y] = v ? "0" : "", O[w] = _ ? "0" : "", O.transform = ($.devicePixelRatio || 1) <= 1 ? "translate(" + m + "px, " + g + "px)" : "translate3d(" + m + "px, " + g + "px, 0)", O));
  }
  return Object.assign({}, D, (t = {}, t[y] = v ? g + "px" : "", t[w] = _ ? m + "px" : "", t.transform = "", t));
}
function EC(e) {
  var t = e.state, n = e.options, o = n.gpuAcceleration, s = o === void 0 ? !0 : o, a = n.adaptive, r = a === void 0 ? !0 : a, i = n.roundOffsets, l = i === void 0 ? !0 : i, c = {
    placement: kn(t.placement),
    variation: Vs(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: s
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, Qd(Object.assign({}, c, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: r,
    roundOffsets: l
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, Qd(Object.assign({}, c, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
var OC = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: EC,
  data: {}
};
function xC(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var o = t.styles[n] || {}, s = t.attributes[n] || {}, a = t.elements[n];
    !Kt(a) || !An(a) || (Object.assign(a.style, o), Object.keys(s).forEach(function(r) {
      var i = s[r];
      i === !1 ? a.removeAttribute(r) : a.setAttribute(r, i === !0 ? "" : i);
    }));
  });
}
function MC(e) {
  var t = e.state, n = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(o) {
      var s = t.elements[o], a = t.attributes[o] || {}, r = Object.keys(t.styles.hasOwnProperty(o) ? t.styles[o] : n[o]), i = r.reduce(function(l, c) {
        return l[c] = "", l;
      }, {});
      !Kt(s) || !An(s) || (Object.assign(s.style, i), Object.keys(a).forEach(function(l) {
        s.removeAttribute(l);
      }));
    });
  };
}
var LC = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: xC,
  effect: MC,
  requires: ["computeStyles"]
}, NC = [TC, DC, OC, LC], FC = /* @__PURE__ */ kC({
  defaultModifiers: NC
});
function RC(e) {
  return e === "x" ? "y" : "x";
}
function jr(e, t, n) {
  return ho(e, Ka(t, n));
}
function VC(e) {
  var t = e.state, n = e.options, o = e.name, s = n.mainAxis, a = s === void 0 ? !0 : s, r = n.altAxis, i = r === void 0 ? !1 : r, l = n.boundary, c = n.rootBoundary, u = n.altBoundary, p = n.padding, f = n.tether, m = f === void 0 ? !0 : f, h = n.tetherOffset, g = h === void 0 ? 0 : h, _ = bp(t, {
    boundary: l,
    rootBoundary: c,
    padding: p,
    altBoundary: u
  }), v = kn(t.placement), w = Vs(t.placement), y = !w, $ = gp(v), S = RC($), A = t.modifiersData.popperOffsets, I = t.rects.reference, D = t.rects.popper, O = typeof g == "function" ? g(Object.assign({}, t.rects, {
    placement: t.placement
  })) : g, x = {
    x: 0,
    y: 0
  };
  if (A) {
    if (a || i) {
      var F = $ === "y" ? Yt : Gt, P = $ === "y" ? ln : cn, E = $ === "y" ? "height" : "width", B = A[$], N = A[$] + _[F], Y = A[$] - _[P], j = m ? -D[E] / 2 : 0, ee = w === Rs ? I[E] : D[E], te = w === Rs ? -D[E] : -I[E], ce = t.elements.arrow, H = m && ce ? vp(ce) : {
        width: 0,
        height: 0
      }, oe = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : Sh(), U = oe[F], Q = oe[P], z = jr(0, I[E], H[E]), Z = y ? I[E] / 2 - j - z - U - O : ee - z - U - O, W = y ? -I[E] / 2 + j + z + Q + O : te + z + Q + O, X = t.elements.arrow && sr(t.elements.arrow), G = X ? $ === "y" ? X.clientTop || 0 : X.clientLeft || 0 : 0, se = t.modifiersData.offset ? t.modifiersData.offset[t.placement][$] : 0, pe = A[$] + Z - se - G, J = A[$] + W - se;
      if (a) {
        var ae = jr(m ? Ka(N, pe) : N, B, m ? ho(Y, J) : Y);
        A[$] = ae, x[$] = ae - B;
      }
      if (i) {
        var re = $ === "x" ? Yt : Gt, ge = $ === "x" ? ln : cn, Ie = A[S], je = Ie + _[re], Ve = Ie - _[ge], Ue = jr(m ? Ka(je, pe) : je, Ie, m ? ho(Ve, J) : Ve);
        A[S] = Ue, x[S] = Ue - Ie;
      }
    }
    t.modifiersData[o] = x;
  }
}
var BC = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: VC,
  requiresIfExists: ["offset"]
}, HC = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function qr(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return HC[t];
  });
}
var UC = {
  start: "end",
  end: "start"
};
function ef(e) {
  return e.replace(/start|end/g, function(t) {
    return UC[t];
  });
}
function zC(e, t) {
  t === void 0 && (t = {});
  var n = t, o = n.placement, s = n.boundary, a = n.rootBoundary, r = n.padding, i = n.flipVariations, l = n.allowedAutoPlacements, c = l === void 0 ? wh : l, u = Vs(o), p = u ? i ? Gd : Gd.filter(function(h) {
    return Vs(h) === u;
  }) : ar, f = p.filter(function(h) {
    return c.indexOf(h) >= 0;
  });
  f.length === 0 && (f = p);
  var m = f.reduce(function(h, g) {
    return h[g] = bp(e, {
      placement: g,
      boundary: s,
      rootBoundary: a,
      padding: r
    })[kn(g)], h;
  }, {});
  return Object.keys(m).sort(function(h, g) {
    return m[h] - m[g];
  });
}
function WC(e) {
  if (kn(e) === hp)
    return [];
  var t = qr(e);
  return [ef(e), t, ef(t)];
}
function jC(e) {
  var t = e.state, n = e.options, o = e.name;
  if (!t.modifiersData[o]._skip) {
    for (var s = n.mainAxis, a = s === void 0 ? !0 : s, r = n.altAxis, i = r === void 0 ? !0 : r, l = n.fallbackPlacements, c = n.padding, u = n.boundary, p = n.rootBoundary, f = n.altBoundary, m = n.flipVariations, h = m === void 0 ? !0 : m, g = n.allowedAutoPlacements, _ = t.options.placement, v = kn(_), w = v === _, y = l || (w || !h ? [qr(_)] : WC(_)), $ = [_].concat(y).reduce(function(Q, z) {
      return Q.concat(kn(z) === hp ? zC(t, {
        placement: z,
        boundary: u,
        rootBoundary: p,
        padding: c,
        flipVariations: h,
        allowedAutoPlacements: g
      }) : z);
    }, []), S = t.rects.reference, A = t.rects.popper, I = /* @__PURE__ */ new Map(), D = !0, O = $[0], x = 0; x < $.length; x++) {
      var F = $[x], P = kn(F), E = Vs(F) === Rs, B = [Yt, ln].indexOf(P) >= 0, N = B ? "width" : "height", Y = bp(t, {
        placement: F,
        boundary: u,
        rootBoundary: p,
        altBoundary: f,
        padding: c
      }), j = B ? E ? cn : Gt : E ? ln : Yt;
      S[N] > A[N] && (j = qr(j));
      var ee = qr(j), te = [];
      if (a && te.push(Y[P] <= 0), i && te.push(Y[j] <= 0, Y[ee] <= 0), te.every(function(Q) {
        return Q;
      })) {
        O = F, D = !1;
        break;
      }
      I.set(F, te);
    }
    if (D)
      for (var ce = h ? 3 : 1, H = function(z) {
        var Z = $.find(function(W) {
          var X = I.get(W);
          if (X)
            return X.slice(0, z).every(function(G) {
              return G;
            });
        });
        if (Z)
          return O = Z, "break";
      }, oe = ce; oe > 0; oe--) {
        var U = H(oe);
        if (U === "break") break;
      }
    t.placement !== O && (t.modifiersData[o]._skip = !0, t.placement = O, t.reset = !0);
  }
}
var qC = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: jC,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function KC(e, t, n) {
  var o = kn(e), s = [Gt, Yt].indexOf(o) >= 0 ? -1 : 1, a = typeof n == "function" ? n(Object.assign({}, t, {
    placement: e
  })) : n, r = a[0], i = a[1];
  return r = r || 0, i = (i || 0) * s, [Gt, cn].indexOf(o) >= 0 ? {
    x: i,
    y: r
  } : {
    x: r,
    y: i
  };
}
function YC(e) {
  var t = e.state, n = e.options, o = e.name, s = n.offset, a = s === void 0 ? [0, 0] : s, r = wh.reduce(function(u, p) {
    return u[p] = KC(p, t.rects, a), u;
  }, {}), i = r[t.placement], l = i.x, c = i.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += l, t.modifiersData.popperOffsets.y += c), t.modifiersData[o] = r;
}
var GC = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: YC
}, ZC = function(t, n) {
  return t = typeof t == "function" ? t(Object.assign({}, n.rects, {
    placement: n.placement
  })) : t, Th(typeof t != "number" ? t : Ah(t, ar));
};
function XC(e) {
  var t, n = e.state, o = e.name, s = e.options, a = n.elements.arrow, r = n.modifiersData.popperOffsets, i = kn(n.placement), l = gp(i), c = [Gt, cn].indexOf(i) >= 0, u = c ? "height" : "width";
  if (!(!a || !r)) {
    var p = ZC(s.padding, n), f = vp(a), m = l === "y" ? Yt : Gt, h = l === "y" ? ln : cn, g = n.rects.reference[u] + n.rects.reference[l] - r[l] - n.rects.popper[u], _ = r[l] - n.rects.reference[l], v = sr(a), w = v ? l === "y" ? v.clientHeight || 0 : v.clientWidth || 0 : 0, y = g / 2 - _ / 2, $ = p[m], S = w - f[u] - p[h], A = w / 2 - f[u] / 2 + y, I = jr($, A, S), D = l;
    n.modifiersData[o] = (t = {}, t[D] = I, t.centerOffset = I - A, t);
  }
}
function JC(e) {
  var t = e.state, n = e.options, o = n.element, s = o === void 0 ? "[data-popper-arrow]" : o;
  s != null && (typeof s == "string" && (s = t.elements.popper.querySelector(s), !s) || Ch(t.elements.popper, s) && (t.elements.arrow = s));
}
var QC = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: XC,
  effect: JC,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
const Zl = (e) => parseInt(e, 10);
function e1({
  arrowPadding: e,
  emit: t,
  locked: n,
  offsetDistance: o,
  offsetSkid: s,
  placement: a,
  popperNode: r,
  triggerNode: i
}) {
  const l = tt({
    isOpen: !1,
    popperInstance: null
  }), c = (g) => {
    var _;
    (_ = l.popperInstance) === null || _ === void 0 || _.setOptions((v) => ({
      ...v,
      modifiers: [...v.modifiers, {
        name: "eventListeners",
        enabled: g
      }]
    }));
  }, u = () => c(!0), p = () => c(!1), f = () => {
    l.isOpen && (l.isOpen = !1, t("close:popper"));
  }, m = () => {
    l.isOpen || (l.isOpen = !0, t("open:popper"));
  };
  le([() => l.isOpen, a], async ([g]) => {
    g ? (await h(), u()) : p();
  });
  const h = async () => {
    await rn(), l.popperInstance = FC(i.value, r.value, {
      placement: a.value,
      modifiers: [BC, qC, {
        name: "flip",
        enabled: !n.value
      }, QC, {
        name: "arrow",
        options: {
          padding: Zl(e.value)
        }
      }, GC, {
        name: "offset",
        options: {
          offset: [Zl(s.value), Zl(o.value)]
        }
      }]
    }), l.popperInstance.update();
  };
  return Jt(() => {
    var g;
    (g = l.popperInstance) === null || g === void 0 || g.destroy();
  }), {
    ...Jv(l),
    open: m,
    close: f
  };
}
const t1 = {
  id: "arrow",
  "data-popper-arrow": ""
};
function n1(e, t) {
  return b(), C("div", t1);
}
function Dh(e, t) {
  t === void 0 && (t = {});
  var n = t.insertAt;
  if (!(!e || typeof document > "u")) {
    var o = document.head || document.getElementsByTagName("head")[0], s = document.createElement("style");
    s.type = "text/css", n === "top" && o.firstChild ? o.insertBefore(s, o.firstChild) : o.appendChild(s), s.styleSheet ? s.styleSheet.cssText = e : s.appendChild(document.createTextNode(e));
  }
}
var o1 = `
#arrow[data-v-20b7fd4a],
  #arrow[data-v-20b7fd4a]::before {
    transition: background 250ms ease-in-out;
    position: absolute;
    width: calc(10px - var(--popper-theme-border-width, 0px));
    height: calc(10px - var(--popper-theme-border-width, 0px));
    box-sizing: border-box;
    background: var(--popper-theme-background-color);
}
#arrow[data-v-20b7fd4a] {
    visibility: hidden;
}
#arrow[data-v-20b7fd4a]::before {
    visibility: visible;
    content: "";
    transform: rotate(45deg);
}

  /* Top arrow */
.popper[data-popper-placement^="top"] > #arrow[data-v-20b7fd4a] {
    bottom: -5px;
}
.popper[data-popper-placement^="top"] > #arrow[data-v-20b7fd4a]::before {
    border-right: var(--popper-theme-border-width)
      var(--popper-theme-border-style) var(--popper-theme-border-color);
    border-bottom: var(--popper-theme-border-width)
      var(--popper-theme-border-style) var(--popper-theme-border-color);
}

  /* Bottom arrow */
.popper[data-popper-placement^="bottom"] > #arrow[data-v-20b7fd4a] {
    top: -5px;
}
.popper[data-popper-placement^="bottom"] > #arrow[data-v-20b7fd4a]::before {
    border-left: var(--popper-theme-border-width)
      var(--popper-theme-border-style) var(--popper-theme-border-color);
    border-top: var(--popper-theme-border-width)
      var(--popper-theme-border-style) var(--popper-theme-border-color);
}

  /* Left arrow */
.popper[data-popper-placement^="left"] > #arrow[data-v-20b7fd4a] {
    right: -5px;
}
.popper[data-popper-placement^="left"] > #arrow[data-v-20b7fd4a]::before {
    border-right: var(--popper-theme-border-width)
      var(--popper-theme-border-style) var(--popper-theme-border-color);
    border-top: var(--popper-theme-border-width)
      var(--popper-theme-border-style) var(--popper-theme-border-color);
}

  /* Right arrow */
.popper[data-popper-placement^="right"] > #arrow[data-v-20b7fd4a] {
    left: -5px;
}
`;
Dh(o1);
const yp = {};
yp.render = n1;
yp.__scopeId = "data-v-20b7fd4a";
var s1 = yp;
const a1 = ["onKeyup"];
var Ph = {
  props: {
    /**
     * Preferred placement (the "auto" placements will choose the side with most space.)
     */
    placement: {
      type: String,
      default: "bottom",
      validator: function(e) {
        return ["auto", "auto-start", "auto-end", "top", "top-start", "top-end", "bottom", "bottom-start", "bottom-end", "right", "right-start", "right-end", "left", "left-start", "left-end"].includes(e);
      }
    },
    /**
     * Disables automatically closing the popover when the user clicks away from it
     */
    disableClickAway: {
      type: Boolean,
      default: !1
    },
    /**
     * Offset in pixels along the trigger element
     */
    offsetSkid: {
      type: String,
      default: "0"
    },
    /**
     * Offset in pixels away from the trigger element
     */
    offsetDistance: {
      type: String,
      default: "12"
    },
    /**
     * Trigger the popper on hover
     */
    hover: {
      type: Boolean,
      default: !1
    },
    /**
     * Manually open/close the Popper, other events are ignored if this prop is set
     */
    show: {
      type: Boolean,
      default: null
    },
    /**
     * Disables the Popper. If it was already open, it will be closed.
     */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
     * Open the Popper after a delay (ms).
     */
    openDelay: {
      type: [Number, String],
      default: 0
    },
    /**
     * Close the Popper after a delay (ms).
     */
    closeDelay: {
      type: [Number, String],
      default: 0
    },
    /**
     * The z-index of the Popper.
     */
    zIndex: {
      type: [Number, String],
      default: 9999
    },
    /**
     * Display an arrow on the popper
     */
    arrow: {
      type: Boolean,
      default: !1
    },
    /**
     * Stop arrow from reaching the edge of the popper
     */
    arrowPadding: {
      type: String,
      default: "0"
    },
    /**
     * If the Popper should be interactive, it will close when clicked/hovered if false
     */
    interactive: {
      type: Boolean,
      default: !0
    },
    /**
     * Lock the Popper into place, it will not flip dynamically when it runs out of space if true
     */
    locked: {
      type: Boolean,
      default: !1
    },
    /**
     * If the content is just a simple string, it can be passed in as a prop
     */
    content: {
      type: String,
      default: null
    }
  },
  emits: ["open:popper", "close:popper"],
  setup(e, {
    emit: t
  }) {
    const n = e;
    En((ee) => ({
      c81fc0a4: e.zIndex
    }));
    const o = B$(), s = R(null), a = R(null), r = R(null), i = R(!1);
    Re(() => {
      const ee = o.default();
      if (ee && ee.length > 1)
        return console.error(`[Popper]: The <Popper> component expects only one child element at its root. You passed ${ee.length} child nodes.`);
    });
    const {
      arrowPadding: l,
      closeDelay: c,
      content: u,
      disableClickAway: p,
      disabled: f,
      interactive: m,
      locked: h,
      offsetDistance: g,
      offsetSkid: _,
      openDelay: v,
      placement: w,
      show: y
    } = Jv(n), {
      isOpen: $,
      open: S,
      close: A
    } = e1({
      arrowPadding: l,
      emit: t,
      locked: h,
      offsetDistance: g,
      offsetSkid: _,
      placement: w,
      popperNode: a,
      triggerNode: r
    }), {
      hasContent: I
    } = Zw(o, a, u), D = V(() => y.value !== null), O = V(() => f.value || !I.value), x = V(() => $.value && !O.value), F = V(() => !p.value && !D.value), P = V(() => m.value ? `border: ${g.value}px solid transparent; margin: -${g.value}px;` : null), E = Gl.debounce(S, v.value), B = Gl.debounce(A, c.value), N = async () => {
      O.value || D.value || (B.clear(), E());
    }, Y = async () => {
      D.value || (E.clear(), B());
    }, j = () => {
      $.value ? Y() : N();
    };
    return le([I, f], ([ee, te]) => {
      $.value && (!ee || te) && A();
    }), le($, (ee) => {
      ee ? i.value = !0 : Gl.debounce(() => {
        i.value = !1;
      }, 200);
    }), Wt(() => {
      D.value && (y.value ? E() : B());
    }), Wt(() => {
      F.value && Gw(s, Y);
    }), (ee, te) => (b(), C("div", {
      class: "inline-block",
      style: Zu(T(P)),
      onMouseleave: te[2] || (te[2] = (ce) => e.hover && Y()),
      ref: (ce, H) => {
        H.popperContainerNode = ce, s.value = ce;
      }
    }, [d("div", {
      ref: (ce, H) => {
        H.triggerNode = ce, r.value = ce;
      },
      onMouseover: te[0] || (te[0] = (ce) => e.hover && N()),
      onClick: j,
      onFocus: N,
      onKeyup: rl(Y, ["esc"])
    }, [Xe(ee.$slots, "default")], 40, a1), q(st, {
      name: "fade"
    }, {
      default: he(() => [ot(d("div", {
        onClick: te[1] || (te[1] = (ce) => !T(m) && Y()),
        class: "popper",
        ref: (ce, H) => {
          H.popperNode = ce, a.value = ce;
        }
      }, [Xe(ee.$slots, "content", {
        close: T(A),
        isOpen: i.value
      }, () => [ne(k(T(u)), 1)]), e.arrow ? (b(), ie(s1, {
        key: 0
      })) : M("", !0)], 512), [[Ds, T(x)]])]),
      _: 3
    })], 36));
  }
}, r1 = `
.inline-block[data-v-5784ed69] {
    display: inline-block;
}
.popper[data-v-5784ed69] {
    transition: background 250ms ease-in-out;
    background: var(--popper-theme-background-color);
    padding: var(--popper-theme-padding);
    color: var(--popper-theme-text-color);
    border-radius: var(--popper-theme-border-radius);
    border-width: var(--popper-theme-border-width);
    border-style: var(--popper-theme-border-style);
    border-color: var(--popper-theme-border-color);
    box-shadow: var(--popper-theme-box-shadow);
    z-index: var(--c81fc0a4);
}
.popper[data-v-5784ed69]:hover,
  .popper:hover > #arrow[data-v-5784ed69]::before {
    background: var(--popper-theme-background-color-hover);
}
.inline-block[data-v-5784ed69] {
    display: inline-block;
}
.fade-enter-active[data-v-5784ed69],
  .fade-leave-active[data-v-5784ed69] {
    transition: opacity 0.2s ease;
}
.fade-enter-from[data-v-5784ed69],
  .fade-leave-to[data-v-5784ed69] {
    opacity: 0;
}
`;
Dh(r1);
Ph.__scopeId = "data-v-5784ed69";
var bi = /* @__PURE__ */ (() => {
  const e = Ph;
  return e.install = (t) => {
    t.component("Popper", e);
  }, e;
})();
function Ih(e = 0, t = 0) {
  window.scrollTo({
    top: e,
    left: t,
    behavior: "instant"
  });
}
function i1() {
  return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
}
function gre() {
  return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
}
function yi(e, t) {
  var o;
  let n = e.target;
  for (; n; ) {
    if ((o = n == null ? void 0 : n.classList) != null && o.contains && t.some((s) => n.classList.contains(s)))
      return !1;
    if (n.parentElement)
      n = n.parentElement;
    else
      break;
  }
  return !0;
}
function l1(e) {
  const t = e.getAttribute("id"), n = document.querySelector('[for="' + t + '"]');
  if (n)
    return n.innerHTML.trim();
}
function c1(e) {
  const t = l1(e);
  return t || e.getAttribute("name");
}
function u1(e, t) {
  var r, i, l, c, u, p, f, m;
  const n = t != null && t.small ? (r = e.url) == null ? void 0 : r.replace("{SIZE}", t.small) : (i = e.url) == null ? void 0 : i.replace("/{SIZE}/", "/"), o = t != null && t.medium ? (l = e.url) == null ? void 0 : l.replace("{SIZE}", t.medium) : (c = e.url) == null ? void 0 : c.replace("/{SIZE}/", "/"), s = t != null && t.large ? (u = e.url) == null ? void 0 : u.replace("{SIZE}", t.large) : (p = e.url) == null ? void 0 : p.replace("/{SIZE}/", "/"), a = t != null && t.xlarge ? (f = e.url) == null ? void 0 : f.replace("{SIZE}", t.xlarge) : (m = e.url) == null ? void 0 : m.replace("/{SIZE}/", "/");
  return {
    small: n,
    medium: o,
    large: s,
    xlarge: a
  };
}
function $i(e, t, n) {
  return e ? e.includes("{VARIATION}") ? t && (n != null && n[t]) ? e.replace("{VARIATION}", t) : e.replace("/{VARIATION}", "") : e : "";
}
function p1(e, t, n) {
  if (n != null && n[t]) {
    const o = /\/focalarea\/(?:cinema|tabletLandscape)\//;
    return e.replace(o, `/focalarea/${t}/`);
  }
  return e;
}
const Eh = (e, t) => {
  const n = (o) => {
    yi(o, e) && t();
  };
  return window.addEventListener("mousedown", n), window.addEventListener("touchstart", n), n;
}, Oh = (e) => {
  e && (window.removeEventListener("mousedown", e), window.removeEventListener("touchstart", e));
};
class _i {
  /*
   * Generates a random ID of a given size.
   * @param length The length of the ID to generate
   * @returns A random ID of the given size
   */
  static generateId(t) {
    const n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", o = new Uint8Array(t);
    return crypto.getRandomValues(o), Array.from(
      o,
      (s) => n[s % n.length]
    ).join("");
  }
}
const d1 = { class: "payment-title-wrapper" }, f1 = { class: "securebooking-wrapper" }, m1 = { class: "securebooking vacv-tooltip" }, v1 = ["innerHTML"], h1 = ["aria-label"], g1 = {
  class: "tooltip-title",
  id: "tooltip-security-title"
}, b1 = ["id", "innerHTML"], y1 = {
  key: 0,
  class: "note"
}, bre = /* @__PURE__ */ K({
  __name: "VacvTravellersTitle",
  props: {
    stepNumber: {}
  },
  setup(e) {
    const t = R(!1), n = _i.generateId(12), o = R();
    le(t, () => {
      t.value ? o.value = Eh(
        ["popper", "btn-tooltip"],
        s
      ) : Oh(o.value);
    });
    const s = () => (t.value = !t.value, t.value);
    return (a, r) => (b(), C("div", d1, [
      d("div", f1, [
        d("div", m1, [
          q(T(bi), {
            arrow: "",
            show: t.value,
            placement: "bottom-start",
            role: "dialog",
            "aria-label": "tooltip-security-title",
            "aria-describedby": `tooltip-security-content-${T(n)}`
          }, ui({
            default: he(() => [
              d("button", {
                class: "btn-tooltip linklook",
                onClick: s,
                innerHTML: a.$t("vacvComponents.travellersTitle.labels.secureBooking")
              }, null, 8, v1)
            ]),
            _: 2
          }, [
            t.value ? {
              name: "content",
              fn: he(() => [
                d("button", {
                  onClick: s,
                  class: "btn-close",
                  "aria-label": a.$t("vacvComponents.common.buttons.close")
                }, null, 8, h1),
                d("div", g1, k(a.$t("vacvComponents.travellersTitle.messages.secureTooltipTitle")), 1),
                d("div", {
                  class: "tooltip-content",
                  id: `tooltip-security-content-${T(n)}`,
                  innerHTML: a.$t(
                    "vacvComponents.travellersTitle.messages.secureTooltipContent"
                  )
                }, null, 8, b1)
              ]),
              key: "0"
            } : void 0
          ]), 1032, ["show", "aria-describedby"])
        ]),
        d("h1", null, k(a.$t("vacvComponents.travellersTitle.labels.title")), 1)
      ]),
      a.stepNumber !== 2 ? (b(), C("div", y1, k(a.$t("vacvComponents.travellersTitle.labels.title-note")), 1)) : M("", !0)
    ]));
  }
}), $1 = ["id", "role", "aria-live", "aria-labelledby"], ta = /* @__PURE__ */ K({
  __name: "AccordionWrapper",
  props: {
    id: {},
    className: {},
    role: {},
    ariaLive: {},
    ariaLabelledby: {}
  },
  setup(e) {
    En((o) => ({
      bad741c4: t.value
    }));
    const t = R("0px"), n = R();
    return le(n, async (o) => {
      o != null && o.scrollHeight && (t.value = o.scrollHeight + "px");
    }), (o, s) => (b(), C("div", {
      id: o.id,
      class: ue("accordion-wrapper" + (o.className ? " " + o.className : "")),
      role: o.role,
      "aria-live": o.ariaLive,
      "aria-labelledby": o.ariaLabelledby,
      ref_key: "scrollHeightRef",
      ref: n
    }, [
      Xe(o.$slots, "default")
    ], 10, $1));
  }
}), _1 = /* @__PURE__ */ K({
  __name: "VacvDataInput",
  props: {
    value: {},
    initialValue: {},
    icon: {},
    label: {},
    tabId: {},
    placeholder: {},
    validations: {},
    validationMessages: {},
    readonly: { type: Boolean },
    isValid: { type: Boolean }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = e, o = R(!0), s = R(n.initialValue ?? n.value), a = t, r = () => {
      a("click");
    }, i = V(() => {
      const l = [];
      return n.validations && l.push(
        ...n.validations.map((c) => [c])
      ), n.isValid !== null && l.push(["booleanCheck", o.value]), l.length > 0 ? l : void 0;
    });
    return le(
      () => n.isValid,
      (l) => {
        o.value = l !== void 0 ? l : !0;
      },
      { immediate: !0 }
    ), le(
      () => n.value,
      (l) => {
        l && (s.value = l);
      }
    ), (l, c) => {
      const u = ut("FormKit");
      return b(), ie(u, {
        "outer-class": "vacv-data-input",
        type: "text",
        name: l.label,
        id: l.tabId + "-" + l.label,
        "data-testid": l.label || "data-input",
        placeholder: l.placeholder,
        readonly: l.readonly,
        "prefix-icon": l.icon,
        validation: i.value,
        "validation-messages": l.validationMessages,
        "validation-visibility": "live",
        "wrapper-class": "fausers",
        modelValue: s.value,
        "onUpdate:modelValue": c[0] || (c[0] = (p) => s.value = p),
        onClick: r
      }, null, 8, ["name", "id", "data-testid", "placeholder", "readonly", "prefix-icon", "validation", "validation-messages", "modelValue"]);
    };
  }
}), w1 = ["aria-labelledby"], C1 = /* @__PURE__ */ K({
  __name: "VacvOverlay",
  props: {
    position: {},
    label: {}
  },
  setup(e) {
    return (t, n) => (b(), C("div", {
      class: ue(["vacv-overlay", t.position]),
      id: "vacv-overlay",
      "test-id": "vacv-overlay",
      "aria-labelledby": t.label
    }, [
      Xe(t.$slots, "default", {}, void 0, !0)
    ], 10, w1));
  }
}), k1 = /* @__PURE__ */ De(C1, [["__scopeId", "data-v-bb7f27b7"]]), xh = (e) => (dn("data-v-cac30eba"), e = e(), fn(), e), S1 = { class: "vacv-counter-selector" }, T1 = { class: "vacv-counter-selector-wrapper" }, A1 = { class: "vacv-counter-selector-wrapper-label" }, D1 = { class: "vacv-counter-selector-wrapper-button" }, P1 = ["disabled"], I1 = /* @__PURE__ */ xh(() => /* @__PURE__ */ d("i", {
  class: "fa-solid fa-minus",
  "aria-hidden": "true"
}, null, -1)), E1 = { class: "sr-only" }, O1 = { class: "vacv-counter-selector-wrapper-button-counter" }, x1 = ["disabled"], M1 = /* @__PURE__ */ xh(() => /* @__PURE__ */ d("i", {
  class: "fa-solid fa-plus",
  "aria-hidden": "true"
}, null, -1)), L1 = { class: "sr-only" }, N1 = {
  key: 0,
  class: "vacv-counter-selector-advisory"
}, F1 = /* @__PURE__ */ K({
  __name: "VacvCounterSelector",
  props: {
    label: {},
    max: {},
    min: { default: 0 },
    value: {},
    advisory: { type: Boolean },
    disable: { type: Boolean }
  },
  emits: ["change"],
  setup(e, { expose: t, emit: n }) {
    const { t: o } = Ne({ useScope: "global" }), s = e, a = n, r = R(s.value || s.min), i = R(!1), l = V(() => r.value <= s.min);
    le(
      () => s.value,
      (f) => {
        r.value = f ?? s.min ?? 0;
      }
    ), le(r, (f, m) => {
      f !== m && a("change", f);
    });
    const c = () => {
      r.value++, s.max && r.value === s.max && (r.value = s.max, i.value = !0);
    }, u = () => {
      i.value = !1, r.value--;
    };
    return t({
      increment: c,
      decrement: u,
      reset: () => {
        r.value = 0;
      }
    }), (f, m) => (b(), C("div", S1, [
      d("div", T1, [
        d("div", A1, k(f.label), 1),
        d("div", D1, [
          d("button", {
            type: "button",
            class: "btn-increment minus",
            disabled: l.value,
            onClick: u
          }, [
            I1,
            d("span", E1, k(T(o)("vacvComponents.guestsInput.counter.remove")), 1)
          ], 8, P1),
          d("span", O1, k(r.value), 1),
          d("button", {
            type: "button",
            class: "btn-increment plus",
            disabled: f.disable ? f.disable : i.value,
            onClick: c
          }, [
            M1,
            d("span", L1, k(T(o)("vacvComponents.guestsInput.counter.add")), 1)
          ], 8, x1)
        ])
      ]),
      f.advisory ? (b(), C("div", N1, [
        d("div", null, k(T(o)("vacvComponents.guestsInput.roomsAdvisory")), 1)
      ])) : M("", !0)
    ]));
  }
}), Pr = /* @__PURE__ */ De(F1, [["__scopeId", "data-v-cac30eba"]]), R1 = ["type", "disabled", "data-testid"], V1 = /* @__PURE__ */ K({
  __name: "VacvButton",
  props: {
    label: {},
    secondary: { type: Boolean },
    position: { default: "left" },
    type: { default: "button" },
    disabled: { type: Boolean },
    dataTestId: {}
  },
  emits: ["click", "blur"],
  setup(e, { emit: t }) {
    const n = t, o = () => {
      n("click");
    }, s = () => {
      n("blur");
    };
    return (a, r) => (b(), C("div", {
      class: ue(["btn-wrapper", a.position])
    }, [
      d("button", {
        type: a.type,
        class: ue({
          "vacv-btn-primary": !a.secondary,
          "vacv-btn-secondary": a.secondary
        }),
        disabled: a.disabled,
        "data-testid": a.dataTestId,
        onClick: o,
        onBlur: s
      }, k(a.label), 43, R1)
    ], 2));
  }
}), ul = /* @__PURE__ */ De(V1, [["__scopeId", "data-v-ab842a76"]]), B1 = ["id", "aria-expanded", "aria-controls", "aria-label", "data-test"], H1 = ["data-inside-form"], U1 = {
  key: 0,
  class: "icon-wrapper"
}, z1 = /* @__PURE__ */ d("i", {
  class: "fa-solid fa-chevron-up",
  "aria-hidden": "true"
}, null, -1), W1 = /* @__PURE__ */ d("i", {
  class: "fa-solid fa-chevron-down",
  "aria-hidden": "true"
}, null, -1), j1 = [
  z1,
  W1
], q1 = { key: 1 }, K1 = ["data-test"], Y1 = {
  key: 3,
  class: "fa-solid fa-chevron-down",
  "aria-hidden": "true"
}, G1 = ["data-test"], Z1 = /* @__PURE__ */ d("i", {
  class: "fa-solid fa-chevron-down",
  "aria-hidden": "true"
}, null, -1), X1 = /* @__PURE__ */ K({
  __name: "VacvDropDownButton",
  props: {
    options: {},
    initialValue: {},
    selectedOption: {},
    label: {},
    dropDownVisible: { type: Boolean },
    dropDownId: {},
    outlined: { type: Boolean },
    useInsideForm: { type: Boolean }
  },
  emits: ["show-options"],
  setup(e) {
    const t = e, n = V(() => t.selectedOption ? t.selectedOption : t.options.length ? t.options.find(
      (s) => s.value === t.initialValue
    ) ?? t.options[0] : void 0);
    return (o, s) => {
      var a, r;
      return b(), C("button", {
        type: "button",
        role: "combobox",
        id: "dropdown-button-" + o.dropDownId,
        class: ue(["vacv-btn", { "vacv-btn-outline": o.outlined }]),
        "aria-haspopup": "true",
        "aria-expanded": o.dropDownVisible,
        "aria-controls": "dropdown-menu-" + o.dropDownId,
        "aria-label": o.$t("vacvComponents.common.buttons.open"),
        onClick: s[0] || (s[0] = (i) => o.$emit("show-options")),
        "data-test": o.dropDownId + "-test-button"
      }, [
        d("span", {
          class: "mobile-only dropdown-btn-text",
          "data-inside-form": o.useInsideForm,
          "aria-hidden": "true"
        }, [
          o.useInsideForm ? (b(), C("span", q1, k((a = n.value) == null ? void 0 : a.label), 1)) : (b(), C("span", U1, j1)),
          o.useInsideForm ? (b(), C("i", Y1)) : (b(), C("span", {
            key: 2,
            class: "vacv-label-sm",
            "data-test": o.dropDownId + "-test-button-label"
          }, k(o.label), 9, K1))
        ], 8, H1),
        d("span", {
          class: "desktop-only dropdown-btn-text",
          "aria-hidden": "true",
          "data-test": o.dropDownId + "-test-button-text"
        }, [
          d("span", null, k((r = n.value) == null ? void 0 : r.label), 1),
          Z1
        ], 8, G1)
      ], 10, B1);
    };
  }
}), J1 = ["id", "aria-labelledby", "aria-activedescendant", "data-test"], Q1 = ["id", "aria-selected", "onClick", "data-test", "drop-down-id"], e2 = ["aria-label"], t2 = /* @__PURE__ */ d("i", {
  class: "fa-solid fa-check",
  "aria-hidden": "true"
}, null, -1), n2 = /* @__PURE__ */ K({
  __name: "VacvDropDownOptions",
  props: {
    options: {},
    initialValue: {},
    dropDownId: {}
  },
  emits: ["change-option"],
  setup(e, { expose: t, emit: n }) {
    const o = e, s = R(o.initialValue), a = R(), r = n, i = (l) => {
      s.value = l, r("change-option", l.value);
    };
    return le(
      () => o.initialValue,
      (l) => {
        l != null && (s.value = o.initialValue);
      }
    ), t({
      items: a
    }), (l, c) => {
      var u;
      return b(), C("ul", {
        role: "listbox",
        class: "vacv-dropdown-menu nolist",
        id: "dropdown-menu-" + o.dropDownId,
        "aria-labelledby": "dropdown-button-" + o.dropDownId,
        "aria-activedescendant": "option-" + ((u = s.value) == null ? void 0 : u.value),
        "data-test": o.dropDownId + "-test-menu"
      }, [
        (b(!0), C($e, null, ke(l.options, (p) => {
          var f, m;
          return b(), C("li", {
            role: "option",
            id: o.dropDownId + "-option-" + p.value,
            class: ue(((f = s.value) == null ? void 0 : f.value) == p.value ? "selected" : ""),
            "aria-selected": ((m = s.value) == null ? void 0 : m.value) == p.value,
            onClick: (h) => i(p),
            "data-test": o.dropDownId + "-test-item",
            "drop-down-id": o.dropDownId,
            key: p.value,
            ref_for: !0,
            ref_key: "items",
            ref: a
          }, [
            d("button", {
              type: "button",
              "aria-label": p.sr ? p.sr : p.label,
              class: "dropdown-option"
            }, [
              t2,
              d("span", null, k(p.label), 1)
            ], 8, e2)
          ], 10, Q1);
        }), 128))
      ], 8, J1);
    };
  }
}), o2 = ["data-test", "data-testid", "id"], s2 = {
  key: 0,
  class: "desktop-only vacv-label-sm"
}, $p = /* @__PURE__ */ K({
  __name: "VacvDropDown",
  props: {
    options: {},
    label: {},
    initialValue: {},
    dropDownId: {},
    selectedValue: {},
    openLeft: { type: Boolean },
    outlined: { type: Boolean },
    directionRow: { type: Boolean },
    useInsideForm: { type: Boolean },
    isStarRating: { type: Boolean }
  },
  emits: ["value-change"],
  setup(e, { expose: t, emit: n }) {
    const o = e, s = (w) => {
      const y = o.options.find(($) => $.value === w);
      return y !== void 0 ? y : o.options[0];
    }, a = R(), r = R(!1), i = R(), l = R(-1), c = R(
      s(o.initialValue)
    ), u = R(
      s(o.initialValue)
    ), p = () => {
      r.value = !1;
    }, f = () => {
      r.value = !r.value, l.value = -1;
    };
    le(
      () => o.selectedValue,
      (w) => {
        w != null && (c.value ? c.value.value != w && m(w) : m(w));
      }
    );
    const m = (w) => {
      var S;
      const y = o.options.find(({ value: A }) => A === w), $ = c.value;
      c.value = y, p(), ((S = u.value) == null ? void 0 : S.value) !== (y == null ? void 0 : y.value) && (u.value = y, _("value-change", $, y));
    };
    lh(a, () => p());
    const h = (w) => {
      const $ = i.value.children[1];
      if (l.value === -1) {
        const S = w === "down" ? 0 : $.childElementCount - 1;
        g(S);
      } else {
        let S = null;
        const A = w === "down" ? l.value + 1 : l.value + $.childElementCount - 1;
        l.value = A % $.childElementCount, S = $.children[l.value], S.children[0].focus();
      }
    }, g = (w) => {
      const $ = i.value.children[1];
      w < 0 && (w = 0), w >= $.children.length && (w = $.children.length - 1), l.value = w, $.children[l.value].children[0].focus();
    }, _ = n, v = (w) => {
      w.key === "ArrowUp" ? (h("up"), w.preventDefault()) : w.key === "ArrowDown" && (h("down"), w.preventDefault());
    };
    return t({
      selectedOption: c,
      changeOption: m,
      goToItem: h,
      handleKeydown: v
    }), (w, y) => {
      var $;
      return b(), C("div", {
        class: ue(["vacv-dropdown", [{ isrow: o.directionRow }]]),
        ref_key: "dropdown",
        ref: a,
        onKeydown: v,
        "data-test": o.dropDownId + "-test",
        "data-testid": o.dropDownId + "-test",
        id: o.dropDownId
      }, [
        o.label ? (b(), C("div", s2, k(o.label), 1)) : M("", !0),
        d("div", {
          class: ue(["vacv-components-dropdown-wrapper", [
            {
              open: r.value,
              left: w.openLeft,
              "star-rating": o.isStarRating
            }
          ]]),
          ref_key: "dropDownContent",
          ref: i
        }, [
          q(X1, {
            "initial-value": o.initialValue,
            options: o.options,
            "selected-option": c.value,
            onShowOptions: f,
            label: o.label,
            class: ue(w.$attrs.class),
            "drop-down-visible": r.value,
            "drop-down-id": o.dropDownId,
            outlined: w.outlined,
            useInsideForm: w.useInsideForm,
            "data-selected": "option-" + (($ = c.value) == null ? void 0 : $.value)
          }, null, 8, ["initial-value", "options", "selected-option", "label", "class", "drop-down-visible", "drop-down-id", "outlined", "useInsideForm", "data-selected"]),
          q(n2, {
            options: w.options,
            onChangeOption: m,
            "initial-value": c.value,
            "drop-down-id": o.dropDownId
          }, null, 8, ["options", "initial-value", "drop-down-id"])
        ], 2)
      ], 42, o2);
    };
  }
}), a2 = {
  key: 0,
  class: "modal-mask"
}, r2 = { class: "modal-content" }, i2 = ["aria-label"], l2 = /* @__PURE__ */ K({
  __name: "VacvMobileOverlay",
  props: {
    onDisplay: { type: Boolean }
  },
  emits: ["close", "before-enter", "after-enter", "after-leave"],
  setup(e, { emit: t }) {
    const n = t, o = () => {
      n("before-enter"), window.dispatchEvent(new CustomEvent("vacvMobileOverlay-open"));
    }, s = () => {
      n("after-enter");
    }, a = () => {
      n("after-leave"), window.dispatchEvent(new CustomEvent("vacvMobileOverlay-close"));
    }, r = () => {
      n("close");
    };
    return (i, l) => (b(), ie(st, {
      name: "modal",
      "on-before-enter": o,
      "on-after-enter": s,
      "on-after-leave": a
    }, {
      default: he(() => [
        i.onDisplay ? (b(), C("div", a2, [
          d("div", r2, [
            d("button", {
              type: "button",
              class: "btn-close",
              onClick: r,
              "aria-label": i.$t("vacvComponents.common.buttons.close")
            }, null, 8, i2),
            Xe(i.$slots, "default")
          ])
        ])) : M("", !0)
      ]),
      _: 3
    }));
  }
}), c2 = 767;
function Mh(e) {
  return e && window.sso.isEmployeeUser(e) ? "vacvComponents.common.phoneNumber.B2CPhoneNumber" : e && window.sso.isB2BUser(e) ? "vacvComponents.common.phoneNumber.B2BPhoneNumber" : "vacvComponents.common.phoneNumber.guestPhoneNumber";
}
const u2 = { class: "guests-wrapper" }, p2 = {
  key: 0,
  class: "vacv-form-row child-age"
}, d2 = {
  key: 0,
  class: "child-age-label errorMsg vacv-form-error"
}, f2 = {
  key: 2,
  class: "one-infant-warning"
}, m2 = {
  key: 3,
  class: "infant-turns-two-warning"
}, v2 = { class: "guests-footer" }, h2 = {
  key: 0,
  class: "errorMsg vacv-form-error",
  role: "alert",
  "aria-atomic": "true"
}, g2 = { class: "advisory-list" }, b2 = ["innerHTML"], y2 = ["innerHTML"], $2 = ["innerHTML"], _2 = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path d="M144 0a80 80 0 1 1 0 160A80 80 0 1 1 144 0zM512 0a80 80 0 1 1 0 160A80 80 0 1 1 512 0zM0 298.7C0 239.8 47.8 192 106.7 192h42.7c15.9 0 31 3.5 44.6 9.7c-1.3 7.2-1.9 14.7-1.9 22.3c0 38.2 16.8 72.5 43.3 96c-.2 0-.4 0-.7 0H21.3C9.6 320 0 310.4 0 298.7zM405.3 320c-.2 0-.4 0-.7 0c26.6-23.5 43.3-57.8 43.3-96c0-7.6-.7-15-1.9-22.3c13.6-6.3 28.7-9.7 44.6-9.7h42.7C592.2 192 640 239.8 640 298.7c0 11.8-9.6 21.3-21.3 21.3H405.3zM224 224a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM128 485.3C128 411.7 187.7 352 261.3 352H378.7C452.3 352 512 411.7 512 485.3c0 14.7-11.9 26.7-26.7 26.7H154.7c-14.7 0-26.7-11.9-26.7-26.7z"/></svg><span class='sr-only'>Guests</span>`, yre = /* @__PURE__ */ K({
  __name: "VacvGuestsInputField",
  props: /* @__PURE__ */ Fd({
    tabId: {},
    modelValue: {},
    showInfantSelector: { type: Boolean }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Fd(["openOverlay", "analyticsErrorMessage", "submit"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const n = e, { t: o } = Ne({ useScope: "global" }), s = t, a = H$(e, "modelValue"), r = R(!1), i = R(null), l = V(() => {
      const W = n.modelValue.totalAdults + n.modelValue.totalChildren + n.modelValue.totalInfants, X = n.modelValue.totalRooms;
      return `${o("vacvComponents.guestsInput.insideDataGuests", W)} - ${o("vacvComponents.guestsInput.insideDataRooms", X)}`;
    }), u = A_({
      mobile: 0,
      desktop: c2
    }).active(), p = V(() => u.value === "mobile"), [f, m] = C_();
    lh(i, () => {
      w(!1);
    });
    function h(W) {
      a.value.totalAdults = W, a.value.totalRooms > W && (a.value.totalRooms = W), a.value.totalInfants > 0 && a.value.totalInfants > W && (a.value.totalInfants = W), D();
    }
    function g(W) {
      if (a.value.totalChildren = W, a.value.childAges.length > W)
        a.value.childAges.length = W;
      else
        for (let X = 0; X < W; X++)
          a.value.childAges[X] || (a.value.childAges[X] = {
            child: X,
            age: "0",
            value: 0
          });
      D(), O();
    }
    function _(W) {
      a.value.totalRooms = W;
    }
    function v(W) {
      a.value.totalInfants = W;
    }
    const w = (W) => {
      r.value = W, s("openOverlay", r.value);
    }, y = V(() => $()), $ = () => !!(a.value.totalAdults % a.value.totalRooms);
    function S() {
      return !(a.value.totalChildren > 0 && a.value.childAges.some((X) => X.value === 0));
    }
    const A = V(() => !S()), I = V(() => !A.value);
    function D() {
      a.value.isDataValid = S();
    }
    const O = () => a.value.totalChildren > 0 && a.value.childAges.some((X) => X.value === 0) ? (s("analyticsErrorMessage", "Enter Child Age at Departure Date"), !0) : $() ? (s("analyticsErrorMessage", "Distribute Adults Equally Between Rooms"), !0) : !1, x = () => {
      D(), !O() && (r.value = !1, s("submit", a.value));
    }, F = (W, X) => {
      a.value.childAges[X] = {
        child: X,
        age: W.label,
        value: W.value
      }, O(), s("submit", a.value);
    }, P = (W) => {
      const X = [
        {
          label: o("vacvComponents.guestsInput.childAge", W + 1),
          value: 0
        }
      ];
      for (let G = 2; G <= 17; G++)
        X.push({ label: G.toString(), value: G });
      return X;
    }, E = V(
      () => a.value.totalAdults === 1
    ), B = V(
      () => a.value.totalAdults + a.value.totalChildren + a.value.totalInfants >= 6
    ), N = V(
      () => a.value.totalChildren + a.value.totalInfants > 0
    ), Y = V(
      () => a.value.totalRooms >= a.value.totalAdults
    ), j = V(
      () => a.value.totalRooms >= a.value.totalAdults
    ), ee = V(() => E.value || N.value || Y.value || j.value), te = V(() => !B.value), ce = V(() => !B.value && a.value.totalRooms === 1), H = V(() => !B.value && a.value.totalRooms === 1 && a.value.totalInfants < a.value.totalAdults), oe = V(() => a.value.totalChildren + a.value.totalInfants > 0 && a.value.totalRooms === 1), U = V(() => a.value.totalInfants >= 1 && a.value.totalInfants === a.value.totalAdults), Q = V(() => o(Mh(Z))), z = V(() => a.value.totalInfants > 0);
    let Z = null;
    return ko(async () => {
      Z = await window.sso.getUserToken();
    }), (W, X) => (b(), C("div", {
      class: "vacv-guests-input-field",
      ref_key: "target",
      ref: i,
      "data-testid": "vacv-guests-input-field"
    }, [
      q(_1, {
        icon: _2,
        value: l.value,
        initialValue: l.value,
        tabId: W.tabId,
        readonly: "",
        label: W.$t("vacvComponents.guestsInput.placeholder"),
        "label-class": "sr-only",
        placeholder: W.$t("vacvComponents.guestsInput.placeholder"),
        validations: ["required"],
        "validation-messages": {
          required: W.$t("vacvComponents.guestsInput.errors.GuestsSelection"),
          booleanCheck: W.$t("vacvComponents.guestsInput.errors.GuestsSelection")
        },
        isValid: I.value,
        "data-testid": "vacv-guests-input",
        onFocus: X[0] || (X[0] = (G) => w(!0)),
        onKeydown: X[1] || (X[1] = rl(Ke(() => {
        }, ["prevent"]), ["enter"]))
      }, null, 8, ["value", "initialValue", "tabId", "label", "placeholder", "validation-messages", "isValid"]),
      q(T(f), null, {
        default: he(() => [
          d("div", u2, [
            q(Pr, {
              class: "guest adult",
              label: W.$t("vacvComponents.guestsInput.adults"),
              max: 6,
              min: 1,
              disable: !te.value,
              value: a.value.totalAdults,
              "data-testid": "vacv-counter-selector-adults",
              onChange: h
            }, null, 8, ["label", "disable", "value"]),
            q(Pr, {
              class: "guest child",
              label: W.$t("vacvComponents.guestsInput.children"),
              max: 4,
              disable: !ce.value,
              value: a.value.totalChildren,
              "data-testid": "vacv-counter-selector-children",
              onChange: g
            }, null, 8, ["label", "disable", "value"]),
            a.value.totalChildren > 0 ? (b(), C("div", p2, [
              A.value ? (b(), C("span", d2, k(W.$t("vacvComponents.guestsInput.errors.ChildAgeSelection")), 1)) : M("", !0),
              (b(!0), C($e, null, ke(a.value.totalChildren, (G, se) => (b(), C("div", {
                class: "vacv-form-item child",
                key: G + se
              }, [
                q($p, {
                  initialValue: a.value.childAges[se].value,
                  dropDownId: `child-age-${se}`,
                  outlined: "",
                  openLeft: "",
                  options: P(se),
                  "data-testid": "vacv-dropdown-children-age",
                  onValueChange: (pe, J) => F(J, se)
                }, null, 8, ["initialValue", "dropDownId", "options", "onValueChange"])
              ]))), 128))
            ])) : M("", !0),
            W.showInfantSelector ? (b(), ie(Pr, {
              key: 1,
              class: "guest infant",
              label: W.$t("vacvComponents.guestsInput.infants"),
              max: 4,
              disable: !H.value,
              value: a.value.totalInfants,
              "data-testid": "vacv-counter-selector-infants",
              onChange: v
            }, null, 8, ["label", "disable", "value"])) : M("", !0),
            U.value ? (b(), C("div", f2, k(W.$t("vacvComponents.guestsInput.oneInfantPerAdult")), 1)) : M("", !0),
            z.value ? (b(), C("div", m2, k(W.$t("vacvComponents.guestsInput.infantTurns2", {
              num: Q.value
            })), 1)) : M("", !0),
            q(Pr, {
              class: "guest room",
              label: W.$t("vacvComponents.guestsInput.rooms"),
              max: 6,
              min: 1,
              value: a.value.totalRooms,
              disable: ee.value,
              advisory: oe.value,
              "data-testid": "vacv-counter-selector-rooms",
              onChange: _
            }, null, 8, ["label", "value", "disable", "advisory"])
          ]),
          d("div", v2, [
            y.value ? (b(), C("span", h2, k(W.$t("vacvComponents.guestsInput.errors.RoomSelection")), 1)) : M("", !0),
            d("ul", g2, [
              d("li", {
                innerHTML: W.$t("vacvComponents.guestsInput.advisoryTravellers7+")
              }, null, 8, b2),
              d("li", {
                innerHTML: W.$t("vacvComponents.guestsInput.advisoryTravellers10+")
              }, null, 8, y2),
              W.showInfantSelector ? M("", !0) : (b(), C("li", {
                key: 0,
                innerHTML: W.$t("vacvComponents.guestsInput.advisoryNoInfantFeature")
              }, null, 8, $2))
            ])
          ]),
          q(ul, {
            label: W.$t("vacvComponents.guestsInput.buttonLabel"),
            position: "right",
            type: "button",
            secondary: "",
            disabled: !I.value,
            dataTestId: "vacv-guests-button-submit",
            onClick: x
          }, null, 8, ["label", "disabled"])
        ]),
        _: 1
      }),
      !p.value && r.value ? (b(), ie(k1, {
        key: 0,
        class: "guest-overlay",
        position: "right",
        label: "Guests"
      }, {
        default: he(() => [
          q(T(m))
        ]),
        _: 1
      })) : M("", !0),
      p.value ? (b(), ie(l2, {
        key: 1,
        onDisplay: p.value && r.value,
        onClose: X[2] || (X[2] = (G) => r.value = !1)
      }, {
        default: he(() => [
          q(T(m))
        ]),
        _: 1
      }, 8, ["onDisplay"])) : M("", !0)
    ], 512));
  }
}), w2 = St("showHide", () => {
  const e = R(!0);
  return { show: e, setShowHide: (n) => {
    e.value = n;
  } };
}), C2 = ["aria-label"], k2 = ["innerHTML"], $re = /* @__PURE__ */ K({
  __name: "AlertMessage",
  props: {
    message: {},
    status: {}
  },
  setup(e) {
    const t = w2(), { show: n } = Ce(t), { setShowHide: o } = t;
    return Re(() => {
      o(!0);
    }), (s, a) => T(n) ? (b(), C("div", {
      key: 0,
      class: ue(["spa-alertbox", s.status]),
      role: "alert",
      "aria-live": "polite"
    }, [
      d("button", {
        onClick: a[0] || (a[0] = (r) => T(o)(!1)),
        class: "btn-close",
        "aria-label": s.$t("vacvComponents.common.buttons.close")
      }, null, 8, C2),
      d("div", {
        class: "text",
        innerHTML: s.message
      }, null, 8, k2)
    ], 2)) : M("", !0);
  }
}), S2 = (e, t, n) => {
  const o = {
    event: e,
    aeroplanElement: n ?? "Aeroplan Badge"
  };
  t && (o.aeroplanElementValue = t), window.dataLayer.push(o);
};
async function _p(e, t = {}) {
  const { timeout: n = t.timeout ?? 6e4, ...o } = t, s = new AbortController();
  return o.signal = s.signal, setTimeout(() => s.abort(), n), fetch(e, o);
}
function Lh(e, t) {
  const n = {
    event: "errorDL",
    errorType: e.name,
    errorDetails: e.message,
    // Adding checks due to flaky CI test runs that run beyond the test lifecycle
    errorURL: typeof document < "u" ? document.URL ?? "" : "",
    errorPreviousURL: T2(t)
  };
  window && window.dataLayer.push(n);
}
function T2(e) {
  return e || (typeof document < "u" && document.referrer ? document.referrer : "");
}
class wi extends Error {
  constructor(n) {
    super("MicroServiceError");
    xo(this, "title");
    xo(this, "status");
    xo(this, "detail");
    xo(this, "errorDetail");
    const { title: o, status: s, detail: a, errorDetail: r } = n;
    this.name = this.constructor.name, this.title = o, this.status = s, this.detail = a, this.errorDetail = r, this.message = `title:${o},status:${s},detail:${a},errorDetail:${r}`;
  }
}
function wp(e) {
  return e instanceof Error ? e : Error(`Unexpected non-Error value: ${JSON.stringify(e)}`);
}
function Ci(e) {
  if (e) {
    const { title: t, status: n, detail: o, errorDetail: s } = e;
    if (t || n || o || s)
      return new wi(e);
  }
  return wp(e);
}
function Go(e, t = !1, n = []) {
  Lh(e), t ? A2(e, n) && Ju.captureException(e) : console.error(e);
}
function to(e, t = !1) {
  return Go(wp(e), t);
}
function A2(e, t = []) {
  return !(e instanceof wi && D2(e, t));
}
function D2(e, t = []) {
  return e.errorDetail ? t.indexOf(e.errorDetail) !== -1 : !1;
}
function _re(e, t, n = !1) {
  Lh(e), n ? Ju.captureException(e, t) : console.error(e);
}
function wre(e, t, n = !1) {
  n && Ju.captureMessage(e, t);
}
const Ya = async (e, t, n, o, s, a) => {
  try {
    const r = await _p(e, {
      timeout: a,
      credentials: "include",
      method: "GET"
    });
    if (r.ok)
      return await r.json();
    {
      const i = new Error(
        `Error: ${t} invalid response ${n ? "retries:" + n : ""} HTTP ${r.status}: ${r.statusText}`
      );
      if (Go(i, o, s), typeof n == "number" && n > 0)
        return Ya(e, t, n - 1);
      throw i;
    }
  } catch (r) {
    if (Go(
      Error(
        `Error: ${t} fetching ${n ? "retries:" + n : ""}`,
        { cause: r }
      ),
      o,
      s
    ), typeof n == "number" && n > 0)
      return Ya(e, t, n - 1);
    throw r;
  }
}, P2 = { class: "ae-login-container" }, I2 = { class: "ae-logo-wrapper" }, E2 = { class: "logo" }, O2 = ["src", "alt"], x2 = { class: "text" }, M2 = { class: "ae-login-btn" }, Cre = /* @__PURE__ */ K({
  __name: "AeroplanLoginBanner",
  props: {
    SENTRY_ERROR_CODE_FILTER: {},
    SHOULD_SEND_SENTRY: { type: Boolean },
    lang: {}
  },
  setup(e) {
    const t = e, { t: n } = Ne({ useScope: "global" }), o = Ye("cdnBaseUrl"), s = Ye("aeSignInBannerURL"), r = Ye("aeLoginUrl") + "?redirect-url=" + encodeURIComponent(window.location.href), i = (c) => {
      c.preventDefault(), window.sso ? window.sso.loginAeroplan() : window.location.assign(r), S2(
        "plpAeroplan",
        "Sign In Button - Aeroplan Banner",
        "Aeroplan Banner"
      );
    }, l = R("");
    return Re(async () => {
      if (s)
        try {
          const c = await Ya(
            s + (t.lang === "fr" ? "?lang=fr" : ""),
            "AE Signin Banner",
            0,
            t.SHOULD_SEND_SENTRY,
            t.SENTRY_ERROR_CODE_FILTER
          );
          l.value = c.titleText ? c.titleText : n("vacvComponents.aeroplan.login-banner");
        } catch {
          l.value = n("vacvComponents.aeroplan.login-banner");
        }
      else
        l.value = n("vacvComponents.aeroplan.login-banner");
    }), (c, u) => (b(), C("div", P2, [
      d("div", I2, [
        d("div", E2, [
          d("img", {
            src: `${T(o)}/img/aeroplan-logo.svg`,
            width: "120",
            alt: c.$t("vacvComponents.aeroplan.aeroplan")
          }, null, 8, O2)
        ]),
        d("div", x2, k(l.value), 1)
      ]),
      d("div", M2, [
        d("button", {
          onClick: u[0] || (u[0] = (p) => i(p)),
          class: "vacv-btn-secondary"
        }, k(c.$t("vacvComponents.aeroplan.signin-btn")), 1)
      ])
    ]));
  }
}), Nh = function(e, t) {
  let n;
  return t === "CA" ? n = J$ : n = Q$, n.test(String(e.value));
};
Nh.skipEmpty = !1;
function tf(e, t, n) {
  const o = +e;
  return o >= t && o <= n;
}
function Fh(e, t, n) {
  e ?? (e = "0");
  const o = n === "fr" ? "," : ".", s = n === "fr" ? "\\s" : ",";
  let a;
  const r = new RegExp(
    "[^\\d" + s + o + "]",
    "g"
  );
  return a = e.replace(r, ""), a = a.split(o).slice(0, 2).map((i, l) => l === 0 ? L2(n, i) : i.slice(0, 2)).join(o), a !== e && t.input(a), a;
}
const Un = (e, t) => {
  let n = 0;
  return typeof t == "string" && (e === "fr" ? n = +t.replace(/\s/g, "").replace(",", ".").replace("$", "") : n = +t.replace(",", "").replace("$", "")), n;
};
function L2(e, t) {
  let n = 0;
  const o = e === "fr" ? /\s+/ : /,+/, s = e === "fr" ? " " : ",";
  return RegExp(o).exec(t) ? t.split(o).slice(0, 2).map((a, r) => {
    if (r === 0)
      return n = a.length >= 6 ? 6 : a.length, a.slice(0, n);
    if (r === 1)
      return a.slice(0, 6 - n);
  }).join(s).slice(0, 7) : t.slice(0, 6);
}
const kre = () => {
};
function nf(e) {
  return new RegExp("/" + e + "($|/)");
}
const N2 = [Ns.en, Ns.fr], F2 = {
  en: nf(Ns.en),
  fr: nf(Ns.fr)
}, R2 = (e) => {
  for (const t of N2)
    if (F2[t].test(e))
      return t;
  return Ns.en;
}, V2 = () => {
  var e;
  return ((e = window == null ? void 0 : window.location) == null ? void 0 : e.pathname) ?? "/";
}, It = () => R2(V2()), Tt = St("checkout", () => {
  const t = R(!0), n = R(!1), o = R(!1), s = R(!1), a = R(0), r = R(""), i = R(""), l = R(""), c = R(null), u = R(0), p = R(!1), f = R(!1), m = R(!0), h = wt.full, g = R(h), _ = R(0), v = R(qt.B2C_GUEST), w = R(!1), y = V(() => {
    if (n.value && !t.value) {
      if (o.value)
        return !1;
      if (p.value && c.value != null && c.value > 0 && a.value === c.value && _.value <= 0 || a.value === u.value)
        return !0;
    }
    return !1;
  }), $ = R(!1), S = R(
    I(Hn, 1)
  ), A = R(
    I(wn, 2)
  );
  function I(fe, Ge) {
    return {
      creditCardName: "",
      creditCardExpiry: "",
      creditCardAmount: "",
      displayAmount: !1,
      disableAmount: !1,
      showAddress: !1,
      showToggleAddress: !1,
      sameBillingAddress: !1,
      creditCardIframeName: fe,
      creditCardIframeNumber: Ge,
      address: "",
      apartment: "",
      city: "",
      country: "CA",
      state: "",
      postcode: "",
      bill96: !1
    };
  }
  const D = tt(
    Array.from({ length: 2 }, () => 0)
  );
  function O(fe) {
    fe < 2 && D[fe]++;
  }
  function x() {
    D.forEach((fe, Ge) => {
      D[Ge] = 0;
    });
  }
  const F = R(!1), P = R(!1), E = R(!1), B = V(() => r.value === "" ? s.value : !0), N = (fe) => {
    t.value = fe;
  }, Y = (fe) => {
    n.value = fe;
  }, j = (fe) => {
    v.value = fe;
  }, ee = (fe) => {
    o.value = fe;
  }, te = (fe) => {
    c.value = fe;
  }, ce = () => {
    c.value = null;
  }, H = (fe) => {
    p.value = fe;
  }, oe = (fe) => {
    g.value = fe;
  }, U = (fe) => {
    f.value = fe;
  }, Q = (fe) => {
    m.value = fe;
  }, z = (fe, Ge) => {
    a.value = fe, r.value = ap(a.value, Ge);
  }, Z = (fe) => {
    _.value = fe;
  }, W = () => {
    a.value = 0, r.value = "", s.value = !1;
  }, X = (fe) => {
    n.value && (t.value ? W() : p.value && c.value !== null && c.value > 0 ? z(c.value, fe) : z(u.value, fe));
  };
  function G(fe) {
    if (t.value && n.value && r.value === "") {
      S.value.creditCardAmount = "";
      return;
    }
    if (t.value)
      if (p.value && c.value) {
        const Ge = c.value - a.value;
        S.value.creditCardAmount = Se(Ge, fe).replace(
          "$",
          ""
        );
      } else {
        let Ge = parseFloat(
          (u.value - a.value).toFixed(2)
        );
        Ge < 0 && (Ge = 0), S.value.creditCardAmount = Se(Ge, fe).replace(
          "$",
          ""
        );
      }
    n.value && (p.value && c.value !== null ? pe() : se());
  }
  function se() {
    t.value && a.value > u.value - _.value ? S.value.creditCardAmount = _.value ? _.value.toString() : "0" : a.value === u.value && !_.value && (t.value = !1);
  }
  function pe() {
    p.value && c.value != null && a.value > c.value - _.value ? t.value && (S.value.creditCardAmount = _.value ? _.value.toString() : "0") : a.value === c.value && !_.value && (t.value = !1);
  }
  function J(fe) {
    const Ge = function(zt) {
      const dt = Un(
        It(),
        zt.value
      );
      return fe(dt);
    };
    return Ge.skipEmpty = !1, Ge;
  }
  const ae = J(
    (fe) => fe < u.value
  ), re = J(
    (fe) => fe <= u.value
  ), ge = J(
    (fe) => _.value > 0 && fe <= u.value
  ), Ie = J(
    (fe) => _.value > 0 && !!c.value && c.value > 0 && fe <= c.value - _.value
  ), je = J((fe) => c.value === null ? !0 : c.value === 0 || fe <= c.value), Ve = J(
    (fe) => fe != c.value
  ), Ue = J(
    (fe) => fe != u.value
  ), Be = J((fe) => fe > 0), ht = J((fe) => p.value && c.value != null ? fe <= c.value : !1);
  return {
    card1: S,
    card2: A,
    showBill96Checkbox: F,
    bill96: P,
    isTotalPriceZero: E,
    isPaymentMethodCreditCard: t,
    isPaymentMethodGiftCard: n,
    isPaymentMethodUplift: o,
    amountToPay: u,
    depositAmount: c,
    selectDeposit: p,
    giftCardAmount: a,
    displayedGiftCardAmount: r,
    giftCardNumber: i,
    giftCardPIN: l,
    validators: {
      isAmountGreaterThanZero: Be,
      isAmountLessThanTotal: ae,
      isAmountLessThanDeposit: je,
      isAmountLessThanOrEqualToTotal: re,
      isAmountLessThanOrEqualToTotalWithoutInsurancePremium: ge,
      isAmountLessThanOrEqualToDepositWithoutInsurancePremium: Ie,
      isAmountLessThanOrEqualToDeposit: ht,
      isAmountNotEqualToTotal: Ue,
      isAmountNotEqualToDeposit: Ve,
      isGiftCardAmountSufficient: function(fe) {
        return Un(
          It(),
          fe.value
        ) >= u.value;
      },
      isGiftCardDepositSufficient: function(fe) {
        return p.value && c.value != null ? Un(
          It(),
          fe.value
        ) >= c.value : !1;
      }
    },
    giftCardAmountErrorVisible: B,
    checkoutHasBeenSubmitted: s,
    toggle2cc: f,
    sameBillingAddress: m,
    showGiftCardTwoCardError: w,
    showGiftCardPayInFullMessage: y,
    showPaymentMethodError: $,
    selectedPlan: g,
    insurancePremiumAmount: _,
    audience: v,
    creditCard3DSFailures: D,
    setDepositAmount: te,
    setDepositAmountToNull: ce,
    setSelectDeposit: H,
    setGiftCardAmount: z,
    clearGiftCardAmount: W,
    autoCalculateGiftCardAmount: X,
    recalculateCreditCard1Amount: G,
    setIsPaymentMethodCreditCard: N,
    setIsPaymentMethodGiftCard: Y,
    setIsPaymentMethodUplift: ee,
    setSelectedPlan: oe,
    setToggle2cc: U,
    setSameBillingAddress: Q,
    setInsurancePremiumAmount: Z,
    setAudience: j,
    incrementCreditCard3DSFailures: O,
    resetCreditCard3DSFailures: x
  };
}), B2 = { class: "cc-form-street vacv-form-row vacv-input" }, H2 = {
  key: 0,
  class: "vacv-form-item medium"
}, U2 = {
  key: 1,
  class: "vacv-form-item narrow"
}, z2 = {
  key: 0,
  class: "cc-form-city vacv-form-row vacv-input"
}, W2 = { class: "vacv-form-item medium" }, j2 = {
  key: 0,
  class: "vacv-form-item narrow"
}, q2 = { class: "cc-form-province vacv-form-row vacv-input" }, K2 = { class: "vacv-form-item medium" }, Y2 = {
  key: 0,
  class: "vacv-form-item narrow"
}, Rh = /* @__PURE__ */ K({
  __name: "BillingAddress",
  props: {
    creditCardName: {},
    lang: {}
  },
  setup(e) {
    const t = Tt(), { card1: n, card2: o, showBill96Checkbox: s, isPaymentMethodUplift: a } = Ce(t), r = e, i = r.creditCardName === "ccframe2" ? o : n, { t: l } = Ne({ useScope: "global" }), c = [
      {
        label: l("vacvComponents.payment.placeholders.select"),
        value: ""
      },
      ...Y$.map((h) => ({
        label: l(`vacvComponents.provinces.${h}`),
        value: h
      }))
    ], u = [
      {
        label: l("vacvComponents.payment.placeholders.select"),
        value: ""
      },
      ...G$.map((h) => ({
        label: l(`vacvComponents.states.${h}`),
        value: h
      }))
    ], p = V(
      () => Z$.map((h) => ({
        label: l(`vacvComponents.countries.${h}`),
        value: h
      }))
    );
    function f() {
      r.creditCardName === "ccframe1" && (s.value = r.lang === "en" && i.value.state === "QC");
    }
    const m = V(() => i.value.country === "US" ? u : c);
    return (h, g) => {
      const _ = ut("FormKit");
      return b(), C($e, null, [
        d("div", B2, [
          T(a) ? M("", !0) : (b(), C("div", H2, [
            q(_, {
              type: "text",
              name: h.creditCardName + "-address",
              id: h.creditCardName + "-address",
              label: `${h.$t("vacvComponents.payment.labels.creditCardAddress")}*`,
              validation: "required",
              "validation-messages": {
                required: h.$t("vacvComponents.payment.errors.pleaseEnterCCAddress")
              },
              modelValue: T(i).address,
              "onUpdate:modelValue": g[0] || (g[0] = (v) => T(i).address = v)
            }, null, 8, ["name", "id", "label", "validation-messages", "modelValue"])
          ])),
          T(a) ? M("", !0) : (b(), C("div", U2, [
            q(_, {
              type: "text",
              name: h.creditCardName + "-apartment",
              id: h.creditCardName + "-apartment",
              label: h.$t("vacvComponents.payment.labels.creditCardApartment"),
              modelValue: T(i).apartment,
              "onUpdate:modelValue": g[1] || (g[1] = (v) => T(i).apartment = v)
            }, null, 8, ["name", "id", "label", "modelValue"])
          ]))
        ]),
        T(a) ? M("", !0) : (b(), C("div", z2, [
          d("div", W2, [
            q(_, {
              type: "text",
              name: h.creditCardName + "-city",
              id: h.creditCardName + "-city",
              label: `${h.$t("vacvComponents.payment.labels.creditCardCity")}*`,
              validation: "required|length:0,35|matches:/^[^\\d]+$/",
              "validation-messages": {
                required: h.$t("vacvComponents.payment.errors.pleaseEnterCCCity"),
                length: h.$t("vacvComponents.payment.errors.maxCharsAccepted", {
                  max: 35
                }),
                matches: h.$t("vacvComponents.payment.errors.cityWrongFormat")
              },
              modelValue: T(i).city,
              "onUpdate:modelValue": g[2] || (g[2] = (v) => T(i).city = v)
            }, null, 8, ["name", "id", "label", "validation-messages", "modelValue"])
          ]),
          T(a) ? M("", !0) : (b(), C("div", j2, [
            q(_, {
              delay: 0,
              type: "select",
              name: h.creditCardName + "-country",
              id: h.creditCardName + "-country",
              label: `${h.$t("vacvComponents.payment.labels.creditCardCountry")}*`,
              options: p.value,
              validation: "required",
              "validation-messages": {
                required: h.$t("vacvComponents.payment.errors.pleaseEnterCCCountry")
              },
              modelValue: T(i).country,
              "onUpdate:modelValue": g[3] || (g[3] = (v) => T(i).country = v)
            }, null, 8, ["name", "id", "label", "options", "validation-messages", "modelValue"])
          ]))
        ])),
        d("div", q2, [
          d("div", K2, [
            q(_, {
              delay: 0,
              type: "select",
              name: h.creditCardName + "-state",
              id: h.creditCardName + "-state",
              label: `${h.$t("vacvComponents.payment.labels.creditCardProvince")}*`,
              options: m.value,
              onChange: f,
              validation: "required",
              "validation-messages": {
                required: h.$t("vacvComponents.payment.errors.pleaseEnterCCProvince")
              },
              modelValue: T(i).state,
              "onUpdate:modelValue": g[4] || (g[4] = (v) => T(i).state = v)
            }, null, 8, ["name", "id", "label", "options", "validation-messages", "modelValue"])
          ]),
          T(a) ? M("", !0) : (b(), C("div", Y2, [
            q(_, {
              type: "text",
              name: h.creditCardName + "-postcode",
              id: h.creditCardName + "-postcode",
              label: `${h.$t("vacvComponents.payment.labels.creditCardPostCode")}*`,
              validation: "required|isPostalCodeValidRule:" + T(i).country,
              "validation-rules": { isPostalCodeValidRule: T(Nh) },
              "validation-messages": {
                required: h.$t("vacvComponents.payment.errors.pleaseEnterCCPostalCode"),
                isPostalCodeValidRule: h.$t(
                  "vacvComponents.payment.errors.postalCodeWrongFormat"
                )
              },
              modelValue: T(i).postcode,
              "onUpdate:modelValue": g[5] || (g[5] = (v) => T(i).postcode = v)
            }, null, 8, ["name", "id", "label", "validation", "validation-rules", "validation-messages", "modelValue"])
          ]))
        ])
      ], 64);
    };
  }
}), yo = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M470.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L192 338.7 425.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg>';
let jo;
function G2() {
  const e = /* @__PURE__ */ new Map();
  return e.set(Hn, {
    hpciCVVValid: !1,
    hpciCardNumberTouched: !1,
    hpciCardNumberValid: !1,
    hpciCVVTouched: !1,
    hpciCCNumToken: "",
    hpciCVVToken: "",
    hpciResponded: !1,
    hpciLateResponse: !1
  }), e;
}
function Z2(e) {
  const t = window.hpciCards.get(e.hpciMsgSrcFrameName);
  t && (t.hpciCardNumberTouched = !0, +e.hpciCCLengthValue > 1 && e.hpciCCBINValue && !e.hpciCCBINValue.startsWith(
    tp
  ) && !e.hpciCCBINValue.startsWith(
    np
  ) && !e.hpciCCBINValue.startsWith(
    op
  ) && !e.hpciCCBINValue.startsWith(sp) ? (window.sendHPCIChangeTextFrameMsg(
    e.hpciMsgSrcFrameName,
    on,
    jo.ccTypeNotAccepted
  ), window.sendHPCIChangeStyleFrameMsg(
    e.hpciMsgSrcFrameName,
    on,
    "display",
    "block"
  )) : window.sendHPCIChangeStyleFrameMsg(
    e.hpciMsgSrcFrameName,
    on,
    "display",
    "none"
  ));
}
function X2(e) {
  const t = window.hpciCards.get(e.hpciMsgSrcFrameName);
  return t ? (t.hpciCardNumberTouched = !0, t.hpciCardNumberValid = !1, +e.hpciCCLengthValue < 1 ? (window.sendHPCIChangeTextFrameMsg(
    e.hpciMsgSrcFrameName,
    on,
    jo.noCardNumber
  ), window.sendHPCIChangeStyleFrameMsg(
    e.hpciMsgSrcFrameName,
    on,
    "display",
    "block"
  )) : +e.hpciCCLengthValue > 1 && e.hpciCCBINValue && !e.hpciCCBINValue.startsWith(
    tp
  ) && !e.hpciCCBINValue.startsWith(
    np
  ) && !e.hpciCCBINValue.startsWith(
    op
  ) && !e.hpciCCBINValue.startsWith(sp) ? (window.sendHPCIChangeTextFrameMsg(
    e.hpciMsgSrcFrameName,
    on,
    jo.ccTypeNotAccepted
  ), window.sendHPCIChangeStyleFrameMsg(
    e.hpciMsgSrcFrameName,
    on,
    "display",
    "block"
  )) : tk(
    e.hpciCCBINValue,
    e.hpciCCLengthValue,
    e.hpciCCEnteredLengthValue,
    e.hpciCCValidValue
  ) ? t.hpciCardNumberValid = !0 : (window.sendHPCIChangeTextFrameMsg(
    e.hpciMsgSrcFrameName,
    on,
    jo.ccWrongFormat
  ), window.sendHPCIChangeStyleFrameMsg(
    e.hpciMsgSrcFrameName,
    on,
    "display",
    "block"
  )), t.hpciCardNumberValid) : !1;
}
function J2(e) {
  const t = window.hpciCards.get(e.hpciMsgSrcFrameName);
  t && (t.hpciCVVTouched = !0, (+e.hpciCVVLengthValue >= 3 || e.hpciCVVValidValue == "Y") && window.sendHPCIChangeStyleFrameMsg(
    e.hpciMsgSrcFrameName,
    Ho,
    "display",
    "none"
  ));
}
function Q2(e) {
  const t = window.hpciCards.get(e.hpciMsgSrcFrameName);
  return t ? (t.hpciCVVTouched = !0, t.hpciCVVValid = !1, +e.hpciCVVLengthValue < 1 ? (window.sendHPCIChangeTextFrameMsg(
    e.hpciMsgSrcFrameName,
    Ho,
    jo.noCVV
  ), window.sendHPCIChangeStyleFrameMsg(
    e.hpciMsgSrcFrameName,
    Ho,
    "display",
    "block"
  )) : +e.hpciCVVLengthValue >= 3 && +e.hpciCVVLengthValue <= 4 && e.hpciCVVValidValue == "Y" ? t.hpciCVVValid = !0 : (window.sendHPCIChangeTextFrameMsg(
    e.hpciMsgSrcFrameName,
    Ho,
    jo.cvvWrongFormat
  ), window.sendHPCIChangeStyleFrameMsg(
    e.hpciMsgSrcFrameName,
    Ho,
    "display",
    "block"
  )), t.hpciCVVValid) : !1;
}
function ek(e) {
  jo = {
    ccTypeNotAccepted: e("vacvComponents.payment.errors.ccTypeNotAccepted"),
    noCardNumber: e("vacvComponents.payment.errors.noCardNumber"),
    ccWrongFormat: e("vacvComponents.payment.errors.ccWrongFormat"),
    noCVV: e("vacvComponents.payment.errors.noCVV"),
    cvvWrongFormat: e("vacvComponents.payment.errors.cvvWrongFormat")
  }, window.hpciCards = G2(), window.customHPCICCTypingValidation = Z2, window.customHPCICCValidation = X2, window.customHPCICVVTypingValidation = J2, window.customHPCICVVValidation = Q2;
}
function tk(e, t, n, o) {
  return !!(e && (e.startsWith(op) || e.startsWith(sp)) && +t == 15 && +n == 17 && o == "Y" || e && (e.startsWith(tp) || e.startsWith(np)) && +t == 16 && +n == 19 && o == "Y");
}
function Vh(e, t) {
  window.hpciCards.forEach((n, o) => {
    n && (n.hpciCardNumberTouched || (Bh(o, e), n.hpciCardNumberValid = !1), n.hpciCVVTouched || (window.sendHPCIChangeTextFrameMsg(
      o,
      Ho,
      t
    ), window.sendHPCIChangeStyleFrameMsg(
      o,
      Ho,
      "display",
      "block"
    ), n.hpciCVVValid = !1));
  });
}
function Bh(e, t) {
  window.sendHPCIChangeTextFrameMsg(
    e,
    on,
    t
  ), window.sendHPCIChangeStyleFrameMsg(
    e,
    on,
    "display",
    "block"
  );
}
function nk(e, t) {
  Vh(e, t);
  let n = !0;
  return window.hpciCards.forEach((o) => {
    (!o.hpciCVVValid || !o.hpciCardNumberValid) && (n = !1);
  }), n;
}
function ok() {
  window.hpciCards.set(wn, {
    hpciCVVValid: !1,
    hpciCardNumberTouched: !1,
    hpciCardNumberValid: !1,
    hpciCVVTouched: !1,
    hpciCCNumToken: "",
    hpciCVVToken: "",
    hpciResponded: !1,
    hpciLateResponse: !1
  });
}
function Xl() {
  window.hpciCards.delete(wn);
}
function sk() {
  window.hpciCards.forEach((e) => {
    e.hpciCardNumberValid = !1, e.hpciCVVValid = !1, e.hpciCardNumberTouched = !1, e.hpciCVVTouched = !1, e.hpciCCNumToken = "", e.hpciCVVToken = "", e.hpciResponded = !1, e.hpciLateResponse = !1;
  });
}
function ak(e) {
  window.customHPCIErrorHandler = function() {
    window.hpciCards.forEach((t) => {
      t.hpciResponded = !0;
    }), e();
  };
}
function Hh(e, t) {
  const n = e.lang == "en" ? "en_CA" : "fr_CA";
  function o(i, l) {
    const { pathname: c = "", search: u = "" } = (window == null ? void 0 : window.location) ?? {}, p = `${c}${u}`;
    return `${e.hpciHost}/iSynSApp/showPxyPage!ccFrame.action?pgmode1=${e.hpciPageMode}&locationName=${e.siteLoc}&enable3DSec=skip3ds&selected3DSecPayName=&selected3DSecPayCurISO=&enableEarlyToken=Y&enableTokenDisplay=Y&reportCCType=Y&reportCCDigits=Y&reportCVVDigits=Y&strictMsgFmt=Y&ccFrameName=${i}&sid=${e.siteId}&fullParentHost=${e.parentHost}&fullParentQStr=${p}&ccTypeMapMode=def&formatCCDigits=Y&formatCCDigitsDelimiter=-&formatCCMaskMode=S2L2&formatCCMaskChar=*&reportInit=Y&lang=${n}&ccNumTokenIdx=${l}`;
  }
  function s(i) {
    const l = window.hpciCards.get(i);
    return l && !l.hpciResponded ? (l.hpciLateResponse = !0, !1) : !0;
  }
  function a(i, l) {
    const c = window.hpciCards.get(i);
    c && (c.hpciResponded = !1, c.hpciLateResponse = !1, setTimeout(() => {
      s(i) || l(i);
    }, e.fetchApiTimeout), window.hpciStatusReset(), window.hpciCCFrameName = i, window.sendHPCIMsg());
  }
  async function r(i, l, c) {
    window.customHPCIHandler = function(u) {
      var f, m;
      const p = window.hpciCards.get(u.hpciMsgSrcFrameName);
      if (p) {
        if (p.hpciLateResponse)
          return;
        if (p.hpciResponded = !0, p.hpciCCNumToken = u.hpciMappedCCValue, p.hpciCVVToken = u.hpciMappedCVVValue, window.hpciCards.size > 1 && u.hpciMsgSrcFrameName == Hn && a(wn, c), window.hpciCards.size === 1 && u.hpciMsgSrcFrameName == Hn || // Pay with one credit card
        window.hpciCards.size > 1 && u.hpciMsgSrcFrameName == wn) {
          if (window.hpciCards.size > 1 && ((f = window.hpciCards.get(Hn)) == null ? void 0 : f.hpciCCNumToken) === ((m = window.hpciCards.get(wn)) == null ? void 0 : m.hpciCCNumToken)) {
            Bh(
              wn,
              t("vacvComponents.payment.errors.repeatCC")
            ), p.hpciCardNumberValid = !1, l();
            return;
          }
          i();
        }
      }
    };
  }
  return {
    retreiveIframeURL: o,
    submitHpciIFrame: a,
    checkIfHasHPCIResponse: s,
    initCustomHPCISubmitHandler: r
  };
}
const un = St("aeroplan", () => {
  const e = R(NaN), t = R(NaN), n = R(NaN), o = R(NaN), s = R(NaN), a = R(!1), r = R(!1), i = R(!1), l = R(!1), c = R(!1), u = R(!1);
  function p(I) {
    e.value = I;
  }
  function f(I) {
    t.value = I;
  }
  function m(I) {
    n.value = I;
  }
  function h(I) {
    o.value = I;
  }
  function g(I) {
    s.value = I;
  }
  function _(I) {
    a.value = I;
  }
  function v(I) {
    r.value = I;
  }
  function w(I) {
    i.value = I;
  }
  function y(I) {
    l.value = I;
  }
  function $(I) {
    c.value = I;
  }
  function S(I) {
    u.value = I;
  }
  function A() {
    e.value = NaN, t.value = NaN, a.value = !1;
  }
  return {
    pointsToRedeem: e,
    dollarValue: t,
    unitPoint: n,
    dollarPerUnitPoints: o,
    wasDollarPerUnitPoints: s,
    hideCreditCardForm: a,
    controlPoints: r,
    dropDownCheckoutFormExecuted: i,
    dropDownBookingSummaryExecuted: l,
    showAeroPlanPointsDropDown: c,
    showAeroplanRedeem: u,
    setPointsToRedeem: p,
    setDollarValue: f,
    setUnitPoint: m,
    setDollarPerUnitPoints: h,
    setWasDollarPerUnitPoints: g,
    setHideCreditCardForm: _,
    setControlPoints: v,
    setDropDownCheckoutFormExecuted: w,
    setDropDownBookingSummaryExecuted: y,
    setShowAeroPlanPointsDropDown: $,
    setShowAeroplanRedeem: S,
    reset: A
  };
}), rk = { class: "onecard-wrapper" }, ik = {
  key: 0,
  class: "h2style"
}, lk = {
  key: 1,
  class: "cc-amount vacv-form-row vacv-input"
}, ck = { class: "not-vacv-form-item" }, uk = {
  key: 2,
  class: "cc-card-section"
}, pk = { class: "cc-form-name vacv-form-row vacv-input" }, dk = { class: "vacv-form-item wide" }, fk = ["id", "src", "name"], mk = { class: "cc-form-expiration vacv-form-row vacv-input" }, vk = { class: "vacv-form-item medium" }, hk = { class: "cc-address-section" }, gk = {
  key: 0,
  class: "sameaddress-checkbox vacv-checkbox"
}, of = /* @__PURE__ */ K({
  __name: "CreditCard",
  props: {
    creditCardName: {},
    hpciConfig: {},
    lang: {},
    insurancePremium: {}
  },
  setup(e, { expose: t }) {
    const n = e, { t: o, n: s } = Ne({ useScope: "global" }), a = Tt(), { validators: r } = a, {
      isPaymentMethodCreditCard: i,
      isPaymentMethodGiftCard: l,
      amountToPay: c,
      depositAmount: u,
      selectDeposit: p,
      toggle2cc: f,
      sameBillingAddress: m,
      showGiftCardTwoCardError: h,
      card1: g,
      card2: _
    } = Ce(a), v = n.creditCardName === Hn ? g : _, { retreiveIframeURL: w } = Hh(n.hpciConfig, o), y = V(() => f.value || l.value), $ = V(() => !!(n.creditCardName === wn || l.value)), S = V(() => {
      const H = ["required", "isAmountGreaterThanZero"];
      return p.value && u.value != null && u.value > 0 ? (H.push("isAmountLessThanDeposit"), H.push("isAmountNotEqualToDeposit")) : (H.push("isAmountNotEqualToTotal"), H.push("isAmountLessThanTotal")), H.join("|");
    });
    function A(H, oe) {
      Fh(H, oe, n.lang), D(H);
    }
    function I(H) {
      const oe = H.target, U = oe.value;
      if (U.length > 0) {
        let Q = Un(n.lang, U);
        n.insurancePremium && Q < n.insurancePremium && (Q = n.insurancePremium);
        const z = Se(Q, s).replace("$", "");
        g.value.creditCardAmount = z, oe.value = z;
      } else
        g.value.creditCardAmount = "0";
    }
    const D = (H) => {
      const oe = Un(
        n.lang,
        H
      ), U = ap(0, s);
      let Q = 0;
      const z = n.insurancePremium ?? 0;
      p.value && u.value ? z ? (Q = u.value - oe, Q < 0 && (Q = 0), _.value.creditCardAmount = Se(Q, s).replace("$", "")) : oe === u.value ? _.value.creditCardAmount = "0" : tf(oe.toString(), 0, u.value) ? (Q = Math.abs(u.value - oe), _.value.creditCardAmount = Se(Q, s).replace("$", "")) : _.value.creditCardAmount = U : tf(oe.toString(), 0, c.value) ? (Q = Math.abs(c.value - oe), _.value.creditCardAmount = Se(Q, s).replace("$", "")) : _.value.creditCardAmount = U, h.value = !1;
    }, O = (H, oe) => {
      const U = H.replace(/[^\d-]/g, "").replace(/-+/g, "-").replace(/^([2-9]|1-)$/, "0$1").replace(/^(\d{2})(\d)$/, "$1-$2");
      U !== H && oe.input(U);
    }, { hideCreditCardForm: x } = Ce(un()), F = V(() => !x.value && i.value), P = V(() => n.creditCardName === wn ? !m.value : !0), {
      isAmountGreaterThanZero: E,
      isAmountLessThanTotal: B,
      isAmountLessThanDeposit: N,
      isAmountNotEqualToTotal: Y,
      isAmountNotEqualToDeposit: j
    } = r, ee = R(), te = () => {
      const H = ee.value;
      H && (H.src = ce());
    };
    function ce() {
      return w(
        v.value.creditCardIframeName,
        v.value.creditCardIframeNumber
      );
    }
    return t({
      resetIFrame: te
    }), (H, oe) => {
      const U = ut("FormKit");
      return b(), C("div", rk, [
        T(f) ? (b(), C("h3", ik, k(H.$t("vacvComponents.payment.labels.creditCard")) + " " + k(T(v).creditCardIframeNumber), 1)) : M("", !0),
        y.value ? (b(), C("div", lk, [
          d("div", ck, [
            $.value ? (b(), ie(U, {
              key: 0,
              type: "text",
              name: H.creditCardName + "-cc-amount-card",
              id: H.creditCardName + "-cc-amount-card",
              label: H.$t("vacvComponents.payment.labels.creditCardAmount") + "*",
              "wrapper-class": "vacv-form-item narrow",
              disabled: "true",
              modelValue: T(v).creditCardAmount,
              "onUpdate:modelValue": oe[0] || (oe[0] = (Q) => T(v).creditCardAmount = Q)
            }, null, 8, ["name", "id", "label", "modelValue"])) : (b(), ie(U, {
              key: 1,
              type: "text",
              name: H.creditCardName + "-cc-amount-card",
              id: H.creditCardName + "-cc-amount-card",
              label: H.$t("vacvComponents.payment.labels.creditCardAmount") + "*",
              "wrapper-class": "vacv-form-item narrow",
              validation: S.value,
              "validation-rules": {
                isAmountGreaterThanZero: T(E),
                isAmountLessThanTotal: T(B),
                isAmountLessThanDeposit: T(N),
                isAmountNotEqualToTotal: T(Y),
                isAmountNotEqualToDeposit: T(j)
              },
              "validation-messages": {
                matches: H.$t("vacvComponents.payment.errors.ccAmountValueTypeError"),
                isAmountGreaterThanZero: H.$t(
                  "vacvComponents.payment.errors.ccAmountZero"
                ),
                isAmountLessThanTotal: H.$t(
                  "vacvComponents.payment.errors.ccAmountTooHighFull"
                ),
                isAmountLessThanDeposit: H.$t(
                  "vacvComponents.payment.errors.ccAmountTooHighDeposit"
                ),
                isAmountNotEqualToTotal: H.$t(
                  "vacvComponents.payment.errors.ccAmountEqualToTotal"
                ),
                isAmountNotEqualToDeposit: H.$t(
                  "vacvComponents.payment.errors.ccAmountEqualToTotal"
                )
              },
              modelValue: T(v).creditCardAmount,
              "onUpdate:modelValue": oe[1] || (oe[1] = (Q) => T(v).creditCardAmount = Q),
              onInput: A,
              onBlur: I,
              autocomplete: "off"
            }, null, 8, ["name", "id", "label", "validation", "validation-rules", "validation-messages", "modelValue"]))
          ])
        ])) : M("", !0),
        F.value ? (b(), C("div", uk, [
          d("div", pk, [
            d("div", dk, [
              q(U, {
                type: "text",
                name: H.creditCardName + "-cc-name",
                id: H.creditCardName + "-cc-name",
                label: H.$t("vacvComponents.payment.labels.creditCardName") + "*",
                validation: `required|length:0,60|matches:${T(tu).personName}`,
                "validation-messages": {
                  required: H.$t("vacvComponents.payment.errors.pleaseEnterCCName"),
                  length: H.$t("vacvComponents.payment.errors.maxCharsAccepted", {
                    max: 60
                  }),
                  matches: H.$t("vacvComponents.payment.errors.ccNameWrongFormat")
                },
                modelValue: T(v).creditCardName,
                "onUpdate:modelValue": oe[2] || (oe[2] = (Q) => T(v).creditCardName = Q)
              }, null, 8, ["name", "id", "label", "validation", "validation-messages", "modelValue"])
            ])
          ]),
          d("iframe", {
            ref_key: "hpciIframe",
            ref: ee,
            title: "Credit Card Payment",
            id: T(v).creditCardIframeName,
            src: ce(),
            name: T(v).creditCardIframeName,
            onload: "receiveHPCIMsg()",
            style: { border: "0px", width: "100%" }
          }, k(H.$t("vacvComponents.payment.errors.notSupportedIframe")), 9, fk),
          d("div", mk, [
            d("div", vk, [
              q(U, {
                type: "text",
                name: H.creditCardName + "-cc-expiry",
                id: H.creditCardName + "-cc-expiry",
                placeholder: "MM-YY",
                maxlength: "5",
                onInput: O,
                label: H.$t("vacvComponents.payment.labels.creditCardExpiry") + "*",
                validation: [
                  ["required"],
                  ["date_format", "MM-YY"],
                  ["monthBetween", ...T(kD)()]
                ],
                "validation-messages": {
                  required: H.$t(
                    "vacvComponents.payment.errors.pleaseEnterCCExpiryDate"
                  ),
                  date_format: H.$t(
                    "vacvComponents.payment.errors.expirationWrongFormat"
                  ),
                  monthBetween: H.$t(
                    "vacvComponents.payment.errors.expirationPastDate"
                  )
                },
                modelValue: T(v).creditCardExpiry,
                "onUpdate:modelValue": oe[3] || (oe[3] = (Q) => T(v).creditCardExpiry = Q)
              }, null, 8, ["name", "id", "label", "validation", "validation-messages", "modelValue"])
            ])
          ])
        ])) : M("", !0),
        d("div", hk, [
          d("h3", null, k(H.$t("vacvComponents.payment.labels.creditCardAddressTitle")), 1),
          H.creditCardName === "ccframe2" ? (b(), C("div", gk, [
            q(U, {
              name: "sameAddress",
              type: "checkbox",
              "aria-checked": T(m) ? "true" : "false",
              label: H.$t("vacvComponents.payment.labels.sameAddress"),
              "decorator-icon": T(yo),
              modelValue: T(m),
              "onUpdate:modelValue": oe[4] || (oe[4] = (Q) => Pt(m) ? m.value = Q : null)
            }, null, 8, ["aria-checked", "label", "decorator-icon", "modelValue"])
          ])) : M("", !0),
          P.value ? (b(), ie(Rh, {
            key: 1,
            creditCardName: T(v).creditCardIframeName,
            lang: H.lang
          }, null, 8, ["creditCardName", "lang"])) : M("", !0)
        ])
      ]);
    };
  }
}), Cp = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M470.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L192 338.7 425.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg>', On = St("insuranceStore", () => {
  const e = R(null), t = R(null), n = R(!1), o = R([]), s = R({}), a = R(!1), r = R(""), i = R(""), l = R(!1), c = R(!1);
  function u(F) {
    e.value = F, n.value = !1;
  }
  function p(F) {
    t.value = F;
  }
  function f(F) {
    o.value = [], F.forEach((P) => {
      o.value.push(P.dob);
    });
  }
  function m(F) {
    a.value = F;
  }
  function h(F) {
    r.value = F;
  }
  function g(F) {
    i.value = F;
  }
  function _() {
    c.value = !0;
  }
  function v() {
    e.value = null;
  }
  function w() {
    t.value = null;
  }
  function y(F) {
    F && e.value && v(), n.value = F;
  }
  function $() {
    n.value = !1;
  }
  function S() {
    s.value = {};
  }
  function A() {
    l.value = !0;
  }
  function I() {
    v(), w(), o.value = [], f([]), $(), S(), g(""), h(""), m(!1), l.value = !1, c.value = !1;
  }
  const D = (F) => {
    F.forEach((P) => {
      P.inclusions.forEach((E) => {
        s.value[E.title] = E.description;
      });
    });
  }, O = V(
    () => {
      var F;
      return ((F = e.value) == null ? void 0 : F.premium) ?? 0;
    }
  ), x = V(
    () => e.value !== null
  );
  return {
    // State
    selectedInsuranceProduct: e,
    declinedTravelInsurance: n,
    insuranceQuoteId: t,
    quotedDOB: o,
    travelInsuranceInclusionsMatrix: s,
    showModalInclusionDetails: a,
    modalTitle: r,
    modalContent: i,
    initialQuoteFailed: l,
    travelInsuranceFailedOnReQuote: c,
    // Actions
    selectTravelInsuranceProduct: u,
    removeInsurance: v,
    declineInsurance: y,
    uncheckDecline: $,
    resetInsuranceStore: I,
    setInsuranceQuoteId: p,
    setQuotedDOB: f,
    populateTravelInsuranceInclusionsMatrix: D,
    setShowModalInclusionDetails: m,
    setModalContent: g,
    setModalTitle: h,
    clearMatrix: S,
    setInitialQuoteFailed: A,
    setFailedOnReQuote: _,
    // Getters
    insurancePremium: O,
    hasSelectedInsuranceProduct: x
  };
}), bk = ["innerHTML"], yk = { class: "giftcard-section" }, $k = { class: "vacv-form-row vacv-input" }, _k = {
  class: "vacv-form-item medium",
  id: "gift-form-number"
}, wk = {
  class: "vacv-form-item narrow",
  id: "gift-form-pin"
}, Ck = /* @__PURE__ */ K({
  __name: "GiftCardForm",
  props: {
    lang: {}
  },
  emits: ["amountBlur"],
  setup(e, { emit: t }) {
    const n = e, o = Tt(), { validators: s } = o, {
      isPaymentMethodCreditCard: a,
      displayedGiftCardAmount: r,
      selectDeposit: i,
      depositAmount: l,
      giftCardAmount: c,
      giftCardNumber: u,
      giftCardPIN: p,
      checkoutHasBeenSubmitted: f,
      giftCardAmountErrorVisible: m,
      insurancePremiumAmount: h,
      amountToPay: g
    } = Ce(o), _ = t, {
      isAmountGreaterThanZero: v,
      isAmountLessThanOrEqualToDeposit: w,
      isAmountLessThanOrEqualToTotal: y,
      isAmountLessThanOrEqualToTotalWithoutInsurancePremium: $,
      isAmountLessThanOrEqualToDepositWithoutInsurancePremium: S,
      isGiftCardAmountSufficient: A,
      isGiftCardDepositSufficient: I
    } = s, { t: D, n: O } = Ne({ useScope: "global" }), x = (j) => {
      const ee = j.target;
      let te = Un(n.lang, ee.value);
      h.value > 0 && (a.value = !0, l.value && te >= l.value - h.value ? (te = l.value - h.value, c.value = te) : te > g.value - h.value && (te = g.value - h.value)), r.value = ap(te, O), f.value = !1, _("amountBlur");
    }, F = (j, ee) => {
      const te = Fh(j, ee, n.lang), ce = Un(n.lang, te);
      c.value = ce;
    }, P = {
      isAmountGreaterThanZero: v,
      isAmountLessThanOrEqualToDeposit: w,
      isAmountLessThanOrEqualToTotal: y,
      isAmountLessThanOrEqualToTotalWithoutInsurancePremium: $,
      isAmountLessThanOrEqualToDepositWithoutInsurancePremium: S,
      isGiftCardAmountSufficient: A,
      isGiftCardDepositSufficient: I
    }, E = {
      matches: D("vacvComponents.payment.errors.ccAmountValueTypeError"),
      isAmountGreaterThanZero: D(
        "vacvComponents.giftCard.errors.giftCardAmountZero"
      ),
      isAmountLessThanOrEqualToDeposit: D(
        "vacvComponents.giftCard.errors.giftCardSplitDeposit"
      ),
      isAmountLessThanOrEqualToTotal: D(
        "vacvComponents.giftCard.errors.giftCardSplitTotal"
      ),
      isAmountLessThanOrEqualToTotalWithoutInsurancePremium: D(
        "vacvComponents.giftCard.errors.giftCardSplitTotalWithoutInsurance"
      ),
      isAmountLessThanOrEqualToDepositWithoutInsurancePremium: D(
        "vacvComponents.giftCard.errors.giftCardLessThanDepositWithoutInsurance"
      ),
      isGiftCardAmountSufficient: D(
        "vacvComponents.giftCard.errors.giftCardInsufficientAmount"
      ),
      isGiftCardDepositSufficient: D(
        "vacvComponents.giftCard.errors.giftCardInsufficientAmount"
      )
    }, B = {
      required: D("vacvComponents.giftCard.errors.giftCardNumber"),
      matches: D("vacvComponents.giftCard.errors.giftCardOnlyNumbers"),
      isValid: D("vacvComponents.payment.errors.ccAmountTooHighFull")
    }, N = {
      required: D("vacvComponents.giftCard.errors.giftCardPIN"),
      matches: D("vacvComponents.giftCard.errors.giftCardOnlyNumbers")
    }, Y = V(() => {
      const j = ["isAmountGreaterThanZero"];
      return i.value && l.value !== null && l.value > 0 ? (a.value || j.push("isGiftCardDepositSufficient"), h.value <= 0 && j.push("isAmountLessThanOrEqualToDeposit")) : (a.value || j.push("isGiftCardAmountSufficient"), h.value <= 0 && j.push("isAmountLessThanOrEqualToTotal")), j.join("|");
    });
    return (j, ee) => {
      const te = ut("FormKit");
      return b(), C($e, null, [
        d("div", {
          class: "giftcard-link",
          innerHTML: j.$t("vacvComponents.giftCard.messages.giftCardCheckAmountLink")
        }, null, 8, bk),
        d("div", yk, [
          d("div", $k, [
            d("div", {
              class: ue({
                "vacv-form-item": !0,
                narrow: !0,
                "hide-errors": !T(m)
              }),
              id: "gift-form-amount"
            }, [
              q(te, {
                type: "text",
                name: "giftcard-amount",
                id: "giftcard-amount",
                label: j.$t("vacvComponents.payment.labels.creditCardAmount") + "*",
                validation: Y.value,
                "validation-rules": P,
                "validation-messages": E,
                "validation-visibility": "blur",
                onInput: F,
                onBlur: ee[0] || (ee[0] = (ce) => x(ce)),
                modelValue: T(r),
                "onUpdate:modelValue": ee[1] || (ee[1] = (ce) => Pt(r) ? r.value = ce : null),
                autocomplete: "off"
              }, null, 8, ["label", "validation", "modelValue"])
            ], 2),
            d("div", _k, [
              q(te, {
                type: "text",
                name: "giftcard-number",
                id: "giftcard-number",
                label: j.$t("vacvComponents.giftCard.labels.giftCardNumber"),
                validation: "required|matches:/^[0-9]+$/",
                "validation-messages": B,
                "validation-visibility": "blur",
                modelValue: T(u),
                "onUpdate:modelValue": ee[2] || (ee[2] = (ce) => Pt(u) ? u.value = ce : null)
              }, null, 8, ["label", "modelValue"])
            ]),
            d("div", wk, [
              q(te, {
                type: "text",
                name: "giftcard-pin",
                id: "giftcard-pin",
                label: j.$t("vacvComponents.giftCard.labels.giftCardPIN"),
                validation: "required|matches:/^[0-9]+$/",
                "validation-messages": N,
                "validation-visibility": "blur",
                modelValue: T(p),
                "onUpdate:modelValue": ee[3] || (ee[3] = (ce) => Pt(p) ? p.value = ce : null)
              }, null, 8, ["label", "modelValue"])
            ])
          ])
        ])
      ], 64);
    };
  }
}), kk = {
  id: "giftcard",
  class: "paddedbox-grey border"
}, Sk = /* @__PURE__ */ K({
  __name: "GiftCardSection",
  props: {
    lang: {}
  },
  emits: ["giftcard-amount-blur", "gift-card-selected"],
  setup(e, { emit: t }) {
    const n = On(), { selectedInsuranceProduct: o, hasSelectedInsuranceProduct: s } = Ce(n), a = Tt(), {
      toggle2cc: r,
      isPaymentMethodGiftCard: i,
      showGiftCardTwoCardError: l,
      amountToPay: c
    } = Ce(a), u = V(
      () => s.value && c.value === o.value.premium
    ), p = V(
      () => !u.value && !r.value
    );
    le(p, (_) => {
      _ || (i.value = !1);
    });
    const f = t;
    function m() {
      f("giftcard-amount-blur");
    }
    function h() {
      rn(() => {
        i.value && f("gift-card-selected");
      });
    }
    function g() {
      !p.value && !u.value && (l.value = !0);
    }
    return (_, v) => {
      const w = ut("FormKit");
      return b(), C("div", kk, [
        d("div", null, [
          d("div", {
            id: "giftcard-checkbox-wrapper",
            class: ue([{ "vacv-checkbox": !0, disabled: !p.value }]),
            onClick: g
          }, [
            q(w, {
              disabled: !p.value,
              id: "giftcard-checkbox",
              name: "paymentMethodGiftCard",
              type: "checkbox",
              label: _.$t("vacvComponents.giftCard.labels.giftCard"),
              "label-class": "h2style",
              "aria-checked": T(i) ? "true" : "false",
              "decorator-icon": T(Cp),
              modelValue: T(i),
              "onUpdate:modelValue": v[0] || (v[0] = (y) => Pt(i) ? i.value = y : null),
              onInput: h
            }, null, 8, ["disabled", "label", "aria-checked", "decorator-icon", "modelValue"])
          ], 2)
        ]),
        T(i) ? (b(), ie(Ck, {
          key: 0,
          lang: _.lang,
          onAmountBlur: m
        }, null, 8, ["lang"])) : M("", !0)
      ]);
    };
  }
});
var Tk = typeof window < "u", Uh = [
  "__key",
  "__init",
  "__shim",
  "__original",
  "__index",
  "__prevKey"
];
function na() {
  return Math.random().toString(36).substring(2, 15);
}
function Ak(e, t) {
  return [...e instanceof Set ? e : new Set(e)];
}
function Ae(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function we(e, t, n = !0, o = ["__key"]) {
  if (e === t)
    return !0;
  if (typeof t == "object" && typeof e == "object") {
    if (e instanceof Map || e instanceof Set)
      return !1;
    if (e instanceof Date && t instanceof Date)
      return e.getTime() === t.getTime();
    if (e instanceof RegExp && t instanceof RegExp)
      return Dk(e, t);
    if (e === null || t === null || Object.keys(e).length !== Object.keys(t).length)
      return !1;
    for (const s of o)
      if ((s in e || s in t) && e[s] !== t[s])
        return !1;
    for (const s in e)
      if (!(s in t) || e[s] !== t[s] && !n || n && !we(e[s], t[s], n, o))
        return !1;
    return !0;
  }
  return !1;
}
function Dk(e, t) {
  return e.source === t.source && e.flags.split("").sort().join("") === t.flags.split("").sort().join("");
}
function Zt(e) {
  const t = typeof e;
  if (t === "number")
    return !1;
  if (e === void 0)
    return !0;
  if (t === "string")
    return e === "";
  if (t === "object") {
    if (e === null)
      return !0;
    for (const n in e)
      return !1;
    return !(e instanceof RegExp || e instanceof Date);
  }
  return !1;
}
function Pk(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function Ik(e) {
  const t = `^${Pk(e)}$`, n = {
    MM: "(0[1-9]|1[012])",
    M: "([1-9]|1[012])",
    DD: "([012][0-9]|3[01])",
    D: "([012]?[0-9]|3[01])",
    YYYY: "\\d{4}",
    YY: "\\d{2}"
  }, o = Object.keys(n);
  return new RegExp(
    o.reduce((s, a) => s.replace(a, n[a]), t)
  );
}
function Zo(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function Ps(e) {
  return Zo(e) || Array.isArray(e);
}
function $o(e) {
  if (Zo(e) === !1 || e.__FKNode__ || e.__POJO__ === !1)
    return !1;
  const t = e.constructor;
  if (t === void 0)
    return !0;
  const n = t.prototype;
  return !(Zo(n) === !1 || n.hasOwnProperty("isPrototypeOf") === !1);
}
var Xn = /* @__NO_SIDE_EFFECTS__ */ (e, t, n = !1, o = !1) => {
  if (t === null)
    return null;
  const s = {};
  if (typeof t == "string")
    return t;
  for (const a in e)
    if (Ae(t, a) && (t[a] !== void 0 || !o)) {
      if (n && Array.isArray(e[a]) && Array.isArray(t[a])) {
        s[a] = e[a].concat(t[a]);
        continue;
      }
      if (t[a] === void 0)
        continue;
      $o(e[a]) && $o(t[a]) ? s[a] = /* @__PURE__ */ Xn(
        e[a],
        t[a],
        n,
        o
      ) : s[a] = t[a];
    } else
      s[a] = e[a];
  for (const a in t)
    !Ae(s, a) && t[a] !== void 0 && (s[a] = t[a]);
  return s;
};
function Ek(e) {
  if (e[0] !== '"' && e[0] !== "'" || e[0] !== e[e.length - 1])
    return !1;
  const t = e[0];
  for (let n = 1; n < e.length; n++)
    if (e[n] === t && (n === 1 || e[n - 1] !== "\\") && n !== e.length - 1)
      return !1;
  return !0;
}
function Ok(e) {
  if (!e.length)
    return "";
  let t = "", n = "";
  for (let o = 0; o < e.length; o++) {
    const s = e.charAt(o);
    (s !== "\\" || n === "\\") && (t += s), n = s;
  }
  return t;
}
function cs(...e) {
  return e.reduce((t, n) => {
    const { value: o, name: s, modelValue: a, config: r, plugins: i, ...l } = n;
    return Object.assign(t, l);
  }, {});
}
function xk(e) {
  const t = [];
  let n = "", o = 0, s = "", a = "";
  for (let r = 0; r < e.length; r++) {
    const i = e.charAt(r);
    i === s && a !== "\\" ? s = "" : (i === "'" || i === '"') && !s && a !== "\\" ? s = i : i === "(" && !s ? o++ : i === ")" && !s && o--, i === "," && !s && o === 0 ? (t.push(n), n = "") : (i !== " " || s) && (n += i), a = i;
  }
  return n && t.push(n), t;
}
function sf(e, t) {
  const n = {}, o = t.filter((a) => a instanceof RegExp), s = new Set(t);
  for (const a in e)
    !s.has(a) && !o.some((r) => r.test(a)) && (n[a] = e[a]);
  return n;
}
function af(e, t) {
  const n = {}, o = t.filter((s) => s instanceof RegExp);
  return t.forEach((s) => {
    s instanceof RegExp || (n[s] = e[s]);
  }), Object.keys(e).forEach((s) => {
    o.some((a) => a.test(s)) && (n[s] = e[s]);
  }), n;
}
function Is(e) {
  return e.replace(
    /-([a-z0-9])/gi,
    (t, n) => n.toUpperCase()
  );
}
function zh(e) {
  return e.replace(
    /([a-z0-9])([A-Z])/g,
    (t, n, o) => n + "-" + o.toLowerCase()
  ).replace(" ", "-").toLowerCase();
}
function ru(e, t = Uh) {
  if (e !== null && typeof e == "object") {
    let n;
    if (Array.isArray(e) ? n = [...e] : $o(e) && (n = { ...e }), n)
      return Lk(e, n, t), n;
  }
  return e;
}
function _o(e, t = Uh) {
  if (e === null || e instanceof RegExp || e instanceof Date || e instanceof Map || e instanceof Set || typeof File == "function" && e instanceof File)
    return e;
  let n;
  Array.isArray(e) ? n = e.map((o) => typeof o == "object" ? _o(o, t) : o) : n = Object.keys(e).reduce((o, s) => (o[s] = typeof e[s] == "object" ? _o(e[s], t) : e[s], o), {});
  for (const o of t)
    o in e && Object.defineProperty(n, o, {
      enumerable: !1,
      value: e[o]
    });
  return n;
}
function jt(e) {
  return typeof e == "object" ? _o(e) : e;
}
function Mk(e, t) {
  if (!e || typeof e != "object")
    return null;
  const n = t.split(".");
  let o = e;
  for (const s in n) {
    const a = n[s];
    if (Ae(o, a) && (o = o[a]), +s === n.length - 1)
      return o;
    if (!o || typeof o != "object")
      return null;
  }
  return null;
}
function _e(e) {
  return e !== void 0 && e !== "false" && e !== !1 ? !0 : void 0;
}
function Bs(e) {
  return Object.isFrozen(e) ? e : Object.defineProperty(e, "__init", {
    enumerable: !1,
    value: !0
  });
}
function kp(e) {
  return e.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]/g, " ").trim().replace(/\s+/g, "-");
}
function Lk(e, t, n) {
  for (const o of n)
    o in e && Object.defineProperty(t, o, {
      enumerable: !1,
      value: e[o]
    });
  return t;
}
function it(e, t, n) {
  if (!Tk)
    return;
  n || (n = document);
  const o = n.getElementById(e);
  if (o)
    return t(o);
  const s = new MutationObserver(() => {
    const a = n == null ? void 0 : n.getElementById(e);
    a && (s == null || s.disconnect(), t(a));
  });
  s.observe(n, { childList: !0, subtree: !0 });
}
function Nk(e) {
  let t = !1;
  return (...n) => {
    if (!t)
      return t = !0, queueMicrotask(() => t = !1), e(...n);
  };
}
function Fk(e) {
  if (!(e === "false" || e === !1))
    return !0;
}
function Sp() {
  const e = [];
  let t = 0;
  const n = (s) => e.push(s), o = (s) => {
    const a = e[t];
    return typeof a == "function" ? a(s, (r) => (t++, o(r))) : (t = 0, s);
  };
  return n.dispatch = o, n.unshift = (s) => e.unshift(s), n.remove = (s) => {
    const a = e.indexOf(s);
    a > -1 && e.splice(a, 1);
  }, n;
}
function Wh() {
  const e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map();
  let n;
  const o = (s, a) => {
    if (n) {
      n.set(a.name, [s, a]);
      return;
    }
    e.has(a.name) && e.get(a.name).forEach((r) => {
      (a.origin === s || r.modifiers.includes("deep")) && r.listener(a);
    }), a.bubble && s.bubble(a);
  };
  return o.flush = () => {
    e.clear(), t.clear(), n == null || n.clear();
  }, o.on = (s, a, r = "push") => {
    const [i, ...l] = s.split("."), c = a.receipt || na(), u = {
      modifiers: l,
      event: i,
      listener: a,
      receipt: c
    };
    return e.has(i) ? e.get(i)[r](u) : e.set(i, [u]), t.has(c) ? t.get(c)[r](i) : t.set(c, [i]), c;
  }, o.off = (s) => {
    var a;
    t.has(s) && ((a = t.get(s)) == null || a.forEach((r) => {
      const i = e.get(r);
      Array.isArray(i) && e.set(
        r,
        i.filter((l) => l.receipt !== s)
      );
    }), t.delete(s));
  }, o.pause = (s) => {
    n || (n = /* @__PURE__ */ new Map()), s && s.walk((a) => a._e.pause());
  }, o.play = (s) => {
    if (!n)
      return;
    const a = n;
    n = void 0, a.forEach(([r, i]) => o(r, i)), s && s.walk((r) => r._e.play());
  }, o;
}
function Rk(e, t, n, o, s = !0, a) {
  return t._e(e, {
    payload: o,
    name: n,
    bubble: s,
    origin: e,
    meta: a
  }), e;
}
function Vk(e, t, n) {
  return ir(e.parent) && e.parent._e(e.parent, n), e;
}
function Bk(e, t, n, o, s) {
  return t._e.on(n, o, s);
}
function Hk(e, t, n) {
  return t._e.off(n), e;
}
var Tp = Sp();
Tp((e, t) => (e.message || (e.message = `E${e.code}`), t(e)));
var Ap = Sp();
Ap((e, t) => {
  e.message || (e.message = `W${e.code}`);
  const n = t(e);
  return console && typeof console.warn == "function" && console.warn(n.message), n;
});
function To(e, t = {}) {
  Ap.dispatch({ code: e, data: t });
}
function Et(e, t = {}) {
  throw Error(Tp.dispatch({ code: e, data: t }).message);
}
function ct(e, t) {
  return {
    blocking: !1,
    key: na(),
    meta: {},
    type: "state",
    visible: !0,
    ...e
  };
}
var rf = {
  apply: Kk,
  set: zk,
  remove: jh,
  filter: jk,
  reduce: qk,
  release: Zk,
  touch: Wk
};
function Uk(e = !1) {
  const t = {};
  let n, o = e, s = [];
  const a = /* @__PURE__ */ new Map();
  let r;
  const i = new Proxy(t, {
    get(...l) {
      const [c, u] = l;
      return u === "buffer" ? o : u === "_b" ? s : u === "_m" ? a : u === "_r" ? r : Ae(rf, u) ? rf[u].bind(
        null,
        t,
        i,
        n
      ) : Reflect.get(...l);
    },
    set(l, c, u) {
      return c === "_n" ? (n = u, r === "__n" && qh(n, i), !0) : c === "_b" ? (s = u, !0) : c === "buffer" ? (o = u, !0) : c === "_r" ? (r = u, !0) : (Et(101, n), !1);
    }
  });
  return i;
}
function zk(e, t, n, o) {
  if (t.buffer)
    return t._b.push([[o]]), t;
  if (e[o.key] !== o) {
    if (typeof o.value == "string" && o.meta.localize !== !1) {
      const a = o.value;
      o.value = n.t(o), o.value !== a && (o.meta.locale = n.props.locale);
    }
    const s = `message-${Ae(e, o.key) ? "updated" : "added"}`;
    e[o.key] = Object.freeze(
      n.hook.message.dispatch(o)
    ), n.emit(s, o);
  }
  return t;
}
function Wk(e, t) {
  for (const n in e) {
    const o = { ...e[n] };
    t.set(o);
  }
}
function jh(e, t, n, o) {
  if (Ae(e, o)) {
    const s = e[o];
    delete e[o], n.emit("message-removed", s);
  }
  return t.buffer === !0 && (t._b = t._b.filter((s) => (s[0] = s[0].filter((a) => a.key !== o), s[1] || s[0].length))), t;
}
function jk(e, t, n, o, s) {
  for (const a in e) {
    const r = e[a];
    (!s || r.type === s) && !o(r) && jh(e, t, n, a);
  }
}
function qk(e, t, n, o, s) {
  for (const a in e) {
    const r = e[a];
    s = o(s, r);
  }
  return s;
}
function Kk(e, t, n, o, s) {
  if (Array.isArray(o)) {
    if (t.buffer) {
      t._b.push([o, s]);
      return;
    }
    const a = new Set(
      o.map((r) => (t.set(r), r.key))
    );
    typeof s == "string" ? t.filter(
      (r) => r.type !== s || a.has(r.key)
    ) : typeof s == "function" && t.filter((r) => !s(r) || a.has(r.key));
  } else
    for (const a in o) {
      const r = n.at(a);
      r ? r.store.apply(o[a], s) : Gk(n, t, a, o[a], s);
    }
}
function Yk(e, ...t) {
  const n = `${e.name}-set`, o = (s) => /* @__PURE__ */ ct({
    key: kp(s),
    type: "error",
    value: s,
    meta: { source: n, autoClear: !0 }
  });
  return t.filter((s) => !!s).map((s) => {
    if (typeof s == "string" && (s = [s]), Array.isArray(s))
      return s.map((a) => o(a));
    {
      const a = {};
      for (const r in s)
        Array.isArray(s[r]) ? a[r] = s[r].map(
          (i) => o(i)
        ) : a[r] = [o(s[r])];
      return a;
    }
  });
}
function Gk(e, t, n, o, s) {
  var r;
  const a = t._m;
  a.has(n) || a.set(n, []), t._r || (t._r = qh(e, t)), (r = a.get(n)) == null || r.push([o, s]);
}
function qh(e, t) {
  return e.on(
    "child.deep",
    ({ payload: n }) => {
      t._m.forEach((o, s) => {
        e.at(s) === n && (o.forEach(([a, r]) => {
          n.store.apply(a, r);
        }), t._m.delete(s));
      }), t._m.size === 0 && t._r && (e.off(t._r), t._r = void 0);
    }
  );
}
function Zk(e, t) {
  t.buffer = !1, t._b.forEach(([n, o]) => t.apply(n, o)), t._b = [];
}
function Xk() {
  const e = {};
  let t;
  return {
    count: (...n) => Jk(t, e, ...n),
    init(n) {
      t = n, n.on("message-added.deep", lf(e, 1)), n.on("message-removed.deep", lf(e, -1));
    },
    merge: (n) => cf(t, e, n),
    settled(n) {
      return Ae(e, n) ? e[n].promise : Promise.resolve();
    },
    unmerge: (n) => cf(t, e, n, !0),
    value(n) {
      return Ae(e, n) ? e[n].count : 0;
    }
  };
}
function Jk(e, t, n, o, s = 0) {
  if (o = Qk(o || n), !Ae(t, n)) {
    const a = {
      condition: o,
      count: 0,
      name: n,
      node: e,
      promise: Promise.resolve(),
      resolve: () => {
      }
      // eslint-disable-line @typescript-eslint/no-empty-function
    };
    t[n] = a, s = e.store.reduce(
      (r, i) => r + a.condition(i) * 1,
      s
    ), e.each((r) => {
      r.ledger.count(a.name, a.condition), s += r.ledger.value(a.name);
    });
  }
  return Kh(t[n], s).promise;
}
function Qk(e) {
  return typeof e == "function" ? e : (t) => t.type === e;
}
function Kh(e, t) {
  const n = e.count, o = e.count + t;
  return e.count = o, n === 0 && o !== 0 ? (e.node.emit(`unsettled:${e.name}`, e.count, !1), e.promise = new Promise((s) => e.resolve = s)) : n !== 0 && o === 0 && (e.node.emit(`settled:${e.name}`, e.count, !1), e.resolve()), e.node.emit(`count:${e.name}`, e.count, !1), e;
}
function lf(e, t) {
  return (n) => {
    for (const o in e) {
      const s = e[o];
      s.condition(n.payload) && Kh(s, t);
    }
  };
}
function cf(e, t, n, o = !1) {
  const s = e;
  for (const a in t) {
    const r = t[a].condition;
    o || n.ledger.count(a, r);
    const i = n.ledger.value(a) * (o ? -1 : 1);
    if (e) {
      do
        e.ledger.count(a, r, i), e = e.parent;
      while (e);
      e = s;
    }
  }
}
var Dp = /* @__PURE__ */ new Map(), Kr = /* @__PURE__ */ new Map(), Pp = Wh();
function eS(e) {
  e.props.id && (Dp.set(e.props.id, e), Kr.set(e, e.props.id), Pp(e, {
    payload: e,
    name: e.props.id,
    bubble: !1,
    origin: e
  }));
}
function tS(e) {
  if (Kr.has(e)) {
    const t = Kr.get(e);
    Kr.delete(e), Dp.delete(t), Pp(e, {
      payload: null,
      name: t,
      bubble: !1,
      origin: e
    });
  }
}
function rr(e) {
  return Dp.get(e);
}
function nS(e, t) {
  return Pp.on(e, t);
}
function iu(e, t, n) {
  let o = !0;
  return t in e.config._t ? o = !1 : e.emit(`config:${t}`, n, !1), t in e.props || (e.emit("prop", { prop: t, value: n }), e.emit(`prop:${t}`, n)), o;
}
function oS(e = {}) {
  const t = /* @__PURE__ */ new Set(), n = {
    ...e,
    _add: (s) => t.add(s),
    _rm: (s) => t.delete(s)
  };
  return new Proxy(n, {
    set(s, a, r, i) {
      return typeof a == "string" && t.forEach((l) => iu(l, a, r)), Reflect.set(s, a, r, i);
    }
  });
}
function Yh(e, t) {
  const n = (t || document).getElementById(e);
  if (n instanceof HTMLFormElement) {
    const o = new Event("submit", { cancelable: !0, bubbles: !0 });
    n.dispatchEvent(o);
    return;
  }
  To(151, e);
}
function sS(e) {
  const t = (n) => {
    for (const o in n.store) {
      const s = n.store[o];
      s.type === "error" || s.type === "ui" && o === "incomplete" ? n.store.remove(o) : s.type === "state" && n.store.set({ ...s, value: !1 });
    }
  };
  t(e), e.walk(t);
}
function Gh(e, t) {
  const n = typeof e == "string" ? rr(e) : e;
  if (n) {
    const o = (r) => {
      const i = jt(r.props.initial);
      return i !== void 0 ? i : r.type === "group" ? {} : r.type === "list" ? [] : void 0;
    };
    n._e.pause(n);
    const s = jt(t);
    return t && !Zt(t) && (n.props.initial = Ps(s) ? Bs(s) : s, n.props._init = n.props.initial), n.input(o(n), !1), n.walk((r) => {
      r.type === "list" && r.sync || r.input(o(r), !1);
    }), n.input(
      Zt(s) && s ? s : o(n),
      !1
    ), n.type !== "input" && t && !Zt(t) && Ps(t) && n.walk((r) => {
      r.props.initial = Ps(r.value) ? Bs(r.value) : r.value, r.props._init = r.props.initial;
    }), n._e.play(n), sS(n), n.emit("reset", n), n;
  }
  To(152, e);
}
var aS = {
  delimiter: ".",
  delay: 0,
  locale: "en",
  rootClasses: (e) => ({ [`formkit-${zh(e)}`]: !0 })
}, Zh = Symbol("index"), lu = Symbol("removed"), cu = Symbol("moved"), Xh = Symbol("inserted");
function rS(e) {
  return e.type === "list" && Array.isArray(e._value);
}
function ir(e) {
  return e && typeof e == "object" && e.__FKNode__ === !0;
}
var Yr = (e, t, n) => {
  Et(102, [e, n]);
}, iS = {
  _c: ze(DS, Yr, !1),
  add: ze($S),
  addProps: ze(yS),
  address: ze(IS, Yr, !1),
  at: ze(ES),
  bubble: ze(Vk),
  clearErrors: ze(BS),
  calm: ze(hS),
  config: ze(!1),
  define: ze(bS),
  disturb: ze(vS),
  destroy: ze(gS),
  extend: ze(US),
  hydrate: ze(fS),
  index: ze(AS, TS, !1),
  input: ze(eg),
  each: ze(CS),
  emit: ze(Rk),
  find: ze(xS),
  on: ze(Bk),
  off: ze(Hk),
  parent: ze(!1, _S),
  plugins: ze(!1),
  remove: ze(wS),
  root: ze(LS, Yr, !1),
  reset: ze(RS),
  resetConfig: ze(SS),
  setErrors: ze(VS),
  submit: ze(FS),
  t: ze(NS),
  use: ze(Ip),
  name: ze(PS, !1, !1),
  walk: ze(kS)
};
function lS() {
  return new Map(Object.entries(iS));
}
function ze(e, t, n = !0) {
  return {
    get: e ? (o, s) => n ? (...a) => e(o, s, ...a) : e(o, s) : !1,
    set: t !== void 0 ? t : Yr.bind(null)
  };
}
function cS() {
  const e = /* @__PURE__ */ new Map();
  return new Proxy(e, {
    get(t, n) {
      return e.has(n) || e.set(n, Sp()), e.get(n);
    }
  });
}
var Jh = 0, uS = 0;
function pS(e) {
  var t, n;
  return ((t = e.parent) == null ? void 0 : t.type) === "list" ? Zh : e.name || `${((n = e.props) == null ? void 0 : n.type) || "input"}_${++Jh}`;
}
function Qh(e) {
  return e.type === "group" ? Bs(
    e.value && typeof e.value == "object" && !Array.isArray(e.value) ? e.value : {}
  ) : e.type === "list" ? Bs(Array.isArray(e.value) ? e.value : []) : e.value;
}
function eg(e, t, n, o = !0) {
  return t._value = dS(e, e.hook.input.dispatch(n)), e.emit("input", t._value), e.isCreated && e.type === "input" && we(t._value, t.value) && !e.props.mergeStrategy ? (e.emit("commitRaw", t.value), t.settled) : (t.isSettled && e.disturb(), o ? (t._tmo && clearTimeout(t._tmo), t._tmo = setTimeout(
    ki,
    e.props.delay,
    e,
    t
  )) : ki(e, t), t.settled);
}
function dS(e, t) {
  switch (e.type) {
    case "input":
      break;
    case "group":
      (!t || typeof t != "object") && Et(107, [e, t]);
      break;
    case "list":
      Array.isArray(t) || Et(108, [e, t]);
      break;
  }
  return t;
}
function ki(e, t, n = !0, o = !0) {
  t._value = t.value = e.hook.commit.dispatch(t._value), e.type !== "input" && o && e.hydrate(), e.emit("commitRaw", t.value), e.emit("commit", t.value), n && e.calm();
}
function tg(e, { name: t, value: n, from: o }) {
  if (!Object.isFrozen(e._value)) {
    if (rS(e)) {
      const s = n === lu ? [] : n === cu && typeof o == "number" ? e._value.splice(o, 1) : [n];
      e._value.splice(
        t,
        n === cu || o === Xh ? 0 : 1,
        ...s
      );
      return;
    }
    n !== lu ? e._value[t] = n : delete e._value[t];
  }
}
function fS(e, t) {
  const n = t._value;
  return e.type === "list" && e.sync && mS(e, t), t.children.forEach((o) => {
    if (typeof n == "object")
      if (o.name in n) {
        const s = o.type !== "input" || n[o.name] && typeof n[o.name] == "object" ? Bs(n[o.name]) : n[o.name];
        if (!o.isSettled || (!Ps(s) || o.props.mergeStrategy) && we(s, o._value))
          return;
        o.input(s, !1);
      } else
        (e.type !== "list" || typeof o.name == "number") && tg(t, { name: o.name, value: o.value }), n.__init || (o.type === "group" ? o.input({}, !1) : o.type === "list" ? o.input([], !1) : o.input(void 0, !1));
  }), e;
}
function mS(e, t) {
  const n = e._value;
  if (!Array.isArray(n))
    return;
  const o = [], s = new Set(t.children), a = /* @__PURE__ */ new Map();
  n.forEach((i, l) => {
    if (t.children[l] && t.children[l]._value === i)
      o.push(t.children[l]), s.delete(t.children[l]);
    else {
      o.push(null);
      const c = a.get(i) || [];
      c.push(l), a.set(i, c);
    }
  }), s.size && a.size && s.forEach((i) => {
    if (a.has(i._value)) {
      const l = a.get(i._value), c = l.shift();
      o[c] = i, s.delete(i), l.length || a.delete(i._value);
    }
  });
  const r = [];
  for (a.forEach((i) => {
    r.push(...i);
  }); s.size && r.length; ) {
    const i = s.values().next().value, l = r.shift();
    if (l === void 0)
      break;
    o[l] = i, s.delete(i);
  }
  r.forEach((i, l) => {
    o[i] = qS({ value: l });
  }), s.size && s.forEach((i) => {
    if (!("__FKP" in i)) {
      const l = i._c.parent;
      if (!l || KS(l))
        return;
      l.ledger.unmerge(i), i._c.parent = null, i.destroy();
    }
  }), t.children = o;
}
function vS(e, t) {
  var n;
  return t._d <= 0 && (t.isSettled = !1, e.emit("settled", !1, !1), t.settled = new Promise((o) => {
    t._resolve = o;
  }), e.parent && ((n = e.parent) == null || n.disturb())), t._d++, e;
}
function hS(e, t, n) {
  var o;
  if (n !== void 0 && e.type !== "input") {
    tg(t, n);
    const s = !!(e.config.mergeStrategy && e.config.mergeStrategy[n.name]);
    return ki(e, t, !0, s);
  }
  t._d > 0 && t._d--, t._d === 0 && (t.isSettled = !0, e.emit("settled", !0, !1), e.parent && ((o = e.parent) == null || o.calm({ name: e.name, value: t.value })), t._resolve && t._resolve(t.value));
}
function gS(e, t) {
  e.emit("destroying", e), e.store.filter(() => !1), e.parent && e.parent.remove(e), tS(e), e.emit("destroyed", e), t._e.flush(), t._value = t.value = void 0;
  for (const n in t.context)
    delete t.context[n];
  t.plugins.clear(), t.context = null;
}
function bS(e, t, n) {
  t.type = n.type;
  const o = _o(n);
  e.props.__propDefs = ng(
    e.props.__propDefs ?? [],
    (o == null ? void 0 : o.props) || []
  ), o.props = e.props.__propDefs, t.props.definition = o, t.value = t._value = Qh({
    type: e.type,
    value: t.value
  }), n.forceTypeProp && (e.props.type && (e.props.originalType = e.props.type), t.props.type = n.forceTypeProp), n.family && (t.props.family = n.family), n.features && n.features.forEach((s) => s(e)), n.props && e.addProps(n.props), e.emit("defined", n);
}
function yS(e, t, n) {
  const o = Array.isArray(n) ? n : Object.keys(n), s = Array.isArray(n) ? {} : o.reduce((r, i) => ("default" in n[i] && (r[i] = n[i].default), r), {});
  if (e.props.attrs) {
    const r = { ...e.props.attrs };
    e.props._emit = !1;
    for (const l in r) {
      const c = Is(l);
      o.includes(c) && (e.props[c] = r[l], delete r[l]);
    }
    Array.isArray(n) || o.forEach((l) => {
      "default" in n[l] && e.props[l] === void 0 && (e.props[l] = s[l]);
    });
    const i = jt(t._value);
    e.props.initial = e.type !== "input" ? Bs(i) : i, e.props._emit = !0, e.props.attrs = r;
  }
  const a = ng(e.props.__propDefs ?? [], n);
  return e.props.definition && (e.props.definition.props = a), e.props.__propDefs = a, e.emit("added-props", n), e;
}
function uu(e) {
  return Array.isArray(e) ? e.reduce((t, n) => (t[n] = {}, t), {}) : e;
}
function ng(e, t) {
  return Array.isArray(e) && Array.isArray(t) ? e.concat(t) : Xn(uu(e), uu(t));
}
function $S(e, t, n, o) {
  if (e.type === "input" && Et(100, e), n.parent && n.parent !== e && n.parent.remove(n), !t.children.includes(n)) {
    if (o !== void 0 && e.type === "list") {
      const s = t.children[o];
      s && "__FKP" in s ? (n._c.uid = s.uid, t.children.splice(o, 1, n)) : t.children.splice(o, 0, n), Array.isArray(e.value) && e.value.length < t.children.length && e.disturb().calm({
        name: o,
        value: n.value,
        from: Xh
      });
    } else
      t.children.push(n);
    n.isSettled || e.disturb();
  }
  if (n.parent !== e) {
    if (n.parent = e, n.parent !== e)
      return e.remove(n), n.parent.add(n), e;
  } else
    n.use(e.plugins);
  return ki(e, t, !1), e.ledger.merge(n), e.emit("child", n), e;
}
function _S(e, t, n, o) {
  return ir(o) ? (e.parent && e.parent !== o && e.parent.remove(e), t.parent = o, e.resetConfig(), o.children.includes(e) ? e.use(o.plugins) : o.add(e), !0) : o === null ? (t.parent = null, !0) : !1;
}
function wS(e, t, n) {
  const o = t.children.indexOf(n);
  if (o !== -1) {
    n.isSettled && e.disturb(), t.children.splice(o, 1);
    let s = _e(n.props.preserve), a = n.parent;
    for (; s === void 0 && a; )
      s = _e(a.props.preserve), a = a.parent;
    s ? e.calm() : e.calm({
      name: e.type === "list" ? o : n.name,
      value: lu
    }), n.parent = null, n.config._rmn = n;
  }
  return e.ledger.unmerge(n), e.emit("childRemoved", n), e;
}
function CS(e, t, n) {
  t.children.forEach((o) => !("__FKP" in o) && n(o));
}
function kS(e, t, n, o = !1, s = !1) {
  t.children.some((a) => {
    if ("__FKP" in a)
      return !1;
    const r = n(a);
    return o && r === !1 ? !0 : s && r === !1 ? !1 : a.walk(n, o, s);
  });
}
function SS(e, t) {
  const n = e.parent || void 0;
  t.config = og(e.config._t, n), e.walk((o) => o.resetConfig());
}
function Ip(e, t, n, o = !0, s = !0) {
  return Array.isArray(n) || n instanceof Set ? (n.forEach((a) => Ip(e, t, a)), e) : (t.plugins.has(n) || (s && typeof n.library == "function" && n.library(e), o && n(e) !== !1 && (t.plugins.add(n), e.children.forEach((a) => a.use(n)))), e);
}
function TS(e, t, n, o) {
  if (ir(e.parent)) {
    const s = e.parent.children, a = o >= s.length ? s.length - 1 : o < 0 ? 0 : o, r = s.indexOf(e);
    return r === -1 ? !1 : (s.splice(r, 1), s.splice(a, 0, e), e.parent.children = s, e.parent.type === "list" && e.parent.disturb().calm({ name: a, value: cu, from: r }), !0);
  }
  return !1;
}
function AS(e) {
  if (e.parent) {
    const t = [...e.parent.children].indexOf(e);
    return t === -1 ? e.parent.children.length : t;
  }
  return -1;
}
function DS(e, t) {
  return t;
}
function PS(e, t) {
  var n;
  return ((n = e.parent) == null ? void 0 : n.type) === "list" ? e.index : t.name !== Zh ? t.name : e.index;
}
function IS(e, t) {
  return t.parent ? t.parent.address.concat([e.name]) : [e.name];
}
function ES(e, t, n) {
  const o = typeof n == "string" ? n.split(e.config.delimiter) : n;
  if (!o.length)
    return;
  const s = o[0];
  let a = e.parent;
  for (a || (String(o[0]) === String(e.name) && o.shift(), a = e), s === "$parent" && o.shift(); a && o.length; ) {
    const r = o.shift();
    switch (r) {
      case "$root":
        a = e.root;
        break;
      case "$parent":
        a = a.parent;
        break;
      case "$self":
        a = e;
        break;
      default:
        a = a.children.find(
          (i) => !("__FKP" in i) && String(i.name) === String(r)
        ) || OS(a, r);
    }
  }
  return a || void 0;
}
function OS(e, t) {
  const n = String(t).match(/^(find)\((.*)\)$/);
  if (n) {
    const [, o, s] = n, a = s.split(",").map((r) => r.trim());
    switch (o) {
      case "find":
        return e.find(a[0], a[1]);
      default:
        return;
    }
  }
}
function xS(e, t, n, o) {
  return MS(e, n, o);
}
function MS(e, t, n = "name") {
  const o = typeof n == "string" ? (a) => a[n] == t : n, s = [e];
  for (; s.length; ) {
    const a = s.shift();
    if (!("__FKP" in a)) {
      if (o(a, t))
        return a;
      s.push(...a.children);
    }
  }
}
function LS(e) {
  let t = e;
  for (; t.parent; )
    t = t.parent;
  return t;
}
function og(e = {}, t) {
  let n;
  return new Proxy(e, {
    get(...o) {
      const s = o[1];
      if (s === "_t")
        return e;
      const a = Reflect.get(...o);
      if (a !== void 0)
        return a;
      if (t) {
        const r = t.config[s];
        if (r !== void 0)
          return r;
      }
      if (e.rootConfig && typeof s == "string") {
        const r = e.rootConfig[s];
        if (r !== void 0)
          return r;
      }
      return s === "delay" && (n == null ? void 0 : n.type) === "input" ? 20 : aS[s];
    },
    set(...o) {
      const s = o[1], a = o[2];
      if (s === "_n")
        return n = a, e.rootConfig && e.rootConfig._add(n), !0;
      if (s === "_rmn")
        return e.rootConfig && e.rootConfig._rm(n), n = void 0, !0;
      if (!we(e[s], a, !1)) {
        const r = Reflect.set(...o);
        return n && (n.emit(`config:${s}`, a, !1), iu(n, s, a), n.walk((i) => iu(i, s, a), !1, !0)), r;
      }
      return !0;
    }
  });
}
function NS(e, t, n, o = "ui") {
  const s = typeof n == "string" ? { key: n, value: n, type: o } : n, a = e.hook.text.dispatch(s);
  return e.emit("text", a, !1), a.value;
}
function FS(e) {
  const t = e.name;
  do {
    if (e.props.isForm === !0)
      break;
    e.parent || Et(106, t), e = e.parent;
  } while (e);
  e.props.id && Yh(e.props.id, e.props.__root);
}
function RS(e, t, n) {
  return Gh(e, n);
}
function VS(e, t, n, o) {
  const s = `${e.name}-set`, a = e.hook.setErrors.dispatch({ localErrors: n, childErrors: o });
  return Yk(e, a.localErrors, a.childErrors).forEach(
    (r) => {
      e.store.apply(r, (i) => i.meta.source === s);
    }
  ), e;
}
function BS(e, t, n = !0, o) {
  return e.store.filter((s) => !(o === void 0 || s.meta.source === o), "error"), n && (o = o || `${e.name}-set`, e.walk((s) => {
    s.store.filter((a) => !(a.type === "error" && a.meta && a.meta.source === o));
  })), e;
}
function HS(e) {
  const t = {
    initial: typeof e == "object" ? jt(e) : e
  };
  let n, o = !0, s = {};
  return new Proxy(t, {
    get(...a) {
      var u, p, f, m;
      const [r, i] = a;
      let l;
      Ae(t, i) ? (l = Reflect.get(...a), (u = s[i]) != null && u.boolean && (l = Fk(l))) : n && typeof i == "string" && n.config[i] !== void 0 ? (l = n.config[i], i === "mergeStrategy" && (n == null ? void 0 : n.type) === "input" && Zo(l) && n.name in l && (l = l[n.name])) : l = (p = s[i]) == null ? void 0 : p.default;
      const c = (f = s[i]) == null ? void 0 : f.getter;
      return (m = s[i]) != null && m.boolean && (l = !!l), c ? c(l, n) : l;
    },
    set(a, r, i, l) {
      var f;
      if (r === "_n")
        return n = i, !0;
      if (r === "_emit")
        return o = i, !0;
      let { prop: c, value: u } = n.hook.prop.dispatch({
        prop: r,
        value: i
      });
      const p = (f = s[c]) == null ? void 0 : f.setter;
      if (u = p ? p(u, n) : u, !we(t[c], u, !1) || typeof u == "object") {
        const m = Reflect.set(a, c, u, l);
        return c === "__propDefs" && (s = uu(u)), o && (n.emit("prop", { prop: c, value: u }), typeof c == "string" && n.emit(`prop:${c}`, u)), m;
      }
      return !0;
    }
  });
}
function US(e, t, n, o) {
  return t.traps.set(n, o), e;
}
function zS(e, t) {
  if (e.props.definition)
    return e.define(e.props.definition);
  for (const n of t) {
    if (e.props.definition)
      return;
    typeof n.library == "function" && n.library(e);
  }
}
function WS(e) {
  const t = Qh(e), n = og(e.config || {}, e.parent);
  return {
    _d: 0,
    _e: Wh(),
    uid: Symbol(),
    _resolve: !1,
    _tmo: !1,
    _value: t,
    children: Ak(e.children || []),
    config: n,
    hook: cS(),
    isCreated: !1,
    isSettled: !0,
    ledger: Xk(),
    name: pS(e),
    parent: e.parent || null,
    plugins: /* @__PURE__ */ new Set(),
    props: HS(t),
    settled: Promise.resolve(t),
    store: Uk(!0),
    sync: e.sync || !1,
    traps: lS(),
    type: e.type || "input",
    value: t
  };
}
function jS(e, t) {
  var o, s;
  const n = (o = t.props) == null ? void 0 : o.id;
  if (n || (s = t.props) == null || delete s.id, e.ledger.init(e.store._n = e.props._n = e.config._n = e), e.props._emit = !1, Object.assign(
    e.props,
    n ? {} : { id: `input_${uS++}` },
    t.props ?? {}
  ), e.props._emit = !0, zS(
    e,
    /* @__PURE__ */ new Set([
      ...t.plugins || [],
      ...e.parent ? e.parent.plugins : []
    ])
  ), t.plugins)
    for (const a of t.plugins)
      Ip(e, e._c, a, !0, !1);
  return e.each((a) => e.add(a)), e.parent && e.parent.add(e, t.index), e.type === "input" && e.children.length && Et(100, e), eg(e, e._c, e._value, !1), e.store.release(), n && eS(e), e.emit("created", e), e.isCreated = !0, e;
}
function qS(e) {
  return {
    __FKP: !0,
    uid: Symbol(),
    name: (e == null ? void 0 : e.name) ?? `p_${Jh++}`,
    value: (e == null ? void 0 : e.value) ?? null,
    _value: (e == null ? void 0 : e.value) ?? null,
    type: (e == null ? void 0 : e.type) ?? "input",
    props: {},
    use: () => {
    },
    input(t) {
      return this._value = t, this.value = t, Promise.resolve();
    },
    isSettled: !0
  };
}
function KS(e) {
  return "__FKP" in e;
}
function YS(e) {
  const t = e || {}, n = WS(t), o = new Proxy(n, {
    get(...s) {
      const [, a] = s;
      if (a === "__FKNode__")
        return !0;
      const r = n.traps.get(a);
      return r && r.get ? r.get(o, n) : Reflect.get(...s);
    },
    set(...s) {
      const [, a, r] = s, i = n.traps.get(a);
      return i && i.set ? i.set(o, n, a, r) : Reflect.set(...s);
    }
  });
  return jS(o, t);
}
function Xo(e) {
  return typeof e != "string" && Ae(e, "$el");
}
function Ga(e) {
  return typeof e != "string" && Ae(e, "$cmp");
}
function bs(e) {
  return !e || typeof e == "string" ? !1 : Ae(e, "if") && Ae(e, "then");
}
function GS(e) {
  return typeof e != "string" && "$formkit" in e;
}
function ZS(e) {
  if (typeof e == "string")
    return {
      $el: "text",
      children: e
    };
  if (GS(e)) {
    const {
      $formkit: t,
      for: n,
      if: o,
      children: s,
      bind: a,
      ...r
    } = e;
    return Object.assign(
      {
        $cmp: "FormKit",
        props: { ...r, type: t }
      },
      o ? { if: o } : {},
      n ? { for: n } : {},
      s ? { children: s } : {},
      a ? { bind: a } : {}
    );
  }
  return e;
}
function nn(e) {
  let t;
  const n = /* @__PURE__ */ new Set(), o = function(_, v) {
    return typeof _ == "function" ? _(v) : _;
  }, s = [
    {
      "&&": (g, _, v) => o(g, v) && o(_, v),
      "||": (g, _, v) => o(g, v) || o(_, v)
    },
    {
      "===": (g, _, v) => o(g, v) === o(_, v),
      "!==": (g, _, v) => o(g, v) !== o(_, v),
      "==": (g, _, v) => o(g, v) == o(_, v),
      "!=": (g, _, v) => o(g, v) != o(_, v),
      ">=": (g, _, v) => o(g, v) >= o(_, v),
      "<=": (g, _, v) => o(g, v) <= o(_, v),
      ">": (g, _, v) => o(g, v) > o(_, v),
      "<": (g, _, v) => o(g, v) < o(_, v)
    },
    {
      "+": (g, _, v) => o(g, v) + o(_, v),
      "-": (g, _, v) => o(g, v) - o(_, v)
    },
    {
      "*": (g, _, v) => o(g, v) * o(_, v),
      "/": (g, _, v) => o(g, v) / o(_, v),
      "%": (g, _, v) => o(g, v) % o(_, v)
    }
  ], a = s.reduce((g, _) => g.concat(Object.keys(_)), []), r = new Set(a.map((g) => g.charAt(0)));
  function i(g, _, v, w) {
    const y = g.filter(($) => $.startsWith(_));
    return y.length ? y.find(($) => w.length >= v + $.length && w.substring(v, v + $.length) === $ ? $ : !1) : !1;
  }
  function l(g, _, v = 1) {
    let w = v ? _.substring(g + 1).trim() : _.substring(0, g).trim();
    if (!w.length)
      return -1;
    if (!v) {
      const $ = w.split("").reverse(), S = $.findIndex((A) => r.has(A));
      w = $.slice(S).join("");
    }
    const y = w[0];
    return s.findIndex(($) => {
      const S = Object.keys($);
      return !!i(S, y, 0, w);
    });
  }
  function c(g, _) {
    let v = "";
    const w = _.length;
    let y = 0;
    for (let $ = g; $ < w; $++) {
      const S = _.charAt($);
      if (S === "(")
        y++;
      else if (S === ")")
        y--;
      else if (y === 0 && S === " ")
        continue;
      if (y === 0 && i(a, S, $, _))
        return [v, $ - 1];
      v += S;
    }
    return [v, _.length - 1];
  }
  function u(g, _ = 0) {
    const v = s[_], w = g.length, y = Object.keys(v);
    let $ = 0, S = !1, A = null, I = "", D = null, O, x = "", F = "", P = "", E = "", B = 0;
    const N = (Y, j) => {
      Y ? P += j : I += j;
    };
    for (let Y = 0; Y < w; Y++)
      if (x = F, F = g.charAt(Y), (F === "'" || F === '"') && x !== "\\" && ($ === 0 && !S || $ && !E)) {
        $ ? E = F : S = F, N($, F);
        continue;
      } else if (S && (F !== S || x === "\\") || E && (F !== E || x === "\\")) {
        N($, F);
        continue;
      } else if (S === F) {
        S = !1, N($, F);
        continue;
      } else if (E === F) {
        E = !1, N($, F);
        continue;
      } else {
        if (F === " ")
          continue;
        if (F === "(")
          $ === 0 ? B = Y : P += F, $++;
        else if (F === ")")
          if ($--, $ === 0) {
            const j = typeof I == "string" && I.startsWith("$") ? I : void 0, ee = j && g.charAt(Y + 1) === ".";
            let te = "";
            ee && ([te, Y] = c(Y + 2, g));
            const ce = A ? _ : l(B, g, 0), H = l(Y, g);
            ce === -1 && H === -1 ? (I = p(P, -1, j, te), typeof I == "string" && (I = P)) : A && (ce >= H || H === -1) && _ === ce ? (D = A.bind(null, p(P, -1, j, te)), A = null, I = "") : H > ce && _ === H ? I = p(P, -1, j, te) : I += `(${P})${ee ? `.${te}` : ""}`, P = "";
          } else
            P += F;
        else if ($ === 0 && (O = i(y, F, Y, g))) {
          Y === 0 && Et(103, [O, g]), Y += O.length - 1, Y === g.length - 1 && Et(104, [O, g]), A ? I && (D = A.bind(null, p(I, _)), A = v[O].bind(null, D), I = "") : D ? (A = v[O].bind(null, p(D, _)), D = null) : (A = v[O].bind(null, p(I, _)), I = "");
          continue;
        } else
          N($, F);
      }
    return I && A && (A = A.bind(null, p(I, _))), A = !A && D ? D : A, !A && I && (A = (Y, j) => typeof Y == "function" ? Y(j) : Y, A = A.bind(null, p(I, _))), !A && !I && Et(105, g), A;
  }
  function p(g, _, v, w) {
    if (v) {
      const y = p(v, s.length);
      let $, S = w ? nn(`$${w}`) : !1;
      if (typeof y == "function") {
        const A = xk(String(g)).map(
          (I) => p(I, -1)
        );
        return (I) => {
          const D = y(I);
          return typeof D != "function" ? (To(150, v), D) : ($ = D(
            ...A.map(
              (O) => typeof O == "function" ? O(I) : O
            )
          ), S && (S = S.provide((O) => {
            const x = t(O);
            return O.reduce(
              (P, E) => {
                if (E === w || (w == null ? void 0 : w.startsWith(`${E}(`))) {
                  const N = Mk($, E);
                  P[E] = () => N;
                } else
                  P[E] = x[E];
                return P;
              },
              {}
            );
          })), S ? S() : $);
        };
      }
    } else if (typeof g == "string") {
      if (g === "true")
        return !0;
      if (g === "false")
        return !1;
      if (g === "undefined")
        return;
      if (Ek(g))
        return Ok(g.substring(1, g.length - 1));
      if (!isNaN(+g))
        return Number(g);
      if (_ < s.length - 1)
        return u(g, _ + 1);
      if (g.startsWith("$")) {
        const y = g.substring(1);
        return n.add(y), function(S) {
          return y in S ? S[y]() : void 0;
        };
      }
      return g;
    }
    return g;
  }
  const f = u(
    e.startsWith("$:") ? e.substring(2) : e
  ), m = Array.from(n);
  function h(g) {
    return t = g, Object.assign(
      // @ts-ignore - @rollup/plugin-typescript doesn't like this
      f.bind(null, g(m)),
      { provide: h }
    );
  }
  return Object.assign(f, {
    provide: h
  });
}
function Gr(e, t, n) {
  return n ? typeof n == "string" ? n.split(" ").reduce(
    (s, a) => Object.assign(s, { [a]: !0 }),
    {}
  ) : typeof n == "function" ? Gr(
    e,
    t,
    n(t, e)
  ) : n : {};
}
function XS(e, t, ...n) {
  const o = n.reduce((s, a) => {
    if (!a)
      return Jl(s);
    const { $reset: r, ...i } = a;
    return Jl(r ? i : Object.assign(s, i));
  }, {});
  return Object.keys(
    e.hook.classes.dispatch({ property: t, classes: o }).classes
  ).filter((s) => o[s]).join(" ") || null;
}
function Jl(e) {
  const t = "$remove:";
  let n = !1;
  const o = Object.keys(e).filter((s) => (e[s] && s.startsWith(t) && (n = !0), e[s]));
  return o.length > 1 && n && o.filter((a) => a.startsWith(t)).map((a) => {
    const r = a.substring(t.length);
    e[r] = !1, e[a] = !1;
  }), e;
}
function JS(e, t, n) {
  const o = rr(e);
  o ? o.setErrors(t, n) : To(651, e);
}
function QS(e, t = !0) {
  const n = rr(e);
  n ? n.clearErrors(t) : To(652, e);
}
var Si = "1.6.9", sg = /* @__PURE__ */ new WeakSet();
function pl(e, t) {
  const n = t || Object.assign(/* @__PURE__ */ new Map(), { active: !1 }), o = /* @__PURE__ */ new Map(), s = function(u) {
    var p;
    n.active && (n.has(e) || n.set(e, /* @__PURE__ */ new Set()), (p = n.get(e)) == null || p.add(u));
  }, a = function(u) {
    return new Proxy(u, {
      get(...p) {
        return typeof p[1] == "string" && s(`prop:${p[1]}`), Reflect.get(...p);
      }
    });
  }, r = function(u) {
    return new Proxy(u, {
      get(...p) {
        return p[1] === "value" ? (f) => (s(`count:${f}`), u.value(f)) : Reflect.get(...p);
      }
    });
  }, i = function(u, p) {
    return ir(u) ? pl(u, n) : (p === "value" && s("commit"), p === "_value" && s("input"), p === "props" ? a(u) : p === "ledger" ? r(u) : (p === "children" && (s("child"), s("childRemoved")), u));
  }, {
    proxy: l,
    revoke: c
  } = Proxy.revocable(e, {
    get(...u) {
      switch (u[1]) {
        case "_node":
          return e;
        case "deps":
          return n;
        case "watch":
          return (f, m, h) => ig(l, f, m, h);
        case "observe":
          return () => {
            const f = new Map(n);
            return n.clear(), n.active = !0, f;
          };
        case "stopObserve":
          return () => {
            const f = new Map(n);
            return n.active = !1, f;
          };
        case "receipts":
          return o;
        case "kill":
          return () => {
            rg(o), sg.add(u[2]), c();
          };
      }
      const p = Reflect.get(...u);
      return typeof p == "function" ? (...f) => {
        const m = p(...f);
        return i(m, u[1]);
      } : i(p, u[1]);
    }
  });
  return l;
}
function ag(e, [t, n], o, s) {
  t.forEach((a, r) => {
    a.forEach((i) => {
      e.receipts.has(r) || e.receipts.set(r, {});
      const l = e.receipts.get(r) ?? {};
      l[i] = l[i] ?? [], l[i].push(r.on(i, o, s)), e.receipts.set(r, l);
    });
  }), n.forEach((a, r) => {
    a.forEach((i) => {
      if (e.receipts.has(r)) {
        const l = e.receipts.get(r);
        l && Ae(l, i) && (l[i].map(r.off), delete l[i], e.receipts.set(r, l));
      }
    });
  });
}
function rg(e) {
  e.forEach((t, n) => {
    for (const o in t)
      t[o].map(n.off);
  }), e.clear();
}
function ig(e, t, n, o) {
  const s = (i) => {
    const l = e.stopObserve();
    ag(
      e,
      lg(a, l),
      () => ig(e, t, n, o),
      o
    ), n && n(i);
  }, a = new Map(e.deps);
  e.observe();
  const r = t(e);
  r instanceof Promise ? r.then((i) => s(i)) : s(r);
}
function lg(e, t) {
  const n = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map();
  return t.forEach((s, a) => {
    if (!e.has(a))
      n.set(a, s);
    else {
      const r = /* @__PURE__ */ new Set(), i = e.get(a);
      s.forEach(
        (l) => !(i != null && i.has(l)) && r.add(l)
      ), n.set(a, r);
    }
  }), e.forEach((s, a) => {
    if (!t.has(a))
      o.set(a, s);
    else {
      const r = /* @__PURE__ */ new Set(), i = t.get(a);
      s.forEach(
        (l) => !(i != null && i.has(l)) && r.add(l)
      ), o.set(a, r);
    }
  }), [n, o];
}
function Ep(e) {
  return sg.has(e);
}
var cg = function({ value: t }) {
  return ["yes", "on", "1", 1, !0, "true"].includes(t);
};
cg.skipEmpty = !1;
var eT = cg, tT = function({ value: e }, t = !1) {
  const n = Date.parse(t || /* @__PURE__ */ new Date()), o = Date.parse(String(e));
  return isNaN(o) ? !1 : o > n;
}, nT = tT, oT = function({ value: e }, t = !1) {
  const n = Date.parse(t || /* @__PURE__ */ new Date()), o = Date.parse(String(e));
  return isNaN(o) ? !1 : o > n || o === n;
}, sT = oT, aT = function(e, t) {
  var s;
  if (!t)
    return !1;
  const n = Date.parse(String(e.value)), o = Date.parse(String((s = e.at(t)) == null ? void 0 : s.value));
  return isNaN(o) ? !0 : isNaN(n) ? !1 : n > o;
}, rT = aT, iT = function({ value: e }, t = "default") {
  const n = {
    default: new RegExp("^\\p{L}+$", "u"),
    latin: /^[a-z]+$/i
  }, o = Ae(n, t) ? t : "default";
  return n[o].test(String(e));
}, lT = iT, cT = function({ value: e }, t = "default") {
  const n = {
    default: /^[\p{L} ]+$/u,
    latin: /^[a-z ]+$/i
  }, o = Ae(n, t) ? t : "default";
  return n[o].test(String(e));
}, uT = cT, pT = function({ value: e }, t = "default") {
  const n = {
    default: /^[0-9\p{L}]+$/u,
    latin: /^[0-9a-z]+$/i
  }, o = Ae(n, t) ? t : "default";
  return n[o].test(String(e));
}, dT = pT, fT = function({ value: e }, t = !1) {
  const n = Date.parse(t || /* @__PURE__ */ new Date()), o = Date.parse(String(e));
  return isNaN(o) ? !1 : o < n;
}, mT = fT, vT = function(e, t) {
  var s;
  if (!t)
    return !1;
  const n = Date.parse(String(e.value)), o = Date.parse(String((s = e.at(t)) == null ? void 0 : s.value));
  return isNaN(o) ? !0 : isNaN(n) ? !1 : n < o;
}, hT = vT, gT = function({ value: e }, t = !1) {
  const n = Date.parse(t || /* @__PURE__ */ new Date()), o = Date.parse(String(e));
  return isNaN(o) ? !1 : o < n || o === n;
}, bT = gT, yT = function({ value: t }, n, o) {
  if (!isNaN(t) && !isNaN(n) && !isNaN(o)) {
    const s = 1 * t;
    n = Number(n), o = Number(o);
    const [a, r] = n <= o ? [n, o] : [o, n];
    return s >= 1 * a && s <= 1 * r;
  }
  return !1;
}, $T = yT, uf = /(_confirm(?:ed)?)$/, _T = function(t, n, o = "loose") {
  var a;
  n || (n = uf.test(t.name) ? t.name.replace(uf, "") : `${t.name}_confirm`);
  const s = (a = t.at(n)) == null ? void 0 : a.value;
  return o === "strict" ? t.value === s : t.value == s;
}, wT = _T, CT = function({ value: e }, t = "default") {
  const n = {
    default: new RegExp("\\p{L}", "u"),
    latin: /[a-z]/i
  }, o = Ae(n, t) ? t : "default";
  return n[o].test(String(e));
}, kT = CT, ST = function({ value: e }, t = "default") {
  const n = {
    default: /[\p{L} ]/u,
    latin: /[a-z ]/i
  }, o = Ae(n, t) ? t : "default";
  return n[o].test(String(e));
}, TT = ST, AT = function({ value: e }, t = "default") {
  const n = {
    default: /[0-9\p{L}]/u,
    latin: /[0-9a-z]/i
  }, o = Ae(n, t) ? t : "default";
  return n[o].test(String(e));
}, DT = AT, PT = function({ value: e }, t = "default") {
  const n = {
    default: new RegExp("\\p{Ll}", "u"),
    latin: /[a-z]/
  }, o = Ae(n, t) ? t : "default";
  return n[o].test(String(e));
}, IT = PT, ET = function({ value: t }) {
  return /[0-9]/.test(String(t));
}, OT = ET, xT = function({ value: e }) {
  return /[!-/:-@[-`{-~]/.test(String(e));
}, MT = xT, LT = function({ value: e }, t = "default") {
  const n = {
    default: new RegExp("\\p{Lu}", "u"),
    latin: /[A-Z]/
  }, o = Ae(n, t) ? t : "default";
  return n[o].test(String(e));
}, NT = LT, FT = function({ value: t }, n, o) {
  n = n instanceof Date ? n.getTime() : Date.parse(n), o = o instanceof Date ? o.getTime() : Date.parse(o);
  const s = t instanceof Date ? t.getTime() : Date.parse(String(t));
  if (n && !o)
    o = n, n = Date.now();
  else if (!n || !s)
    return !1;
  return s >= n && s <= o;
}, RT = FT, VT = function({ value: t }, n) {
  return n && typeof n == "string" ? Ik(n).test(String(t)) : !isNaN(Date.parse(String(t)));
}, BT = VT, HT = function({ value: t }) {
  return /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(String(t));
}, UT = HT, zT = function({ value: t }, ...n) {
  return typeof t == "string" && n.length ? n.some((o) => t.endsWith(o)) : typeof t == "string" && n.length === 0;
}, WT = zT, jT = function({ value: t }, ...n) {
  return n.some((o) => typeof o == "object" ? we(o, t) : o == t);
}, qT = jT, KT = function({ value: t }, n = 0, o = 1 / 0) {
  n = parseInt(n), o = isNaN(parseInt(o)) ? 1 / 0 : parseInt(o);
  const s = n <= o ? n : o, a = o >= n ? o : n;
  if (typeof t == "string" || Array.isArray(t))
    return t.length >= s && t.length <= a;
  if (t && typeof t == "object") {
    const r = Object.keys(t).length;
    return r >= s && r <= a;
  }
  return !1;
}, YT = KT, GT = function({ value: e }, t = "default") {
  const n = {
    default: new RegExp("^\\p{Ll}+$", "u"),
    allow_non_alpha: /^[0-9\p{Ll}!-/:-@[-`{-~]+$/u,
    allow_numeric: /^[0-9\p{Ll}]+$/u,
    allow_numeric_dashes: /^[0-9\p{Ll}-]+$/u,
    latin: /^[a-z]+$/
  }, o = Ae(n, t) ? t : "default";
  return n[o].test(String(e));
}, ZT = GT, XT = function({ value: t }, ...n) {
  return n.some((o) => (typeof o == "string" && o.substr(0, 1) === "/" && o.substr(-1) === "/" && (o = new RegExp(o.substr(1, o.length - 2))), o instanceof RegExp ? o.test(String(t)) : o === t));
}, JT = XT, QT = function({ value: t }, n = 10) {
  return Array.isArray(t) ? t.length <= n : Number(t) <= Number(n);
}, eA = QT, tA = function({ value: t }, n = 1) {
  return Array.isArray(t) ? t.length >= n : Number(t) >= Number(n);
}, nA = tA, oA = function({ value: t }, ...n) {
  return !n.some((o) => typeof o == "object" ? we(o, t) : o === t);
}, sA = oA, aA = function({ value: t }) {
  return !isNaN(t);
}, rA = aA, ug = function(e, ...t) {
  return Zt(e.value) ? t.map((o) => {
    var s;
    return (s = e.at(o)) == null ? void 0 : s.value;
  }).some((o) => !Zt(o)) : !0;
};
ug.skipEmpty = !1;
var iA = ug, pg = function({ value: t }, n = "default") {
  return n === "trim" && typeof t == "string" ? !Zt(t.trim()) : !Zt(t);
};
pg.skipEmpty = !1;
var lA = pg, cA = function({ value: t }, ...n) {
  return typeof t == "string" && n.length ? n.some((o) => t.startsWith(o)) : typeof t == "string" && n.length === 0;
}, uA = cA, pA = function({ value: e }) {
  return /^[!-/:-@[-`{-~]+$/.test(String(e));
}, dA = pA, fA = function({ value: e }, t = "default") {
  const n = {
    default: new RegExp("^\\p{Lu}+$", "u"),
    latin: /^[A-Z]+$/
  }, o = Ae(n, t) ? t : "default";
  return n[o].test(String(e));
}, mA = fA, vA = function({ value: t }, ...n) {
  try {
    const o = n.length ? n : ["http:", "https:"], s = new URL(String(t));
    return o.includes(s.protocol);
  } catch {
    return !1;
  }
}, hA = vA;
const gA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  accepted: eT,
  alpha: lT,
  alpha_spaces: uT,
  alphanumeric: dT,
  between: $T,
  confirm: wT,
  contains_alpha: kT,
  contains_alpha_spaces: TT,
  contains_alphanumeric: DT,
  contains_lowercase: IT,
  contains_numeric: OT,
  contains_symbol: MT,
  contains_uppercase: NT,
  date_after: nT,
  date_after_node: rT,
  date_after_or_equal: sT,
  date_before: mT,
  date_before_node: hT,
  date_before_or_equal: bT,
  date_between: RT,
  date_format: BT,
  email: UT,
  ends_with: WT,
  is: qT,
  length: YT,
  lowercase: ZT,
  matches: JT,
  max: eA,
  min: nA,
  not: sA,
  number: rA,
  require_one: iA,
  required: lA,
  starts_with: uA,
  symbol: dA,
  uppercase: mA,
  url: hA
}, Symbol.toStringTag, { value: "Module" }));
var pu = /* @__PURE__ */ ct({
  type: "state",
  blocking: !0,
  visible: !1,
  value: !0,
  key: "validating"
});
function bA(e = {}) {
  return function(n) {
    let o = jt(n.props.validationRules || {}), s = { ...e, ...o };
    const a = { input: na(), rerun: null, isPassing: !0 };
    let r = jt(n.props.validation);
    n.on("prop:validation", ({ payload: l }) => i(l, o)), n.on(
      "prop:validationRules",
      ({ payload: l }) => i(r, l)
    );
    function i(l, c) {
      var u;
      we(Object.keys(o || {}), Object.keys(c || {})) && we(r, l) || (o = jt(c), r = jt(l), s = { ...e, ...o }, (u = n.props.parsedRules) == null || u.forEach((p) => {
        dg(p), rg(p.observer.receipts), p.observer.kill();
      }), n.store.filter(() => !1, "validation"), n.props.parsedRules = df(l, s, n), a.isPassing = !0, du(n, n.props.parsedRules, a));
    }
    n.props.parsedRules = df(r, s, n), du(n, n.props.parsedRules, a);
  };
}
function du(e, t, n) {
  Ep(e) || (n.input = na(), e.store.set(
    /* @__PURE__ */ ct({
      key: "failing",
      value: !n.isPassing,
      visible: !1
    })
  ), n.isPassing = !0, e.store.filter((o) => !o.meta.removeImmediately, "validation"), t.forEach(
    (o) => o.debounce && clearTimeout(o.timer)
  ), t.length && (e.store.set(pu), fu(0, t, n, !1, () => {
    e.store.remove(pu.key), e.store.set(
      /* @__PURE__ */ ct({
        key: "failing",
        value: !n.isPassing,
        visible: !1
      })
    );
  })));
}
function fu(e, t, n, o, s) {
  const a = t[e];
  if (!a)
    return s();
  const r = a.observer;
  if (Ep(r))
    return;
  const i = n.input;
  a.state = null;
  function l(c, u) {
    if (n.input !== i)
      return;
    n.isPassing = n.isPassing && !!u, a.queued = !1;
    const p = r.stopObserve(), f = lg(a.deps, p);
    if (ag(
      r,
      f,
      function() {
        try {
          r.store.set(pu);
        } catch {
        }
        a.queued = !0, n.rerun && clearTimeout(n.rerun), n.rerun = setTimeout(
          du,
          0,
          r,
          t,
          n
        );
      },
      "unshift"
      // We want these listeners to run before other events are emitted so the 'state.validating' will be reliable.
    ), a.deps = p, a.state = u, u === !1 ? $A(a, o || c) : dg(a), t.length > e + 1) {
      const m = t[e + 1];
      (u || m.force || !m.skipEmpty) && m.state === null && (m.queued = !0), fu(e + 1, t, n, o || c, s);
    } else
      s();
  }
  (!Zt(r.value) || !a.skipEmpty) && (n.isPassing || a.force) ? a.queued ? yA(a, r, (c) => {
    c instanceof Promise ? c.then((u) => l(!0, u)) : l(!1, c);
  }) : fu(e + 1, t, n, o, s) : Zt(r.value) && a.skipEmpty && n.isPassing ? (r.observe(), r.value, l(!1, n.isPassing)) : l(!1, null);
}
function yA(e, t, n) {
  e.debounce ? e.timer = setTimeout(() => {
    t.observe(), n(e.rule(t, ...e.args));
  }, e.debounce) : (t.observe(), n(e.rule(t, ...e.args)));
}
function dg(e) {
  const t = `rule_${e.name}`;
  e.messageObserver && (e.messageObserver = e.messageObserver.kill()), Ae(e.observer.store, t) && e.observer.store.remove(t);
}
function $A(e, t) {
  const n = e.observer;
  Ep(n) || (e.messageObserver || (e.messageObserver = pl(n._node)), e.messageObserver.watch(
    (o) => wA(
      o,
      e
    ),
    (o) => {
      const s = _A(n, e, o), a = /* @__PURE__ */ ct({
        blocking: e.blocking,
        key: `rule_${e.name}`,
        meta: {
          /**
           * Use this key instead of the message root key to produce i18n validation
           * messages.
           */
          messageKey: e.name,
          /**
           * For messages that were created *by or after* a debounced or async
           * validation rule — we make note of it so we can immediately remove them
           * as soon as the next commit happens.
           */
          removeImmediately: t,
          /**
           * Determines if this message should be passed to localization.
           */
          localize: !s,
          /**
           * The arguments that will be passed to the validation rules
           */
          i18nArgs: o
        },
        type: "validation",
        value: s || "This field is not valid."
      });
      n.store.set(a);
    }
  ));
}
function _A(e, t, n) {
  const o = e.props.validationMessages && Ae(e.props.validationMessages, t.name) ? e.props.validationMessages[t.name] : void 0;
  return typeof o == "function" ? o(...n) : o;
}
function wA(e, t) {
  return [
    {
      node: e,
      name: Op(e),
      args: t.args
    }
  ];
}
function Op(e) {
  return typeof e.props.validationLabel == "function" ? e.props.validationLabel(e) : e.props.validationLabel || e.props.label || e.props.name || String(e.name);
}
var fg = "(?:[\\*+?()0-9]+)", mg = "[a-zA-Z][a-zA-Z0-9_]+", CA = new RegExp(
  `^(${fg}?${mg})(?:\\:(.*)+)?$`,
  "i"
), kA = new RegExp(`^(${fg})(${mg})$`, "i"), SA = /([\*+?]+)?(\(\d+\))([\*+?]+)?/, pf = /\(\d+\)/, TA = {
  blocking: !0,
  debounce: 0,
  force: !1,
  skipEmpty: !0,
  name: ""
};
function df(e, t, n) {
  return e ? (typeof e == "string" ? AA(e) : _o(e)).reduce((s, a) => {
    let r = a.shift();
    const i = {};
    if (typeof r == "string") {
      const [l, c] = PA(r);
      Ae(t, l) && (r = t[l], Object.assign(i, c));
    }
    return typeof r == "function" && s.push({
      observer: pl(n),
      rule: r,
      args: a,
      timer: 0,
      state: null,
      queued: !0,
      deps: /* @__PURE__ */ new Map(),
      ...TA,
      ...IA(i, r)
    }), s;
  }, []) : [];
}
function AA(e) {
  return e.split("|").reduce((t, n) => {
    const o = DA(n);
    return o && t.push(o), t;
  }, []);
}
function DA(e) {
  const t = e.trim();
  if (t) {
    const n = t.match(CA);
    if (n && typeof n[1] == "string") {
      const o = n[1].trim(), s = n[2] && typeof n[2] == "string" ? n[2].split(",").map((a) => a.trim()) : [];
      return [o, ...s];
    }
  }
  return !1;
}
function PA(e) {
  const t = e.match(kA);
  if (!t)
    return [e, { name: e }];
  const n = {
    "*": { force: !0 },
    "+": { skipEmpty: !1 },
    "?": { blocking: !1 }
  }, [, o, s] = t, a = pf.test(o) ? o.match(SA) || [] : [, o];
  return [
    s,
    [a[1], a[2], a[3]].reduce(
      (r, i) => (i && (pf.test(i) ? r.debounce = parseInt(i.substr(1, i.length - 1)) : i.split("").forEach(
        (l) => Ae(n, l) && Object.assign(r, n[l])
      )), r),
      { name: s }
    )
  ];
}
function IA(e, t) {
  return e.name || (e.name = t.ruleName || t.name), ["skipEmpty", "force", "debounce", "blocking"].reduce(
    (n, o) => (Ae(t, o) && !Ae(n, o) && Object.assign(n, {
      [o]: t[o]
    }), n),
    e
  );
}
function EA(e) {
  const t = /* @__PURE__ */ new Map(), n = (o) => {
    const s = [];
    for (const a in o.store) {
      const r = o.store[a];
      r.type === "validation" && r.visible && typeof r.value == "string" && s.push(r);
    }
    return s.length && t.set(o, s), o;
  };
  return n(e).walk(n), t;
}
function be(e) {
  return e[0].toUpperCase() + e.substr(1);
}
function Ti(e, t = "or") {
  return e.reduce((n, o, s) => (n += o, s <= e.length - 2 && e.length > 2 && (n += ", "), s === e.length - 2 && (n += `${e.length === 2 ? " " : ""}${t} `), n), "");
}
function po(e) {
  const t = typeof e == "string" ? new Date(Date.parse(e)) : e;
  return t instanceof Date ? new Intl.DateTimeFormat(void 0, {
    dateStyle: "medium",
    timeZone: "UTC"
  }).format(t) : "(unknown)";
}
function vg(e, t) {
  return Number(e) >= Number(t) ? [t, e] : [e, t];
}
var OA = {
  /**
   * Shown on a button for adding additional items.
   */
  add: "Add",
  /**
   * Shown when a button to remove items is visible.
   */
  remove: "Remove",
  /**
   * Shown when there are multiple items to remove at the same time.
   */
  removeAll: "Remove all",
  /**
   * Shown when all fields are not filled out correctly.
   */
  incomplete: "Sorry, not all fields are filled out correctly.",
  /**
   * Shown in a button inside a form to submit the form.
   */
  submit: "Submit",
  /**
   * Shown when no files are selected.
   */
  noFiles: "No file chosen",
  /**
   * Shown on buttons that move fields up in a list.
   */
  moveUp: "Move up",
  /**
   * Shown on buttons that move fields down in a list.
   */
  moveDown: "Move down",
  /**
   * Shown when something is actively loading.
   */
  isLoading: "Loading...",
  /**
   * Shown when there is more to load.
   */
  loadMore: "Load more",
  /**
   * Show on buttons that navigate state forward
   */
  next: "Next",
  /**
   * Show on buttons that navigate state backward
   */
  prev: "Previous",
  /**
   * Shown when adding all values.
   */
  addAllValues: "Add all values",
  /**
   * Shown when adding selected values.
   */
  addSelectedValues: "Add selected values",
  /**
   * Shown when removing all values.
   */
  removeAllValues: "Remove all values",
  /**
   * Shown when removing selected values.
   */
  removeSelectedValues: "Remove selected values",
  /**
   * Shown when there is a date to choose.
   */
  chooseDate: "Choose date",
  /**
   * Shown when there is a date to change.
   */
  changeDate: "Change date",
  /**
   * Shown above error summaries when someone attempts to submit a form with
   * errors and the developer has implemented `<FormKitSummary />`.
   */
  summaryHeader: "There were errors in your form.",
  /*
   * Shown when there is something to close
   */
  close: "Close",
  /**
   * Shown when there is something to open.
   */
  open: "Open"
}, xA = {
  /**
   * The value is not an accepted value.
   * @see {@link https://formkit.com/essentials/validation#accepted}
   */
  accepted({ name: e }) {
    return `Please accept the ${e}.`;
  },
  /**
   * The date is not after
   * @see {@link https://formkit.com/essentials/validation#date-after}
   */
  date_after({ name: e, args: t }) {
    return Array.isArray(t) && t.length ? `${be(e)} must be after ${po(t[0])}.` : `${be(e)} must be in the future.`;
  },
  /**
   * The value is not a letter.
   * @see {@link https://formkit.com/essentials/validation#alpha}
   */
  alpha({ name: e }) {
    return `${be(e)} can only contain alphabetical characters.`;
  },
  /**
   * The value is not alphanumeric
   * @see {@link https://formkit.com/essentials/validation#alphanumeric}
   */
  alphanumeric({ name: e }) {
    return `${be(e)} can only contain letters and numbers.`;
  },
  /**
   * The value is not letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#alpha-spaces}
   */
  alpha_spaces({ name: e }) {
    return `${be(e)} can only contain letters and spaces.`;
  },
  /**
   * The value have no letter.
   * @see {@link https://formkit.com/essentials/validation#contains_alpha}
   */
  contains_alpha({ name: e }) {
    return `${be(e)} must contain alphabetical characters.`;
  },
  /**
   * The value have no alphanumeric
   * @see {@link https://formkit.com/essentials/validation#contains_alphanumeric}
   */
  contains_alphanumeric({ name: e }) {
    return `${be(e)} must contain letters or numbers.`;
  },
  /**
   * The value have no letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#contains_alpha-spaces}
   */
  contains_alpha_spaces({ name: e }) {
    return `${be(e)} must contain letters or spaces.`;
  },
  /**
   * The value have no symbol
   * @see {@link https://formkit.com/essentials/validation#contains_symbol}
   */
  contains_symbol({ name: e }) {
    return `${be(e)} must contain a symbol.`;
  },
  /**
   * The value have no uppercase
   * @see {@link https://formkit.com/essentials/validation#contains_uppercase}
   */
  contains_uppercase({ name: e }) {
    return `${be(e)} must contain an uppercase letter.`;
  },
  /**
   * The value have no lowercase
   * @see {@link https://formkit.com/essentials/validation#contains_lowercase}
   */
  contains_lowercase({ name: e }) {
    return `${be(e)} must contain a lowercase letter.`;
  },
  /**
   *  The value have no numeric
   * @see {@link https://formkit.com/essentials/validation#contains_numeric}
   */
  contains_numeric({ name: e }) {
    return `${be(e)} must contain numbers.`;
  },
  /**
   * The value is not symbol
   * @see {@link https://formkit.com/essentials/validation#symbol}
   */
  symbol({ name: e }) {
    return `${be(e)} must be a symbol.`;
  },
  /**
   * The value is not uppercase
   * @see {@link https://formkit.com/essentials/validation#uppercase}
   */
  uppercase({ name: e }) {
    return `${be(e)} can only contain uppercase letters.`;
  },
  /**
   * The value is not lowercase
   * @see {@link https://formkit.com/essentials/validation#lowercase}
   */
  lowercase({ name: e, args: t }) {
    let n = "";
    return Array.isArray(t) && t.length && (t[0] === "allow_non_alpha" && (n = ", numbers and symbols"), t[0] === "allow_numeric" && (n = " and numbers"), t[0] === "allow_numeric_dashes" && (n = ", numbers and dashes")), `${be(e)} can only contain lowercase letters${n}.`;
  },
  /**
   * The date is not before
   * @see {@link https://formkit.com/essentials/validation#date-before}
   */
  date_before({ name: e, args: t }) {
    return Array.isArray(t) && t.length ? `${be(e)} must be before ${po(t[0])}.` : `${be(e)} must be in the past.`;
  },
  /**
   * The value is not between two numbers
   * @see {@link https://formkit.com/essentials/validation#between}
   */
  between({ name: e, args: t }) {
    if (isNaN(t[0]) || isNaN(t[1]))
      return "This field was configured incorrectly and can’t be submitted.";
    const [n, o] = vg(t[0], t[1]);
    return `${be(e)} must be between ${n} and ${o}.`;
  },
  /**
   * The confirmation field does not match
   * @see {@link https://formkit.com/essentials/validation#confirm}
   */
  confirm({ name: e }) {
    return `${be(e)} does not match.`;
  },
  /**
   * The value is not a valid date
   * @see {@link https://formkit.com/essentials/validation#date-format}
   */
  date_format({ name: e, args: t }) {
    return Array.isArray(t) && t.length ? `${be(e)} is not a valid date, please use the format ${t[0]}` : "This field was configured incorrectly and can’t be submitted";
  },
  /**
   * Is not within expected date range
   * @see {@link https://formkit.com/essentials/validation#date-between}
   */
  date_between({ name: e, args: t }) {
    return `${be(e)} must be between ${po(t[0])} and ${po(t[1])}`;
  },
  /**
   * Shown when the user-provided value is not a valid email address.
   * @see {@link https://formkit.com/essentials/validation#email}
   */
  email: "Please enter a valid email address.",
  /**
   * Does not end with the specified value
   * @see {@link https://formkit.com/essentials/validation#ends-with}
   */
  ends_with({ name: e, args: t }) {
    return `${be(e)} doesn’t end with ${Ti(t)}.`;
  },
  /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#is}
   */
  is({ name: e }) {
    return `${be(e)} is not an allowed value.`;
  },
  /**
   * Does not match specified length
   * @see {@link https://formkit.com/essentials/validation#length}
   */
  length({ name: e, args: [t = 0, n = 1 / 0] }) {
    const o = Number(t) <= Number(n) ? t : n, s = Number(n) >= Number(t) ? n : t;
    return o == 1 && s === 1 / 0 ? `${be(e)} must be at least one character.` : o == 0 && s ? `${be(e)} must be less than or equal to ${s} characters.` : o === s ? `${be(e)} should be ${s} characters long.` : o && s === 1 / 0 ? `${be(e)} must be greater than or equal to ${o} characters.` : `${be(e)} must be between ${o} and ${s} characters.`;
  },
  /**
   * Value is not a match
   * @see {@link https://formkit.com/essentials/validation#matches}
   */
  matches({ name: e }) {
    return `${be(e)} is not an allowed value.`;
  },
  /**
   * Exceeds maximum allowed value
   * @see {@link https://formkit.com/essentials/validation#max}
   */
  max({ name: e, node: { value: t }, args: n }) {
    return Array.isArray(t) ? `Cannot have more than ${n[0]} ${e}.` : `${be(e)} must be no more than ${n[0]}.`;
  },
  /**
   * The (field-level) value does not match specified mime type
   * @see {@link https://formkit.com/essentials/validation#mime}
   */
  mime({ name: e, args: t }) {
    return t[0] ? `${be(e)} must be of the type: ${t[0]}` : "No file formats allowed.";
  },
  /**
   * Does not fulfill minimum allowed value
   * @see {@link https://formkit.com/essentials/validation#min}
   */
  min({ name: e, node: { value: t }, args: n }) {
    return Array.isArray(t) ? `Cannot have fewer than ${n[0]} ${e}.` : `${be(e)} must be at least ${n[0]}.`;
  },
  /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#not}
   */
  not({ name: e, node: { value: t } }) {
    return `“${t}” is not an allowed ${e}.`;
  },
  /**
   *  Is not a number
   * @see {@link https://formkit.com/essentials/validation#number}
   */
  number({ name: e }) {
    return `${be(e)} must be a number.`;
  },
  /**
   * Require one field.
   * @see {@link https://formkit.com/essentials/validation#require-one}
   */
  require_one: ({ name: e, node: t, args: n }) => {
    const o = n.map((s) => {
      const a = t.at(s);
      return a ? Op(a) : !1;
    }).filter((s) => !!s);
    return o.unshift(e), `${o.join(" or ")} is required.`;
  },
  /**
   * Required field.
   * @see {@link https://formkit.com/essentials/validation#required}
   */
  required({ name: e }) {
    return `${be(e)} is required.`;
  },
  /**
   * Does not start with specified value
   * @see {@link https://formkit.com/essentials/validation#starts-with}
   */
  starts_with({ name: e, args: t }) {
    return `${be(e)} doesn’t start with ${Ti(t)}.`;
  },
  /**
   * Is not a url
   * @see {@link https://formkit.com/essentials/validation#url}
   */
  url() {
    return "Please enter a valid URL.";
  },
  /**
   * Shown when the date is invalid.
   */
  invalidDate: "The selected date is invalid."
}, hg = { ui: OA, validation: xA }, MA = {
  /**
   * Shown on buttons for adding new items.
   */
  add: "Ajouter",
  /**
   * Shown when a button to remove items is visible.
   */
  remove: "Supprimer",
  /**
   * Shown when there are multiple items to remove at the same time.
   */
  removeAll: "Enlever tout",
  /**
   * Shown when all fields are not filled out correctly.
   */
  incomplete: "Désolé, tous les champs ne sont pas remplis correctement.",
  /**
   * Shown in a button inside a form to submit the form.
   */
  submit: "Valider",
  /**
   * Shown when no files are selected.
   */
  noFiles: "Aucun fichier choisi",
  /**
   * Shown on buttons that move fields up in a list.
   */
  moveUp: "Déplacez-vous",
  /**
   * Shown on buttons that move fields down in a list.
   */
  moveDown: "Déplacez-vous",
  /**
   * Shown when something is actively loading.
   */
  isLoading: "Chargement...",
  /**
   * Shown when there is more to load.
   */
  loadMore: "Chargez plus",
  /**
   * Shown on buttons that navigate state forward
   */
  next: "Suivant",
  /**
   * Shown on buttons that navigate state backward
   */
  prev: "Précédent",
  /**
   * Shown when adding all values.
   */
  addAllValues: "Ajouter toutes les valeurs",
  /**
   * Shown when adding selected values.
   */
  addSelectedValues: "Ajouter les valeurs sélectionnées",
  /**
   * Shown when removing all values.
   */
  removeAllValues: "Supprimer toutes les valeurs",
  /**
   * Shown when removing selected values.
   */
  removeSelectedValues: "Supprimer les valeurs sélectionnées",
  /**
   * Shown when there is a date to choose.
   */
  chooseDate: "Choisissez la date",
  /**
   * Shown when there is a date to change.
   */
  changeDate: "Modifier la date",
  /**
   * Shown when there is something to close
   */
  close: "Fermer",
  /**
   * Shown when there is something to open.
   */
  open: "Ouvrir"
}, LA = {
  /**
   * The value is not an accepted value.
   * @see {@link https://formkit.com/essentials/validation#accepted}
   */
  accepted({ name: e }) {
    return `Veuillez accepter le ${e}.`;
  },
  /**
   * The date is not after
   * @see {@link https://formkit.com/essentials/validation#date-after}
   */
  date_after({ name: e, args: t }) {
    return Array.isArray(t) && t.length ? `${be(e)} doit être postérieure au ${po(t[0])}.` : `${be(e)} doit être dans le futur.`;
  },
  /**
   * The value is not a letter.
   * @see {@link https://formkit.com/essentials/validation#alpha}
   */
  alpha({ name: e }) {
    return `${be(e)} ne peut contenir que des caractères alphabétiques.`;
  },
  /**
   * The value is not alphanumeric
   * @see {@link https://formkit.com/essentials/validation#alphanumeric}
   */
  alphanumeric({ name: e }) {
    return `${be(e)} ne peut contenir que des lettres et des chiffres.`;
  },
  /**
   * The value is not letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#alpha-spaces}
   */
  alpha_spaces({ name: e }) {
    return `${be(e)} ne peuvent contenir que des lettres et des espaces.`;
  },
  /**
   * The value have no letter.
   * @see {@link https://formkit.com/essentials/validation#contains_alpha}
   */
  contains_alpha({ name: e }) {
    return `${be(e)} doit contenir des caractères alphabétiques.`;
  },
  /**
   * The value have no alphanumeric
   * @see {@link https://formkit.com/essentials/validation#contains_alphanumeric}
   */
  contains_alphanumeric({ name: e }) {
    return `${be(e)} doit contenir au moins un lettre ou nombre.`;
  },
  /**
   * The value have no letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#contains_alpha-spaces}
   */
  contains_alpha_spaces({ name: e }) {
    return `${be(e)} doit contenir des lettres ou des espaces.`;
  },
  /**
   * The value have no symbol
   * @see {@link https://formkit.com/essentials/validation#contains_symbol}
   */
  contains_symbol({ name: e }) {
    return `${be(e)} doit contenir un symbole.`;
  },
  /**
   * The value have no uppercase
   * @see {@link https://formkit.com/essentials/validation#contains_uppercase}
   */
  contains_uppercase({ name: e }) {
    return `${be(e)} doit contenir au moins une majuscule.`;
  },
  /**
   * The value have no lowercase
   * @see {@link https://formkit.com/essentials/validation#contains_lowercase}
   */
  contains_lowercase({ name: e }) {
    return `${be(e)} doit contenir au moins une minuscule.`;
  },
  /**
   *  The value have no numeric
   * @see {@link https://formkit.com/essentials/validation#contains_numeric}
   */
  contains_numeric({ name: e }) {
    return `${be(e)} doit contenir des chiffres.`;
  },
  /**
   * The value is not symbol
   * @see {@link https://formkit.com/essentials/validation#symbol}
   */
  symbol({ name: e }) {
    return `${be(e)} doit être un symbole.`;
  },
  /**
   * The value is not uppercase
   * @see {@link https://formkit.com/essentials/validation#uppercase}
   */
  uppercase({ name: e }) {
    return `${be(e)} ne peuvent contenir que des majuscules.`;
  },
  /**
   * The value is not lowercase
   * @see {@link https://formkit.com/essentials/validation#lowercase}
   */
  lowercase({ name: e }) {
    return `${be(e)} ne peut contenir que des lettres minuscules.`;
  },
  /**
   * The date is not before
   * @see {@link https://formkit.com/essentials/validation#date-before}
   */
  date_before({ name: e, args: t }) {
    return Array.isArray(t) && t.length ? `${be(e)} doit être antérieure au ${po(t[0])}.` : `${be(e)} doit être dans le passé.`;
  },
  /**
   * The value is not between two numbers
   * @see {@link https://formkit.com/essentials/validation#between}
   */
  between({ name: e, args: t }) {
    if (isNaN(t[0]) || isNaN(t[1]))
      return "Ce champ a été configuré de manière incorrecte et ne peut pas être soumis.";
    const [n, o] = vg(t[0], t[1]);
    return `${be(e)} doit être comprise entre ${n} et ${o}.`;
  },
  /**
   * The confirmation field does not match
   * @see {@link https://formkit.com/essentials/validation#confirm}
   */
  confirm({ name: e }) {
    return `${be(e)} ne correspond pas.`;
  },
  /**
   * The value is not a valid date
   * @see {@link https://formkit.com/essentials/validation#date-format}
   */
  date_format({ name: e, args: t }) {
    return Array.isArray(t) && t.length ? `${be(
      e
    )} n'est pas une date valide, veuillez utiliser le format ${t[0]}` : "Ce champ a été configuré de manière incorrecte et ne peut pas être soumis.";
  },
  /**
   * Is not within expected date range
   * @see {@link https://formkit.com/essentials/validation#date-between}
   */
  date_between({ name: e, args: t }) {
    return `${be(e)} doit être comprise entre ${po(t[0])} et ${po(
      t[1]
    )}`;
  },
  /**
   * Shown when the user-provided value is not a valid email address.
   * @see {@link https://formkit.com/essentials/validation#email}
   */
  email: "Veuillez saisir une adresse email valide.",
  /**
   * Does not end with the specified value
   * @see {@link https://formkit.com/essentials/validation#ends-with}
   */
  ends_with({ name: e, args: t }) {
    return `${be(e)} ne se termine pas par ${Ti(t)}.`;
  },
  /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#is}
   */
  is({ name: e }) {
    return `${be(e)} n'est pas une valeur autorisée.`;
  },
  /**
   * Does not match specified length
   * @see {@link https://formkit.com/essentials/validation#length}
   */
  length({ name: e, args: [t = 0, n = 1 / 0] }) {
    const o = Number(t) <= Number(n) ? t : n, s = Number(n) >= Number(t) ? n : t;
    return o == 1 && s === 1 / 0 ? `${be(e)} doit comporter au moins un caractère.` : o == 0 && s ? `${be(e)} doit être inférieur ou égal à ${s} caractères.` : o === s ? `${be(e)} doit contenir ${s} caractères.` : o && s === 1 / 0 ? `${be(e)} doit être supérieur ou égal à ${o} caractères.` : `${be(e)} doit être comprise entre ${o} et ${s} caractères.`;
  },
  /**
   * Value is not a match
   * @see {@link https://formkit.com/essentials/validation#matches}
   */
  matches({ name: e }) {
    return `${be(e)} n'est pas une valeur autorisée.`;
  },
  /**
   * Exceeds maximum allowed value
   * @see {@link https://formkit.com/essentials/validation#max}
   */
  max({ name: e, node: { value: t }, args: n }) {
    return Array.isArray(t) ? `Ne peut pas avoir plus de ${n[0]} ${e}.` : `${be(e)} doit être inférieur ou égal à ${n[0]}.`;
  },
  /**
   * The (field-level) value does not match specified mime type
   * @see {@link https://formkit.com/essentials/validation#mime}
   */
  mime({ name: e, args: t }) {
    return t[0] ? `${be(e)} doit être du type: ${t[0]}` : "Aucun format de fichier n’est autorisé";
  },
  /**
   * Does not fulfill minimum allowed value
   * @see {@link https://formkit.com/essentials/validation#min}
   */
  min({ name: e, node: { value: t }, args: n }) {
    return Array.isArray(t) ? `Ne peut pas avoir moins de ${n[0]} ${e}.` : `${be(e)} doit être au moins de ${n[0]}.`;
  },
  /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#not}
   */
  not({ name: e, node: { value: t } }) {
    return `“${t}” n'est pas un ${e} autorisé.`;
  },
  /**
   *  Is not a number
   * @see {@link https://formkit.com/essentials/validation#number}
   */
  number({ name: e }) {
    return `${be(e)} doit être un nombre.`;
  },
  /**
   * Require one field.
   * @see {@link https://formkit.com/essentials/validation#require-one}
   */
  require_one: ({ name: e, node: t, args: n }) => {
    const o = n.map((s) => {
      const a = t.at(s);
      return a ? Op(a) : !1;
    }).filter((s) => !!s);
    return o.unshift(e), `${o.join(" ou ")} est requis.`;
  },
  /**
   * Required field.
   * @see {@link https://formkit.com/essentials/validation#required}
   */
  required({ name: e }) {
    return `${be(e)} est requis.`;
  },
  /**
   * Does not start with specified value
   * @see {@link https://formkit.com/essentials/validation#starts-with}
   */
  starts_with({ name: e, args: t }) {
    return `${be(e)} ne commence pas par ${Ti(t)}.`;
  },
  /**
   * Is not a url
   * @see {@link https://formkit.com/essentials/validation#url}
   */
  url() {
    return "Entrez une URL valide.";
  },
  /**
   * Shown when the date is invalid.
   */
  invalidDate: "La date sélectionnée n'est pas valide."
}, NA = { ui: MA, validation: LA }, ff = /* @__PURE__ */ new Set();
function FA(e) {
  return function(n) {
    ff.add(n), n.on("destroying", () => ff.delete(n));
    let o = mf(n.config.locale, e), s = o ? e[o] : {};
    n.on("prop:locale", ({ payload: a }) => {
      o = mf(a, e), s = o ? e[o] : {}, n.store.touch();
    }), n.on("prop:label", () => n.store.touch()), n.on("prop:validationLabel", () => n.store.touch()), n.hook.text((a, r) => {
      var l, c;
      const i = ((l = a.meta) == null ? void 0 : l.messageKey) || a.key;
      if (Ae(s, a.type) && Ae(s[a.type], i)) {
        const u = s[a.type][i];
        typeof u == "function" ? a.value = Array.isArray((c = a.meta) == null ? void 0 : c.i18nArgs) ? u(...a.meta.i18nArgs) : u(a) : a.value = u;
      }
      return r(a);
    });
  };
}
function mf(e, t) {
  if (Ae(t, e))
    return e;
  const [n] = e.split("-");
  if (Ae(t, n))
    return n;
  for (const o in t)
    return o;
  return !1;
}
function RA(...e) {
  const t = e.reduce(
    (o, s) => Xn(o, s),
    {}
  ), n = () => {
  };
  return n.library = function(o) {
    const s = Is(o.props.type);
    Ae(t, s) && o.define(t[s]);
  }, n;
}
var VA = [
  "classes",
  "config",
  "delay",
  "errors",
  "id",
  "index",
  "inputErrors",
  "library",
  "modelValue",
  "onUpdate:modelValue",
  "name",
  "number",
  "parent",
  "plugins",
  "sectionsSchema",
  "type",
  "validation",
  "validationLabel",
  "validationMessages",
  "validationRules",
  // Runtime event props:
  "onInput",
  "onInputRaw",
  "onUpdate:modelValue",
  "onNode",
  "onSubmit",
  "onSubmitInvalid",
  "onSubmitRaw"
];
function dl(e) {
  return e && typeof e == "object" && "group" in e && Array.isArray(e.options);
}
function Ai(e, t = { count: 1 }) {
  return Array.isArray(e) ? e.map(
    (n) => {
      if (typeof n == "string" || typeof n == "number")
        return {
          label: String(n),
          value: String(n)
        };
      if (typeof n == "object") {
        if ("group" in n)
          return n.options = Ai(n.options || [], t), n;
        "value" in n && typeof n.value != "string" && Object.assign(n, {
          value: `__mask_${t.count++}`,
          __original: n.value
        });
      }
      return n;
    }
  ) : Object.keys(e).map((n) => ({
    label: e[n],
    value: n
  }));
}
function Jo(e, t, n = !1) {
  if (Array.isArray(e)) {
    for (const o of e)
      if (!(typeof o != "object" && o)) {
        if (dl(o)) {
          const s = Jo(o.options, t, !0);
          if (s !== void 0)
            return s;
        } else if (t == o.value)
          return "__original" in o ? o.__original : o.value;
      }
  }
  return n ? void 0 : t;
}
function Hs(e, t) {
  return e === null && t === void 0 || e === void 0 && t === null ? !1 : e == t ? !0 : $o(e) && $o(t) ? we(e, t) : !1;
}
function xn(e) {
  e.hook.prop((t, n) => {
    var o;
    return t.prop === "options" && (typeof t.value == "function" ? (e.props.optionsLoader = t.value, t.value = []) : ((o = e.props)._normalizeCounter ?? (o._normalizeCounter = { count: 1 }), t.value = Ai(t.value, e.props._normalizeCounter))), n(t);
  });
}
// @__NO_SIDE_EFFECTS__
function Te(e, t, n = !1) {
  return (...o) => {
    const s = (a) => {
      const r = !t || typeof t == "string" ? { $el: t } : t();
      return (Xo(r) || Ga(r)) && (r.meta ? r.meta.section = e : r.meta = { section: e }, o.length && !r.children && (r.children = [
        ...o.map(
          (i) => typeof i == "function" ? i(a) : i
        )
      ]), Xo(r) && (r.attrs = {
        class: `$classes.${e}`,
        ...r.attrs || {}
      })), {
        if: `$slots.${e}`,
        then: `$slots.${e}`,
        else: e in a ? /* @__PURE__ */ zo(r, a[e]) : r
      };
    };
    return s._s = e, n ? /* @__PURE__ */ BA(s) : s;
  };
}
// @__NO_SIDE_EFFECTS__
function BA(e) {
  return (t) => [e(t)];
}
function Za(e) {
  return !!(e && typeof e == "object" && ("$el" in e || "$cmp" in e || "$formkit" in e));
}
// @__NO_SIDE_EFFECTS__
function zo(e, t = {}) {
  return typeof e == "string" ? Za(t) || typeof t == "string" ? t : e : Array.isArray(e) ? Za(t) ? t : e : Xn(e, t);
}
var HA = /* @__PURE__ */ Te("actions", () => ({
  $el: "div",
  if: "$actions"
})), Di = /* @__PURE__ */ Te("input", () => ({
  $el: "input",
  bind: "$attrs",
  attrs: {
    type: "$type",
    name: "$node.props.altName || $node.name",
    disabled: "$option.attrs.disabled || $disabled",
    onInput: "$handlers.toggleChecked",
    checked: "$fns.eq($_value, $onValue)",
    onBlur: "$handlers.blur",
    value: "$: true",
    id: "$id",
    "aria-describedby": {
      if: "$options.length",
      then: {
        if: "$option.help",
        then: '$: "help-" + $option.attrs.id',
        else: void 0
      },
      else: {
        if: "$help",
        then: '$: "help-" + $id',
        else: void 0
      }
    }
  }
})), gg = /* @__PURE__ */ Te("optionHelp", () => ({
  $el: "div",
  if: "$option.help",
  attrs: {
    id: '$: "help-" + $option.attrs.id'
  }
})), Pi = /* @__PURE__ */ Te("inner", "span"), Ii = /* @__PURE__ */ Te("label", "span"), bg = /* @__PURE__ */ Te("option", () => ({
  $el: "li",
  for: ["option", "$options"],
  attrs: {
    "data-disabled": "$option.attrs.disabled || $disabled || undefined"
  }
})), yg = /* @__PURE__ */ Te("options", "ul"), Ei = /* @__PURE__ */ Te("wrapper", () => ({
  $el: "label",
  attrs: {
    "data-disabled": {
      if: "$options.length",
      then: void 0,
      else: "$disabled || undefined"
    },
    "data-checked": {
      if: "$options == undefined",
      then: "$fns.eq($_value, $onValue) || undefined",
      else: "$fns.isChecked($option.value) || undefined"
    }
  }
})), UA = /* @__PURE__ */ Te("input", () => ({
  $el: "button",
  bind: "$attrs",
  attrs: {
    type: "$type",
    disabled: "$disabled",
    name: "$node.name",
    id: "$id"
  }
})), zA = /* @__PURE__ */ Te("default", null), Oi = /* @__PURE__ */ Te("decorator", () => ({
  $el: "span",
  attrs: {
    "aria-hidden": "true"
  }
})), $g = /* @__PURE__ */ Te("fieldset", () => ({
  $el: "fieldset",
  attrs: {
    id: "$id",
    "aria-describedby": {
      if: "$help",
      then: '$: "help-" + $id',
      else: void 0
    }
  }
})), WA = /* @__PURE__ */ Te("input", () => ({
  $el: "input",
  bind: "$attrs",
  attrs: {
    type: "file",
    disabled: "$disabled",
    name: "$node.name",
    onChange: "$handlers.files",
    onBlur: "$handlers.blur",
    id: "$id",
    "aria-describedby": "$describedBy",
    "aria-required": "$state.required || undefined"
  }
})), jA = /* @__PURE__ */ Te("fileItem", () => ({
  $el: "li",
  for: ["file", "$value"]
})), qA = /* @__PURE__ */ Te("fileList", () => ({
  $el: "ul",
  if: "$value.length",
  attrs: {
    "data-has-multiple": "$_hasMultipleFiles"
  }
})), KA = /* @__PURE__ */ Te("fileName", () => ({
  $el: "span",
  attrs: {
    class: "$classes.fileName"
  }
})), vf = /* @__PURE__ */ Te("fileRemove", () => ({
  $el: "button",
  attrs: {
    type: "button",
    onClick: "$handlers.resetFiles"
  }
})), YA = /* @__PURE__ */ Te("form", () => ({
  $el: "form",
  bind: "$attrs",
  meta: {
    autoAnimate: !0
  },
  attrs: {
    id: "$id",
    name: "$node.name",
    onSubmit: "$handlers.submit",
    "data-loading": "$state.loading || undefined"
  }
})), xp = /* @__PURE__ */ Te("wrapper", null, !0), Dn = /* @__PURE__ */ Te("help", () => ({
  $el: "div",
  if: "$help",
  attrs: {
    id: '$: "help-" + $id'
  }
})), rt = (e, t) => (/* @__PURE__ */ Te(`${e}Icon`, () => {
  const n = `_raw${e.charAt(0).toUpperCase()}${e.slice(1)}Icon`;
  return {
    if: `$${e}Icon && $${n}`,
    $el: `${t || "span"}`,
    attrs: {
      class: `$classes.${e}Icon + " " + $classes.icon`,
      innerHTML: `$${n}`,
      onClick: `$handlers.iconClick(${e})`,
      role: `$fns.iconRole(${e})`,
      tabindex: `$fns.iconRole(${e}) === "button" && "0" || undefined`,
      for: {
        if: `${t === "label"}`,
        then: "$id"
      }
    }
  };
}))(), lr = /* @__PURE__ */ Te("inner", "div"), cr = /* @__PURE__ */ Te("label", () => ({
  $el: "label",
  if: "$label",
  attrs: {
    for: "$id"
  }
})), _g = /* @__PURE__ */ Te("legend", () => ({
  $el: "legend",
  if: "$label"
})), no = /* @__PURE__ */ Te("message", () => ({
  $el: "li",
  for: ["message", "$messages"],
  attrs: {
    key: "$message.key",
    id: "$id + '-' + $message.key",
    "data-message-type": "$message.type"
  }
})), oo = /* @__PURE__ */ Te("messages", () => ({
  $el: "ul",
  if: "$defaultMessagePlacement && $fns.length($messages)"
})), GA = /* @__PURE__ */ Te("noFiles", () => ({
  $el: "span",
  if: "$value == null || $value.length == 0"
})), ZA = /* @__PURE__ */ Te("optGroup", () => ({
  $el: "optgroup",
  bind: "$option.attrs",
  attrs: {
    label: "$option.group"
  }
})), hf = /* @__PURE__ */ Te("option", () => ({
  $el: "option",
  bind: "$option.attrs",
  attrs: {
    class: "$classes.option",
    value: "$option.value",
    selected: "$fns.isSelected($option)"
  }
})), gf = /* @__PURE__ */ Te("options", () => ({
  $el: null,
  if: "$options.length",
  for: ["option", "$option.options || $options"]
})), Ao = /* @__PURE__ */ Te("outer", () => ({
  $el: "div",
  meta: {
    autoAnimate: !0
  },
  attrs: {
    key: "$id",
    "data-family": "$family || undefined",
    "data-type": "$type",
    "data-multiple": '$attrs.multiple || ($type != "select" && $options != undefined) || undefined',
    "data-has-multiple": "$_hasMultipleFiles",
    "data-disabled": '$: ($disabled !== "false" && $disabled) || undefined',
    "data-empty": "$state.empty || undefined",
    "data-complete": "$state.complete || undefined",
    "data-invalid": "$state.invalid || undefined",
    "data-errors": "$state.errors || undefined",
    "data-submitted": "$state.submitted || undefined",
    "data-prefix-icon": "$_rawPrefixIcon !== undefined || undefined",
    "data-suffix-icon": "$_rawSuffixIcon !== undefined || undefined",
    "data-prefix-icon-click": "$onPrefixIconClick !== undefined || undefined",
    "data-suffix-icon-click": "$onSuffixIconClick !== undefined || undefined"
  }
})), Pn = /* @__PURE__ */ Te("prefix", null), XA = /* @__PURE__ */ Te("input", () => ({
  $el: "select",
  bind: "$attrs",
  attrs: {
    id: "$id",
    "data-placeholder": "$fns.showPlaceholder($_value, $placeholder)",
    disabled: "$disabled",
    class: "$classes.input",
    name: "$node.name",
    onChange: "$handlers.onChange",
    onInput: "$handlers.selectInput",
    onBlur: "$handlers.blur",
    "aria-describedby": "$describedBy",
    "aria-required": "$state.required || undefined"
  }
})), JA = /* @__PURE__ */ Te("submit", () => ({
  $cmp: "FormKit",
  bind: "$submitAttrs",
  props: {
    type: "submit",
    label: "$submitLabel"
  }
})), In = /* @__PURE__ */ Te("suffix", null), wg = /* @__PURE__ */ Te("input", () => ({
  $el: "input",
  bind: "$attrs",
  attrs: {
    type: "$type",
    disabled: "$disabled",
    name: "$node.name",
    onInput: "$handlers.DOMInput",
    onBlur: "$handlers.blur",
    value: "$_value",
    id: "$id",
    "aria-describedby": "$describedBy",
    "aria-required": "$state.required || undefined"
  }
})), QA = /* @__PURE__ */ Te("input", () => ({
  $el: "textarea",
  bind: "$attrs",
  attrs: {
    disabled: "$disabled",
    name: "$node.name",
    onInput: "$handlers.DOMInput",
    onBlur: "$handlers.blur",
    value: "$_value",
    id: "$id",
    "aria-describedby": "$describedBy",
    "aria-required": "$state.required || undefined"
  },
  children: "$initialValue"
})), oa = /* @__PURE__ */ Te("wrapper", "div"), e3 = 0;
function Cg(e) {
  (e.type === "group" || e.type === "list") && e.plugins.add(t3);
}
function t3(e) {
  e.props.type === "radio" && (e.addProps(["altName"]), e.props.altName = `${e.name}_${e3++}`);
}
function kg(e) {
  return function(t, n) {
    return t.prop === "options" && Array.isArray(t.value) && (t.value = t.value.map((o) => {
      var s;
      return (s = o.attrs) != null && s.id ? o : Xn(o, {
        attrs: {
          id: `${e.props.id}-option-${kp(String(o.value))}`
        }
      });
    }), e.props.type === "checkbox" && !Array.isArray(e.value) && (e.isCreated ? e.input([], !1) : e.on("created", () => {
      Array.isArray(e.value) || e.input([], !1);
    }))), n(t);
  };
}
function n3(e, t) {
  const n = t.target;
  if (n instanceof HTMLInputElement) {
    const o = Array.isArray(e.props.options) ? Jo(e.props.options, n.value) : n.value;
    Array.isArray(e.props.options) && e.props.options.length ? Array.isArray(e._value) ? e._value.some((s) => Hs(o, s)) ? e.input(
      e._value.filter(
        (s) => !Hs(o, s)
      )
    ) : e.input([...e._value, o]) : e.input([o]) : n.checked ? e.input(e.props.onValue) : e.input(e.props.offValue);
  }
}
function o3(e, t) {
  var n, o;
  return (n = e.context) == null || n.value, (o = e.context) == null || o._value, Array.isArray(e._value) ? e._value.some(
    (s) => Hs(Jo(e.props.options, t), s)
  ) : !1;
}
function s3(e) {
  e.on("created", () => {
    var t, n;
    (t = e.context) != null && t.handlers && (e.context.handlers.toggleChecked = n3.bind(null, e)), (n = e.context) != null && n.fns && (e.context.fns.isChecked = o3.bind(null, e)), Ae(e.props, "onValue") || (e.props.onValue = !0), Ae(e.props, "offValue") || (e.props.offValue = !1);
  }), e.hook.prop(kg(e));
}
function Oe(e, t) {
  return (n) => {
    n.props[`${e}Icon`] === void 0 && (n.props[`${e}Icon`] = t.startsWith("<svg") ? t : `default:${t}`);
  };
}
function fl(e) {
  e.on("created", () => {
    "disabled" in e.props && (e.props.disabled = _e(e.props.disabled), e.config.disabled = _e(e.props.disabled));
  }), e.hook.prop(({ prop: t, value: n }, o) => (n = t === "disabled" ? _e(n) : n, o({ prop: t, value: n }))), e.on("prop:disabled", ({ payload: t }) => {
    e.config.disabled = _e(t);
  });
}
function We(e, t) {
  return (n) => {
    n.store.set(
      /* @__PURE__ */ ct({
        key: e,
        type: "ui",
        value: t || e,
        meta: {
          localize: !0,
          i18nArgs: [n]
        }
      })
    );
  };
}
var Ql = typeof window < "u";
function Sg(e) {
  e.target instanceof HTMLElement && e.target.hasAttribute("data-file-hover") && e.target.removeAttribute("data-file-hover");
}
function bf(e, t) {
  t.target instanceof HTMLInputElement ? e === "dragover" && t.target.setAttribute("data-file-hover", "true") : t.preventDefault(), e === "drop" && Sg(t);
}
function a3(e) {
  We("noFiles", "Select file")(e), We("removeAll", "Remove all")(e), We("remove")(e), e.addProps(["_hasMultipleFiles"]), Ql && (window._FormKit_File_Drop || (window.addEventListener(
    "dragover",
    bf.bind(null, "dragover")
  ), window.addEventListener("drop", bf.bind(null, "drop")), window.addEventListener("dragleave", Sg), window._FormKit_File_Drop = !0)), e.hook.input((t, n) => n(Array.isArray(t) ? t : [])), e.on("input", ({ payload: t }) => {
    e.props._hasMultipleFiles = Array.isArray(t) && t.length > 1 ? !0 : void 0;
  }), e.on("reset", () => {
    if (e.props.id && Ql) {
      const t = document.getElementById(e.props.id);
      t && (t.value = "");
    }
  }), e.on("created", () => {
    Array.isArray(e.value) || e.input([], !1), e.context && (e.context.handlers.resetFiles = (t) => {
      if (t.preventDefault(), e.input([]), e.props.id && Ql) {
        const n = document.getElementById(e.props.id);
        n && (n.value = ""), n == null || n.focus();
      }
    }, e.context.handlers.files = (t) => {
      var o, s;
      const n = [];
      if (t.target instanceof HTMLInputElement && t.target.files) {
        for (let a = 0; a < t.target.files.length; a++) {
          let r;
          (r = t.target.files.item(a)) && n.push({ name: r.name, file: r });
        }
        e.input(n);
      }
      e.context && (e.context.files = n), typeof ((o = e.props.attrs) == null ? void 0 : o.onChange) == "function" && ((s = e.props.attrs) == null || s.onChange(t));
    });
  });
}
var yf = /* @__PURE__ */ ct({
  key: "loading",
  value: !0,
  visible: !1
});
async function r3(e, t) {
  const n = Math.random();
  if (e.props._submitNonce = n, t.preventDefault(), await e.settled, e.ledger.value("validating") && (e.store.set(yf), await e.ledger.settled("validating"), e.store.remove("loading"), e.props._submitNonce !== n))
    return;
  const o = (s) => s.store.set(
    /* @__PURE__ */ ct({
      key: "submitted",
      value: !0,
      visible: !1
    })
  );
  if (e.walk(o), o(e), e.emit("submit-raw"), typeof e.props.onSubmitRaw == "function" && e.props.onSubmitRaw(t, e), e.ledger.value("blocking"))
    typeof e.props.onSubmitInvalid == "function" && e.props.onSubmitInvalid(e), e.props.incompleteMessage !== !1 && Tg(e);
  else if (typeof e.props.onSubmit == "function") {
    const s = e.props.onSubmit(
      e.hook.submit.dispatch(_o(e.value)),
      e
    );
    if (s instanceof Promise) {
      const a = e.props.disabled === void 0 && e.props.submitBehavior !== "live";
      a && (e.props.disabled = !0), e.store.set(yf), await s, a && (e.props.disabled = !1), e.store.remove("loading");
    }
  } else
    t.target instanceof HTMLFormElement && t.target.submit();
}
function Tg(e) {
  e.store.set(
    /* @__PURE__ */ ct({
      blocking: !1,
      key: "incomplete",
      meta: {
        localize: e.props.incompleteMessage === void 0,
        i18nArgs: [{ node: e }],
        showAsMessage: !0
      },
      type: "ui",
      value: e.props.incompleteMessage || "Form incomplete."
    })
  );
}
function i3(e) {
  var t;
  e.props.isForm = !0, e.ledger.count("validating", (n) => n.key === "validating"), (t = e.props).submitAttrs ?? (t.submitAttrs = {
    disabled: e.props.disabled
  }), e.on("prop:disabled", ({ payload: n }) => {
    e.props.submitAttrs = { ...e.props.submitAttrs, disabled: n };
  }), e.on("created", () => {
    var n;
    (n = e.context) != null && n.handlers && (e.context.handlers.submit = r3.bind(null, e)), Ae(e.props, "actions") || (e.props.actions = !0);
  }), e.on("prop:incompleteMessage", () => {
    e.store.incomplete && Tg(e);
  }), e.on("settled:blocking", () => e.store.remove("incomplete"));
}
function l3(e) {
  e.props.ignore === void 0 && (e.props.ignore = !0, e.parent = null);
}
function c3(e) {
  e.on("created", () => {
    e.context && (e.context.initialValue = e.value || "");
  });
}
function Ag(e) {
  if (typeof e.props.number > "u")
    return;
  const t = ["number", "range", "hidden"].includes(e.props.type);
  e.hook.input((n, o) => {
    if (n === "")
      return o(void 0);
    const s = e.props.number === "integer" ? parseInt(n) : parseFloat(n);
    return Number.isFinite(s) ? o(s) : o(t ? void 0 : n);
  });
}
function u3(e, t) {
  t.target instanceof HTMLInputElement && e.input(Jo(e.props.options, t.target.value));
}
function p3(e, t) {
  var n, o;
  return (n = e.context) == null || n.value, (o = e.context) == null || o._value, Hs(Jo(e.props.options, t), e._value);
}
function d3(e) {
  e.on("created", () => {
    var t, n;
    Array.isArray(e.props.options) || To(350, {
      node: e,
      inputType: "radio"
    }), (t = e.context) != null && t.handlers && (e.context.handlers.toggleChecked = u3.bind(null, e)), (n = e.context) != null && n.fns && (e.context.fns.isChecked = p3.bind(null, e));
  }), e.hook.prop(kg(e));
}
function f3(e, t) {
  if (dl(t))
    return !1;
  e.context && e.context.value;
  const n = "__original" in t ? t.__original : t.value;
  return Array.isArray(e._value) ? e._value.some((o) => Hs(o, n)) : (e._value === void 0 || e._value === null && !Dg(e.props.options, null)) && t.attrs && t.attrs["data-is-placeholder"] ? !0 : Hs(n, e._value);
}
function Dg(e, t) {
  return e.some((n) => dl(n) ? Dg(n.options, t) : ("__original" in n ? n.__original : n.value) === t);
}
async function m3(e, t) {
  var n;
  typeof ((n = e.props.attrs) == null ? void 0 : n.onChange) == "function" && (await new Promise((o) => setTimeout(o, 0)), await e.settled, e.props.attrs.onChange(t));
}
function v3(e, t) {
  const n = t.target, o = n.hasAttribute("multiple") ? Array.from(n.selectedOptions).map(
    (s) => Jo(e.props.options, s.value)
  ) : Jo(e.props.options, n.value);
  e.input(o);
}
function $f(e, t) {
  return e.some(
    (n) => n.attrs && n.attrs["data-is-placeholder"]
  ) ? e : [
    {
      label: t,
      value: "",
      attrs: {
        hidden: !0,
        disabled: !0,
        "data-is-placeholder": "true"
      }
    },
    ...e
  ];
}
function Pg(e) {
  const t = e.length > 0 ? e[0] : void 0;
  if (t)
    return dl(t) ? Pg(t.options) : "__original" in t ? t.__original : t.value;
}
function h3(e) {
  e.on("created", () => {
    var n, o, s;
    const t = _e((n = e.props.attrs) == null ? void 0 : n.multiple);
    !t && e.props.placeholder && Array.isArray(e.props.options) && (e.hook.prop(({ prop: a, value: r }, i) => (a === "options" && (r = $f(r, e.props.placeholder)), i({ prop: a, value: r }))), e.props.options = $f(
      e.props.options,
      e.props.placeholder
    )), t ? e.value === void 0 && e.input([], !1) : e.context && !e.context.options && (e.props.attrs = Object.assign({}, e.props.attrs, {
      value: e._value
    }), e.on("input", ({ payload: a }) => {
      e.props.attrs = Object.assign({}, e.props.attrs, {
        value: a
      });
    })), (o = e.context) != null && o.handlers && (e.context.handlers.selectInput = v3.bind(null, e), e.context.handlers.onChange = m3.bind(null, e)), (s = e.context) != null && s.fns && (e.context.fns.isSelected = f3.bind(null, e), e.context.fns.showPlaceholder = (a, r) => {
      if (!Array.isArray(e.props.options))
        return !1;
      const i = e.props.options.some(
        (l) => {
          if (l.attrs && "data-is-placeholder" in l.attrs)
            return !1;
          const c = "__original" in l ? l.__original : l.value;
          return we(a, c);
        }
      );
      return r && !i ? !0 : void 0;
    });
  }), e.hook.input((t, n) => {
    var o, s, a;
    return !e.props.placeholder && t === void 0 && Array.isArray((o = e.props) == null ? void 0 : o.options) && e.props.options.length && !_e((a = (s = e.props) == null ? void 0 : s.attrs) == null ? void 0 : a.multiple) && (t = Pg(e.props.options)), n(t);
  });
}
// @__NO_SIDE_EFFECTS__
function Xa(e) {
  return !!(bs(e) && e.if && e.if.startsWith("$slots.") && typeof e.then == "string" && e.then.startsWith("$slots.") && "else" in e);
}
// @__NO_SIDE_EFFECTS__
function g3(e, t = {}) {
  const n = /* @__PURE__ */ Ao(
    /* @__PURE__ */ oa(
      /* @__PURE__ */ cr("$label"),
      /* @__PURE__ */ lr(/* @__PURE__ */ rt("prefix"), /* @__PURE__ */ Pn(), e(), /* @__PURE__ */ In(), /* @__PURE__ */ rt("suffix"))
    ),
    /* @__PURE__ */ Dn("$help"),
    /* @__PURE__ */ oo(/* @__PURE__ */ no("$message.value"))
  );
  return (o = {}) => n(Xn(t, o));
}
// @__NO_SIDE_EFFECTS__
function zn(e, t, n) {
  const o = (s) => {
    const a = t(s);
    if (n || Za(a) && "if" in a || /* @__PURE__ */ Xa(a)) {
      const r = {
        if: e,
        then: a
      };
      return n && (r.else = n(s)), r;
    } else /* @__PURE__ */ Xa(a) ? Object.assign(a.else, { if: e }) : Za(a) && Object.assign(a, { if: e });
    return a;
  };
  return o._s = na(), o;
}
// @__NO_SIDE_EFFECTS__
function Es(e, t) {
  const n = (o) => {
    const s = e({});
    return /* @__PURE__ */ Xa(s) ? (Array.isArray(s.else) || (s.else = /* @__PURE__ */ zo(
      /* @__PURE__ */ zo(s.else, t),
      e._s ? o[e._s] : {}
    )), s) : /* @__PURE__ */ zo(
      /* @__PURE__ */ zo(s, t),
      e._s ? o[e._s] : {}
    );
  };
  return n._s = e._s, n;
}
var _f = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ Ao(
    /* @__PURE__ */ oo(/* @__PURE__ */ no("$message.value")),
    /* @__PURE__ */ oa(
      /* @__PURE__ */ UA(
        /* @__PURE__ */ rt("prefix"),
        /* @__PURE__ */ Pn(),
        /* @__PURE__ */ zA("$label || $ui.submit.value"),
        /* @__PURE__ */ In(),
        /* @__PURE__ */ rt("suffix")
      )
    ),
    /* @__PURE__ */ Dn("$help")
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "input",
  /**
   * The family of inputs this one belongs too. For example "text" and "email"
   * are both part of the "text" family. This is primary used for styling.
   */
  family: "button",
  /**
   * An array of extra props to accept for this input.
   */
  props: [],
  /**
   * Additional features that should be added to your input
   */
  features: [We("submit"), l3],
  /**
   * A key to use for memoizing the schema. This is used to prevent the schema
   * from needing to be stringified when performing a memo lookup.
   */
  schemaMemoKey: "h6st4epl3j8"
}, b3 = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ Ao(
    /* @__PURE__ */ zn(
      "$options == undefined",
      /**
       * Single checkbox structure.
       */
      /* @__PURE__ */ Ei(
        /* @__PURE__ */ Pi(/* @__PURE__ */ Pn(), /* @__PURE__ */ Di(), /* @__PURE__ */ Oi(/* @__PURE__ */ rt("decorator")), /* @__PURE__ */ In()),
        /* @__PURE__ */ Es(/* @__PURE__ */ Ii("$label"), {
          if: "$label"
        })
      ),
      /**
       * Multi checkbox structure.
       */
      /* @__PURE__ */ $g(
        /* @__PURE__ */ _g("$label"),
        /* @__PURE__ */ Dn("$help"),
        /* @__PURE__ */ yg(
          /* @__PURE__ */ bg(
            /* @__PURE__ */ Ei(
              /* @__PURE__ */ Pi(
                /* @__PURE__ */ Pn(),
                /* @__PURE__ */ Es(/* @__PURE__ */ Di(), {
                  bind: "$option.attrs",
                  attrs: {
                    id: "$option.attrs.id",
                    value: "$option.value",
                    checked: "$fns.isChecked($option.value)"
                  }
                }),
                /* @__PURE__ */ Oi(/* @__PURE__ */ rt("decorator")),
                /* @__PURE__ */ In()
              ),
              /* @__PURE__ */ Es(/* @__PURE__ */ Ii("$option.label"), {
                if: "$option.label"
              })
            ),
            /* @__PURE__ */ gg("$option.help")
          )
        )
      )
    ),
    // Help text only goes under the input when it is a single.
    /* @__PURE__ */ zn("$options == undefined && $help", /* @__PURE__ */ Dn("$help")),
    /* @__PURE__ */ oo(/* @__PURE__ */ no("$message.value"))
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "input",
  /**
   * The family of inputs this one belongs too. For example "text" and "email"
   * are both part of the "text" family. This is primary used for styling.
   */
  family: "box",
  /**
   * An array of extra props to accept for this input.
   */
  props: ["options", "onValue", "offValue", "optionsLoader"],
  /**
   * Additional features that should be added to your input
   */
  features: [
    xn,
    s3,
    Oe("decorator", "checkboxDecorator")
  ],
  /**
   * The key used to memoize the schema.
   */
  schemaMemoKey: "qje02tb3gu8"
}, y3 = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ Ao(
    /* @__PURE__ */ oa(
      /* @__PURE__ */ cr("$label"),
      /* @__PURE__ */ lr(
        /* @__PURE__ */ rt("prefix", "label"),
        /* @__PURE__ */ Pn(),
        /* @__PURE__ */ WA(),
        /* @__PURE__ */ qA(
          /* @__PURE__ */ jA(
            /* @__PURE__ */ rt("fileItem"),
            /* @__PURE__ */ KA("$file.name"),
            /* @__PURE__ */ zn(
              "$value.length === 1",
              /* @__PURE__ */ vf(
                /* @__PURE__ */ rt("fileRemove"),
                '$ui.remove.value + " " + $file.name'
              )
            )
          )
        ),
        /* @__PURE__ */ zn("$value.length > 1", /* @__PURE__ */ vf("$ui.removeAll.value")),
        /* @__PURE__ */ GA(/* @__PURE__ */ rt("noFiles"), "$ui.noFiles.value"),
        /* @__PURE__ */ In(),
        /* @__PURE__ */ rt("suffix")
      )
    ),
    /* @__PURE__ */ Dn("$help"),
    /* @__PURE__ */ oo(/* @__PURE__ */ no("$message.value"))
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "input",
  /**
   * The family of inputs this one belongs too. For example "text" and "email"
   * are both part of the "text" family. This is primary used for styling.
   */
  family: "text",
  /**
   * An array of extra props to accept for this input.
   */
  props: [],
  /**
   * Additional features that should be added to your input
   */
  features: [
    a3,
    Oe("fileItem", "fileItem"),
    Oe("fileRemove", "fileRemove"),
    Oe("noFiles", "noFiles")
  ],
  /**
   * The key used to memoize the schema.
   */
  schemaMemoKey: "9kqc4852fv8"
}, $3 = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ YA(
    "$slots.default",
    /* @__PURE__ */ oo(/* @__PURE__ */ no("$message.value")),
    /* @__PURE__ */ HA(/* @__PURE__ */ JA())
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "group",
  /**
   * An array of extra props to accept for this input.
   */
  props: [
    "actions",
    "submit",
    "submitLabel",
    "submitAttrs",
    "submitBehavior",
    "incompleteMessage"
  ],
  /**
   * Additional features that should be added to your input
   */
  features: [i3, fl],
  /**
   * The key used to memoize the schema.
   */
  schemaMemoKey: "5bg016redjo"
}, _3 = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ xp("$slots.default"),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "group",
  /**
   * An array of extra props to accept for this input.
   */
  props: [],
  /**
   * Additional features that should be added to your input
   */
  features: [fl, Cg]
}, w3 = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ wg(),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "input",
  /**
   * An array of extra props to accept for this input.
   */
  props: [],
  /**
   * Additional features that should be added to your input
   */
  features: [Ag]
}, C3 = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ xp("$slots.default"),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "list",
  /**
   * An array of extra props to accept for this input.
   */
  props: ["sync", "dynamic"],
  /**
   * Additional features that should be added to your input
   */
  features: [fl, Cg]
}, k3 = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ xp(),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "input",
  /**
   * An array of extra props to accept for this input.
   */
  props: [],
  /**
   * Additional features that should be added to your input
   */
  features: []
}, S3 = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ Ao(
    /* @__PURE__ */ zn(
      "$options == undefined",
      /**
       * Single radio structure.
       */
      /* @__PURE__ */ Ei(
        /* @__PURE__ */ Pi(/* @__PURE__ */ Pn(), /* @__PURE__ */ Di(), /* @__PURE__ */ Oi(/* @__PURE__ */ rt("decorator")), /* @__PURE__ */ In()),
        /* @__PURE__ */ Es(/* @__PURE__ */ Ii("$label"), {
          if: "$label"
        })
      ),
      /**
       * Multi radio structure.
       */
      /* @__PURE__ */ $g(
        /* @__PURE__ */ _g("$label"),
        /* @__PURE__ */ Dn("$help"),
        /* @__PURE__ */ yg(
          /* @__PURE__ */ bg(
            /* @__PURE__ */ Ei(
              /* @__PURE__ */ Pi(
                /* @__PURE__ */ Pn(),
                /* @__PURE__ */ Es(/* @__PURE__ */ Di(), {
                  bind: "$option.attrs",
                  attrs: {
                    id: "$option.attrs.id",
                    value: "$option.value",
                    checked: "$fns.isChecked($option.value)"
                  }
                }),
                /* @__PURE__ */ Oi(/* @__PURE__ */ rt("decorator")),
                /* @__PURE__ */ In()
              ),
              /* @__PURE__ */ Es(/* @__PURE__ */ Ii("$option.label"), {
                if: "$option.label"
              })
            ),
            /* @__PURE__ */ gg("$option.help")
          )
        )
      )
    ),
    // Help text only goes under the input when it is a single.
    /* @__PURE__ */ zn("$options == undefined && $help", /* @__PURE__ */ Dn("$help")),
    /* @__PURE__ */ oo(/* @__PURE__ */ no("$message.value"))
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "input",
  /**
   * The family of inputs this one belongs too. For example "text" and "email"
   * are both part of the "text" family. This is primary used for styling.
   */
  family: "box",
  /**
   * An array of extra props to accept for this input.
   */
  props: ["options", "onValue", "offValue", "optionsLoader"],
  /**
   * Additional features that should be added to your input
   */
  features: [xn, d3, Oe("decorator", "radioDecorator")],
  /**
   * The key used to memoize the schema.
   */
  schemaMemoKey: "qje02tb3gu8"
}, T3 = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ Ao(
    /* @__PURE__ */ oa(
      /* @__PURE__ */ cr("$label"),
      /* @__PURE__ */ lr(
        /* @__PURE__ */ rt("prefix"),
        /* @__PURE__ */ Pn(),
        /* @__PURE__ */ XA(
          /* @__PURE__ */ zn(
            "$slots.default",
            () => "$slots.default",
            /* @__PURE__ */ gf(
              /* @__PURE__ */ zn(
                "$option.group",
                /* @__PURE__ */ ZA(/* @__PURE__ */ gf(/* @__PURE__ */ hf("$option.label"))),
                /* @__PURE__ */ hf("$option.label")
              )
            )
          )
        ),
        /* @__PURE__ */ zn("$attrs.multiple !== undefined", () => "", /* @__PURE__ */ rt("select")),
        /* @__PURE__ */ In(),
        /* @__PURE__ */ rt("suffix")
      )
    ),
    /* @__PURE__ */ Dn("$help"),
    /* @__PURE__ */ oo(/* @__PURE__ */ no("$message.value"))
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "input",
  /**
   * An array of extra props to accept for this input.
   */
  props: ["options", "placeholder", "optionsLoader"],
  /**
   * Additional features that should be added to your input
   */
  features: [xn, h3, Oe("select", "select")],
  /**
   * The key used to memoize the schema.
   */
  schemaMemoKey: "cb119h43krg"
}, A3 = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ Ao(
    /* @__PURE__ */ oa(
      /* @__PURE__ */ cr("$label"),
      /* @__PURE__ */ lr(
        /* @__PURE__ */ rt("prefix", "label"),
        /* @__PURE__ */ Pn(),
        /* @__PURE__ */ QA(),
        /* @__PURE__ */ In(),
        /* @__PURE__ */ rt("suffix")
      )
    ),
    /* @__PURE__ */ Dn("$help"),
    /* @__PURE__ */ oo(/* @__PURE__ */ no("$message.value"))
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "input",
  /**
   * An array of extra props to accept for this input.
   */
  props: [],
  /**
   * Additional features that should be added to your input
   */
  features: [c3],
  /**
   * The key used to memoize the schema.
   */
  schemaMemoKey: "b1n0td79m9g"
}, At = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ Ao(
    /* @__PURE__ */ oa(
      /* @__PURE__ */ cr("$label"),
      /* @__PURE__ */ lr(
        /* @__PURE__ */ rt("prefix", "label"),
        /* @__PURE__ */ Pn(),
        /* @__PURE__ */ wg(),
        /* @__PURE__ */ In(),
        /* @__PURE__ */ rt("suffix")
      )
    ),
    /* @__PURE__ */ Dn("$help"),
    /* @__PURE__ */ oo(/* @__PURE__ */ no("$message.value"))
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "input",
  /**
   * The family of inputs this one belongs too. For example "text" and "email"
   * are both part of the "text" family. This is primary used for styling.
   */
  family: "text",
  /**
   * An array of extra props to accept for this input.
   */
  props: [],
  /**
   * Additional features that should be added to your input
   */
  features: [Ag],
  /**
   * The key used to memoize the schema.
   */
  schemaMemoKey: "c3cc4kflsg"
}, D3 = {
  button: _f,
  submit: _f,
  checkbox: b3,
  file: y3,
  form: $3,
  group: _3,
  hidden: w3,
  list: C3,
  meta: k3,
  radio: S3,
  select: T3,
  textarea: A3,
  text: At,
  color: At,
  date: At,
  datetimeLocal: At,
  email: At,
  month: At,
  number: At,
  password: At,
  search: At,
  tel: At,
  time: At,
  url: At,
  week: At,
  range: At
}, an = void 0, hn = null, xi, Ig = !1, Da = !1, P3 = /* @__PURE__ */ new Promise((e) => {
  xi = () => {
    Ig = !0, e();
  };
}), Wn = typeof window < "u" && typeof fetch < "u";
an = Wn ? /* @__PURE__ */ getComputedStyle(document.documentElement) : void 0;
var ks = {}, ec = {};
function I3(e, t, n, o) {
  t && Object.assign(ks, t), Wn && !Da && (an != null && an.getPropertyValue("--formkit-theme")) ? (xi(), Da = !0) : e && !Da && Wn ? E3(e) : !Da && Wn && xi();
  const s = function(r) {
    var i, l;
    r.addProps(["iconLoader", "iconLoaderUrl"]), r.props.iconHandler = wf(
      (i = r.props) != null && i.iconLoader ? r.props.iconLoader : o,
      (l = r.props) != null && l.iconLoaderUrl ? r.props.iconLoaderUrl : n
    ), M3(r, r.props.iconHandler), r.on("created", () => {
      var c, u;
      (c = r == null ? void 0 : r.context) != null && c.handlers && (r.context.handlers.iconClick = (p) => {
        const f = `on${p.charAt(0).toUpperCase()}${p.slice(1)}IconClick`, m = r.props[f];
        if (m && typeof m == "function")
          return (h) => m(r, h);
      }), (u = r == null ? void 0 : r.context) != null && u.fns && (r.context.fns.iconRole = (p) => {
        const f = `on${p.charAt(0).toUpperCase()}${p.slice(1)}IconClick`;
        return typeof r.props[f] == "function" ? "button" : null;
      });
    });
  };
  return s.iconHandler = wf(o, n), s;
}
function E3(e) {
  if (!(!e || !Wn || typeof getComputedStyle != "function") && (Da = !0, hn = document.getElementById("formkit-theme"), e && // if we have a window object
  Wn && // we don't have an existing theme OR the theme being set up is different
  (!(an != null && an.getPropertyValue("--formkit-theme")) && !hn || hn != null && hn.getAttribute("data-theme") && (hn == null ? void 0 : hn.getAttribute("data-theme")) !== e))) {
    const n = `https://cdn.jsdelivr.net/npm/@formkit/themes@${Si.startsWith("__") ? "latest" : Si}/dist/${e}/theme.css`, o = document.createElement("link");
    o.type = "text/css", o.rel = "stylesheet", o.id = "formkit-theme", o.setAttribute("data-theme", e), o.onload = () => {
      an = getComputedStyle(document.documentElement), xi();
    }, document.head.appendChild(o), o.href = n, hn && hn.remove();
  }
}
function wf(e, t) {
  return (n) => {
    if (typeof n != "string")
      return;
    if (n.startsWith("<svg"))
      return n;
    const o = n.startsWith("default:");
    n = o ? n.split(":")[1] : n;
    const s = n in ks;
    let a;
    if (s)
      return ks[n];
    if (!ec[n]) {
      if (a = O3(n), a = Wn && typeof a > "u" ? Promise.resolve(a) : a, a instanceof Promise)
        ec[n] = a.then((r) => !r && typeof n == "string" && !o ? a = typeof e == "function" ? e(n) : x3(n, t) : r).then((r) => (typeof n == "string" && (ks[o ? `default:${n}` : n] = r), r));
      else if (typeof a == "string")
        return ks[o ? `default:${n}` : n] = a, a;
    }
    return ec[n];
  };
}
function O3(e) {
  if (Wn)
    return Ig ? Cf(e) : P3.then(() => Cf(e));
}
function Cf(e) {
  const t = an == null ? void 0 : an.getPropertyValue(`--fk-icon-${e}`);
  if (t) {
    const n = atob(t);
    if (n.startsWith("<svg"))
      return ks[e] = n, n;
  }
}
function x3(e, t) {
  const n = Si.startsWith("__") ? "latest" : Si, o = typeof t == "function" ? t(e) : `https://cdn.jsdelivr.net/npm/@formkit/icons@${n}/dist/icons/${e}.svg`;
  if (Wn)
    return fetch(`${o}`).then(async (s) => {
      const a = await s.text();
      if (a.startsWith("<svg"))
        return a;
    }).catch((s) => {
      console.error(s);
    });
}
function M3(e, t) {
  const n = /^[a-zA-Z-]+(?:-icon|Icon)$/;
  Object.keys(e.props).filter((s) => n.test(s)).forEach((s) => L3(e, t, s));
}
function L3(e, t, n) {
  const o = e.props[n], s = t(o), a = `_raw${n.charAt(0).toUpperCase()}${n.slice(1)}`, r = `on${n.charAt(0).toUpperCase()}${n.slice(1)}Click`;
  if (e.addProps([a, r]), e.on(`prop:${n}`, N3), s instanceof Promise)
    return s.then((i) => {
      e.props[a] = i;
    });
  e.props[a] = s;
}
function N3(e) {
  var r;
  const t = e.origin, n = e.payload, o = (r = t == null ? void 0 : t.props) == null ? void 0 : r.iconHandler, s = e.name.split(":")[1], a = `_raw${s.charAt(0).toUpperCase()}${s.slice(1)}`;
  if (o && typeof o == "function") {
    const i = o(n);
    if (i instanceof Promise)
      return i.then((l) => {
        t.props[a] = l;
      });
    t.props[a] = i;
  }
}
var kf = {
  /**
   * FormKit errors:
   */
  100: ({ data: e }) => `Only groups, lists, and forms can have children (${e.name}).`,
  101: ({ data: e }) => `You cannot directly modify the store (${e.name}). See: https://formkit.com/advanced/core#message-store`,
  102: ({
    data: [e, t]
  }) => `You cannot directly assign node.${t} (${e.name})`,
  103: ({ data: [e] }) => `Schema expressions cannot start with an operator (${e})`,
  104: ({ data: [e, t] }) => `Schema expressions cannot end with an operator (${e} in "${t}")`,
  105: ({ data: e }) => `Invalid schema expression: ${e}`,
  106: ({ data: e }) => `Cannot submit because (${e}) is not in a form.`,
  107: ({ data: [e, t] }) => `Cannot set ${e.name} to non object value: ${t}`,
  108: ({ data: [e, t] }) => `Cannot set ${e.name} to non array value: ${t}`,
  /**
   * Input specific errors:
   */
  300: ({ data: [e] }) => `Cannot set behavior prop to overscroll (on ${e.name} input) when options prop is a function.`,
  /**
   * FormKit vue errors:
   */
  600: ({ data: e }) => `Unknown input type${typeof e.props.type == "string" ? ' "' + e.props.type + '"' : ""} ("${e.name}")`,
  601: ({ data: e }) => `Input definition${typeof e.props.type == "string" ? ' "' + e.props.type + '"' : ""} is missing a schema or component property (${e.name}).`
}, Sf = {
  /**
   * Core warnings:
   */
  150: ({ data: e }) => `Schema function "${e}()" is not a valid function.`,
  151: ({ data: e }) => `No form element with id: ${e}`,
  152: ({ data: e }) => `No input element with id: ${e}`,
  /**
   * Input specific warnings:
   */
  350: ({
    data: { node: e, inputType: t }
  }) => `Invalid options prop for ${e.name} input (${t}). See https://formkit.com/inputs/${t}`,
  /**
   * Vue warnings:
   */
  650: 'Schema "$get()" must use the id of an input to access.',
  651: ({ data: e }) => `Cannot setErrors() on "${e}" because no such id exists.`,
  652: ({ data: e }) => `Cannot clearErrors() on "${e}" because no such id exists.`,
  /**
   * Deprecation warnings:
   */
  800: ({ data: e }) => `${e} is deprecated.`
}, F3 = (e, t) => {
  if (e.code in kf) {
    const n = kf[e.code];
    e.message = typeof n == "function" ? n(e) : n;
  }
  return t(e);
}, Tf = !1;
function R3() {
  Tf || (Tp(F3), Ap(V3), Tf = !0);
}
var V3 = (e, t) => {
  if (e.code in Sf) {
    const n = Sf[e.code];
    e.message = typeof n == "function" ? n(e) : n;
  }
  return t(e);
}, B3 = Object.defineProperty, H3 = Object.getOwnPropertyNames, Eg = (e, t) => function() {
  return e && (t = (0, e[H3(e)[0]])(e = 0)), t;
}, U3 = (e, t) => {
  for (var n in t)
    B3(e, n, { get: t[n], enumerable: !0 });
}, Af, Og, xg = Eg({
  "packages/vue/src/bindings.ts"() {
    Af = function(t) {
      t.ledger.count("blocking", (P) => P.blocking);
      const n = R(!t.ledger.value("blocking"));
      t.ledger.count("errors", (P) => P.type === "error");
      const o = R(!!t.ledger.value("errors"));
      let s = !1;
      rn(() => {
        s = !0;
      });
      const a = tt(
        t.store.reduce((P, E) => (E.visible && (P[E.key] = E), P), {})
      ), r = R(
        t.props.validationVisibility || (t.props.type === "checkbox" ? "dirty" : "blur")
      );
      t.on("prop:validationVisibility", ({ payload: P }) => {
        r.value = P;
      });
      const i = R(r.value === "live"), l = R(!1), c = (P) => {
        l.value = (P ?? []).some(
          (E) => E.name === "required"
        );
      };
      c(t.props.parsedRules), t.on("prop:parsedRules", ({ payload: P }) => c(P));
      const u = R(t.children.map((P) => P.uid)), p = V(() => {
        if (!I.state)
          return !1;
        if (I.state.submitted)
          return !0;
        if (!i.value && !I.state.settled)
          return !1;
        switch (r.value) {
          case "live":
            return !0;
          case "blur":
            return I.state.blurred;
          case "dirty":
            return I.state.dirty;
          default:
            return !1;
        }
      }), f = V(() => I.state.failing && p.value), m = V(() => I && h.value ? n.value && !o.value : I.state.dirty && !Zt(I.value)), h = R(
        Array.isArray(t.props.parsedRules) && t.props.parsedRules.length > 0
      );
      t.on("prop:parsedRules", ({ payload: P }) => {
        h.value = Array.isArray(P) && P.length > 0;
      });
      const g = V(() => {
        const P = {};
        for (const E in a) {
          const B = a[E];
          (B.type !== "validation" || p.value) && (P[E] = B);
        }
        return P;
      }), _ = tt(
        t.store.reduce((P, E) => (E.type === "ui" && E.visible && (P[E.key] = E), P), {})
      ), v = V(() => !I.state.failing), w = tt({}), y = new Proxy(w, {
        get(...P) {
          if (!t)
            return "";
          const [E, B] = P;
          let N = Reflect.get(...P);
          return !N && typeof B == "string" && !Ae(E, B) && !B.startsWith("__v") && pl(t).watch((j) => {
            const ee = typeof j.config.rootClasses == "function" ? j.config.rootClasses(B, j) : {}, te = j.config.classes ? Gr(B, j, j.config.classes[B]) : {}, ce = Gr(
              B,
              j,
              j.props[`_${B}Class`]
            ), H = Gr(
              B,
              j,
              j.props[`${B}Class`]
            );
            N = XS(
              j,
              B,
              ee,
              te,
              ce,
              H
            ), E[B] = N ?? "";
          }), N;
        }
      });
      t.on("prop:rootClasses", () => {
        const P = Object.keys(w);
        for (const E of P)
          delete w[E];
      });
      const $ = V(() => {
        if (!t)
          return;
        const P = [];
        I.help && P.push(`help-${t.props.id}`);
        for (const E in g.value)
          P.push(`${t.props.id}-${E}`);
        return P.length ? P.join(" ") : void 0;
      }), S = R(t.value), A = R(t.value), I = tt({
        _value: A,
        attrs: t.props.attrs,
        disabled: t.props.disabled,
        describedBy: $,
        fns: {
          length: (P) => Object.keys(P).length,
          number: (P) => Number(P),
          string: (P) => String(P),
          json: (P) => JSON.stringify(P),
          eq: we
        },
        handlers: {
          blur: (P) => {
            t && (t.store.set(
              /* @__PURE__ */ ct({ key: "blurred", visible: !1, value: !0 })
            ), typeof t.props.attrs.onBlur == "function" && t.props.attrs.onBlur(P));
          },
          touch: () => {
            var B;
            const P = I.dirtyBehavior === "compare";
            if ((B = t.store.dirty) != null && B.value && !P)
              return;
            const E = !we(t.props._init, t._value);
            !E && !P || t.store.set(
              /* @__PURE__ */ ct({ key: "dirty", visible: !1, value: E })
            );
          },
          DOMInput: (P) => {
            t.input(P.target.value), t.emit("dom-input-event", P);
          }
        },
        help: t.props.help,
        id: t.props.id,
        items: u,
        label: t.props.label,
        messages: g,
        didMount: !1,
        node: il(t),
        options: t.props.options,
        defaultMessagePlacement: !0,
        slots: t.props.__slots,
        state: {
          blurred: !1,
          complete: m,
          dirty: !1,
          empty: Zt(S),
          submitted: !1,
          settled: t.isSettled,
          valid: n,
          invalid: f,
          errors: o,
          rules: h,
          validationVisible: p,
          required: l,
          failing: !1,
          passing: v
        },
        type: t.props.type,
        family: t.props.family,
        ui: _,
        value: S,
        classes: y
      });
      t.on("created", () => {
        we(I.value, t.value) || (A.value = t.value, S.value = t.value, kr(S), kr(A)), (async () => (await t.settled, t && (t.props._init = jt(t.value))))();
      }), t.on("mounted", () => {
        I.didMount = !0;
      }), t.on("settled", ({ payload: P }) => {
        I.state.settled = P;
      });
      function D(P) {
        (Array.isArray(P) ? P : Object.keys(P)).forEach((B) => {
          B = Is(B), Ae(I, B) || (I[B] = t.props[B]), t.on(`prop:${B}`, ({ payload: N }) => {
            I[B] = N;
          });
        });
      }
      D((() => {
        const P = [
          "__root",
          "help",
          "label",
          "disabled",
          "options",
          "type",
          "attrs",
          "preserve",
          "preserveErrors",
          "id",
          "dirtyBehavior"
        ], E = /^[a-zA-Z-]+(?:-icon|Icon)$/, B = Object.keys(t.props).filter((N) => E.test(N));
        return P.concat(B);
      })());
      function x(P) {
        P.props && D(P.props);
      }
      t.props.definition && x(t.props.definition), t.on("added-props", ({ payload: P }) => D(P)), t.on("input", ({ payload: P }) => {
        t.type !== "input" && !Pt(P) && !Xc(P) ? A.value = ru(P) : (A.value = P, kr(A));
      }), t.on("commitRaw", ({ payload: P }) => {
        t.type !== "input" && !Pt(P) && !Xc(P) ? S.value = A.value = ru(P) : (S.value = A.value = P, kr(S)), t.emit("modelUpdated");
      }), t.on("commit", ({ payload: P }) => {
        var E;
        if ((!I.state.dirty || I.dirtyBehavior === "compare") && t.isCreated && s)
          if (!((E = t.store.validating) != null && E.value))
            I.handlers.touch();
          else {
            const B = t.on("message-removed", ({ payload: N }) => {
              N.key === "validating" && (I.handlers.touch(), t.off(B));
            });
          }
        m && t.type === "input" && o.value && !_e(t.props.preserveErrors) && t.store.filter(
          (B) => {
            var N;
            return !(B.type === "error" && ((N = B.meta) == null ? void 0 : N.autoClear) === !0);
          }
        ), t.type === "list" && t.sync && (u.value = t.children.map((B) => B.uid)), I.state.empty = Zt(P);
      });
      const F = async (P) => {
        P.type === "ui" && P.visible && !P.meta.showAsMessage ? _[P.key] = P : P.visible ? a[P.key] = P : P.type === "state" && (I.state[P.key] = !!P.value);
      };
      t.on("message-added", (P) => F(P.payload)), t.on("message-updated", (P) => F(P.payload)), t.on("message-removed", ({ payload: P }) => {
        delete _[P.key], delete a[P.key], delete I.state[P.key];
      }), t.on("settled:blocking", () => {
        n.value = !0;
      }), t.on("unsettled:blocking", () => {
        n.value = !1;
      }), t.on("settled:errors", () => {
        o.value = !1;
      }), t.on("unsettled:errors", () => {
        o.value = !0;
      }), le(p, (P) => {
        P && (i.value = !0);
      }), t.context = I, t.emit("context", t, !1), t.on("destroyed", () => {
        t.context = void 0, t = null;
      });
    }, Og = Af;
  }
}), z3 = {};
U3(z3, {
  defaultConfig: () => Mp
});
var Mp, W3 = Eg({
  "packages/vue/src/defaultConfig.ts"() {
    xg(), Mp = (e = {}) => {
      R3();
      const {
        rules: t = {},
        locales: n = {},
        inputs: o = {},
        messages: s = {},
        locale: a = void 0,
        theme: r = void 0,
        iconLoaderUrl: i = void 0,
        iconLoader: l = void 0,
        icons: c = {},
        ...u
      } = e, p = bA({
        ...gA,
        ...t || {}
      }), f = FA(
        Xn({ en: hg, ...n || {} }, s)
      ), m = RA(D3, o), h = I3(r, c, i, l);
      return Xn(
        {
          plugins: [m, h, Og, f, p],
          ...a ? { config: { locale: a } } : {}
        },
        u || {},
        !0
      );
    };
  }
}), j3 = typeof window > "u", tc = /* @__PURE__ */ new Map();
function q3(e, t) {
  var n;
  !j3 || !e || (tc.has(e) || tc.set(e, /* @__PURE__ */ new Set()), (n = tc.get(e)) == null || n.add(t));
}
var Mg = typeof window > "u", xa = {}, Os = {}, Ct, Vn = /* @__PURE__ */ new WeakMap(), K3 = "__raw__", Y3 = /[a-zA-Z0-9\-][cC]lass$/;
function G3(e, t) {
  const n = R(null);
  if (e === "get") {
    const s = {};
    return n.value = Z3.bind(null, s), n;
  }
  const o = e.split(".");
  return Wt(() => {
    n.value = Lp(
      Pt(t) ? t.value : t,
      o
    );
  }), n;
}
function Lp(e, t) {
  if (Array.isArray(e)) {
    for (const s of e) {
      const a = s !== !1 && Lp(s, t);
      if (a !== void 0)
        return a;
    }
    return;
  }
  let n, o = e;
  for (const s in t) {
    const a = t[s];
    if (typeof o != "object" || o === null) {
      n = void 0;
      break;
    }
    const r = o[a];
    if (Number(s) === t.length - 1 && r !== void 0) {
      n = typeof r == "function" ? r.bind(o) : r;
      break;
    }
    o = r;
  }
  return n;
}
function Z3(e, t) {
  if (typeof t != "string")
    return To(650);
  if (t in e || (e[t] = R(void 0)), e[t].value === void 0) {
    e[t].value = null;
    const n = rr(t);
    n && (e[t].value = n.context), nS(t, ({ payload: o }) => {
      e[t].value = ir(o) ? o.context : o;
    });
  }
  return e[t].value;
}
function Df(e, t, n) {
  function o(m, h) {
    const g = p(nn(h.if), { if: !0 }), _ = c(m, h.then), v = h.else ? c(m, h.else) : null;
    return [g, _, v];
  }
  function s(m, h) {
    var w, y;
    const g = p(nn(m.if));
    let _ = () => h, v = () => h;
    return typeof m.then == "object" ? v = a(m.then, void 0) : typeof m.then == "string" && ((w = m.then) != null && w.startsWith("$")) ? v = p(nn(m.then)) : v = () => m.then, Ae(m, "else") && (typeof m.else == "object" ? _ = a(m.else) : typeof m.else == "string" && ((y = m.else) != null && y.startsWith("$")) ? _ = p(nn(m.else)) : _ = () => m.else), () => g() ? v() : _();
  }
  function a(m, h, g = {}) {
    const _ = new Set(Object.keys(m || {})), v = h ? p(nn(h)) : () => ({}), w = [
      (y) => {
        const $ = v();
        for (const S in $)
          _.has(S) || (y[S] = $[S]);
      }
    ];
    if (m) {
      if (bs(m))
        return s(
          m,
          g
        );
      for (let y in m) {
        const $ = m[y];
        let S;
        const A = typeof $ == "string";
        y.startsWith(K3) ? (y = y.substring(7), S = () => $) : A && $.startsWith("$") && $.length > 1 && !($.startsWith("$reset") && Y3.test(y)) ? S = p(nn($)) : typeof $ == "object" && bs($) ? S = s($, void 0) : typeof $ == "object" && $o($) ? S = a($) : S = () => $, w.push((I) => {
          I[y] = S();
        });
      }
    }
    return () => {
      const y = Array.isArray(m) ? [] : {};
      return w.forEach(($) => $(y)), y;
    };
  }
  function r(m, h) {
    let g = null, _ = () => null, v = !1, w = null, y = null, $ = null, S = !1;
    const A = ZS(h);
    if (Xo(A) ? (g = A.$el, _ = A.$el !== "text" ? a(A.attrs, A.bind) : () => null) : Ga(A) ? (typeof A.$cmp == "string" ? Ae(m, A.$cmp) ? g = m[A.$cmp] : (g = A.$cmp, S = !0) : g = A.$cmp, _ = a(A.props, A.bind)) : bs(A) && ([v, w, y] = o(m, A)), !bs(A) && "if" in A ? v = p(nn(A.if)) : !bs(A) && g === null && (v = () => !0), "children" in A && A.children)
      if (typeof A.children == "string")
        if (A.children.startsWith("$slots."))
          g = g === "text" ? "slot" : g, w = p(nn(A.children));
        else if (A.children.startsWith("$") && A.children.length > 1) {
          const I = p(nn(A.children));
          w = () => String(I());
        } else
          w = () => String(A.children);
      else if (Array.isArray(A.children))
        w = c(m, A.children);
      else {
        const [I, D, O] = o(m, A.children);
        w = (x) => I && I() ? D && D(x) : O && O(x);
      }
    if (Ga(A))
      if (w) {
        const I = w;
        w = (D) => ({
          default(O, x) {
            var E, B, N, Y;
            const F = Ct;
            x && (Ct = x), O && ((E = Vn.get(Ct)) == null || E.unshift(O)), D && ((B = Vn.get(Ct)) == null || B.unshift(D));
            const P = I(D);
            return O && ((N = Vn.get(Ct)) == null || N.shift()), D && ((Y = Vn.get(Ct)) == null || Y.shift()), Ct = F, P;
          }
        }), w.slot = !0;
      } else
        w = () => ({});
    if ("for" in A && A.for) {
      const I = A.for.length === 3 ? A.for[2] : A.for[1];
      $ = [
        typeof I == "string" && I.startsWith("$") ? p(nn(I)) : () => I,
        A.for[0],
        A.for.length === 3 ? String(A.for[1]) : null
      ];
    }
    return [v, g, _, w, y, $, S];
  }
  function i(m, h) {
    const g = m(h), _ = Ct;
    return Object.keys(g).reduce((v, w) => {
      const y = g && g[w];
      return v[w] = ($) => y && y($, _) || null, v;
    }, {});
  }
  function l(m, h) {
    const [g, _, v, w, y, $, S] = r(m, h);
    let A = (I) => {
      if (g && _ === null && w)
        return g() ? w(I) : y && y(I);
      if (_ && (!g || g())) {
        if (_ === "text" && w)
          return ne(String(w()));
        if (_ === "slot" && w)
          return w(I);
        const D = S ? ut(_) : _, O = w != null && w.slot ? i(w, I) : null;
        return za(
          D,
          v(),
          O || (w ? w(I) : [])
        );
      }
      return typeof y == "function" ? y(I) : y;
    };
    if ($) {
      const I = A, [D, O, x] = $;
      A = () => {
        const F = D(), P = Number.isFinite(F) ? Array(Number(F)).fill(0).map((Y, j) => j) : F, E = [];
        if (typeof P != "object")
          return null;
        const B = Vn.get(Ct) || [], N = Array.isArray(P);
        for (const Y in P) {
          if (N && Y in Array.prototype)
            continue;
          const j = Object.defineProperty(
            {
              ...B.reduce(
                (ee, te) => ee.__idata ? { ...ee, ...te } : te,
                {}
              ),
              [O]: P[Y],
              ...x !== null ? { [x]: N ? Number(Y) : Y } : {}
            },
            "__idata",
            { enumerable: !1, value: !0 }
          );
          B.unshift(j), E.push(I.bind(null, j)()), B.shift();
        }
        return E;
      };
    }
    return A;
  }
  function c(m, h) {
    if (Array.isArray(h)) {
      const _ = h.map(l.bind(null, m));
      return (v) => _.map((w) => w(v));
    }
    const g = l(m, h);
    return (_) => g(_);
  }
  const u = [];
  function p(m, h = {}) {
    const g = /* @__PURE__ */ new WeakMap();
    return u.push((_, v) => {
      g.set(
        v,
        m.provide((w) => _(w, h))
      );
    }), () => g.get(Ct)();
  }
  function f(m, h) {
    n ?? (n = Ng(t));
    const [g, _] = Ae(xa, n) ? xa[n] : [c(e, t), u];
    return Mg || (Os[n] ?? (Os[n] = 0), Os[n]++, xa[n] = [g, _]), _.forEach((v) => {
      v(m, h);
    }), () => (Ct = h, g());
  }
  return f;
}
function Lg(e, t) {
  const n = Vn.get(Ct) || [];
  let o;
  return n.length && (o = Lp(n, e.split("."))), o === void 0 ? t : o;
}
function X3(e, t) {
  return new Proxy(e, {
    get(...n) {
      let o;
      const s = n[1];
      if (typeof s == "string") {
        const a = Ct;
        Ct = t, o = Lg(s, void 0), Ct = a;
      }
      return o !== void 0 ? o : Reflect.get(...n);
    }
  });
}
function Pf(e, t, n) {
  return e(
    (o, s = {}) => o.reduce((a, r) => {
      if (r.startsWith("slots.")) {
        const i = r.substring(6), l = () => t.slots && Ae(t.slots, i) && typeof t.slots[i] == "function";
        if (s.if)
          a[r] = l;
        else if (t.slots) {
          const c = X3(t, n);
          a[r] = () => l() ? t.slots[i](c) : null;
        }
      } else {
        const i = G3(r, t);
        a[r] = () => Lg(r, i.value);
      }
      return a;
    }, {}),
    n
  );
}
function If(e, t, n) {
  if (t ?? (t = Ng(e)), Os[t]--, Os[t] === 0) {
    delete Os[t];
    const [, o] = xa[t];
    delete xa[t], o.length = 0;
  }
  Vn.delete(n);
}
function Ng(e) {
  return JSON.stringify(e, (t, n) => typeof n == "function" ? n.toString() : n);
}
var Fg = /* @__PURE__ */ K({
  name: "FormKitSchema",
  props: {
    schema: {
      type: [Array, Object],
      required: !0
    },
    data: {
      type: Object,
      default: () => ({})
    },
    library: {
      type: Object,
      default: () => ({})
    },
    memoKey: {
      type: String,
      required: !1
    }
  },
  emits: ["mounted"],
  setup(e, t) {
    var c;
    const n = bo();
    let o = {};
    Vn.set(o, []);
    const s = { FormKit: il(Np), ...e.library };
    let a = Df(s, e.schema, e.memoKey), r, i;
    Mg || le(
      () => e.schema,
      (u, p) => {
        var m;
        const f = o;
        o = {}, Vn.set(o, []), a = Df(s, e.schema, e.memoKey), r = Pf(a, i, o), u === p && ((m = n == null ? void 0 : n.proxy) == null ? void 0 : m.$forceUpdate).call(m), If(e.schema, e.memoKey, f);
      },
      { deep: !0 }
    ), Wt(() => {
      i = Object.assign(tt(e.data ?? {}), {
        slots: t.slots
      }), t.slots, r = Pf(a, i, o);
    });
    function l() {
      If(e.schema, e.memoKey, o), i && (i.node && i.node.destroy(), i.slots = null, i = null), r = null;
    }
    return Re(() => t.emit("mounted")), Xu(l), q3((c = bo()) == null ? void 0 : c.appContext.app, l), () => r ? r() : null;
  }
}), Rg = Fg, J3 = typeof window > "u", mu = Symbol("FormKitParent"), Q3 = Symbol("FormKitComponentCallback");
function eD(e, t) {
  const n = iD(e, t);
  if (n.props.definition || Et(600, n), n.props.definition.component)
    return () => {
      var c;
      return za(
        (c = n.props.definition) == null ? void 0 : c.component,
        {
          context: n.context
        },
        { ...t.slots }
      );
    };
  const o = R([]);
  let s = n.props.definition.schemaMemoKey;
  const a = () => {
    var u, p;
    const c = (p = (u = n.props) == null ? void 0 : u.definition) == null ? void 0 : p.schema;
    c || Et(601, n), typeof c == "function" ? (o.value = c({ ...e.sectionsSchema || {} }), (s && e.sectionsSchema || "memoKey" in c && typeof c.memoKey == "string") && (s = (s ?? (c == null ? void 0 : c.memoKey)) + JSON.stringify(e.sectionsSchema))) : o.value = c;
  };
  a(), J3 || n.on("schema", () => {
    s += "♻️", a();
  }), t.emit("node", n);
  const r = n.props.definition.library, i = {
    FormKit: il(Vg),
    ...r,
    ...e.library ?? {}
  };
  function l() {
    n.emit("mounted");
  }
  return t.expose({ node: n }), () => za(
    Fg,
    {
      schema: o.value,
      data: n.context,
      onMounted: l,
      library: i,
      memoKey: s
    },
    { ...t.slots }
  );
}
var Vg = /* @__PURE__ */ K(
  eD,
  {
    props: VA,
    inheritAttrs: !1
  }
), Np = Vg, tD = Symbol();
function nD(e, t) {
  return e.component(t.alias || "FormKit", Np).component(t.schemaAlias || "FormKitSchema", Rg), {
    get: rr,
    setLocale: (n) => {
      var o;
      (o = t.config) != null && o.rootConfig && (t.config.rootConfig.locale = n);
    },
    clearErrors: QS,
    setErrors: JS,
    submit: Yh,
    reset: Gh
  };
}
var Bg = Symbol.for("FormKitOptions"), oD = Symbol.for("FormKitConfig"), Sre = {
  install(e, t) {
    const n = Object.assign(
      {
        alias: "FormKit",
        schemaAlias: "FormKitSchema"
      },
      typeof t == "function" ? t() : t
    ), o = oS(n.config || {});
    n.config = { rootConfig: o }, e.config.globalProperties.$formkit = nD(e, n), e.provide(Bg, n), e.provide(oD, o), typeof window < "u" && (globalThis.__FORMKIT_CONFIGS__ = (globalThis.__FORMKIT_CONFIGS__ || []).concat([o]));
  }
}, sD = typeof window < "u", nc = [
  // Boolean props
  "ignore",
  "disabled",
  "preserve",
  // String props
  "help",
  "label",
  /^preserve(-e|E)rrors/,
  /^[a-z]+(?:-visibility|Visibility|-behavior|Behavior)$/,
  /^[a-zA-Z-]+(?:-class|Class)$/,
  "prefixIcon",
  "suffixIcon",
  /^[a-zA-Z-]+(?:-icon|Icon)$/
], aD = ["disabled", "ignore", "preserve"];
function Ef(e, t) {
  t.classes && Object.keys(t.classes).forEach(
    (n) => {
      typeof n == "string" && (e.props[`_${n}Class`] = t.classes[n], Ps(t.classes[n]) && n === "inner" && Object.values(t.classes[n]));
    }
  );
}
function rD(e) {
  return e ? ["Submit", "SubmitRaw", "SubmitInvalid"].reduce(
    (n, o) => {
      const s = `on${o}`;
      return s in e && typeof e[s] == "function" && (n[s] = e[s]), n;
    },
    {}
  ) : {};
}
function iD(e, t, n = {}) {
  const o = Object.assign({}, Ye(Bg) || {}, n), s = Ye(tD, R(sD ? document : void 0)), a = Ye(Q3, () => {
  }), r = bo(), i = rD(r == null ? void 0 : r.vnode.props), l = ["modelValue", "model-value"].some(
    (A) => A in ((r == null ? void 0 : r.vnode.props) ?? {})
  );
  let c = !1;
  Re(() => {
    c = !0;
  });
  const u = e.modelValue !== void 0 ? e.modelValue : jt(t.attrs.value);
  function p() {
    const A = {
      ...cs(e),
      ...i,
      type: e.type ?? "text",
      __root: s.value,
      __slots: t.slots
    }, I = sf(cs(t.attrs), nc);
    I.key || (I.key = na()), A.attrs = I;
    const D = af(cs(t.attrs), nc);
    for (const x in D)
      aD.includes(x) && D[x] === "" && (D[x] = !0), A[Is(x)] = D[x];
    const O = { props: {} };
    return Ef(O, e), Object.assign(A, O.props), typeof A.type != "string" && (A.definition = A.type, delete A.type), A;
  }
  const f = p(), m = f.ignore ? null : e.parent || Ye(mu, null), h = YS(
    Xn(
      o || {},
      {
        name: e.name || void 0,
        value: u,
        parent: m,
        plugins: (o.plugins || []).concat(e.plugins ?? []),
        config: e.config || {},
        props: f,
        index: e.index,
        sync: !!_e(t.attrs.sync || t.attrs.dynamic)
      },
      !1,
      !0
    )
  );
  a(h), h.props.definition || Et(600, h);
  const g = R(
    new Set(
      Array.isArray(h.props.__propDefs) ? h.props.__propDefs : Object.keys(h.props.__propDefs ?? {})
    )
  );
  h.on(
    "added-props",
    ({ payload: A }) => {
      (Array.isArray(A) ? A : Object.keys(A ?? {})).forEach((D) => g.value.add(D));
    }
  );
  const _ = V(
    () => nc.concat([...g.value]).reduce((A, I) => (typeof I == "string" ? (A.push(Is(I)), A.push(zh(I))) : A.push(I), A), [])
  );
  Wt(() => Ef(h, e));
  const v = cs(e);
  for (const A in v)
    le(
      () => e[A],
      () => {
        e[A] !== void 0 && (h.props[A] = e[A]);
      }
    );
  Wt(() => {
    h.props.__root = s.value;
  });
  const w = /* @__PURE__ */ new Set(), y = cs(t.attrs);
  Wt(() => {
    $(af(y, _.value));
  });
  function $(A) {
    w.forEach((I) => {
      I(), w.delete(I);
    });
    for (const I in A) {
      const D = Is(I);
      w.add(
        le(
          () => t.attrs[I],
          () => {
            h.props[D] = t.attrs[I];
          }
        )
      );
    }
  }
  if (Wt(() => {
    const A = sf(cs(t.attrs), _.value);
    "multiple" in A && (A.multiple = _e(A.multiple)), typeof A.onBlur == "function" && (A.onBlur = Nk(A.onBlur)), h.props.attrs = Object.assign({}, h.props.attrs || {}, A);
  }), Wt(() => {
    const A = (e.errors ?? []).map(
      (I) => /* @__PURE__ */ ct({
        key: kp(I),
        type: "error",
        value: I,
        meta: { source: "prop" }
      })
    );
    h.store.apply(
      A,
      (I) => I.type === "error" && I.meta.source === "prop"
    );
  }), h.type !== "input") {
    const A = `${h.name}-prop`;
    Wt(() => {
      const I = e.inputErrors ?? {}, D = Object.keys(I);
      D.length || h.clearErrors(!0, A);
      const O = D.reduce((x, F) => {
        let P = I[F];
        return typeof P == "string" && (P = [P]), Array.isArray(P) && (x[F] = P.map(
          (E) => /* @__PURE__ */ ct({
            key: E,
            type: "error",
            value: E,
            meta: { source: A }
          })
        )), x;
      }, {});
      h.store.apply(
        O,
        (x) => x.type === "error" && x.meta.source === A
      );
    });
  }
  Wt(() => Object.assign(h.config, e.config)), h.type !== "input" && Zc(mu, h);
  let S;
  return h.on("modelUpdated", () => {
    var A, I;
    t.emit("inputRaw", (A = h.context) == null ? void 0 : A.value, h), c && t.emit("input", (I = h.context) == null ? void 0 : I.value, h), l && h.context && (S = jt(h.value), t.emit("update:modelValue", ru(h.value)));
  }), l && (le(
    Wo(e, "modelValue"),
    (A) => {
      we(S, A) || h.input(A, !1);
    },
    { deep: !0 }
  ), h.value !== u && h.emit("modelUpdated")), Jt(() => h.destroy()), h;
}
var lD = 1;
function cD(e) {
  return typeof e == "function" && e.length === 2 || typeof e == "object" && !Array.isArray(e) && !("$el" in e) && !("$cmp" in e) && !("if" in e);
}
function Hg(e, t = {}, n = {}) {
  const o = {
    type: "input",
    ...t
  };
  let s;
  if (cD(e)) {
    const a = `SchemaComponent${lD++}`;
    s = /* @__PURE__ */ Te("input", () => ({
      $cmp: a,
      props: {
        context: "$node.context"
      }
    })), o.library = { [a]: il(e) };
  } else typeof e == "function" ? s = e : s = /* @__PURE__ */ Te("input", () => jt(e));
  return o.schema = /* @__PURE__ */ g3(s || "Schema undefined", n), o.schemaMemoKey || (o.schemaMemoKey = `${Math.random()}`), o;
}
var uD = /* @__PURE__ */ Te("messages", () => ({
  $el: "ul",
  if: "$fns.length($messages)"
})), pD = /* @__PURE__ */ Te("message", () => ({
  $el: "li",
  for: ["message", "$messages"],
  attrs: {
    key: "$message.key",
    id: "$id + '-' + $message.key",
    "data-message-type": "$message.type"
  }
})), dD = uD(pD("$message.value")), Ug = /* @__PURE__ */ K({
  props: {
    node: {
      type: Object,
      required: !1
    },
    sectionsSchema: {
      type: Object,
      default: {}
    },
    defaultPosition: {
      type: [String, Boolean],
      default: !1
    },
    library: {
      type: Object,
      default: () => ({})
    }
  },
  setup(e, t) {
    const n = V(() => e.node || Ye(mu, void 0));
    le(
      n,
      () => {
        var a;
        (a = n.value) != null && a.context && !_e(e.defaultPosition) && (n.value.context.defaultMessagePlacement = !1);
      },
      { immediate: !0 }
    );
    const o = dD(e.sectionsSchema || {}), s = V(() => {
      var a, r, i, l, c, u;
      return {
        messages: ((r = (a = n.value) == null ? void 0 : a.context) == null ? void 0 : r.messages) || {},
        fns: ((l = (i = n.value) == null ? void 0 : i.context) == null ? void 0 : l.fns) || {},
        classes: ((u = (c = n.value) == null ? void 0 : c.context) == null ? void 0 : u.classes) || {}
      };
    });
    return () => {
      var a;
      return (a = n.value) != null && a.context ? za(
        Rg,
        { schema: o, data: s.value, library: e.library },
        { ...t.slots }
      ) : null;
    };
  }
}), fD = /* @__PURE__ */ Te("summary", () => ({
  $el: "div",
  attrs: {
    "aria-live": "polite"
  }
})), mD = /* @__PURE__ */ Te("summaryInner", () => ({
  $el: "div",
  if: "$summaries.length && $showSummaries"
})), vD = /* @__PURE__ */ Te("messages", () => ({
  $el: "ul",
  if: "$summaries.length && $showSummaries"
})), hD = /* @__PURE__ */ Te("message", () => ({
  $el: "li",
  for: ["summary", "$summaries"],
  attrs: {
    key: "$summary.key",
    "data-message-type": "$summary.type"
  }
})), gD = /* @__PURE__ */ Te("summaryHeader", () => ({
  $el: "h2",
  attrs: {
    id: "$id"
  }
})), bD = /* @__PURE__ */ Te("messageLink", () => ({
  $el: "a",
  attrs: {
    id: "$summary.key",
    href: '$: "#" + $summary.id',
    onClick: "$jumpLink"
  }
}));
fD(
  mD(
    gD("$summaryHeader"),
    vD(hD(bD("$summary.message")))
  )
);
W3();
xg();
const yD = ["id", "placeholder"], $D = ["id", "placeholder"], _D = ["id", "placeholder"], wD = {
  __name: "DOBInput",
  props: {
    context: Object
  },
  setup(e) {
    const t = e, n = R(null), o = R(null), s = tt({
      d: "",
      m: "",
      y: ""
    });
    le(
      () => t.context.dob,
      () => {
        t.context.dob && (s.d = t.context.dob.substring(6, 8), s.m = t.context.dob.substring(4, 6), s.y = t.context.dob.substring(0, 4));
      }
    );
    const a = (l, c) => {
      const { target: u } = l;
      c === "y" && u.value.length > 4 && (u.value = u.value.slice(0, 4)), s[c] = u.value.replace(/\D/g, "");
    }, r = (l, c) => {
      const { target: u } = l, p = u.value;
      s[c] = ("" + p).length === 1 ? "0" + p : p;
    };
    le(
      () => s.d,
      (l) => {
        (l > 3 || l <= 3 && l.length === 2) && (s.d = l.toString().slice(0, 2), n.value.focus());
      }
    ), le(
      () => s.m,
      (l) => {
        (l > 1 || l <= 1 && l.length === 2) && (s.m = l.toString().slice(0, 2), o.value.focus());
      }
    ), le(
      () => s.y,
      (l) => {
        l.length === 4 && o.value.blur();
      }
    ), le(
      () => [s.d, s.m, s.y],
      ([l, c, u]) => {
        const p = u + "-" + c + "-" + l;
        t.context.node.input(p);
      }
    );
    const i = tt({
      d: !1,
      m: !1,
      y: !1
    });
    return le(
      () => [!i.d, !i.m, !i.y],
      ([l, c, u]) => {
        l && c && u && t.context.handlers.blur();
      }
    ), (l, c) => (b(), C($e, null, [
      ot(d("input", {
        type: "mask",
        "onUpdate:modelValue": c[0] || (c[0] = (u) => s.d = u),
        mask: "##",
        id: `dd-${e.context.id}`,
        class: "formkit-input",
        placeholder: l.$t("vacvComponents.traveller.placeholders.birthDay"),
        maxlength: 2,
        onInput: c[1] || (c[1] = (u) => a(u, "d")),
        onFocus: c[2] || (c[2] = (u) => i.d = !0),
        onBlur: c[3] || (c[3] = (u) => {
          r(u, "d"), i.d = !1;
        })
      }, null, 40, yD), [
        [Wl, s.d]
      ]),
      ot(d("input", {
        type: "mask",
        ref_key: "MM",
        ref: n,
        "onUpdate:modelValue": c[4] || (c[4] = (u) => s.m = u),
        mask: "##",
        id: `mm-${e.context.id}`,
        class: "formkit-input",
        placeholder: l.$t("vacvComponents.traveller.placeholders.birthMonth"),
        maxlength: 2,
        onInput: c[5] || (c[5] = (u) => a(u, "m")),
        onFocus: c[6] || (c[6] = (u) => i.m = !0),
        onBlur: c[7] || (c[7] = (u) => {
          r(u, "m"), i.m = !1;
        })
      }, null, 40, $D), [
        [Wl, s.m]
      ]),
      ot(d("input", {
        type: "mask",
        ref_key: "YYYY",
        ref: o,
        "onUpdate:modelValue": c[8] || (c[8] = (u) => s.y = u),
        mask: "####",
        id: `yyyy-${e.context.id}`,
        class: "formkit-input year",
        placeholder: l.$t("vacvComponents.traveller.placeholders.birthYear"),
        maxlength: 4,
        onInput: c[9] || (c[9] = (u) => a(u, "y")),
        onFocus: c[10] || (c[10] = (u) => i.y = !0),
        onBlur: c[11] || (c[11] = (u) => i.y = !1)
      }, null, 40, _D), [
        [Wl, s.y]
      ])
    ], 64));
  }
}, CD = /* @__PURE__ */ De(wD, [["__scopeId", "data-v-d8c63c36"]]), zg = (e) => !!e && (e == null ? void 0 : e.source) === "TA" && !!(e != null && e.ratingImageUrl) && !!(e != null && e.reviews) && !!(e != null && e.value);
function kD(e = 20) {
  const t = Me.now().toFormat("MM-yy"), n = Me.now().plus({ years: e }).toFormat("MM-yy");
  return [t, n];
}
function Tre(e) {
  const t = /* @__PURE__ */ new Set();
  return e.forEach((n) => {
    var o;
    (o = n.information) != null && o.destination && t.add(n.information.destination);
  }), t.size > 1;
}
function Wg(e, t, n) {
  var a;
  let o, s = [];
  return e.length && (s = SD(e)), s.length === 1 && (a = s[0]) != null && a.date && s[0].date.replace(/-/g, "") === t ? [] : s.some(
    (r) => {
      var i;
      return ((i = r.date) == null ? void 0 : i.replace(/-/g, "")) === t;
    }
  ) ? (s.length <= n ? o = s : o = TD(
    s,
    t,
    n
  ), o.map((r) => {
    var i;
    return {
      ...r,
      selected: t === ((i = r == null ? void 0 : r.date) == null ? void 0 : i.replace(/-/g, ""))
    };
  })) : [];
}
function SD(e) {
  return e.filter((t) => t.date && /^\d{4}-\d{2}-\d{2}$/.test(t.date) && t.price).sort(function(t, n) {
    if (t.date && n.date) {
      const o = parseInt(t.date.replace(/-/g, "")), s = parseInt(n.date.replace(/-/g, ""));
      return o > s ? 1 : -1;
    }
    return 0;
  });
}
function TD(e, t, n) {
  const o = e.findIndex(
    (s) => {
      var a;
      return ((a = s.date) == null ? void 0 : a.replace(/-/g, "")) === t;
    }
  );
  if (o === -1)
    return e.slice(0, n);
  {
    const s = Math.max(0, o - 1), a = Math.min(e.length - 1, s + n - 1);
    return e.slice(s, a + 1);
  }
}
function AD(e) {
  return "quote" in e ? e.quote : void 0;
}
function ml(e) {
  const t = AD(e);
  if (t)
    return "prePackage" in t ? t.prePackage : "hotel" in t ? t.hotel : void 0;
}
function jg(e) {
  var n;
  const t = ml(e);
  if (t && "selectedOptionIds" in t) {
    const o = "itineraryId" in t.selectedOptionIds ? t.selectedOptionIds.itineraryId : void 0;
    return { itinerary: o ? (n = e == null ? void 0 : e.itineraries) == null ? void 0 : n[o] : void 0, itineraryId: o };
  }
}
const DD = 24 * 60 * 60 * 1e3;
function qg(e, t = "dd/MM/yyyy") {
  try {
    return Math.round(
      Me.fromFormat(e, t).diff(
        Me.now(),
        "days"
      ).days
    );
  } catch (n) {
    return to(n), "";
  }
}
function Kg(e, t, n) {
  try {
    return Me.fromFormat(e, t).toFormat(n);
  } catch (o) {
    to(o);
  }
  return "";
}
function sn(e) {
  return Yg(e, "yyyyMMdd", !1);
}
function Mi(e, t) {
  return Yg(e, t, !0);
}
function Yg(e, t, n) {
  e = e.replace(/[/-]/g, "");
  try {
    const o = Me.fromFormat(
      e,
      t,
      n ? { zone: "utc" } : {}
    );
    if (o.isValid)
      return o.toJSDate();
  } catch (o) {
    to(o);
  }
}
function PD(e, t) {
  return Me.fromJSDate(e).plus({ days: t }).toJSDate();
}
function Ma(e) {
  return Me.fromJSDate(e).toFormat("yyyyMMdd");
}
function Li(e, t) {
  const n = e && t ? Math.abs(e.getTime() - t.getTime()) : -1;
  return n > -1 ? Math.ceil(n / DD) : -1;
}
function Us(e) {
  e = e.replace(/[/-]/g, "");
  try {
    const t = Me.fromFormat(e, "ddMMyyyy");
    if (t.isValid)
      return t.toFormat("yyyyMMdd");
  } catch (t) {
    to(t);
  }
}
const Fp = (e) => Gg(e, "yyyyMMdd", "dd-MM-yyyy"), ID = (e) => Gg(e, "yyyyMMdd", "MM/dd/yyyy"), Gg = (e, t, n) => {
  if (e) {
    e = e.replace(/[/-]/g, "");
    try {
      const o = Me.fromFormat(e, t);
      if (o.isValid)
        return o.toFormat(n);
    } catch (o) {
      to(o);
    }
  }
  return "";
}, Ss = (e, t) => {
  try {
    return Me.fromFormat(e + t, "yyyyMMddhhmm").toJSDate();
  } catch (n) {
    to(n);
  }
  return "";
}, Are = (e, t) => {
  const n = t.getTime() - e.getTime();
  return n > 0 ? n / (60 * 1e3) : 0;
}, Of = (e, t) => {
  if (e == "fr")
    return t.toLowerCase();
  {
    const [n, o] = t.split("H");
    return Me.fromFormat(`${n}:${o}`, "H:m").toFormat("h:mm a");
  }
}, ED = (e, t) => Me.fromFormat(t, "yyyy-MM-dd").setLocale(e).toLocaleString({ weekday: "short", month: "short", day: "2-digit" }), xf = (e) => {
  const t = e && Me.fromFormat(e, "dd/MM/yyyy");
  return t ? Zg(t) : "";
}, Zg = (e) => e.isValid ? e.toISODate() + "T00:00:00Z" : "";
function OD(e) {
  const t = Fp(e);
  return Xg(t);
}
function xD(e, t) {
  const n = sn(e);
  if (n) {
    const o = PD(n, t ?? 0), s = Fp(Ma(o));
    return Xg(s);
  }
  return "";
}
function Xg(e) {
  return e && e.replace(/-/g, "/");
}
function MD(e, t) {
  const n = Me.fromFormat(e, "yyyy/MM/dd"), o = Me.fromFormat(t, "yyyy/MM/dd");
  return Qv.fromDateTimes(n, o);
}
function LD(e, t) {
  const n = Me.fromJSDate(e), o = Me.fromJSDate(t);
  return Math.floor(o.diff(n, ["years"]).years);
}
function Dre(e) {
  var n, o;
  const t = ((o = (n = e == null ? void 0 : e.segments) == null ? void 0 : n[0]) == null ? void 0 : o.departureDate) ?? "";
  return ND(t);
}
function ND(e, t = "yyyyMMdd") {
  const n = Me.fromFormat(e, t);
  return n.isValid ? n.toJSDate() : null;
}
function FD(e, t) {
  var n, o, s, a, r;
  if (!e)
    return null;
  if ("itineraries" in e) {
    const i = (s = (o = (n = e.itineraries) == null ? void 0 : n[t]) == null ? void 0 : o.segments) == null ? void 0 : s.filter((u) => u.bound === "O"), l = ((a = i == null ? void 0 : i[0]) == null ? void 0 : a.departureDate) ?? "", c = Me.fromFormat(l, "yyyyMMdd");
    return c.isValid ? c.toJSDate() : null;
  } else if (e.quote && "hotel" in e.quote) {
    const i = ((r = e.quote) == null ? void 0 : r.hotel.information.checkIn) ?? "", l = Me.fromFormat(i, "yyyyMMdd");
    return l.isValid ? l.toJSDate() : null;
  }
  return null;
}
function RD(e, t, n) {
  const o = {
    event: "paymentFormAbandonment",
    payFormPaymMethod: e,
    paymMeans1Fields: t,
    paymMeans2Fields: n
  };
  window.dataLayer.push(o);
}
const vu = [];
function Jg(e) {
  const t = e.target;
  if (t != null && t.tagName && (t.tagName.toUpperCase() == "INPUT" || t.tagName.toUpperCase() == "SELECT")) {
    const n = c1(t);
    VD(n);
  }
}
function Qg() {
  RD(
    "Credit Card",
    vu.join(" > "),
    null
  );
}
function VD(e) {
  vu.includes(e) || vu.push(e);
}
function BD() {
  document.addEventListener("change", Jg), window.addEventListener(
    "beforeunload",
    Qg
  );
}
function HD() {
  document.removeEventListener("change", Jg), window.removeEventListener(
    "beforeunload",
    Qg
  );
}
async function UD(e) {
  const t = zD(e), o = new TextEncoder().encode(t), s = await crypto.subtle.digest("SHA-256", o);
  return Array.from(new Uint8Array(s)).map((i) => i.toString(16).padStart(2, "0")).join("");
}
function zD(e) {
  let t = e.trim().toLowerCase();
  const n = ["gmail.com", "googlemail.com"], o = t.split("@");
  return n.includes(o[1]) && (o[0] = o[0].replace(/\./g, ""), t = o.join("@")), t;
}
function WD(e) {
  var t, n, o, s, a, r;
  return !!(e && ((n = (t = e == null ? void 0 : e.restaurants) == null ? void 0 : t.info) != null && n.length || (s = (o = e == null ? void 0 : e.bars) == null ? void 0 : o.names) != null && s.length || (r = (a = e == null ? void 0 : e.bars) == null ? void 0 : a.more) != null && r.length));
}
function jD(e) {
  var t, n, o, s, a, r, i, l, c, u, p, f, m, h, g, _, v, w, y, $;
  return e ? !!(((n = (t = e == null ? void 0 : e.pools) == null ? void 0 : t.names) == null ? void 0 : n.length) ?? ((s = (o = e == null ? void 0 : e.pools) == null ? void 0 : o.more) == null ? void 0 : s.length) ?? ((r = (a = e == null ? void 0 : e.landSports) == null ? void 0 : a.names) == null ? void 0 : r.length) ?? ((l = (i = e == null ? void 0 : e.landSports) == null ? void 0 : i.more) == null ? void 0 : l.length) ?? ((u = (c = e == null ? void 0 : e.waterSports) == null ? void 0 : c.names) == null ? void 0 : u.length) ?? ((f = (p = e == null ? void 0 : e.waterSports) == null ? void 0 : p.more) == null ? void 0 : f.length) ?? ((h = (m = e == null ? void 0 : e.golf) == null ? void 0 : m.names) == null ? void 0 : h.length) ?? ((_ = (g = e == null ? void 0 : e.golf) == null ? void 0 : g.more) == null ? void 0 : _.length) ?? ((w = (v = e == null ? void 0 : e.health) == null ? void 0 : v.names) == null ? void 0 : w.length) ?? (($ = (y = e == null ? void 0 : e.health) == null ? void 0 : y.more) == null ? void 0 : $.length)) : !1;
}
function qD(e) {
  var t, n;
  return !!(e && (e != null && e.petFriendlyDisclamer || (t = e == null ? void 0 : e.names) != null && t.length || (n = e == null ? void 0 : e.more) != null && n.length || e != null && e.hasDisclaimer));
}
function Pre(e) {
  return !!(e && Object.keys(e).length > 0 && (WD(e.foodAndDrink) || jD(e.activities) || qD(e.otherFacilityAndServices)));
}
function KD(e, t) {
  if (e && t) {
    const n = t - e;
    return Math.floor(n / t * 100);
  } else
    return 0;
}
function Rp(e) {
  return (e == null ? void 0 : e.paxCount) && (e == null ? void 0 : e.paxCount) > 1;
}
function eb([e, t], n, o) {
  return t === n && o && (t = o), `${e}-${t}`;
}
function vl(e, t) {
  var o;
  if (!((o = e == null ? void 0 : e.fixedValueFilters) != null && o.length))
    return [];
  const n = e.fixedValueFilters.find((s) => s.name === t);
  return (n == null ? void 0 : n.values.sort(function(s, a) {
    return s.value.toLowerCase() > a.value.toLowerCase() ? 1 : -1;
  }).map((s) => ({
    value: s.id,
    // in our data the destination numbers are .id
    label: s.value
    // and the names of the desitnations are .value
  }))) || [];
}
const hu = (e) => vl(e, "DESTINATION"), Mf = (e) => vl(e, "DEALS"), Lf = (e) => vl(e, "AMENITIES"), Nf = (e) => vl(e, "VACATION_TYPE");
function hl(e, t) {
  const n = /* @__PURE__ */ new Map(), o = e == null ? void 0 : e.find(
    (s) => s.name === t
  );
  return o == null || o.values.forEach((s) => {
    const a = typeof s.value == "string" ? s.value : "";
    n.set(s.id, a);
  }), n;
}
const YD = (e) => hl(e, "DESTINATION"), GD = (e) => hl(e, "AMENITIES"), ZD = (e) => hl(e, "VACATION_TYPE"), XD = (e) => hl(e, "DEALS"), JD = (e, t, n, o) => {
  if (!(e != null && e.length) || !o)
    return;
  let s = 0, a = 0, r = 0, i = 0;
  return e.map((l) => {
    let c;
    if (l.dob) {
      const m = Me.fromFormat(l.dob, "yyyyMMdd");
      m.isValid ? c = LD(m.toJSDate(), o) : c = 18;
    } else
      c = 18;
    const u = c >= 18, p = c < 2;
    u ? (s++, i = s) : p ? (r++, i = r) : (a++, i = a);
    const f = {
      ...l,
      adult: u,
      age: c,
      birthdayFormatted: Fp(l.dob),
      orderIndex: i
    };
    return f.primaryTraveller && (f.phoneNumber = t, f.emailAddress = n), f;
  });
};
class QD {
  async init(t, n, o, s, a, r) {
    await this.loadData(
      o,
      s,
      t,
      n,
      a,
      r
    );
  }
  async loadData(t, n, o = "app", s = "vacv-spa-container", a, r) {
    fetch(t, {
      method: "post"
    }).then((i) => i.json()).then((i) => {
      this.startApp(
        o,
        s,
        i,
        n,
        a,
        r
      );
    });
  }
  appendStyleImported(t, n) {
    if (t && t != "") {
      const o = JSON.parse(t);
      Array.from(o).forEach((s) => {
        const a = document.createElement("style");
        a.innerText = `@import "${s}"`, n.append(a);
      });
    }
  }
  appendJavaScriptImported(t, n) {
    if (t && t != "") {
      const o = JSON.parse(t);
      Array.from(o).forEach((s) => {
        const a = document.createElement("script");
        a.setAttribute("type", "text/javascript"), a.setAttribute("src", `${s}`), n.appendChild(a);
      });
    }
  }
  appendSpaAssets(t, n, o) {
    let s = t.cacheBusting;
    t.name === "local" && (s = Math.random().toString(36).substring(2, 15));
    const a = document.createElement("link");
    a.setAttribute("rel", "stylesheet"), a.setAttribute(
      "href",
      `${n}/css/index.css?${s}`
    ), o.appendChild(a);
    const r = document.createElement("script");
    r.setAttribute("type", "module"), r.setAttribute("src", `${n}/js/index.js?${s}`), o.appendChild(r);
  }
  appendData(t, n, o) {
    o.setAttribute("class", "vuejsDevWrapper");
    const s = document.createElement("div");
    s.setAttribute("id", t), s.setAttribute("data-vars", JSON.stringify(n.vars)), o.appendChild(s);
  }
  startApp(t, n, o, s, a, r) {
    const i = document.createElement("div");
    a && this.appendStyleImported(a, i), r && this.appendJavaScriptImported(r, i), this.appendData(t, o, i), this.appendSpaAssets(o, s, i);
    const l = document.getElementById(n);
    l == null || l.appendChild(i);
  }
}
const Ire = () => {
  window.VACV_SPA_CONFIG = new QD();
};
async function eP(e, t = 2) {
  return Ya(e, "Promo Badges", t);
}
function Vp(e) {
  const t = e.privateTransfer ? [
    {
      type: "privateTransfer",
      ...e.privateTransfer
    }
  ] : [], n = Array.isArray(e.mealPlans) ? e.mealPlans : [], o = Array.isArray(e.activities) ? e.activities.map((l) => ({
    type: "activity",
    ...l
  })) : [], s = Array.isArray(e.travelProtections) ? e.travelProtections : [], a = (l, c) => [...l].sort((u, p) => {
    var h, g;
    const f = ((h = u.title) == null ? void 0 : h.toLowerCase()) ?? "", m = ((g = p.title) == null ? void 0 : g.toLowerCase()) ?? "";
    return f.localeCompare(m);
  }).map((u) => ({ type: c, ...u })), r = a(
    s,
    "travelProtection"
  ), i = a(n, "mealPlan");
  return [
    ...r,
    ...t,
    ...o,
    ...i
  ];
}
function tb(e, t) {
  const {
    travelProtectionIds: n = [],
    privateTransferId: o,
    // @ts-expect-error ts239 - HotelOnly API not properly typed yet
    mealPlanIds: s = [],
    activityIds: a = []
  } = e ?? {}, r = (f) => {
    const [m, h] = f.split("-");
    return `${m}-${h}`;
  }, i = n.length ? n.flatMap(
    (f) => Object.values((t == null ? void 0 : t.travelProtections) ?? {}).filter(
      (m) => {
        var h;
        return ((h = Object.values(m.subOptions)[0]) == null ? void 0 : h.id) === f;
      }
    )
  ) : [], l = o && (t != null && t.privateTransfers) ? Object.values(t.privateTransfers).find(
    (f) => {
      var m;
      return ((m = Object.values(f.subOptions)[0]) == null ? void 0 : m.id) === o;
    }
  ) : null, c = s.length ? s.flatMap(
    (f) => Object.values((t == null ? void 0 : t.mealPlans) ?? {}).filter(
      (m) => m.subOptions[r(f)]
    )
  ) : [], u = a.length ? a.flatMap(
    (f) => Object.values((t == null ? void 0 : t.activities) ?? {}).filter(
      (m) => m.subOptions[r(f)]
    )
  ) : [], p = (f, m) => {
    for (const h of f) {
      const g = {};
      for (const _ of m) {
        const v = r(_);
        h.subOptions[v] && (g[v] = h.subOptions[v]);
      }
      h.subOptions = g;
    }
  };
  return p(u, a), p(c, s), {
    travelProtections: i,
    activities: u,
    privateTransfer: l,
    mealPlans: c
  };
}
function tP(e) {
  return e.filter((t) => t.type !== "privateTransfer");
}
function nP(e = []) {
  return e == null ? void 0 : e.reduce((t, n) => n.paxCount ? n.paxCount + t : t, 0);
}
const gl = (e, t) => {
  const n = t.split("-");
  return e.subOptions[`${n[0]}-${n[1]}`];
}, oP = (e, t) => {
  const n = t.split("-");
  return e.subOptions[`${n[0]}-${n[1]}`];
}, zs = (e) => "dates" in e, Ere = (e) => e.selectedSubOptionId ? gl(e, e.selectedSubOptionId).title : Object.values(e.subOptions)[0].title ?? "", Ore = (e) => {
  let t;
  if (e) {
    const n = Object.values(e);
    n.length && (t = n.find((o) => o == null ? void 0 : o.recommended), t ?? (t = n.find((o) => (o == null ? void 0 : o.category) === "CAREFLEX")), t ?? (t = n.find((o) => (o == null ? void 0 : o.category) === "CAREFREE")));
  }
  return t;
}, nb = St("hotelAndRoomStore", () => {
  const e = R(), t = R(), n = R(), o = R(), s = R(), a = R(), r = R(), i = R(!1);
  function l(c, u, p) {
    var f, m, h, g, _, v;
    return e.value = (f = p == null ? void 0 : p.query) != null && f.numberOfRooms ? parseInt(p.query.numberOfRooms.toString()) : null, t.value = (m = c == null ? void 0 : c.information) != null && m.checkIn ? new Date(
      parseInt(c.information.checkIn.substring(0, 4)),
      parseInt(c.information.checkIn.substring(4, 6)) - 1,
      parseInt(c.information.checkIn.substring(6))
    ) : null, n.value = (h = c == null ? void 0 : c.information) != null && h.checkOut ? new Date(
      parseInt(c.information.checkOut.substring(0, 4)),
      parseInt(c.information.checkOut.substring(4, 6)) - 1,
      parseInt(c.information.checkOut.substring(6))
    ) : null, o.value = c == null ? void 0 : c.roomId, s.value = o.value && ((_ = (g = u == null ? void 0 : u.rooms) == null ? void 0 : g[o.value]) != null && _.name) ? u == null ? void 0 : u.rooms[o.value].name : null, a.value = (v = c == null ? void 0 : c.information) == null ? void 0 : v.mealPlanName, r.value = u != null && u.name ? u.name : null, t.value && n.value && s.value && e.value && r.value ? (i.value = !0, i) : (i.value = !1, i);
  }
  return {
    checkIn: t,
    checkOut: n,
    roomName: s,
    mealPlan: a,
    hotelName: r,
    numberOfRooms: e,
    isValid: i,
    setHotelAndRoom: l
  };
}), Do = St("ancillary", () => {
  const e = R({
    activities: [],
    travelProtections: [],
    mealPlans: [],
    privateTransfer: null
  }), t = R(0), n = ($, S, A) => {
    if ($ === "privateTransfer")
      e.value[$] = S;
    else if ($ === "travelProtections") {
      const I = e.value[$];
      I.some((D) => D.id === S.id) || I.push(S);
    } else A && ($ === "mealPlans" ? (c(S), e.value[$].push({
      ...S,
      selectedSubOptionId: A
    })) : (l(S), e.value[$].push({
      ...S,
      selectedSubOptionId: A
    })));
    g();
  }, o = ($, S) => {
    h(), $.selectedActivityIds && $.selectedActivityIds.split(",").forEach((A) => {
      var I;
      S.activities && n(
        "activities",
        (I = S.activities) == null ? void 0 : I[A.split("-")[0]],
        A
      );
    }), $.selectedTravelProtectionIds && $.selectedTravelProtectionIds.split(",").forEach((A) => {
      var I;
      S.travelProtections && n(
        "travelProtections",
        (I = S.travelProtections) == null ? void 0 : I[A.split("-")[0]]
      );
    }), $.selectedMealPlanIds && $.selectedMealPlanIds.split(",").forEach((A) => {
      var I;
      S.mealPlans && n(
        "mealPlans",
        (I = S.mealPlans) == null ? void 0 : I[A.split("-")[0]],
        A
      );
    }), $.selectedPrivateTransferId && S.privateTransfers && n(
      "privateTransfer",
      S.privateTransfers[$.selectedPrivateTransferId.split("-")[0]]
    );
  }, s = ($) => {
    const { activities: S, travelProtections: A, mealPlans: I, privateTransfer: D } = e.value;
    return [
      ...S,
      ...A,
      ...I,
      ...D ? [D] : []
    ].find((x) => x.id === $);
  }, a = ($) => {
    var x;
    const S = s($);
    if (!(S != null && S.selectedSubOptionId))
      return;
    const A = S.selectedSubOptionId, I = A.split("-"), D = `${I[0]}-${I[1]}`, O = S.subOptions[D];
    if (O)
      return zs(O) && ((x = O.dates) == null ? void 0 : x[A]) !== void 0 ? O.dates[A] : O;
  }, r = ($) => {
    const S = s($);
    if (!(S != null && S.selectedSubOptionId))
      return S == null ? void 0 : S.title;
    const I = S.selectedSubOptionId.split("-"), D = `${I[0]}-${I[1]}`, O = S.subOptions[D];
    return O ? O.title : S.title;
  }, i = ($, S, A) => {
    var I;
    if ($ === "privateTransfer")
      ((I = e.value[$]) == null ? void 0 : I.id) === S && (e.value[$] = null);
    else if ($ === "mealPlans") {
      const D = e.value[$];
      A ? e.value[$] = D.filter(
        (O) => O.selectedSubOptionId !== A
      ) : e.value[$] = D.filter(
        (O) => O.id !== S
      );
    } else if ($ === "travelProtections") {
      const D = e.value[$];
      e.value[$] = D.filter(
        (O) => O.id !== S
      );
    } else if ($ === "activities") {
      const D = e.value[$];
      A ? e.value[$] = D.filter(
        (O) => O.selectedSubOptionId !== A
      ) : e.value[$] = D.filter(
        (O) => O.id !== S
      );
    }
    g();
  }, l = ($) => {
    e.value.activities = e.value.activities.filter(
      (S) => S.id !== $.id
    );
  }, c = ($) => {
    e.value.mealPlans = e.value.mealPlans.filter(
      (S) => S.id !== $.id
    );
  }, u = ($, S) => {
    const A = e.value[$];
    return Array.isArray(A) ? A.some((I) => I.id === S) : (A == null ? void 0 : A.id) === S;
  }, p = ($, S) => {
    const A = e.value[$];
    return Array.isArray(A) ? A.some(
      (I) => I.selectedSubOptionId === S
    ) : !1;
  }, f = ($) => {
    var x, F, P, E;
    const S = (x = $ == null ? void 0 : $.selectedTravelProtectionIds) != null && x.length ? $.selectedTravelProtectionIds.split(",") : e.value.travelProtections.map((B) => Object.values(B.subOptions)[0].id).filter((B) => B !== void 0), A = (F = $ == null ? void 0 : $.selectedMealPlanIds) != null && F.length ? $.selectedMealPlanIds.split(",") : e.value.mealPlans.map((B) => Object.values(B.subOptions)[0].id).filter((B) => B !== void 0), I = (P = $ == null ? void 0 : $.selectedActivityIds) != null && P.length ? $.selectedActivityIds.split(",") : e.value.activities.map((B) => B.selectedSubOptionId).filter((B) => B !== void 0);
    let D;
    (E = $ == null ? void 0 : $.selectedPrivateTransferId) != null && E.length ? D = $.selectedPrivateTransferId : e.value.privateTransfer ? D = Object.values(
      e.value.privateTransfer.subOptions
    )[0].id : D = void 0;
    const O = {};
    return S && S.length > 0 && (O.travelProtectionIds = S), I && I.length > 0 && (O.activityIds = I), D && (O.privateTransferId = D), A && A.length > 0 && (O.mealPlanIds = A), O;
  }, m = V(() => e.value.travelProtections.length > 0 || e.value.activities.length > 0 || e.value.privateTransfer !== null || e.value.mealPlans.length > 0), h = () => {
    e.value.travelProtections = [], e.value.activities = [], e.value.privateTransfer = null, e.value.mealPlans = [];
  }, g = () => {
    let $ = 0;
    const S = (D) => Object.values(D.subOptions)[0].price, A = (D) => {
      const O = gl(D, D.selectedSubOptionId);
      return O ? O.dates ? O.dates[D.selectedSubOptionId].price : O.price : Object.values(D.subOptions)[0].price;
    }, I = (D) => {
      const O = oP(D, D.selectedSubOptionId);
      return O ? O.price : 0;
    };
    e.value.travelProtections.forEach((D) => {
      $ += S(D);
    }), e.value.activities.forEach((D) => {
      $ += A(D);
    }), e.value.privateTransfer && ($ += S(e.value.privateTransfer)), e.value.mealPlans.forEach((D) => {
      $ += I(D);
    }), t.value = $;
  }, _ = V(
    () => e.value.activities.map(($) => $.selectedSubOptionId).join(",")
  ), v = V(
    () => e.value.travelProtections.map(($) => Object.keys($.subOptions)[0]).join(",")
  ), w = V(
    () => {
      var $;
      return Object.keys((($ = e.value.privateTransfer) == null ? void 0 : $.subOptions) ?? {})[0] ?? "";
    }
  ), y = V(
    () => e.value.mealPlans.map(($) => $.selectedSubOptionId).join(",")
  );
  return {
    ancillaries: e,
    hasSelectedAncillaries: m,
    totalPriceOfSelectedAncillariesPerTraveler: t,
    addAncillary: n,
    removeAncillary: i,
    setStore: o,
    isAncillarySelected: u,
    isAncillarySubOptionSelected: p,
    getSelectedAncillary: s,
    getSelectedSubOption: a,
    geSubOptionTitle: r,
    toPostData: f,
    reset: h,
    activityIdsString: _,
    travelProtectionIdsString: v,
    privateTransferIdString: w,
    mealPlanIdsString: y
  };
});
function et(e, t) {
  return e ?? t;
}
function xre(e, t, n, o, s, a) {
  var m, h, g, _;
  const r = Do(), { numberOfRooms: i } = Ce(nb()), l = n ? et(n.segments, []) : [], c = t == null ? void 0 : t.hotelId, u = t == null ? void 0 : t.roomId;
  let p = {
    numberOfRooms: 0,
    checkIn: "",
    checkOut: "",
    roomName: "",
    hotelName: ""
  };
  if (c && u) {
    const v = (o == null ? void 0 : o.name) ?? "", w = (h = (m = o == null ? void 0 : o.rooms) == null ? void 0 : m[u]) == null ? void 0 : h.name;
    p = {
      numberOfRooms: et(i.value, 0),
      checkIn: et((g = t == null ? void 0 : t.information) == null ? void 0 : g.checkIn, ""),
      checkOut: et((_ = t == null ? void 0 : t.information) == null ? void 0 : _.checkOut, ""),
      roomName: et(w, ""),
      hotelName: et(v, "")
    };
  }
  const f = Vp(r.ancillaries);
  return a(
    e,
    l,
    p,
    f,
    s
  );
}
function sP(e) {
  return e.map((t, n) => ({
    id: n,
    first_name: et(t.firstName, ""),
    last_name: et(t.lastName, ""),
    date_of_birth: et(ID(t.dob), "")
  }));
}
function aP(e) {
  var n, o, s;
  const t = e == null ? void 0 : e.filter((a) => a.bound === "O");
  return [
    {
      airline_name: et((n = t[0]) == null ? void 0 : n.carrierName, ""),
      origin: et((o = t[0]) == null ? void 0 : o.origin, ""),
      destination: et(
        (s = t[t.length - 1]) == null ? void 0 : s.destination,
        ""
      ),
      trip_type: "roundtrip",
      itinerary: e.map((a) => ({
        departure_apc: et(a.origin, ""),
        departure_time: et(a.departureDate, ""),
        arrival_apc: et(a.destination, ""),
        arrival_time: et(a.arrivalDate, ""),
        fare_class: et(a.cabinClassName, ""),
        carrier_code: et(a.carrierCode, "")
      })),
      insurance: []
    }
  ];
}
function rP(e) {
  return [
    {
      reservation_type: "pre_paid",
      has_deposit: !1,
      hotel_name: et(e.hotelName, ""),
      number_of_rooms: et(e.numberOfRooms, 0),
      room_type: et(e.roomName, ""),
      check_in: et(e.checkIn, ""),
      check_out: et(e.checkOut, ""),
      insurance: []
    }
  ];
}
function iP(e, t) {
  return e.map((n, o) => ({
    id: o.toString(),
    name: n.title,
    price: lP(n, t)
  }));
}
function lP(e, t) {
  if (e.type === "activity") {
    const o = Do().getSelectedAncillary(
      e.id
    );
    return o ? ((a) => {
      const r = gl(
        o,
        o.selectedSubOptionId
      );
      return r ? r.dates ? r.dates[a.selectedSubOptionId].price : r.price : Object.values(a.subOptions)[0].price;
    })(o) * 100 * t : 0;
  } else {
    const o = Object.values(e.subOptions)[0];
    return o.price ? o.price * 100 * t : 0;
  }
}
function ob(e, t, n, o, s) {
  function a() {
    (function(w, y, $, S, A, I, D, O, x) {
      w.UpLiftPlatformObject = A, w[A] = w[A] || function() {
        (w[A].q = w[A].q || []).push(arguments);
      }, // @ts-expect-error: this is uplift library
      w[A].l = 1 * /* @__PURE__ */ new Date(), O = y.createElement($), x = y.getElementsByTagName($)[0], O.async = 1, O.src = S + "?upcode=" + I, x.parentNode.insertBefore(O, x), D = w.location.host.match(/[\w-]+\.\w{2,3}(:\d+)?$/), D && (D = D[0]), w[A]("create", I, D);
    })(
      window,
      document,
      "script",
      "https://tag.uplift.com/external/up.js",
      "up",
      o
      //getEnvVar("VITE_UPLIFT_LIB_UPC")
    );
  }
  function r() {
    return !!(window.Uplift && window.Uplift.Payments);
  }
  function i() {
    return !!(window.Uplift && window.Uplift.initialized);
  }
  function l(w, y, $) {
    const S = It(), A = {
      apiKey: s,
      //getEnvVar("VITE_UPLIFT_LIB_API_KEY"),
      locale: S === "en" ? "en-CA" : "fr-CA",
      currency: "CAD",
      checkout: w,
      channel: y ? "desktop" : "mobile",
      container: w ? "#up-pay-monthly-container" : void 0,
      onChange: w ? $ : void 0
    };
    r() ? window.Uplift.Payments.init(A) : u();
  }
  function c(w, y, $, S, A) {
    const I = sP(w), D = y ? aP(y) : [], O = $ ? rP($) : [], x = iP(
      S,
      w.length
    ), F = {
      travelers: I,
      air_reservations: D,
      hotel_reservations: O,
      add_ons: x,
      order_amount: A > 0 ? Math.round((A * 100 + Number.EPSILON) * 100) / 100 : 0
    };
    return r() ? window.Uplift.Payments.load(F) : u(), F;
  }
  function u() {
    e && Go(
      Error("Flex Pay library is not ready yet"),
      t,
      n
    );
  }
  function p() {
    r() ? window.Uplift.Payments.select() : u();
  }
  function f(w) {
    r() ? window.Uplift.Payments.load(w) : u();
  }
  function m(w) {
    r() ? (window.Uplift.Payments.deselect(w), window.Uplift.Analytics.selectPayment(w)) : u();
  }
  function h() {
    r() ? window.Uplift.Payments.getToken() : u();
  }
  function g(w) {
    r() ? window.Uplift.Analytics.selectPayment(w) : u();
  }
  function _(w, y) {
    r() ? window.Uplift.Analytics.orderSubmit(w, y) : u();
  }
  function v(w) {
    r() ? (window.Uplift.Analytics.orderResponse(w), window.Uplift.Payments.confirm(w.order_id)) : u();
  }
  return {
    loadUpliftLib: a,
    isUpliftReady: r,
    isUpliftInitialized: i,
    initPayMonthly: l,
    sendOrderInfo: c,
    upliftNotReadyError: u,
    selectUpliftPayment: p,
    loadOrderInfo: f,
    deselectUpliftPayment: m,
    getUpliftToken: h,
    upliftAnalyticsSelectPayment: g,
    upliftOrderSubmit: _,
    upliftOrderConfirmation: v
  };
}
const cP = async (e, t, n, o, s, a) => {
  n();
  const i = {
    billingAddress: pP(t),
    creditCards: [uP(t, e)]
    // Add the virtual card
  };
  if (a && a > 0) {
    const l = o();
    i.aeroplanPoints = [l];
  }
  s(i);
}, sb = (e) => ({
  address1: e.street_address,
  city: e.city,
  province: e.region,
  country: e.country,
  postalCode: e.postal_code,
  email: e.email,
  phone: e.phone
}), uP = (e, t) => ({
  correlation: _i.generateId(12),
  trace: _i.generateId(12),
  ...sb(e.contact),
  nameOnCard: e.name_on_card,
  creditCardTypeEnum: dP(e.card_type),
  // API should define as string in case of leading zeros
  cardSecurityCode: e.card_ccv,
  creditCardToken: e.card_number,
  expirationMonth: fP(e.expiration_month),
  expirationYear: mP(e.expiration_year),
  amount: t,
  currency: "cad"
}), pP = (e) => sb(e.contact), dP = (e) => {
  if (e === "MASTERCARD")
    return "masterCard";
  if (e === "VISA")
    return "visa";
}, fP = (e) => e.toString().padStart(2, "0"), mP = (e) => e.toString().slice(-2);
function vP(e, t) {
  const n = {
    subTotal: 0,
    totalBeforeAeroplan: 0,
    total: e ? e.total : 0
  };
  t && (t.allowOpcTax && (n.total = e ? e.grandTotal : 0), t.priceAncillaries && (n.total += t.priceAncillaries), hP(
    t.allowPromoCode,
    t.allowOpcTax,
    e,
    n,
    t.priceAncillaries
  ), gP(
    t.dollarValue,
    t.allowOpcTax,
    e,
    n,
    t.priceAncillaries
  ), bP(
    n,
    e,
    t.priceAncillaries,
    t.allowOpcTax,
    t.insurancePremium
  ));
  const o = n.totalBeforeAeroplan > 0 ? n.totalBeforeAeroplan : n.total - ((t == null ? void 0 : t.insurancePremium) ?? 0);
  return {
    subTotal: n.subTotal,
    totalBeforeAeroplan: o,
    total: n.total
  };
}
function hP(e, t, n, o, s) {
  var a;
  if (e && ((a = n == null ? void 0 : n.promo) != null && a.value)) {
    const r = Bp(n, s, t);
    typeof r == "number" && (o.subTotal = r), typeof n.grandTotal == "number" && (o.total = n.grandTotal);
  }
}
function gP(e, t, n, o, s) {
  if (e && e > 0) {
    const a = Bp(n, s, t);
    typeof a == "number" && (o.subTotal = a);
    let r = e > o.total ? 0 : o.total - e;
    r = Math.round(r * 100) / 100, o.totalBeforeAeroplan = o.total, o.total = r;
  }
}
function bP(e, t, n, o, s) {
  if (s) {
    if (e.subTotal === 0) {
      const a = Bp(
        t,
        n,
        o
      );
      typeof a == "number" && (e.subTotal = a);
    }
    e.total += s;
  }
}
function Bp(e, t, n) {
  let o = e == null ? void 0 : e.total;
  return typeof o == "number" && (t && (o += t), n && (e != null && e.opcTax) && (o += e.opcTax)), o;
}
const Hp = (e, t) => e === "JWT_TOKEN_ERROR" || e === 401 || e === 403 && t === Qc.FORBIDDEN_GROUP || e === 400 && t === Qc.USER_CHANGE, ab = St("message", () => {
  const e = R(null), t = R(null);
  function n(r) {
    e.value = r;
  }
  function o() {
    e.value = null;
  }
  function s(r) {
    t.value = r;
  }
  function a() {
    t.value = null;
  }
  return {
    alertMessage: e,
    statusMessage: t,
    setAlert: n,
    deleteAlert: o,
    setStatus: s,
    deleteStatus: a
  };
});
var gu = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function yP(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function $P(e) {
  if (e.__esModule) return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function o() {
      return this instanceof o ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(o) {
    var s = Object.getOwnPropertyDescriptor(e, o);
    Object.defineProperty(n, o, s.get ? s : {
      enumerable: !0,
      get: function() {
        return e[o];
      }
    });
  }), n;
}
var sa = TypeError;
const _P = {}, wP = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _P
}, Symbol.toStringTag, { value: "Module" })), CP = /* @__PURE__ */ $P(wP);
var Up = typeof Map == "function" && Map.prototype, oc = Object.getOwnPropertyDescriptor && Up ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, Ni = Up && oc && typeof oc.get == "function" ? oc.get : null, Ff = Up && Map.prototype.forEach, zp = typeof Set == "function" && Set.prototype, sc = Object.getOwnPropertyDescriptor && zp ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, Fi = zp && sc && typeof sc.get == "function" ? sc.get : null, Rf = zp && Set.prototype.forEach, kP = typeof WeakMap == "function" && WeakMap.prototype, La = kP ? WeakMap.prototype.has : null, SP = typeof WeakSet == "function" && WeakSet.prototype, Na = SP ? WeakSet.prototype.has : null, TP = typeof WeakRef == "function" && WeakRef.prototype, Vf = TP ? WeakRef.prototype.deref : null, AP = Boolean.prototype.valueOf, DP = Object.prototype.toString, PP = Function.prototype.toString, IP = String.prototype.match, Wp = String.prototype.slice, fo = String.prototype.replace, EP = String.prototype.toUpperCase, Bf = String.prototype.toLowerCase, rb = RegExp.prototype.test, Hf = Array.prototype.concat, _n = Array.prototype.join, OP = Array.prototype.slice, Uf = Math.floor, bu = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, ac = Object.getOwnPropertySymbols, yu = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, Ws = typeof Symbol == "function" && typeof Symbol.iterator == "object", Fa = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === Ws || !0) ? Symbol.toStringTag : null, ib = Object.prototype.propertyIsEnumerable, zf = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(e) {
  return e.__proto__;
} : null);
function Wf(e, t) {
  if (e === 1 / 0 || e === -1 / 0 || e !== e || e && e > -1e3 && e < 1e3 || rb.call(/e/, t))
    return t;
  var n = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
  if (typeof e == "number") {
    var o = e < 0 ? -Uf(-e) : Uf(e);
    if (o !== e) {
      var s = String(o), a = Wp.call(t, s.length + 1);
      return fo.call(s, n, "$&_") + "." + fo.call(fo.call(a, /([0-9]{3})/g, "$&_"), /_$/, "");
    }
  }
  return fo.call(t, n, "$&_");
}
var $u = CP, jf = $u.custom, qf = ub(jf) ? jf : null, lb = {
  __proto__: null,
  double: '"',
  single: "'"
}, xP = {
  __proto__: null,
  double: /(["\\])/g,
  single: /(['\\])/g
}, bl = function e(t, n, o, s) {
  var a = n || {};
  if (Fn(a, "quoteStyle") && !Fn(lb, a.quoteStyle))
    throw new TypeError('option "quoteStyle" must be "single" or "double"');
  if (Fn(a, "maxStringLength") && (typeof a.maxStringLength == "number" ? a.maxStringLength < 0 && a.maxStringLength !== 1 / 0 : a.maxStringLength !== null))
    throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
  var r = Fn(a, "customInspect") ? a.customInspect : !0;
  if (typeof r != "boolean" && r !== "symbol")
    throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
  if (Fn(a, "indent") && a.indent !== null && a.indent !== "	" && !(parseInt(a.indent, 10) === a.indent && a.indent > 0))
    throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
  if (Fn(a, "numericSeparator") && typeof a.numericSeparator != "boolean")
    throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
  var i = a.numericSeparator;
  if (typeof t > "u")
    return "undefined";
  if (t === null)
    return "null";
  if (typeof t == "boolean")
    return t ? "true" : "false";
  if (typeof t == "string")
    return db(t, a);
  if (typeof t == "number") {
    if (t === 0)
      return 1 / 0 / t > 0 ? "0" : "-0";
    var l = String(t);
    return i ? Wf(t, l) : l;
  }
  if (typeof t == "bigint") {
    var c = String(t) + "n";
    return i ? Wf(t, c) : c;
  }
  var u = typeof a.depth > "u" ? 5 : a.depth;
  if (typeof o > "u" && (o = 0), o >= u && u > 0 && typeof t == "object")
    return _u(t) ? "[Array]" : "[Object]";
  var p = XP(a, o);
  if (typeof s > "u")
    s = [];
  else if (pb(s, t) >= 0)
    return "[Circular]";
  function f(E, B, N) {
    if (B && (s = OP.call(s), s.push(B)), N) {
      var Y = {
        depth: a.depth
      };
      return Fn(a, "quoteStyle") && (Y.quoteStyle = a.quoteStyle), e(E, Y, o + 1, s);
    }
    return e(E, a, o + 1, s);
  }
  if (typeof t == "function" && !Kf(t)) {
    var m = UP(t), h = Ir(t, f);
    return "[Function" + (m ? ": " + m : " (anonymous)") + "]" + (h.length > 0 ? " { " + _n.call(h, ", ") + " }" : "");
  }
  if (ub(t)) {
    var g = Ws ? fo.call(String(t), /^(Symbol\(.*\))_[^)]*$/, "$1") : yu.call(t);
    return typeof t == "object" && !Ws ? ha(g) : g;
  }
  if (YP(t)) {
    for (var _ = "<" + Bf.call(String(t.nodeName)), v = t.attributes || [], w = 0; w < v.length; w++)
      _ += " " + v[w].name + "=" + cb(MP(v[w].value), "double", a);
    return _ += ">", t.childNodes && t.childNodes.length && (_ += "..."), _ += "</" + Bf.call(String(t.nodeName)) + ">", _;
  }
  if (_u(t)) {
    if (t.length === 0)
      return "[]";
    var y = Ir(t, f);
    return p && !ZP(y) ? "[" + wu(y, p) + "]" : "[ " + _n.call(y, ", ") + " ]";
  }
  if (NP(t)) {
    var $ = Ir(t, f);
    return !("cause" in Error.prototype) && "cause" in t && !ib.call(t, "cause") ? "{ [" + String(t) + "] " + _n.call(Hf.call("[cause]: " + f(t.cause), $), ", ") + " }" : $.length === 0 ? "[" + String(t) + "]" : "{ [" + String(t) + "] " + _n.call($, ", ") + " }";
  }
  if (typeof t == "object" && r) {
    if (qf && typeof t[qf] == "function" && $u)
      return $u(t, { depth: u - o });
    if (r !== "symbol" && typeof t.inspect == "function")
      return t.inspect();
  }
  if (zP(t)) {
    var S = [];
    return Ff && Ff.call(t, function(E, B) {
      S.push(f(B, t, !0) + " => " + f(E, t));
    }), Yf("Map", Ni.call(t), S, p);
  }
  if (qP(t)) {
    var A = [];
    return Rf && Rf.call(t, function(E) {
      A.push(f(E, t));
    }), Yf("Set", Fi.call(t), A, p);
  }
  if (WP(t))
    return rc("WeakMap");
  if (KP(t))
    return rc("WeakSet");
  if (jP(t))
    return rc("WeakRef");
  if (RP(t))
    return ha(f(Number(t)));
  if (BP(t))
    return ha(f(bu.call(t)));
  if (VP(t))
    return ha(AP.call(t));
  if (FP(t))
    return ha(f(String(t)));
  if (typeof window < "u" && t === window)
    return "{ [object Window] }";
  if (typeof globalThis < "u" && t === globalThis || typeof gu < "u" && t === gu)
    return "{ [object globalThis] }";
  if (!LP(t) && !Kf(t)) {
    var I = Ir(t, f), D = zf ? zf(t) === Object.prototype : t instanceof Object || t.constructor === Object, O = t instanceof Object ? "" : "null prototype", x = !D && Fa && Object(t) === t && Fa in t ? Wp.call(Po(t), 8, -1) : O ? "Object" : "", F = D || typeof t.constructor != "function" ? "" : t.constructor.name ? t.constructor.name + " " : "", P = F + (x || O ? "[" + _n.call(Hf.call([], x || [], O || []), ": ") + "] " : "");
    return I.length === 0 ? P + "{}" : p ? P + "{" + wu(I, p) + "}" : P + "{ " + _n.call(I, ", ") + " }";
  }
  return String(t);
};
function cb(e, t, n) {
  var o = n.quoteStyle || t, s = lb[o];
  return s + e + s;
}
function MP(e) {
  return fo.call(String(e), /"/g, "&quot;");
}
function os(e) {
  return !Fa || !(typeof e == "object" && (Fa in e || typeof e[Fa] < "u"));
}
function _u(e) {
  return Po(e) === "[object Array]" && os(e);
}
function LP(e) {
  return Po(e) === "[object Date]" && os(e);
}
function Kf(e) {
  return Po(e) === "[object RegExp]" && os(e);
}
function NP(e) {
  return Po(e) === "[object Error]" && os(e);
}
function FP(e) {
  return Po(e) === "[object String]" && os(e);
}
function RP(e) {
  return Po(e) === "[object Number]" && os(e);
}
function VP(e) {
  return Po(e) === "[object Boolean]" && os(e);
}
function ub(e) {
  if (Ws)
    return e && typeof e == "object" && e instanceof Symbol;
  if (typeof e == "symbol")
    return !0;
  if (!e || typeof e != "object" || !yu)
    return !1;
  try {
    return yu.call(e), !0;
  } catch {
  }
  return !1;
}
function BP(e) {
  if (!e || typeof e != "object" || !bu)
    return !1;
  try {
    return bu.call(e), !0;
  } catch {
  }
  return !1;
}
var HP = Object.prototype.hasOwnProperty || function(e) {
  return e in this;
};
function Fn(e, t) {
  return HP.call(e, t);
}
function Po(e) {
  return DP.call(e);
}
function UP(e) {
  if (e.name)
    return e.name;
  var t = IP.call(PP.call(e), /^function\s*([\w$]+)/);
  return t ? t[1] : null;
}
function pb(e, t) {
  if (e.indexOf)
    return e.indexOf(t);
  for (var n = 0, o = e.length; n < o; n++)
    if (e[n] === t)
      return n;
  return -1;
}
function zP(e) {
  if (!Ni || !e || typeof e != "object")
    return !1;
  try {
    Ni.call(e);
    try {
      Fi.call(e);
    } catch {
      return !0;
    }
    return e instanceof Map;
  } catch {
  }
  return !1;
}
function WP(e) {
  if (!La || !e || typeof e != "object")
    return !1;
  try {
    La.call(e, La);
    try {
      Na.call(e, Na);
    } catch {
      return !0;
    }
    return e instanceof WeakMap;
  } catch {
  }
  return !1;
}
function jP(e) {
  if (!Vf || !e || typeof e != "object")
    return !1;
  try {
    return Vf.call(e), !0;
  } catch {
  }
  return !1;
}
function qP(e) {
  if (!Fi || !e || typeof e != "object")
    return !1;
  try {
    Fi.call(e);
    try {
      Ni.call(e);
    } catch {
      return !0;
    }
    return e instanceof Set;
  } catch {
  }
  return !1;
}
function KP(e) {
  if (!Na || !e || typeof e != "object")
    return !1;
  try {
    Na.call(e, Na);
    try {
      La.call(e, La);
    } catch {
      return !0;
    }
    return e instanceof WeakSet;
  } catch {
  }
  return !1;
}
function YP(e) {
  return !e || typeof e != "object" ? !1 : typeof HTMLElement < "u" && e instanceof HTMLElement ? !0 : typeof e.nodeName == "string" && typeof e.getAttribute == "function";
}
function db(e, t) {
  if (e.length > t.maxStringLength) {
    var n = e.length - t.maxStringLength, o = "... " + n + " more character" + (n > 1 ? "s" : "");
    return db(Wp.call(e, 0, t.maxStringLength), t) + o;
  }
  var s = xP[t.quoteStyle || "single"];
  s.lastIndex = 0;
  var a = fo.call(fo.call(e, s, "\\$1"), /[\x00-\x1f]/g, GP);
  return cb(a, "single", t);
}
function GP(e) {
  var t = e.charCodeAt(0), n = {
    8: "b",
    9: "t",
    10: "n",
    12: "f",
    13: "r"
  }[t];
  return n ? "\\" + n : "\\x" + (t < 16 ? "0" : "") + EP.call(t.toString(16));
}
function ha(e) {
  return "Object(" + e + ")";
}
function rc(e) {
  return e + " { ? }";
}
function Yf(e, t, n, o) {
  var s = o ? wu(n, o) : _n.call(n, ", ");
  return e + " (" + t + ") {" + s + "}";
}
function ZP(e) {
  for (var t = 0; t < e.length; t++)
    if (pb(e[t], `
`) >= 0)
      return !1;
  return !0;
}
function XP(e, t) {
  var n;
  if (e.indent === "	")
    n = "	";
  else if (typeof e.indent == "number" && e.indent > 0)
    n = _n.call(Array(e.indent + 1), " ");
  else
    return null;
  return {
    base: n,
    prev: _n.call(Array(t + 1), n)
  };
}
function wu(e, t) {
  if (e.length === 0)
    return "";
  var n = `
` + t.prev + t.base;
  return n + _n.call(e, "," + n) + `
` + t.prev;
}
function Ir(e, t) {
  var n = _u(e), o = [];
  if (n) {
    o.length = e.length;
    for (var s = 0; s < e.length; s++)
      o[s] = Fn(e, s) ? t(e[s], e) : "";
  }
  var a = typeof ac == "function" ? ac(e) : [], r;
  if (Ws) {
    r = {};
    for (var i = 0; i < a.length; i++)
      r["$" + a[i]] = a[i];
  }
  for (var l in e)
    Fn(e, l) && (n && String(Number(l)) === l && l < e.length || Ws && r["$" + l] instanceof Symbol || (rb.call(/[^\w$]/, l) ? o.push(t(l, e) + ": " + t(e[l], e)) : o.push(l + ": " + t(e[l], e))));
  if (typeof ac == "function")
    for (var c = 0; c < a.length; c++)
      ib.call(e, a[c]) && o.push("[" + t(a[c]) + "]: " + t(e[a[c]], e));
  return o;
}
var JP = bl, QP = sa, yl = function(e, t, n) {
  for (var o = e, s; (s = o.next) != null; o = s)
    if (s.key === t)
      return o.next = s.next, n || (s.next = /** @type {NonNullable<typeof list.next>} */
      e.next, e.next = s), s;
}, eI = function(e, t) {
  if (e) {
    var n = yl(e, t);
    return n && n.value;
  }
}, tI = function(e, t, n) {
  var o = yl(e, t);
  o ? o.value = n : e.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */
  {
    // eslint-disable-line no-param-reassign, no-extra-parens
    key: t,
    next: e.next,
    value: n
  };
}, nI = function(e, t) {
  return e ? !!yl(e, t) : !1;
}, oI = function(e, t) {
  if (e)
    return yl(e, t, !0);
}, sI = function() {
  var t, n = {
    assert: function(o) {
      if (!n.has(o))
        throw new QP("Side channel does not contain " + JP(o));
    },
    delete: function(o) {
      var s = t && t.next, a = oI(t, o);
      return a && s && s === a && (t = void 0), !!a;
    },
    get: function(o) {
      return eI(t, o);
    },
    has: function(o) {
      return nI(t, o);
    },
    set: function(o, s) {
      t || (t = {
        next: void 0
      }), tI(
        /** @type {NonNullable<typeof $o>} */
        t,
        o,
        s
      );
    }
  };
  return n;
}, fb = Object, aI = Error, rI = EvalError, iI = RangeError, lI = ReferenceError, cI = SyntaxError, uI = URIError, pI = Math.abs, dI = Math.floor, fI = Math.max, mI = Math.min, vI = Math.pow, hI = Math.round, gI = Number.isNaN || function(t) {
  return t !== t;
}, bI = gI, yI = function(t) {
  return bI(t) || t === 0 ? t : t < 0 ? -1 : 1;
}, $I = Object.getOwnPropertyDescriptor, Zr = $I;
if (Zr)
  try {
    Zr([], "length");
  } catch {
    Zr = null;
  }
var mb = Zr, Xr = Object.defineProperty || !1;
if (Xr)
  try {
    Xr({}, "a", { value: 1 });
  } catch {
    Xr = !1;
  }
var _I = Xr, ic, Gf;
function wI() {
  return Gf || (Gf = 1, ic = function() {
    if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
      return !1;
    if (typeof Symbol.iterator == "symbol")
      return !0;
    var t = {}, n = Symbol("test"), o = Object(n);
    if (typeof n == "string" || Object.prototype.toString.call(n) !== "[object Symbol]" || Object.prototype.toString.call(o) !== "[object Symbol]")
      return !1;
    var s = 42;
    t[n] = s;
    for (var a in t)
      return !1;
    if (typeof Object.keys == "function" && Object.keys(t).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(t).length !== 0)
      return !1;
    var r = Object.getOwnPropertySymbols(t);
    if (r.length !== 1 || r[0] !== n || !Object.prototype.propertyIsEnumerable.call(t, n))
      return !1;
    if (typeof Object.getOwnPropertyDescriptor == "function") {
      var i = (
        /** @type {PropertyDescriptor} */
        Object.getOwnPropertyDescriptor(t, n)
      );
      if (i.value !== s || i.enumerable !== !0)
        return !1;
    }
    return !0;
  }), ic;
}
var lc, Zf;
function CI() {
  if (Zf) return lc;
  Zf = 1;
  var e = typeof Symbol < "u" && Symbol, t = wI();
  return lc = function() {
    return typeof e != "function" || typeof Symbol != "function" || typeof e("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : t();
  }, lc;
}
var cc, Xf;
function vb() {
  return Xf || (Xf = 1, cc = typeof Reflect < "u" && Reflect.getPrototypeOf || null), cc;
}
var uc, Jf;
function hb() {
  if (Jf) return uc;
  Jf = 1;
  var e = fb;
  return uc = e.getPrototypeOf || null, uc;
}
var kI = "Function.prototype.bind called on incompatible ", SI = Object.prototype.toString, TI = Math.max, AI = "[object Function]", Qf = function(t, n) {
  for (var o = [], s = 0; s < t.length; s += 1)
    o[s] = t[s];
  for (var a = 0; a < n.length; a += 1)
    o[a + t.length] = n[a];
  return o;
}, DI = function(t, n) {
  for (var o = [], s = n, a = 0; s < t.length; s += 1, a += 1)
    o[a] = t[s];
  return o;
}, PI = function(e, t) {
  for (var n = "", o = 0; o < e.length; o += 1)
    n += e[o], o + 1 < e.length && (n += t);
  return n;
}, II = function(t) {
  var n = this;
  if (typeof n != "function" || SI.apply(n) !== AI)
    throw new TypeError(kI + n);
  for (var o = DI(arguments, 1), s, a = function() {
    if (this instanceof s) {
      var u = n.apply(
        this,
        Qf(o, arguments)
      );
      return Object(u) === u ? u : this;
    }
    return n.apply(
      t,
      Qf(o, arguments)
    );
  }, r = TI(0, n.length - o.length), i = [], l = 0; l < r; l++)
    i[l] = "$" + l;
  if (s = Function("binder", "return function (" + PI(i, ",") + "){ return binder.apply(this,arguments); }")(a), n.prototype) {
    var c = function() {
    };
    c.prototype = n.prototype, s.prototype = new c(), c.prototype = null;
  }
  return s;
}, EI = II, $l = Function.prototype.bind || EI, jp = Function.prototype.call, pc, em;
function gb() {
  return em || (em = 1, pc = Function.prototype.apply), pc;
}
var OI = typeof Reflect < "u" && Reflect && Reflect.apply, xI = $l, MI = gb(), LI = jp, NI = OI, FI = NI || xI.call(LI, MI), RI = $l, VI = sa, BI = jp, HI = FI, bb = function(t) {
  if (t.length < 1 || typeof t[0] != "function")
    throw new VI("a function is required");
  return HI(RI, BI, t);
}, dc, tm;
function UI() {
  if (tm) return dc;
  tm = 1;
  var e = bb, t = mb, n;
  try {
    n = /** @type {{ __proto__?: typeof Array.prototype }} */
    [].__proto__ === Array.prototype;
  } catch (r) {
    if (!r || typeof r != "object" || !("code" in r) || r.code !== "ERR_PROTO_ACCESS")
      throw r;
  }
  var o = !!n && t && t(
    Object.prototype,
    /** @type {keyof typeof Object.prototype} */
    "__proto__"
  ), s = Object, a = s.getPrototypeOf;
  return dc = o && typeof o.get == "function" ? e([o.get]) : typeof a == "function" ? (
    /** @type {import('./get')} */
    function(i) {
      return a(i == null ? i : s(i));
    }
  ) : !1, dc;
}
var fc, nm;
function zI() {
  if (nm) return fc;
  nm = 1;
  var e = vb(), t = hb(), n = UI();
  return fc = e ? function(s) {
    return e(s);
  } : t ? function(s) {
    if (!s || typeof s != "object" && typeof s != "function")
      throw new TypeError("getProto: not an object");
    return t(s);
  } : n ? function(s) {
    return n(s);
  } : null, fc;
}
var mc, om;
function WI() {
  if (om) return mc;
  om = 1;
  var e = Function.prototype.call, t = Object.prototype.hasOwnProperty, n = $l;
  return mc = n.call(e, t), mc;
}
var xe, jI = fb, qI = aI, KI = rI, YI = iI, GI = lI, js = cI, xs = sa, ZI = uI, XI = pI, JI = dI, QI = fI, eE = mI, tE = vI, nE = hI, oE = yI, yb = Function, vc = function(e) {
  try {
    return yb('"use strict"; return (' + e + ").constructor;")();
  } catch {
  }
}, Ja = mb, sE = _I, hc = function() {
  throw new xs();
}, aE = Ja ? function() {
  try {
    return arguments.callee, hc;
  } catch {
    try {
      return Ja(arguments, "callee").get;
    } catch {
      return hc;
    }
  }
}() : hc, us = CI()(), gt = zI(), rE = hb(), iE = vb(), $b = gb(), ur = jp, ys = {}, lE = typeof Uint8Array > "u" || !gt ? xe : gt(Uint8Array), qo = {
  __proto__: null,
  "%AggregateError%": typeof AggregateError > "u" ? xe : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer > "u" ? xe : ArrayBuffer,
  "%ArrayIteratorPrototype%": us && gt ? gt([][Symbol.iterator]()) : xe,
  "%AsyncFromSyncIteratorPrototype%": xe,
  "%AsyncFunction%": ys,
  "%AsyncGenerator%": ys,
  "%AsyncGeneratorFunction%": ys,
  "%AsyncIteratorPrototype%": ys,
  "%Atomics%": typeof Atomics > "u" ? xe : Atomics,
  "%BigInt%": typeof BigInt > "u" ? xe : BigInt,
  "%BigInt64Array%": typeof BigInt64Array > "u" ? xe : BigInt64Array,
  "%BigUint64Array%": typeof BigUint64Array > "u" ? xe : BigUint64Array,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView > "u" ? xe : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": qI,
  "%eval%": eval,
  // eslint-disable-line no-eval
  "%EvalError%": KI,
  "%Float16Array%": typeof Float16Array > "u" ? xe : Float16Array,
  "%Float32Array%": typeof Float32Array > "u" ? xe : Float32Array,
  "%Float64Array%": typeof Float64Array > "u" ? xe : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? xe : FinalizationRegistry,
  "%Function%": yb,
  "%GeneratorFunction%": ys,
  "%Int8Array%": typeof Int8Array > "u" ? xe : Int8Array,
  "%Int16Array%": typeof Int16Array > "u" ? xe : Int16Array,
  "%Int32Array%": typeof Int32Array > "u" ? xe : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": us && gt ? gt(gt([][Symbol.iterator]())) : xe,
  "%JSON%": typeof JSON == "object" ? JSON : xe,
  "%Map%": typeof Map > "u" ? xe : Map,
  "%MapIteratorPrototype%": typeof Map > "u" || !us || !gt ? xe : gt((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": jI,
  "%Object.getOwnPropertyDescriptor%": Ja,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise > "u" ? xe : Promise,
  "%Proxy%": typeof Proxy > "u" ? xe : Proxy,
  "%RangeError%": YI,
  "%ReferenceError%": GI,
  "%Reflect%": typeof Reflect > "u" ? xe : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set > "u" ? xe : Set,
  "%SetIteratorPrototype%": typeof Set > "u" || !us || !gt ? xe : gt((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? xe : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": us && gt ? gt(""[Symbol.iterator]()) : xe,
  "%Symbol%": us ? Symbol : xe,
  "%SyntaxError%": js,
  "%ThrowTypeError%": aE,
  "%TypedArray%": lE,
  "%TypeError%": xs,
  "%Uint8Array%": typeof Uint8Array > "u" ? xe : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? xe : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array > "u" ? xe : Uint16Array,
  "%Uint32Array%": typeof Uint32Array > "u" ? xe : Uint32Array,
  "%URIError%": ZI,
  "%WeakMap%": typeof WeakMap > "u" ? xe : WeakMap,
  "%WeakRef%": typeof WeakRef > "u" ? xe : WeakRef,
  "%WeakSet%": typeof WeakSet > "u" ? xe : WeakSet,
  "%Function.prototype.call%": ur,
  "%Function.prototype.apply%": $b,
  "%Object.defineProperty%": sE,
  "%Object.getPrototypeOf%": rE,
  "%Math.abs%": XI,
  "%Math.floor%": JI,
  "%Math.max%": QI,
  "%Math.min%": eE,
  "%Math.pow%": tE,
  "%Math.round%": nE,
  "%Math.sign%": oE,
  "%Reflect.getPrototypeOf%": iE
};
if (gt)
  try {
    null.error;
  } catch (e) {
    var cE = gt(gt(e));
    qo["%Error.prototype%"] = cE;
  }
var uE = function e(t) {
  var n;
  if (t === "%AsyncFunction%")
    n = vc("async function () {}");
  else if (t === "%GeneratorFunction%")
    n = vc("function* () {}");
  else if (t === "%AsyncGeneratorFunction%")
    n = vc("async function* () {}");
  else if (t === "%AsyncGenerator%") {
    var o = e("%AsyncGeneratorFunction%");
    o && (n = o.prototype);
  } else if (t === "%AsyncIteratorPrototype%") {
    var s = e("%AsyncGenerator%");
    s && gt && (n = gt(s.prototype));
  }
  return qo[t] = n, n;
}, sm = {
  __proto__: null,
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
}, pr = $l, Ri = WI(), pE = pr.call(ur, Array.prototype.concat), dE = pr.call($b, Array.prototype.splice), am = pr.call(ur, String.prototype.replace), Vi = pr.call(ur, String.prototype.slice), fE = pr.call(ur, RegExp.prototype.exec), mE = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, vE = /\\(\\)?/g, hE = function(t) {
  var n = Vi(t, 0, 1), o = Vi(t, -1);
  if (n === "%" && o !== "%")
    throw new js("invalid intrinsic syntax, expected closing `%`");
  if (o === "%" && n !== "%")
    throw new js("invalid intrinsic syntax, expected opening `%`");
  var s = [];
  return am(t, mE, function(a, r, i, l) {
    s[s.length] = i ? am(l, vE, "$1") : r || a;
  }), s;
}, gE = function(t, n) {
  var o = t, s;
  if (Ri(sm, o) && (s = sm[o], o = "%" + s[0] + "%"), Ri(qo, o)) {
    var a = qo[o];
    if (a === ys && (a = uE(o)), typeof a > "u" && !n)
      throw new xs("intrinsic " + t + " exists, but is not available. Please file an issue!");
    return {
      alias: s,
      name: o,
      value: a
    };
  }
  throw new js("intrinsic " + t + " does not exist!");
}, qp = function(t, n) {
  if (typeof t != "string" || t.length === 0)
    throw new xs("intrinsic name must be a non-empty string");
  if (arguments.length > 1 && typeof n != "boolean")
    throw new xs('"allowMissing" argument must be a boolean');
  if (fE(/^%?[^%]*%?$/, t) === null)
    throw new js("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
  var o = hE(t), s = o.length > 0 ? o[0] : "", a = gE("%" + s + "%", n), r = a.name, i = a.value, l = !1, c = a.alias;
  c && (s = c[0], dE(o, pE([0, 1], c)));
  for (var u = 1, p = !0; u < o.length; u += 1) {
    var f = o[u], m = Vi(f, 0, 1), h = Vi(f, -1);
    if ((m === '"' || m === "'" || m === "`" || h === '"' || h === "'" || h === "`") && m !== h)
      throw new js("property names with quotes must have matching quotes");
    if ((f === "constructor" || !p) && (l = !0), s += "." + f, r = "%" + s + "%", Ri(qo, r))
      i = qo[r];
    else if (i != null) {
      if (!(f in i)) {
        if (!n)
          throw new xs("base intrinsic for " + t + " exists, but the property is not available.");
        return;
      }
      if (Ja && u + 1 >= o.length) {
        var g = Ja(i, f);
        p = !!g, p && "get" in g && !("originalValue" in g.get) ? i = g.get : i = i[f];
      } else
        p = Ri(i, f), i = i[f];
      p && !l && (qo[r] = i);
    }
  }
  return i;
}, _b = qp, wb = bb, bE = wb([_b("%String.prototype.indexOf%")]), Cb = function(t, n) {
  var o = (
    /** @type {(this: unknown, ...args: unknown[]) => unknown} */
    _b(t, !!n)
  );
  return typeof o == "function" && bE(t, ".prototype.") > -1 ? wb(
    /** @type {const} */
    [o]
  ) : o;
}, yE = qp, dr = Cb, $E = bl, _E = sa, rm = yE("%Map%", !0), wE = dr("Map.prototype.get", !0), CE = dr("Map.prototype.set", !0), kE = dr("Map.prototype.has", !0), SE = dr("Map.prototype.delete", !0), TE = dr("Map.prototype.size", !0), kb = !!rm && /** @type {Exclude<import('.'), false>} */
function() {
  var t, n = {
    assert: function(o) {
      if (!n.has(o))
        throw new _E("Side channel does not contain " + $E(o));
    },
    delete: function(o) {
      if (t) {
        var s = SE(t, o);
        return TE(t) === 0 && (t = void 0), s;
      }
      return !1;
    },
    get: function(o) {
      if (t)
        return wE(t, o);
    },
    has: function(o) {
      return t ? kE(t, o) : !1;
    },
    set: function(o, s) {
      t || (t = new rm()), CE(t, o, s);
    }
  };
  return n;
}, AE = qp, _l = Cb, DE = bl, Er = kb, PE = sa, ps = AE("%WeakMap%", !0), IE = _l("WeakMap.prototype.get", !0), EE = _l("WeakMap.prototype.set", !0), OE = _l("WeakMap.prototype.has", !0), xE = _l("WeakMap.prototype.delete", !0), ME = ps ? (
  /** @type {Exclude<import('.'), false>} */
  function() {
    var t, n, o = {
      assert: function(s) {
        if (!o.has(s))
          throw new PE("Side channel does not contain " + DE(s));
      },
      delete: function(s) {
        if (ps && s && (typeof s == "object" || typeof s == "function")) {
          if (t)
            return xE(t, s);
        } else if (Er && n)
          return n.delete(s);
        return !1;
      },
      get: function(s) {
        return ps && s && (typeof s == "object" || typeof s == "function") && t ? IE(t, s) : n && n.get(s);
      },
      has: function(s) {
        return ps && s && (typeof s == "object" || typeof s == "function") && t ? OE(t, s) : !!n && n.has(s);
      },
      set: function(s, a) {
        ps && s && (typeof s == "object" || typeof s == "function") ? (t || (t = new ps()), EE(t, s, a)) : Er && (n || (n = Er()), n.set(s, a));
      }
    };
    return o;
  }
) : Er, LE = sa, NE = bl, FE = sI, RE = kb, VE = ME, BE = VE || RE || FE, HE = function() {
  var t, n = {
    assert: function(o) {
      if (!n.has(o))
        throw new LE("Side channel does not contain " + NE(o));
    },
    delete: function(o) {
      return !!t && t.delete(o);
    },
    get: function(o) {
      return t && t.get(o);
    },
    has: function(o) {
      return !!t && t.has(o);
    },
    set: function(o, s) {
      t || (t = BE()), t.set(o, s);
    }
  };
  return n;
}, UE = String.prototype.replace, zE = /%20/g, gc = {
  RFC1738: "RFC1738",
  RFC3986: "RFC3986"
}, Kp = {
  default: gc.RFC3986,
  formatters: {
    RFC1738: function(e) {
      return UE.call(e, zE, "+");
    },
    RFC3986: function(e) {
      return String(e);
    }
  },
  RFC1738: gc.RFC1738,
  RFC3986: gc.RFC3986
}, WE = Kp, bc = Object.prototype.hasOwnProperty, Vo = Array.isArray, gn = function() {
  for (var e = [], t = 0; t < 256; ++t)
    e.push("%" + ((t < 16 ? "0" : "") + t.toString(16)).toUpperCase());
  return e;
}(), jE = function(t) {
  for (; t.length > 1; ) {
    var n = t.pop(), o = n.obj[n.prop];
    if (Vo(o)) {
      for (var s = [], a = 0; a < o.length; ++a)
        typeof o[a] < "u" && s.push(o[a]);
      n.obj[n.prop] = s;
    }
  }
}, Sb = function(t, n) {
  for (var o = n && n.plainObjects ? { __proto__: null } : {}, s = 0; s < t.length; ++s)
    typeof t[s] < "u" && (o[s] = t[s]);
  return o;
}, qE = function e(t, n, o) {
  if (!n)
    return t;
  if (typeof n != "object" && typeof n != "function") {
    if (Vo(t))
      t.push(n);
    else if (t && typeof t == "object")
      (o && (o.plainObjects || o.allowPrototypes) || !bc.call(Object.prototype, n)) && (t[n] = !0);
    else
      return [t, n];
    return t;
  }
  if (!t || typeof t != "object")
    return [t].concat(n);
  var s = t;
  return Vo(t) && !Vo(n) && (s = Sb(t, o)), Vo(t) && Vo(n) ? (n.forEach(function(a, r) {
    if (bc.call(t, r)) {
      var i = t[r];
      i && typeof i == "object" && a && typeof a == "object" ? t[r] = e(i, a, o) : t.push(a);
    } else
      t[r] = a;
  }), t) : Object.keys(n).reduce(function(a, r) {
    var i = n[r];
    return bc.call(a, r) ? a[r] = e(a[r], i, o) : a[r] = i, a;
  }, s);
}, KE = function(t, n) {
  return Object.keys(n).reduce(function(o, s) {
    return o[s] = n[s], o;
  }, t);
}, YE = function(e, t, n) {
  var o = e.replace(/\+/g, " ");
  if (n === "iso-8859-1")
    return o.replace(/%[0-9a-f]{2}/gi, unescape);
  try {
    return decodeURIComponent(o);
  } catch {
    return o;
  }
}, yc = 1024, GE = function(t, n, o, s, a) {
  if (t.length === 0)
    return t;
  var r = t;
  if (typeof t == "symbol" ? r = Symbol.prototype.toString.call(t) : typeof t != "string" && (r = String(t)), o === "iso-8859-1")
    return escape(r).replace(/%u[0-9a-f]{4}/gi, function(m) {
      return "%26%23" + parseInt(m.slice(2), 16) + "%3B";
    });
  for (var i = "", l = 0; l < r.length; l += yc) {
    for (var c = r.length >= yc ? r.slice(l, l + yc) : r, u = [], p = 0; p < c.length; ++p) {
      var f = c.charCodeAt(p);
      if (f === 45 || f === 46 || f === 95 || f === 126 || f >= 48 && f <= 57 || f >= 65 && f <= 90 || f >= 97 && f <= 122 || a === WE.RFC1738 && (f === 40 || f === 41)) {
        u[u.length] = c.charAt(p);
        continue;
      }
      if (f < 128) {
        u[u.length] = gn[f];
        continue;
      }
      if (f < 2048) {
        u[u.length] = gn[192 | f >> 6] + gn[128 | f & 63];
        continue;
      }
      if (f < 55296 || f >= 57344) {
        u[u.length] = gn[224 | f >> 12] + gn[128 | f >> 6 & 63] + gn[128 | f & 63];
        continue;
      }
      p += 1, f = 65536 + ((f & 1023) << 10 | c.charCodeAt(p) & 1023), u[u.length] = gn[240 | f >> 18] + gn[128 | f >> 12 & 63] + gn[128 | f >> 6 & 63] + gn[128 | f & 63];
    }
    i += u.join("");
  }
  return i;
}, ZE = function(t) {
  for (var n = [{ obj: { o: t }, prop: "o" }], o = [], s = 0; s < n.length; ++s)
    for (var a = n[s], r = a.obj[a.prop], i = Object.keys(r), l = 0; l < i.length; ++l) {
      var c = i[l], u = r[c];
      typeof u == "object" && u !== null && o.indexOf(u) === -1 && (n.push({ obj: r, prop: c }), o.push(u));
    }
  return jE(n), t;
}, XE = function(t) {
  return Object.prototype.toString.call(t) === "[object RegExp]";
}, JE = function(t) {
  return !t || typeof t != "object" ? !1 : !!(t.constructor && t.constructor.isBuffer && t.constructor.isBuffer(t));
}, QE = function(t, n) {
  return [].concat(t, n);
}, eO = function(t, n) {
  if (Vo(t)) {
    for (var o = [], s = 0; s < t.length; s += 1)
      o.push(n(t[s]));
    return o;
  }
  return n(t);
}, Tb = {
  arrayToObject: Sb,
  assign: KE,
  combine: QE,
  compact: ZE,
  decode: YE,
  encode: GE,
  isBuffer: JE,
  isRegExp: XE,
  maybeMap: eO,
  merge: qE
}, Ab = HE, Jr = Tb, Ra = Kp, tO = Object.prototype.hasOwnProperty, Db = {
  brackets: function(t) {
    return t + "[]";
  },
  comma: "comma",
  indices: function(t, n) {
    return t + "[" + n + "]";
  },
  repeat: function(t) {
    return t;
  }
}, $n = Array.isArray, nO = Array.prototype.push, Pb = function(e, t) {
  nO.apply(e, $n(t) ? t : [t]);
}, oO = Date.prototype.toISOString, im = Ra.default, ft = {
  addQueryPrefix: !1,
  allowDots: !1,
  allowEmptyArrays: !1,
  arrayFormat: "indices",
  charset: "utf-8",
  charsetSentinel: !1,
  commaRoundTrip: !1,
  delimiter: "&",
  encode: !0,
  encodeDotInKeys: !1,
  encoder: Jr.encode,
  encodeValuesOnly: !1,
  filter: void 0,
  format: im,
  formatter: Ra.formatters[im],
  // deprecated
  indices: !1,
  serializeDate: function(t) {
    return oO.call(t);
  },
  skipNulls: !1,
  strictNullHandling: !1
}, sO = function(t) {
  return typeof t == "string" || typeof t == "number" || typeof t == "boolean" || typeof t == "symbol" || typeof t == "bigint";
}, $c = {}, aO = function e(t, n, o, s, a, r, i, l, c, u, p, f, m, h, g, _, v, w) {
  for (var y = t, $ = w, S = 0, A = !1; ($ = $.get($c)) !== void 0 && !A; ) {
    var I = $.get(t);
    if (S += 1, typeof I < "u") {
      if (I === S)
        throw new RangeError("Cyclic object value");
      A = !0;
    }
    typeof $.get($c) > "u" && (S = 0);
  }
  if (typeof u == "function" ? y = u(n, y) : y instanceof Date ? y = m(y) : o === "comma" && $n(y) && (y = Jr.maybeMap(y, function(ce) {
    return ce instanceof Date ? m(ce) : ce;
  })), y === null) {
    if (r)
      return c && !_ ? c(n, ft.encoder, v, "key", h) : n;
    y = "";
  }
  if (sO(y) || Jr.isBuffer(y)) {
    if (c) {
      var D = _ ? n : c(n, ft.encoder, v, "key", h);
      return [g(D) + "=" + g(c(y, ft.encoder, v, "value", h))];
    }
    return [g(n) + "=" + g(String(y))];
  }
  var O = [];
  if (typeof y > "u")
    return O;
  var x;
  if (o === "comma" && $n(y))
    _ && c && (y = Jr.maybeMap(y, c)), x = [{ value: y.length > 0 ? y.join(",") || null : void 0 }];
  else if ($n(u))
    x = u;
  else {
    var F = Object.keys(y);
    x = p ? F.sort(p) : F;
  }
  var P = l ? String(n).replace(/\./g, "%2E") : String(n), E = s && $n(y) && y.length === 1 ? P + "[]" : P;
  if (a && $n(y) && y.length === 0)
    return E + "[]";
  for (var B = 0; B < x.length; ++B) {
    var N = x[B], Y = typeof N == "object" && N && typeof N.value < "u" ? N.value : y[N];
    if (!(i && Y === null)) {
      var j = f && l ? String(N).replace(/\./g, "%2E") : String(N), ee = $n(y) ? typeof o == "function" ? o(E, j) : E : E + (f ? "." + j : "[" + j + "]");
      w.set(t, S);
      var te = Ab();
      te.set($c, w), Pb(O, e(
        Y,
        ee,
        o,
        s,
        a,
        r,
        i,
        l,
        o === "comma" && _ && $n(y) ? null : c,
        u,
        p,
        f,
        m,
        h,
        g,
        _,
        v,
        te
      ));
    }
  }
  return O;
}, rO = function(t) {
  if (!t)
    return ft;
  if (typeof t.allowEmptyArrays < "u" && typeof t.allowEmptyArrays != "boolean")
    throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
  if (typeof t.encodeDotInKeys < "u" && typeof t.encodeDotInKeys != "boolean")
    throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
  if (t.encoder !== null && typeof t.encoder < "u" && typeof t.encoder != "function")
    throw new TypeError("Encoder has to be a function.");
  var n = t.charset || ft.charset;
  if (typeof t.charset < "u" && t.charset !== "utf-8" && t.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  var o = Ra.default;
  if (typeof t.format < "u") {
    if (!tO.call(Ra.formatters, t.format))
      throw new TypeError("Unknown format option provided.");
    o = t.format;
  }
  var s = Ra.formatters[o], a = ft.filter;
  (typeof t.filter == "function" || $n(t.filter)) && (a = t.filter);
  var r;
  if (t.arrayFormat in Db ? r = t.arrayFormat : "indices" in t ? r = t.indices ? "indices" : "repeat" : r = ft.arrayFormat, "commaRoundTrip" in t && typeof t.commaRoundTrip != "boolean")
    throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
  var i = typeof t.allowDots > "u" ? t.encodeDotInKeys === !0 ? !0 : ft.allowDots : !!t.allowDots;
  return {
    addQueryPrefix: typeof t.addQueryPrefix == "boolean" ? t.addQueryPrefix : ft.addQueryPrefix,
    allowDots: i,
    allowEmptyArrays: typeof t.allowEmptyArrays == "boolean" ? !!t.allowEmptyArrays : ft.allowEmptyArrays,
    arrayFormat: r,
    charset: n,
    charsetSentinel: typeof t.charsetSentinel == "boolean" ? t.charsetSentinel : ft.charsetSentinel,
    commaRoundTrip: !!t.commaRoundTrip,
    delimiter: typeof t.delimiter > "u" ? ft.delimiter : t.delimiter,
    encode: typeof t.encode == "boolean" ? t.encode : ft.encode,
    encodeDotInKeys: typeof t.encodeDotInKeys == "boolean" ? t.encodeDotInKeys : ft.encodeDotInKeys,
    encoder: typeof t.encoder == "function" ? t.encoder : ft.encoder,
    encodeValuesOnly: typeof t.encodeValuesOnly == "boolean" ? t.encodeValuesOnly : ft.encodeValuesOnly,
    filter: a,
    format: o,
    formatter: s,
    serializeDate: typeof t.serializeDate == "function" ? t.serializeDate : ft.serializeDate,
    skipNulls: typeof t.skipNulls == "boolean" ? t.skipNulls : ft.skipNulls,
    sort: typeof t.sort == "function" ? t.sort : null,
    strictNullHandling: typeof t.strictNullHandling == "boolean" ? t.strictNullHandling : ft.strictNullHandling
  };
}, iO = function(e, t) {
  var n = e, o = rO(t), s, a;
  typeof o.filter == "function" ? (a = o.filter, n = a("", n)) : $n(o.filter) && (a = o.filter, s = a);
  var r = [];
  if (typeof n != "object" || n === null)
    return "";
  var i = Db[o.arrayFormat], l = i === "comma" && o.commaRoundTrip;
  s || (s = Object.keys(n)), o.sort && s.sort(o.sort);
  for (var c = Ab(), u = 0; u < s.length; ++u) {
    var p = s[u], f = n[p];
    o.skipNulls && f === null || Pb(r, aO(
      f,
      p,
      i,
      l,
      o.allowEmptyArrays,
      o.strictNullHandling,
      o.skipNulls,
      o.encodeDotInKeys,
      o.encode ? o.encoder : null,
      o.filter,
      o.sort,
      o.allowDots,
      o.serializeDate,
      o.format,
      o.formatter,
      o.encodeValuesOnly,
      o.charset,
      c
    ));
  }
  var m = r.join(o.delimiter), h = o.addQueryPrefix === !0 ? "?" : "";
  return o.charsetSentinel && (o.charset === "iso-8859-1" ? h += "utf8=%26%2310003%3B&" : h += "utf8=%E2%9C%93&"), m.length > 0 ? h + m : "";
}, Qo = Tb, Cu = Object.prototype.hasOwnProperty, lm = Array.isArray, nt = {
  allowDots: !1,
  allowEmptyArrays: !1,
  allowPrototypes: !1,
  allowSparse: !1,
  arrayLimit: 20,
  charset: "utf-8",
  charsetSentinel: !1,
  comma: !1,
  decodeDotInKeys: !1,
  decoder: Qo.decode,
  delimiter: "&",
  depth: 5,
  duplicates: "combine",
  ignoreQueryPrefix: !1,
  interpretNumericEntities: !1,
  parameterLimit: 1e3,
  parseArrays: !0,
  plainObjects: !1,
  strictDepth: !1,
  strictNullHandling: !1,
  throwOnLimitExceeded: !1
}, lO = function(e) {
  return e.replace(/&#(\d+);/g, function(t, n) {
    return String.fromCharCode(parseInt(n, 10));
  });
}, Ib = function(e, t, n) {
  if (e && typeof e == "string" && t.comma && e.indexOf(",") > -1)
    return e.split(",");
  if (t.throwOnLimitExceeded && n >= t.arrayLimit)
    throw new RangeError("Array limit exceeded. Only " + t.arrayLimit + " element" + (t.arrayLimit === 1 ? "" : "s") + " allowed in an array.");
  return e;
}, cO = "utf8=%26%2310003%3B", uO = "utf8=%E2%9C%93", pO = function(t, n) {
  var o = { __proto__: null }, s = n.ignoreQueryPrefix ? t.replace(/^\?/, "") : t;
  s = s.replace(/%5B/gi, "[").replace(/%5D/gi, "]");
  var a = n.parameterLimit === 1 / 0 ? void 0 : n.parameterLimit, r = s.split(
    n.delimiter,
    n.throwOnLimitExceeded ? a + 1 : a
  );
  if (n.throwOnLimitExceeded && r.length > a)
    throw new RangeError("Parameter limit exceeded. Only " + a + " parameter" + (a === 1 ? "" : "s") + " allowed.");
  var i = -1, l, c = n.charset;
  if (n.charsetSentinel)
    for (l = 0; l < r.length; ++l)
      r[l].indexOf("utf8=") === 0 && (r[l] === uO ? c = "utf-8" : r[l] === cO && (c = "iso-8859-1"), i = l, l = r.length);
  for (l = 0; l < r.length; ++l)
    if (l !== i) {
      var u = r[l], p = u.indexOf("]="), f = p === -1 ? u.indexOf("=") : p + 1, m, h;
      f === -1 ? (m = n.decoder(u, nt.decoder, c, "key"), h = n.strictNullHandling ? null : "") : (m = n.decoder(u.slice(0, f), nt.decoder, c, "key"), h = Qo.maybeMap(
        Ib(
          u.slice(f + 1),
          n,
          lm(o[m]) ? o[m].length : 0
        ),
        function(_) {
          return n.decoder(_, nt.decoder, c, "value");
        }
      )), h && n.interpretNumericEntities && c === "iso-8859-1" && (h = lO(String(h))), u.indexOf("[]=") > -1 && (h = lm(h) ? [h] : h);
      var g = Cu.call(o, m);
      g && n.duplicates === "combine" ? o[m] = Qo.combine(o[m], h) : (!g || n.duplicates === "last") && (o[m] = h);
    }
  return o;
}, dO = function(e, t, n, o) {
  var s = 0;
  if (e.length > 0 && e[e.length - 1] === "[]") {
    var a = e.slice(0, -1).join("");
    s = Array.isArray(t) && t[a] ? t[a].length : 0;
  }
  for (var r = o ? t : Ib(t, n, s), i = e.length - 1; i >= 0; --i) {
    var l, c = e[i];
    if (c === "[]" && n.parseArrays)
      l = n.allowEmptyArrays && (r === "" || n.strictNullHandling && r === null) ? [] : Qo.combine([], r);
    else {
      l = n.plainObjects ? { __proto__: null } : {};
      var u = c.charAt(0) === "[" && c.charAt(c.length - 1) === "]" ? c.slice(1, -1) : c, p = n.decodeDotInKeys ? u.replace(/%2E/g, ".") : u, f = parseInt(p, 10);
      !n.parseArrays && p === "" ? l = { 0: r } : !isNaN(f) && c !== p && String(f) === p && f >= 0 && n.parseArrays && f <= n.arrayLimit ? (l = [], l[f] = r) : p !== "__proto__" && (l[p] = r);
    }
    r = l;
  }
  return r;
}, fO = function(t, n, o, s) {
  if (t) {
    var a = o.allowDots ? t.replace(/\.([^.[]+)/g, "[$1]") : t, r = /(\[[^[\]]*])/, i = /(\[[^[\]]*])/g, l = o.depth > 0 && r.exec(a), c = l ? a.slice(0, l.index) : a, u = [];
    if (c) {
      if (!o.plainObjects && Cu.call(Object.prototype, c) && !o.allowPrototypes)
        return;
      u.push(c);
    }
    for (var p = 0; o.depth > 0 && (l = i.exec(a)) !== null && p < o.depth; ) {
      if (p += 1, !o.plainObjects && Cu.call(Object.prototype, l[1].slice(1, -1)) && !o.allowPrototypes)
        return;
      u.push(l[1]);
    }
    if (l) {
      if (o.strictDepth === !0)
        throw new RangeError("Input depth exceeded depth option of " + o.depth + " and strictDepth is true");
      u.push("[" + a.slice(l.index) + "]");
    }
    return dO(u, n, o, s);
  }
}, mO = function(t) {
  if (!t)
    return nt;
  if (typeof t.allowEmptyArrays < "u" && typeof t.allowEmptyArrays != "boolean")
    throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
  if (typeof t.decodeDotInKeys < "u" && typeof t.decodeDotInKeys != "boolean")
    throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
  if (t.decoder !== null && typeof t.decoder < "u" && typeof t.decoder != "function")
    throw new TypeError("Decoder has to be a function.");
  if (typeof t.charset < "u" && t.charset !== "utf-8" && t.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  if (typeof t.throwOnLimitExceeded < "u" && typeof t.throwOnLimitExceeded != "boolean")
    throw new TypeError("`throwOnLimitExceeded` option must be a boolean");
  var n = typeof t.charset > "u" ? nt.charset : t.charset, o = typeof t.duplicates > "u" ? nt.duplicates : t.duplicates;
  if (o !== "combine" && o !== "first" && o !== "last")
    throw new TypeError("The duplicates option must be either combine, first, or last");
  var s = typeof t.allowDots > "u" ? t.decodeDotInKeys === !0 ? !0 : nt.allowDots : !!t.allowDots;
  return {
    allowDots: s,
    allowEmptyArrays: typeof t.allowEmptyArrays == "boolean" ? !!t.allowEmptyArrays : nt.allowEmptyArrays,
    allowPrototypes: typeof t.allowPrototypes == "boolean" ? t.allowPrototypes : nt.allowPrototypes,
    allowSparse: typeof t.allowSparse == "boolean" ? t.allowSparse : nt.allowSparse,
    arrayLimit: typeof t.arrayLimit == "number" ? t.arrayLimit : nt.arrayLimit,
    charset: n,
    charsetSentinel: typeof t.charsetSentinel == "boolean" ? t.charsetSentinel : nt.charsetSentinel,
    comma: typeof t.comma == "boolean" ? t.comma : nt.comma,
    decodeDotInKeys: typeof t.decodeDotInKeys == "boolean" ? t.decodeDotInKeys : nt.decodeDotInKeys,
    decoder: typeof t.decoder == "function" ? t.decoder : nt.decoder,
    delimiter: typeof t.delimiter == "string" || Qo.isRegExp(t.delimiter) ? t.delimiter : nt.delimiter,
    // eslint-disable-next-line no-implicit-coercion, no-extra-parens
    depth: typeof t.depth == "number" || t.depth === !1 ? +t.depth : nt.depth,
    duplicates: o,
    ignoreQueryPrefix: t.ignoreQueryPrefix === !0,
    interpretNumericEntities: typeof t.interpretNumericEntities == "boolean" ? t.interpretNumericEntities : nt.interpretNumericEntities,
    parameterLimit: typeof t.parameterLimit == "number" ? t.parameterLimit : nt.parameterLimit,
    parseArrays: t.parseArrays !== !1,
    plainObjects: typeof t.plainObjects == "boolean" ? t.plainObjects : nt.plainObjects,
    strictDepth: typeof t.strictDepth == "boolean" ? !!t.strictDepth : nt.strictDepth,
    strictNullHandling: typeof t.strictNullHandling == "boolean" ? t.strictNullHandling : nt.strictNullHandling,
    throwOnLimitExceeded: typeof t.throwOnLimitExceeded == "boolean" ? t.throwOnLimitExceeded : !1
  };
}, vO = function(e, t) {
  var n = mO(t);
  if (e === "" || e === null || typeof e > "u")
    return n.plainObjects ? { __proto__: null } : {};
  for (var o = typeof e == "string" ? pO(e, n) : e, s = n.plainObjects ? { __proto__: null } : {}, a = Object.keys(o), r = 0; r < a.length; ++r) {
    var i = a[r], l = fO(i, o[i], n, typeof e == "string");
    s = Qo.merge(s, l, n);
  }
  return n.allowSparse === !0 ? s : Qo.compact(s);
}, hO = iO, gO = vO, bO = Kp, yO = {
  formats: bO,
  parse: gO,
  stringify: hO
};
const Yp = /* @__PURE__ */ yP(yO);
var Qr = /* @__PURE__ */ ((e) => (e.priceasc = "priceasc", e.pricedesc = "pricedesc", e.nameasc = "nameasc", e.namedesc = "namedesc", e.starasc = "starasc", e.stardesc = "stardesc", e.recommended = "recommended", e.bestsavings = "bestsavings", e))(Qr || {}), wt = /* @__PURE__ */ ((e) => (e.full = "full", e.deposit = "deposit", e.uplift = "uplift", e))(wt || {}), ei = /* @__PURE__ */ ((e) => (e.pax = "PAX", e.insurance = "INSURANCE", e.checkout = "CHECKOUT", e))(ei || {}), qt = /* @__PURE__ */ ((e) => (e.B2C_GUEST = "B2C Guest", e.AEROPLAN_B2C = "Aeroplan B2C Signed In", e.B2B = "B2B", e.AFFILIATE = "Affiliate", e.FRIENDS_AND_FAMILY = "Friends&Family", e.EMPLOYEE = "Employee", e))(qt || {}), Gp = /* @__PURE__ */ ((e) => (e.AEROPLAN = "aeroplan", e.GUEST = "guest", e.FAF = "fandf", e.AGENT_B2B = "agent_b2b", e.ADMIN_B2B = "admin_b2b", e.AFFILIATE = "affiliate", e.EMPLOYEE = "employee_b2c", e.EMPLOYEE_B2E = "employee_b2e", e.EMPLOYEE_FAF = "employee_b2c_fandf", e))(Gp || {});
window.dataLayer = window.dataLayer || [];
const ku = "Vacation Package", Eb = "Flight&Hotel", $O = "Vacation Package+Flight&Hotel (Mixed)", Ob = "Hotel Only";
function xb(e) {
  return Cl(e) + " Search Results";
}
function Mb(e, t, n) {
  const o = _O(e, n), s = Kg(
    fr(),
    "dd/mm/yyyy",
    "yyyy-mm"
  ), a = wO(e), r = CO();
  return [
    Cl(e),
    o,
    t == null ? void 0 : t.name,
    s,
    `${a} Nights`,
    `${r} DBD`
  ].join(" | ");
}
function _O(e, t) {
  if (t) {
    const n = Zp(t), o = wl(t);
    return `${n} | ${o}`;
  }
  return e.information.destination ?? "N/A";
}
function Bi() {
  const e = new URLSearchParams(window.location.search), t = fr(), n = e.get("returnDateTime");
  if (typeof t == "string" && typeof n == "string") {
    const o = Mi(t, "ddMMyyyy"), s = Mi(n, "ddMMyyyy");
    if (o && s)
      return Li(o, s);
  }
  return -1;
}
function Lb() {
  const e = fr();
  return Us(e) ?? "";
}
function wO(e) {
  var o, s;
  const t = (o = e == null ? void 0 : e.information) == null ? void 0 : o.checkIn, n = (s = e == null ? void 0 : e.information) == null ? void 0 : s.checkOut;
  if (t && n) {
    const a = Mi(t, "yyyyMMdd"), r = Mi(n, "yyyyMMdd");
    if (a && r)
      return Li(r, a);
  }
  return 0;
}
function CO() {
  const e = fr();
  return qg(e);
}
function Zp(e = void 0) {
  return e ? kO(e) : TO();
}
function Nb(e, t) {
  return t ? wl(t) ?? "N/A" : e.information.destination ?? "N/A";
}
function wl(e = void 0) {
  return e ? SO(e) : AO();
}
function kO(e) {
  var t;
  return ((t = e == null ? void 0 : e.segments) == null ? void 0 : t.filter((n) => n.bound === "O")[0].origin) ?? "";
}
function SO(e) {
  var t;
  return (t = e == null ? void 0 : e.segments) == null ? void 0 : t.filter((n) => n.bound === "O").slice(-1)[0].destination;
}
function TO() {
  const e = new URLSearchParams(window.location.search), t = e.get("departureLocationPlaceId");
  return e.get("departureLocationSuggestionType") === "AIRPORTGROUP" && t ? t : "N/A";
}
function AO() {
  const e = new URLSearchParams(window.location.search), t = e.get("arrivalLocationPlaceId");
  if (e.get("arrivalLocationSuggestionType") === "AIRPORTGROUP" && t)
    return t;
}
function DO() {
  const e = new URLSearchParams(window.location.search);
  return e.get("arrivalLocationPlaceId") ?? e.get("arrivalLocation") ?? void 0;
}
function fr() {
  const e = new URLSearchParams(window.location.search);
  return e.get("departingDateTime") ?? e.get("checkInDate") ?? "";
}
function PO(e) {
  const t = [];
  return e.economyCabins && t.push("Economy"), e.premiumEconomyCabins && t.push("Premium Economy"), e.businessCabins && t.push("Business"), e.mixedCabins && t.push("Mixed Cabin"), t.join(",");
}
function Cl(e) {
  return e && "dynamicPackage" in e ? e.dynamicPackage ? Eb : ku : Ob;
}
function IO(e) {
  if (!e)
    return ku;
  if ((e == null ? void 0 : e.length) > 0 && !("dynamicPackage" in e[0]))
    return Ob;
  let t = !1, n = !1;
  return e.forEach((o) => {
    "dynamicPackage" in o && o.dynamicPackage ? t = !0 : n = !0;
  }), t && n ? $O : t && !n ? Eb : ku;
}
function ss(e, t, n, o, s) {
  var c, u, p;
  const a = new URLSearchParams(window.location.search), r = ((u = (c = o == null ? void 0 : o.segments) == null ? void 0 : c[0]) == null ? void 0 : u.origin) ?? "N/A", i = Nb(t, o), l = a.get("no_hotel") ? "Room" : "Hotel";
  return {
    item_name: (n == null ? void 0 : n.name) ?? "",
    item_id: Mb(t, n, o),
    price: (p = t.pricing) == null ? void 0 : p.total,
    item_brand: Sl(i),
    item_category: Cl(t),
    item_category2: r,
    item_category3: i,
    item_category4: Hb(s, l),
    item_category5: RO(t),
    item_variant: OO(n, o),
    item_list_name: xb(t),
    item_list_id: "",
    index: e + 1,
    quantity: 1
  };
}
function EO(e, t, n) {
  const o = Nb(e, t);
  return {
    item_name: (n == null ? void 0 : n.name) ?? "",
    item_id: Mb(e, n, t),
    price: e.pricing.total,
    item_brand: Sl(o),
    item_category: Cl(e),
    item_category2: Zp(t),
    item_category3: o ?? "N/A",
    item_category4: "N/A",
    item_category5: "N/A",
    item_variant: t ? Fb(t) : n.starCategory + "*",
    quantity: 1,
    item_list_name: xb(e),
    item_list_id: "",
    index: 1
  };
}
function OO(e, t) {
  return t ? Fb(t) : e.starCategory ? `${e.starCategory}*` : "";
}
function kl(e, t, n) {
  return {
    ...ss(0, e, n, t),
    item_list_id: "",
    quantity: 1
  };
}
const xO = /* @__PURE__ */ new Map([
  ["Y", "Economy"],
  ["O", "Premium Economy"],
  ["J", "Business"]
]);
function Fb(e) {
  var t;
  return [
    ...new Set(
      (t = e == null ? void 0 : e.segments) == null ? void 0 : t.map((n) => xO.get(n.cabinClass ?? ""))
    )
  ].join(";");
}
function MO(e, t) {
  return e ? t ? 2 : 1 : 0;
}
function Rb(e, t, n, o) {
  const s = [];
  if (n)
    s.push("Flex Pay");
  else {
    if (e)
      for (let a = 0; a < e; a++)
        s.push("Credit Card");
    t && s.push("Aeroplan Points"), o && s.push("Gift Card");
  }
  return s.join(", ");
}
const wo = /* @__PURE__ */ new Map();
wo.set("guest", qt.B2B);
wo.set("aeroplan", qt.AEROPLAN_B2C);
wo.set("affiliate", qt.AFFILIATE);
wo.set("b2b", qt.B2B);
wo.set("fandf", qt.FRIENDS_AND_FAMILY);
wo.set("employee", qt.EMPLOYEE);
function LO(e) {
  return e.affiliate_name;
}
async function Vb(e) {
  return window.sso ? window.sso.getUserAudience(await window.sso.getUserToken()) : wo.has(e.groups) ? wo.get(e.groups) : e.groups;
}
function Bb(e) {
  return e != null && e.groups && e.groups !== Gp.GUEST ? "Signed In" : "Not Signed In";
}
function NO(e) {
  return (e == null ? void 0 : e.groups) !== Gp.GUEST && (e == null ? void 0 : e.gid) !== "" ? e == null ? void 0 : e.gid : null;
}
function Hb(e, t) {
  if (!e)
    return "N/A";
  const { type: n, value: o = "", span: s = "" } = e, a = parseInt(o, 10), r = a > 1 ? "s" : "";
  switch (n) {
    case "ROOMS_LEFT":
      return `Only ${a} room${r} left`;
    case "LAST_BOOKING":
      return `${t} booked ${a} ${s.toLowerCase()}${r} ago`;
    case "TOTAL_BOOKINGS":
      return `${t} booked ${a} time${r} in the last ${parseInt(s)} hours`;
    default:
      return "N/A";
  }
}
function FO(e) {
  return e > 0 ? `+$${e}` : "$0";
}
function RO(e, t = 5) {
  var a, r;
  const { total: n, wasPrice: o } = ((r = (a = e == null ? void 0 : e.pricing) == null ? void 0 : a.perPaxType) == null ? void 0 : r[0]) ?? {}, s = KD(
    n,
    o
  );
  return s >= Number(t) ? `Save ${s}%` : "N/A";
}
function Sl(e) {
  var t;
  return e ? ((t = window == null ? void 0 : window.mappedBudgetProductLine) == null ? void 0 : t.get(e)) ?? "N/A" : "N/A";
}
async function VO(e, t, n, o, s, a) {
  const r = {
    event: "vpv",
    virtualPageUrl: o,
    virtualPageTitle: document == null ? void 0 : document.title,
    virtualPageReferrer: a ?? "",
    spaType: s,
    virtualLanguage: e,
    virtualAudience: await Vb(t),
    affiliateName: LO(t) ?? "",
    virtualSignInStatus: Bb(t),
    virtualPageType: n,
    virtualUserID: t.gid ?? null
  };
  window.dataLayer.push(r);
}
var lt = /* @__PURE__ */ ((e) => (e.PackagesSpa = "Package Booking Flow", e.HotelsSpa = "Hotels Booking Flow", e.PromotionsSpa = "Promo Module", e.GqtSpaB2C = "Group Quoting Tool (B2C)", e.GqtSpaB2B = "Group Quoting Tool (B2B)", e.StaticPage = "N/A", e))(lt || {});
function BO(e, t, n, o) {
  const { no_hotel: s } = n;
  if (!s)
    throw new Error("parameter no_hotel/hotel-id is not defined.");
  const a = `/packages-search/search/${s}?`, r = `/hotel-only/search/${s}?`, i = ti(t, void 0, void 0, o) ? "&" + ti(t, void 0, void 0, o) : "", l = lt.HotelsSpa ? `hotel-id=${s}` + i : ti(t), c = o === lt.HotelsSpa ? r : a;
  return Mt(e, c + (l ?? ""));
}
function HO(e, t, n, o) {
  const s = {
    offset: 0,
    lang: void 0
  };
  e = { ...s, ...e };
  const a = {
    ...e
  }, r = ti(
    t,
    s.offset,
    a,
    o
  ), c = (o === lt.HotelsSpa ? "/hotel-only/search?" : "/packages-search/search?") + r;
  return Mt(n, c);
}
function UO(e) {
  return Mt(e, "/hotel-only/quote");
}
function zO(e) {
  return Mt(e, "/packages-quote/v2/quotes");
}
function WO(e, t) {
  const { quoteId: n } = t, o = `/hotel-only/quote/${n}`;
  return Mt(e, o);
}
function jO(e, t) {
  const { quoteId: n } = t, o = `/packages-quote/v2/quotes/${n}`;
  return Mt(e, o);
}
function Mre(e, t) {
  const { quoteId: n, lang: o } = t, s = `/packages-quote/quotes/${n}?lang=${o}`;
  return Mt(e, s);
}
function qO(e, t) {
  const { booking_id: n, lang: o } = t, s = `/packages-booking/booking/${n}?lang=${o}`;
  return Mt(e, s);
}
function Lre(e, t) {
  const n = `/packages-quote/quotes/${t}/insurance`;
  return Mt(e, n);
}
function KO(e) {
  return Mt(e, "/passengers/passengers");
}
function YO(e, t) {
  const { id: n } = e, o = `/passengers/passengers/${n}`;
  return Mt(t, o);
}
function Nre(e) {
  return Mt(e, "/packages-booking/booking");
}
function GO(e, t) {
  const { id: n, lang: o } = t, s = `/hotel-only/booking/${n}?lang=${o}`;
  return Mt(e, s);
}
function ZO(e) {
  return Mt(e, "redeem/maximum-redeemable-points");
}
function Mt(e, t) {
  const n = new URL(e.origin.replace(/\/+$/, "") + "/"), o = t.replace(/^\/+/, "");
  return new URL(o, n);
}
function Ub(e, t = null) {
  const n = {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + e
    }
  };
  return {
    ...t ? { body: t } : null,
    ...n
  };
}
function ti(e, t = 1, n = {}, o) {
  const s = ex(
    window.location.search,
    {
      offset: t,
      limit: e,
      ...n
    },
    o
  );
  return Yp.stringify(s, {
    arrayFormat: "comma",
    skipNulls: !0
  });
}
function cm(e) {
  return /^\d+$/.test(e);
}
function XO(e) {
  if (!e)
    return;
  const t = {
    economy: "Y",
    premiumeconomy: "PE",
    business: "B"
  }, n = e.cabinClass;
  if (n in t)
    return t[n];
}
function um(e) {
  if (typeof (e == null ? void 0 : e.returnDateTime) == "string")
    return Us(e.returnDateTime);
  if (typeof e.checkOutDate == "string")
    return Us(e.checkOutDate);
}
function pm(e) {
  if (typeof (e == null ? void 0 : e.departingDateTime) == "string")
    return Us(e.departingDateTime);
  if (typeof e.checkInDate == "string")
    return Us(e.checkInDate);
}
function dm(e) {
  if (e && e.nb_child && cm(e.nb_child)) {
    const t = parseInt(e.nb_child), n = [];
    for (let o = 1; o <= t && ("non_adult" + o in e && cm(e["non_adult" + o])); o++) {
      const s = e["non_adult" + o];
      n.push(s);
    }
    return n;
  }
}
function fm(e) {
  if (e && typeof e.dest_dep == "string")
    return e.dest_dep.replace(/_/g, ",");
}
function Fre(e) {
  if (e && typeof e.arrivalLocationPlaceId == "string")
    return e.arrivalLocationPlaceId.replace(/_/g, ",");
}
function mm(e) {
  if (!e)
    return;
  const t = e.utm_source;
  if (typeof t == "string")
    return t;
}
const JO = /* @__PURE__ */ new Set([
  "priceasc",
  "pricedesc",
  "nameasc",
  "namedesc",
  "starasc",
  "stardesc"
]), QO = "priceasc", ex = (e, t, n) => {
  if (!e)
    return {};
  const o = Yp.parse(
    e.substring(e.indexOf("?") + 1)
  ), s = n == lt.HotelsSpa ? {
    dest: fm,
    adults: "nb_adult",
    // Use the value from nb_adult directly
    "child-ages": dm,
    lang: "language",
    // Use the value from language directly
    rooms: "numberOfRooms",
    // Use the value from numberOfRooms directly
    packageId: "packageId",
    // Use the value from package-id directly
    tempMagHotelId: "tempMagHotelId",
    //Temp solution to fetch specific hotel info from Magnolia
    "check-in-date": pm,
    "check-out-date": um,
    campaign: mm
  } : {
    orig: "departureLocation",
    // Use the value from departureLocation directly
    dest: fm,
    adults: "nb_adult",
    // Use the value from nb_adult directly
    "child-ages": dm,
    "dep-date": pm,
    "ret-date": um,
    cabin: XO,
    lang: "language",
    // Use the value from language directly
    rooms: "numberOfRooms",
    // Use the value from numberOfRooms directly
    hotels: "no_hotel",
    // Use the value from no_hotel directly
    packageId: "packageId",
    // Use the value from package-id directly
    tempMagHotelId: "tempMagHotelId",
    //Temp solution to fetch specific hotel info from Magnolia
    campaign: mm
  };
  let a = {};
  for (const [r, i] of Object.entries(s))
    if (typeof i == "string") {
      const l = i;
      l in o && (a[r] = o[l]);
    } else if (typeof i == "function") {
      const l = i;
      a[r] = l(o);
    }
  return o.sort && JO.has(o.sort) ? a.sort = o.sort : a.sort = QO, t && (a = {
    ...a,
    ...t
  }), a;
};
async function Jn(e, t = null, n = "POST", o = 0, s = 3, a = 6e4) {
  try {
    const r = await window.sso.getUserToken(), i = Ub(r, t), l = await _p(e.toString(), {
      ...i,
      method: n,
      timeout: a
    });
    if (l.ok) {
      const c = await l.json();
      if (("title" in c || "errorDetail" in c) && "status" in c && "detail" in c)
        throw Ci(c);
      return c;
    } else {
      if (l.status === 401 && o < s)
        return o++, await Jn(e, t, n, o);
      {
        const c = await l.json(), { status: u, detail: p } = c;
        if (Hp(u, p)) {
          const { setStatus: f } = ab();
          f(c);
        }
        throw Ci(c);
      }
    }
  } catch (r) {
    throw wp(r);
  }
}
const Rre = (e, t = {}, n = "") => {
  const o = {};
  t[n] && (o[n] = t[n]);
  for (const s of e)
    s !== n && t[s] && (o[s] = t[s]);
  return o;
}, Vre = (e, t) => {
  var o;
  const n = (o = e[t]) == null ? void 0 : o.segments;
  return n ? n.length > 2 ? "Layover Flight" : "Direct Flight" : null;
}, Bre = (e, t) => {
  var o, s;
  const n = /* @__PURE__ */ new Set();
  return (s = (o = e[t]) == null ? void 0 : o.segments) == null || s.forEach((a) => {
    a.cabinClassName && n.add(a.cabinClassName);
  }), Array.from(n).join(", ");
};
function Hre(e, t, n) {
  const o = /* @__PURE__ */ new Map([
    ["economy", t.economy],
    ["premiumeconomy", t.premiumEconomy],
    ["business", t.business],
    ["mixed", t.mixed]
  ]);
  return Array.from(th.entries()).filter(
    ([s]) => (e == null ? void 0 : e[s]) && s !== eh.get(n)
  ).map(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ([s, a]) => o.get(a)
  );
}
function Ure(e, t) {
  const n = e.insuranceCompany.products.find(
    (o) => o.productCode === t
  );
  return n || null;
}
function Ts(e) {
  if (e !== null)
    return parseInt(e);
}
function zre(e) {
  if (typeof e == "string" && (/^-?\d+$/.test(e) || /^-?\d*\.\d+$/.test(e)) && tx(e))
    return parseFloat(e);
}
function tx(e) {
  return typeof e == "string" && !isNaN(parseFloat(e)) && isFinite(parseFloat(e));
}
function nx(e) {
  return typeof e == "string" ? /^-?\d+$/.test(e) : !1;
}
function Wre(e) {
  const t = Me.now();
  return e.some((n) => {
    const o = Me.fromISO(n.dob);
    return t.diff(o, "years").years >= 19;
  });
}
function jre(e, t) {
  return e.length !== t.length ? !0 : e.some((n, o) => n.dob !== t[o]);
}
function qre(e) {
  return e.map((t) => (t == null ? void 0 : t.dob) ?? null);
}
function Kre(e) {
  return e.firstName !== e.originalFirstName || e.lastName !== e.originalLastName || e.middleName !== e.originalMiddleName || e.phoneNumber !== e.originalPhoneNumber || e.emailAddress != e.originalEmailAddress || e.title != e.originalTitle || e.dob != e.originalDob || e.aeroplanNum != e.originalAeroplanNum;
}
async function Yre(e, t, n, o) {
  return await Jn(
    KO(o),
    JSON.stringify(e),
    "POST",
    0,
    n,
    t
  );
}
async function Gre(e, t, n, o) {
  return await Jn(
    YO(e, o),
    JSON.stringify(e),
    "PUT",
    0,
    n,
    t
  );
}
const zb = (e) => e.paxType === "A";
function Zre(e) {
  var n;
  if (!e)
    return 0;
  const t = (n = e.perPaxType) == null ? void 0 : n.find(zb);
  return t ? t.total ?? 0 : 0;
}
function Xre(e) {
  return (e == null ? void 0 : e.perNightWithTax) ?? 0;
}
function Jre(e) {
  var n;
  if (!e)
    return 0;
  const t = (n = e.perPaxType) == null ? void 0 : n.find(zb);
  return t ? t.wasPrice ?? 0 : 0;
}
function Qre(e, t) {
  if (e !== 0 && t !== 0) {
    const n = t - e;
    return Math.floor(n / t * 100);
  } else
    return 0;
}
function eie(e) {
  const t = [], n = Ts(e.get("nb_child"));
  if (n != null && n > 0)
    for (let o = 0; o < n; o++) {
      const s = e.get("non_adult" + (o + 1)) ?? "";
      if (nx(s))
        parseInt(s) >= 2 && t.push(parseInt(s));
      else
        break;
    }
  return t;
}
function tie(e) {
  const t = Ts(e.get("nb_child")) ?? 0;
  let n = 0, o = 0;
  return Array.from({ length: t }, (a, r) => {
    const i = Number(e.get(`non_adult${r + 1}`)) || 0, l = i < 2;
    return {
      index: l ? ++n : ++o,
      age: i,
      type: l ? "infant" : "child"
    };
  }).sort((a, r) => {
    const i = { child: 0, infant: 1 };
    return i[a.type] - i[r.type];
  });
}
const Wb = ".yCmsContentSlot.plp-package-section";
function nie() {
  const e = jb(Wb);
  return e != null && (e.style.display = "none"), e;
}
function oie() {
  const e = jb(Wb);
  return e != null && (e.style.display = ""), e;
}
function jb(e) {
  return document.querySelector(e);
}
const sie = (e) => {
  const t = document.createElement("link");
  t.setAttribute("rel", "stylesheet"), t.setAttribute("href", `${e}/fonts/fonts.css`);
  const n = document.createElement("link");
  n.setAttribute("rel", "stylesheet"), n.setAttribute(
    "href",
    `${e}/fonts/fontawesome/css/all.min.css`
  );
  const o = document.getElementsByTagName("head")[0];
  o.appendChild(t), o.appendChild(n);
}, vm = (e, t) => {
  const n = ox(e);
  t.node.walk((o) => {
    n.includes(o.name) && o.value && o.value !== "" && sx(o);
  });
};
function ox(e) {
  const t = /* @__PURE__ */ new Set([
    "address",
    "apartment",
    "city",
    "country",
    "state",
    "postcode",
    "cc-expiry",
    "cc-name"
  ]), n = e.creditCardIframeName;
  return Array.from(t).map(
    (o) => `${n}-${o}`
  );
}
const sx = (e) => {
  e.store.set(
    ct({
      key: "submitted",
      value: !0,
      visible: !1
    })
  );
};
function aie(e, t) {
  var a, r, i, l, c, u, p, f, m, h, g, _, v, w, y, $, S, A, I;
  const n = (i = (r = (a = e.quote) == null ? void 0 : a.prePackage) == null ? void 0 : r.selectedOptionIds) == null ? void 0 : i.itineraryId, o = (c = (l = e.quote) == null ? void 0 : l.prePackage) == null ? void 0 : c.hotelId;
  t.itineraryID = n, t.hotelID = o, t.packageQuoteId = (u = e.quote) == null ? void 0 : u.id, t.prePackagePricing = (f = (p = e.quote) == null ? void 0 : p.prePackage) == null ? void 0 : f.pricing, n && (t.itinerary = (m = e == null ? void 0 : e.itineraries) == null ? void 0 : m[n]), o && (t.hotel = (h = e == null ? void 0 : e.hotels) == null ? void 0 : h[o]), t.prePackage = (g = e.quote) == null ? void 0 : g.prePackage, e.itineraries && (t.itineraries = e.itineraries), t.ancillaries = e.ancillaryOptions;
  const s = {
    id: "000",
    name: ((w = (v = Object.values(((_ = e.ancillaryOptions) == null ? void 0 : _.travelProtections) ?? {})[0]) == null ? void 0 : v.termsAndConditions) == null ? void 0 : w.name) ?? "Not informed",
    description: ((S = ($ = Object.values(((y = e.ancillaryOptions) == null ? void 0 : y.travelProtections) ?? {})[0]) == null ? void 0 : $.termsAndConditions) == null ? void 0 : S.description) ?? "Not informed"
  };
  t.ancillariesTermsAndCondition = s, t.depositTermsAndCondition = (A = e.termsAndConditions) == null ? void 0 : A.minimalDeposit, t.information = e.information, t.quoteID = (I = e.quote) == null ? void 0 : I.id;
}
function ax(e) {
  var t, n, o;
  if ((t = e == null ? void 0 : e.quote) != null && t.prePackage && (e != null && e.itineraries) && (e != null && e.hotels)) {
    const s = (n = e.quote.prePackage.selectedOptionIds) == null ? void 0 : n.itineraryId;
    if (s) {
      const a = e.itineraries[s], r = (o = e.itineraries[s]) == null ? void 0 : o.segments;
      return !!a && !!r;
    }
  }
  return !1;
}
function rx(e) {
  var s, a, r, i;
  const t = (s = e == null ? void 0 : e.quote) == null ? void 0 : s.id, n = (r = (a = e == null ? void 0 : e.quote) == null ? void 0 : a.hotel) == null ? void 0 : r.hotelId, o = !!(n && ((i = e == null ? void 0 : e.hotels) != null && i[n]));
  return !!(t && o);
}
function ix(e) {
  return e != null && e.trim() ? lx(e) % 10 == 0 : !1;
}
function lx(e) {
  let t = !1, n = 0;
  for (let o = e.length - 1; o >= 0; o--) {
    let s = Number(e[o]);
    t && (s *= 2, s > 9 && (s -= 9)), n += s, t = !t;
  }
  return n;
}
const cx = function(e) {
  return ix(String(e.value));
};
function rie({
  lang: e,
  amountToPay: t,
  depositAmount: n,
  insurancePremiumAmount: o
}) {
  function s(a) {
    const r = function(i) {
      const l = Un(e, i.value);
      return a(l);
    };
    return r.skipEmpty = !1, r;
  }
  return {
    isAmountGreaterThanZero: s((a) => a > 0),
    isAmountLessThanTotal: s(
      (a) => a < t
    ),
    isAmountLessThanOrEqualToTotal: s(
      (a) => a <= t
    ),
    isAmountLessThanOrEqualToTotalWithoutInsurancePremium: s(
      (a) => o > 0 && a <= t
    ),
    isAmountLessThanOrEqualToDepositWithoutInsurancePremium: s(
      (a) => o > 0 && !!n && n > 0 && a <= n - o
    ),
    isAmountLessThanDeposit: s(
      // GiftCard form checks that depositAmount.value is not null before calling this validator
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      (a) => n === 0 || a <= n
    ),
    isAmountNotEqualToDeposit: s(
      (a) => a !== n
    ),
    isAmountNotEqualToTotal: s(
      (a) => a !== t
    ),
    isAmountLessThanOrEqualToDeposit: s(
      // GiftCard form checks that depositAmount.value is not null before calling this validator
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      (a) => a <= n
    ),
    isGiftCardAmountSufficient: s(
      (a) => a >= t
    ),
    isGiftCardDepositSufficient: s(
      // GiftCard form checks that depositAmount.value is not null before calling this validator
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      (a) => a >= n
    )
  };
}
const ux = (e) => (dn("data-v-d05f8a65"), e = e(), fn(), e), px = { class: "checkout-form" }, dx = { class: "traveller-section step1" }, fx = { class: "traveller-item" }, mx = { class: "traveller-item-title" }, vx = { class: "note" }, hx = { class: "traveller-form-title vacv-form-row vacv-radio" }, gx = { class: "vacv-radio-group" }, bx = { class: "traveller-form-name vacv-form-row vacv-input" }, yx = { class: "vacv-form-item" }, $x = { class: "vacv-form-item" }, _x = { class: "vacv-form-item" }, wx = { class: "traveller-form-birthdate vacv-form-row vacv-input" }, Cx = ["id"], kx = /* @__PURE__ */ ux(() => /* @__PURE__ */ d("div", { class: "break" }, null, -1)), Sx = ["innerHTML"], Tx = {
  key: 0,
  class: "traveller-form-contact vacv-form-row vacv-input"
}, Ax = { class: "vacv-form-item tooltip-wrapper" }, Dx = { class: "vacv-form-item" }, Px = {
  key: 1,
  class: "traveller-form-aeroplan vacv-form-row vacv-input"
}, Ix = { class: "vacv-form-item" }, Ex = /* @__PURE__ */ K({
  __name: "TravellerForm",
  props: {
    index: {},
    type: {},
    age: {},
    travelDate: {},
    aeroplanDOB: {},
    userNameLocked: { type: Boolean },
    showAeroplan: { type: Boolean, default: !0 }
  },
  setup(e) {
    const t = e, n = Hg(CD, {
      props: ["dob"]
    }), o = R(""), s = /^(?![\s\S]*\s)(?!.*\.\.|[.-])[\w.-]+[\w]@[^.-][\w]+([.-]?[\w]+)*\.[A-Za-z]{2,}$/, a = R(!1), r = V(() => t.age !== void 0 ? t.age : 18), i = V(() => t.age !== void 0 ? t.age + 1 : 130), l = (P) => {
      var B, N;
      const E = P.value;
      if (a.value = !1, E && E.length === 10) {
        const Y = Me.fromFormat(E, "yyyy-MM-dd");
        if (t.type === "infant" && ((B = t.travelDate) != null && B.returnLastDate)) {
          const ee = Me.fromFormat(
            t.travelDate.returnLastDate,
            "yyyyMMdd"
          ).diff(Y, ["years"]).years;
          return ee >= 0 && ee <= 3;
        } else if ((N = t.travelDate) != null && N.departureFirstDate) {
          const j = Me.fromFormat(
            t.travelDate.departureFirstDate,
            "yyyyMMdd"
          ), ee = Y.plus({ years: r.value }), te = Y.plus({ years: i.value });
          return j >= ee && j < te;
        } else
          return !1;
      }
      return !1;
    }, c = (P) => {
      var B;
      const E = P.value;
      if ((B = t.travelDate) != null && B.returnLastDate && E && E.length === 10) {
        const N = E.replace(/-/g, ""), Y = Me.fromFormat(
          t.travelDate.returnLastDate,
          "yyyyMMdd"
        ), j = Me.fromFormat(N, "yyyyMMdd"), ee = Y.diff(j, ["years"]).years;
        return t.type === "infant" && ee >= 2 ? (a.value = !0, !1) : (a.value = !1, !0);
      }
      return a.value = !0, !1;
    }, { t: u } = Ne({ useScope: "global" }), p = V(() => "required|length:0," + da + `|matches:${tu.personName}`), f = V(() => "length:0," + da + `|matches:${tu.personName}`), m = t.type === "adult" && t.index === 1, h = V(() => ({
      required: u(m ? "vacvComponents.traveller.errors.noFirstNameEntered" : "vacvComponents.traveller.errors.noOtherTravellerFirstName"),
      length: u(
        t.userNameLocked ? "vacvComponents.traveller.errors.employeeNamePrefilled" : "vacvComponents.traveller.errors.firstNameTextLength"
      ),
      matches: u(
        t.userNameLocked ? "vacvComponents.traveller.errors.employeeNamePrefilled" : "vacvComponents.traveller.errors.nameWrongFormat"
      )
    })), g = V(() => ({
      length: u(
        t.userNameLocked ? "vacvComponents.traveller.errors.employeeNamePrefilled" : "vacvComponents.traveller.errors.firstNameTextLength"
      ),
      matches: u(
        t.userNameLocked ? "vacvComponents.traveller.errors.employeeNamePrefilled" : "vacvComponents.traveller.errors.nameWrongFormat"
      )
    })), _ = V(() => ({
      required: u(m ? "vacvComponents.traveller.errors.noLastNameEntered" : "vacvComponents.traveller.errors.noOtherTravellerLastName"),
      length: u(
        t.userNameLocked ? "vacvComponents.traveller.errors.employeeNamePrefilled" : "vacvComponents.traveller.errors.lastNameTextLength"
      ),
      matches: u(
        t.userNameLocked ? "vacvComponents.traveller.errors.employeeNamePrefilled" : "vacvComponents.traveller.errors.nameWrongFormat"
      )
    })), v = {
      required: u(m ? "vacvComponents.traveller.errors.noDOBEntered" : "vacvComponents.traveller.errors.noOtherTravellerDateOfBirth"),
      date_format: u("vacvComponents.traveller.errors.invalidDOB"),
      length: u("vacvComponents.traveller.errors.invalidDOB"),
      right_age: t.type === "adult" ? u("vacvComponents.traveller.errors.invalidDOB") : u("vacvComponents.traveller.errors.invalidChildDOB"),
      age_on_return: u("vacvComponents.traveller.errors.invalidInfantReturnDOB")
    }, w = {
      required: u(m ? "vacvComponents.traveller.errors.noTitleSelected" : "vacvComponents.traveller.errors.noOtherTravellerTitleField")
    }, y = {
      required: u("vacvComponents.traveller.errors.noPhoneNumberEntered"),
      matches: u("vacvComponents.traveller.errors.phoneNumberWrongFormat"),
      length: u("vacvComponents.traveller.errors.phoneNumberTextLength")
    }, $ = {
      required: u("vacvComponents.traveller.errors.noEmailEntered"),
      length: u("vacvComponents.traveller.errors.emailTextLength"),
      matches: u("vacvComponents.traveller.errors.emailWrongFormat")
    }, S = {
      matches: u("vacvComponents.traveller.errors.aeroplanNumberWrongFormat"),
      length: u("vacvComponents.traveller.errors.aeroplanInvalidNumber"),
      isLuhnValidRule: u("vacvComponents.traveller.errors.aeroplanInvalidNumber")
    }, A = V(() => u(Mh(O))), I = R(), D = R(!1);
    let O = null;
    ko(async () => {
      O = await window.sso.getUserToken();
    }), le(
      () => t.userNameLocked,
      (P) => {
        var E, B;
        if (P) {
          const N = I.value;
          if ((B = (E = N == null ? void 0 : N.node) == null ? void 0 : E.children) != null && B.length) {
            const Y = /* @__PURE__ */ new Set([
              "firstname-adult-1",
              "middlename-adult-1",
              "lastname-adult-1"
            ]);
            N.node.walk((j) => {
              Y.has(j.name) && j.store.set(
                ct({
                  key: "submitted",
                  value: !0,
                  visible: !1
                })
              ), j.name === "middlename-adult-1" && j.value && (D.value = !0);
            });
          }
        }
      }
    );
    const x = (P) => {
      P.preventDefault();
    }, F = V(() => {
      const { type: P, index: E, age: B } = t, N = E === 1 ? "er" : "e";
      if (P === "adult") {
        let Y = u("vacvComponents.traveller.labels.adult", { index: E, pos: N });
        return m && (Y += ` ${u("vacvComponents.traveller.messages.mainTraveller")}`), Y;
      }
      return P === "child" ? u("vacvComponents.traveller.labels.child", { index: E, age: B, pos: N }) : P === "infant" ? u("vacvComponents.traveller.labels.infant", { index: E, age: B, pos: N }) : "";
    });
    return (P, E) => {
      const B = ut("FormKit");
      return b(), ie(B, {
        delay: 0,
        type: "group",
        name: `passenger-${P.type}-${P.index}`,
        ref_key: "formRef",
        ref: I
      }, {
        default: he(() => [
          d("div", px, [
            d("section", dx, [
              d("div", fx, [
                d("div", mx, [
                  d("h2", null, k(F.value), 1),
                  d("div", vx, k(T(u)("vacvComponents.traveller.messages.travellerName")), 1)
                ]),
                d("div", hx, [
                  d("div", gx, [
                    q(B, {
                      delay: 0,
                      type: "radio",
                      name: `title-${P.type}-${P.index}`,
                      id: `title-${P.type}-${P.index}`,
                      label: T(u)("vacvComponents.traveller.labels.travellerTitleField") + "*",
                      options: [
                        T(u)("vacvComponents.traveller.labels.travellerTitleMr"),
                        T(u)("vacvComponents.traveller.labels.travellerTitleMrs"),
                        T(u)("vacvComponents.traveller.labels.travellerTitleMs")
                      ],
                      validation: "required",
                      "validation-messages": w,
                      onInput: E[0] || (E[0] = (N) => P.$emit("trackPaxFormInput", N, P.index, P.type, "Title"))
                    }, null, 8, ["name", "id", "label", "options"])
                  ])
                ]),
                d("div", bx, [
                  d("div", yx, [
                    q(B, {
                      type: "text",
                      disabled: P.userNameLocked,
                      name: `firstname-${P.type}-${P.index}`,
                      id: `firstname-${P.type}-${P.index}`,
                      label: T(u)("vacvComponents.traveller.labels.travellerFirstName") + "*",
                      validation: p.value,
                      "validation-messages": h.value,
                      maxlength: T(da),
                      onInput: E[1] || (E[1] = (N) => P.$emit("trackPaxFormInput", N, P.index, P.type, "First Name"))
                    }, null, 8, ["disabled", "name", "id", "label", "validation", "validation-messages", "maxlength"])
                  ]),
                  d("div", $x, [
                    q(B, {
                      type: "text",
                      disabled: D.value,
                      name: `middlename-${P.type}-${P.index}`,
                      id: `middlename-${P.type}-${P.index}`,
                      label: T(u)("vacvComponents.traveller.labels.travellerMiddleName"),
                      validation: f.value,
                      "validation-messages": g.value,
                      maxlength: T(da),
                      onInput: E[2] || (E[2] = (N) => P.$emit("trackPaxFormInput", N, P.index, P.type, "Middle Name"))
                    }, null, 8, ["disabled", "name", "id", "label", "validation", "validation-messages", "maxlength"])
                  ]),
                  d("div", _x, [
                    q(B, {
                      type: "text",
                      disabled: P.userNameLocked,
                      name: `lastname-${P.type}-${P.index}`,
                      id: `lastname-${P.type}-${P.index}`,
                      label: T(u)("vacvComponents.traveller.labels.travellerLastName") + "*",
                      validation: p.value,
                      "validation-messages": _.value,
                      maxlength: T(da),
                      onInput: E[3] || (E[3] = (N) => P.$emit("trackPaxFormInput", N, P.index, P.type, "Last Name"))
                    }, null, 8, ["disabled", "name", "id", "label", "validation", "validation-messages", "maxlength"])
                  ])
                ]),
                d("div", wx, [
                  d("legend", null, k(`${T(u)("vacvComponents.traveller.labels.dateOfBirth")}*`), 1),
                  q(B, {
                    name: "dateOfBirth",
                    type: "group"
                  }, {
                    default: he(() => [
                      d("div", {
                        class: "vacv-form-item narrow3 birthdate",
                        id: `traveller-${P.type}-${P.index}-dob`
                      }, [
                        q(B, {
                          type: T(n),
                          dob: P.aeroplanDOB,
                          classes: {
                            inner: "flex"
                          },
                          modelValue: o.value,
                          "onUpdate:modelValue": E[4] || (E[4] = (N) => o.value = N),
                          index: P.index,
                          name: `dob-${P.type}-${P.index}`,
                          id: `dob-${P.type}-${P.index}`,
                          validation: [
                            ["length", 8],
                            ["required"],
                            ["date_format", "YYYY-MM-DD"],
                            ["right_age"],
                            ["age_on_return"]
                          ],
                          "validation-visibility": "blur",
                          "validation-rules": {
                            right_age: l,
                            age_on_return: c
                          },
                          "validation-messages": v,
                          onInput: E[5] || (E[5] = (N) => P.$emit(
                            "trackPaxFormInput",
                            N,
                            P.index,
                            P.type,
                            "Date of Birth - Date > Month > Year"
                          ))
                        }, null, 8, ["type", "dob", "modelValue", "index", "name", "id", "validation-rules"])
                      ], 8, Cx),
                      kx,
                      a.value ? (b(), C("div", {
                        key: 0,
                        class: "vacv-form-item return-age-error-details",
                        innerHTML: T(u)(
                          "vacvComponents.traveller.errors.invalidInfantReturnDOBDetails",
                          { num: A.value }
                        )
                      }, null, 8, Sx)) : M("", !0)
                    ]),
                    _: 1
                  })
                ]),
                P.type === "adult" && P.index === 1 ? (b(), C("div", Tx, [
                  d("div", Ax, [
                    q(B, {
                      type: "email",
                      name: "main-email",
                      id: "main-email",
                      inputmode: "email",
                      label: T(u)("vacvComponents.traveller.labels.travellerEmail") + "*",
                      validation: [
                        ["required"],
                        ["length", 0, 50],
                        ["matches", s]
                      ],
                      "validation-messages": $,
                      onInput: E[6] || (E[6] = (N) => P.$emit("trackPaxFormInput", N, P.index, P.type, "Email ")),
                      onBlur: E[7] || (E[7] = (N) => N.target.value = N.target.value.trim())
                    }, null, 8, ["label", "validation"])
                  ]),
                  d("div", Dx, [
                    q(B, {
                      type: "mask",
                      mode: "replace",
                      mask: "(###) ###-####",
                      name: "main-tel",
                      id: "main-tel",
                      "unmask-value": "true",
                      "show-mask": !0,
                      label: T(u)("vacvComponents.traveller.labels.travellerPhoneNumber") + "*",
                      validation: [
                        ["required"],
                        ["matches", /^[\d\s+,\(\)-]+$/],
                        ["length", 0, T(X$)]
                      ],
                      "validation-messages": y,
                      autocomplete: "tel-national",
                      onInput: E[8] || (E[8] = (N) => P.$emit(
                        "trackPaxFormInput",
                        N,
                        P.index,
                        P.type,
                        "Phone Number"
                      )),
                      onPaste: x
                    }, null, 8, ["label", "validation"])
                  ])
                ])) : M("", !0),
                P.showAeroplan ? (b(), C("div", Px, [
                  d("div", Ix, [
                    q(B, {
                      type: "number",
                      name: `aeroplan-${P.type}-${P.index}`,
                      id: `aeroplan-${P.type}-${P.index}`,
                      label: T(u)("vacvComponents.traveller.labels.travellerAeroplanNumber"),
                      validation: "matches:/^[0-9]*$/|length:9,9|isLuhnValidRule",
                      "validation-visibility": "blur",
                      "validation-rules": { isLuhnValidRule: T(cx) },
                      "validation-messages": S,
                      onInput: E[9] || (E[9] = (N) => P.$emit(
                        "trackPaxFormInput",
                        N,
                        P.index,
                        P.type,
                        "Aeroplan Number"
                      ))
                    }, null, 8, ["name", "id", "label", "validation-rules"])
                  ])
                ])) : M("", !0)
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["name"]);
    };
  }
}), iie = /* @__PURE__ */ De(Ex, [["__scopeId", "data-v-d05f8a65"]]), Ox = { class: "navback-navbar" }, xx = { class: "navback-wrapper" }, Mx = {
  href: "http://vacations.aircanada.com",
  class: "navback-link link"
}, Lx = /* @__PURE__ */ d("i", {
  class: "fa-solid fa-chevron-left",
  "aria-hidden": "true"
}, null, -1), Nx = ["aria-expanded"], Fx = /* @__PURE__ */ d("i", {
  class: "fa-solid fa-chevron-down",
  "aria-hidden": "true"
}, null, -1), Rx = {
  key: 0,
  class: "progressbar-wrapper",
  id: "progressBar"
}, Vx = { class: "progressbar" }, Bx = /* @__PURE__ */ d("div", { class: "progressline-wrapper" }, [
  /* @__PURE__ */ d("div", { class: "progressline" }),
  /* @__PURE__ */ d("div", { class: "marker" }, [
    /* @__PURE__ */ d("i", {
      class: "fa-solid fa-check",
      "aria-hidden": "true"
    })
  ])
], -1), Hx = { class: "link-wrapper" }, lie = /* @__PURE__ */ K({
  __name: "ProgressBar",
  props: {
    currentStep: {},
    spaType: {}
  },
  setup(e, { expose: t }) {
    const n = e, { t: o } = Ne({ useScope: "global" }), { width: s } = cp(), a = R(), r = R(!1), i = n.spaType && n.spaType === lt.HotelsSpa ? tt({
      1: "hotel",
      2: "room",
      3: "payment"
    }) : tt({
      1: "hotel",
      2: "room",
      3: "flight",
      4: "extras",
      5: "payment"
    });
    le(r, () => {
      r.value ? a.value = Eh(
        ["mobile-menu-opener", "progressbar-wrapper"],
        c
      ) : Oh(a.value);
    });
    const l = V(() => r.value || s.value >= di.tablet), c = () => (r.value = !r.value, r.value), u = (m) => m === void 0 ? "" : o("vacvComponents.progressbar.labels." + m), p = (m, h) => m === h, f = (m, h) => m === 1 ? !0 : m < h;
    return t({
      width: s,
      isProgressBarVisible: r,
      labelsForSteps: u,
      Steps: i
    }), (m, h) => (b(), C("div", Ox, [
      d("div", xx, [
        d("a", Mx, [
          Lx,
          ne(k(m.$t("vacvComponents.progressbar.labels.navback")), 1)
        ])
      ]),
      d("div", {
        class: ue(l.value ? "navbar-wrapper open" : "navbar-wrapper")
      }, [
        d("button", {
          class: "mobile-menu-opener",
          onClick: c,
          "aria-expanded": l.value,
          "aria-controls": "progressBar"
        }, [
          ne(k(m.$t("vacvComponents.progressbar.labels.stepofsteps", {
            step: m.currentStep,
            steps: Object.keys(T(i)).length
          })) + k(u(T(i)[m.currentStep])), 1),
          Fx
        ], 8, Nx),
        l.value ? (b(), C("nav", Rx, [
          d("ul", Vx, [
            (b(!0), C($e, null, ke(T(i), (g, _) => (b(), C("li", {
              key: g + _,
              class: ue([
                g,
                { active: p(parseInt(_), m.currentStep) },
                {
                  visited: f(parseInt(_), m.currentStep)
                }
              ])
            }, [
              Bx,
              d("div", Hx, k(_) + ". " + k(u(g)), 1)
            ], 2))), 128))
          ])
        ])) : M("", !0)
      ], 2)
    ]));
  }
}), Ux = {
  key: 0,
  class: "message-box"
}, zx = ["innerHTML"], Wx = ["innerHTML"], cie = /* @__PURE__ */ K({
  __name: "MessageBox",
  props: {
    title: {},
    message: {}
  },
  setup(e) {
    return (t, n) => t.message ? (b(), C("div", Ux, [
      t.title ? (b(), C("div", {
        key: 0,
        class: "title h3style",
        innerHTML: t.title
      }, null, 8, zx)) : M("", !0),
      d("div", {
        class: "message vacv-editor special-list",
        innerHTML: t.message
      }, null, 8, Wx)
    ])) : M("", !0);
  }
}), jx = { class: "confirmation-modal" }, qx = ["innerHTML"], Kx = ["innerHTML"], Yx = { class: "modal-cta-container" }, Gx = /* @__PURE__ */ K({
  __name: "ConfirmationModalDialog",
  props: {
    title: {},
    message: {},
    primaryCta: {},
    secondaryCta: {}
  },
  emits: ["confirm", "cancel"],
  setup(e, { emit: t }) {
    const n = t, o = () => {
      n("confirm");
    }, s = () => {
      n("cancel");
    };
    return (a, r) => (b(), C("div", jx, [
      a.title ? (b(), C("h2", {
        key: 0,
        class: "modal-title",
        innerHTML: a.title
      }, null, 8, qx)) : M("", !0),
      d("div", {
        class: "modal-content",
        innerHTML: a.message
      }, null, 8, Kx),
      d("div", Yx, [
        a.primaryCta ? (b(), C("button", {
          key: 0,
          type: "submit",
          onClick: o,
          class: "vacv-btn-primary confirm"
        }, k(a.primaryCta), 1)) : M("", !0),
        a.secondaryCta ? (b(), C("button", {
          key: 1,
          type: "button",
          onClick: s,
          class: "vacv-btn-secondary cancel"
        }, k(a.secondaryCta), 1)) : M("", !0)
      ])
    ]));
  }
}), uie = /* @__PURE__ */ K({
  __name: "ConfirmationModal",
  props: {
    show: { type: Boolean },
    hideClose: { type: Boolean },
    size: {},
    title: {},
    message: {},
    primaryCta: {},
    secondaryCta: {}
  },
  emits: ["close", "cancel", "confirm"],
  setup(e, { emit: t }) {
    const n = e, o = R(n.show);
    le(
      () => n.show,
      () => {
        o.value = n.show;
      }
    );
    const s = t, a = () => {
      o.value = !1, s("close");
    }, r = () => {
      o.value = !1, s("cancel");
    }, i = () => {
      o.value = !1, s("confirm");
    };
    return (l, c) => (b(), ie(Qt, {
      onClose: a,
      modelValue: o.value,
      "onUpdate:modelValue": c[0] || (c[0] = (u) => o.value = u),
      class: "vacv-modal modal-fullscreen vacv-modal-centered confirmation-modal",
      "click-to-close": !1,
      "hide-close": l.hideClose,
      size: l.size,
      "aria-label": l.$t("vacvComponents.dialogs.confirmation.modal-label-accessibility")
    }, {
      default: he(() => [
        q(Gx, {
          title: l.title,
          message: l.message,
          primaryCta: l.primaryCta,
          secondaryCta: l.secondaryCta,
          onConfirm: i,
          onCancel: r
        }, null, 8, ["title", "message", "primaryCta", "secondaryCta"])
      ]),
      _: 1
    }, 8, ["modelValue", "hide-close", "size", "aria-label"]));
  }
}), Zx = ["innerHTML"], Xx = { class: "vacv-radio-group" }, Jx = { for: "cubaPopupYes" }, Qx = { for: "cubaPopupNo" }, eM = ["innerHTML"], tM = { class: "align-center" }, nM = ["disabled"], oM = {
  key: 1,
  class: "change-destination align-center padding-top"
}, sM = /* @__PURE__ */ d("i", { class: "fa-solid fa-pen-circle" }, null, -1), aM = /* @__PURE__ */ K({
  __name: "VacvCubaPopupDialog",
  emits: ["continue", "cancel"],
  setup(e, { emit: t }) {
    const n = t, o = () => {
      n("continue");
    }, s = () => {
      n("cancel");
    }, a = R("no");
    return (r, i) => (b(), C("form", {
      onSubmit: Ke(o, ["prevent"]),
      class: "cubaPopup"
    }, [
      d("h2", null, k(r.$t("vacvComponents.dialogs.cubaPopup.title")), 1),
      d("div", {
        class: "cuba-question",
        innerHTML: r.$t("vacvComponents.dialogs.cubaPopup.question")
      }, null, 8, Zx),
      d("ul", Xx, [
        d("li", null, [
          ot(d("input", {
            "onUpdate:modelValue": i[0] || (i[0] = (l) => a.value = l),
            class: "formkit-input vacv-custom",
            id: "cubaPopupYes",
            type: "radio",
            name: "yesno",
            value: "yes"
          }, null, 512), [
            [Cs, a.value]
          ]),
          d("label", Jx, k(r.$t("vacvComponents.dialogs.cubaPopup.yes")), 1)
        ]),
        d("li", null, [
          ot(d("input", {
            "onUpdate:modelValue": i[1] || (i[1] = (l) => a.value = l),
            id: "cubaPopupNo",
            class: "formkit-input vacv-custom",
            type: "radio",
            name: "yesno",
            value: "no",
            selected: ""
          }, null, 512), [
            [Cs, a.value]
          ]),
          d("label", Qx, k(r.$t("vacvComponents.dialogs.cubaPopup.no")), 1)
        ])
      ]),
      a.value === "yes" ? (b(), C("div", {
        key: 0,
        class: "dialog-scrolling-content",
        innerHTML: r.$t("vacvComponents.dialogs.cubaPopup.yesSelected")
      }, null, 8, eM)) : M("", !0),
      d("div", tM, [
        d("button", {
          type: "submit",
          class: "vacv-btn-primary continue",
          disabled: a.value !== "yes" && a.value !== "no"
        }, k(r.$t("vacvComponents.dialogs.cubaPopup.continue")), 9, nM)
      ]),
      a.value === "yes" ? (b(), C("div", oM, [
        d("a", {
          href: "/",
          onClick: Ke(s, ["prevent"])
        }, [
          sM,
          ne(k(r.$t("vacvComponents.dialogs.cubaPopup.changeDestination")), 1)
        ])
      ])) : M("", !0)
    ], 32));
  }
}), pie = /* @__PURE__ */ K({
  __name: "VacvCubaPopup",
  props: {
    show: { type: Boolean }
  },
  emits: ["cancel", "continue"],
  setup(e, { emit: t }) {
    const n = e, o = R(n.show);
    le(
      () => n.show,
      () => {
        o.value = n.show;
      }
    );
    const s = t, a = () => {
      o.value = !1, s("cancel");
    }, r = () => {
      o.value = !1, s("continue");
    };
    return Xu(a), (i, l) => (b(), ie(Qt, {
      onClose: a,
      modelValue: o.value,
      "onUpdate:modelValue": l[0] || (l[0] = (c) => o.value = c),
      class: "vacv-modal modal-fullscreen vacv-modal-centered cuba-popup-modal",
      "click-to-close": !1
    }, {
      default: he(() => [
        q(aM, {
          onContinue: r,
          onCancel: a
        })
      ]),
      _: 1
    }, 8, ["modelValue"]));
  }
}), rM = {
  id: "ae-signin-form",
  class: "ae-signin-container"
}, iM = {
  key: 0,
  class: "ae-signin-logo"
}, lM = ["src", "alt"], cM = { class: "text" }, uM = { class: "ae-btn-wrapper" }, pM = ["href"], dM = /* @__PURE__ */ K({
  __name: "VacvAeSignIn",
  props: {
    aeroplanSignInUrl: {},
    aeroplanLogoUrl: { default: "/img/aeroplan-logo.png" }
  },
  emits: ["continue-as-guest", "sign-in"],
  setup(e, { emit: t }) {
    const n = t, o = () => {
      n("sign-in");
    }, s = () => {
      n("continue-as-guest");
    };
    return (a, r) => (b(), C("div", rM, [
      a.aeroplanLogoUrl ? (b(), C("div", iM, [
        d("img", {
          src: a.aeroplanLogoUrl,
          alt: a.$t("vacvComponents.aeroplan.aeroplan")
        }, null, 8, lM)
      ])) : M("", !0),
      d("div", cM, k(a.$t("vacvComponents.aeroplan.earn-or-book-and-save")), 1),
      d("div", uM, [
        d("a", {
          class: "ae-link vacv-btn-primary",
          href: a.aeroplanSignInUrl,
          rel: "noreferrer noopener",
          onClick: r[0] || (r[0] = (i) => o())
        }, k(a.$t("vacvComponents.aeroplan.signin-btn")), 9, pM),
        q(ul, {
          secondary: !0,
          label: a.$t("vacvComponents.aeroplan.cont-as-guest-btn"),
          onClick: r[1] || (r[1] = (i) => s())
        }, null, 8, ["label"])
      ])
    ]));
  }
}), fM = /* @__PURE__ */ K({
  __name: "VacvAeSignInModal",
  props: {
    aeroplanSignInUrl: {},
    aeroplanLogoUrl: {}
  },
  emits: ["continue-as-guest", "sign-in", "close"],
  setup(e, { emit: t }) {
    const n = R(!0), o = t, s = () => {
      n.value = !1, o("continue-as-guest");
    }, a = () => {
      o("sign-in");
    }, r = () => {
      n.value = !1, o("close");
    };
    return (i, l) => (b(), ie(Qt, {
      modelValue: n.value,
      "onUpdate:modelValue": l[2] || (l[2] = (c) => n.value = c),
      onClose: l[3] || (l[3] = (c) => r()),
      class: "vacv-modal modal-fullscreen vacv-modal-centered"
    }, {
      default: he(() => [
        q(dM, {
          "aeroplan-sign-in-url": i.aeroplanSignInUrl,
          "aeroplan-logo-url": i.aeroplanLogoUrl,
          onContinueAsGuest: l[0] || (l[0] = (c) => s()),
          onSignIn: l[1] || (l[1] = (c) => a())
        }, null, 8, ["aeroplan-sign-in-url", "aeroplan-logo-url"])
      ]),
      _: 1
    }, 8, ["modelValue"]));
  }
}), die = /* @__PURE__ */ K({
  __name: "VacvFormkitWrapper",
  props: {
    modelValue: {},
    name: {},
    componentClasses: {}
  },
  setup(e) {
    const t = Xv();
    return (n, o) => (b(), ie(T(Np), Ta({
      type: "custom",
      name: n.name,
      "model-value": n.modelValue
    }, T(t)), {
      default: he(() => [
        Xe(n.$slots, "default")
      ]),
      _: 3
    }, 16, ["name", "model-value"]));
  }
}), mM = {}, vM = (e) => (dn("data-v-2026153c"), e = e(), fn(), e), hM = { class: "rotate-screen-icon" }, gM = /* @__PURE__ */ vM(() => /* @__PURE__ */ d("i", { class: "fa-kit fa-screen-rotate-acv" }, null, -1)), bM = [
  gM
];
function yM(e, t) {
  return b(), C("div", hM, bM);
}
const $M = /* @__PURE__ */ De(mM, [["render", yM], ["__scopeId", "data-v-2026153c"]]), _M = /* @__PURE__ */ K({
  __name: "ImageCarouselTransition",
  props: {
    direction: {}
  },
  setup(e) {
    return (t, n) => (b(), C($e, null, [
      q(st, { name: "overlay" }, {
        default: he(() => [
          Xe(t.$slots, "fallback")
        ]),
        _: 3
      }),
      q(st, { name: t.direction }, {
        default: he(() => [
          Xe(t.$slots, "image")
        ]),
        _: 3
      }, 8, ["name"])
    ], 64));
  }
}), wM = (e, t) => {
  const n = R(null);
  return I_(e, {
    passive: !0,
    onSwipeEnd(o, s) {
      switch (s) {
        case "left":
        case "right":
          n.value = s, t[s]();
          break;
        default:
          n.value = s;
      }
    }
  }), {
    swipeDirection: n
  };
}, CM = ["aria-label"], kM = /* @__PURE__ */ d("span", { class: "btn-prev fa-chevron-left" }, null, -1), SM = [
  kM
], TM = ["src", "alt"], AM = ["aria-label"], DM = /* @__PURE__ */ d("span", { class: "btn-next fa-chevron-right" }, null, -1), PM = [
  DM
], IM = { class: "vacv-carousel-caption" }, EM = { class: "caption-full" }, OM = { key: 0 }, xM = 1, hm = /* @__PURE__ */ K({
  __name: "ImageCarouselSlide",
  props: {
    indexPosition: {},
    imagesCount: {},
    imageUrl: {},
    direction: {},
    overlay: { type: Boolean },
    altText: {},
    description: {},
    mode: {}
  },
  emits: ["prev", "next", "on-select-image", "on-loaded"],
  setup(e, { emit: t }) {
    const n = e, o = t, s = R(null);
    wM(s, {
      left: () => o("next"),
      right: () => o("prev")
    });
    const a = Ye("defaultImage"), r = (u) => {
      const p = u.target;
      let f = parseInt(p.getAttribute("data-retry-count") || "0");
      if (f >= xM) {
        p.src = "", p.alt = "Image failed to load";
        return;
      }
      f += 1, p.setAttribute("data-retry-count", f.toString()), p.src = a ?? "";
    }, i = V(() => n.mode === "cinema" ? !1 : n.overlay), l = V(() => n.imageUrl ? n.overlay : !1), c = V(() => n.imageUrl ?? a);
    return (u, p) => (b(), C($e, null, [
      d("div", {
        class: "vacv-carousel__slide",
        ref_key: "swipeHandler",
        ref: s
      }, [
        u.imagesCount > 1 ? (b(), C("button", {
          key: 0,
          onClick: p[0] || (p[0] = Ke((f) => u.$emit("prev"), ["stop"])),
          class: "left vacv-carousel-control",
          "aria-label": u.$t("vacvComponents.carousel.aria-previous")
        }, SM, 8, CM)) : M("", !0),
        q(_M, { direction: u.direction }, {
          fallback: he(() => [
            ot(d("span", {
              class: ue(["vacv-carousel__overlay", { "vacv-carousel__overlay--cinema": u.mode === "cinema" }])
            }, null, 2), [
              [Ds, l.value]
            ])
          ]),
          image: he(() => [
            (b(), C("img", {
              ref: "smallImage",
              class: ue(["vacv-carousel__img", { "vacv-carousel__img--cinema": u.mode === "cinema" }]),
              src: i.value ? "" : c.value,
              alt: u.altText,
              tabindex: "0",
              onLoad: p[1] || (p[1] = (f) => u.$emit("on-loaded", u.imageUrl)),
              onClick: p[2] || (p[2] = (f) => u.$emit("on-select-image")),
              onKeyup: p[3] || (p[3] = rl((f) => u.$emit("on-select-image"), ["enter"])),
              onError: r,
              key: u.imageUrl,
              role: "button"
            }, null, 42, TM))
          ]),
          _: 1
        }, 8, ["direction"]),
        u.imagesCount > 1 ? (b(), C("button", {
          key: 1,
          onClick: p[4] || (p[4] = Ke((f) => u.$emit("next"), ["stop"])),
          class: "right vacv-carousel-control",
          "aria-label": u.$t("vacvComponents.carousel.aria-next")
        }, PM, 8, AM)) : M("", !0)
      ], 512),
      d("div", IM, [
        d("span", EM, [
          ne(k(u.indexPosition + 1) + " " + k(u.$t("vacvComponents.carousel.slidenum")) + " " + k(u.imagesCount) + " ", 1),
          u.description ? (b(), C("span", OM, " - ")) : M("", !0),
          ne(" " + k(u.description), 1)
        ])
      ])
    ], 64));
  }
}), MM = {
  class: "vacv-carousel vacv-carousel-thumbs",
  id: "carousel-thumbs"
}, LM = ["aria-label"], NM = /* @__PURE__ */ d("span", { class: "btn-prev fa-chevron-left" }, null, -1), FM = [
  NM
], RM = { class: "vacv-carousel-inner" }, VM = ["data-index"], BM = { class: "thumb" }, HM = ["onClick"], UM = ["src", "alt"], zM = ["aria-label"], WM = /* @__PURE__ */ d("span", { class: "btn-next fa-chevron-right" }, null, -1), jM = [
  WM
], Dt = 6, qM = /* @__PURE__ */ K({
  __name: "ImageCarouselThumbs",
  props: {
    position: {},
    images: {},
    direction: {},
    availableVariations: {}
  },
  emits: ["select"],
  setup(e, { emit: t }) {
    const n = e, o = t, s = Ye("defaultImage"), a = (h) => {
      h.target.src = s ?? "";
    }, r = (h) => {
      const g = n.images[h];
      return $i(
        g.small,
        "cinema",
        n.availableVariations
      );
    }, i = n.images.map((h, g) => ({
      ...h,
      thumbnail: r(g)
    })), l = R(Math.floor(n.position / Dt) * Dt), c = R(l.value + Dt), u = V(() => i.slice(l.value, c.value));
    le(
      () => n.position,
      (h) => {
        h !== void 0 && (h >= c.value ? n.direction === "backward" ? p() : f() : h === 0 ? (l.value = 0, c.value = Dt) : h < l.value && (l.value -= Dt, c.value -= Dt));
      }
    );
    const p = () => {
      l.value === 0 ? (l.value = (Math.ceil(n.images.length / Dt) - 1) * Dt, c.value = l.value + Dt) : (l.value -= Dt, c.value -= Dt);
    }, f = () => {
      c.value < n.images.length ? (l.value += Dt, c.value += Dt) : (l.value = 0, c.value = Dt);
    }, m = V(() => n.images.length > 6);
    return (h, g) => (b(), C("div", MM, [
      m.value ? (b(), C("button", {
        key: 0,
        onClick: Ke(p, ["stop"]),
        class: "left vacv-carousel-control",
        "aria-label": h.$t("vacvComponents.carousel.aria-previous")
      }, FM, 8, LM)) : M("", !0),
      d("div", RM, [
        (b(!0), C($e, null, ke(u.value, (_, v) => (b(), C("div", {
          key: _.small,
          "data-index": v,
          class: ue(["item", {
            selected: h.position !== void 0 && h.position - l.value === v
          }])
        }, [
          d("div", BM, [
            d("a", {
              onClick: Ke((w) => o("select", l.value + v), ["prevent"]),
              href: "/",
              role: "button"
            }, [
              d("img", {
                src: _.thumbnail,
                alt: _.altText,
                onError: a
              }, null, 40, UM)
            ], 8, HM)
          ])
        ], 10, VM))), 128))
      ]),
      m.value ? (b(), C("button", {
        key: 1,
        onClick: Ke(f, ["stop"]),
        class: "right vacv-carousel-control",
        "aria-label": h.$t("vacvComponents.carousel.aria-next")
      }, jM, 8, zM)) : M("", !0)
    ]));
  }
}), KM = (e, t) => {
  const n = R("forward"), o = D_(e), s = "backward", a = "forward", r = R(0), i = V(() => n.value === a), l = V(() => n.value === s);
  return {
    ...o,
    prev: () => {
      n.value = "backward", o.prev(), r.value = (r.value - 1 + e.length) % e.length;
    },
    next: () => {
      n.value = "forward", o.next(), r.value = (r.value + 1) % e.length;
    },
    direction: n,
    isForward: i,
    isBackward: l,
    currentIndex: r
  };
};
function Xp(e) {
  return Yv() ? (Gv(e), !0) : !1;
}
const qb = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const YM = (e) => e != null, GM = Object.prototype.toString, ZM = (e) => GM.call(e) === "[object Object]", ni = () => {
}, gm = /* @__PURE__ */ XM();
function XM() {
  var e, t;
  return qb && ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((t = window == null ? void 0 : window.navigator) == null ? void 0 : t.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function oi(e) {
  return Array.isArray(e) ? e : [e];
}
function JM(...e) {
  if (e.length !== 1)
    return Wo(...e);
  const t = e[0];
  return typeof t == "function" ? Gu(Zv(() => ({ get: t, set: ni }))) : R(t);
}
function QM(e, t, n) {
  return le(
    e,
    t,
    {
      ...n,
      immediate: !0
    }
  );
}
const Kb = qb ? window : void 0;
function si(e) {
  var t;
  const n = Bn(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
function eL(...e) {
  const t = [], n = () => {
    t.forEach((i) => i()), t.length = 0;
  }, o = (i, l, c, u) => (i.addEventListener(l, c, u), () => i.removeEventListener(l, c, u)), s = V(() => {
    const i = oi(Bn(e[0])).filter((l) => l != null);
    return i.every((l) => typeof l != "string") ? i : void 0;
  }), a = QM(
    () => {
      var i, l;
      return [
        (l = (i = s.value) == null ? void 0 : i.map((c) => si(c))) != null ? l : [Kb].filter((c) => c != null),
        oi(Bn(s.value ? e[1] : e[0])),
        oi(T(s.value ? e[2] : e[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        Bn(s.value ? e[3] : e[2])
      ];
    },
    ([i, l, c, u]) => {
      if (n(), !(i != null && i.length) || !(l != null && l.length) || !(c != null && c.length))
        return;
      const p = ZM(u) ? { ...u } : u;
      t.push(
        ...i.flatMap(
          (f) => l.flatMap(
            (m) => c.map((h) => o(f, m, h, p))
          )
        )
      );
    },
    { flush: "post" }
  ), r = () => {
    a(), n();
  };
  return Xp(n), r;
}
function tL() {
  const e = ea(!1), t = bo();
  return t && Re(() => {
    e.value = !0;
  }, t), e;
}
function nL(e) {
  const t = tL();
  return V(() => (t.value, !!e()));
}
function bm(e, t, n = {}) {
  const {
    root: o,
    rootMargin: s = "0px",
    threshold: a = 0,
    window: r = Kb,
    immediate: i = !0
  } = n, l = nL(() => r && "IntersectionObserver" in r), c = V(() => {
    const h = Bn(e);
    return oi(h).map(si).filter(YM);
  });
  let u = ni;
  const p = ea(i), f = l.value ? le(
    () => [c.value, si(o), p.value],
    ([h, g]) => {
      if (u(), !p.value || !h.length)
        return;
      const _ = new IntersectionObserver(
        t,
        {
          root: si(g),
          rootMargin: s,
          threshold: a
        }
      );
      h.forEach((v) => v && _.observe(v)), u = () => {
        _.disconnect(), u = ni;
      };
    },
    { immediate: i, flush: "post" }
  ) : ni, m = () => {
    u(), f(), p.value = !1;
  };
  return Xp(m), {
    isSupported: l,
    isActive: p,
    pause() {
      u(), p.value = !1;
    },
    resume() {
      p.value = !0;
    },
    stop: m
  };
}
function _c(e) {
  return typeof Window < "u" && e instanceof Window ? e.document.documentElement : typeof Document < "u" && e instanceof Document ? e.documentElement : e;
}
const as = {
  mounted(e, t) {
    typeof t.value == "function" ? bm(e, t.value) : bm(e, ...t.value);
  }
};
function Yb(e) {
  const t = window.getComputedStyle(e);
  if (t.overflowX === "scroll" || t.overflowY === "scroll" || t.overflowX === "auto" && e.clientWidth < e.scrollWidth || t.overflowY === "auto" && e.clientHeight < e.scrollHeight)
    return !0;
  {
    const n = e.parentNode;
    return !n || n.tagName === "BODY" ? !1 : Yb(n);
  }
}
function oL(e) {
  const t = e || window.event, n = t.target;
  return Yb(n) ? !1 : t.touches.length > 1 ? !0 : (t.preventDefault && t.preventDefault(), !1);
}
const wc = /* @__PURE__ */ new WeakMap();
function sL(e, t = !1) {
  const n = ea(t);
  let o = null, s = "";
  le(JM(e), (i) => {
    const l = _c(Bn(i));
    if (l) {
      const c = l;
      if (wc.get(c) || wc.set(c, c.style.overflow), c.style.overflow !== "hidden" && (s = c.style.overflow), c.style.overflow === "hidden")
        return n.value = !0;
      if (n.value)
        return c.style.overflow = "hidden";
    }
  }, {
    immediate: !0
  });
  const a = () => {
    const i = _c(Bn(e));
    !i || n.value || (gm && (o = eL(
      i,
      "touchmove",
      (l) => {
        oL(l);
      },
      { passive: !1 }
    )), i.style.overflow = "hidden", n.value = !0);
  }, r = () => {
    const i = _c(Bn(e));
    !i || !n.value || (gm && (o == null || o()), i.style.overflow = s, wc.delete(i), n.value = !1);
  };
  return Xp(r), V({
    get() {
      return n.value;
    },
    set(i) {
      i ? a() : r();
    }
  });
}
function aL() {
  let e = !1;
  const t = ea(!1);
  return (n, o) => {
    if (t.value = o.value, e)
      return;
    e = !0;
    const s = sL(n, o.value);
    le(t, (a) => s.value = a);
  };
}
aL();
const rL = {
  key: 0,
  class: "vacv-carousel"
}, iL = { class: "vacv-carousel-inner" }, lL = { class: "item" }, cL = ["src", "onLoad", "onError"], uL = {
  id: "carousel-full",
  class: "vacv-carousel carousel-full",
  "data-interval": "false"
}, pL = { class: "vacv-carousel-inner" }, dL = { class: "item-wrapper" }, Jp = /* @__PURE__ */ K({
  __name: "VacvImageCarousel",
  props: {
    images: {},
    sizes: {},
    displaySize: {},
    displayVariation: {},
    availableVariations: {}
  },
  emits: ["carousel-modal-opened"],
  setup(e, { emit: t }) {
    const n = e, o = R(!1), s = t, a = V(() => n.images.length), r = V(() => n.images.map((Y) => {
      const j = $i(
        Y.url,
        o.value ? "cinema" : n.displayVariation,
        n.availableVariations
      ), ee = { ...Y, url: j }, te = u1(ee, n.sizes);
      return {
        ...ee,
        url: te[n.displaySize],
        ...te
      };
    })), i = V(() => {
      const N = r.value[g.value].xlarge, Y = "cinema", j = n.availableVariations;
      return $i(N, Y, j);
    });
    function l(N, Y, j) {
      const ee = Y === "medium" ? j[N].medium : j[N].large, te = Y === "medium" ? "tabletLandscape" : "cinema";
      return ee && n.availableVariations ? p1(ee, te, n.availableVariations) : ee;
    }
    const c = V(() => l(
      g.value,
      n.displaySize,
      r.value
    )), u = V(() => l(
      _.value,
      n.displaySize,
      r.value
    )), p = V(() => l(
      v.value,
      n.displaySize,
      r.value
    )), { next: f, prev: m, direction: h, currentIndex: g } = KM(
      r.value
    ), _ = V(
      () => (g.value - 1 + a.value) % a.value
    ), v = V(() => (g.value + 1) % a.value), w = tt(
      /* @__PURE__ */ new Map([
        [r.value[_.value].url, !1],
        [r.value[g.value].url, !1],
        [r.value[v.value].url, !1]
      ])
    );
    le([g, o], ([, N]) => {
      N && (y(r.value[_.value].xlarge), y(r.value[v.value].xlarge), y(c.value)), y(u.value), y(p.value);
    });
    const y = (N) => {
      w.get(N) || w.set(N, !1);
    }, $ = R(!1), S = ([
      { isIntersecting: N }
    ]) => {
      N && ($.value = N);
    }, A = (N) => {
      h.value = N < g.value ? "backward" : "forward", g.value = N;
    }, I = V(() => !!w.get(r.value[g.value].url)), D = V(() => !!w.get(r.value[g.value].xlarge)), O = V(() => !($.value && I.value)), x = V(() => !D.value), F = (N) => {
      w.set(N, !0);
    }, P = (N) => {
      w.set(N, "ERROR");
    }, E = () => {
      y(r.value[_.value].xlarge), y(r.value[g.value].xlarge), y(r.value[v.value].xlarge), o.value = !0, document.documentElement.style.setProperty("overflow-x", "unset"), s("carousel-modal-opened");
    }, B = () => {
      document.documentElement.style.removeProperty("overflow-x"), o.value = !1;
    };
    return (N, Y) => a.value ? (b(), C("div", rL, [
      ot((b(), C("div", iL, [
        d("div", lL, [
          $.value ? (b(!0), C($e, { key: 0 }, ke(w, ([j]) => (b(), C("img", {
            class: "vacv-carousel__img--preload",
            src: j,
            key: j,
            onLoad: (ee) => F(j),
            onError: (ee) => P(j),
            alt: ""
          }, null, 40, cL))), 128)) : M("", !0),
          q(hm, {
            direction: T(h),
            overlay: O.value,
            "alt-text": N.$t("vacvComponents.carousel.photo") + r.value[T(g)].altText,
            "image-url": r.value[T(g)].url,
            "index-position": T(g),
            "images-count": a.value,
            onOnSelectImage: E,
            onPrev: T(m),
            onNext: T(f)
          }, null, 8, ["direction", "overlay", "alt-text", "image-url", "index-position", "images-count", "onPrev", "onNext"]),
          q(Qt, {
            modelValue: o.value,
            "onUpdate:modelValue": Y[1] || (Y[1] = (j) => o.value = j),
            class: "vacv-modal modal-fullscreen vacv-modal-carousel",
            id: "vacv-carousel-modal",
            onClose: B
          }, {
            default: he(() => [
              q($M),
              d("div", uL, [
                d("div", pL, [
                  d("div", dL, [
                    q(hm, {
                      direction: T(h),
                      "alt-text": r.value[T(g)].altText,
                      "image-url": i.value,
                      description: r.value[T(g)].description,
                      "index-position": T(g),
                      "images-count": a.value,
                      overlay: x.value,
                      mode: "cinema",
                      onOnLoaded: F,
                      onPrev: T(m),
                      onNext: T(f)
                    }, null, 8, ["direction", "alt-text", "image-url", "description", "index-position", "images-count", "overlay", "onPrev", "onNext"])
                  ]),
                  q(qM, {
                    direction: T(h),
                    position: T(g),
                    images: r.value,
                    "available-variations": N.availableVariations,
                    onSelect: Y[0] || (Y[0] = (j) => A(j))
                  }, null, 8, ["direction", "position", "images", "available-variations"])
                ])
              ])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ])), [
        [T(as), S]
      ])
    ])) : M("", !0);
  }
}), fL = { class: "insurance-notes" }, mL = ["innerHTML"], vL = /* @__PURE__ */ K({
  __name: "InsuranceNotes",
  props: {
    insuranceNotes: {}
  },
  setup(e) {
    return (t, n) => (b(), C("div", fL, [
      d("div", {
        class: "notes vacv-editor special-list",
        innerHTML: t.insuranceNotes
      }, null, 8, mL)
    ]));
  }
}), hL = { class: "insurance-section" }, gL = { class: "insurance-box paddedbox-grey" }, bL = {
  key: 0,
  class: "insurance-info"
}, yL = { class: "insurance-product" }, $L = { class: "insurance-travellers-number" }, _L = { class: "insurance-amount" }, wL = {
  key: 1,
  class: "insurance-optout"
}, CL = {
  key: 2,
  class: "insurance-optout"
}, fie = /* @__PURE__ */ K({
  __name: "InsuranceDetails",
  props: {
    insuranceNotes: {},
    insuranceNbPax: {},
    travelInsuranceFailedOnReQuote: { type: Boolean }
  },
  setup(e) {
    const t = On(), {
      selectedInsuranceProduct: n,
      declinedTravelInsurance: o,
      hasSelectedInsuranceProduct: s
    } = Ce(t);
    return (a, r) => (b(), C("section", hL, [
      d("h2", null, k(a.$t("vacvComponents.payment.labels.allianzTravelInsuranceTitle")), 1),
      T(s) ? (b(), ie(vL, {
        key: 0,
        insuranceNotes: a.insuranceNotes
      }, null, 8, ["insuranceNotes"])) : M("", !0),
      d("div", gL, [
        T(s) ? (b(), C("div", bL, [
          d("span", yL, k(T(n).title), 1),
          d("span", $L, k(a.$t("vacvComponents.payment.labels.insuranceForXTravellers", {
            x: a.insuranceNbPax
          })), 1),
          d("span", _L, k(T(Se)(T(n).premium, a.$n)) + " " + k(a.$t("vacvComponents.payment.labels.plusTaxes")), 1)
        ])) : T(o) ? (b(), C("div", wL, k(a.$t("vacvComponents.payment.labels.allianzOptedOutInsurance")), 1)) : a.travelInsuranceFailedOnReQuote ? (b(), C("div", CL, k(a.$t("vacvComponents.payment.messages.travelInsuranceNoOptions")), 1)) : M("", !0)
      ])
    ]));
  }
});
function Gb(e) {
  const t = {
    event: "insurancePlanSelect",
    insurancePlanChosen: e
  };
  window.dataLayer.push(t);
}
function mie(e, t, n, o, s) {
  const a = ss(-1, e, n, t, s);
  window.dataLayer.push({ ecommerce: null });
  const r = {
    event: "add_insurance_info",
    ecommerce: {
      items: [
        {
          ...a,
          insurance_plan_selected: o,
          item_list_id: ""
        }
      ]
    }
  };
  window.dataLayer.push(r);
}
const kL = { class: "decline-insurance" }, SL = { class: "vacv-checkbox" }, vie = /* @__PURE__ */ K({
  __name: "InsuranceDecline",
  setup(e) {
    const t = On(), { declineInsurance: n } = t, { declinedTravelInsurance: o } = Ce(t);
    function s() {
      const a = o.value;
      n(!a), a || Gb("Decline Insurance");
    }
    return (a, r) => {
      const i = ut("FormKit");
      return b(), C("div", kL, [
        d("div", SL, [
          q(i, {
            name: "insurance-decline",
            id: "insurance-decline",
            type: "checkbox",
            label: a.$t("vacvComponents.payment.labels.allianzDeclineTravelInsurance"),
            modelValue: T(o),
            "onUpdate:modelValue": r[0] || (r[0] = (l) => Pt(o) ? o.value = l : null),
            "decorator-icon": T(yo),
            onClick: s,
            "aria-checked": T(o) ? "true" : "false"
          }, null, 8, ["label", "modelValue", "decorator-icon", "aria-checked"])
        ])
      ]);
    };
  }
}), TL = { class: "insurance-description" }, AL = { class: "description" }, DL = ["src"], hie = /* @__PURE__ */ K({
  __name: "InsuranceDescription",
  props: {
    insuranceCompanyLogo: {}
  },
  setup(e) {
    return (t, n) => (b(), C("div", TL, [
      d("div", AL, [
        d("img", {
          src: t.insuranceCompanyLogo,
          height: "56",
          alt: ""
        }, null, 8, DL),
        d("p", null, k(t.$t("vacvComponents.payment.labels.allianzTravelInsuranceDescription")), 1),
        d("p", null, [
          d("strong", null, k(t.$t("vacvComponents.payment.labels.allianzTravelInsuranceDescription2")), 1)
        ])
      ])
    ]));
  }
}), PL = { class: "insurance-disclaimer" }, IL = ["innerHTML"], gie = /* @__PURE__ */ K({
  __name: "InsuranceDisclaimer",
  props: {
    insuranceDisclaimer: {}
  },
  setup(e) {
    return (t, n) => (b(), C("div", PL, [
      d("div", {
        class: "disclaimer vacv-editor",
        innerHTML: t.insuranceDisclaimer
      }, null, 8, IL)
    ]));
  }
}), EL = { class: "insurance-table insurance-table-desktop" }, OL = { class: "table-recommended-row" }, xL = {
  id: "empty-recomended-line",
  style: { width: "30%" }
}, ML = { class: "sr-only" }, LL = ["id"], NL = {
  key: 0,
  class: "insurance-header-sup"
}, FL = /* @__PURE__ */ d("i", {
  class: "fa-solid fa-thumbs-up",
  "aria-hidden": "true"
}, null, -1), RL = {
  key: 1,
  class: "sr-only"
}, VL = { class: "table-header-row" }, BL = {
  id: "title-line-empty",
  class: "insurance-item-title",
  style: { width: "30%" }
}, HL = { class: "sr-only" }, UL = ["id"], zL = { class: "table-row" }, WL = {
  class: "table-left-column product-title product-price",
  style: { width: "30%" }
}, jL = {
  class: "table-left-column product-title",
  style: { width: "30%" }
}, qL = ["onClick", "aria-label"], KL = /* @__PURE__ */ d("span", { class: "round-icon" }, null, -1), YL = [
  KL
], GL = {
  key: 0,
  class: "fa-solid fa-check"
}, ZL = { class: "table-button-row" }, XL = /* @__PURE__ */ d("td", {
  class: "table-left-column",
  style: { width: "30%" }
}, null, -1), JL = ["onclick"], QL = { class: "add" }, eN = { class: "sr-only" }, tN = { class: "added" }, nN = /* @__PURE__ */ d("i", {
  class: "fa-solid fa-check",
  "aria-hidden": "true"
}, null, -1), oN = { class: "sr-only" }, sN = { class: "table-terms-row" }, aN = /* @__PURE__ */ d("td", { style: { width: "30%" } }, null, -1), rN = ["href", "innerHTML"], iN = ["href", "innerHTML"], lN = /* @__PURE__ */ K({
  __name: "InsuranceOptionsDesktop",
  props: {
    travelInsuranceProducts: {},
    numberOfInsuredPassengers: {}
  },
  emits: ["handleSelectionOfInsuranceProduct"],
  setup(e, { emit: t }) {
    const n = t, o = On(), { setShowModalInclusionDetails: s, setModalContent: a, setModalTitle: r } = o, { selectedInsuranceProduct: i, travelInsuranceInclusionsMatrix: l } = Ce(o), c = (u, p) => {
      a(p), r(u), s(!0);
    };
    return (u, p) => (b(), C("table", EL, [
      d("tr", OL, [
        d("th", xL, [
          d("div", ML, k(u.$t("vacvComponents.ancillary.access.table-cell-empty")), 1)
        ]),
        (b(!0), C($e, null, ke(u.travelInsuranceProducts, (f) => (b(), C("th", {
          key: f.productCode,
          id: `recomended-line-product-${f.productCode}`,
          class: "table-recommended-line"
        }, [
          f.recommended ? (b(), C("div", NL, [
            FL,
            ne(" " + k(u.$t("vacvComponents.payment.labels.mostPopular")), 1)
          ])) : M("", !0),
          f.recommended ? (b(), C("div", RL, k(u.$t("vacvComponents.ancillary.access.table-cell-empty")), 1)) : M("", !0)
        ], 8, LL))), 128))
      ]),
      d("tr", VL, [
        d("th", BL, [
          d("div", HL, k(u.$t("vacvComponents.ancillary.access.table-cell-empty")), 1)
        ]),
        (b(!0), C($e, null, ke(u.travelInsuranceProducts, (f) => {
          var m;
          return b(), C("th", {
            key: f.productCode,
            id: `title-line-product-${f.productCode}`,
            class: ue([
              "insurance-item-title",
              {
                "selected-product-column": ((m = T(i)) == null ? void 0 : m.productCode) == f.productCode
              }
            ])
          }, k(f.title), 11, UL);
        }), 128))
      ]),
      d("tr", zL, [
        d("td", WL, k(u.numberOfInsuredPassengers > 1 ? u.$t(
          "vacvComponents.payment.labels.priceTitle",
          u.numberOfInsuredPassengers
        ) : u.$t("vacvComponents.payment.labels.priceTitle")), 1),
        (b(!0), C($e, null, ke(u.travelInsuranceProducts, (f, m) => {
          var h;
          return b(), C("td", {
            key: f.productCode,
            class: ue([
              "h1style",
              {
                "selected-product-column": ((h = T(i)) == null ? void 0 : h.productCode) == f.productCode
              },
              {
                "table-right-column": m === u.travelInsuranceProducts.length - 1
              }
            ])
          }, k("+ " + T(Se)(f.premium, u.$n)), 3);
        }), 128))
      ]),
      (b(!0), C($e, null, ke(T(l), (f, m) => (b(), C("tr", {
        class: "table-row",
        key: m
      }, [
        d("td", jL, [
          ne(k(m), 1),
          f ? (b(), C("button", {
            key: 0,
            onClick: (h) => c(m, f),
            class: "price-popover-link",
            "aria-haspopup": "true",
            "aria-label": `${u.$t("vacvComponents.ancillary.access.know-more-about")} ${m}`
          }, YL, 8, qL)) : M("", !0)
        ]),
        (b(!0), C($e, null, ke(u.travelInsuranceProducts, (h, g) => {
          var _;
          return b(), C("td", {
            key: h.productCode,
            class: ue([
              { "content-middle": g === 0 },
              {
                "selected-product-column": ((_ = T(i)) == null ? void 0 : _.productCode) === h.productCode
              },
              {
                "table-right-column": g === u.travelInsuranceProducts.length - 1
              }
            ])
          }, [
            h.inclusions.some(
              (v) => v.title === m
            ) ? (b(), C("i", GL)) : M("", !0)
          ], 2);
        }), 128))
      ]))), 128)),
      d("tr", ZL, [
        XL,
        (b(!0), C($e, null, ke(u.travelInsuranceProducts, (f, m) => {
          var h, g;
          return b(), C("td", {
            key: f.productCode,
            class: ue([
              {
                "selected-product-column": ((h = T(i)) == null ? void 0 : h.productCode) == f.productCode
              },
              {
                "table-right-column": m === u.travelInsuranceProducts.length - 1
              }
            ])
          }, [
            d("button", {
              class: ue(["vacv-btn-secondary", {
                active: ((g = T(i)) == null ? void 0 : g.productCode) === f.productCode
              }]),
              onclick: () => n("handleSelectionOfInsuranceProduct", f)
            }, [
              d("span", QL, [
                ne(k(u.$t("vacvComponents.common.buttons.add")) + " ", 1),
                d("span", eN, k(f.title), 1)
              ]),
              d("span", tN, [
                nN,
                d("span", oN, k(f.title), 1),
                ne(" " + k(u.$t("vacvComponents.common.buttons.added")), 1)
              ])
            ], 10, JL)
          ], 2);
        }), 128))
      ]),
      d("tr", sN, [
        aN,
        (b(!0), C($e, null, ke(u.travelInsuranceProducts, (f) => {
          var m;
          return b(), C("td", {
            key: f.productCode,
            class: ue([
              {
                "selected-product-column": ((m = T(i)) == null ? void 0 : m.productCode) == f.productCode
              }
            ]),
            style: { width: "23.3%" }
          }, [
            f.termsConditionsUrl ? (b(), C("a", {
              key: 0,
              href: f.termsConditionsUrl,
              target: "_blank",
              class: "navback-link link product-terms",
              innerHTML: u.$t("vacvComponents.payment.labels.allianzTermsAndConditions")
            }, null, 8, rN)) : M("", !0),
            f.productUrl ? (b(), C("a", {
              key: 1,
              href: f.productUrl,
              target: "_blank",
              class: "navback-link link product-terms",
              innerHTML: u.$t("vacvComponents.payment.labels.allianzProductSummary")
            }, null, 8, iN)) : M("", !0)
          ], 2);
        }), 128))
      ])
    ]));
  }
}), cN = { class: "mobile-scroller-wrapper" }, uN = { class: "mobile-scroller" }, pN = {
  key: 0,
  class: "insurance-header-sup"
}, dN = /* @__PURE__ */ d("i", {
  class: "fa-solid fa-thumbs-up",
  "aria-hidden": "true"
}, null, -1), fN = { class: "table-header-row" }, mN = {
  class: "insurance-item-title",
  colspan: "2"
}, vN = { class: "table-row" }, hN = { class: "product-title product-price" }, gN = { class: "h1style" }, bN = { class: "product-title" }, yN = ["onClick", "aria-label"], $N = /* @__PURE__ */ d("span", { class: "round-icon" }, null, -1), _N = [
  $N
], wN = {
  key: 0,
  class: "fa-solid fa-check",
  "aria-hidden": "true"
}, CN = { class: "table-button-row" }, kN = { colspan: "2" }, SN = ["onclick"], TN = { class: "add" }, AN = { class: "sr-only" }, DN = { class: "added" }, PN = /* @__PURE__ */ d("i", {
  class: "fa-solid fa-check",
  "aria-hidden": "true"
}, null, -1), IN = { class: "sr-only" }, EN = { class: "table-terms-row" }, ON = { colspan: "2" }, xN = ["href", "innerHTML"], MN = ["href", "innerHTML"], LN = /* @__PURE__ */ K({
  __name: "InsuranceOptionsMobile",
  props: {
    travelInsuranceProducts: {},
    numberOfInsuredPassengers: {}
  },
  emits: ["handleSelectionOfInsuranceProduct"],
  setup(e, { emit: t }) {
    const n = t, o = On(), { setModalContent: s, setModalTitle: a, setShowModalInclusionDetails: r } = o, { selectedInsuranceProduct: i, travelInsuranceInclusionsMatrix: l } = Ce(o), c = (u, p) => {
      s(p), a(u), r(!0);
    };
    return (u, p) => (b(), C("div", cN, [
      d("div", uN, [
        (b(!0), C($e, null, ke(u.travelInsuranceProducts, (f, m) => {
          var h, g;
          return b(), C("div", {
            key: f.productCode,
            class: "mobile-table-container"
          }, [
            f.recommended ?? !1 ? (b(), C("div", pN, [
              dN,
              ne(" " + k(u.$t("vacvComponents.payment.labels.mostPopular")), 1)
            ])) : M("", !0),
            d("table", {
              class: ue([
                "insurance-table insurance-table-mobile",
                {
                  "selected-product-column": ((h = T(i)) == null ? void 0 : h.productCode) == f.productCode
                }
              ])
            }, [
              d("tr", fN, [
                d("th", mN, k(f.title), 1)
              ]),
              d("tr", vN, [
                d("td", hN, k(u.numberOfInsuredPassengers > 1 ? u.$t(
                  "vacvComponents.payment.labels.priceTitle",
                  u.numberOfInsuredPassengers
                ) : u.$t("vacvComponents.payment.labels.priceTitle")), 1),
                d("td", gN, k("+ " + T(Se)(f.premium, u.$n)), 1)
              ]),
              (b(!0), C($e, null, ke(T(l), (_, v) => (b(), C("tr", {
                class: "table-row",
                key: v
              }, [
                d("td", bN, [
                  ne(k(v), 1),
                  _ ? (b(), C("button", {
                    key: 0,
                    class: "price-popover-link",
                    onClick: (w) => c(v, _),
                    "aria-haspopup": "true",
                    "aria-label": `${u.$t("ancillary.access.know-more-about")} ${v}`
                  }, _N, 8, yN)) : M("", !0)
                ]),
                d("td", null, [
                  u.travelInsuranceProducts[m].inclusions.some(
                    (w) => w.title === v
                  ) ? (b(), C("i", wN)) : M("", !0)
                ])
              ]))), 128)),
              d("tr", CN, [
                d("td", kN, [
                  d("button", {
                    class: ue(["vacv-btn-secondary", {
                      active: ((g = T(i)) == null ? void 0 : g.productCode) === f.productCode
                    }]),
                    onclick: () => n("handleSelectionOfInsuranceProduct", f)
                  }, [
                    d("span", TN, [
                      ne(k(u.$t("vacvComponents.common.buttons.add")) + " ", 1),
                      d("span", AN, k(f.title), 1)
                    ]),
                    d("span", DN, [
                      PN,
                      d("span", IN, k(f.title), 1),
                      ne(" " + k(u.$t("vacvComponents.common.buttons.added")), 1)
                    ])
                  ], 10, SN)
                ])
              ]),
              d("tr", EN, [
                d("td", ON, [
                  f.termsConditionsUrl ? (b(), C("a", {
                    key: 0,
                    href: f.termsConditionsUrl,
                    target: "_blank",
                    class: "navback-link link product-terms",
                    innerHTML: u.$t("vacvComponents.payment.labels.allianzTermsAndConditions")
                  }, null, 8, xN)) : M("", !0),
                  f.productUrl ? (b(), C("a", {
                    key: 1,
                    href: f.productUrl,
                    target: "_blank",
                    class: "navback-link link product-terms",
                    innerHTML: u.$t("vacvComponents.payment.labels.allianzProductSummary")
                  }, null, 8, MN)) : M("", !0)
                ])
              ])
            ], 2)
          ]);
        }), 128))
      ])
    ]));
  }
});
function Qp(e, t = 100) {
  const n = ip(e, t);
  Re(function() {
    window.addEventListener("resize", n);
  }), Jt(function() {
    window.removeEventListener("resize", n);
  });
}
const NN = () => {
  const e = R(window.innerWidth);
  Qp(() => {
    e.value = window.innerWidth;
  });
  const n = V(() => e.value >= 991), o = V(
    () => e.value >= 768 && e.value < 991
  ), s = V(() => o.value || n.value);
  return {
    deviceSize: e,
    isDesktop: n,
    isTablet: o,
    isTabletAndUp: s
  };
}, FN = ["innerHTML"], RN = ["innerHTML"], bie = /* @__PURE__ */ K({
  __name: "InsuranceOptions",
  props: {
    travelInsuranceProducts: {},
    numberOfInsuredPassengers: {}
  },
  setup(e) {
    const t = On(), { selectTravelInsuranceProduct: n } = t, { modalTitle: o, modalContent: s } = Ce(t), { isTabletAndUp: a } = NN(), r = () => {
      t.setShowModalInclusionDetails(!1);
    };
    function i(l) {
      n(l), Gb(l.productCode);
    }
    return (l, c) => (b(), C($e, null, [
      q(Qt, {
        onClose: r,
        modelValue: T(t).showModalInclusionDetails,
        "onUpdate:modelValue": c[0] || (c[0] = (u) => T(t).showModalInclusionDetails = u),
        class: "vacv-modal modal-fullscreen vacv-modal-centered"
      }, {
        default: he(() => [
          d("div", {
            id: "inclusions-modal-title",
            class: "h3style",
            innerHTML: T(o)
          }, null, 8, FN),
          d("div", {
            id: "inclusions-modal-content",
            class: "vacv-editor",
            innerHTML: T(s)
          }, null, 8, RN)
        ]),
        _: 1
      }, 8, ["modelValue"]),
      T(a) ? (b(), ie(lN, {
        key: 0,
        "travel-insurance-products": l.travelInsuranceProducts,
        "number-of-insured-passengers": l.numberOfInsuredPassengers,
        onHandleSelectionOfInsuranceProduct: i
      }, null, 8, ["travel-insurance-products", "number-of-insured-passengers"])) : (b(), ie(LN, {
        key: 1,
        "travel-insurance-products": l.travelInsuranceProducts,
        "number-of-insured-passengers": l.numberOfInsuredPassengers,
        onHandleSelectionOfInsuranceProduct: i
      }, null, 8, ["travel-insurance-products", "number-of-insured-passengers"]))
    ], 64));
  }
}), so = St("filter", () => {
  const t = R({
    rangeValueFilters: [
      { name: "PRICE", low: 0, high: 5e3, increment: 50 },
      { name: "RATING", low: 0, high: 5, increment: 1 }
    ],
    fixedValueFilters: [
      { name: "DESTINATION", values: [] },
      { name: "AMENITIES", values: [] },
      { name: "DEALS", values: [] },
      { name: "VACATION_TYPE", values: [] }
    ]
  }), n = R([
    { name: "PRICE", selectedLow: 0, selectedHigh: 5e3 },
    { name: "RATING", selectedLow: 0, selectedHigh: 5 }
  ]), o = R([
    { name: "DESTINATION", selectedIds: [] },
    { name: "AMENITIES", selectedIds: [] },
    { name: "DEALS", selectedIds: [] },
    { name: "VACATION_TYPE", selectedIds: [] }
  ]), s = R(!1), a = R(!1), r = R(!1), i = R(!1), l = R(!1);
  function c(v, w) {
    return v.filter((y) => u(y, w));
  }
  function u(v, w) {
    return w.some((y) => y.id === v);
  }
  function p(v) {
    !s.value && (v != null && v.length) && (t.value.rangeValueFilters = v.map((w) => w.name === "RATING" ? { ...w, low: 0 } : { ...w }), n.value = n.value.map(
      (w) => {
        const y = v.find(
          ($) => $.name === w.name
        );
        return y ? y.name === "RATING" ? {
          ...w,
          selectedLow: w.selectedLow === 0 ? 0 : Math.max(
            2,
            Math.min(w.selectedLow, y.high)
          ),
          selectedHigh: Math.min(
            y.high,
            Math.max(w.selectedHigh, 2)
          )
        } : {
          ...w,
          selectedLow: Math.max(
            0,
            Math.min(w.selectedLow, y.high)
          ),
          selectedHigh: Math.min(
            y.high,
            Math.max(w.selectedHigh, 0)
          )
        } : w;
      }
    ), s.value = !0);
  }
  function f(v) {
    !a.value && (v != null && v.length) && (t.value.fixedValueFilters = [...v], o.value = o.value.map(
      (w) => {
        const y = v.find(
          ($) => $.name === w.name
        );
        if (y) {
          const $ = c(w.selectedIds, y.values);
          return { ...w, selectedIds: $ };
        }
        return w;
      }
    ), a.value = !0);
  }
  function m(v, w, y) {
    const $ = n.value.find((x) => x.name === v), S = t.value.rangeValueFilters.find(
      (x) => x.name === v
    ), A = (S == null ? void 0 : S.low) ?? 0, I = (S == null ? void 0 : S.high) ?? (v === "PRICE" ? 5e3 : 5);
    let D = w ?? A, O = y ?? I;
    v === "RATING" && D === 0 ? D = 0 : D = Math.max(A, D), O = Math.min(I, O), $ ? ($.selectedLow = D, $.selectedHigh = O) : n.value.push({
      name: v,
      selectedLow: D,
      selectedHigh: O
    });
  }
  function h(v, w) {
    const y = o.value.find((A) => A.name === v), $ = t.value.fixedValueFilters.find(
      (A) => A.name === v
    ), S = w && w.length > 0 ? c(w, ($ == null ? void 0 : $.values) ?? []) : [];
    y ? y.selectedIds = S : o.value.push({ name: v, selectedIds: S });
  }
  function g() {
    n.value = [
      { name: "PRICE", selectedLow: 0, selectedHigh: 5e3 },
      { name: "RATING", selectedLow: 0, selectedHigh: 5 }
    ], o.value = [
      { name: "DESTINATION", selectedIds: [] },
      { name: "AMENITIES", selectedIds: [] },
      { name: "DEALS", selectedIds: [] },
      { name: "VACATION_TYPE", selectedIds: [] }
    ], r.value = !1, i.value = !1;
  }
  const _ = V(() => {
    const v = {}, w = n.value.find(
      (D) => D.name === "PRICE"
    );
    w && (w.selectedLow > 0 || w.selectedHigh < 5e3) && (v.fprice = `${w.selectedLow}-${w.selectedHigh}`);
    const y = n.value.find(
      (D) => D.name === "RATING"
    );
    y && (y.selectedLow > 0 || y.selectedHigh < 5) && (v.frating = `${y.selectedLow}-${y.selectedHigh}`);
    const $ = o.value.find(
      (D) => D.name === "DESTINATION"
    );
    $ != null && $.selectedIds.length && (v.fdest = $.selectedIds.join(","));
    const S = o.value.find(
      (D) => D.name === "AMENITIES"
    );
    S != null && S.selectedIds.length && (v.famenities = S.selectedIds.join(","));
    const A = o.value.find(
      (D) => D.name === "DEALS"
    );
    A != null && A.selectedIds.length && (v.fdeal = A.selectedIds.join(","));
    const I = o.value.find(
      (D) => D.name === "VACATION_TYPE"
    );
    return I != null && I.selectedIds.length && (v.fVacationType = I.selectedIds.join(",")), v;
  });
  return {
    filters: t,
    selectedRangeFilters: n,
    selectedFixedFilters: o,
    rangeFiltersInitialized: s,
    fixedFiltersInitialized: a,
    moreAmenitiesShow: r,
    moreDestinationsShow: i,
    hasPreviouslyAppliedFilters: l,
    updateAvailableRangeFilters: p,
    updateAvailableFixedFilters: f,
    updateSelectedRangeFilters: m,
    updateSelectedFixedFilters: h,
    resetFilters: g,
    searchOptionsFilters: _
  };
}), VN = {
  key: 0,
  class: "filter-section filteredby",
  "aria-live": "polite"
}, BN = { class: "vacv-label-sm" }, HN = { class: "filteredby-wrapper" }, UN = /* @__PURE__ */ K({
  __name: "FilteredBy",
  props: {
    maxPriceRange: {}
  },
  emits: ["clear-filters"],
  setup(e, { emit: t }) {
    const n = t, o = e, s = so(), { filters: a, selectedRangeFilters: r, selectedFixedFilters: i } = Ce(s), { t: l, n: c } = Ne({ useScope: "global" });
    function u($) {
      return V(() => {
        var S;
        return $((S = a.value) == null ? void 0 : S.fixedValueFilters);
      });
    }
    const p = u(XD), f = u(YD), m = u(GD), h = u(ZD), g = ($) => {
      switch ($) {
        case "2-5":
          return l("vacvComponents.filters.starRatingOptions.2");
        case "3-5":
          return l("vacvComponents.filters.starRatingOptions.3");
        case "4-5":
          return l("vacvComponents.filters.starRatingOptions.4");
        case "5-5":
          return l("vacvComponents.filters.starRatingOptions.5");
        default:
          return "";
      }
    };
    function _($, S, A) {
      ($ == null ? void 0 : $.length) > 0 && $.forEach((I) => {
        const D = S.get(I);
        D && A.push(D);
      });
    }
    const v = () => {
      const $ = [], S = i.value.find(
        (F) => F.name === "DEALS"
      );
      _((S == null ? void 0 : S.selectedIds) || [], p.value, $);
      const A = r.value.find(
        (F) => F.name === "PRICE"
      );
      A && (A.selectedLow !== 0 || A.selectedHigh !== o.maxPriceRange) && $.push(
        Se(A.selectedLow, c, !0) + " - " + Se(A.selectedHigh, c, !0) + `${A.selectedHigh === o.maxPriceRange ? " +" : ""}`
      );
      const I = r.value.find(
        (F) => F.name === "RATING"
      );
      if (I && (I.selectedLow > 0 || I.selectedHigh < 5)) {
        const F = `${I.selectedLow}-${I.selectedHigh}`;
        $.push(g(F));
      }
      const D = i.value.find(
        (F) => F.name === "DESTINATION"
      );
      _(
        (D == null ? void 0 : D.selectedIds) || [],
        f.value,
        $
      );
      const O = i.value.find(
        (F) => F.name === "AMENITIES"
      );
      _(
        (O == null ? void 0 : O.selectedIds) || [],
        m.value,
        $
      );
      const x = i.value.find(
        (F) => F.name === "VACATION_TYPE"
      );
      return _(
        (x == null ? void 0 : x.selectedIds) || [],
        h.value,
        $
      ), $;
    }, w = V(() => v()), y = () => {
      n("clear-filters");
    };
    return ($, S) => w.value.length > 0 ? (b(), C("section", VN, [
      d("div", BN, k($.$t("vacvComponents.filters.filteredBy")), 1),
      d("div", HN, [
        (b(!0), C($e, null, ke(w.value, (A) => (b(), C("span", { key: A }, k(A), 1))), 128))
      ]),
      d("button", {
        class: "link linklook",
        onClick: Ke(y, ["prevent"]),
        type: "button",
        "data-test": "clearAllButton"
      }, k($.$t("vacvComponents.filters.clearFilters")), 1)
    ])) : M("", !0);
  }
}), zN = { class: "vacv-rangeslider-wrapper" }, WN = /* @__PURE__ */ K({
  __name: "RangeSlider",
  emits: ["change-price-range"],
  setup(e, { emit: t }) {
    const n = t, o = so(), { filters: s, selectedRangeFilters: a } = Ce(o), r = V(() => {
      var p, f;
      const u = (f = (p = s.value) == null ? void 0 : p.rangeValueFilters) == null ? void 0 : f.find(
        (m) => m.name === "PRICE"
      );
      return {
        min: (u == null ? void 0 : u.low) ?? 0,
        max: (u == null ? void 0 : u.high) ?? 5e3
      };
    }), i = V(() => [
      r.value.min,
      r.value.max
    ]), l = R(i.value);
    function c() {
      const u = a.value.find(
        (h) => h.name === "PRICE"
      ), p = (u == null ? void 0 : u.selectedLow) ?? r.value.min, f = (u == null ? void 0 : u.selectedHigh) ?? r.value.max, m = [
        Math.max(
          r.value.min,
          Math.min(p, r.value.max)
        ),
        Math.max(
          r.value.min,
          Math.min(f, r.value.max)
        )
      ];
      l.value.splice(0, 2, m[0], m[1]);
    }
    return Re(() => {
      c();
    }), le(
      () => a.value.find((u) => u.name === "PRICE"),
      () => {
        c();
      },
      { deep: !0 }
    ), le(
      () => s.value,
      () => {
        c();
      },
      { deep: !0 }
    ), le(
      l,
      (u) => {
        n("change-price-range", u);
      },
      { deep: !0 }
    ), ko(() => {
      l.value = i.value;
    }), (u, p) => {
      const f = ut("FormKit");
      return b(), C("div", zN, [
        q(f, {
          id: "priceRange",
          modelValue: l.value,
          "onUpdate:modelValue": p[0] || (p[0] = (m) => l.value = m),
          type: "slider",
          "outer-class": "vacv-formkit-rangeslider",
          min: r.value.min,
          max: r.value.max,
          value: l.value,
          tooltip: "false",
          "show-input": "",
          name: "priceRange",
          "min-input-attrs": {
            onpaste: "return false;"
          },
          "max-input-attrs": {
            onpaste: "return false;",
            sectionsSchema: {
              prefix: {
                $el: "span",
                children: "+",
                attrs: {
                  class: {
                    if: `$_value !== ${r.value.max}`,
                    then: "hidden"
                  }
                }
              }
            }
          }
        }, null, 8, ["modelValue", "min", "max", "value", "max-input-attrs"])
      ]);
    };
  }
}), jN = { class: "filter-section starrating" }, qN = { class: "vacv-radio" }, KN = { class: "vacv-radio-group column" }, YN = {
  class: "formkit-outer",
  "data-family": "box",
  "data-type": "radio",
  "data-multiple": "true",
  "data-complete": "true"
}, GN = { class: "formkit-fieldset" }, ZN = { class: "formkit-legend" }, XN = { class: "formkit-options" }, JN = { class: "formkit-option" }, QN = { class: "formkit-wrapper" }, eF = { class: "formkit-inner" }, tF = { class: "formkit-label" }, nF = /* @__PURE__ */ U$('<i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i>', 5), oF = { class: "sr-only" }, sF = { class: "formkit-option" }, aF = { class: "formkit-wrapper" }, rF = { class: "formkit-inner" }, iF = { class: "formkit-label" }, lF = /* @__PURE__ */ d("i", { class: "fa-solid fa-star" }, null, -1), cF = /* @__PURE__ */ d("i", { class: "fa-solid fa-star" }, null, -1), uF = /* @__PURE__ */ d("i", { class: "fa-solid fa-star" }, null, -1), pF = /* @__PURE__ */ d("i", { class: "fa-solid fa-star" }, null, -1), dF = { class: "sr-only" }, fF = { class: "formkit-option" }, mF = { class: "formkit-wrapper" }, vF = { class: "formkit-inner" }, hF = { class: "formkit-label" }, gF = /* @__PURE__ */ d("i", { class: "fa-solid fa-star" }, null, -1), bF = /* @__PURE__ */ d("i", { class: "fa-solid fa-star" }, null, -1), yF = /* @__PURE__ */ d("i", { class: "fa-solid fa-star" }, null, -1), $F = { class: "sr-only" }, _F = { class: "formkit-option" }, wF = { class: "formkit-wrapper" }, CF = { class: "formkit-inner" }, kF = { class: "formkit-label" }, SF = /* @__PURE__ */ d("i", { class: "fa-solid fa-star" }, null, -1), TF = /* @__PURE__ */ d("i", { class: "fa-solid fa-star" }, null, -1), AF = { class: "sr-only" }, DF = /* @__PURE__ */ K({
  __name: "StarRatingFilter",
  emits: ["change-rating"],
  setup(e, { emit: t }) {
    const n = t, o = so(), { selectedRangeFilters: s } = Ce(o), a = R(""), r = [2, 3, 4, 5], i = r.map(() => R(null));
    async function l() {
      const u = s.value.find(
        (h) => h.name === "RATING"
      ), p = (u == null ? void 0 : u.selectedLow) ?? 0, f = (u == null ? void 0 : u.selectedHigh) ?? 5, m = p > 0 && f === 5 ? String(p) : "";
      a.value = r.includes(Number(m)) ? m + "-5" : "";
    }
    Re(() => {
      l();
    }), le(
      () => s.value.find((u) => u.name === "RATING"),
      () => {
        l();
      },
      { deep: !0 }
    );
    const c = (u) => {
      a.value = u, n("change-rating", a.value);
    };
    return ko(() => {
      a.value = "";
    }), (u, p) => {
      const f = ut("FormKit");
      return b(), C("section", jN, [
        d("div", qN, [
          d("div", KN, [
            d("div", YN, [
              q(f, {
                modelValue: a.value,
                "onUpdate:modelValue": p[0] || (p[0] = (m) => a.value = m),
                name: "rating",
                type: "hidden"
              }, null, 8, ["modelValue"]),
              d("fieldset", GN, [
                d("legend", ZN, k(u.$t("vacvComponents.filters.starRating")), 1),
                d("ul", XN, [
                  d("li", JN, [
                    d("label", QN, [
                      d("div", eF, [
                        ot(d("input", {
                          ref: T(i)[0],
                          class: "formkit-input vacv-custom",
                          type: "radio",
                          name: "frating",
                          id: "starrating-option-5-stars",
                          value: "5-5",
                          "onUpdate:modelValue": p[1] || (p[1] = (m) => a.value = m),
                          "data-test": "star-rating-input",
                          onChange: p[2] || (p[2] = (m) => c("5-5"))
                        }, null, 544), [
                          [Cs, a.value]
                        ])
                      ]),
                      d("span", tF, [
                        nF,
                        d("span", oF, "5 " + k(u.$t("vacvComponents.filters.starslabel.stars")), 1)
                      ])
                    ])
                  ]),
                  d("li", sF, [
                    d("label", aF, [
                      d("div", rF, [
                        ot(d("input", {
                          ref: T(i)[1],
                          class: "formkit-input vacv-custom",
                          type: "radio",
                          name: "frating",
                          id: "starrating-option-4-stars-up",
                          value: "4-5",
                          "onUpdate:modelValue": p[3] || (p[3] = (m) => a.value = m),
                          "data-test": "star-rating-input",
                          onChange: p[4] || (p[4] = (m) => c("4-5"))
                        }, null, 544), [
                          [Cs, a.value]
                        ])
                      ]),
                      d("span", iF, [
                        lF,
                        cF,
                        uF,
                        pF,
                        d("span", dF, "4 " + k(u.$t("vacvComponents.filters.starslabel.stars")), 1),
                        ne(k(u.$t("vacvComponents.filters.starslabel.andup")), 1)
                      ])
                    ])
                  ]),
                  d("li", fF, [
                    d("label", mF, [
                      d("div", vF, [
                        ot(d("input", {
                          ref: T(i)[2],
                          class: "formkit-input vacv-custom",
                          type: "radio",
                          name: "frating",
                          id: "starrating-option-3-stars-up",
                          value: "3-5",
                          "onUpdate:modelValue": p[5] || (p[5] = (m) => a.value = m),
                          "data-test": "star-rating-input",
                          onChange: p[6] || (p[6] = (m) => c("3-5"))
                        }, null, 544), [
                          [Cs, a.value]
                        ])
                      ]),
                      d("span", hF, [
                        gF,
                        bF,
                        yF,
                        d("span", $F, "3 " + k(u.$t("vacvComponents.filters.starslabel.stars")), 1),
                        ne(k(u.$t("vacvComponents.filters.starslabel.andup")), 1)
                      ])
                    ])
                  ]),
                  d("li", _F, [
                    d("label", wF, [
                      d("div", CF, [
                        ot(d("input", {
                          ref: T(i)[3],
                          class: "formkit-input vacv-custom",
                          type: "radio",
                          name: "frating",
                          id: "starrating-option-2-stars-up",
                          value: "2-5",
                          "onUpdate:modelValue": p[7] || (p[7] = (m) => a.value = m),
                          "data-test": "star-rating-input",
                          onChange: p[8] || (p[8] = (m) => c("2-5"))
                        }, null, 544), [
                          [Cs, a.value]
                        ])
                      ]),
                      d("span", kF, [
                        SF,
                        TF,
                        d("span", AF, "2 " + k(u.$t("vacvComponents.filters.starslabel.stars")), 1),
                        ne(k(u.$t("vacvComponents.filters.starslabel.andup")), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]);
    };
  }
}), PF = {
  key: 0,
  class: "filter-section deals"
}, IF = { class: "vacv-checkbox" }, EF = /* @__PURE__ */ K({
  __name: "DealsFilter",
  emits: ["change-deals"],
  setup(e, { emit: t }) {
    const n = t, o = so(), { filters: s, selectedFixedFilters: a } = Ce(o), r = R(Mf(s.value)), i = R([]);
    function l(u = []) {
      const p = r.value.map((m) => String(m.value)), f = u.filter((m) => p.includes(m));
      i.value.splice(0, i.value.length, ...f);
    }
    Re(() => {
      const u = a.value.find(
        (f) => f.name === "DEALS"
      ), p = u ? u.selectedIds : [];
      l(p);
    }), le(
      () => s.value,
      (u) => {
        r.value = Mf(u);
        const p = a.value.find(
          (m) => m.name === "DEALS"
        ), f = p ? p.selectedIds : [];
        l(f);
      },
      { deep: !0 }
    ), le(
      () => {
        var u;
        return (u = a.value.find((p) => p.name === "DEALS")) == null ? void 0 : u.selectedIds;
      },
      (u) => {
        l(u || []);
      },
      { deep: !0 }
    ), le(
      i,
      (u) => {
        const p = [...u].sort();
        n("change-deals", p);
      },
      { deep: !0 }
    );
    const c = V(() => r.value);
    return ko(() => {
      i.value = [];
    }), (u, p) => {
      const f = ut("FormKit");
      return c.value.length ? (b(), C("section", PF, [
        d("div", IF, [
          q(f, {
            id: "dealsFilter",
            modelValue: i.value,
            "onUpdate:modelValue": p[0] || (p[0] = (m) => i.value = m),
            name: "deals",
            type: "checkbox",
            label: u.$t("vacvComponents.filters.deals"),
            options: c.value,
            "decorator-icon": T(yo)
          }, null, 8, ["modelValue", "label", "options", "decorator-icon"])
        ])
      ])) : M("", !0);
    };
  }
}), OF = {
  key: 0,
  class: "filter-section destinations"
}, xF = { class: "vacv-checkbox" }, MF = { class: "vacv-checkbox" }, LF = ["aria-expanded"], ga = 5, NF = /* @__PURE__ */ K({
  __name: "DestinationsFilter",
  emits: ["change-destinations"],
  setup(e, { emit: t }) {
    En((v) => ({
      "5e31f37c": g.value
    }));
    const n = t, o = so(), { filters: s, selectedFixedFilters: a, moreDestinationsShow: r } = Ce(o), i = R(hu(s.value)), l = R([]), c = R([]);
    async function u(v = []) {
      const w = i.value.map(
        (A) => String(A.value)
      ), y = v.filter((A) => w.includes(A)), $ = i.value.slice(0, ga).map((A) => String(A.value)), S = i.value.slice(ga).map((A) => String(A.value));
      l.value.splice(
        0,
        l.value.length,
        ...$.filter((A) => y.includes(A))
      ), c.value.splice(
        0,
        c.value.length,
        ...S.filter((A) => y.includes(A))
      );
    }
    Re(() => {
      const v = a.value.find(
        (y) => y.name === "DESTINATION"
      ), w = v ? v.selectedIds : [];
      u(w);
    }), le(
      () => s.value,
      (v) => {
        i.value = hu(v), u();
      },
      { deep: !0 }
    ), le(
      () => {
        var v;
        return (v = a.value.find((w) => w.name === "DESTINATION")) == null ? void 0 : v.selectedIds;
      },
      (v) => {
        u(v || []);
      },
      { deep: !0 }
    ), le(
      [l, c],
      ([v, w]) => {
        const y = v.concat(w);
        n("change-destinations", y);
      },
      { deep: !0 }
    );
    const p = V(
      () => i.value.slice(0, ga)
    ), f = V(
      () => i.value.slice(ga)
    ), m = V(() => i.value.length), h = () => {
      r.value = !r.value;
    }, g = R("0px"), _ = R();
    return le(_, async (v) => {
      v != null && v.scrollHeight && (g.value = v.scrollHeight + "px");
    }), ko(() => {
      l.value = [], c.value = [];
    }), (v, w) => {
      const y = ut("FormKit");
      return m.value > 0 ? (b(), C("section", OF, [
        d("div", xF, [
          q(y, {
            id: "destinationsFilter",
            modelValue: l.value,
            "onUpdate:modelValue": w[0] || (w[0] = ($) => l.value = $),
            name: "destinations",
            type: "checkbox",
            label: v.$t("vacvComponents.filters.destinations"),
            options: p.value,
            "decorator-icon": T(yo)
          }, null, 8, ["modelValue", "label", "options", "decorator-icon"])
        ]),
        q(st, { name: "collapsible" }, {
          default: he(() => [
            T(r) ? (b(), C("div", {
              key: 0,
              id: "destinationsMoreAccordion",
              class: "hotel-accordion-wrapper",
              role: "region",
              "aria-live": "polite",
              ref_key: "scrollHeightDestinationsRef",
              ref: _
            }, [
              d("div", MF, [
                q(y, {
                  id: "destinationsMoreFilter",
                  modelValue: c.value,
                  "onUpdate:modelValue": w[1] || (w[1] = ($) => c.value = $),
                  name: "destinationsMore",
                  type: "checkbox",
                  label: v.$t("vacvComponents.filters.moreDestinations"),
                  options: f.value,
                  "decorator-icon": T(yo)
                }, null, 8, ["modelValue", "label", "options", "decorator-icon"])
              ])
            ], 512)) : M("", !0)
          ]),
          _: 1
        }),
        m.value > ga ? (b(), C("button", {
          key: 0,
          onClick: Ke(h, ["prevent"]),
          type: "button",
          class: "details-link link linklook",
          "aria-expanded": T(r),
          "aria-controls": "destinationsMoreAccordion"
        }, [
          d("i", {
            class: ue(
              "fa-solid " + (T(r) ? "fa-circle-minus" : "fa-circle-plus")
            ),
            "aria-hidden": "true"
          }, null, 2),
          ne(k(T(r) ? v.$t("vacvComponents.filters.showLess") : v.$t("vacvComponents.filters.showMore")), 1)
        ], 8, LF)) : M("", !0)
      ])) : M("", !0);
    };
  }
}), FF = {
  key: 0,
  class: "filter-section amenities"
}, RF = { class: "vacv-checkbox" }, VF = { class: "vacv-checkbox" }, BF = ["aria-expanded"], Or = 5, HF = /* @__PURE__ */ K({
  __name: "AmenitiesFilter",
  emits: ["change-amenities"],
  setup(e, { emit: t }) {
    En((v) => ({
      "1e40ad9f": _.value
    }));
    const n = t, o = so(), { filters: s, selectedFixedFilters: a, moreAmenitiesShow: r } = Ce(o), i = R(Lf(s.value)), l = R([]), c = R([]);
    function u(v = []) {
      const w = i.value.map(
        (A) => String(A.value)
      ), y = v.filter((A) => w.includes(A)), $ = i.value.slice(0, Or).map((A) => String(A.value)), S = i.value.slice(Or).map((A) => String(A.value));
      l.value.splice(
        0,
        l.value.length,
        ...$.filter((A) => y.includes(A))
      ), c.value.splice(
        0,
        c.value.length,
        ...S.filter((A) => y.includes(A))
      );
    }
    Re(() => {
      const v = a.value.find(
        (y) => y.name === "AMENITIES"
      ), w = v ? v.selectedIds : [];
      u(w);
    }), le(
      () => s.value,
      (v) => {
        i.value = Lf(v), u();
      },
      { deep: !0 }
    ), le(
      () => {
        var v;
        return (v = a.value.find((w) => w.name === "AMENITIES")) == null ? void 0 : v.selectedIds;
      },
      (v) => {
        u(v || []);
      },
      { deep: !0 }
    ), le(
      [l, c],
      ([v, w]) => {
        const y = v.concat(w);
        n("change-amenities", y);
      },
      { deep: !0 }
    );
    const p = V(
      () => i.value.slice(0, Or)
    ), f = V(
      () => i.value.slice(Or)
    ), m = () => {
      r.value = !r.value;
    }, h = V(() => i.value.length), g = R("0px"), _ = R();
    return le(_, async (v) => {
      v != null && v.scrollHeight && (g.value = v.scrollHeight + "px");
    }), ko(() => {
      l.value = [], c.value = [];
    }), (v, w) => {
      const y = ut("FormKit");
      return h.value > 0 ? (b(), C("section", FF, [
        d("div", RF, [
          q(y, {
            modelValue: l.value,
            "onUpdate:modelValue": w[0] || (w[0] = ($) => l.value = $),
            name: "amenities",
            type: "checkbox",
            id: "amenitiesFilter",
            label: v.$t("vacvComponents.filters.amenities"),
            options: p.value,
            "decorator-icon": T(yo),
            "data-test": "amenities-input"
          }, null, 8, ["modelValue", "label", "options", "decorator-icon"])
        ]),
        q(st, { name: "collapsible" }, {
          default: he(() => [
            T(r) ? (b(), C("div", {
              key: 0,
              id: "amenitiesMoreAccordion",
              class: "hotel-accordion-wrapper",
              role: "region",
              "aria-live": "polite",
              ref_key: "scrollHeightAmenitiesRef",
              ref: _
            }, [
              d("div", VF, [
                q(y, {
                  modelValue: c.value,
                  "onUpdate:modelValue": w[1] || (w[1] = ($) => c.value = $),
                  id: "amenitiesMoreFilter",
                  name: "amenitiesMore",
                  type: "checkbox",
                  label: v.$t("vacvComponents.filters.moreAmenities"),
                  options: f.value,
                  "decorator-icon": T(yo)
                }, null, 8, ["modelValue", "label", "options", "decorator-icon"])
              ])
            ], 512)) : M("", !0)
          ]),
          _: 1
        }),
        h.value > 5 ? (b(), C("button", {
          key: 0,
          onClick: w[2] || (w[2] = Ke(($) => m(), ["prevent"])),
          type: "button",
          class: "details-link link linklook",
          "aria-expanded": T(r),
          "aria-controls": "amenitiesMoreAccordion",
          id: "amenities-showmore"
        }, [
          d("i", {
            class: ue(
              "fa-solid " + (T(r) ? "fa-circle-minus" : "fa-circle-plus")
            ),
            "aria-hidden": "true"
          }, null, 2),
          ne(" " + k(T(r) ? v.$t("vacvComponents.filters.showLess") : v.$t("vacvComponents.filters.showMore")), 1)
        ], 8, BF)) : M("", !0)
      ])) : M("", !0);
    };
  }
}), UF = {
  key: 0,
  class: "filter-section vacationtype"
}, zF = { class: "vacv-checkbox" }, WF = /* @__PURE__ */ K({
  __name: "VacationTypeFilter",
  emits: ["change-vacation-types"],
  setup(e, { emit: t }) {
    const n = t, o = so(), { filters: s, selectedFixedFilters: a } = Ce(o), r = R(Nf(s.value)), i = V(() => r.value.length), l = R([]);
    async function c(p = []) {
      const f = r.value.map(
        (h) => String(h.value)
      ), m = p.filter((h) => f.includes(h));
      l.value.splice(0, l.value.length, ...m);
    }
    Re(() => {
      const p = a.value.find(
        (m) => m.name === "VACATION_TYPE"
      ), f = p ? p.selectedIds : [];
      c(f);
    }), le(
      () => s.value,
      (p) => {
        r.value = Nf(p);
        const f = a.value.find(
          (h) => h.name === "VACATION_TYPE"
        ), m = f ? f.selectedIds : [];
        c(m);
      },
      { deep: !0 }
    ), le(
      () => {
        var p;
        return (p = a.value.find((f) => f.name === "VACATION_TYPE")) == null ? void 0 : p.selectedIds;
      },
      (p) => {
        c(p || []);
      },
      { deep: !0 }
    ), le(
      l,
      (p) => {
        n("change-vacation-types", p);
      },
      { deep: !0 }
    );
    const u = V(() => r.value);
    return ko(() => {
      l.value = [];
    }), (p, f) => {
      const m = ut("FormKit");
      return i.value > 0 ? (b(), C("section", UF, [
        d("div", zF, [
          q(m, {
            id: "vacationTypeFilter",
            modelValue: l.value,
            "onUpdate:modelValue": f[0] || (f[0] = (h) => l.value = h),
            name: "vacationType",
            type: "checkbox",
            label: p.$t("vacvComponents.filters.vacationType"),
            options: u.value,
            "decorator-icon": T(yo),
            "data-test": "vacation-types-input"
          }, null, 8, ["modelValue", "label", "options", "decorator-icon"])
        ])
      ])) : M("", !0);
    };
  }
}), Zb = () => {
  const e = R(window.innerWidth > 991), n = ip(() => {
    e.value = window.innerWidth > 991;
  }, 100), o = () => {
    window.addEventListener("resize", n);
  }, s = () => {
    window.removeEventListener("resize", n);
  };
  return Re(o), Xu(s), e;
};
function jF(e, t) {
  var n, o, s;
  if (t.deals.length && ds(t.deals, "Deals"), t.rating) {
    const a = t.rating.substring(
      0,
      t.rating.indexOf("-")
    );
    if (a) {
      const r = a + (a === "5" ? "" : " & up");
      ds(r, "Star Rating");
    }
  }
  if (t.destinations.length) {
    const a = [], r = hu(e);
    t.destinations.forEach((i) => {
      const l = r.find(
        (c) => c.value === i
      );
      l && a.push(l.label);
    }), ds(a, "Destinations");
  }
  (n = t.amenities) != null && n.length && ds(t.amenities, "Amenities"), (o = t.vacationType) != null && o.length && ds(t.vacationType, "Vacation Type"), (s = t.priceRange) != null && s.length && ds(
    eb(t.priceRange),
    "Price Range"
  );
}
function ds(e, t) {
  const n = {
    event: "plpFilters",
    filterName: t,
    filterValue: Array.isArray(e) ? e.join(",") : e
  };
  window.dataLayer.push(n);
}
const qF = { class: "spa-aside-wrapper" }, KF = {
  id: "filter-title",
  class: "sr-only"
}, YF = ["aria-label"], GF = { class: "filter-section pricerange" }, ZF = { class: "vacv-label-sm" }, XF = {
  key: 0,
  class: "vacv-error",
  "aria-live": "polite"
}, JF = {
  type: "submit",
  class: "vacv-btn-secondary"
}, yie = /* @__PURE__ */ K({
  __name: "PlpFilter",
  props: {
    openFilter: { type: Boolean },
    priceRangeTitle: {},
    maxPriceRange: { default: 5e3 },
    unlimitedPriceRange: { default: 1e6 }
  },
  emits: ["apply-filters", "close-filter"],
  setup(e, { emit: t }) {
    const n = e, { t: o } = Ne({ useScope: "global" }), s = n.priceRangeTitle ? n.priceRangeTitle : o("vacvComponents.filters.rangeSlider"), a = so(), {
      updateSelectedRangeFilters: r,
      updateSelectedFixedFilters: i,
      resetFilters: l,
      filters: c
    } = a, { hasPreviouslyAppliedFilters: u } = Ce(a), p = Zb(), f = R(), m = R(), h = R([]), g = R([]), _ = R([]), v = R([]), w = R(""), y = [0, n.maxPriceRange], $ = R(y), S = R(), A = R(!1), I = R(!1);
    function D() {
      return {
        destinations: g.value,
        rating: w.value,
        amenities: _.value,
        vacationType: v.value,
        priceRange: $.value,
        deals: h.value
      };
    }
    const O = t;
    function x() {
      const { selectedRangeFilters: J, selectedFixedFilters: ae } = a, re = J.find((Be) => Be.name === "PRICE");
      re && ($.value = [
        re.selectedLow,
        re.selectedHigh
      ]);
      const ge = J.find((Be) => Be.name === "RATING");
      ge && (ge.selectedLow > 0 || ge.selectedHigh < 5) && (w.value = `${ge.selectedLow}-${ge.selectedHigh}`);
      const Ie = ae.find((Be) => Be.name === "DEALS");
      Ie && (h.value = [...Ie.selectedIds]);
      const je = ae.find(
        (Be) => Be.name === "DESTINATION"
      );
      je && (g.value = [...je.selectedIds]);
      const Ve = ae.find(
        (Be) => Be.name === "AMENITIES"
      );
      Ve && (_.value = [...Ve.selectedIds]);
      const Ue = ae.find(
        (Be) => Be.name === "VACATION_TYPE"
      );
      Ue && (v.value = [...Ue.selectedIds]), P();
    }
    const F = (J) => J.destinations.length > 0 || J.rating.length > 0 || J.amenities.length > 0 || J.vacationType.length > 0 || J.deals.length > 0 || J.priceRange.length === 2 && (J.priceRange[0] !== 0 || J.priceRange[1] !== n.maxPriceRange), P = () => {
      const J = D(), ae = F(J);
      u.value ? E(!0) : E(ae), I.value = !1;
    }, E = (J) => {
      p.value || (document.body.style.overflow = J ? "hidden" : "", document.body.style.height = J ? "100%" : ""), A.value = J;
    };
    function B(J) {
      var ge, Ie, je, Ve;
      const ae = D();
      N();
      const re = {};
      (ge = ae.destinations) != null && ge.length && (re.fdest = ae.destinations.join(",")), ae.rating && ae.rating !== "0-5" && (re.frating = ae.rating), (Ie = ae.amenities) != null && Ie.length && (re.famenities = ae.amenities.join(",")), (je = ae.vacationType) != null && je.length && (re.fVacationType = ae.vacationType.join(",")), (Ve = ae.deals) != null && Ve.length && (re.fdeal = ae.deals.join(",")), ae.priceRange && (re.fprice = eb(
        ae.priceRange,
        n.maxPriceRange,
        n.unlimitedPriceRange
      )), O("apply-filters", re, J);
    }
    function N() {
      if (r(
        "PRICE",
        $.value[0],
        $.value[1]
      ), w.value) {
        const [J, ae] = w.value.split("-").map(Number);
        r("RATING", J, ae);
      } else
        r("RATING", 0, 5);
      i("DESTINATION", g.value), i("AMENITIES", _.value), i("DEALS", h.value), i("VACATION_TYPE", v.value);
    }
    function Y(J, ae) {
      c && jF(c, J), te(), B(ae), u.value = !0;
    }
    function j(J) {
      p.value ? u.value ? (B(J), u.value = !1) : I.value = !0 : (te(), B(J));
    }
    const ee = () => {
      const J = D(), ae = F(J);
      E(!1), ae ? Y(J, ae) : j(ae);
    };
    function te() {
      I.value = !1, p.value || O("close-filter");
    }
    const ce = (J) => {
      yi(J, ["spa-col-aside", "btn-close"]) && (window.removeEventListener("mousedown", ce), window.removeEventListener("touchstart", ce), te());
    }, H = () => {
      if (!p.value) {
        window.addEventListener("mousedown", ce), window.addEventListener("touchstart", ce);
        const J = D(), ae = F(J);
        u.value ? E(!1) : E(ae), I.value = !1, setTimeout(() => {
          f.value && (f.value.tabIndex = 1), m.value && m.value.focus();
        }, 100);
      }
    }, oe = () => {
      p.value || (I.value = !1, E(!1), window.removeEventListener("mousedown", ce), window.removeEventListener("touchstart", ce));
    };
    le(
      () => n.openFilter,
      (J) => {
        J ? H() : oe();
      }
    );
    const U = R("0px"), Q = R();
    le(Q, async (J) => {
      J != null && J.scrollHeight && (U.value = J.scrollHeight + "px");
    });
    const z = async () => {
      g.value = [], h.value = [], _.value = [], v.value = [], w.value = "", $.value = y, l(), P(), ee();
    }, Z = (J) => {
      $.value = J, P();
    }, W = (J) => {
      w.value = J, P();
    }, X = (J) => {
      h.value = J, P();
    }, G = (J) => {
      g.value = J, P();
    }, se = (J) => {
      _.value = J, P();
    }, pe = (J) => {
      v.value = J, P();
    };
    return Re(() => {
      x();
    }), (J, ae) => {
      const re = ut("FormKit");
      return T(c) ? (b(), C("aside", {
        key: 0,
        ref_key: "filterPanelRef",
        ref: f,
        id: "mobile-filter-panel",
        class: ue({
          "col-md-3": !0,
          "spa-col-aside": !0,
          open: n.openFilter,
          sticky: A.value
        }),
        "aria-live": "polite",
        "aria-labelledby": "filter-title"
      }, [
        d("div", qF, [
          d("h2", KF, k(J.$t("vacvComponents.filters.filterBy")), 1),
          q(re, {
            ref_key: "formRef",
            ref: S,
            id: "filter-form",
            type: "form",
            actions: !1,
            onSubmit: ee,
            novalidate: ""
          }, {
            default: he(() => [
              d("button", {
                ref_key: "mobileCloseButtonRef",
                ref: m,
                onClick: Ke(te, ["prevent"]),
                "data-test": "closeButton",
                class: "btn-close mobile-only",
                "aria-label": J.$t("vacvComponents.common.buttons.close"),
                "aria-expanded": "true",
                "aria-controls": "mobile-filter-panel"
              }, null, 8, YF),
              q(UN, {
                "max-price-range": J.maxPriceRange,
                onClearFilters: z
              }, null, 8, ["max-price-range"]),
              d("section", GF, [
                d("div", ZF, k(T(s)), 1),
                q(WN, { onChangePriceRange: Z })
              ]),
              q(EF, { onChangeDeals: X }),
              q(DF, { onChangeRating: W }),
              q(NF, { onChangeDestinations: G }),
              q(HF, { onChangeAmenities: se }),
              q(WF, { onChangeVacationTypes: pe }),
              d("div", {
                class: ue(A.value ? "filter-apply sticky" : "filter-apply")
              }, [
                I.value ? (b(), C("div", XF, k(J.$t("vacvComponents.filters.error")), 1)) : M("", !0),
                d("button", JF, k(J.$t("vacvComponents.filters.applyButton")), 1)
              ], 2)
            ]),
            _: 1
          }, 512)
        ])
      ], 2)) : M("", !0);
    };
  }
}), Xb = St("UX", () => {
  const e = R(), t = tt({
    PDPSectionInView: "rooms"
  });
  return {
    PDP: t,
    setPDPSectionDisplayed: (o, s) => {
      s ? (e.value = s, t.PDPSectionInView = o ?? "rooms", setTimeout(() => {
        e.value = !1;
      }, 1500)) : e.value || (t.PDPSectionInView = o);
    }
  };
});
function aa() {
  const { setPDPSectionDisplayed: e } = Xb(), t = R();
  return {
    onIntersectionObserver: ([{ isIntersecting: o }]) => {
      o && lp(() => {
        t.value && e(t.value.id);
      }, 500);
    },
    section: t
  };
}
const QF = { "data-test": "pdp-hotel-overview-section-title" }, eR = {
  key: 0,
  class: "sub-section"
}, tR = ["innerHTML"], nR = { class: "spa-list details-2col" }, oR = { key: 0 }, sR = { key: 1 }, aR = { key: 2 }, rR = { key: 3 }, iR = { key: 4 }, lR = { key: 5 }, cR = {
  key: 1,
  class: "sub-section"
}, uR = {
  class: "spa-list details-2col",
  id: "subsection-details-list"
}, pR = ["id"], dR = ["id"], fR = {
  key: 2,
  class: "sub-section"
}, mR = {
  class: "spa-list details-2col",
  id: "subsection-details-list-other-services"
}, vR = ["id"], $ie = /* @__PURE__ */ K({
  __name: "PdpOverview",
  props: {
    overview: {},
    inclusions: {},
    lang: {}
  },
  setup(e) {
    const { onIntersectionObserver: t, section: n } = aa();
    return (o, s) => {
      var a, r, i, l;
      return b(), C("section", {
        id: "overview",
        class: "pdp-section overview",
        ref_key: "section",
        ref: n
      }, [
        ot((b(), C("h2", QF, [
          ne(k(o.$t("vacvComponents.productDetails.overview.title")), 1)
        ])), [
          [T(as), [T(t), { section: T(n) }]]
        ]),
        o.overview.description ? (b(), C("div", eR, [
          d("div", {
            class: "text vacv-editor",
            innerHTML: o.overview.description
          }, null, 8, tR),
          d("ul", nR, [
            o.overview.checkIn ? (b(), C("li", oR, [
              d("span", null, k(o.$t("vacvComponents.productDetails.overview.checkin")), 1),
              ne(" " + k(T(Of)(o.lang, o.overview.checkIn)), 1)
            ])) : M("", !0),
            o.overview.checkOut ? (b(), C("li", sR, [
              d("span", null, k(o.$t("vacvComponents.productDetails.overview.checkout")), 1),
              ne(" " + k(T(Of)(o.lang, o.overview.checkOut)), 1)
            ])) : M("", !0),
            o.overview.numBars ? (b(), C("li", aR, [
              d("span", null, k(o.$t("vacvComponents.productDetails.overview.numberBars")), 1),
              ne(" " + k(o.overview.numBars), 1)
            ])) : M("", !0),
            o.overview.numRestaurants ? (b(), C("li", rR, [
              d("span", null, k(o.$t("vacvComponents.productDetails.overview.numberRestaurants")), 1),
              ne(" " + k(o.overview.numRestaurants), 1)
            ])) : M("", !0),
            o.overview.numRooms ? (b(), C("li", iR, [
              d("span", null, k(o.$t("vacvComponents.productDetails.overview.numberRooms")), 1),
              ne(" " + k(o.overview.numRooms), 1)
            ])) : M("", !0),
            o.overview.numOutdoorPools ? (b(), C("li", lR, [
              d("span", null, k(o.$t("vacvComponents.productDetails.overview.numberPoolsOutdoor")), 1),
              ne(" " + k(o.overview.numOutdoorPools), 1)
            ])) : M("", !0)
          ])
        ])) : M("", !0),
        (a = o.overview.hotelLevelInclusions) != null && a.length || (i = (r = o.inclusions) == null ? void 0 : r.activitiesInclusions) != null && i.length ? (b(), C("div", cR, [
          d("h3", null, k(o.$t("vacvComponents.productDetails.overview.inclusions")), 1),
          d("ul", uR, [
            (b(!0), C($e, null, ke(o.overview.hotelLevelInclusions, (c, u) => (b(), C("li", {
              key: u,
              id: "pdp-hotel-inclusion-item-" + u
            }, k(c), 9, pR))), 128)),
            (b(!0), C($e, null, ke((l = o.inclusions) == null ? void 0 : l.activitiesInclusions, (c, u) => (b(), C("li", {
              key: u,
              id: "pdp-hotel-inclusion-item-" + u
            }, k(c), 9, dR))), 128))
          ])
        ])) : M("", !0),
        o.overview.otherServicesAtACharge && o.overview.otherServicesAtACharge.length ? (b(), C("div", fR, [
          d("h3", null, k(o.$t("vacvComponents.productDetails.overview.otherServices")), 1),
          d("ul", mR, [
            (b(!0), C($e, null, ke(o.overview.otherServicesAtACharge, (c, u) => (b(), C("li", {
              key: u,
              id: "pdp-hotel-other-services-item-" + u
            }, k(c), 9, vR))), 128))
          ])
        ])) : M("", !0)
      ], 512);
    };
  }
}), hR = { "data-test": "pdp-hotel-importantinfo-section-title" }, gR = { key: 0 }, bR = ["innerHTML"], yR = /* @__PURE__ */ K({
  __name: "PdpImportantInformation",
  props: {
    hints: {}
  },
  setup(e) {
    const { onIntersectionObserver: t, section: n } = aa();
    return (o, s) => (b(), C("section", {
      id: "importantInformation",
      class: "pdp-section importantinfo",
      ref_key: "section",
      ref: n
    }, [
      ot((b(), C("h2", hR, [
        ne(k(o.$t("vacvComponents.productDetails.important.title")), 1)
      ])), [
        [T(as), [T(t), { section: T(n) }]]
      ]),
      (b(!0), C($e, null, ke(o.hints, (a, r) => (b(), C("div", {
        key: r,
        class: "sub-section"
      }, [
        a.title ? (b(), C("h3", gR, k(a.title), 1)) : M("", !0),
        a.description ? (b(), C("div", {
          key: 1,
          class: "text vacv-editor",
          innerHTML: a.description
        }, null, 8, bR)) : M("", !0)
      ]))), 128))
    ], 512));
  }
});
var $R = { exports: {} };
(function(e) {
  (function(t, n) {
    e.exports ? e.exports = n(No) : n(t.L);
  })(typeof self < "u" ? self : gu, (t) => {
    if (typeof document > "u")
      return console.warn('"window.document" is undefined; leaflet.fullscreen requires this object to access the DOM'), !1;
    const n = (() => {
      const a = [
        // Standard
        [
          "requestFullscreen",
          "exitFullscreen",
          "fullscreenElement",
          "fullscreenEnabled",
          "fullscreenchange",
          "fullscreenerror"
        ],
        // New WebKit
        [
          "webkitRequestFullscreen",
          "webkitExitFullscreen",
          "webkitFullscreenElement",
          "webkitFullscreenEnabled",
          "webkitfullscreenchange",
          "webkitfullscreenerror"
        ]
      ], r = a[0], i = {};
      for (const l of a)
        if (l[1] in document) {
          for (let c = 0; c < l.length; c++)
            i[r[c]] = l[c];
          return i;
        }
      return !1;
    })(), o = {
      change: n.fullscreenchange,
      error: n.fullscreenerror
    }, s = {
      request(a, r) {
        return new Promise((i, l) => {
          const c = (function() {
            this.off("change", c), i();
          }).bind(this);
          this.on("change", c), a = a || document.documentElement;
          const u = a[n.requestFullscreen](r);
          u instanceof Promise && u.then(c).catch(l);
        });
      },
      exit() {
        return new Promise((a, r) => {
          if (!this.isFullscreen) {
            a();
            return;
          }
          const i = (function() {
            this.off("change", i), a();
          }).bind(this);
          this.on("change", i);
          const l = document[n.exitFullscreen]();
          l instanceof Promise && l.then(i).catch(r);
        });
      },
      on(a, r) {
        const i = o[a];
        i && document.addEventListener(i, r, !1);
      },
      off(a, r) {
        const i = o[a];
        i && document.removeEventListener(i, r, !1);
      },
      nativeAPI: n
    };
    return Object.defineProperties(s, {
      isFullscreen: {
        get() {
          return !!document[n.fullscreenElement];
        }
      },
      isEnabled: {
        enumerable: !0,
        get() {
          return !!document[n.fullscreenEnabled];
        }
      }
    }), t.Control.FullScreen = t.Control.extend({
      options: {
        position: "topleft",
        title: "Full Screen",
        titleCancel: "Exit Full Screen",
        forceSeparateButton: !1,
        forcePseudoFullscreen: !1,
        fullscreenElement: !1
      },
      _screenfull: s,
      onAdd(a) {
        let r = "leaflet-control-zoom-fullscreen", i, l = "";
        return a.zoomControl && !this.options.forceSeparateButton ? i = a.zoomControl._container : i = t.DomUtil.create("div", "leaflet-bar"), this.options.content ? l = this.options.content : r += " fullscreen-icon", this._createButton(this.options.title, r, l, i, this.toggleFullScreen, this), this._map.fullscreenControl = this, this._map.on("enterFullscreen exitFullscreen", this._toggleState, this), i;
      },
      onRemove() {
        t.DomEvent.off(this.link, "click", t.DomEvent.stop).off(this.link, "click", this.toggleFullScreen, this), this._screenfull.isEnabled && (t.DomEvent.off(this._container, this._screenfull.nativeAPI.fullscreenchange, t.DomEvent.stop).off(this._container, this._screenfull.nativeAPI.fullscreenchange, this._handleFullscreenChange, this), t.DomEvent.off(document, this._screenfull.nativeAPI.fullscreenchange, t.DomEvent.stop).off(document, this._screenfull.nativeAPI.fullscreenchange, this._handleFullscreenChange, this));
      },
      _createButton(a, r, i, l, c, u) {
        return this.link = t.DomUtil.create("a", r, l), this.link.href = "#", this.link.title = a, this.link.innerHTML = i, this.link.setAttribute("role", "button"), this.link.setAttribute("aria-label", a), L.DomEvent.disableClickPropagation(l), t.DomEvent.on(this.link, "click", t.DomEvent.stop).on(this.link, "click", c, u), this._screenfull.isEnabled && (t.DomEvent.on(l, this._screenfull.nativeAPI.fullscreenchange, t.DomEvent.stop).on(l, this._screenfull.nativeAPI.fullscreenchange, this._handleFullscreenChange, u), t.DomEvent.on(document, this._screenfull.nativeAPI.fullscreenchange, t.DomEvent.stop).on(document, this._screenfull.nativeAPI.fullscreenchange, this._handleFullscreenChange, u)), this.link;
      },
      toggleFullScreen() {
        const a = this._map;
        a._exitFired = !1, a._isFullscreen ? (this._screenfull.isEnabled && !this.options.forcePseudoFullscreen ? this._screenfull.exit().then(() => a.invalidateSize()) : (t.DomUtil.removeClass(this.options.fullscreenElement ? this.options.fullscreenElement : a._container, "leaflet-pseudo-fullscreen"), a.invalidateSize()), a.fire("exitFullscreen"), a._exitFired = !0, a._isFullscreen = !1) : (this._screenfull.isEnabled && !this.options.forcePseudoFullscreen ? this._screenfull.request(this.options.fullscreenElement ? this.options.fullscreenElement : a._container).then(() => a.invalidateSize()) : (t.DomUtil.addClass(this.options.fullscreenElement ? this.options.fullscreenElement : a._container, "leaflet-pseudo-fullscreen"), a.invalidateSize()), a.fire("enterFullscreen"), a._isFullscreen = !0);
      },
      _toggleState() {
        this.link.title = this._map._isFullscreen ? this.options.title : this.options.titleCancel, this._map._isFullscreen ? L.DomUtil.removeClass(this.link, "leaflet-fullscreen-on") : L.DomUtil.addClass(this.link, "leaflet-fullscreen-on");
      },
      _handleFullscreenChange(a) {
        const r = this._map;
        a.target === r.getContainer() && !this._screenfull.isFullscreen && !r._exitFired && (this._screenfull.exit().then(() => r.invalidateSize()), r.fire("exitFullscreen"), r._exitFired = !0, r._isFullscreen = !1);
      }
    }), t.Map.include({
      toggleFullscreen() {
        this.fullscreenControl.toggleFullScreen();
      }
    }), t.Map.addInitHook(function() {
      this.options.fullscreenControl && this.addControl(t.control.fullscreen(this.options.fullscreenControlOptions));
    }), t.control.fullscreen = function(a) {
      return new t.Control.FullScreen(a);
    }, { leaflet: t };
  });
})($R);
function Cc(e, t, n) {
  const o = {
    event: "pdpRoomTileLinks",
    roomLinkName: e,
    roomMealPlan: t,
    roomHotelName: n
  };
  window.dataLayer.push(o);
}
function _R(e, t, n) {
  const o = Hb(t, "Room"), s = FO(n), a = {
    event: "pdpSelect",
    roomPosition: e,
    roomPsychTrigger: o,
    roomPriceDifference: s
  };
  window.dataLayer.push(a);
}
function Jb(e, t) {
  const n = {
    event: "pdpMaps",
    mapsHotelName: e,
    mapsDestination: t
  };
  window.dataLayer.push(n);
}
function wR(e) {
  const t = {
    event: "pdpRoomNav",
    roomNavName: e
  };
  window.dataLayer.push(t);
}
const CR = { class: "map-height" }, ym = 48, kR = 14, SR = /* @__PURE__ */ K({
  __name: "VacationsMap",
  props: {
    cdnBaseUrl: {},
    hotel: {}
  },
  setup(e) {
    var h, g;
    const t = e, { t: n } = Ne({ useScope: "global" });
    let o;
    const s = R(), a = R(!0), r = No.icon({
      iconUrl: `${t.cdnBaseUrl}/img/icon-location-48.png`,
      iconRetinaUrl: `${t.cdnBaseUrl}/img/icon-location-96.png`,
      iconSize: [ym, ym]
    }), i = parseFloat((h = t.hotel.location) == null ? void 0 : h.latitude), l = parseFloat((g = t.hotel.location) == null ? void 0 : g.longitude), c = [i, l], u = No.marker(c, { icon: r });
    u.bindPopup(
      `<div style="text-align: center;">
      <h4>${t.hotel.name}</h4>
    </div>`
    );
    function p(_) {
      const v = No.map(_, { zoomControl: !1 }).setView(
        c,
        kR
      );
      v.on("enterFullscreen", function() {
        t.hotel.name && t.hotel.destination && Jb(t.hotel.name, t.hotel.destination);
      }), No.control.fullscreen({
        position: "topleft",
        // change the position of the button can be topleft, topright, bottomright or bottomleft, default topleft
        title: n("vacvComponents.productDetails.map.enter-full-screen"),
        // change the title of the button, default Full Screen
        titleCancel: n("vacvComponents.productDetails.map.exit-full-screen"),
        // change the title of the button when fullscreen is on, default Exit Full Screen
        content: null,
        // change the content of the button, can be HTML, default null
        forceSeparateButton: !0,
        // force separate button to detach from zoom buttons, default false
        forcePseudoFullscreen: !0,
        // force use of pseudo full screen even if full screen API is available, default false
        fullscreenElement: !1
        // Dom element to render in full screen, false by default, fallback to map._container
      }).addTo(v), No.control.zoom({
        zoomInText: '<span aria-hidden="true">+</span>',
        zoomInTitle: n("vacvComponents.productDetails.map.zoom-in"),
        zoomOutText: '<span aria-hidden="true">&#x2212;</span>',
        zoomOutTitle: n("vacvComponents.productDetails.map.zoom-out")
      }).addTo(v), No.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
      }).addTo(v), u.addTo(v);
      const w = v.getContainer();
      if (w) {
        const y = w.querySelector(
          ".leaflet-attribution-flag"
        );
        y && y.remove();
      }
      return v;
    }
    function f() {
      o && (o.remove(), o = void 0);
    }
    const m = new IntersectionObserver(
      function(_) {
        _[0].isIntersecting === !0 && s.value ? (f(), o = p(s.value)) : f();
      },
      { threshold: [0.9] }
    );
    return Re(() => {
      s.value && m.observe(s.value);
    }), Jt(() => {
      m.disconnect(), f();
    }), (_, v) => (b(), ie(st, { name: "slide" }, {
      default: he(() => [
        ot(d("div", CR, [
          v[0] || (pi(-1), (v[0] = d("div", {
            class: "map-height",
            ref_key: "mapElement",
            ref: s
          }, null, 512)).cacheIndex = 0, pi(1), v[0])
        ], 512), [
          [Ds, a.value]
        ])
      ]),
      _: 1
    }));
  }
}), TR = /* @__PURE__ */ De(SR, [["__scopeId", "data-v-fc381d64"]]), AR = { "data-test": "pdp-hotel-location-section-title" }, DR = {
  key: 1,
  class: "sub-section"
}, PR = {
  class: "text",
  "data-test": "hotel-address"
}, IR = /* @__PURE__ */ d("i", { class: "fa-solid fa-location-dot" }, null, -1), ER = {
  key: 2,
  class: "spa-list special-list details-2col"
}, OR = { key: 0 }, xR = { key: 1 }, MR = {
  key: 3,
  class: "spa-list special-list details-2col"
}, LR = ["id"], _ie = /* @__PURE__ */ K({
  __name: "PdpLocation",
  props: {
    cdnBaseUrl: {}
  },
  setup(e) {
    const t = Ye("hotel"), { onIntersectionObserver: n, section: o } = aa();
    return (s, a) => {
      var r, i, l, c, u, p;
      return b(), C("section", {
        id: "location",
        class: "pdp-section location",
        ref_key: "section",
        ref: o
      }, [
        ot((b(), C("h2", AR, [
          ne(k(s.$t("vacvComponents.productDetails.labels.hotel.location.title")), 1)
        ])), [
          [T(as), [T(n), { section: T(o) }]]
        ]),
        (r = T(t).location) != null && r.latitude && ((i = T(t).location) != null && i.longitude) ? (b(), ie(TR, {
          key: 0,
          hotel: T(t),
          cdnBaseUrl: s.cdnBaseUrl,
          "data-test": "pdp-hotel-location-map"
        }, null, 8, ["hotel", "cdnBaseUrl"])) : M("", !0),
        (l = T(t).location) != null && l.address ? (b(), C("div", DR, [
          d("div", PR, [
            IR,
            ne(k(T(t).location.address), 1)
          ])
        ])) : M("", !0),
        (c = T(t).location) != null && c.kmToAirport && T(t).location.kmToAirport !== "" || (u = T(t).location) != null && u.specificLocation && T(t).location.specificLocation !== "" ? (b(), C("ul", ER, [
          T(t).location.kmToAirport && T(t).location.kmToAirport !== "" ? (b(), C("li", OR, k(T(t).location.kmToAirport), 1)) : M("", !0),
          T(t).location.specificLocation && T(t).location.specificLocation !== "" ? (b(), C("li", xR, k(T(t).location.specificLocation), 1)) : M("", !0)
        ])) : M("", !0),
        (p = T(t).location) != null && p.distancePointOfInterests && T(t).location.distancePointOfInterests.length ? (b(), C("ul", MR, [
          (b(!0), C($e, null, ke(T(t).location.distancePointOfInterests, (f, m) => (b(), C("li", {
            key: m,
            id: "pdp-hotel-inclusion-item-" + m,
            "data-test": "POI"
          }, k(f), 9, LR))), 128))
        ])) : M("", !0)
      ], 512);
    };
  }
}), NR = { class: "toggletext" }, Qb = /* @__PURE__ */ K({
  __name: "ExpandableButton",
  props: {
    isExpanded: { type: Boolean },
    showText: {},
    hideText: {}
  },
  emits: ["toggle-learn-more"],
  setup(e, { emit: t }) {
    const n = t, o = () => {
      n("toggle-learn-more");
    };
    return (s, a) => (b(), C("button", {
      class: "details-link link linklook",
      onClick: o
    }, [
      d("span", NR, [
        d("i", {
          class: ue(
            "fa-solid " + (s.isExpanded ? "fa-circle-minus" : "fa-circle-plus")
          ),
          "aria-hidden": "true"
        }, null, 2),
        ne(" " + k(s.isExpanded ? s.hideText : s.showText), 1)
      ])
    ]));
  }
});
function ey(e) {
  const t = e + "px", n = R(!1), o = R(!1), s = R(), a = R("0px"), r = () => {
    o.value = !o.value;
  };
  Re(() => {
    var c;
    const l = (c = s.value) == null ? void 0 : c.clientHeight;
    l && l > e && (n.value = !0, a.value = `${l}px`), o.value = !1;
  });
  const i = V(() => {
    const l = "spa-list-expandwrap", c = o.value ? " expanded" : " rolledup";
    return `${l}${n.value ? c : ""}`;
  });
  return {
    toggleLearnMore: r,
    expandableContent: s,
    isExpandable: n,
    isExpanded: o,
    expandedHeight: a,
    defaultRollupHeightPX: t,
    expandableContentClass: i
  };
}
const FR = { class: "sub-section" }, RR = { class: "sub-row" }, VR = {
  key: 0,
  class: "vacv-collection-icon"
}, BR = ["src"], HR = {
  key: 0,
  class: "mobile-only h3style"
}, UR = { class: "sub-content" }, zR = { key: 0 }, WR = ["innerHTML"], jR = 100, qR = /* @__PURE__ */ K({
  __name: "PdpBestForItem",
  props: {
    collection: {}
  },
  setup(e) {
    En((p) => ({
      "016857ba": T(i),
      "7ffbf985": T(r)
    }));
    const t = e, {
      toggleLearnMore: n,
      expandableContent: o,
      isExpandable: s,
      isExpanded: a,
      expandedHeight: r,
      defaultRollupHeightPX: i,
      expandableContentClass: l
    } = ey(jR), c = V(
      () => {
        var p, f;
        return ((f = (p = t.collection) == null ? void 0 : p.description) == null ? void 0 : f.filter(Boolean)) || [];
      }
    ), u = V(() => c.value.length > 1);
    return (p, f) => (b(), C("div", FR, [
      d("div", RR, [
        p.collection.icon ? (b(), C("div", VR, [
          d("img", {
            alt: "",
            src: p.collection.icon,
            "aria-hidden": "true"
          }, null, 8, BR),
          p.collection.title ? (b(), C("div", HR, k(p.collection.title), 1)) : M("", !0)
        ])) : M("", !0),
        d("div", UR, [
          p.collection.title ? (b(), C("h3", zR, k(p.collection.title), 1)) : M("", !0),
          c.value.length ? (b(), C("div", {
            key: 1,
            ref_key: "expandableContent",
            ref: o,
            class: ue(T(l))
          }, [
            d("ul", {
              class: ue(u.value ? "spa-list special-list" : "spa-list")
            }, [
              (b(!0), C($e, null, ke(c.value, (m) => (b(), C("li", {
                key: m,
                class: "spa-list-item vacv-editor",
                innerHTML: m
              }, null, 8, WR))), 128))
            ], 2)
          ], 2)) : M("", !0),
          T(s) ? (b(), ie(Qb, {
            key: 2,
            "is-expanded": T(a),
            "show-text": p.$t("vacvComponents.productDetails.bestFor.learnMore"),
            "hide-text": p.$t("vacvComponents.productDetails.bestFor.hideDetails"),
            onToggleLearnMore: T(n)
          }, null, 8, ["is-expanded", "show-text", "hide-text", "onToggleLearnMore"])) : M("", !0)
        ])
      ])
    ]));
  }
}), KR = /* @__PURE__ */ De(qR, [["__scopeId", "data-v-b75229b8"]]), YR = { "data-test": "pdp-hotel-best-for-section-title" }, wie = /* @__PURE__ */ K({
  __name: "PdpBestFor",
  props: {
    bestFor: {}
  },
  setup(e) {
    const { onIntersectionObserver: t, section: n } = aa();
    return (o, s) => (b(), C("section", {
      id: "bestFor",
      class: "pdp-section bestfor",
      ref_key: "section",
      ref: n
    }, [
      ot((b(), C("h2", YR, [
        ne(k(o.$t("vacvComponents.productDetails.bestFor.title")), 1)
      ])), [
        [T(as), [T(t), { section: T(n) }]]
      ]),
      (b(!0), C($e, null, ke(o.bestFor, (a, r) => (b(), ie(KR, {
        key: r,
        collection: a
      }, null, 8, ["collection"]))), 128))
    ], 512));
  }
}), GR = { key: 0 }, ZR = { key: 0 }, XR = ["innerHTML"], JR = {
  key: 2,
  class: "terms"
}, QR = ["id"], eV = { class: "h4style" }, tV = ["innerHTML"], nV = ["aria-expanded", "aria-controls"], oV = { class: "toggletext" }, sV = /* @__PURE__ */ K({
  __name: "OffersItem",
  props: {
    promotion: {},
    index: {}
  },
  setup(e) {
    En((l) => ({
      "3ca41dec": o.value
    }));
    const { t } = Ne({ useScope: "global" }), n = R(!1), o = R("0px"), s = R(null);
    le(s, (l) => {
      l != null && l.scrollHeight && (o.value = l.scrollHeight + "px");
    });
    const a = () => {
      n.value = !n.value;
    }, r = V(
      () => `fa-solid ${n.value ? "fa-circle-minus" : "fa-circle-plus"}`
    ), i = V(
      () => n.value ? t("vacvComponents.productDetails.offers.showLess") : t("vacvComponents.productDetails.offers.terms")
    );
    return (l, c) => {
      var u, p, f;
      return (u = l.promotion) != null && u.title || (p = l.promotion) != null && p.description || (f = l.promotion) != null && f.termsAndConditions ? (b(), C("div", GR, [
        l.promotion.title ? (b(), C("h3", ZR, k(l.promotion.title), 1)) : M("", !0),
        l.promotion.description ? (b(), C("div", {
          key: 1,
          class: "text vacv-editor",
          innerHTML: l.promotion.description,
          "data-test": "description"
        }, null, 8, XR)) : M("", !0),
        l.promotion.termsAndConditions ? (b(), C("div", JR, [
          q(st, { name: "collapsible" }, {
            default: he(() => [
              n.value ? (b(), C("section", {
                key: 0,
                id: `offersTermsAccordion-${l.index}`,
                class: ue(["hotel-accordion-wrapper mini", { open: n.value }]),
                "aria-live": "polite",
                "aria-label": "Terms & Conditions",
                ref_key: "scrollHeightRef",
                ref: s
              }, [
                d("div", eV, k(l.$t("vacvComponents.productDetails.offers.terms")), 1),
                d("div", {
                  class: "text vacv-editor",
                  innerHTML: l.promotion.termsAndConditions,
                  "data-test": "termsAndConditions"
                }, null, 8, tV)
              ], 10, QR)) : M("", !0)
            ]),
            _: 1
          }),
          d("button", {
            class: "details-link link linklook",
            "aria-expanded": n.value,
            "aria-controls": `offersTermsAccordion-${l.index}`,
            onClick: a
          }, [
            d("span", oV, [
              d("i", {
                class: ue(r.value),
                "aria-hidden": "true"
              }, null, 2),
              ne(" " + k(i.value), 1)
            ])
          ], 8, nV)
        ])) : M("", !0)
      ])) : M("", !0);
    };
  }
}), Cie = /* @__PURE__ */ K({
  __name: "Offers",
  props: {
    promotions: {}
  },
  setup(e) {
    const { onIntersectionObserver: t, section: n } = aa();
    return (o, s) => (b(), C("section", {
      id: "offers",
      class: "pdp-section offers",
      ref_key: "section",
      ref: n
    }, [
      ot((b(), C("h2", null, [
        ne(k(o.$t("vacvComponents.productDetails.offers.title")), 1)
      ])), [
        [T(as), [T(t), { section: T(n) }]]
      ]),
      (b(!0), C($e, null, ke(o.promotions, (a, r) => (b(), C("div", {
        key: r,
        class: "sub-section"
      }, [
        q(sV, {
          promotion: a,
          index: r
        }, null, 8, ["promotion", "index"])
      ]))), 128))
    ], 512));
  }
}), aV = {
  key: 0,
  class: "sub-content"
}, rV = { class: "h3style" }, iV = {
  key: 0,
  class: "description"
}, lV = { class: "spa-list special-list" }, cV = { class: "restaurant-name" }, uV = {
  key: 0,
  class: "restaurant-description"
}, pV = /* @__PURE__ */ K({
  __name: "FacilitiesSubSectionRestaurants",
  props: {
    restaurant: {},
    title: {}
  },
  setup(e) {
    const t = e, { t: n } = Ne({ useScope: "global" }), o = V(() => {
      var a;
      return ((a = t.restaurant.info) == null ? void 0 : a.filter((r) => r.name).map((r) => ({
        ...r,
        description: s(r)
      }))) || [];
    });
    function s(a) {
      const r = [];
      return a.type && r.push(
        `${n("vacvComponents.productDetails.facilities.restaurantType")}: ${a.type}`
      ), a.cuisineType && r.push(
        `${n("vacvComponents.productDetails.facilities.restaurantCuisine")}: ${a.cuisineType}`
      ), a.additionnalInfo && r.push(
        `${n("vacvComponents.productDetails.facilities.restaurantNote")}: ${a.additionnalInfo}`
      ), r.join(" | ");
    }
    return (a, r) => a.restaurant.info ? (b(), C("div", aV, [
      d("h4", rV, k(a.title), 1),
      a.restaurant.title ? (b(), C("p", iV, k(a.restaurant.title), 1)) : M("", !0),
      d("ul", lV, [
        (b(!0), C($e, null, ke(o.value, (i) => (b(), C("li", {
          key: i.name,
          class: "spa-list-item"
        }, [
          d("span", cV, k(i.name), 1),
          i.description ? (b(), C("span", uV, k(i.description), 1)) : M("", !0)
        ]))), 128))
      ])
    ])) : M("", !0);
  }
}), dV = /* @__PURE__ */ De(pV, [["__scopeId", "data-v-edcfe840"]]), fV = {
  key: 1,
  class: "sub-content"
}, mV = {
  key: 0,
  class: "h3style"
}, vV = {
  key: 1,
  class: "description"
}, hV = {
  key: 2,
  class: "description"
}, gV = { class: "spa-list special-list details-2col" }, bV = {
  key: 3,
  class: "disclaimer"
}, yV = {
  key: 4,
  class: "disclaimer pet"
}, $m = /* @__PURE__ */ K({
  __name: "FacilitiesSubSection",
  props: {
    subsection: {},
    restaurantSubsection: {},
    keyName: {}
  },
  setup(e) {
    const t = e, { t: n } = Ne({ useScope: "global" }), o = V(() => ({
      pools: n("vacvComponents.productDetails.facilities.pools"),
      landSports: n("vacvComponents.productDetails.facilities.landSports"),
      waterSports: n("vacvComponents.productDetails.facilities.waterSports"),
      entertainment: n("vacvComponents.productDetails.facilities.entertainment"),
      golf: n("vacvComponents.productDetails.facilities.golf"),
      bars: n("vacvComponents.productDetails.facilities.bars") + ":",
      restaurants: n("vacvComponents.productDetails.facilities.restaurants") + ":",
      health: n("vacvComponents.productDetails.facilities.health")
    })), s = V(() => o.value[t.keyName] ?? null), a = (i = [], l = []) => [...i, ...l], r = V(() => {
      var i, l;
      return ((i = t.subsection) == null ? void 0 : i.description) || ((l = t.subsection) == null ? void 0 : l.title) || null;
    });
    return (i, l) => {
      var c, u, p, f;
      return i.restaurantSubsection ? (b(), ie(dV, {
        key: 0,
        restaurant: i.restaurantSubsection,
        title: s.value
      }, null, 8, ["restaurant", "title"])) : (u = (c = i.subsection) == null ? void 0 : c.names) != null && u.length || (p = i.subsection) != null && p.additionalInformation || (f = i.subsection) != null && f.description ? (b(), C("div", fV, [
        s.value ? (b(), C("h4", mV, k(s.value), 1)) : M("", !0),
        r.value ? (b(), C("p", vV, k(r.value), 1)) : M("", !0),
        i.subsection.additionalInformation ? (b(), C("p", hV, k(i.subsection.additionalInformation), 1)) : M("", !0),
        d("ul", gV, [
          (b(!0), C($e, null, ke(a(i.subsection.names, i.subsection.more), (m) => (b(), C("li", {
            key: m,
            class: "spa-list-item"
          }, k(m), 1))), 128))
        ]),
        i.subsection.hasDisclaimer ? (b(), C("p", bV, k(i.$t("vacvComponents.productDetails.facilities.disclaimer")), 1)) : M("", !0),
        "petFriendlyDisclamer" in i.subsection && i.subsection.petFriendlyDisclamer ? (b(), C("p", yV, k(i.$t("vacvComponents.productDetails.facilities.disclaimerPetFriendly")), 1)) : M("", !0)
      ])) : M("", !0);
    };
  }
}), ty = (e) => (dn("data-v-4beead86"), e = e(), fn(), e), $V = {
  key: 0,
  class: "sub-section"
}, _V = { class: "h2style" }, wV = {
  key: 0,
  class: "fooddrink-icon"
}, CV = /* @__PURE__ */ ty(() => /* @__PURE__ */ d("i", {
  class: "fa-solid fa-utensils",
  "aria-hidden": "true"
}, null, -1)), kV = /* @__PURE__ */ ty(() => /* @__PURE__ */ d("i", {
  class: "fa-solid fa-wine-glass",
  "aria-hidden": "true"
}, null, -1)), SV = [
  CV,
  kV
], TV = {
  key: 1,
  class: "fa-solid fa-water-ladder",
  "aria-hidden": "true"
}, AV = { key: 2 }, DV = 250, PV = /* @__PURE__ */ K({
  __name: "FacilitiesItem",
  props: {
    facility: {},
    facilityName: {}
  },
  setup(e) {
    En((m) => ({
      f90383fa: T(i),
      "72ca28b6": T(r)
    }));
    const t = e, {
      toggleLearnMore: n,
      expandableContent: o,
      isExpandable: s,
      isExpanded: a,
      expandedHeight: r,
      defaultRollupHeightPX: i,
      expandableContentClass: l
    } = ey(DV), { t: c } = Ne({ useScope: "global" }), u = (m) => ({
      foodAndDrink: c("vacvComponents.productDetails.facilities.foodAndDrinks"),
      activities: c("vacvComponents.productDetails.facilities.activities"),
      otherFacilityAndServices: c(
        "vacvComponents.productDetails.facilities.otherFacilitiesAndServices"
      )
    })[m] ?? null, p = () => {
      if (t.facilityName === "otherFacilityAndServices" || t.facilityName === "foodAndDrink")
        return !0;
      for (const m in t.facility) {
        const h = t.facility[m];
        if (!h)
          return !1;
        const g = h.names && h.names.length, _ = h.more && h.more.length;
        return g || _;
      }
      return !1;
    }, f = V(() => !u(t.facilityName) || !t.facility || Object.keys(t.facility).length === 0 ? !1 : p());
    return (m, h) => f.value ? (b(), C("div", $V, [
      d("h3", _V, [
        m.facilityName === "foodAndDrink" ? (b(), C("span", wV, SV)) : M("", !0),
        m.facilityName === "activities" ? (b(), C("i", TV)) : M("", !0),
        m.facilityName === "otherFacilityAndServices" ? (b(), C("span", AV, " ($) ")) : M("", !0),
        ne(" " + k(u(m.facilityName)), 1)
      ]),
      m.facilityName !== "otherFacilityAndServices" ? (b(), C("div", {
        key: 0,
        class: ue(T(l)),
        ref_key: "expandableContent",
        ref: o
      }, [
        (b(!0), C($e, null, ke(m.facility, (g, _) => (b(), ie($m, {
          key: _,
          keyName: _,
          subsection: g,
          restaurantSubsection: "info" in g ? g : void 0
        }, null, 8, ["keyName", "subsection", "restaurantSubsection"]))), 128))
      ], 2)) : (b(), C("div", {
        key: 1,
        class: ue(T(l)),
        ref_key: "expandableContent",
        ref: o
      }, [
        q($m, {
          keyName: "otherFacilityAndServices",
          subsection: m.facility
        }, null, 8, ["subsection"])
      ], 2)),
      T(s) ? (b(), ie(Qb, {
        key: 2,
        "is-expanded": T(a),
        "show-text": m.$t("vacvComponents.productDetails.facilities.showMore"),
        "hide-text": m.$t("vacvComponents.productDetails.facilities.showLess"),
        onToggleLearnMore: T(n)
      }, null, 8, ["is-expanded", "show-text", "hide-text", "onToggleLearnMore"])) : M("", !0)
    ])) : M("", !0);
  }
}), IV = /* @__PURE__ */ De(PV, [["__scopeId", "data-v-4beead86"]]), EV = { "data-test": "pdp-hotel-facilities-section-title" }, kie = /* @__PURE__ */ K({
  __name: "Facilities",
  props: {
    facilities: {}
  },
  setup(e) {
    const { onIntersectionObserver: t, section: n } = aa();
    return (o, s) => (b(), C("section", {
      id: "facilities",
      class: "pdp-section facilities",
      ref_key: "section",
      ref: n
    }, [
      ot((b(), C("h2", EV, [
        ne(k(o.$t("vacvComponents.productDetails.facilities.title")), 1)
      ])), [
        [T(as), [T(t), { section: T(n) }]]
      ]),
      (b(!0), C($e, null, ke(o.facilities, (a, r, i) => (b(), C($e, null, [
        a ? (b(), ie(IV, {
          key: i,
          facility: a,
          "facility-name": r
        }, null, 8, ["facility", "facility-name"])) : M("", !0)
      ], 64))), 256))
    ], 512));
  }
}), OV = { class: "sr-only" }, xV = { class: "sr-only" }, MV = { class: "sr-only" }, LV = { class: "sr-only" }, NV = { class: "sr-only" }, FV = { class: "sr-only" }, RV = { class: "sr-only" }, VV = /* @__PURE__ */ K({
  __name: "PdpNavAnchors",
  props: {
    hasOverviewData: { type: Boolean },
    hasLocationData: { type: Boolean },
    hasBestForData: { type: Boolean },
    hasFacilitesData: { type: Boolean },
    hasPromotionsData: { type: Boolean },
    hasImportantInformation: { type: Boolean }
  },
  setup(e) {
    const t = Xb(), { PDP: n, setPDPSectionDisplayed: o } = t, s = V(() => n.PDPSectionInView), a = R(null), r = R(null), i = (l, c) => {
      var f;
      const p = (f = l.target.getAttribute("href")) == null ? void 0 : f.replace("#", "");
      return o(p, !0), wR(c), !1;
    };
    return Jt(() => {
      o(null, !0);
    }), le(
      s,
      () => {
        var c, u, p;
        const { width: l } = cp();
        if (a.value && ((c = a.value) == null ? void 0 : c.scrollWidth) > l.value) {
          const f = (u = a.value) == null ? void 0 : u.childNodes.length, m = [].findIndex.call(
            (p = a.value) == null ? void 0 : p.childNodes,
            (v) => {
              var w;
              return ((w = v == null ? void 0 : v.classList) == null ? void 0 : w.contains) !== void 0 ? v.classList.contains("active") : !1;
            }
          );
          let h = 0;
          f > 5 && m > 3 && (h = 300);
          const { x: g } = P_(a.value, { behavior: "smooth" });
          lp(() => {
            g.value = h;
          }, 800);
        }
      },
      {
        flush: "post"
      }
    ), (l, c) => (b(), C("nav", {
      ref_key: "navEl",
      ref: r
    }, [
      d("ul", {
        class: "nav-scroller",
        ref_key: "listEl",
        ref: a,
        "data-test": "navbar"
      }, [
        d("li", {
          class: ue({ active: s.value === "rooms" })
        }, [
          d("a", {
            href: "#rooms",
            onClick: c[0] || (c[0] = (u) => i(u, "Rooms"))
          }, [
            d("span", OV, k(l.$t("vacvComponents.productDetails.labels.accessibleAnchor")), 1),
            ne(k(l.$t("vacvComponents.productDetails.rooms")), 1)
          ])
        ], 2),
        l.hasOverviewData ? (b(), C("li", {
          key: 0,
          class: ue({ active: s.value === "overview" })
        }, [
          d("a", {
            href: "#overview",
            onClick: c[1] || (c[1] = (u) => i(u, "Overview"))
          }, [
            d("span", xV, k(l.$t("vacvComponents.productDetails.labels.accessibleAnchor")), 1),
            ne(k(l.$t("vacvComponents.productDetails.labels.hotel.overview.title")), 1)
          ])
        ], 2)) : M("", !0),
        l.hasLocationData ? (b(), C("li", {
          key: 1,
          class: ue({ active: s.value === "location" })
        }, [
          d("a", {
            href: "#location",
            onClick: c[2] || (c[2] = (u) => i(u, "Location"))
          }, [
            d("span", MV, k(l.$t("vacvComponents.productDetails.labels.accessibleAnchor")), 1),
            ne(k(l.$t("vacvComponents.productDetails.labels.hotel.location.title")), 1)
          ])
        ], 2)) : M("", !0),
        l.hasBestForData ? (b(), C("li", {
          key: 2,
          class: ue({ active: s.value === "bestFor" })
        }, [
          d("a", {
            href: "#bestFor",
            onClick: c[3] || (c[3] = (u) => i(u, "Ideal For"))
          }, [
            d("span", LV, k(l.$t("vacvComponents.productDetails.labels.accessibleAnchor")), 1),
            ne(k(l.$t("vacvComponents.productDetails.bestFor.title")), 1)
          ])
        ], 2)) : M("", !0),
        l.hasFacilitesData ? (b(), C("li", {
          key: 3,
          class: ue({ active: s.value === "facilities" })
        }, [
          d("a", {
            href: "#facilities",
            onClick: c[4] || (c[4] = (u) => i(u, "Facilities"))
          }, [
            d("span", NV, k(l.$t("vacvComponents.productDetails.labels.accessibleAnchor")), 1),
            ne(k(l.$t("vacvComponents.productDetails.labels.hotel.facilities.title")), 1)
          ])
        ], 2)) : M("", !0),
        l.hasPromotionsData ? (b(), C("li", {
          key: 4,
          class: ue({ active: s.value === "offers" })
        }, [
          d("a", {
            href: "#offers",
            onClick: c[5] || (c[5] = (u) => i(u, "Offers"))
          }, [
            d("span", FV, k(l.$t("vacvComponents.productDetails.labels.accessibleAnchor")), 1),
            ne(k(l.$t("vacvComponents.productDetails.labels.hotel.offers.title")), 1)
          ])
        ], 2)) : M("", !0),
        l.hasImportantInformation ? (b(), C("li", {
          key: 5,
          class: ue({ active: s.value === "importantInformation" })
        }, [
          d("a", {
            href: "#importantInformation",
            onClick: c[6] || (c[6] = (u) => i(u, "Important Information"))
          }, [
            d("span", RV, k(l.$t("vacvComponents.productDetails.labels.accessibleAnchor")), 1),
            ne(k(l.$t("vacvComponents.productDetails.labels.hotel.important.title")), 1)
          ])
        ], 2)) : M("", !0)
      ], 512)
    ], 512));
  }
}), Sie = /* @__PURE__ */ De(VV, [["__scopeId", "data-v-dce3f66a"]]), BV = (e) => (dn("data-v-31b5bf41"), e = e(), fn(), e), HV = { class: "rating-ta-wrapper" }, UV = {
  key: 0,
  class: "rating-wrapper"
}, zV = {
  key: 0,
  class: "hotel-rating"
}, WV = { class: "stars" }, jV = /* @__PURE__ */ BV(() => /* @__PURE__ */ d("i", {
  class: "fa-solid fa-star",
  "aria-hidden": "true"
}, null, -1)), qV = { class: "sr-only" }, KV = {
  key: 1,
  class: "hotel-plan"
}, YV = {
  key: 2,
  class: "hotel-city"
}, GV = /* @__PURE__ */ K({
  __name: "VacvHotelRating",
  props: {
    hotel: {},
    package: {}
  },
  setup(e) {
    return (t, n) => {
      var o, s, a, r;
      return b(), C("div", HV, [
        t.hotel.starCategory || t.hotel.destination ? (b(), C("div", UV, [
          t.hotel.starCategory ? (b(), C("span", zV, [
            d("span", WV, [
              ne(k(t.hotel.starCategory), 1),
              jV,
              d("span", qV, k(t.$t("vacvComponents.hotelRating.stars")), 1)
            ])
          ])) : M("", !0),
          (s = (o = t.package) == null ? void 0 : o.information) != null && s.mealPlanName ? (b(), C("span", KV, k((r = (a = t.package) == null ? void 0 : a.information) == null ? void 0 : r.mealPlanName), 1)) : M("", !0),
          t.hotel.destination ? (b(), C("span", YV, k(t.hotel.destination), 1)) : M("", !0)
        ])) : M("", !0),
        Xe(t.$slots, "default", {}, void 0, !0)
      ]);
    };
  }
}), ny = /* @__PURE__ */ De(GV, [["__scopeId", "data-v-31b5bf41"]]), ZV = { class: "pdp-header" }, XV = /* @__PURE__ */ K({
  __name: "VacvPdpHeader",
  setup(e) {
    const t = Ye("hotel");
    return (n, o) => (b(), C("header", ZV, [
      d("h1", null, k(T(t).name), 1),
      q(ny, { hotel: T(t) }, {
        default: he(() => [
          T(t).rating && T(zg)(T(t).rating) ? (b(), ie(ah, {
            key: 0,
            rating: T(t).rating
          }, null, 8, ["rating"])) : M("", !0)
        ]),
        _: 1
      }, 8, ["hotel"])
    ]));
  }
}), Tie = /* @__PURE__ */ De(XV, [["__scopeId", "data-v-994e3487"]]), JV = { class: "traveller-summary" }, QV = { class: "traveller-item-title" }, eB = { class: "h2style passenger-title" }, tB = {
  key: 0,
  class: "note--mainemail"
}, nB = { class: "h3style passenger-name" }, oB = { key: 0 }, sB = { key: 1 }, aB = { key: 2 }, rB = { key: 3 }, iB = {
  key: 0,
  class: "item-detail dob"
}, lB = {
  key: 1,
  class: "item-detail email"
}, cB = {
  key: 2,
  class: "item-detail phone"
}, uB = {
  key: 3,
  class: "item-detail aeroplan"
}, oy = /* @__PURE__ */ K({
  __name: "TravellerSummary",
  props: {
    passenger: {},
    showDOB: { type: Boolean, default: !0 }
  },
  setup(e) {
    const { t } = Ne({ useScope: "global" }), n = e, o = V(() => {
      const { passenger: s, showDOB: a } = n, r = s.orderIndex, i = r === 1 ? "er" : "e";
      if (s.adult) {
        let l = t("vacvComponents.traveller.labels.adult", { index: r, pos: i });
        return s.orderIndex === 1 && (l += ` ${t("vacvComponents.traveller.messages.mainTraveller")}`), l;
      }
      return s.age !== void 0 && s.age < 2 ? a === !1 ? t("vacvComponents.traveller.labels.infantHideAge", { index: r, pos: i }) : t("vacvComponents.traveller.labels.infant", {
        index: r,
        age: s.age,
        pos: i
      }) : a === !1 ? t("vacvComponents.traveller.labels.childHideAge", { index: r, pos: i }) : t("vacvComponents.traveller.labels.child", {
        index: r,
        age: s.age,
        pos: i
      });
    });
    return (s, a) => (b(), C("div", JV, [
      d("div", QV, [
        d("div", eB, k(o.value), 1),
        s.passenger.adult && s.passenger.orderIndex === 1 ? (b(), C("div", tB, k(s.$t("vacvComponents.traveller.messages.travellerEmailDisclaimer")), 1)) : M("", !0)
      ]),
      d("div", null, [
        d("div", nB, [
          s.passenger.title === "MR" ? (b(), C("span", oB, k(s.$t("vacvComponents.traveller.labels.travellerTitleMr")), 1)) : M("", !0),
          s.passenger.title === "MRS" ? (b(), C("span", sB, k(s.$t("vacvComponents.traveller.labels.travellerTitleMrs")), 1)) : M("", !0),
          s.passenger.title === "MS" ? (b(), C("span", aB, k(s.$t("vacvComponents.traveller.labels.travellerTitleMs")), 1)) : M("", !0),
          ne(" " + k(s.passenger.firstName) + " ", 1),
          s.passenger.middleName ? (b(), C("span", rB, k(s.passenger.middleName), 1)) : M("", !0),
          ne(" " + k(s.passenger.lastName), 1)
        ]),
        s.passenger.birthdayFormatted && s.showDOB !== !1 ? (b(), C("div", iB, [
          ne(k(s.$t("vacvComponents.traveller.labels.dateOfBirth-filled")) + " ", 1),
          d("span", null, k(s.passenger.birthdayFormatted), 1)
        ])) : M("", !0),
        s.passenger.emailAddress ? (b(), C("div", lB, k(s.$t("vacvComponents.traveller.labels.travellerEmail-filled")) + " " + k(s.passenger.emailAddress), 1)) : M("", !0),
        s.passenger.phoneNumber ? (b(), C("div", cB, k(s.$t("vacvComponents.traveller.labels.travellerPhoneNumber-filled")) + " " + k(s.passenger.phoneNumber), 1)) : M("", !0),
        s.passenger.aeroplanNum ? (b(), C("div", uB, k(s.$t("vacvComponents.traveller.labels.travellerAeroplanNumber-filled")) + " " + k(s.passenger.aeroplanNum), 1)) : M("", !0)
      ])
    ]));
  }
}), pB = { class: "paddedbox-grey" }, dB = {
  key: 0,
  class: "note"
}, fB = { class: "traveller-list" }, mB = ["index", "passenger"], Aie = /* @__PURE__ */ K({
  __name: "TravellersSummary",
  props: {
    passengers: {},
    showDOB: { type: Boolean, default: !0 },
    stepNumber: {}
  },
  emits: ["update-information"],
  setup(e, { emit: t }) {
    const n = e, o = t, s = () => {
      o("update-information");
    }, a = V(() => {
      var r;
      return (r = n.passengers) == null ? void 0 : r.some((i) => i.nameModified);
    });
    return (r, i) => (b(), C("section", {
      class: ue(["travellers-summary", `step-${r.stepNumber}`])
    }, [
      d("div", pB, [
        a.value ? (b(), C("p", dB, [
          d("strong", null, k(r.$t("vacvComponents.payment.labels.note")), 1),
          ne(" " + k(r.$t("vacvComponents.payment.labels.travellerInfoNormalizedNote")), 1)
        ])) : M("", !0),
        d("ul", fB, [
          (b(!0), C($e, null, ke(r.passengers, (l, c) => (b(), C("li", {
            key: l.id,
            index: c,
            passenger: l,
            class: "traveller-item"
          }, [
            q(oy, {
              passenger: l,
              showDOB: r.showDOB
            }, null, 8, ["passenger", "showDOB"])
          ], 8, mB))), 128))
        ]),
        r.stepNumber !== 2 ? (b(), C("button", {
          key: 1,
          class: "update-info vacv-btn-secondary",
          onClick: s
        }, [
          d("span", null, k(r.$t("vacvComponents.payment.labels.updateInformation")), 1)
        ])) : M("", !0)
      ])
    ], 2));
  }
}), vB = { class: "qty" }, hB = /* @__PURE__ */ K({
  __name: "TravellerQuantity",
  props: {
    pricing: {},
    taxes: { type: Boolean, default: !1 },
    showDOB: { type: Boolean }
  },
  setup(e) {
    const t = e, { t: n } = Ne({ useScope: "global" }), o = V(() => {
      const { pricing: s, taxes: a, showDOB: r } = t, i = s.paxCount;
      let l;
      s.paxType === "A" ? l = "adult" : s.paxAge && s.paxAge >= 2 ? l = "child" : l = "infant";
      const c = Rp(s) ? 2 : 1, u = n(`vacvComponents.pricedetails.${l}`, c);
      let p = `${i} ${u}`;
      if (r && !a && s.paxAge && s.paxType !== "A") {
        const f = s.paxAge >= 2 ? s.paxAge : n("vacvComponents.pricedetails.infantAge");
        p += ` (${f})`;
      }
      return a && (p += ` ${n("vacvComponents.pricedetails.taxesFees")}`), p;
    });
    return (s, a) => (b(), C("div", vB, k(o.value), 1));
  }
}), gB = /* @__PURE__ */ De(hB, [["__scopeId", "data-v-c9a13738"]]), bB = /* @__PURE__ */ K({
  __name: "TravellerEach",
  props: {
    amount: {}
  },
  setup(e) {
    const t = e;
    return (n, o) => (b(), C("div", null, "   x " + k(T(Se)(t.amount, n.$n)), 1));
  }
}), yB = { class: "total" }, $B = /* @__PURE__ */ K({
  __name: "TravellerTotal",
  props: {
    amount: {}
  },
  setup(e) {
    const t = e;
    return (n, o) => (b(), C("div", yB, k(T(Se)(t.amount, n.$n)), 1));
  }
}), _m = /* @__PURE__ */ K({
  __name: "TravellerSection",
  props: {
    pricing: {},
    taxes: { type: Boolean, default: !1 },
    showDOB: { type: Boolean }
  },
  setup(e) {
    const t = e, n = V(
      () => t.taxes ? t.pricing.taxFees : t.pricing.price
    ), o = V(() => t.pricing.paxCount);
    return (s, a) => (b(), C($e, null, [
      q(gB, {
        showDOB: s.showDOB,
        pricing: s.pricing,
        taxes: s.taxes
      }, null, 8, ["showDOB", "pricing", "taxes"]),
      typeof n.value == "number" && T(Rp)(s.pricing) ? (b(), ie(bB, {
        key: 0,
        amount: n.value
      }, null, 8, ["amount"])) : M("", !0),
      typeof n.value == "number" && typeof o.value == "number" ? (b(), ie($B, {
        key: 1,
        amount: n.value * o.value
      }, null, 8, ["amount"])) : M("", !0)
    ], 64));
  }
}), _B = { class: "breakdown-price-section" }, wB = {
  key: 0,
  class: "extras-included"
}, CB = !0, kB = /* @__PURE__ */ K({
  __name: "TravellerSections",
  props: {
    pricing: {},
    extrasIncluded: { type: Boolean },
    showDOB: { type: Boolean }
  },
  setup(e) {
    const t = e, n = V(
      () => Rp(t.pricing) ? "multiple price-row " : "price-row "
    );
    return (o, s) => (b(), C("ul", _B, [
      d("li", {
        class: ue(`${n.value} baseprice`)
      }, [
        q(_m, {
          showDOB: o.showDOB,
          pricing: t.pricing
        }, null, 8, ["showDOB", "pricing"])
      ], 2),
      o.extrasIncluded ? (b(), C("li", wB, k(o.$t("vacvComponents.pricedetails.extras-included")), 1)) : M("", !0),
      d("li", {
        class: ue(`${n.value} taxfees`)
      }, [
        q(_m, {
          showDOB: o.showDOB,
          pricing: t.pricing,
          taxes: CB
        }, null, 8, ["showDOB", "pricing"])
      ], 2)
    ]));
  }
}), SB = /* @__PURE__ */ De(kB, [["__scopeId", "data-v-e9018a0e"]]), TB = { class: "breakdown-travellerList" }, AB = /* @__PURE__ */ K({
  __name: "TravellerType",
  props: {
    pricing: {},
    extrasIncluded: { type: Boolean },
    showDOB: { type: Boolean }
  },
  setup(e) {
    return (t, n) => (b(), C("ul", TB, [
      (b(!0), C($e, null, ke(t.pricing, (o, s) => (b(), C("li", { key: s }, [
        q(SB, {
          showDOB: t.showDOB,
          pricing: o,
          extrasIncluded: t.extrasIncluded
        }, null, 8, ["showDOB", "pricing", "extrasIncluded"])
      ]))), 128))
    ]));
  }
}), DB = {};
function PB(e, t) {
  return Xe(e.$slots, "priceBreakdownLines");
}
const wm = /* @__PURE__ */ De(DB, [["render", PB]]), IB = (e, t) => {
  const n = Yp.parse(t.substring(t.indexOf("?") + 1)), o = Object.entries(n).filter((r) => r[0].startsWith("non_adult")).map((r) => {
    let i = 0;
    typeof r[0] == "string" && (i = parseInt(r[0].substring(9)));
    let l = 0;
    return typeof r[1] == "string" && (l = parseInt(r[1])), [i, l];
  });
  o.sort((r, i) => r[0] < i[0] ? -1 : 1);
  const s = o.map((r) => r[1]), a = [...e ?? []];
  return a.sort(function(r, i) {
    if (r.paxType === "C" && i.paxType === "C" && typeof r.paxAge == "number" && typeof i.paxAge == "number") {
      const l = s.indexOf(r.paxAge), c = s.indexOf(i.paxAge);
      return l > c ? 1 : -1;
    }
    return 0;
  }), a;
}, EB = {
  key: 0,
  class: "breakdown-wrapper"
}, OB = { class: "vacv-label-sm" }, xB = { class: "breakdown-travellerList" }, MB = { class: "breakdown-price-section" }, LB = { class: "price-row baseprice" }, NB = { class: "qty" }, FB = { class: "total" }, RB = { class: "price-row" }, VB = { class: "qty" }, BB = { class: "total" }, HB = {
  key: 1,
  class: "breakdown-wrapper"
}, UB = { class: "vacv-label-sm" }, zB = {
  key: 0,
  class: "packageInclusions"
}, ed = /* @__PURE__ */ K({
  __name: "PriceBreakdown",
  props: {
    prePackagePricing: {},
    packageInclusions: {},
    extrasIncluded: { type: Boolean },
    spaType: {},
    showDOB: { type: Boolean }
  },
  setup(e) {
    const t = e, n = V(() => {
      var r;
      const a = (r = t == null ? void 0 : t.prePackagePricing) == null ? void 0 : r.perPaxType;
      return IB(a, document.location.search);
    }), o = V(
      () => t.prePackagePricing
    ), s = t.spaType === lt.HotelsSpa;
    return (a, r) => s ? (b(), C("div", EB, [
      d("h3", OB, k(a.$t("vacvComponents.pricedetails.hotelOnlyTitle")), 1),
      d("ul", xB, [
        d("li", null, [
          d("ul", MB, [
            d("li", LB, [
              d("div", NB, [
                ne(k(o.value.numberOfNights) + " ", 1),
                d("span", null, k(a.$t("vacvComponents.pricedetails.nights")), 1),
                d("div", null, "    x " + k(T(Se)(o.value.perNightWithOutTax, a.$n)), 1)
              ]),
              d("div", FB, k(T(Se)(o.value.totalWithOutTax, a.$n)), 1)
            ]),
            d("li", RB, [
              d("div", VB, [
                ne("  "),
                d("span", null, k(a.$t("vacvComponents.pricedetails.taxesAndFees")), 1)
              ]),
              d("div", BB, k(T(Se)(o.value.totalTax, a.$n)), 1)
            ])
          ])
        ])
      ]),
      q(wm, null, {
        priceBreakdownLines: he(() => [
          Xe(a.$slots, "priceBreakdownLines")
        ]),
        _: 3
      }),
      Xe(a.$slots, "default")
    ])) : (b(), C("div", HB, [
      d("h3", UB, [
        ne(k(a.$t("vacvComponents.pricedetails.title")) + " ", 1),
        a.packageInclusions ? (b(), C("span", zB, "(" + k(a.packageInclusions) + ")", 1)) : M("", !0)
      ]),
      q(AB, {
        showDOB: a.showDOB,
        pricing: n.value,
        extrasIncluded: a.extrasIncluded
      }, null, 8, ["showDOB", "pricing", "extrasIncluded"]),
      q(wm, null, {
        priceBreakdownLines: he(() => [
          Xe(a.$slots, "priceBreakdownLines")
        ]),
        _: 3
      }),
      Xe(a.$slots, "default")
    ]));
  }
}), WB = (e) => (dn("data-v-a04592eb"), e = e(), fn(), e), jB = { class: "price" }, qB = /* @__PURE__ */ WB(() => /* @__PURE__ */ d("span", {
  class: "round-icon",
  "aria-hidden": "true"
}, null, -1)), KB = {
  key: 0,
  class: "aeroplan-applied"
}, YB = /* @__PURE__ */ K({
  __name: "PriceTotal",
  props: {
    total: {},
    aeroplanPoints: {}
  },
  emits: ["hide"],
  setup(e) {
    const t = e, n = V(
      () => {
        var o;
        return t.aeroplanPoints && ((o = t.aeroplanPoints) == null ? void 0 : o.pointsCashValue) > 0;
      }
    );
    return (o, s) => {
      var a;
      return b(), C($e, null, [
        d("button", {
          class: "price-popover-link link",
          onClick: s[0] || (s[0] = Ke((r) => o.$emit("hide"), ["stop"])),
          "aria-haspopup": "true"
        }, [
          d("span", jB, k(T(Se)(t.total, o.$n)), 1),
          ne(" " + k(o.$t("vacvComponents.pricedetails.total")) + " ", 1),
          qB
        ]),
        n.value ? (b(), C("div", KB, k(o.$n((a = o.aeroplanPoints) == null ? void 0 : a.amountOfPoints, "decimal")) + " " + k(o.$t("vacvComponents.pricedetails.aeroplan-points-applied")), 1)) : M("", !0)
      ], 64);
    };
  }
}), GB = /* @__PURE__ */ De(YB, [["__scopeId", "data-v-a04592eb"]]), ZB = {}, XB = { class: "pricedisclaimer-section" }, JB = { class: "legal" };
function QB(e, t) {
  return b(), C("section", XB, [
    d("div", JB, k(e.$t("vacvComponents.legal.disclaimer.price")), 1)
  ]);
}
const Su = /* @__PURE__ */ De(ZB, [["render", QB]]), eH = ["innerHTML"], tH = /* @__PURE__ */ K({
  __name: "BreakdownRow",
  props: {
    title: {},
    value: {},
    reverseOrder: { type: Boolean, default: !1 },
    titleClasses: {},
    valueClasses: {}
  },
  setup(e) {
    return (t, n) => (b(), C("div", {
      class: ue(["bdrow", [
        {
          "bdrow--reversed": t.reverseOrder
        },
        t.$attrs.class
      ]])
    }, [
      d("div", {
        innerHTML: t.title,
        class: ue(["bdrow__title", t.titleClasses])
      }, null, 10, eH),
      t.value ? (b(), C("div", {
        key: 0,
        class: ue(["bdrow__value", t.valueClasses])
      }, k(t.value), 3)) : M("", !0)
    ], 2));
  }
}), Qn = /* @__PURE__ */ De(tH, [["__scopeId", "data-v-60635fea"]]), nH = {}, oH = { class: "non-refundable-rate" };
function sH(e, t) {
  return b(), C("div", oH, k(e.$t("vacvComponents.pricedetails.nonRefundableRate")), 1);
}
const td = /* @__PURE__ */ De(nH, [["render", sH]]), aH = /* @__PURE__ */ K({
  __name: "PriceTotalRow",
  props: {
    priceTotal: {},
    estimated: { type: Boolean, default: !0 },
    reverseOrder: { type: Boolean, default: !1 },
    modifier: {},
    isSection: { type: Boolean },
    isRefundable: { type: Boolean, default: !0 },
    includesTravelInsurance: { type: Boolean },
    spaType: {}
  },
  setup(e) {
    const t = e, { t: n } = Ne({ useScope: "global" }), o = V(() => t.spaType === lt.HotelsSpa || t.estimated ? n("vacvComponents.pricedetails.estimatedTotal") : n("vacvComponents.pricedetails.total")), s = V(
      () => t.includesTravelInsurance ? o.value + "<sup>†</sup>" : o.value
    ), a = V(() => ({
      "bdrow--grand": t.modifier === "grand",
      "bdrow--amount": t.modifier === "amount",
      "bdrow--popover": t.modifier === "popover",
      "bdrow--confirmation": t.modifier === "confirmation",
      "bdrow--checkout-mobile": t.modifier === "checkout-mobile",
      "bdrow--mobile": t.modifier === "mobile"
    }));
    return (r, i) => (b(), C("div", {
      class: ue(["grand-total pricetotalrow", { "pricetotalrow--section": r.isSection }])
    }, [
      q(Qn, {
        title: s.value,
        value: r.priceTotal != null && !isNaN(r.priceTotal) ? T(Se)(r.priceTotal, r.$n) : "",
        "reverse-order": r.reverseOrder,
        class: ue(a.value)
      }, null, 8, ["title", "value", "reverse-order", "class"]),
      r.isRefundable ? M("", !0) : (b(), ie(td, { key: 0 }))
    ], 2));
  }
}), nd = /* @__PURE__ */ De(aH, [["__scopeId", "data-v-4347bde2"]]), rH = {
  key: 0,
  class: "subtotal subtotal--section"
}, iH = /* @__PURE__ */ K({
  __name: "SubTotalRow",
  props: {
    subTotal: {}
  },
  setup(e) {
    return (t, n) => t.subTotal && t.subTotal > 0 ? (b(), C("div", rH, [
      q(Qn, {
        title: t.$t("vacvComponents.pricedetails.paymentSubtotal"),
        value: T(Se)(t.subTotal, t.$n),
        class: "bdrow--amount-total"
      }, null, 8, ["title", "value"])
    ])) : M("", !0);
  }
}), sy = /* @__PURE__ */ De(iH, [["__scopeId", "data-v-2b1a67bf"]]), lH = (e = "left-start", t = "top") => {
  const n = R(), o = R(e), s = () => {
    n.value = i1();
  };
  return Qp(s), le(n, async (a) => {
    a && (a < di.tablet ? o.value = t : o.value = e);
  }), Re(() => {
    s();
  }), {
    placement: o
  };
}, cH = { class: "price-left" }, uH = ["aria-label"], pH = { class: "disclaimer legal" }, dH = { class: "total-wrapper" }, fH = { class: "price-per" }, mH = { class: "vacv-price" }, vH = {
  key: 0,
  class: "per"
}, hH = {
  key: 1,
  class: "per"
}, gH = { class: "price-total" }, bH = ["aria-label"], yH = { class: "price-taxes" }, $H = /* @__PURE__ */ K({
  __name: "PriceDetails",
  props: {
    prePackagePricing: {},
    aeroplanPoints: {},
    price: {},
    total: {},
    showDifference: { type: Boolean },
    wasPricePerAdult: {},
    savingsPercentage: {},
    savingsThreshold: {},
    wasPriceTooltipEnabled: { type: Boolean },
    spaType: {}
  },
  emits: ["price-total-click", "was-price-click"],
  setup(e, { emit: t }) {
    const n = e, o = t, s = R(!1), a = R(!1), r = () => {
      window.addEventListener("mousedown", l), window.addEventListener("touchstart", l);
    }, i = () => {
      window.removeEventListener("mousedown", l), window.removeEventListener("touchstart", l);
    }, l = (h) => {
      yi(h, ["popper", "price-popover-link"]) && (s.value = !1, i()), yi(h, ["popper", "was-price-popover-link"]) && (a.value = !1, i());
    }, { placement: c } = lH(), u = V(() => n.savingsPercentage !== void 0 && n.savingsPercentage >= (n.savingsThreshold ?? 0)), p = () => {
      a.value = !a.value, a.value ? (o("was-price-click"), r()) : i();
    }, f = () => {
      s.value = !s.value, s.value ? (r(), o("price-total-click")) : i();
    }, m = V(() => n.spaType === lt.HotelsSpa);
    return (h, g) => (b(), C("div", cH, [
      u.value ? (b(), C("div", {
        key: 0,
        class: ue(["was-price-wrapper", { "tooltip-none": !h.wasPriceTooltipEnabled }])
      }, [
        q(T(bi), {
          arrow: "",
          show: a.value,
          placement: T(c),
          onClick: p
        }, ui({
          default: he(() => [
            h.savingsPercentage ? (b(), ie(s_, {
              key: 0,
              percentage: h.savingsPercentage,
              "was-price": h.wasPricePerAdult,
              "show-fraction": !0
            }, null, 8, ["percentage", "was-price"])) : M("", !0)
          ]),
          _: 2
        }, [
          a.value ? {
            name: "content",
            fn: he(() => [
              d("button", {
                class: "btn-close",
                onClick: Ke(p, ["stop"]),
                "aria-label": h.$t("vacvComponents.common.buttons.close")
              }, null, 8, uH),
              d("span", pH, k(h.$t("vacvComponents.legal.disclaimer.was-price")), 1)
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["show", "placement"])
      ], 2)) : M("", !0),
      d("div", dH, [
        d("div", fH, [
          d("span", mH, k(h.showDifference ? "+" : "") + " " + k(T(Se)(h.price, h.$n)), 1),
          m.value ? (b(), C("span", vH, k(h.$t("vacvComponents.common.pricedetails.perNight")), 1)) : (b(), C("span", hH, k(h.$t("vacvComponents.common.pricedetails.peradult")), 1))
        ]),
        d("div", gH, [
          q(T(bi), {
            arrow: "",
            show: s.value,
            placement: T(c),
            onClick: f
          }, ui({
            default: he(() => [
              q(GB, {
                total: h.total,
                aeroplanPoints: h.aeroplanPoints,
                onHide: f
              }, null, 8, ["total", "aeroplanPoints"])
            ]),
            _: 2
          }, [
            s.value ? {
              name: "content",
              fn: he(() => [
                d("button", {
                  class: "btn-close",
                  onClick: Ke(f, ["stop"]),
                  "aria-label": h.$t("vacvComponents.common.buttons.close")
                }, null, 8, bH),
                q(ed, {
                  "pre-package-pricing": h.prePackagePricing,
                  spaType: h.spaType,
                  onHide: f,
                  showDOB: !0
                }, {
                  priceBreakdownLines: he(() => [
                    Xe(h.$slots, "priceBreakdownLines", {}, void 0, !0)
                  ]),
                  default: he(() => [
                    g[0] || (pi(-1), (g[0] = q(Su)).cacheIndex = 0, pi(1), g[0])
                  ]),
                  _: 3
                }, 8, ["pre-package-pricing", "spaType"])
              ]),
              key: "0"
            } : void 0
          ]), 1032, ["show", "placement"])
        ]),
        d("div", yH, k(h.$t("vacvComponents.common.pricedetails.taxesincl")), 1)
      ])
    ]));
  }
}), ay = /* @__PURE__ */ De($H, [["__scopeId", "data-v-b2e75170"]]), _H = {
  key: 0,
  class: "aeroplanpoints-row"
}, wH = /* @__PURE__ */ K({
  __name: "AeroplanPointsRow",
  props: {
    pointsToRedeem: {},
    dollarValue: {}
  },
  setup(e) {
    const { n: t, t: n } = Ne({ useScope: "global" }), o = e, s = V(
      () => t(o.pointsToRedeem) + " " + n("vacvComponents.pricedetails.paymentAEPoints")
    );
    return (a, r) => a.dollarValue > 0 ? (b(), C("div", _H, [
      q(Qn, {
        title: s.value,
        value: "-" + T(Se)(a.dollarValue, a.$n),
        "value-classes": "text-red",
        class: "bdrow--small"
      }, null, 8, ["title", "value"])
    ])) : M("", !0);
  }
}), ry = /* @__PURE__ */ De(wH, [["__scopeId", "data-v-3c158e52"]]), CH = {
  key: 0,
  class: "information-notes-section"
}, kH = ["innerHTML"], SH = /* @__PURE__ */ K({
  __name: "ConfirmationImportantNotes",
  props: {
    activity: {}
  },
  setup(e) {
    return (t, n) => t.activity.importantNotes ? (b(), C("section", CH, [
      d("div", {
        id: "notes-div",
        class: "paddedbox-grey note",
        innerHTML: t.activity.importantNotes
      }, null, 8, kH)
    ])) : M("", !0);
  }
}), TH = { class: "confirm-success-section" }, AH = /* @__PURE__ */ d("i", {
  class: "fa-solid fa-check",
  "aria-hidden": "true"
}, null, -1), DH = { class: "h2style" }, PH = { class: "number" }, IH = { class: "note" }, Die = /* @__PURE__ */ K({
  __name: "ConfirmationSuccess",
  props: {
    bookingNumber: {},
    activities: {},
    selectedActivitiesIds: {}
  },
  setup(e) {
    const t = e, n = V(() => {
      var s, a;
      return (s = t.selectedActivitiesIds) != null && s.length ? (a = t.selectedActivitiesIds) == null ? void 0 : a.map(
        (r) => Object.values(t.activities ?? {}).filter((i) => {
          const l = r.split("-");
          return !!i.subOptions[`${l[0]}-${l[1]}`];
        })
      ).flat() : [];
    }), o = () => {
      window.print();
    };
    return (s, a) => (b(), C("section", TH, [
      d("h1", null, [
        AH,
        ne(k(s.$t("vacvComponents.confirmation.labels.title")), 1)
      ]),
      d("div", DH, k(s.$t("vacvComponents.confirmation.messages.thankYou")), 1),
      d("div", PH, [
        ne(k(s.$t("vacvComponents.confirmation.labels.bookingNumber")) + " ", 1),
        d("strong", null, k(s.bookingNumber), 1)
      ]),
      d("div", IH, k(s.$t("vacvComponents.confirmation.messages.checkInbox")), 1),
      d("button", {
        class: "vacv-btn-primary print-btn",
        onClick: o
      }, k(s.$t("vacvComponents.confirmation.labels.print")), 1),
      (b(!0), C($e, null, ke(n.value, (r) => (b(), ie(SH, {
        key: r.id,
        activity: r
      }, null, 8, ["activity"]))), 128))
    ]));
  }
}), EH = { class: "confirm-aeroplan-section" }, OH = { class: "logo" }, xH = ["src", "alt"], MH = ["innerHTML"], Pie = /* @__PURE__ */ K({
  __name: "ConfirmationAeroplan",
  props: {
    cdnBaseUrl: {},
    heading: {},
    firstName: {},
    messages: {}
  },
  setup(e) {
    return (t, n) => (b(), C("section", EH, [
      d("div", OH, [
        d("img", {
          src: `${t.cdnBaseUrl}/img/aeroplan-logo.svg`,
          alt: t.$t("vacvComponents.common.labels.aeroplan")
        }, null, 8, xH)
      ]),
      d("h2", null, k(t.heading) + " " + k(t.firstName) + "!", 1),
      (b(!0), C($e, null, ke(t.messages, (o) => (b(), C("div", {
        class: "text",
        key: o,
        innerHTML: o
      }, null, 8, MH))), 128))
    ]));
  }
});
function Iie(e) {
  const t = {
    event: "checkoutAeroplan",
    aeroplanElement: "Points Tier Selector - Aeroplan Banner"
  };
  e && (t.aeroplanElementValue = e), window.dataLayer.push(t);
}
function LH(e, t) {
  const n = {
    event: NH(e),
    aeroplanElement: "Points Tier Selector - Booking Summary",
    aeroplanElementValue: t
  };
  window.dataLayer.push(n);
}
function NH(e) {
  switch (e) {
    case "FlightDetails":
      return "flightAeroplan";
    case "Ancillary":
      return "ancilAeroplan";
    case "ProductDetails":
      return "pdpAeroplan";
    default:
      return "undefined component name";
  }
}
const FH = () => {
  iy("Join Aeroplan");
}, RH = () => {
  iy("Aeroplan number(s)");
};
function iy(e) {
  const t = {
    event: "confirmationAeroplan",
    aeroplanElement: e
  };
  window.dataLayer.push(t);
}
const VH = () => {
  od("Sign In");
}, BH = () => {
  od("Continue As Guest");
}, HH = () => {
  od("Close the Overlay (X)");
};
function od(e) {
  const t = {
    event: "signInCheckoutModal",
    modalOption: e
  };
  window.dataLayer.push(t);
}
function Eie(e, t, n, o) {
  UH(t, n, o, e);
}
function UH(e, t, n, o) {
  const s = {
    event: "ancillary_cont_booking",
    ancillariesSelected: o,
    ecommerce: {
      items: [kl(e, t, n)]
    }
  };
  window.dataLayer.push({ ecommerce: null }), window.dataLayer.push(s);
}
var Tu = /* @__PURE__ */ ((e) => (e.show = "Show Options", e.hide = "Hide Options", e))(Tu || {});
function zH(e, t) {
  const n = {
    event: "ancillaryOptions",
    ancillaryGroup: ep.get(e) ?? "",
    ancillaryOption: t
  };
  window.dataLayer.push(n);
}
function ly(e, t) {
  const n = {
    event: "ancillaryProduct",
    ancillaryGroup: ep.get(e) ?? "",
    ancillaryProduct: t
  };
  window.dataLayer.push(n);
}
function WH(e, t) {
  const n = {
    event: "ancillarySubOptions",
    ancillaryGroup: ep.get(e) ?? "",
    ancillaryProduct: t
  };
  window.dataLayer.push(n);
}
function jH(e) {
  const t = {
    event: "checkoutPromoCode",
    chkPromoCode: e
  };
  window.dataLayer.push(t);
}
function Oie() {
  const e = {
    event: "checkoutUpdateInfo"
  };
  window.dataLayer.push(e);
}
function qH() {
  const e = {
    event: "checkoutEngDocs"
  };
  window.dataLayer.push(e);
}
async function xie(e) {
  var w, y, $, S, A, I, D, O, x, F, P, E, B, N, Y, j;
  const t = ml(e), n = (w = t == null ? void 0 : t.selectedOptionIds) == null ? void 0 : w.travelProtectionIds, o = (y = e == null ? void 0 : e.ancillaryOptions) == null ? void 0 : y.travelProtections;
  let s = "N/A";
  n && o && (s = Object.values(
    o
  ).filter(
    (te) => n == null ? void 0 : n.includes(
      Object.values(te.subOptions)[0].id
    )
  ).map((te) => te).map((te) => te.title).join("&"));
  const a = (S = ($ = e == null ? void 0 : e.payment) == null ? void 0 : $.creditCards) == null ? void 0 : S.length, r = ((A = e == null ? void 0 : e.payment) == null ? void 0 : A.aeroplanPoints) != null, i = KH(e == null ? void 0 : e.payment), l = (O = (D = (I = e == null ? void 0 : e.payment) == null ? void 0 : I.aeroplanPoints) == null ? void 0 : D[0]) == null ? void 0 : O.amountOfPoints, c = (x = e == null ? void 0 : e.payment) == null ? void 0 : x.isMinDepositApplied, u = (F = e == null ? void 0 : e.passengers) == null ? void 0 : F.some(
    (ee) => ee.aeroplanNum
  ), p = ((E = (P = e == null ? void 0 : e.passengers) == null ? void 0 : P[0]) == null ? void 0 : E.emailAddress) ?? "", f = await UD(p), m = {
    id: Number(e == null ? void 0 : e.bookingNumber),
    revenue: (t == null ? void 0 : t.pricing.total) ?? NaN,
    coupon: ((N = (B = t == null ? void 0 : t.pricing) == null ? void 0 : B.promo) == null ? void 0 : N.code) ?? "N/A",
    pax_per_booking: (Y = e == null ? void 0 : e.passengers) == null ? void 0 : Y.length,
    travel_protection: s,
    activity_ticket_name: h(
      t == null ? void 0 : t.selectedOptionIds,
      e.ancillaryOptions
    ),
    payment_type: Rb(a, r, i),
    payment_plan: c ? "Book With a Deposit" : "Pay in Full",
    aeroplan_accumulation: !!u,
    aeroplan_redemption: l,
    hema: f
  };
  function h(ee, te) {
    if (ee != null && ee.activityIds && (te != null && te.activities)) {
      const ce = tb(
        ee,
        te
      );
      return ce ? Object.values(ce.activities).map(
        (H) => Object.values(H.subOptions).map((oe) => oe.title).join("; ")
      ).join("; ") : "N/A";
    }
    return "N/A";
  }
  const g = jg(e), _ = t == null ? void 0 : t.hotelId, v = _ ? (j = e.hotels) == null ? void 0 : j[_] : void 0;
  t && v && GH(
    m,
    e,
    t,
    g == null ? void 0 : g.itinerary,
    v
  );
}
function KH(e) {
  var t;
  if ((t = e == null ? void 0 : e.creditCards) != null && t.length) {
    const n = e.creditCards[0];
    return "correlation" in n && "trace" in n;
  }
  return !1;
}
const Au = (e, t) => {
  if ("itineraries" in e) {
    const n = Object.values(e.itineraries)[0].segments;
    if (n) {
      const o = [
        ...new Set(n.map((r) => r.cabinClassName))
      ], s = wl(
        Object.values(e.itineraries)[0]
      ), a = Object.values(e.hotels ?? {}).map((r) => r.name).join(", ");
      YH(
        t,
        o.toString().replace(",", ";"),
        Sl(s),
        a
      );
    }
  }
};
function YH(e, t, n, o) {
  const s = {
    event: e,
    budgetProductLine: n,
    cabinClass: t
  };
  e === "confirmationPrivTransfer" && o && (s.confHotelName = o), window.dataLayer.push(s);
}
function GH(e, t, n, o, s) {
  window.dataLayer.push({ ecommerce: null }), window.dataLayer.push(
    ZH(e, t, n, o, s)
  );
}
function ZH(e, t, n, o, s) {
  var a, r, i, l;
  return {
    event: "purchase",
    ecommerce: {
      transaction_id: t.bookingNumber,
      affiliation: "ACV.com",
      value: n.pricing.total,
      net_revenue: XH((a = n == null ? void 0 : n.pricing) == null ? void 0 : a.perPaxType),
      currency: "CAD",
      coupon: ((i = (r = n == null ? void 0 : n.pricing) == null ? void 0 : r.promo) == null ? void 0 : i.code) ?? "N/A",
      pax_per_booking: (l = t == null ? void 0 : t.passengers) == null ? void 0 : l.length,
      travel_protection: e.travel_protection,
      activity_ticket_name: e.activity_ticket_name,
      payment_type: e.payment_type ?? "",
      payment_plan: e.payment_plan,
      aeroplan_accumulation: e.aeroplan_accumulation,
      aeroplan_redemption: e.aeroplan_redemption ?? "",
      hema: e.hema,
      items: [EO(n, o, s)]
    }
  };
}
function XH(e = []) {
  return e.map((t) => t.price && t.paxCount ? t.price * t.paxCount : 0).reduce((t, n) => t + n, 0);
}
function Mie(e, t, n, o) {
  JH(t, n, o, e);
}
function JH(e, t, n, o) {
  window.dataLayer.push({ ecommerce: null });
  const s = {
    event: "flight_cont_booking",
    flightPosition: o + 1,
    //For SPA position start from 0, for analytical it starts at 1
    ecommerce: {
      items: [kl(e, t, n)]
    }
  };
  window.dataLayer.push(s);
}
function Lie(e, t) {
  const n = {
    event: "flightSelect",
    flightType: e,
    flightCabinClass: t
  };
  window.dataLayer.push(n);
}
function QH(e) {
  const n = {
    event: "flightFilter",
    filterName: "Flight Filter",
    filterValue: {
      allStops: "All Stops",
      directFlightsOnly: "Direct Flights",
      oneStopOrLess: "One Stop or Fewer"
    }[e]
  };
  window.dataLayer.push(n);
}
function Nie(e) {
  const t = /* @__PURE__ */ new Map();
  for (const [n, o] of e)
    t.set(n, [...o].join(" > "));
  e8(t);
}
function e8(e) {
  window.dataLayer.push({
    event: "paxInfoFormAbandonment",
    ...Object.fromEntries(e.entries())
  });
}
function Fie(e, t, n, o, s) {
  if (e) {
    const r = `pifCompFields${n === "adult" ? "Adult" : "Child"}${t}`;
    if (s.get(r)) {
      const i = s.get(r);
      i && s.set(r, i.add(o));
    } else
      s.set(r, /* @__PURE__ */ new Set([o]));
  }
}
function Rie(e, t, n) {
  window.dataLayer.push({ ecommerce: null }), window.dataLayer.push(t8(e, t, n));
}
function t8(e, t, n) {
  return {
    event: "add_passenger_info",
    ecommerce: {
      items: [kl(e, t, n)]
    }
  };
}
function n8(e, t, n, o, s, a) {
  window.dataLayer.push({ ecommerce: null });
  const r = {
    event: "add_payment_info",
    payment_plan: a8(o, s),
    //  'Payment plan selected by user: one of [Pay in Full] OR [Pay Monthly] OR [Book With a Deposit]>',
    payment_type: a,
    // 'payment_type': '<Payment option selected by user: one or more of [Gift Card/Coupon/Voucher] OR [FTC] OR [Credit Card] OR [Flex Pay] OR [Aeroplan Points]>',
    ecommerce: {
      items: [r8(e, t, n)]
    }
  };
  window.dataLayer.push(r);
}
function o8(e) {
  window.dataLayer.push({ ecommerce: null });
  const t = {
    event: "checkoutPaymentToggle",
    chkPayToggleElement: e
  };
  window.dataLayer.push(t);
}
function s8(e) {
  const t = {
    event: "checkoutPaymentMethod",
    checkoutPayMethod: e
  };
  window.dataLayer.push(t);
}
function a8(e, t) {
  return e ? "Book With a Deposit" : t ? "Pay Monthly" : "Pay in Full";
}
function r8(e, t, n) {
  return kl(e, t, n);
}
function Vie(e, t, n, o, s) {
  i8(e, t, n, o, s), l8(e, t, n, o, s);
}
function i8(e, t, n, o, s) {
  window.dataLayer.push({ ecommerce: null });
  const a = {
    event: "add_to_cart",
    ecommerce: {
      items: [ss(e, t, o, n, s)]
    }
  };
  window.dataLayer.push(a);
}
function l8(e, t, n, o, s) {
  window.dataLayer.push({ ecommerce: null });
  const a = {
    event: "begin_checkout",
    ecommerce: {
      items: [ss(e, t, o, n, s)]
    }
  };
  window.dataLayer.push(a);
}
function Bie(e, t, n, o, s) {
  window.dataLayer.push({ ecommerce: null }), window.dataLayer.push(
    c8(e, t, n, o, s)
  );
}
function c8(e, t, n, o, s) {
  return {
    event: "view_item",
    ecommerce: {
      items: [ss(e, t, o, n, s)]
    }
  };
}
function u8() {
  const e = {
    event: "pageElements",
    pageElementName: "Back to Top Button",
    mpePageURL: document.location.href
  };
  window.dataLayer.push(e);
}
function Hie() {
  const e = {
    event: "pageElements",
    pageElementName: "Show More Results Button",
    mpePageURL: document.location.href
  };
  window.dataLayer.push(e);
}
function Uie(e) {
  const t = {
    event: "plpSorting",
    sortingRule: e
  };
  window.dataLayer.push(t);
}
function zie(e) {
  const t = p8(e);
  if (t.length > 0) {
    const n = {
      event: "view_item_list",
      ecommerce: {
        items: t
      }
    };
    window.dataLayer.push(n);
  }
}
function Wie(e) {
  const n = {
    event: "searchResults",
    ...Tl(e)
  };
  window.dataLayer.push(n);
}
function jie(e, t) {
  const n = Tl(e), o = n.cabinClass;
  if (e.information) {
    const s = PO(e.information), a = {
      event: "altCabinSearchResults",
      ...n,
      cabinClass: t ? "Searched Cabin Available Along With Other Cabins" : "Searched Cabin Not Available",
      searchedCabinClass: o,
      returnedCabinClass: s
    };
    window.dataLayer.push(a);
  }
}
function qie(e) {
  const n = {
    event: "altDateSearchResults",
    ...Tl(e)
  };
  window.dataLayer.push(n);
}
function p8(e) {
  var s;
  const t = e.results;
  if (!t)
    return [];
  const n = ((s = t == null ? void 0 : t.metaData) == null ? void 0 : s.currentStart) ?? 0;
  return cy(t).map((a, r) => {
    var u, p, f;
    const i = e.hotels[a.hotelId], l = "itineraries" in e ? (p = e.itineraries) == null ? void 0 : p[(u = a.selectedOptionIds) == null ? void 0 : u.itineraryId] : void 0, c = "triggers" in e ? (f = e.triggers) == null ? void 0 : f[a.id] : void 0;
    return ss(
      r + n,
      a,
      i,
      l,
      c
    );
  });
}
function cy(e) {
  return e ? "packages" in e ? e.packages : "hotelPackages" in e ? e.hotelPackages : [] : [];
}
function Kie(e) {
  let t = "Destination Has No Results", n = "noSearchResults";
  switch (e) {
    case Rn.INCORRECT_SEARCH:
      t = "Generic - No Availability";
      break;
    case Rn.INVALID_NUM_ROOM_CHILD:
      t = "Children - More Than 1 Room", n = "errorDL";
      break;
    case Rn.INVALID_OCCUPANCY:
      t = "More Than 6 PAX", n = "errorDL";
      break;
  }
  const s = {
    ...Tl(),
    event: n,
    noSearchResultsErrorMessage: t
  };
  window.dataLayer.push(s);
}
function Tl(e) {
  const t = new URLSearchParams(window.location.search), n = cy(e == null ? void 0 : e.results), o = n.length, s = e && "itineraries" in e ? wl(Object.values((e == null ? void 0 : e.itineraries) ?? {})[0]) : "", a = t.get("flexibleDuration"), r = Bi() > 0 ? Bi() : "", i = s ?? DO();
  return {
    productType: IO(n),
    budgetProductLine: Sl(i),
    noSearchResults: !o,
    dateSelectionType: a ? "Flexible" : "Exact",
    destinationSearchSuggestionType: t.get(
      "arrivalLocationSuggestionType"
    ) ?? "",
    gatewayAirportCode: e && "itineraries" in e ? Zp(Object.values((e == null ? void 0 : e.itineraries) ?? {})[0]) : "",
    destinationAirportCode: s ?? "N/A",
    destinationName: t.get("arrivalLocationName") ?? "",
    departureDate: Kg(
      fr(),
      "dd/mm/yyyy",
      "yyyy-mm-dd"
    ),
    flexibleDateDuration: Ts(a) ?? 0,
    tripDuration: r,
    bookToTravelWindow: qg(
      t.get("departingDateTime")
    ),
    numberOfRooms: Ts(t.get("numberOfRooms")) ?? "",
    numberOfAdults: Ts(t.get("nb_adult")) ?? "",
    numberOfChildren: t.get("nb_child") ? Ts(t.get("nb_child")) : 0,
    cabinClass: j$.get(
      t.get("cabinClass")
    )
  };
}
function d8(e, t, n, o, s) {
  window.dataLayer.push({ ecommerce: null });
  const a = {
    event: "select_item",
    ecommerce: {
      items: [
        f8(e, t, n, o, s)
      ]
    }
  };
  window.dataLayer.push(a);
}
function f8(e, t, n, o, s) {
  var r;
  return {
    ...ss(e, t, n, o, s),
    product_badge: n.recommended ? "Our Recommendation" : "none",
    rate_type: ((r = t.information) == null ? void 0 : r.refundable) === !0 ? "Refundable" : "Non-refundable",
    hotel_type: "dynamicPackage" in t && t.dynamicPackage ? "External" : "Internal"
  };
}
function Vt(e, t) {
  const n = {
    event: "plpTiles",
    tileElementName: e,
    tileElementValue: t
  };
  window.dataLayer.push(n);
}
async function Yie(e, t, n, o, s) {
  const a = {
    event: "vpv",
    virtualPageUrl: t,
    virtualPageTitle: n,
    spaType: e,
    virtualLanguage: o,
    virtualAudience: await Vb(s),
    virtualSignInStatus: Bb(s),
    virtualPageType: "PLP",
    virtualUserID: NO(s)
  };
  window.dataLayer.push(a);
}
function Gie(e) {
  const t = {
    event: "carePlanModal",
    modalOption: m8(e)
  };
  window.dataLayer.push(t);
}
function m8(e) {
  switch (e) {
    case "close":
      return "Close the Overlay (X)";
    case "":
      return "Decline Travel Protection";
    default:
      return "Protect My Booking";
  }
}
const v8 = { class: "confirm-aeroplan-section" }, h8 = { class: "logo" }, g8 = ["src", "alt"], b8 = ["innerHTML"], y8 = ["innerHTML"], $8 = { class: "button-wrapper" }, _8 = ["href"], w8 = { key: 0 }, C8 = ["innerHTML"], k8 = { class: "text" }, S8 = ["href"], Zie = /* @__PURE__ */ K({
  __name: "ConfirmationAeroplanEnroll",
  props: {
    cdnBaseUrl: {},
    showAddAeroplanMessage: { type: Boolean, default: !0 }
  },
  setup(e) {
    const t = () => {
      FH();
    }, n = () => {
      RH();
    };
    return (o, s) => (b(), C("section", v8, [
      d("div", h8, [
        d("img", {
          src: `${o.cdnBaseUrl}/img/aeroplan-logo.svg`,
          alt: o.$t("vacvComponents.common.labels.aeroplan")
        }, null, 8, g8)
      ]),
      d("div", {
        class: "text",
        innerHTML: o.$t("vacvComponents.confirmation.messages.aeroplanEnroll")
      }, null, 8, b8),
      d("div", {
        class: "text",
        innerHTML: o.$t("vacvComponents.confirmation.messages.aeroplanBenefits")
      }, null, 8, y8),
      d("div", $8, [
        d("a", {
          href: o.$t("vacvComponents.confirmation.labels.aeroplanJoinLink"),
          target: "_blank",
          onClick: t,
          class: "vacv-btn-primary",
          rel: "noreferrer noopener"
        }, k(o.$t("vacvComponents.confirmation.labels.aeroplanJoin")), 9, _8)
      ]),
      o.showAddAeroplanMessage ? (b(), C("div", w8, [
        d("div", {
          class: "text",
          innerHTML: o.$t("vacvComponents.confirmation.messages.aeroplanAlready")
        }, null, 8, C8),
        d("div", k8, [
          d("a", {
            href: o.$t("vacvComponents.confirmation.labels.aeroplanAddNumberLink"),
            target: "_blank",
            onClick: n,
            class: "link addNumber",
            rel: "noreferrer noopener"
          }, k(o.$t("vacvComponents.confirmation.labels.aeroplanAddNumber")), 9, S8)
        ])
      ])) : M("", !0)
    ]));
  }
}), T8 = { class: "tp-product" }, A8 = {
  key: 0,
  class: "logo"
}, D8 = ["src"], P8 = {
  key: 1,
  class: "logo fallback"
}, I8 = ["src"], E8 = { class: "h2style" }, O8 = {
  key: 2,
  class: "content"
}, x8 = { class: "text" }, M8 = ["innerHTML"], L8 = {
  key: 3,
  class: "content"
}, N8 = { class: "text" }, F8 = /* @__PURE__ */ K({
  __name: "ConfirmationAncillaryProduct",
  props: {
    ancillary: {}
  },
  setup(e) {
    var u;
    const { ancillary: t } = e, { t: n } = Ne(), o = Ye("cdnBaseUrl"), s = t.type === "travelProtection", a = s ? (u = t == null ? void 0 : t.category) == null ? void 0 : u.toUpperCase() : null, r = t.title, i = n("vacvComponents.ancillary.labels.travelprotection") + " - " + r, l = s ? i : r, c = Object.values(t.subOptions)[0].title;
    return (p, f) => (b(), C("div", T8, [
      p.ancillary.icon ? (b(), C("div", A8, [
        d("img", {
          src: p.ancillary.icon,
          width: "80",
          alt: ""
        }, null, 8, D8)
      ])) : (b(), C("div", P8, [
        d("img", {
          src: `${T(o)}/img/fallback-img.jpg`,
          width: "90",
          alt: ""
        }, null, 8, I8)
      ])),
      d("h4", E8, k(T(l)), 1),
      T(a) ? (b(), C("div", O8, [
        d("div", x8, k(p.$t(
          `vacvComponents.confirmation.labels.${T(a)}.inclusions`
        )), 1),
        d("div", {
          innerHTML: p.$t(
            "vacvComponents.confirmation.messages.ancillaryTravelProtectionLink"
          )
        }, null, 8, M8)
      ])) : (b(), C("div", L8, [
        d("div", N8, k(T(c)), 1)
      ]))
    ]));
  }
}), uy = (e) => (dn("data-v-5ccd10bb"), e = e(), fn(), e), R8 = {
  class: "confirm-summary-hotel",
  "data-test": "confirm-summary-hotel"
}, V8 = { class: "vacv-section-title" }, B8 = { class: "summary-hotel-wrapper" }, H8 = {
  key: 0,
  class: "hotel-image"
}, U8 = ["src", "alt"], z8 = { class: "hotel-info" }, W8 = { class: "h2style" }, j8 = { class: "stars" }, q8 = /* @__PURE__ */ uy(() => /* @__PURE__ */ d("i", {
  class: "fa-solid fa-star",
  "aria-hidden": "true"
}, null, -1)), K8 = /* @__PURE__ */ uy(() => /* @__PURE__ */ d("span", { class: "sr-only" }, "stars", -1)), Y8 = {
  key: 0,
  class: "room-type"
}, G8 = { class: "hotel-checkinout" }, Z8 = { key: 0 }, X8 = { key: 0 }, J8 = /* @__PURE__ */ K({
  __name: "ConfirmationHotel",
  props: {
    hotel: {},
    checkIn: {},
    checkOut: {},
    roomId: {}
  },
  setup(e) {
    var i, l;
    const t = e, n = t.checkIn ? sn(t.checkIn) : null, o = t.checkOut ? sn(t.checkOut) : null, s = V(() => {
      var h, g, _, v, w, y, $, S;
      const c = (_ = (g = (h = t.hotel) == null ? void 0 : h.media) == null ? void 0 : g.images) == null ? void 0 : _[0], u = (y = (w = (v = t.hotel) == null ? void 0 : v.media) == null ? void 0 : w.sizes) == null ? void 0 : y.small, p = (S = ($ = t.hotel) == null ? void 0 : $.media) == null ? void 0 : S.variations;
      if (!(c != null && c.url) || !u)
        return null;
      const f = $i(
        c.url.replace("{SIZE}", u),
        "tabletLandscape",
        p
      ), m = c.altText ?? c.description ?? "";
      return { url: f, alt: m };
    }), a = t.roomId ? (l = (i = t.hotel) == null ? void 0 : i.rooms) == null ? void 0 : l[t.roomId] : null, r = a != null && a.mealPlanName ? " - " + a.mealPlanName : "";
    return (c, u) => {
      var p, f;
      return b(), C("div", R8, [
        d("h3", V8, k(c.$t("vacvComponents.confirmation.labels.hotelTitle")), 1),
        d("div", B8, [
          s.value ? (b(), C("div", H8, [
            d("img", {
              src: s.value.url,
              alt: s.value.alt
            }, null, 8, U8)
          ])) : M("", !0),
          d("div", z8, [
            d("h3", W8, [
              ne(k(c.hotel.name), 1),
              d("span", j8, [
                ne(k(c.hotel.starCategory), 1),
                q8,
                K8
              ])
            ]),
            c.roomId && ((f = (p = c.hotel) == null ? void 0 : p.rooms) != null && f[c.roomId].name) ? (b(), C("div", Y8, k(c.hotel.rooms[c.roomId].name) + k(T(r)), 1)) : M("", !0),
            d("div", G8, [
              d("span", null, [
                ne(k(c.$t("vacvComponents.confirmation.labels.checkInTime")) + " ", 1),
                T(n) ? (b(), C("span", Z8, k(c.$d(T(n), "short")), 1)) : M("", !0)
              ]),
              d("span", null, [
                ne(k(c.$t("vacvComponents.confirmation.labels.checkOutTime")) + " ", 1),
                T(o) ? (b(), C("span", X8, k(c.$d(T(o), "short")), 1)) : M("", !0)
              ])
            ])
          ])
        ])
      ]);
    };
  }
}), Q8 = /* @__PURE__ */ De(J8, [["__scopeId", "data-v-5ccd10bb"]]), e4 = ["data-transfer"], t4 = { class: "vacv-section-title" }, n4 = ["innerHTML"], o4 = /* @__PURE__ */ K({
  __name: "ConfirmationTransfer",
  props: {
    transfer: {},
    destination: {}
  },
  setup(e) {
    const { transfer: t } = e;
    return (n, o) => (b(), C("div", {
      class: "confirm-transfer",
      "data-test": "confirm-transfer",
      "data-transfer": n.transfer
    }, [
      d("h3", t4, k(n.$t(`vacvComponents.confirmation.labels.${n.transfer}`)), 1),
      d("div", {
        innerHTML: n.$t(`vacvComponents.confirmation.messages.${n.transfer}`, {
          destination: n.destination
        })
      }, null, 8, n4)
    ], 8, e4));
  }
}), s4 = { class: "confirm-insurance-section" }, a4 = { class: "vacv-section-title" }, r4 = { class: "logo-wrapper" }, i4 = { class: "logo" }, l4 = ["src"], c4 = { class: "logo-title" }, u4 = { class: "text" }, p4 = { class: "button-wrapper" }, d4 = ["innerHTML"], f4 = { class: "note" };
var py = /* @__PURE__ */ ((e) => (e.en = "https://sales.allianz-assistance.ca/en-US/aircanadavacations/Sales/Quote", e.fr = "https://sales.allianz-assistance.ca/fr-CA/aircanadavacations/Sales/Quote", e))(py || {});
const m4 = /* @__PURE__ */ K({
  __name: "ConfirmationTravelInsurance",
  props: {
    booking: {},
    language: {}
  },
  setup(e) {
    const t = e, n = Ye("cdnBaseUrl"), o = () => {
      Au(t.booking, "confirmationTravelInsurance"), window.open(
        py[t.language],
        "_blank",
        "noreferrer"
      );
    };
    return (s, a) => (b(), C("section", s4, [
      d("h3", a4, k(s.$t("vacvComponents.confirmation.labels.insuranceTitle")), 1),
      d("div", r4, [
        d("div", i4, [
          d("img", {
            src: `${T(n)}/img/allianz-global-assistance-logo.png`,
            width: "90",
            alt: ""
          }, null, 8, l4)
        ]),
        d("div", c4, k(s.$t("vacvComponents.confirmation.labels.insuranceLogoTitle")), 1)
      ]),
      d("div", u4, k(s.$t("vacvComponents.confirmation.labels.insuranceDescription")), 1),
      d("div", p4, [
        d("button", {
          class: "vacv-btn-primary",
          onClick: a[0] || (a[0] = (r) => o())
        }, k(s.$t("vacvComponents.confirmation.labels.insuranceBtn")), 1)
      ]),
      d("div", {
        class: "insurance-contact",
        innerHTML: s.$t("vacvComponents.confirmation.labels.insuranceContact")
      }, null, 8, d4),
      d("div", f4, k(s.$t("vacvComponents.confirmation.labels.insuranceNote")), 1)
    ]));
  }
}), v4 = { class: "h1style" }, h4 = {
  key: 0,
  class: "private-transfer-section"
}, g4 = { class: "vacv-section-title" }, b4 = { class: "private-transfer-wrapper" }, y4 = { class: "private-transfer-image" }, $4 = ["src", "alt"], _4 = ["src", "alt"], w4 = { class: "text" }, C4 = { class: "button-wrapper" }, k4 = ["href"], S4 = { class: "confirm-seatselection-section" }, T4 = { class: "vacv-section-title" }, A4 = { class: "spa-list special-list details-2col" }, D4 = ["innerHTML"], P4 = { class: "button-wrapper" }, I4 = ["href"];
var Du = /* @__PURE__ */ ((e) => (e.en = "https://vacations.aircanada.com/en/travel-info/manage-your-booking", e.fr = "https://vacations.aircanada.com/fr/infos-de-voyage/gestion-reservation", e))(Du || {});
const E4 = /* @__PURE__ */ K({
  __name: "ConfirmationGetReady",
  props: {
    booking: {},
    language: {}
  },
  setup(e) {
    var f, m, h;
    const t = e, n = Ye("cdnBaseUrl"), o = t.booking.tripLink ?? Du[t.language], s = () => {
      Au(t.booking, "confirmationSeatSelect"), window.open(o, "_blank", "noreferrer");
    }, a = Du[t.language], r = () => {
      Au(t.booking, "confirmationPrivTransfer"), window.open(a, "_blank", "noreferrer");
    }, i = ml(t.booking), l = ((f = i == null ? void 0 : i.selectedOptionIds) == null ? void 0 : f.privateTransferId) ?? "", c = ((h = (m = t.booking) == null ? void 0 : m.ancillaryOptions) == null ? void 0 : h.privateTransfers) ?? {}, u = Object.values(c).find(
      (g) => Object.values(g.subOptions)[0].id === l
    ) ?? void 0, p = Object.values(c)[0];
    return (g, _) => {
      var v;
      return b(), C($e, null, [
        d("h2", v4, k(g.$t("vacvComponents.confirmation.labels.getReadyTitle")), 1),
        !T(u) && ((v = T(p)) != null && v.title) ? (b(), C("section", h4, [
          d("h3", g4, k(T(p).title), 1),
          d("div", b4, [
            d("div", y4, [
              T(p).icon ? (b(), C("img", {
                key: 0,
                src: T(p).icon,
                alt: T(p).title
              }, null, 8, $4)) : (b(), C("img", {
                key: 1,
                src: `${T(n)}/img/carousel-fallback-img_${g.language}.jpg`,
                alt: g.$t("vacvComponents.common.messages.fallback-img")
              }, null, 8, _4))
            ]),
            d("div", null, [
              d("div", w4, k(g.$t("vacvComponents.confirmation.labels.privateTransferDescription")), 1),
              d("div", C4, [
                d("a", {
                  class: "vacv-btn-primary",
                  href: T(a),
                  target: "_blank",
                  rel: "noreferrer",
                  onClick: Ke(r, ["prevent"])
                }, k(g.$t("vacvComponents.confirmation.labels.privateTransferButton")), 9, k4)
              ])
            ])
          ])
        ])) : M("", !0),
        d("section", S4, [
          d("h3", T4, k(g.$t("vacvComponents.confirmation.labels.seatSelTitle")), 1),
          d("ul", A4, [
            d("li", null, k(g.$t("vacvComponents.confirmation.labels.seatSelOption1")), 1),
            d("li", {
              innerHTML: g.$t("vacvComponents.confirmation.labels.seatSelOption2")
            }, null, 8, D4),
            d("li", null, k(g.$t("vacvComponents.confirmation.labels.seatSelOption3")), 1)
          ]),
          d("div", P4, [
            d("a", {
              class: "vacv-btn-primary",
              href: T(o),
              target: "_blank",
              rel: "noreferrer",
              onClick: Ke(s, ["prevent"])
            }, k(g.$t("vacvComponents.confirmation.labels.seatSelBtn")), 9, I4)
          ])
        ])
      ], 64);
    };
  }
}), O4 = {
  key: 0,
  class: "opc-tax opc-tax--section"
}, x4 = /* @__PURE__ */ K({
  __name: "OpcTaxRow",
  props: {
    opcTax: {}
  },
  setup(e) {
    return (t, n) => t.opcTax > 0 ? (b(), C("div", O4, [
      q(Qn, {
        title: t.$t("vacvComponents.confirmation.labels.CFCTA"),
        value: T(Se)(t.opcTax, t.$n)
      }, null, 8, ["title", "value"])
    ])) : M("", !0);
  }
}), M4 = /* @__PURE__ */ De(x4, [["__scopeId", "data-v-af8007e8"]]), L4 = {
  key: 0,
  class: "promo-code"
}, N4 = /* @__PURE__ */ K({
  __name: "PromoCodeRow",
  props: {
    prePackagePricing: {}
  },
  setup(e) {
    const t = e, n = V(
      () => {
        var o, s, a, r;
        return ((s = (o = t.prePackagePricing) == null ? void 0 : o.promo) == null ? void 0 : s.value) && ((r = (a = t.prePackagePricing) == null ? void 0 : a.promo) == null ? void 0 : r.value) > 0;
      }
    );
    return (o, s) => {
      var a, r, i, l;
      return n.value ? (b(), C("div", L4, [
        q(Qn, {
          title: o.$t("vacvComponents.prices.labels.promoCode") + " " + (((r = (a = o.prePackagePricing) == null ? void 0 : a.promo) == null ? void 0 : r.code) ?? ""),
          value: "-" + T(Se)((l = (i = o.prePackagePricing) == null ? void 0 : i.promo) == null ? void 0 : l.value, o.$n),
          "value-classes": "text-red",
          class: "bdrow--small"
        }, null, 8, ["title", "value"])
      ])) : M("", !0);
    };
  }
}), F4 = /* @__PURE__ */ De(N4, [["__scopeId", "data-v-c67696b6"]]), R4 = /* @__PURE__ */ K({
  __name: "DepositRow",
  props: {
    prePackagePricing: {},
    totalPrice: {},
    dueAmount: {},
    reverseOrder: { type: Boolean },
    modifier: {},
    isSection: { type: Boolean },
    insurancePremium: {},
    lang: {}
  },
  setup(e) {
    const { t, d: n, n: o } = Ne({ useScope: "global" }), s = e, a = V(() => {
      var u, p;
      return s.dueAmount ? ((u = s == null ? void 0 : s.prePackagePricing) == null ? void 0 : u.minimumDeposit) ?? 0 : (p = s == null ? void 0 : s.prePackagePricing) != null && p.minimumDeposit ? (s == null ? void 0 : s.prePackagePricing.minimumDeposit) + s.insurancePremium : 0;
    }), r = V(() => {
      if (s.dueAmount)
        return s.dueAmount;
      if (s.totalPrice)
        return s.totalPrice - a.value;
    }), i = V(() => {
      var u;
      if ((u = s == null ? void 0 : s.prePackagePricing) != null && u.minimumDepositDueDate)
        return s.dueAmount ? n(
          sn(
            s.prePackagePricing.minimumDepositDueDate
          ),
          "short"
        ) : Me.fromFormat(
          s.prePackagePricing.minimumDepositDueDate,
          "yyyyMMdd"
        ).setLocale(s.lang).toFormat(s.lang === "fr" ? "dd LLL yyyy" : "LLL. dd, yyyy");
    }), l = V(() => s != null && s.reverseOrder ? t(
      "vacvComponents.prices.deposit-payment-remaining-balance-mobile-message",
      {
        remaining: Se(r.value, o),
        date: i.value
      }
    ) : t(
      "vacvComponents.prices.deposit-payment-remaining-balance-message",
      { date: i.value }
    )), c = V(() => ({
      "bdrow--deposit": s.modifier === "deposit",
      "bdrow--confirmation-deposit": s.modifier === "confirmation-deposit",
      "bdrow--mobile-deposit": s.modifier === "mobile-deposit"
    }));
    return (u, p) => a.value > 0 ? (b(), C("div", {
      key: 0,
      class: ue(["grand-total depositrow", { "deposit--section": u.isSection }]),
      "data-test": "minimum-deposit"
    }, [
      q(Qn, {
        title: u.$t("vacvComponents.prices.deposit"),
        value: T(Se)(a.value, u.$n),
        reverseOrder: u.reverseOrder,
        class: "bdrow--deposit-grand"
      }, null, 8, ["title", "value", "reverseOrder"]),
      q(Qn, {
        title: l.value,
        value: s != null && s.reverseOrder ? void 0 : T(Se)(r.value, u.$n),
        class: ue(["depositrow--balance", c.value]),
        titleClasses: "depositrow--balance--title"
      }, null, 8, ["title", "value", "class"])
    ], 2)) : M("", !0);
  }
}), V4 = /* @__PURE__ */ De(R4, [["__scopeId", "data-v-8d4fb565"]]), B4 = { class: "total-title" }, H4 = { key: 0 }, U4 = { key: 1 }, z4 = { class: "total-grand" }, Cm = /* @__PURE__ */ K({
  __name: "PricePaymentMethods",
  props: {
    amount: {},
    cardNumber: {},
    type: {},
    creditCardType: {}
  },
  setup(e) {
    const t = e, n = (s) => s.charAt(0).toUpperCase() + s.slice(1), o = () => String(t.cardNumber).slice(-4);
    return (s, a) => (b(), C($e, null, [
      d("div", B4, [
        s.type === "creditCard" ? (b(), C("span", H4, [
          ne(k(s.creditCardType && n(s.creditCardType)) + " ", 1),
          d("strong", null, k(s.$t("vacvComponents.confirmation.labels.endingWith")), 1)
        ])) : s.type === "giftCard" ? (b(), C("span", U4, k(s.$t("vacvComponents.confirmation.labels.giftCard")), 1)) : M("", !0),
        ne(" " + k(o()), 1)
      ]),
      d("div", z4, k(T(Se)(s.amount, s.$n)), 1)
    ], 64));
  }
}), W4 = { class: "hotel-accordion" }, j4 = { class: "accordion-content" }, q4 = { class: "breakdown-price-section breakdown-travellerList" }, K4 = { class: "title" }, Y4 = {
  key: 0,
  class: "description"
}, G4 = {
  key: 1,
  class: "price-row"
}, Z4 = { class: "qty" }, X4 = { key: 0 }, J4 = { class: "total" }, Q4 = {
  key: 2,
  class: "price-row"
}, e5 = { key: 0 }, t5 = { class: "total" }, n5 = {
  class: "accordion-content",
  style: { display: "none" }
}, o5 = {
  class: "vacv-form-error",
  "aria-live": "polite"
}, s5 = /* @__PURE__ */ K({
  __name: "AncillarySection",
  props: {
    ancillaries: {},
    pricing: {},
    selectedOptionIds: {}
  },
  setup(e) {
    const t = e, { t: n, n: o } = Ne({ useScope: "global" }), s = Do(), { hasSelectedAncillaries: a } = Ce(s), r = V(() => {
      var g;
      return nP((g = t.pricing) == null ? void 0 : g.perPaxType);
    }), i = V(
      () => {
        var g;
        return (g = t.ancillaries) != null && g.length ? t.ancillaries : [];
      }
    ), l = (g) => g.type === "travelProtection", c = (g) => l(g) ? n("vacvComponents.ancillary.labels.travelprotection") + " - " + g.title : g.title, u = (g) => Se(Object.values(g.subOptions)[0].price, o), p = (g) => Se(
      Object.values(g.subOptions)[0].price * r.value,
      o
    ), f = (g) => a.value ? s.geSubOptionTitle(g.id) : Object.values(g.subOptions)[0].title, m = (g) => (g == null ? void 0 : g.type) === "activity", h = (g) => (g == null ? void 0 : g.type) === "mealPlan";
    return (g, _) => (b(), C("div", W4, [
      d("div", j4, [
        d("ul", q4, [
          (b(!0), C($e, null, ke(i.value, (v) => (b(), C("li", {
            key: v == null ? void 0 : v.id
          }, [
            d("div", K4, k(c(v)), 1),
            h(v) || m(v) ? (b(), C("div", Y4, k(f(v)), 1)) : M("", !0),
            l(v) ? (b(), C("div", G4, [
              d("div", Z4, [
                ne(k(r.value) + " ", 1),
                d("span", null, [
                  ne(k(g.$t("vacvComponents.common.bookingsummary.labels.traveller")), 1),
                  r.value > 1 ? (b(), C("span", X4, "s")) : M("", !0)
                ])
              ]),
              d("div", null, "    x " + k(u(v)), 1),
              d("div", J4, k(p(v)), 1)
            ])) : (b(), C("div", Q4, [
              d("div", null, [
                d("span", null, [
                  ne(k(r.value) + " ", 1),
                  d("span", null, [
                    ne(k(g.$t("vacvComponents.common.bookingsummary.labels.traveller")), 1),
                    r.value > 1 ? (b(), C("span", e5, "s")) : M("", !0)
                  ])
                ])
              ]),
              d("div", t5, k(g.$t("vacvComponents.common.bookingsummary.labels.included")), 1)
            ]))
          ]))), 128))
        ])
      ]),
      d("div", n5, [
        d("p", o5, k(g.$t("vacvComponents.common.bookingsummary.errors.ancillary")), 1)
      ])
    ]));
  }
}), dy = /* @__PURE__ */ De(s5, [["__scopeId", "data-v-061ba829"]]), a5 = { key: 0 }, r5 = { key: 1 }, i5 = { key: 2 }, Hi = /* @__PURE__ */ K({
  __name: "FlightStops",
  props: {
    connections: {}
  },
  setup(e) {
    const t = e;
    return (n, o) => t.connections === 0 ? (b(), C("span", a5, k(n.$t("vacvComponents.flight.labels.stops", 0)), 1)) : t.connections === 1 ? (b(), C("span", r5, k(n.$t("vacvComponents.flight.labels.stops", 1)), 1)) : t.connections && t.connections > 1 ? (b(), C("span", i5, k(n.$t(
      "vacvComponents.flight.labels.stops",
      {
        count: t.connections
      },
      2
    )), 1)) : M("", !0);
  }
}), Ui = /* @__PURE__ */ K({
  __name: "FlightStopsDots",
  props: {
    connections: {}
  },
  setup(e) {
    const t = e;
    return (n, o) => (b(), C("div", null, [
      (b(!0), C($e, null, ke(t.connections, (s) => (b(), C("span", {
        key: s,
        class: ue("dot dot-" + s)
      }, null, 2))), 128))
    ]));
  }
}), l5 = { class: "flight-segment" }, c5 = {
  class: "flight-trip",
  "data-test": "flight-trip"
}, u5 = {
  class: "flight-row city-stop",
  "data-test": "city-stop"
}, p5 = {
  class: "city origin",
  "data-test": "city-origin"
}, d5 = {
  class: "code",
  "data-test": "city-origin-code"
}, f5 = {
  class: "desktop-only stops",
  "data-test": "desktop-stops"
}, m5 = {
  class: "city destination",
  "data-test": "city-destination"
}, v5 = {
  class: "code",
  "data-test": "city-destination-code"
}, h5 = {
  class: "flight-row time-duration",
  "data-test": "time-duration"
}, g5 = { class: "datetime origin" }, b5 = {
  class: "date",
  "data-test": "datetime-origin-date"
}, y5 = {
  class: "time",
  "data-test": "datetime-origin-time"
}, $5 = {
  key: 0,
  class: "desktop-only duration",
  "data-test": "desktop-duration"
}, _5 = { class: "datetime destination" }, w5 = {
  class: "date",
  "data-test": "datetime-destination-date"
}, C5 = {
  class: "time",
  "data-test": "datetime-destination-time"
}, k5 = {
  class: "mobile-only stop-duration",
  "data-test": "mobile-stop-duration"
}, S5 = {
  class: "stops",
  "data-test": "mobile-stops"
}, T5 = {
  key: 0,
  class: "duration",
  "data-test": "mobile-duration"
}, A5 = {
  key: 0,
  class: "segment-details",
  "data-test": "segment-details"
}, D5 = {
  key: 0,
  class: "airline",
  "data-test": "flight-airline"
}, P5 = {
  key: 1,
  class: "airline",
  "data-test": "flight-airline"
}, I5 = {
  key: 2,
  class: "flightnum"
}, E5 = {
  class: "cabinClass",
  "data-test": "flight-class"
}, O5 = {
  key: 1,
  class: "segment-details",
  "data-test": "segment-details"
}, x5 = { class: "info" }, M5 = {
  key: 0,
  class: "airline",
  "data-test": "flight-airline"
}, L5 = {
  key: 1,
  class: "airline",
  "data-test": "flight-airline"
}, N5 = { class: "flightnum" }, F5 = {
  class: "cabinClass",
  "data-test": "flight-class"
}, R5 = {
  key: 2,
  class: "layover",
  "data-test": "layover-block"
}, V5 = { class: "duration" }, km = /* @__PURE__ */ K({
  __name: "FlightSegment",
  props: {
    segments: {},
    expanded: { type: Boolean },
    index: {},
    displayDuration: { type: Boolean, default: !0 }
  },
  setup(e) {
    const t = e, n = t.segments[t.index].originName, o = t.segments[t.index].origin, s = t.expanded ? t.segments[t.index].destinationName : t.segments[t.segments.length - 1].destinationName, a = t.expanded ? t.segments[t.index].destination : t.segments[t.segments.length - 1].destination, r = V(
      () => t.expanded ? Ss(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        t.segments[t.index].departureDate,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        t.segments[t.index].departureTime
      ) : Ss(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        t.segments[0].departureDate,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        t.segments[0].departureTime
      )
    ), i = V(
      () => t.expanded ? Ss(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        t.segments[t.index].arrivalDate,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        t.segments[t.index].arrivalTime
      ) : Ss(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        t.segments[t.segments.length - 1].arrivalDate,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        t.segments[t.segments.length - 1].arrivalTime
      )
    ), l = V(
      () => {
        var p;
        return (p = t.segments[t.index]) == null ? void 0 : p.totalFlightDuration;
      }
    ), c = V(() => l.value ? l.value.substring(0, 2) + "h" + l.value.substring(2) : null), u = V(
      () => {
        var p;
        return ((p = t.segments[t.index]) == null ? void 0 : p.numConnections) ?? t.segments.length - 1;
      }
    );
    return (p, f) => (b(), C("div", l5, [
      d("div", c5, [
        d("div", u5, [
          d("div", p5, [
            ne(k(T(n)) + " ", 1),
            d("span", d5, k(T(o)), 1)
          ]),
          d("div", f5, [
            q(Hi, {
              connections: p.expanded ? void 0 : u.value
            }, null, 8, ["connections"]),
            q(Ui, {
              class: ue("line stop-" + u.value),
              connections: p.expanded ? void 0 : u.value
            }, null, 8, ["class", "connections"])
          ]),
          d("div", m5, [
            ne(k(T(s)) + " ", 1),
            d("span", v5, k(T(a)), 1)
          ])
        ]),
        d("div", h5, [
          q(Ui, {
            class: ue("mobile-only line stop-" + u.value),
            connections: p.expanded ? void 0 : u.value
          }, null, 8, ["class", "connections"]),
          d("div", g5, [
            d("span", b5, k(p.$d(r.value, "short")), 1),
            d("span", y5, k(p.$d(r.value, "time")), 1)
          ]),
          c.value && p.displayDuration ? (b(), C("div", $5, [
            ne(k(p.$t("vacvComponents.flight.labels.duration")) + ": ", 1),
            d("span", null, " " + k(c.value), 1)
          ])) : M("", !0),
          d("div", _5, [
            d("span", w5, k(p.$d(i.value, "short")), 1),
            d("span", C5, k(p.$d(i.value, "time")), 1)
          ])
        ])
      ]),
      d("div", k5, [
        d("div", S5, [
          q(Hi, {
            connections: p.expanded ? void 0 : u.value
          }, null, 8, ["connections"])
        ]),
        c.value && p.displayDuration ? (b(), C("div", T5, [
          ne(k(p.$t("vacvComponents.flight.labels.duration")) + ": ", 1),
          d("span", null, " " + k(c.value), 1)
        ])) : M("", !0)
      ]),
      p.expanded ? (b(), C("div", O5, [
        d("div", x5, [
          p.segments[p.index].operatingAirline ? (b(), C("span", M5, k(p.$t("vacvComponents.flight.labels.operatedBy")) + " " + k(p.segments[p.index].operatingAirline) + ", ", 1)) : (b(), C("span", L5, k(p.segments[p.index].carrierName) + ", ", 1)),
          d("span", N5, k(p.segments[p.index].carrierCode) + " " + k(p.segments[p.index].flightNumber) + ", ", 1),
          d("span", F5, k(p.segments[p.index].cabinClassName), 1)
        ])
      ])) : (b(), C("div", A5, [
        (b(!0), C($e, null, ke(p.segments, (m, h) => (b(), C("div", {
          class: "info",
          key: h
        }, [
          m.operatingAirline ? (b(), C("span", D5, k(p.$t("vacvComponents.flight.labels.operatedBy")) + " " + k(m.operatingAirline) + ", ", 1)) : (b(), C("span", P5, k(m.carrierName) + ", ", 1)),
          p.displayDuration ? M("", !0) : (b(), C("span", I5, k(m.carrierCode) + " " + k(m.flightNumber) + ", ", 1)),
          d("span", E5, k(m.cabinClassName), 1)
        ]))), 128))
      ])),
      p.expanded && p.segments[p.index].layoverDuration ? (b(), C("div", R5, [
        d("div", V5, [
          ne(k(p.$t("vacvComponents.flight.labels.layoverDuration")) + " ", 1),
          d("span", null, k(p.segments[p.index].layoverDuration), 1)
        ])
      ])) : M("", !0)
    ]));
  }
}), B5 = { class: "title-wrapper" }, H5 = { class: "flight-title-multi fa-plane" }, U5 = { class: "see" }, z5 = { class: "flights-wrapper" }, W5 = {
  key: 0,
  class: "segment-wrapper"
}, j5 = {
  key: 0,
  class: "desktop-only link-wrapper"
}, q5 = { class: "see" }, zi = /* @__PURE__ */ K({
  __name: "FlightDetailsSegmentMulti",
  props: {
    segments: {},
    displayDuration: { type: Boolean },
    modifier: {}
  },
  setup(e) {
    const t = e, n = R(!1), { t: o } = Ne({ useScope: "global" }), s = V(() => {
      var c;
      return (c = t.segments) == null ? void 0 : c[0].bound;
    }), a = V(() => s.value === "O" ? o("vacvComponents.flight.labels.departure") : o("vacvComponents.flight.labels.return")), r = V(() => n.value ? o("vacvComponents.flight.labels.hideDetails") : o("vacvComponents.flight.labels.showDetails")), i = V(() => n.value ? "fa-solid fa-circle-minus" : "fa-solid fa-circle-plus"), l = V(() => ({
      "hide-button": t.modifier === "hideButtonOnMobile"
    }));
    return (c, u) => (b(), C("div", {
      class: ue(["accordion-content", s.value])
    }, [
      d("div", B5, [
        d("div", H5, [
          d("span", null, k(a.value), 1)
        ]),
        c.segments.length > 1 ? (b(), C("div", {
          key: 0,
          class: ue(["mobile-only link-wrapper", l.value])
        }, [
          d("button", {
            class: "details-link link linklook",
            onClick: u[0] || (u[0] = (p) => n.value = !n.value)
          }, [
            d("span", U5, [
              d("i", {
                class: ue(i.value),
                "aria-hidden": "true"
              }, null, 2),
              ne(k(r.value), 1)
            ])
          ])
        ], 2)) : M("", !0)
      ]),
      d("div", z5, [
        n.value ? (b(), C("div", W5, [
          (b(!0), C($e, null, ke(c.segments, (p, f) => (b(), ie(km, {
            key: p.flightNumber,
            expanded: n.value,
            segments: c.segments,
            index: f,
            displayDuration: c.displayDuration
          }, null, 8, ["expanded", "segments", "index", "displayDuration"]))), 128))
        ])) : (b(), ie(km, {
          key: 1,
          segments: c.segments,
          expanded: n.value,
          index: 0,
          displayDuration: c.displayDuration
        }, null, 8, ["segments", "expanded", "displayDuration"]))
      ]),
      c.segments.length > 1 ? (b(), C("div", j5, [
        d("button", {
          class: "details-link link linklook",
          onClick: u[1] || (u[1] = (p) => n.value = !n.value)
        }, [
          d("span", q5, [
            d("i", {
              class: ue(i.value),
              "aria-hidden": "true"
            }, null, 2),
            ne(k(r.value), 1)
          ])
        ])
      ])) : M("", !0)
    ], 2));
  }
}), K5 = { class: "confirm-summary-section" }, Y5 = { class: "spa-col-main" }, G5 = { class: "h1style" }, Z5 = {
  key: 0,
  class: "confirm-summary-travellers"
}, X5 = { class: "vacv-section-title" }, J5 = { class: "travellers-summary" }, Q5 = { class: "paddedbox-grey" }, eU = {
  key: 0,
  class: "note--modifiedname"
}, tU = { class: "traveller-list" }, nU = ["index", "passenger"], oU = {
  key: 1,
  class: "confirm-summary-flights"
}, sU = { class: "vacv-section-title" }, aU = {
  key: 0,
  class: "hotel-accordion-wrapper flight-details multi",
  "data-test": "flight-details-multi"
}, rU = { class: "hotel-accordion" }, iU = {
  key: 4,
  class: "confirm-summary-ancillary"
}, lU = { class: "vacv-section-title" }, cU = { class: "confirm-travelprotection-section" }, uU = {
  key: 5,
  class: "confirm-summary-pricedetails"
}, pU = { class: "vacv-section-title" }, dU = { class: "price-details" }, fU = {
  key: 0,
  class: "ancillaries-wrapper"
}, mU = { class: "vacv-label-sm" }, vU = {
  key: 0,
  "data-test": "payment-forms-uplift",
  class: "breakdown-wrapper payment"
}, hU = { class: "breakdown-price-section" }, gU = { class: "payment-title" }, bU = { class: "price-row" }, yU = {
  key: 1,
  "data-test": "payment-forms-container",
  class: "breakdown-wrapper payment"
}, $U = { class: "breakdown-price-section" }, _U = { class: "payment-title" }, wU = {
  key: 6,
  class: "confirm-summary-getready"
}, Xie = /* @__PURE__ */ K({
  __name: "ConfirmationSummary",
  props: {
    bookingResponse: {},
    language: {}
  },
  setup(e) {
    var j, ee, te, ce, H, oe, U, Q, z, Z, W, X, G, se, pe, J;
    const { bookingResponse: t, language: n } = e, o = ml(t), s = On(), { insurancePremium: a } = Ce(s), r = !!((te = (ee = (j = t.payment) == null ? void 0 : j.creditCards) == null ? void 0 : ee[0]) != null && te.trace && t.payment.creditCards[0].correlation), i = (o == null ? void 0 : o.hotelId) ?? "", l = (ce = t == null ? void 0 : t.hotels) == null ? void 0 : ce[i], c = (oe = (H = t == null ? void 0 : t.payment) == null ? void 0 : H.billingAddress) == null ? void 0 : oe.phone, u = (Q = (U = t.payment) == null ? void 0 : U.billingAddress) == null ? void 0 : Q.email, p = jg(t), f = (p == null ? void 0 : p.itineraryId) ?? "", m = p != null && p.itinerary && f ? p.itinerary : null, h = m && m.segments.filter((ae) => ae.bound === "O"), g = m && ((z = m.segments) == null ? void 0 : z.filter((ae) => ae.bound === "I")), _ = o && "packageInclusions" in o.information ? o.information.packageInclusions : void 0, v = ((Z = h == null ? void 0 : h[h.length - 1]) == null ? void 0 : Z.destinationName) || "", w = "travelInsurance" in t ? t.travelInsurance : void 0, y = JD(
      t.passengers,
      c,
      u,
      FD(t, f)
    ), $ = (X = (W = t.payment) == null ? void 0 : W.aeroplanPoints) == null ? void 0 : X[0], S = (G = t.payment) == null ? void 0 : G.creditCards, A = (se = t.payment) == null ? void 0 : se.giftCards;
    function I() {
      const ae = o == null ? void 0 : o.selectedOptionIds, re = t.ancillaryOptions;
      return !ae || !re ? [] : Vp(
        tb(
          ae,
          re
        )
      );
    }
    const D = I(), O = tP(D), x = O && Object.keys(O).length > 0, F = {
      dollarValue: $ == null ? void 0 : $.pointsCashValue,
      priceAncillaries: 0,
      allowOpcTax: !0,
      allowPromoCode: !0
    }, P = vP(o == null ? void 0 : o.pricing, F), E = (pe = t.passengers) == null ? void 0 : pe.some(
      (ae) => ae.nameModified
    ), B = (J = o == null ? void 0 : o.pricing) == null ? void 0 : J.opcTax, N = V(() => !("itineraries" in t)), Y = t.quote && "prePackage" in t.quote ? o != null && o.selectedOptionIds.privateTransferId ? "privateTransfer" : t.quote.prePackage.information.packageInclusions.toLowerCase().includes("transfer") ? "sharedTransfer" : null : null;
    return (ae, re) => {
      var ge, Ie, je, Ve, Ue, Be, ht, _t, Ft, Rt;
      return b(), C("section", K5, [
        d("div", Y5, [
          d("h2", G5, k(ae.$t("vacvComponents.confirmation.labels.bookingSummaryTitle")), 1),
          T(y) ? (b(), C("div", Z5, [
            d("h3", X5, k(ae.$t("vacvComponents.confirmation.labels.travellersTitle")), 1),
            d("div", J5, [
              d("div", Q5, [
                T(E) ? (b(), C("div", eU, [
                  d("strong", null, k(ae.$t("vacvComponents.payment.labels.note")), 1),
                  ne(" " + k(ae.$t("vacvComponents.payment.labels.travellerInfoNormalizedNote")), 1)
                ])) : M("", !0),
                d("ul", tU, [
                  (b(!0), C($e, null, ke(T(y), (fe, Ge) => (b(), C("li", {
                    key: Ge,
                    index: Ge,
                    passenger: fe,
                    class: "traveller-item"
                  }, [
                    fe ? (b(), ie(oy, {
                      key: 0,
                      passenger: fe,
                      showDOB: !1
                    }, null, 8, ["passenger"])) : M("", !0)
                  ], 8, nU))), 128))
                ])
              ])
            ])
          ])) : M("", !0),
          N.value ? M("", !0) : (b(), C("div", oU, [
            d("h3", sU, k(ae.$t("vacvComponents.confirmation.labels.flightTitle")), 1),
            T(h) && T(g) ? (b(), C("div", aU, [
              d("div", rU, [
                q(zi, {
                  class: "outbound",
                  segments: T(h)
                }, null, 8, ["segments"]),
                q(zi, {
                  class: "inbound",
                  segments: T(g)
                }, null, 8, ["segments"])
              ])
            ])) : M("", !0)
          ])),
          T(Y) ? (b(), ie(o4, {
            key: 2,
            transfer: T(Y),
            destination: T(v)
          }, null, 8, ["transfer", "destination"])) : M("", !0),
          T(l) ? (b(), ie(Q8, {
            key: 3,
            hotel: T(l),
            checkIn: (Ie = (ge = T(o)) == null ? void 0 : ge.information) == null ? void 0 : Ie.checkIn,
            checkOut: (Ve = (je = T(o)) == null ? void 0 : je.information) == null ? void 0 : Ve.checkOut,
            "room-id": (Ue = T(o)) == null ? void 0 : Ue.roomId
          }, null, 8, ["hotel", "checkIn", "checkOut", "room-id"])) : M("", !0),
          T(x) && ((Be = T(o)) != null && Be.selectedOptionIds) ? (b(), C("div", iU, [
            d("h3", lU, k(ae.$t("vacvComponents.confirmation.labels.ancillaryTitle")), 1),
            d("div", cU, [
              (b(!0), C($e, null, ke(T(O), (fe) => (b(), ie(F8, {
                key: fe.id,
                ancillary: fe
              }, null, 8, ["ancillary"]))), 128))
            ])
          ])) : M("", !0),
          (ht = T(o)) != null && ht.pricing ? (b(), C("div", uU, [
            d("h3", pU, k(ae.$t("vacvComponents.confirmation.labels.priceDetailsTitle")), 1),
            d("div", dU, [
              q(ed, {
                prePackagePricing: T(o).pricing,
                "package-inclusions": T(_),
                ancillaries: T(D),
                extrasIncluded: T(x),
                showDOB: !1,
                spaType: N.value ? T(lt).HotelsSpa : T(lt).PackagesSpa
              }, {
                priceBreakdownLines: he(() => {
                  var fe, Ge, zt, dt, $t, en;
                  return [
                    (fe = T(D)) != null && fe.length ? (b(), C("div", fU, [
                      d("h3", mU, k(ae.$t("vacvComponents.confirmation.labels.ancillaryTitle")), 1),
                      q(dy, {
                        ancillaries: T(D),
                        pricing: T(o).pricing,
                        selectedOptionIds: T(o).selectedOptionIds
                      }, null, 8, ["ancillaries", "pricing", "selectedOptionIds"])
                    ])) : M("", !0),
                    T(B) ? (b(), ie(M4, {
                      key: 1,
                      opcTax: T(B)
                    }, null, 8, ["opcTax"])) : M("", !0),
                    q(sy, {
                      subTotal: T(P).subTotal
                    }, null, 8, ["subTotal"]),
                    q(F4, {
                      "pre-package-pricing": T(o).pricing
                    }, null, 8, ["pre-package-pricing"]),
                    T($) ? (b(), ie(ry, {
                      key: 2,
                      "dollar-value": (Ge = T($)) == null ? void 0 : Ge.pointsCashValue,
                      "points-to-redeem": (zt = T($)) == null ? void 0 : zt.amountOfPoints
                    }, null, 8, ["dollar-value", "points-to-redeem"])) : M("", !0),
                    q(nd, {
                      "price-total": T(P).total,
                      estimated: !1,
                      modifier: "confirmation",
                      "is-section": "",
                      "is-refundable": ($t = (dt = T(o)) == null ? void 0 : dt.information) == null ? void 0 : $t.refundable
                    }, null, 8, ["price-total", "is-refundable"]),
                    (en = ae.bookingResponse.payment) != null && en.isMinDepositApplied ? (b(), ie(V4, {
                      key: 3,
                      "pre-package-pricing": T(o).pricing,
                      "due-amount": ae.bookingResponse.payment.paymentDueAmount,
                      "insurance-premium": T(a),
                      modifier: "confirmation-deposit",
                      "is-section": "",
                      lang: ae.language
                    }, null, 8, ["pre-package-pricing", "due-amount", "insurance-premium", "lang"])) : M("", !0)
                  ];
                }),
                _: 1
              }, 8, ["prePackagePricing", "package-inclusions", "ancillaries", "extrasIncluded", "spaType"]),
              r ? (b(), C("div", vU, [
                d("ul", hU, [
                  d("li", gU, k(ae.$t("vacvComponents.confirmation.labels.paymentTitle")), 1),
                  d("li", bU, k(ae.$t("vacvComponents.confirmation.labels.uplift")), 1)
                ])
              ])) : (_t = T(A)) != null && _t.length || (Ft = T(S)) != null && Ft.length ? (b(), C("div", yU, [
                d("ul", $U, [
                  d("li", _U, k(ae.$t("vacvComponents.confirmation.labels.paymentTitle")), 1),
                  (b(!0), C($e, null, ke(T(A), (fe) => (b(), C("li", {
                    key: fe.number,
                    class: "price-row"
                  }, [
                    q(Cm, {
                      amount: fe.amount,
                      "card-number": fe.number,
                      type: "giftCard"
                    }, null, 8, ["amount", "card-number"])
                  ]))), 128)),
                  (b(!0), C($e, null, ke(T(S), (fe) => (b(), C("li", {
                    key: fe.creditCardToken,
                    class: "price-row"
                  }, [
                    q(Cm, {
                      amount: fe.amount,
                      "card-number": fe.creditCardToken,
                      type: "creditCard",
                      "credit-card-type": fe.creditCardTypeEnum
                    }, null, 8, ["amount", "card-number", "credit-card-type"])
                  ]))), 128))
                ])
              ])) : M("", !0)
            ])
          ])) : M("", !0),
          N.value ? M("", !0) : (b(), C("div", wU, [
            q(E4, {
              booking: ae.bookingResponse,
              language: ae.language
            }, null, 8, ["booking", "language"]),
            ((Rt = T(w)) == null ? void 0 : Rt.status) !== "FAILED" ? (b(), ie(m4, {
              key: 0,
              booking: ae.bookingResponse,
              language: ae.language
            }, null, 8, ["booking", "language"])) : M("", !0)
          ]))
        ])
      ]);
    };
  }
}), CU = {}, kU = { class: "passengerprotection-section" }, SU = { class: "text" }, TU = ["innerHTML"];
function AU(e, t) {
  return b(), C("section", kU, [
    d("h2", null, k(e.$t("vacvComponents.payment.labels.passengerProtection")), 1),
    d("div", SU, k(e.$t("vacvComponents.payment.messages.passengerProtection-1")), 1),
    d("div", {
      class: "text",
      innerHTML: e.$t("vacvComponents.payment.messages.passengerProtection-2")
    }, null, 8, TU)
  ]);
}
const DU = /* @__PURE__ */ De(CU, [["render", AU]]), PU = (e) => (dn("data-v-71380a98"), e = e(), fn(), e), IU = { key: 0 }, EU = { class: "formkit-messages" }, OU = {
  class: "formkit-message",
  "data-message-type": "validation"
}, xU = { key: 1 }, MU = {
  class: "spa-alertbox info",
  role: "alert",
  "aria-live": "polite"
}, LU = { class: "text" }, NU = { key: 2 }, FU = { class: "formkit-messages" }, RU = {
  class: "formkit-message",
  "data-message-type": "validation"
}, VU = /* @__PURE__ */ PU(() => /* @__PURE__ */ d("br", null, null, -1)), BU = /* @__PURE__ */ K({
  __name: "PaymentErrors",
  setup(e) {
    const t = Tt(), {
      showGiftCardTwoCardError: n,
      showGiftCardPayInFullMessage: o,
      showPaymentMethodError: s
    } = Ce(t);
    return (a, r) => T(s) ? (b(), C("div", IU, [
      d("ul", EU, [
        d("li", OU, k(a.$t("vacvComponents.payment.validation.paymentMethod")), 1)
      ])
    ])) : T(o) ? (b(), C("div", xU, [
      d("div", MU, [
        d("div", LU, k(a.$t("vacvComponents.payment.errors.giftCardPayInFull")), 1)
      ])
    ])) : T(n) ? (b(), C("div", NU, [
      d("ul", FU, [
        d("li", RU, k(a.$t("vacvComponents.payment.errors.maxTwoPaymentMethods")), 1)
      ]),
      VU
    ])) : M("", !0);
  }
}), HU = /* @__PURE__ */ De(BU, [["__scopeId", "data-v-71380a98"]]), Co = St("upliftStore", () => {
  const e = R(!1), t = R(!1), n = R(!1), o = R(), s = R(), a = R(!1), r = R(!1), i = R(!0), l = R();
  function c() {
    e.value = !1, t.value = !1, n.value = !1, o.value = null;
  }
  function u(y) {
    e.value = y;
  }
  function p(y) {
    t.value = y;
  }
  function f(y) {
    n.value = y;
  }
  function m(y) {
    o.value = y;
  }
  function h(y) {
    s.value = y;
  }
  function g(y) {
    a.value = y;
  }
  function _(y) {
    r.value = y;
  }
  function v(y) {
    i.value = y;
  }
  function w(y) {
    l.value = y;
  }
  return {
    upliftOfferAvailable: e,
    upliftTokenAvailable: t,
    upliftTokenRetrieved: n,
    upliftToken: o,
    upLiftOrderObj: s,
    showFormIncompleteError: a,
    showUnableToGetUpliftTokenError: r,
    passengerIsOldEnough: i,
    upliftWasDisabledByNonEligibility: l,
    resetUplift: c,
    setUpliftOfferAvailable: u,
    setUpliftOrder: h,
    setUpliftTokenAvailable: p,
    setUpliftTokenRetrieved: f,
    setUpliftToken: m,
    setShowFormIncompleteError: g,
    setShowUnableToGetUpliftTokenError: _,
    setPassengerIsOldEnough: v,
    setUpliftWasDisabledByNonEligibility: w
  };
}), UU = /* @__PURE__ */ K({
  __name: "SeparateBillingAddress",
  props: {
    lang: {}
  },
  setup(e) {
    const t = Tt(), {
      isPaymentMethodCreditCard: n,
      isPaymentMethodGiftCard: o,
      isPaymentMethodUplift: s,
      amountToPay: a
    } = Ce(t), r = Co(), { upliftOfferAvailable: i } = Ce(r), l = V(
      () => o.value && !n.value || s.value
    ), c = V(
      () => a.value === 0 || l.value
    );
    return (u, p) => c.value ? (b(), C("div", {
      key: 0,
      id: "separate-billing-address",
      class: ue([
        T(i) ? "paddedbox-grey border uplift-billing" : "paddedbox-grey border"
      ])
    }, [
      d("h3", null, k(u.$t("vacvComponents.payment.labels.creditCardAddressTitle")), 1),
      q(Rh, {
        creditCardName: "ccframe1",
        lang: u.lang
      }, null, 8, ["lang"])
    ], 2)) : M("", !0);
  }
}), zU = { key: 0 }, WU = { class: "formkit-messages uplift-error-container" }, jU = {
  class: "formkit-message",
  "data-message-type": "validation"
}, qU = { key: 1 }, KU = { class: "formkit-messages uplift-error-container" }, YU = {
  class: "formkit-message",
  "data-message-type": "validation"
}, GU = /* @__PURE__ */ K({
  __name: "UpliftPaymentErrors",
  setup(e) {
    const t = Co(), { showFormIncompleteError: n, showUnableToGetUpliftTokenError: o } = Ce(t);
    return (s, a) => (b(), C($e, null, [
      T(n) ? (b(), C("div", zU, [
        d("ul", WU, [
          d("li", jU, k(s.$t("vacvComponents.payment.errors.upliftFormNotCompleted")), 1)
        ])
      ])) : M("", !0),
      T(o) ? (b(), C("div", qU, [
        d("ul", KU, [
          d("li", YU, k(s.$t("vacvComponents.payment.errors.unableGetUpliftToken")), 1)
        ])
      ])) : M("", !0)
    ], 64));
  }
}), ZU = ["innerHTML", "location"], XU = {
  id: "uplift-warning-modal-content",
  class: "vacv-editor"
}, JU = { class: "message" }, QU = { class: "uplift-warning-modal-ok-btn" }, ez = ["aria-label"], tz = /* @__PURE__ */ d("i", { class: "fa-solid fa-circle-xmark" }, null, -1), mr = /* @__PURE__ */ K({
  __name: "UpliftWarningMessage",
  props: {
    displayUpliftWarningModal: { type: Boolean },
    location: {}
  },
  emits: ["on-close-uplift-warning-modal"],
  setup(e, { emit: t }) {
    const { t: n } = Ne({ useScope: "global" }), o = e, s = V(() => o.displayUpliftWarningModal), a = t, r = (i) => {
      a("on-close-uplift-warning-modal", i);
    };
    return (i, l) => (b(), ie(Qt, {
      onClose: l[2] || (l[2] = (c) => r("CLOSE")),
      modelValue: s.value,
      "onUpdate:modelValue": l[3] || (l[3] = (c) => s.value = c),
      class: "vacv-modal modal-fullscreen vacv-modal-centered",
      id: "uplift-warning-modal"
    }, {
      default: he(() => [
        d("div", {
          id: "uplift-warning-modal-title",
          class: "h3style",
          innerHTML: T(n)("vacvComponents.payment.labels.upliftWarningModalTitle"),
          location: i.location
        }, null, 8, ZU),
        d("div", XU, [
          d("div", JU, k(T(n)("vacvComponents.payment.messages.upliftWarningMessage")), 1),
          d("div", QU, [
            d("button", {
              class: "vacv-btn-primary",
              onClick: l[0] || (l[0] = (c) => r("OK"))
            }, k(T(n)("vacvComponents.payment.labels.upLiftWarningModalBtnOK")), 1)
          ]),
          d("button", {
            onClick: l[1] || (l[1] = (c) => r("CANCEL")),
            class: "uplift-linklook",
            "aria-expanded": "false",
            "aria-label": T(n)("vacvComponents.common.buttons.close")
          }, [
            tz,
            ne(k(T(n)("vacvComponents.payment.labels.upliftWarningModalBtnCancel")), 1)
          ], 8, ez)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]));
  }
}), nz = {
  class: "h1style",
  id: "payment-section-title"
}, oz = { class: "options-wrapper" }, sz = { class: "payment-amount" }, az = { class: "vacv-price" }, rz = { class: "payment-select" }, iz = { class: "vacv-btn-secondary noclick" }, lz = { key: 0 }, cz = /* @__PURE__ */ d("i", {
  class: "fa-solid fa-check",
  "aria-hidden": "true"
}, null, -1), uz = { key: 1 }, pz = { class: "payment-amount" }, dz = ["aria-label"], fz = /* @__PURE__ */ d("span", { class: "round-icon" }, null, -1), mz = [
  fz
], vz = ["innerHTML"], hz = ["innerHTML"], gz = {
  class: "vacv-price",
  id: "deposit-price"
}, bz = { class: "text" }, yz = ["innerHTML"], $z = { class: "payment-select" }, _z = { class: "vacv-btn-secondary noclick" }, wz = { key: 0 }, Cz = /* @__PURE__ */ d("i", {
  class: "fa-solid fa-check",
  "aria-hidden": "true"
}, null, -1), kz = { key: 1 }, Sz = { id: "up-pay-monthly-selector" }, Tz = ["data-up-price-value"], Az = /* @__PURE__ */ d("span", { "data-up-from-currency-unit-major": "" }, null, -1), Dz = ["aria-label"], Pz = {
  id: "up-offer-not-available",
  "data-up-error": "",
  style: { display: "none" }
}, Iz = /* @__PURE__ */ d("span", { "data-up-tooltip": "" }, null, -1), Ez = { class: "payment-select" }, Oz = { class: "vacv-btn-secondary noclick" }, xz = { key: 0 }, Mz = /* @__PURE__ */ d("i", {
  class: "fa-solid fa-check",
  "aria-hidden": "true"
}, null, -1), Lz = { key: 1 }, Jie = /* @__PURE__ */ K({
  __name: "PaymentOptions",
  props: {
    totalAmountToPay: {},
    minimumDeposit: {},
    minimumDepositDueDate: {},
    depositTermsAndCondition: {},
    reset: { type: Boolean },
    ENABLE_UPLIFT: { type: Boolean },
    SHOULD_SEND_SENTRY: { type: Boolean },
    SENTRY_ERROR_CODE_FILTER: {},
    UPLIFT_LIB_UPC: {},
    UPLIFT_LIB_API_KEY: {},
    UPLIFT_MIN_AMOUNT: {},
    UPLIFT_MAX_AMOUNT: {}
  },
  setup(e) {
    const { n: t } = Ne({ useScope: "global" }), n = e, {
      deselectUpliftPayment: o,
      selectUpliftPayment: s,
      isUpliftReady: a,
      upliftNotReadyError: r
    } = ob(
      n.ENABLE_UPLIFT,
      n.SHOULD_SEND_SENTRY,
      n.SENTRY_ERROR_CODE_FILTER,
      n.UPLIFT_LIB_UPC,
      n.UPLIFT_LIB_API_KEY
    ), i = On(), { selectedInsuranceProduct: l } = Ce(i), c = Co(), {
      setShowFormIncompleteError: u,
      setShowUnableToGetUpliftTokenError: p,
      setUpliftWasDisabledByNonEligibility: f
    } = Co(), {
      upliftTokenAvailable: m,
      passengerIsOldEnough: h,
      upliftWasDisabledByNonEligibility: g,
      upliftOfferAvailable: _
    } = Ce(c), v = Tt(), {
      setDepositAmountToNull: w,
      setSelectDeposit: y,
      setDepositAmount: $,
      setIsPaymentMethodUplift: S,
      setSelectedPlan: A
    } = v, { isPaymentMethodUplift: I, selectedPlan: D } = Ce(v), O = It(), x = n.ENABLE_UPLIFT, F = n.UPLIFT_MIN_AMOUNT, P = n.UPLIFT_MAX_AMOUNT, E = R(!1), B = R(!1), N = R(), Y = R(wt.full), j = V(() => n.totalAmountToPay - (n.minimumDeposit ? n.minimumDeposit : 0)), ee = V(
      () => !!n.minimumDeposit && !!n.minimumDepositDueDate && n.minimumDeposit < n.totalAmountToPay && j.value > 0
    ), te = V(
      () => !!(n.totalAmountToPay && n.totalAmountToPay > F && n.totalAmountToPay < P && h.value && x && _.value && !l.value)
    ), ce = V(() => n.totalAmountToPay > 0), H = () => {
      E.value = !0;
    }, oe = () => {
      B.value = !0;
    }, U = () => {
      E.value = !1;
    }, Q = (re) => {
      if (re === "OK") {
        B.value = !1, Z(Y.value);
        const ge = N.value;
        ge && ge();
      } else
        B.value = !1;
    }, z = (re) => {
      Y.value = re, I.value && m.value && !n.reset ? oe() : (Z(re), re == "deposit" ? G() : X());
    }, Z = (re) => {
      u(!1), p(!1), S(!1), o(re);
    }, W = () => {
      A(wt.uplift), w(), y(!1);
    }, X = () => {
      A(wt.full), w(), y(!1);
    }, G = () => {
      A(wt.deposit), $(n.minimumDeposit), y(!0);
    }, se = () => {
      I.value ? (N.value = X, z(wt.full)) : X();
    }, pe = () => {
      I.value ? (N.value = G, z(wt.deposit)) : G();
    }, J = () => {
      a() ? (s(), W(), S(!0)) : (r(), p(!0));
    }, ae = V(() => {
      const re = O === "fr" ? "dd LLL yyyy" : "LLL. dd, yyyy";
      return n.minimumDepositDueDate ? Me.fromFormat(n.minimumDepositDueDate, "yyyyMMdd").setLocale(O).toFormat(re) : "";
    });
    return le(ee, (re) => {
      re || se();
    }), le(
      () => n.reset,
      (re) => {
        re && (I.value || se());
      }
    ), le(h, (re) => {
      re || se();
    }), le(te, (re) => {
      re || (Z(wt.full), X());
    }), Re(() => {
      if (I.value && !_.value) {
        const re = le(_, async (ge) => {
          ge && (J(), re());
        });
      }
    }), le(g, (re) => {
      re && (se(), f(!1));
    }), (re, ge) => (b(), C("section", {
      class: ue([{ hidden: !ce.value }, "paymentoptions-section"])
    }, [
      d("h2", nz, k(re.$t("vacvComponents.payment.labels.paymentOptions")), 1),
      q(GU),
      d("div", oz, [
        d("button", {
          class: ue(["optionbox payment-full", {
            selected: T(D) === T(wt).full,
            solo: !ee.value
          }]),
          onClick: se
        }, [
          d("div", sz, [
            d("h3", null, k(re.$t("vacvComponents.payment.labels.payInFull")), 1),
            d("div", az, k(T(Se)(re.totalAmountToPay, T(t))), 1)
          ]),
          d("div", rz, [
            d("div", iz, [
              T(D) === T(wt).full ? (b(), C("span", lz, [
                cz,
                ne(k(re.$t("vacvComponents.common.buttons.selected")), 1)
              ])) : (b(), C("span", uz, k(re.$t("vacvComponents.common.buttons.select")), 1))
            ])
          ])
        ], 2),
        ee.value ? (b(), C("button", {
          key: 0,
          class: ue(["optionbox payment-deposit", { selected: T(D) === T(wt).deposit }]),
          onClick: pe
        }, [
          d("div", pz, [
            d("h3", null, [
              ne(k(re.$t("vacvComponents.payment.labels.payWithDeposit")), 1),
              d("button", {
                onClick: H,
                class: "price-popover-link link",
                "aria-haspopup": "true",
                "aria-label": re.$t("vacvComponents.ancillary.access.details"),
                "aria-describedby": "deposit-modal-title"
              }, mz, 8, dz)
            ]),
            q(Qt, {
              onClose: U,
              modelValue: E.value,
              "onUpdate:modelValue": ge[0] || (ge[0] = (Ie) => E.value = Ie),
              class: "vacv-modal modal-fullscreen vacv-modal-centered"
            }, {
              default: he(() => {
                var Ie, je;
                return [
                  d("div", {
                    id: "deposit-modal-title",
                    class: "h2style",
                    innerHTML: (Ie = re.depositTermsAndCondition) == null ? void 0 : Ie.name
                  }, null, 8, vz),
                  d("div", {
                    id: "deposit-modal-content",
                    class: "vacv-editor",
                    innerHTML: (je = re.depositTermsAndCondition) == null ? void 0 : je.description
                  }, null, 8, hz)
                ];
              }),
              _: 1
            }, 8, ["modelValue"]),
            d("div", gz, k(T(Se)(re.minimumDeposit, T(t))), 1),
            d("div", bz, [
              d("span", {
                innerHTML: re.$t("vacvComponents.payment.messages.amountDueBy", {
                  amount: T(Se)(j.value, T(t)),
                  date: ae.value
                })
              }, null, 8, yz)
            ])
          ]),
          d("div", $z, [
            d("div", _z, [
              T(D) === T(wt).deposit ? (b(), C("span", wz, [
                Cz,
                ne(k(re.$t("vacvComponents.common.buttons.selected")), 1)
              ])) : (b(), C("span", kz, k(re.$t("vacvComponents.common.buttons.select")), 1))
            ])
          ])
        ], 2)) : M("", !0),
        d("button", {
          class: ue([
            {
              selected: T(D) === T(wt).uplift,
              solo: !ee.value
            },
            { hidden: !te.value },
            "optionbox payment-uplift"
          ]),
          onClick: J
        }, [
          d("div", Sz, [
            d("h3", null, k(re.$t("vacvComponents.payment.labels.payWithUplift")), 1),
            q(mr, {
              location: "PaymentOptions",
              "display-uplift-warning-modal": B.value,
              onOnCloseUpliftWarningModal: Q
            }, null, 8, ["display-uplift-warning-modal"]),
            d("span", {
              id: "up-pay-monthly-selector-from-pricing",
              style: { cursor: "pointer" },
              "data-up-price-type": "total",
              "data-up-price-value": re.totalAmountToPay * 100
            }, [
              ne(k(re.$t("vacvComponents.payment.labels.upliftFrom")), 1),
              Az,
              ne(k(re.$t("vacvComponents.payment.labels.payMonthlyOffer")), 1),
              d("span", {
                "data-up-tooltip": "",
                class: "round-icon info",
                role: "button",
                "aria-haspopup": "true",
                "aria-label": re.$t("vacvComponents.ancillary.access.details"),
                tabindex: "0"
              }, null, 8, Dz)
            ], 8, Tz),
            d("span", Pz, [
              ne(k(re.$t("vacvComponents.payment.errors.offerNotAvailable")) + " ", 1),
              Iz
            ])
          ]),
          d("div", Ez, [
            d("div", Oz, [
              T(D) === T(wt).uplift ? (b(), C("span", xz, [
                Mz,
                ne(k(re.$t("vacvComponents.common.buttons.selected")), 1)
              ])) : (b(), C("span", Lz, k(re.$t("vacvComponents.common.buttons.select")), 1))
            ])
          ])
        ], 2)
      ])
    ], 2));
  }
}), Nz = {
  key: 0,
  class: "bill96-section vacv-checkbox"
}, Fz = { class: "h3style" }, Rz = /* @__PURE__ */ K({
  __name: "Bill96Checkbox",
  setup(e) {
    const t = Tt(), { bill96: n, showBill96Checkbox: o } = Ce(t);
    return (s, a) => {
      const r = ut("FormKit");
      return T(o) ? (b(), C("section", Nz, [
        d("div", Fz, k(s.$t("vacvComponents.payment.messages.bill96-disclaimer")), 1),
        q(r, {
          name: "bill96",
          type: "checkbox",
          label: s.$t("vacvComponents.payment.messages.bill96-checkbox"),
          modelValue: T(n),
          "onUpdate:modelValue": a[0] || (a[0] = (i) => Pt(n) ? n.value = i : null),
          "decorator-icon": T(Cp)
        }, null, 8, ["label", "modelValue", "decorator-icon"])
      ])) : M("", !0);
    };
  }
}), Vz = { class: "creditcard-logos" }, Bz = { class: "cc-logo" }, Hz = ["src"], Uz = { class: "cc-logo" }, zz = ["src"], Wz = { class: "cc-logo" }, jz = ["src"], qz = /* @__PURE__ */ K({
  __name: "CreditCardLogos",
  setup(e) {
    const t = Ye("cdnBaseUrl");
    return (n, o) => (b(), C("div", Vz, [
      d("span", Bz, [
        d("img", {
          src: `${T(t)}/img/payment-mastercard.png`,
          alt: "Mastercard",
          "data-test": "mastercard-logo"
        }, null, 8, Hz)
      ]),
      d("span", Uz, [
        d("img", {
          src: `${T(t)}/img/payment-visa.png`,
          alt: "Visa",
          "data-test": "visa-logo"
        }, null, 8, zz)
      ]),
      d("span", Wz, [
        d("img", {
          src: `${T(t)}/img/payment-amex.png`,
          alt: "American Express",
          "data-test": "amex-logo"
        }, null, 8, jz)
      ])
    ]));
  }
}), Kz = {
  id: "creditcard",
  class: "paddedbox-grey border"
}, Yz = { class: "payment-section-title" }, Gz = {
  key: 0,
  class: "vacv-checkbox"
}, Zz = {
  key: 1,
  class: "h2style"
}, Xz = {
  key: 0,
  class: "twocards-section"
}, Jz = {
  key: 0,
  class: "cc-toggle-section"
}, Qz = { class: "sr-only" }, e7 = {
  key: 1,
  class: "insurance-note"
}, t7 = { class: "insurance-note-title" }, n7 = { class: "insurance-note-notes" }, o7 = { class: "insurance-note-notes-first-note" }, s7 = { class: "insurance-note-notes-second-note" }, a7 = /* @__PURE__ */ K({
  __name: "CreditCardSection",
  props: {
    hpciConfig: {},
    TWO_CC_THRESHOLD: {},
    showPayWithCreditCard: { type: Boolean, default: !0 }
  },
  emits: ["change-twocards", "credit-card-selected"],
  setup(e, { expose: t, emit: n }) {
    const o = e, s = It(), a = On(), r = Tt(), {
      isPaymentMethodCreditCard: i,
      isPaymentMethodGiftCard: l,
      amountToPay: c,
      toggle2cc: u
    } = Ce(r), { dollarValue: p } = Ce(un()), f = V(
      () => {
        var S;
        return ((S = a.selectedInsuranceProduct) == null ? void 0 : S.premium) ?? 0;
      }
    ), m = V(() => !(l.value || p.value > 0 || !isNaN(o.TWO_CC_THRESHOLD) && c.value + f.value < o.TWO_CC_THRESHOLD)), h = V(() => f.value > 0 || i.value), g = n;
    function _(S) {
      var I;
      const A = !!((I = S == null ? void 0 : S.target) != null && I.checked);
      g("change-twocards", A), u.value = A;
    }
    function v() {
      rn(() => {
        i.value && g("credit-card-selected");
      });
    }
    const w = R(), y = R();
    function $() {
      var S, A;
      (S = w.value) != null && S.resetIFrame && w.value.resetIFrame(), (A = y.value) != null && A.resetIFrame && y.value.resetIFrame();
    }
    return t({
      resetIframes: $
    }), (S, A) => {
      const I = ut("FormKit");
      return b(), C("div", Kz, [
        d("div", Yz, [
          S.showPayWithCreditCard ? (b(), C("div", Gz, [
            q(I, {
              name: "paymentMethodCreditCard",
              id: "creditcard-checkbox",
              type: "checkbox",
              label: S.$t("vacvComponents.payment.labels.creditCard"),
              "aria-checked": h.value ? "true" : "false",
              "decorator-icon": T(Cp),
              "label-class": "h2style",
              disabled: !!T(a).selectedInsuranceProduct,
              checked: h.value,
              modelValue: T(i),
              "onUpdate:modelValue": A[0] || (A[0] = (D) => Pt(i) ? i.value = D : null),
              onInput: v
            }, null, 8, ["label", "aria-checked", "decorator-icon", "disabled", "checked", "modelValue"])
          ])) : (b(), C("span", Zz, k(S.$t("vacvComponents.payment.labels.creditCard")), 1)),
          q(qz)
        ]),
        T(i) ? (b(), C("div", Xz, [
          m.value && !T(l) ? (b(), C("div", Jz, [
            d("span", Qz, k(S.$t("vacvComponents.payment.labels.twoCreditCards")), 1),
            q(I, {
              type: "toggle",
              name: "toggle-2cc",
              id: "toggle2cc",
              label: S.$t("vacvComponents.payment.labels.twoCreditCards"),
              onChange: _,
              modelValue: T(u),
              "onUpdate:modelValue": A[1] || (A[1] = (D) => Pt(u) ? u.value = D : null)
            }, null, 8, ["label", "modelValue"])
          ])) : M("", !0),
          f.value > 0 ? (b(), C("div", e7, [
            d("div", t7, k(S.$t("vacvComponents.payment.labels.allianzDescriptionNotesTitle")), 1),
            d("ul", n7, [
              d("li", o7, k(S.$t("vacvComponents.payment.labels.allianzDescriptionNotesNoteOne")), 1),
              d("li", s7, k(S.$t("vacvComponents.payment.labels.allianzDescriptionNotesNoteTwo")), 1)
            ])
          ])) : M("", !0),
          q(of, {
            ref_key: "card1Ref",
            ref: w,
            "credit-card-name": "ccframe1",
            hpciConfig: S.hpciConfig,
            lang: T(s),
            "insurance-premium": f.value
          }, null, 8, ["hpciConfig", "lang", "insurance-premium"]),
          T(u) ? (b(), ie(of, {
            key: 2,
            ref_key: "card2Ref",
            ref: y,
            creditCardName: "ccframe2",
            hpciConfig: S.hpciConfig,
            lang: T(s)
          }, null, 8, ["hpciConfig", "lang"])) : M("", !0)
        ])) : M("", !0)
      ]);
    };
  }
}), r7 = { class: "loading-spinner" }, i7 = ["src"], sd = /* @__PURE__ */ K({
  __name: "LoadingSpinner",
  props: {
    cdnBaseUrl: {}
  },
  setup(e) {
    return (t, n) => (b(), C("div", r7, [
      d("img", {
        src: `${t.cdnBaseUrl}/img/spinner-dots.png`,
        alt: ""
      }, null, 8, i7)
    ]));
  }
}), l7 = {
  class: "waiting-screen-overlay overlay-open",
  "data-test": "waiting-screen"
}, c7 = { class: "waiting-screen-content" }, u7 = { class: "title" }, p7 = ["innerHTML"], d7 = /* @__PURE__ */ K({
  __name: "WaitingScreen",
  props: {
    title: {},
    text: {},
    cdnBaseUrl: {}
  },
  setup(e) {
    return (t, n) => (b(), C("div", l7, [
      d("div", c7, [
        q(sd, { cdnBaseUrl: t.cdnBaseUrl }, null, 8, ["cdnBaseUrl"]),
        d("div", u7, k(t.title), 1),
        d("div", {
          class: "text",
          innerHTML: t.text
        }, null, 8, p7)
      ])
    ]));
  }
}), f7 = { id: "threeDSwrapper" }, m7 = ["action"], v7 = ["value"], h7 = ["value"], g7 = ["value"], b7 = ["width", "height"], Sm = /* @__PURE__ */ K({
  __name: "ThreeDomainSecureIframe",
  props: {
    actionURL: {},
    challengeData: {},
    threeDSServerTransId: {},
    threeDSMethodData: {}
  },
  setup(e) {
    const t = e, n = R(), { width: o } = cp(), s = V(
      () => o.value < di.tablet ? "100%" : "600px"
    ), a = V(
      () => o.value < di.tablet ? "0" : "border: 10px solid white; border-radius: 5px;"
    ), r = V(
      () => t != null && t.challengeData ? s.value : "0"
    ), i = V(
      () => t != null && t.challengeData ? a.value : "display: none;"
    );
    return Re(() => {
      n.value.submit();
    }), (l, c) => (b(), C("div", f7, [
      d("form", {
        id: "threeDSForm",
        action: l.actionURL,
        target: "threeDSiFrame",
        method: "POST",
        ref_key: "threeDSForm",
        ref: n
      }, [
        l.challengeData ? (b(), C("input", {
          key: 0,
          type: "hidden",
          name: "creq",
          id: "creq",
          value: l.challengeData
        }, null, 8, v7)) : M("", !0),
        l.threeDSServerTransId ? (b(), C("input", {
          key: 1,
          type: "hidden",
          id: "threeDSServerTransId",
          name: "threeDSServerTransId",
          value: l.threeDSServerTransId
        }, null, 8, h7)) : M("", !0),
        l.threeDSMethodData ? (b(), C("input", {
          key: 2,
          type: "hidden",
          id: "threeDSMethodData",
          name: "threeDSMethodData",
          value: l.threeDSMethodData
        }, null, 8, g7)) : M("", !0)
      ], 8, m7),
      d("iframe", {
        name: "threeDSiFrame",
        title: "3DS",
        id: "threeDSiFrame",
        width: r.value,
        height: r.value,
        style: Zu(i.value)
      }, null, 12, b7)
    ]));
  }
});
function y7(e) {
  const t = Tt(), {
    isPaymentMethodGiftCard: n,
    selectDeposit: o,
    depositAmount: s,
    amountToPay: a,
    giftCardAmount: r,
    giftCardNumber: i,
    giftCardPIN: l,
    toggle2cc: c,
    sameBillingAddress: u,
    card1: p,
    card2: f
  } = Ce(t);
  function m(v, w, y, $, S) {
    const A = w.hpciCCNumToken, I = parseInt(A), D = w.hpciCVVToken, O = parseInt(D);
    let x;
    c.value || n.value && r.value > 0 ? (x = Un(
      e,
      v.creditCardAmount
    ), S && (x = _(x, S))) : o.value && s.value !== null ? (x = s.value, S && (x = _(x, S))) : (x = a.value, S && (x = _(x, S)));
    const F = e == "en" ? eu.enCA : eu.frCA, P = {
      currency: "cad",
      creditCardToken: I,
      cardSecurityCode: O,
      expirationMonth: v.creditCardExpiry.substring(0, 2),
      expirationYear: v.creditCardExpiry.substring(3, 5),
      nameOnCard: v.creditCardName,
      amount: x,
      language: F
    };
    let E;
    v.creditCardIframeName === Hn ? E = v : u.value ? E = p.value : E = v;
    const B = Wi(
      E,
      y,
      $
    );
    return {
      ...P,
      ...B
    };
  }
  function h(v, w, y) {
    const $ = Wi(
      p.value,
      v,
      w
    ), S = [], A = window.hpciCards.get(Hn);
    A && S.push(
      m(
        p.value,
        A,
        v,
        w,
        y
      )
    );
    const I = window.hpciCards.get(wn);
    c.value && I && S.push(
      m(
        f.value,
        I,
        v,
        w
      )
    );
    const D = g();
    return {
      billingAddress: $,
      creditCards: S,
      giftCards: D
    };
  }
  function g() {
    if (n.value)
      return [{
        number: i.value,
        securityCode: l.value,
        amount: r.value,
        currency: "cad"
      }];
  }
  function _(v, w) {
    const y = (v - w).toFixed(2);
    let $ = parseFloat(y);
    return $ < 0 && ($ = 0), $;
  }
  return {
    generateMicroServicePaymentRequest: h,
    extractGiftCards: g
  };
}
function Wi(e, t, n) {
  return {
    address1: e.address,
    address2: e.apartment,
    city: e.city,
    province: e.state,
    country: e.country,
    postalCode: e.postcode,
    phone: t,
    email: n
  };
}
const $7 = "/form-of-payment", ad = $7 + "/threeDS", _7 = ad + "/cardLookup", w7 = ad + "/authentication", C7 = ad + "/cavvLookup";
async function k7(e, t) {
  try {
    return await Jn(
      new URL(t + _7),
      JSON.stringify(e),
      "POST"
    );
  } catch (n) {
    return to(n, !0), !1;
  }
}
async function S7(e, t) {
  try {
    return await Jn(
      new URL(t + w7),
      JSON.stringify(e),
      "POST"
    );
  } catch (n) {
    return to(n), !1;
  }
}
async function T7(e, t) {
  try {
    return await Jn(
      new URL(t + C7),
      JSON.stringify(e),
      "POST"
    );
  } catch (n) {
    return to(n), !1;
  }
}
async function A7(e = "3ds") {
  return new Promise((t) => {
    const n = (o) => {
      var s, a;
      (a = (s = o.data) == null ? void 0 : s.origin) != null && a.includes(e) && (t({
        status: o.data.status,
        result: o.data.result
      }), window.removeEventListener("message", n));
    };
    window.addEventListener("message", n);
  });
}
function D7(e, t, n) {
  const o = R(), s = R(), a = R(), r = R(), i = R(), l = Tt(), { incrementCreditCard3DSFailures: c } = l;
  async function u(m, h) {
    var _, v, w, y;
    let g = !0;
    for (let $ = 0; $ < m.length; $++) {
      const S = await p(
        m[$],
        $,
        h
      );
      if (S) {
        if (((_ = S.threeDS) == null ? void 0 : _.authStatus) === "challenge") {
          if (o.value = (v = S.threeDS) == null ? void 0 : v.challengeURL, s.value = (w = S.threeDS) == null ? void 0 : w.challengeData, g = await f($, h), !g) {
            c($);
            break;
          }
        } else if (((y = S.threeDS) == null ? void 0 : y.authStatus) === "reject") {
          g = !1;
          break;
        }
      }
    }
    return g;
  }
  async function p(m, h, g) {
    var w, y, $, S, A;
    m.id = _i.generateId(12);
    let _ = kc(
      m,
      g
    );
    const v = await k7(
      _,
      t
    );
    if (v && ((w = e == null ? void 0 : e.payment) != null && w.creditCards) && (e.payment.creditCards[h] = v, ((y = v.threeDS) == null ? void 0 : y.transStatus) !== "X")) {
      n && (a.value = ($ = v.threeDS) == null ? void 0 : $.threeDSMethodURL, r.value = (S = v.threeDS) == null ? void 0 : S.threeDSServerTransId, i.value = (A = v.threeDS) == null ? void 0 : A.threeDSMethodData), _ = kc(
        v,
        g
      );
      const I = await S7(
        _,
        t
      );
      if (a.value = void 0, r.value = void 0, i.value = void 0, I)
        return e.payment.creditCards[h] = I, I;
    }
    return !1;
  }
  async function f(m, h) {
    var _, v;
    const g = await A7();
    if (g.status === "success" && ((_ = e == null ? void 0 : e.payment) != null && _.creditCards)) {
      e.payment.creditCards[m].threeDS.cresData = g.result, o.value = void 0, s.value = void 0;
      const w = kc(
        e.payment.creditCards[m],
        h
      ), y = await T7(
        w,
        t
      );
      if (y)
        return e.payment.creditCards[m] = y, !!((v = y.threeDS) != null && v.accepted);
    }
    return !0;
  }
  return {
    challengeUrl: o,
    challengeData: s,
    fingerprintUrl: a,
    threeDSServerTransId: r,
    threeDSMethodData: i,
    processCreditCardsVia3DS: u
  };
}
function kc(e, t) {
  return {
    gatewayAirport: t,
    creditCard: e
  };
}
const P7 = { class: "paymentmethod-section payment2cc" }, I7 = {
  key: 0,
  class: "h1style",
  id: "payment-method-title"
}, E7 = { class: "checkout-termsconditions" }, O7 = ["innerHTML"], x7 = "/form-of-payment/payment", Qie = /* @__PURE__ */ K({
  __name: "PaymentMethod",
  props: {
    envVars: {},
    prePackage: {},
    hotel: {},
    itinerary: {},
    totalAmountToPay: {},
    isVisible: { type: Boolean },
    emailAddress: {},
    passengers: {},
    phoneNumber: {},
    packageQuoteId: {}
  },
  emits: ["showAlertErrors", "clearAlertErrors", "goToConfirmation"],
  setup(e, { emit: t }) {
    const n = e, o = It(), { envVars: s } = n, {
      API_HOST: a,
      ENABLE_3DS: r,
      UPLIFT_TOKEN_INTERVAL: i,
      UPLIFT_TOKEN_RETRIES: l,
      HPCI_HOST: c,
      HPCI_PAGE_MODE: u,
      HPCI_PARENT_HOST: p,
      HPCI_SITE_ID: f,
      HPCI_LOCATION_NAME: m,
      FETCH_API_TIMEOUT: h,
      ENABLE_UPLIFT: g,
      UPLIFT_LIB_UPC: _,
      UPLIFT_LIB_API_KEY: v,
      SENTRY_ERROR_CODE_FILTER: w,
      SHOULD_SEND_SENTRY: y,
      TWO_CC_THRESHOLD: $,
      MICROSERVICE_RETRY_TIMES: S,
      COMMON_STATIC_URL: A,
      BOOKING_URL: I,
      SHOW_PAY_WITH_CC: D,
      GIFT_CARD_ENABLED: O
    } = s, x = {
      hpciHost: c,
      hpciPageMode: u,
      parentHost: p,
      siteId: f,
      siteLoc: m,
      fetchApiTimeout: h,
      lang: o
    }, { getUpliftToken: F, upliftOrderSubmit: P, upliftOrderConfirmation: E } = ob(
      g,
      y,
      w,
      _,
      v
    ), { t: B, n: N } = Ne({ useScope: "global" });
    Re(() => {
      BD();
    }), ek(B);
    const Y = R(), j = R(), ee = R(), te = R(), ce = R(), H = R(), oe = R(
      /* @__PURE__ */ new Set()
    ), U = tt({
      payment: null,
      loading: !1
    }), Q = t, z = On(), { selectedInsuranceProduct: Z, insuranceQuoteId: W, insurancePremium: X } = Ce(z), { dollarValue: G, pointsToRedeem: se, hideCreditCardForm: pe } = Ce(un()), J = Co(), {
      setShowFormIncompleteError: ae,
      setShowUnableToGetUpliftTokenError: re,
      setUpliftTokenRetrieved: ge,
      setUpliftToken: Ie
    } = J, {
      upliftOfferAvailable: je,
      upliftTokenAvailable: Ve,
      upliftToken: Ue,
      upLiftOrderObj: Be
    } = Ce(J), ht = Tt(), {
      setGiftCardAmount: _t,
      clearGiftCardAmount: Ft,
      recalculateCreditCard1Amount: Rt,
      setInsurancePremiumAmount: fe
    } = ht, {
      bill96: Ge,
      isTotalPriceZero: zt,
      isPaymentMethodCreditCard: dt,
      isPaymentMethodGiftCard: $t,
      isPaymentMethodUplift: en,
      displayedGiftCardAmount: Fl,
      selectDeposit: Rl,
      depositAmount: ro,
      amountToPay: Eo,
      giftCardAmount: _r,
      checkoutHasBeenSubmitted: J0,
      showGiftCardTwoCardError: Q0,
      showPaymentMethodError: la,
      toggle2cc: ca,
      card1: ua,
      card2: Dd,
      audience: e$
    } = Ce(ht), { submitHpciIFrame: t$, initCustomHPCISubmitHandler: n$ } = Hh(
      x,
      B
    ), { generateMicroServicePaymentRequest: o$, extractGiftCards: s$ } = y7(o), {
      challengeUrl: Pd,
      challengeData: a$,
      fingerprintUrl: Id,
      threeDSServerTransId: r$,
      threeDSMethodData: i$,
      processCreditCardsVia3DS: l$
    } = D7(U, a, r), c$ = V(() => !pe.value && dt.value), u$ = V(() => en.value ? !1 : Eo.value !== 0), p$ = [
      qt.EMPLOYEE,
      qt.B2C_GUEST,
      qt.AFFILIATE,
      qt.FRIENDS_AND_FAMILY
    ], d$ = V(() => en.value ? !1 : p$.includes(e$.value) ? O && !zt.value : !1), f$ = V(() => {
      var me, Ee;
      return (Ee = (me = n.prePackage) == null ? void 0 : me.pricing) == null ? void 0 : Ee.promo;
    }), m$ = V(() => {
      var Ee, Pe, Je;
      return ((Je = (Pe = (Ee = n.itinerary) == null ? void 0 : Ee.segments) == null ? void 0 : Pe[0]) == null ? void 0 : Je.origin) ?? "xxx";
    });
    function Ed(me) {
      Eo.value = me, zt.value = me === 0, me === 0 && ($t.value = !1);
    }
    const Vl = () => {
      const me = document.getElementById("payment-section-title");
      me != null && me.scrollIntoView && me.scrollIntoView();
    };
    typeof n.totalAmountToPay == "number" && Ed(n.totalAmountToPay);
    function v$() {
      var me;
      (me = H.value) != null && me.resetIframes && H.value.resetIframes();
    }
    const h$ = (me) => {
      me && (zl(), EA(me).forEach((Pe) => {
        Pe.forEach((Je) => {
          oe.value.add(Je.value);
        });
      })), dt.value && Vh(
        B("vacvComponents.payment.errors.noCardNumber"),
        B("vacvComponents.payment.errors.noCVV")
      ), Vl();
    };
    function pa(me) {
      Go(me, y, w), Od(me);
    }
    const Od = (me) => {
      U.loading = !1, Q("showAlertErrors", {
        status: me.status,
        message: B("vacvComponents.payment.errors.paymentTechnicalError"),
        title: me.title,
        detail: me.detail,
        errorDetail: me.errorDetail
      }), Ih();
    }, Bl = () => ({
      amountOfPoints: se.value,
      pointsCashValue: G.value,
      currency: "cad"
    }), wr = async (me) => {
      G.value > 0 && (me.aeroplanPoints = [Bl()]);
      try {
        const Ee = new URL(a + x7), Pe = await Jn(
          Ee,
          JSON.stringify(me),
          "POST",
          0,
          S,
          h
        );
        Hl(Pe), g$();
      } catch (Ee) {
        return pa(Ee), !1;
      }
      return !0;
    };
    function Hl(me) {
      U.payment = me;
    }
    async function g$() {
      U.loading = !0;
      const me = z$(n.passengers), Ee = me == null ? void 0 : me.map((Je) => Je.id), Pe = {
        language: o,
        quoteId: n.packageQuoteId,
        paxIds: (Ee == null ? void 0 : Ee.toString()) ?? "",
        paymentId: U.payment.id,
        bill96: Ge.value,
        // bill96 checkbox enables email in both languages (see ACVW-7555)
        province: en.value ? ua.value.state : void 0
      };
      W.value && (Pe.travelInsuranceQuoteId = W.value), Z.value && Z.value.productCode && (Pe.travelInsuranceSelectedProduct = Z.value.productCode);
      try {
        const Je = new URL(a + I), tn = await Jn(
          Je,
          JSON.stringify(Pe),
          "POST",
          0,
          S,
          h
        );
        y$(tn);
      } catch (Je) {
        pa(Je);
      }
      U.loading = !1;
    }
    function b$() {
      Q("goToConfirmation", ee.value);
    }
    function y$(me) {
      const Ee = me;
      if ((Ee == null ? void 0 : Ee.bookingStatus) == "OK") {
        if (en.value) {
          const Pe = {
            mode_of_payment: "pay monthly",
            order_id: Ee.bookingNumber ?? ""
          };
          E(Pe);
        }
        j.value = Ee.authorization, ee.value = Ee.id, te.value = Ee.bookingStatus, ce.value = Ee.pinNumber, HD(), b$();
      } else {
        const Pe = me, Je = new wi({
          title: Pe == null ? void 0 : Pe.title,
          status: Pe == null ? void 0 : Pe.status,
          name: "",
          message: Pe == null ? void 0 : Pe.message,
          detail: Pe == null ? void 0 : Pe.detail,
          errorDetail: Pe == null ? void 0 : Pe.errorDetail
        });
        pa(Je);
      }
      U.loading = !1;
    }
    const Cr = () => {
      Q("clearAlertErrors"), U.loading = !0, Hl(null);
      const me = MO(
        dt.value,
        ca.value
      ), Ee = !!ro.value, Pe = G.value > 0, Je = (en.value && Ve.value) ?? !1, tn = Rb(
        me,
        Pe,
        Je,
        _r.value > 0
      );
      n.prePackage && n.hotel && n8(
        n.prePackage,
        void 0,
        n.hotel,
        Ee,
        Je,
        tn
      );
    };
    function $$() {
      var me, Ee;
      if (J0.value = !0, !dt.value && !zt.value && !$t.value && !en.value) {
        la.value = !0, zl();
        return;
      }
      la.value = !1, (Ee = (me = Y.value) == null ? void 0 : me.node) == null || Ee.submit();
    }
    function _$() {
      return en.value ? w$() : zt.value ? k$() : $t.value && !dt.value ? S$() : dt.value && T$(), !1;
    }
    async function w$() {
      je.value && Ve.value ? (U.loading = !0, Ie(null), ge(!1), re(!1), ae(!1), C$()) : (ae(!0), Vl());
    }
    function C$() {
      F();
      let me = 0;
      const Pe = setInterval(() => {
        if (me++ < l) {
          if (Ue.value) {
            const Je = {
              mode_of_payment: "pay monthly",
              payment_options: ["full", "pay monthly", "deposit"]
            };
            Be.value && P(Be.value, Je), clearInterval(Pe), cP(
              Eo.value,
              Ue.value,
              Cr,
              Bl,
              wr,
              se.value
            );
          }
        } else
          clearInterval(Pe), re(!0), U.loading = !1, Vl();
      }, i);
    }
    async function k$() {
      Cr();
      const me = Bl(), Pe = {
        billingAddress: Wi(
          ua.value,
          n.phoneNumber,
          n.emailAddress
        ),
        aeroplanPoints: [me]
      };
      await wr(Pe);
    }
    async function S$() {
      Cr();
      const me = Wi(
        ua.value,
        n.phoneNumber,
        n.emailAddress
      ), Ee = s$();
      await wr({
        billingAddress: me,
        giftCards: Ee
      });
    }
    function T$() {
      nk(
        B("vacvComponents.payment.errors.noCardNumber"),
        B("vacvComponents.payment.errors.noCVV")
      ) && (Cr(), zl(), ak(A$), n$(
        D$,
        P$,
        xd
      ), t$(Hn, xd));
    }
    function xd(me) {
      pa(new Error("No response from HPCI in " + me));
    }
    function A$() {
      Od({
        status: "",
        message: B("vacvComponents.payment.errors.paymentTechnicalError")
      });
    }
    async function D$() {
      const me = o$(
        n.phoneNumber,
        n.emailAddress,
        X.value
      );
      Hl(me), await l$(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        U.payment.creditCards,
        m$.value
      ) ? wr(me) : pa(
        new wi({
          title: B("vacvComponents.payment.errors.payment3DSError"),
          status: 400,
          detail: q$
        })
      );
    }
    function P$() {
      U.loading = !1;
    }
    async function Ul() {
      Y.value && (await rn(), vm(ua.value, Y.value), ca.value && vm(Dd.value, Y.value));
    }
    async function I$() {
      $t.value && (_r.value === Eo.value || ro.value !== null && ro.value > 0 && _r.value === ro.value) && Ft(), la.value = !1, dt.value ? await Ul() : (ca.value = !1, $t.value && (Rl.value && ro.value ? _t(ro.value, N) : _t(Eo.value, N)));
    }
    function Md() {
      la.value = !1, $t.value ? (ca.value = !1, Xl(), dt.value ? Ft() : Rl.value && ro.value ? _t(ro.value, N) : _t(Eo.value, N), Rt(N)) : Oo(N);
    }
    function zl() {
      oe.value.clear();
    }
    async function E$(me) {
      me ? (o8("Credit Card"), ok(), await Ul()) : Xl(), Oo(N);
    }
    function Ld() {
      ($t.value || dt.value) && s8(
        O$()
      );
    }
    const O$ = () => {
      const me = [];
      return dt.value && me.push("Credit Card"), $t.value && me.push("Gift Card"), me.join("; ");
    }, Oo = (me) => {
      var Pe, Je;
      Q0.value = !1, $t.value ? Rt(me) : ua.value.creditCardAmount = "", Dd.value.creditCardAmount = "";
      const Ee = (Je = (Pe = Y == null ? void 0 : Y.value) == null ? void 0 : Pe.node) == null ? void 0 : Je.children.find(
        (tn) => tn.name === "ccframe1-cc-amount-card"
      );
      lp(() => {
        var tn;
        (tn = Ee == null ? void 0 : Ee.store) == null || tn.filter(() => !1);
      }, 10);
    };
    async function x$() {
      dt.value && $t.value && (Fl.value === "0" || Fl.value === "0.00" || Fl.value === "0,00") && Rt(N), await Ul();
    }
    return le(
      () => n.totalAmountToPay,
      (me) => {
        typeof me == "number" && (Oo(N), Ed(me));
      }
    ), le(
      () => G.value,
      (me) => {
        me > 0 && (ca.value = !1, Xl(), Oo(N)), la.value = !1;
      }
    ), le(
      () => n.isVisible,
      (me) => {
        me || (sk(), v$(), Oo(N), Q("clearAlertErrors"));
      }
    ), le(Ge, (me) => {
      me && qH();
    }), le(dt, I$), le($t, Md), le(_r, () => {
      Rt(N);
    }), le(Rl, async () => {
      dt.value && $t.value ? (Ft(), Rt(N)) : dt.value ? Oo(N) : $t.value && Md();
    }), le(Z, (me) => {
      fe(me ? me.premium : 0);
    }), le([c$, Eo, f$], () => {
      Oo(N);
    }), (me, Ee) => {
      const Pe = ut("FormKit");
      return b(), C($e, null, [
        q(Pe, {
          ref_key: "formRef",
          ref: Y,
          id: "cc-accept-form",
          type: "form",
          actions: !1,
          onSubmitInvalid: h$,
          onSubmit: _$
        }, {
          default: he(() => {
            var Je, tn;
            return [
              d("section", P7, [
                T(zt) ? M("", !0) : (b(), C("h2", I7, k(me.$t("vacvComponents.payment.labels.paymentMethod")), 1)),
                q(T(Ug)),
                q(HU),
                d$.value ? (b(), ie(Sk, {
                  key: 1,
                  lang: T(o),
                  onGiftcardAmountBlur: x$,
                  onGiftCardSelected: Ld
                }, null, 8, ["lang"])) : M("", !0),
                u$.value ? (b(), ie(a7, {
                  key: 2,
                  ref_key: "creditCardsRef",
                  ref: H,
                  hpciConfig: x,
                  TWO_CC_THRESHOLD: T($),
                  showPayWithCreditCard: T(D),
                  onChangeTwocards: E$,
                  onCreditCardSelected: Ld
                }, null, 8, ["TWO_CC_THRESHOLD", "showPayWithCreditCard"])) : M("", !0),
                d("div", {
                  id: "up-pay-monthly-container",
                  src: "",
                  class: ue([
                    { hidden: !(T(je) && T(en)) },
                    "paddedbox-grey border uplift-container"
                  ])
                }, null, 2),
                q(UU, { lang: T(o) }, null, 8, ["lang"])
              ]),
              q(DU),
              (tn = (Je = me.hotel) == null ? void 0 : Je.hints) != null && tn.length ? (b(), ie(yR, {
                key: 0,
                hints: me.hotel.hints
              }, null, 8, ["hints"])) : M("", !0),
              q(Rz),
              d("div", E7, [
                d("div", {
                  innerHTML: me.$t("vacvComponents.payment.messages.termsConditions"),
                  class: "text"
                }, null, 8, O7)
              ]),
              q(Pe, {
                id: "submit-button",
                type: "button",
                label: me.$t("vacvComponents.payment.labels.creditCardConfirm"),
                "input-class": "$reset vacv-btn-primary",
                onClick: $$
              }, null, 8, ["label"])
            ];
          }),
          _: 1
        }, 512),
        U.loading ? (b(), ie(d7, {
          key: 0,
          title: me.$t("vacvComponents.payment.messages.waiting-message-title"),
          text: me.$t("vacvComponents.payment.messages.waiting-message-description"),
          cdnBaseUrl: T(A)
        }, null, 8, ["title", "text", "cdnBaseUrl"])) : M("", !0),
        T(Id) ? (b(), ie(Sm, {
          key: 1,
          actionURL: T(Id),
          threeDSServerTransId: T(r$),
          threeDSMethodData: T(i$)
        }, null, 8, ["actionURL", "threeDSServerTransId", "threeDSMethodData"])) : M("", !0),
        T(Pd) ? (b(), ie(Sm, {
          key: 2,
          actionURL: T(Pd),
          challengeData: T(a$)
        }, null, 8, ["actionURL", "challengeData"])) : M("", !0)
      ], 64);
    };
  }
});
function fy(e, t) {
  const n = OD(e), o = Bi(), s = xD(e, o);
  if (n !== "" && s !== "") {
    const a = new URLSearchParams(window.location.search);
    a.set("departingDateTime", n), a.set("returnDateTime", s), t && a.set("no_hotel", t), window.location.search = a.toString();
  }
}
const M7 = { class: "title-date" }, L7 = { class: "vacv-title" }, N7 = { class: "vacv-date" }, F7 = { class: "vacv-price" }, R7 = /* @__PURE__ */ K({
  __name: "FlexibleHotelDatesItem",
  props: {
    alternateHotelDate: {},
    tripDuration: {},
    selected: { type: Boolean },
    no_hotel: {},
    hotelName: {}
  },
  setup(e) {
    const t = It(), n = e, { t: o } = Ne({ useScope: "global" }), s = V(() => {
      var r;
      return (r = n.alternateHotelDate) != null && r.date ? ED(t, n.alternateHotelDate.date) : "";
    }), a = () => {
      if (!n.selected && n.alternateHotelDate.date) {
        const r = sn(n.alternateHotelDate.date);
        if (r) {
          const i = Ma(r);
          Vt("Flexible Dates Option", n.hotelName), fy(i, n.no_hotel);
        }
      }
    };
    return (r, i) => {
      var l;
      return b(), C("button", {
        class: "date-button",
        onClick: Ke(a, ["prevent"])
      }, [
        d("div", M7, [
          d("div", L7, k(T(o)("vacvComponents.plpList.flexDatesDeparture")), 1),
          d("div", N7, [
            ne(k(s.value) + " ", 1),
            d("span", null, k(T(o)("vacvComponents.plpList.flexNights", { count: r.tripDuration })), 1)
          ])
        ]),
        d("div", F7, k(T(Se)((l = r.alternateHotelDate) == null ? void 0 : l.price, r.$n)), 1)
      ]);
    };
  }
}), V7 = { class: "hotel-accordion" }, B7 = { class: "accordion-title" }, H7 = ["id"], U7 = ["aria-controls"], z7 = { class: "accordion-content" }, W7 = { class: "date-list" }, j7 = 5, q7 = /* @__PURE__ */ K({
  __name: "FlexibleHotelDatesAccordion",
  props: {
    position: { default: 0 },
    alternateHotelDates: {},
    no_hotel: {},
    hotelName: {},
    showHide: {}
  },
  setup(e) {
    const t = e, n = Bi(), o = Lb(), s = V(
      () => Wg(
        t.alternateHotelDates,
        o,
        j7
      )
    );
    function a(r) {
      return r.selected;
    }
    return (r, i) => (b(), ie(ta, {
      id: "flexibleDatesAccordion-" + t.position,
      className: "flexible-dates",
      role: "region",
      "aria-live": "polite",
      "aria-labelledby": "flexibleDatesAccordion-title-" + t.position
    }, {
      default: he(() => [
        d("div", V7, [
          d("div", B7, [
            d("div", {
              id: "flexibleDatesAccordion-title-" + t.position,
              class: "vacv-label-sm"
            }, k(r.$t("vacvComponents.plpList.flexDates")), 9, H7),
            d("button", {
              onClick: i[0] || (i[0] = //@ts-ignore
              (...l) => r.showHide && r.showHide(...l)),
              class: "btn-close",
              "a:aria-label": "$t('vacvComponents.common.buttons.close')",
              "aria-expanded": "true",
              "aria-controls": "flexibleDatesAccordion-" + t.position
            }, null, 8, U7)
          ]),
          d("div", z7, [
            d("ul", W7, [
              (b(!0), C($e, null, ke(s.value, (l, c) => (b(), C("li", {
                key: c,
                class: ue({
                  selected: a(l)
                })
              }, [
                q(R7, {
                  alternateHotelDate: l,
                  tripDuration: T(n),
                  selected: a(l),
                  no_hotel: r.no_hotel,
                  hotelName: r.hotelName
                }, null, 8, ["alternateHotelDate", "tripDuration", "selected", "no_hotel", "hotelName"])
              ], 2))), 128))
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["id", "aria-labelledby"]));
  }
}), rd = (e) => (dn("data-v-9addd532"), e = e(), fn(), e), K7 = { class: "item-content-left" }, Y7 = { class: "room-name" }, G7 = {
  key: 0,
  class: "room-view"
}, Z7 = { class: "room-beds" }, X7 = {
  key: 1,
  class: "room-amenities"
}, J7 = { key: 0 }, Q7 = /* @__PURE__ */ rd(() => /* @__PURE__ */ d("i", {
  class: "fa-solid fa-wifi",
  "aria-hidden": "true"
}, null, -1)), e6 = { key: 1 }, t6 = /* @__PURE__ */ rd(() => /* @__PURE__ */ d("i", {
  class: "fa-solid fa-tv",
  "aria-hidden": "true"
}, null, -1)), n6 = { key: 2 }, o6 = /* @__PURE__ */ rd(() => /* @__PURE__ */ d("i", {
  class: "fa-regular fa-snowflake",
  "aria-hidden": "true"
}, null, -1)), s6 = { class: "room-links" }, a6 = {
  key: 2,
  class: "room-options"
}, r6 = { class: "room-links" }, i6 = /* @__PURE__ */ K({
  __name: "HotelRoomDetails",
  props: {
    room: {},
    selectRoom: { type: Function }
  },
  setup(e) {
    const t = e, n = Ye("maxAvailability") ?? 0, o = V(() => {
      var s;
      return (s = t == null ? void 0 : t.room) != null && s.mealPlanName ? " - " + t.room.mealPlanName : "";
    });
    return (s, a) => {
      var r;
      return b(), C("div", K7, [
        d("h3", Y7, k(s.room.name) + k(o.value), 1),
        (r = s.room) != null && r.view ? (b(), C("div", G7, k(s.room.view), 1)) : M("", !0),
        d("div", Z7, k(s.room.bed), 1),
        s.room.wifi || s.room.television || s.room.airConditioning ? (b(), C("ul", X7, [
          s.room.wifi ? (b(), C("li", J7, [
            Q7,
            ne("Wifi ")
          ])) : M("", !0),
          s.room.television ? (b(), C("li", e6, [
            t6,
            ne("TV ")
          ])) : M("", !0),
          s.room.airConditioning ? (b(), C("li", n6, [
            o6,
            ne("AC ")
          ])) : M("", !0)
        ])) : M("", !0),
        d("div", s6, [
          d("button", {
            onClick: a[0] || (a[0] = (i) => s.selectRoom("See All Details Link")),
            class: "link linklook"
          }, k(s.$t("vacvComponents.plpList.roomShowDetails")), 1)
        ]),
        T(n) > 1 ? (b(), C("div", a6, [
          d("strong", null, k(s.$t("vacvComponents.plpList.roomOptionsInfo", {
            count: T(n) - 1
          })), 1),
          d("div", r6, [
            d("button", {
              onClick: a[1] || (a[1] = (i) => s.selectRoom("See All Room Options Link")),
              class: "link linklook"
            }, k(s.$t("vacvComponents.plpList.roomOptionsButton")), 1)
          ])
        ])) : M("", !0)
      ]);
    };
  }
}), l6 = /* @__PURE__ */ De(i6, [["__scopeId", "data-v-9addd532"]]), c6 = { class: "hotel-accordion" }, u6 = { class: "accordion-title" }, p6 = ["id"], d6 = ["aria-label", "aria-controls"], f6 = { class: "accordion-content" }, m6 = {
  key: 0,
  class: "item-gallery"
}, v6 = { class: "item-content" }, h6 = /* @__PURE__ */ K({
  __name: "HotelRoomAccordion",
  props: {
    hotelName: { default: "" },
    room: {},
    position: {},
    visible: { type: Boolean },
    showHide: {},
    selectRoom: {}
  },
  setup(e) {
    var r, i, l, c, u, p;
    const t = e, n = (i = (r = t.room.roomDetails) == null ? void 0 : r.images) == null ? void 0 : i.images, o = (c = (l = t.room.roomDetails) == null ? void 0 : l.images) == null ? void 0 : c.sizes, s = (p = (u = t.room.roomDetails) == null ? void 0 : u.images) == null ? void 0 : p.variations, a = () => {
      t.hotelName && Vt("Room Modal - Room Picture", t.hotelName);
    };
    return (f, m) => (b(), ie(ta, {
      id: "roomDetailsAccordion-" + f.position,
      className: "room-details",
      role: "region",
      "aria-live": "polite",
      "aria-labelledby": "roomDetailsAccordion-title-" + f.position
    }, {
      default: he(() => [
        d("div", c6, [
          d("div", u6, [
            d("div", {
              class: "vacv-label-sm",
              id: "roomDetailsAccordion-title-" + f.position
            }, k(f.$t("vacvComponents.plpList.roomDetails")), 9, p6),
            d("button", {
              onClick: m[0] || (m[0] = //@ts-ignore
              (...h) => f.showHide && f.showHide(...h)),
              class: "btn-close",
              "aria-label": f.$t("vacvComponents.common.buttons.close"),
              "aria-expanded": "true",
              "aria-controls": "roomDetailsAccordion-" + f.position
            }, null, 8, d6)
          ]),
          d("div", f6, [
            d("div", {
              class: ue(["hotel-item", { "has-item-gallery": T(n) }])
            }, [
              T(n) && T(o) ? (b(), C("div", m6, [
                q(Jp, {
                  class: "carousel-small",
                  images: T(n),
                  sizes: T(o),
                  "available-variations": T(s),
                  "display-size": "medium",
                  "display-variation": "tabletLandscape",
                  onCarouselModalOpened: a
                }, null, 8, ["images", "sizes", "available-variations"])
              ])) : M("", !0),
              d("div", v6, [
                q(l6, {
                  room: f.room,
                  selectRoom: f.selectRoom
                }, null, 8, ["room", "selectRoom"])
              ])
            ], 2)
          ])
        ])
      ]),
      _: 1
    }, 8, ["id", "aria-labelledby"]));
  }
}), Tm = {
  LAST_BOOKING: {
    hotel: {
      MINUTE: "vacvComponents.psytriggers.last-booking-minute",
      HOUR: "vacvComponents.psytriggers.last-booking-hour"
    },
    room: {
      MINUTE: "vacvComponents.psytriggers.room-last-booking-minute",
      HOUR: "vacvComponents.psytriggers.room-last-booking-hour"
    }
  },
  TOTAL_BOOKINGS: {
    hotel: {
      "24H": "vacvComponents.psytriggers.total-bookings-24",
      "48H": "vacvComponents.psytriggers.total-bookings-48"
    },
    room: {
      "24H": "vacvComponents.psytriggers.room-total-bookings-24",
      "48H": "vacvComponents.psytriggers.room-total-bookings-48"
    }
  },
  ROOMS_LEFT: "vacvComponents.psytriggers.rooms-left"
}, Am = {
  ROOMS_LEFT: "vacvComponents.psytriggers.rooms-left-advisory",
  BOOKINGS: "vacvComponents.psytriggers.bookings-advisory"
}, g6 = (e, t) => {
  if (e != null && e.type) {
    if (e.type === "ROOMS_LEFT")
      return {
        message: Tm[e.type],
        advisory: Am.ROOMS_LEFT
      };
    if (e.type === "LAST_BOOKING" || e.type === "TOTAL_BOOKINGS")
      return {
        message: Tm[e.type][t][e.span],
        advisory: Am.BOOKINGS
      };
  }
}, b6 = (e) => (dn("data-v-502976f1"), e = e(), fn(), e), y6 = { class: "btn-tooltip linklook" }, $6 = /* @__PURE__ */ b6(() => /* @__PURE__ */ d("i", {
  class: "fa-solid fa-alarm-clock",
  "aria-hidden": "true"
}, null, -1)), _6 = ["onClick", "aria-label"], w6 = {
  class: "tooltip-content",
  id: "tooltip-psytrigger-content"
}, C6 = /* @__PURE__ */ K({
  __name: "PsychTrigger",
  props: {
    trigger: {},
    appliedTo: {}
  },
  setup(e) {
    const t = e, n = parseInt(t.trigger.value ?? "0"), o = g6(t.trigger, t.appliedTo);
    return (s, a) => {
      var r;
      return (r = T(o)) != null && r.message && T(n) ? (b(), ie(T(bi), {
        key: 0,
        placement: "bottom",
        arrow: "",
        role: "dialog",
        "aria-label": "tooltip-psytrigger-content"
      }, ui({
        default: he(() => [
          d("button", y6, [
            $6,
            ne(" " + k(s.$t(T(o).message, { count: T(n) })), 1)
          ])
        ]),
        _: 2
      }, [
        T(o).advisory ? {
          name: "content",
          fn: he(({ close: i }) => [
            d("button", {
              class: "btn-close",
              onClick: i,
              "aria-label": s.$t("vacvComponents.common.buttons.close")
            }, null, 8, _6),
            d("div", w6, k(s.$t(T(o).advisory)), 1)
          ]),
          key: "0"
        } : void 0
      ]), 1024)) : M("", !0);
    };
  }
}), my = /* @__PURE__ */ De(C6, [["__scopeId", "data-v-502976f1"]]), k6 = { class: "accordion-content" }, S6 = { class: "flight-title fa-plane" }, T6 = { class: "flight-trip" }, A6 = { class: "flight-row city-stop" }, D6 = { class: "city origin" }, P6 = { class: "code" }, I6 = { class: "desktop-only stops" }, E6 = { class: "city destination" }, O6 = { class: "code" }, x6 = { class: "flight-row time-duration" }, M6 = { class: "datetime origin" }, L6 = { class: "date" }, N6 = { class: "time" }, F6 = {
  key: 0,
  class: "desktop-only duration"
}, R6 = { class: "datetime destination" }, V6 = { class: "date" }, B6 = { class: "time" }, H6 = { class: "mobile-only stop-duration" }, U6 = { class: "stops" }, z6 = {
  key: 0,
  class: "duration"
}, W6 = { class: "flight-details" }, j6 = { class: "info" }, q6 = {
  key: 0,
  class: "airline"
}, K6 = {
  key: 1,
  class: "airline"
}, Y6 = {
  key: 2,
  class: "flightnum"
}, G6 = { class: "cabinClass" }, Dm = /* @__PURE__ */ K({
  __name: "FlightDetailsSegment",
  props: {
    segments: {},
    displayDuration: { type: Boolean, default: !0 }
  },
  setup(e) {
    const t = e, { t: n } = Ne({ useScope: "global" }), o = t.segments[0].originName, s = t.segments[0].origin, a = t.segments[t.segments.length - 1].destinationName, r = t.segments[t.segments.length - 1].destination, i = V(() => {
      var y;
      return (y = t.segments) == null ? void 0 : y[0].bound;
    }), l = V(() => i.value === "O" ? n("vacvComponents.flight.labels.departure") : n("vacvComponents.flight.labels.return")), c = V(
      () => Ss(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        t.segments[0].departureDate,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        t.segments[0].departureTime
      )
    ), u = V(
      () => Ss(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        t.segments[t.segments.length - 1].arrivalDate,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        t.segments[t.segments.length - 1].arrivalTime
      )
    ), p = V(() => t.segments[0].numConnections), f = V(() => {
      var y;
      return (y = t.segments[0]) == null ? void 0 : y.totalFlightDuration;
    }), m = V(() => f.value ? f.value.substring(0, 2) + "h" + f.value.substring(2) : null), h = V(() => {
      var y;
      return (y = t.segments) == null ? void 0 : y[0].operatingAirline;
    }), g = V(() => {
      var y;
      return (y = t.segments) == null ? void 0 : y[0].carrierName;
    }), _ = V(() => {
      var y;
      return (y = t.segments) == null ? void 0 : y[0].carrierCode;
    }), v = V(() => {
      var y;
      return (y = t.segments) == null ? void 0 : y[0].flightNumber;
    }), w = V(() => {
      var y;
      return (y = t.segments) == null ? void 0 : y[0].cabinClassName;
    });
    return (y, $) => (b(), C("div", k6, [
      d("div", S6, [
        d("span", null, k(l.value), 1)
      ]),
      d("div", T6, [
        d("div", A6, [
          d("div", D6, [
            ne(k(T(o)) + " ", 1),
            d("span", P6, k(T(s)), 1)
          ]),
          d("div", I6, [
            q(Hi, { connections: p.value }, null, 8, ["connections"]),
            q(Ui, {
              class: ue("line stop-" + p.value),
              connections: p.value
            }, null, 8, ["class", "connections"])
          ]),
          d("div", E6, [
            ne(k(T(a)) + " ", 1),
            d("span", O6, k(T(r)), 1)
          ])
        ]),
        d("div", x6, [
          q(Ui, {
            class: ue("mobile-only line stop-" + p.value),
            connections: p.value
          }, null, 8, ["class", "connections"]),
          d("div", M6, [
            d("span", L6, k(y.$d(c.value, "short")), 1),
            d("span", N6, k(y.$d(c.value, "time")), 1)
          ]),
          m.value && y.displayDuration ? (b(), C("div", F6, [
            ne(k(y.$t("vacvComponents.flight.labels.duration")) + ": ", 1),
            d("span", null, " " + k(m.value), 1)
          ])) : M("", !0),
          d("div", R6, [
            d("span", V6, k(y.$d(u.value, "short")), 1),
            d("span", B6, k(y.$d(u.value, "time")), 1)
          ])
        ])
      ]),
      d("div", H6, [
        d("div", U6, [
          q(Hi, { connections: p.value }, null, 8, ["connections"])
        ]),
        m.value && y.displayDuration ? (b(), C("div", z6, [
          ne(k(y.$t("vacvComponents.flight.labels.duration")) + ": ", 1),
          d("span", null, " " + k(m.value), 1)
        ])) : M("", !0)
      ]),
      d("div", W6, [
        d("div", j6, [
          h.value ? (b(), C("span", q6, k(y.$t("vacvComponents.flight.labels.operatedBy")) + " " + k(h.value) + ", ", 1)) : (b(), C("span", K6, k(g.value) + ", ", 1)),
          y.displayDuration ? M("", !0) : (b(), C("span", Y6, k(_.value) + " " + k(v.value) + ", ", 1)),
          d("span", G6, k(w.value), 1)
        ])
      ])
    ]));
  }
}), Z6 = { class: "hotel-accordion" }, X6 = ["id"], J6 = { class: "vacv-label-sm" }, Q6 = {
  key: 0,
  class: "title-sub"
}, eW = ["aria-label", "aria-controls"], tW = /* @__PURE__ */ K({
  __name: "FlightDetailsAccordion",
  props: {
    position: { default: 0 },
    outbound: {},
    inbound: {},
    showHide: {}
  },
  setup(e) {
    const t = e, n = V(
      () => t.inbound !== void 0 || t.outbound !== void 0
    );
    return (o, s) => (b(), ie(ta, {
      id: "flightDetailsAccordion-" + t.position,
      className: "flight-details",
      role: "region",
      "aria-live": "polite",
      "aria-labelledby": "flightDetailsAccordion-title-" + t.position
    }, {
      default: he(() => [
        d("div", Z6, [
          d("div", {
            class: ue(
              n.value ? "accordion-title details" : "accordion-title details no-avail"
            )
          }, [
            d("div", {
              id: "flightDetailsAccordion-title-" + t.position
            }, [
              d("div", J6, k(n.value ? o.$t("vacvComponents.flight.labels.flightDetails") : o.$t("vacvComponents.flight.messages.flightDetailsError")), 1),
              n.value ? (b(), C("div", Q6, k(o.$t("vacvComponents.flight.messages.flightDetailsSubtitle")), 1)) : M("", !0)
            ], 8, X6),
            d("button", {
              onClick: s[0] || (s[0] = //@ts-ignore
              (...a) => o.showHide && o.showHide(...a)),
              class: "btn-close",
              "aria-label": o.$t("vacvComponents.common.buttons.close"),
              "aria-expanded": "true",
              "aria-controls": "flightDetailsAccordion-" + t.position
            }, null, 8, eW)
          ], 2),
          o.outbound ? (b(), ie(Dm, {
            key: 0,
            class: ue("outbound"),
            segments: o.outbound
          }, null, 8, ["segments"])) : M("", !0),
          o.inbound ? (b(), ie(Dm, {
            key: 1,
            class: ue("inbound"),
            segments: o.inbound
          }, null, 8, ["segments"])) : M("", !0)
        ])
      ]),
      _: 1
    }, 8, ["id", "aria-labelledby"]));
  }
}), nW = ["id"], oW = { class: "hotel-item" }, sW = { class: "item-gallery" }, aW = {
  key: 0,
  class: "recommended-label"
}, rW = /* @__PURE__ */ d("i", { class: "fa-solid fa-thumbs-up" }, null, -1), iW = { class: "sr-only" }, lW = {
  key: 2,
  class: "carousel-fallback-img"
}, cW = ["src", "alt"], uW = { class: "item-content" }, pW = { class: "item-content-left" }, dW = { class: "hotel-name" }, fW = {
  key: 2,
  class: "hotel-package"
}, mW = { class: "desktop-only links-wrapper" }, vW = ["aria-expanded", "aria-controls"], hW = /* @__PURE__ */ d("i", {
  class: "fa-solid fa-plane",
  "aria-hidden": "true"
}, null, -1), gW = ["aria-expanded", "aria-controls"], bW = /* @__PURE__ */ d("i", {
  class: "fa-solid fa-bed-front",
  "aria-hidden": "true"
}, null, -1), yW = ["aria-expanded", "aria-controls"], $W = /* @__PURE__ */ d("i", {
  class: "fa-solid fa-calendar-days",
  "aria-hidden": "true"
}, null, -1), _W = { class: "item-content-right" }, wW = { class: "price-right" }, CW = { class: "hotel-select" }, kW = { class: "sr-only" }, SW = { class: "mobile-only links-wrapper" }, TW = ["aria-expanded", "aria-controls"], AW = /* @__PURE__ */ d("i", {
  class: "fa-solid fa-plane",
  "aria-hidden": "true"
}, null, -1), DW = ["aria-expanded", "aria-controls"], PW = /* @__PURE__ */ d("i", {
  class: "fa-solid fa-bed-front",
  "aria-hidden": "true"
}, null, -1), IW = ["aria-expanded", "aria-controls"], EW = /* @__PURE__ */ d("i", {
  class: "fa-solid fa-calendar-days",
  "aria-hidden": "true"
}, null, -1), OW = 5, ele = /* @__PURE__ */ K({
  __name: "PlpListItemContent",
  props: {
    position: {},
    package: {},
    hotel: {},
    itinerary: {},
    localisedPromo: {},
    trigger: {},
    price: {},
    total: {},
    wasPricePerAdult: {},
    savingsPercentage: {},
    savingsThreshold: {},
    wasPriceTooltipEnabled: { type: Boolean },
    cdnBaseUrl: {},
    spaType: {}
  },
  emits: ["select"],
  setup(e, { emit: t }) {
    var x, F, P, E, B;
    const n = t, o = e, s = Lb(), { locale: a } = Ne({ useScope: "global" }), r = R(!1), i = R(!1), l = R(!1), c = ((F = (x = o.itinerary) == null ? void 0 : x.segments) == null ? void 0 : F.filter((N) => N.bound === "O")) ?? [], u = ((E = (P = o.itinerary) == null ? void 0 : P.segments) == null ? void 0 : E.filter((N) => N.bound === "I")) ?? [], p = V(() => {
      var Y;
      const N = (Y = o.package) == null ? void 0 : Y.alternateDates;
      if (N) {
        const j = Wg(
          N,
          s,
          OW
        );
        if (j.length)
          return j;
      }
      return null;
    }), f = o.hotel.rooms ? Object.values(o.hotel.rooms)[0] : void 0, m = (N, Y) => {
      var ee, te;
      const j = N.value;
      r.value = !1, i.value = !1, l.value = !1, N.value = !j, N.value && (o != null && o.hotel.name) && (Y === "Room Link" ? (Vt("Room Link", o.hotel.name), Vt(
        (te = (ee = f == null ? void 0 : f.roomDetails) == null ? void 0 : ee.images) != null && te.images ? "Room Modal - Room Picture Available" : "Room Modal - Room Picture Not Available",
        o.hotel.name
      )) : Vt(Y, o.hotel.name));
    }, h = () => {
      m(r, "Flight Details Link");
    }, g = () => {
      m(i, "Room Link");
    }, _ = () => {
      m(l, "Flexible Dates Link");
    };
    function v() {
      o.hotel.name && Vt("Total Price Link", o.hotel.name);
    }
    const w = () => {
      o.hotel.name && Vt("Was Price", o.hotel.name);
    }, y = () => {
      o.hotel.name && Vt("Hotel Picture", o.hotel.name);
    };
    Zc(
      "defaultImage",
      `${o.cdnBaseUrl}/img/carousel-fallback-img_${a.value}.jpg`
    ), Zc("maxAvailability", o.package.maxAvailableRoomCategory);
    const $ = (N) => {
      d8(
        o.position,
        o.package,
        o.hotel,
        o.itinerary,
        o.trigger
      ), o.hotel.name && Vt(N === "See All Details Link" || N === "See All Room Options Link" ? `Room Modal - ${N}` : "Select Button", o.hotel.name), n("select");
    }, S = () => {
      o.hotel.name && Vt("Hotel Name Link", o.hotel.name), n("select");
    }, A = ((B = o.package.information) == null ? void 0 : B.refundable) ?? !0, I = "packageInclusions" in o.package.information && o.package.information.packageInclusions, D = (() => {
      var N;
      return (N = o.package.pricing) == null ? void 0 : N.grandTotal;
    })(), O = V(() => o.spaType === lt.HotelsSpa);
    return (N, Y) => {
      var j, ee, te, ce, H;
      return b(), C("div", {
        id: "spa-list-item-" + N.position,
        class: "hotel-item-wrapper"
      }, [
        d("div", oW, [
          d("div", sW, [
            N.hotel.recommended ? (b(), C("div", aW, [
              rW,
              d("span", iW, k(N.$t("vacvComponents.plp.messages.recommended-access")), 1),
              ne(k(N.$t("vacvComponents.plp.messages.recommended")), 1)
            ])) : M("", !0),
            (te = (ee = (j = N.hotel) == null ? void 0 : j.media) == null ? void 0 : ee.images) != null && te.length && ((H = (ce = N.hotel) == null ? void 0 : ce.media) != null && H.sizes) ? (b(), ie(Jp, {
              key: 1,
              class: "carousel-small",
              images: N.hotel.media.images,
              sizes: N.hotel.media.sizes,
              "available-variations": N.hotel.media.variations,
              "display-size": "medium",
              "display-variation": "tabletLandscape",
              onCarouselModalOpened: y
            }, null, 8, ["images", "sizes", "available-variations"])) : (b(), C("div", lW, [
              d("img", {
                src: `${N.cdnBaseUrl}/img/carousel-fallback-img_${T(a)}.jpg`,
                alt: N.$t("vacvComponents.common.messages.fallback-img")
              }, null, 8, cW)
            ]))
          ]),
          d("div", uW, [
            d("div", pW, [
              N.trigger ? (b(), ie(my, {
                key: 0,
                trigger: N.trigger,
                appliedTo: "hotel",
                class: "psytrigger vacv-tooltip"
              }, null, 8, ["trigger"])) : M("", !0),
              N.localisedPromo && !O.value ? (b(), ie(bh, {
                key: 1,
                class: "aeroplanpoints",
                badge: N.localisedPromo.Badge,
                "modal-title": N.$t("vacvComponents.plpList.aeroplanpointsTitle"),
                "modal-text": N.localisedPromo.Terms,
                origin: "plpAeroplan"
              }, null, 8, ["badge", "modal-title", "modal-text"])) : M("", !0),
              d("h2", dW, [
                d("a", {
                  href: "/",
                  class: "hotel-name-link",
                  onClick: Ke(S, ["prevent"])
                }, k(N.hotel.name), 1)
              ]),
              q(ny, {
                hotel: N.hotel,
                package: N.package
              }, null, 8, ["hotel", "package"]),
              T(I) ? (b(), C("div", fW, k(T(I)), 1)) : M("", !0),
              N.hotel.rating && T(zg)(N.hotel.rating) ? (b(), ie(ah, {
                key: 3,
                rating: N.hotel.rating
              }, null, 8, ["rating"])) : M("", !0),
              d("div", mW, [
                O.value ? M("", !0) : (b(), C("button", {
                  key: 0,
                  onClick: h,
                  class: "flight-details-link hotel-link-icon link linklook",
                  "aria-expanded": r.value,
                  "aria-controls": "flightDetailsAccordion-" + N.position
                }, [
                  hW,
                  ne(" " + k(N.$t("vacvComponents.plpList.flightdetails")), 1)
                ], 8, vW)),
                T(f) ? (b(), C("button", {
                  key: 1,
                  onClick: g,
                  class: "room-details-link hotel-link-icon link linklook",
                  "aria-expanded": i.value,
                  "aria-controls": "roomDetailsAccordion-" + N.position
                }, [
                  bW,
                  ne(" " + k(N.$t("vacvComponents.plpList.roomDetails")), 1)
                ], 8, gW)) : M("", !0),
                p.value ? (b(), C("button", {
                  key: 2,
                  onClick: _,
                  class: "flexible-dates-link hotel-link-icon link linklook",
                  "aria-expanded": l.value,
                  "aria-controls": "flexibleDatesAccordion-" + N.position
                }, [
                  $W,
                  ne(" " + k(N.$t("vacvComponents.plpList.flexibleDates")), 1)
                ], 8, yW)) : M("", !0)
              ])
            ]),
            d("div", _W, [
              N.package.pricing ? (b(), ie(ay, {
                key: 0,
                "pre-package-pricing": N.package.pricing,
                price: N.price,
                total: N.total,
                "show-difference": !1,
                wasPricePerAdult: N.wasPricePerAdult,
                savingsPercentage: N.savingsPercentage,
                wasPriceTooltipEnabled: N.wasPriceTooltipEnabled,
                savingsThreshold: N.savingsThreshold,
                spaType: N.spaType,
                onPriceTotalClick: v,
                onWasPriceClick: w
              }, {
                priceBreakdownLines: he(() => [
                  q(nd, {
                    "price-total": T(D),
                    spaType: N.spaType,
                    modifier: "popover",
                    "is-section": "",
                    "is-refundable": T(A)
                  }, null, 8, ["price-total", "spaType", "is-refundable"])
                ]),
                _: 1
              }, 8, ["pre-package-pricing", "price", "total", "wasPricePerAdult", "savingsPercentage", "wasPriceTooltipEnabled", "savingsThreshold", "spaType"])) : M("", !0),
              d("div", wW, [
                T(A) ? M("", !0) : (b(), ie(td, { key: 0 })),
                d("div", CW, [
                  d("button", {
                    onClick: Y[0] || (Y[0] = () => $()),
                    class: "vacv-btn-primary"
                  }, [
                    ne(k(N.$t("vacvComponents.common.buttons.select")) + " ", 1),
                    d("span", kW, k(N.hotel.name), 1)
                  ])
                ])
              ])
            ]),
            d("div", SW, [
              O.value ? M("", !0) : (b(), C("button", {
                key: 0,
                onClick: h,
                class: "flight-details-link hotel-link-icon link linklook",
                "aria-expanded": r.value,
                "aria-controls": "flightDetailsAccordion-" + N.position
              }, [
                AW,
                ne(" " + k(N.$t("vacvComponents.plpList.flightdetails")), 1)
              ], 8, TW)),
              T(f) ? (b(), C("button", {
                key: 1,
                onClick: g,
                class: "room-details-link hotel-link-icon link linklook",
                "aria-expanded": i.value,
                "aria-controls": "roomDetailsAccordion-" + N.position
              }, [
                PW,
                ne(" " + k(N.$t("vacvComponents.plpList.roomDetails")), 1)
              ], 8, DW)) : M("", !0),
              p.value ? (b(), C("button", {
                key: 2,
                onClick: _,
                class: "flexible-dates-link hotel-link-icon link linklook",
                "aria-expanded": l.value,
                "aria-controls": "flexibleDatesAccordion-" + N.position
              }, [
                EW,
                ne(" " + k(N.$t("vacvComponents.plpList.flexibleDates")), 1)
              ], 8, IW)) : M("", !0)
            ])
          ])
        ]),
        q(st, { name: "collapsible" }, {
          default: he(() => [
            r.value && !O.value ? (b(), ie(tW, {
              key: 0,
              id: "flightDetailsAccordion-" + N.position,
              position: N.position,
              outbound: T(c),
              inbound: T(u),
              showHide: h
            }, null, 8, ["id", "position", "outbound", "inbound"])) : M("", !0)
          ]),
          _: 1
        }),
        q(st, { name: "collapsible" }, {
          default: he(() => [
            T(f) && i.value ? (b(), ie(h6, {
              key: 0,
              id: "roomDetailsAccordion-" + N.position,
              hotelName: N.hotel.name,
              room: T(f),
              position: N.position,
              showHide: g,
              selectRoom: $,
              visible: i.value
            }, null, 8, ["id", "hotelName", "room", "position", "visible"])) : M("", !0)
          ]),
          _: 1
        }),
        q(st, { name: "collapsible" }, {
          default: he(() => [
            p.value && l.value && N.package.svHotelId && N.hotel.name ? (b(), ie(q7, {
              key: 0,
              id: "flexibleDatesAccordion-" + N.position,
              position: N.position,
              alternateHotelDates: p.value,
              no_hotel: N.package.svHotelId,
              hotelName: N.hotel.name,
              showHide: _
            }, null, 8, ["id", "position", "alternateHotelDates", "no_hotel", "hotelName"])) : M("", !0)
          ]),
          _: 1
        })
      ], 8, nW);
    };
  }
}), xW = {
  key: 0,
  id: "alternatedates-section",
  class: "alternatedates-section"
}, MW = { class: "message-title" }, LW = {
  key: 0,
  id: "message-multiple-dates"
}, NW = { class: "message-directive" }, FW = {
  key: 1,
  id: "message-single-date"
}, RW = { class: "message-directive" }, VW = { class: "alternatedates-listing" }, BW = { class: "vacv-radio-group column" }, tle = /* @__PURE__ */ K({
  __name: "AlternateDates",
  props: {
    alternateDates: {},
    departingDateTime: {}
  },
  setup(e) {
    const t = e, { t: n, d: o, locale: s } = Ne({ useScope: "global" }), a = async (u) => {
      fy(u.alternatedates);
    }, r = V(() => {
      const u = (f) => /^\d{8}$/.test(f), p = (f, m) => parseInt(f) - parseInt(m);
      return t.alternateDates === void 0 ? [] : t.alternateDates.filter(u).sort(p).slice(0, 5);
    }), i = V(() => r.value.map((u) => {
      const p = sn(u);
      if (p)
        return {
          label: n("vacvComponents.alternatedates.labels.prefix-available-date") + o(p, "medium", s.value),
          value: u
        };
    })), l = V(() => r.value.length == 1 ? r.value[0] : c());
    function c() {
      if (t.departingDateTime === void 0 || t.departingDateTime == null)
        return r.value[0];
      if (typeof t.departingDateTime != "string")
        return "";
      const u = Us(t.departingDateTime);
      if (u === void 0)
        return r.value[0];
      const p = r.value.length - 1, f = r.value.findIndex((_) => _ > u);
      if (f === -1)
        return r.value[p];
      const m = f > 0 ? sn(r.value[f - 1]) : sn(r.value[f]), h = f < p ? sn(r.value[f]) : sn(r.value[p]), g = sn(u);
      if (g && m && h) {
        const _ = Li(g, m), v = Li(h, g);
        return _ === v ? Ma(m) : _ > v ? Ma(h) : Ma(m);
      }
      return "";
    }
    return (u, p) => {
      const f = ut("FormKit");
      return r.value.length > 0 ? (b(), C("div", xW, [
        d("h1", MW, k(u.$t("vacvComponents.alternatedates.messages.not-available")), 1),
        r.value.length > 1 ? (b(), C("div", LW, [
          d("div", NW, k(u.$t("vacvComponents.alternatedates.messages.select-available-dates")), 1)
        ])) : (b(), C("div", FW, [
          d("div", RW, k(u.$t("vacvComponents.alternatedates.messages.found-one-date")), 1)
        ])),
        d("div", VW, [
          q(f, {
            id: "alternatedates-form",
            type: "form",
            actions: !1,
            onSubmit: a
          }, {
            default: he(() => [
              d("div", BW, [
                q(f, {
                  id: "alternatedates-radio",
                  type: "radio",
                  name: "alternatedates",
                  options: i.value,
                  value: l.value,
                  validation: "required",
                  "validation-messages": {
                    required: u.$t(
                      "vacvComponents.alternatedates.errors.mandatory-date"
                    )
                  }
                }, null, 8, ["options", "value", "validation-messages"])
              ]),
              d("div", null, [
                q(f, {
                  id: "alternatedates-submit",
                  type: "submit",
                  label: u.$t("vacvComponents.common.buttons.submit"),
                  "input-class": "$reset vacv-btn-primary"
                }, null, 8, ["label"])
              ])
            ]),
            _: 1
          })
        ])
      ])) : M("", !0);
    };
  }
}), vy = {
  subTitle: "vacvComponents.plp.messages.something-went-wrong",
  suggestTitle: "vacvComponents.plp.messages.try-again-by",
  suggestions: [
    "vacvComponents.plp.messages.click-modify",
    "vacvComponents.plp.messages.refresh-page"
  ]
}, HW = {
  subTitle: "vacvComponents.plp.messages.specific-s214-error-tulum",
  suggestTitle: "vacvComponents.plp.messages.suggest-cancun-good-news",
  suggestTitle2: "vacvComponents.plp.messages.suggest-cancun-update",
  updateCta: !0
}, UW = {
  subTitle: "vacvComponents.plp.messages.notfound-unavailable",
  suggestTitle: "vacvComponents.plp.messages.suggest",
  suggestions: [
    "vacvComponents.plp.messages.suggest-date",
    "vacvComponents.plp.messages.suggest-travellers",
    "vacvComponents.plp.messages.suggest-different-airport",
    "vacvComponents.plp.messages.suggest-alternative-destination"
  ],
  updateCta: !0
}, zW = {
  subTitle: "vacvComponents.plp.messages.notfound",
  suggestTitle: "vacvComponents.plp.messages.suggest",
  suggestions: [
    "vacvComponents.plp.messages.suggest-date",
    "vacvComponents.plp.messages.suggest-nearby-airports",
    "vacvComponents.plp.messages.suggest-different-destination"
  ],
  updateCta: !0
}, WW = {
  html: "vacvComponents.plp.messages.children-more-than-one-room-error",
  updateCta: !0
}, jW = {
  html: "vacvComponents.plp.messages.more-than-6-pax-error",
  updateCta: !0
}, qW = {
  html: "vacvComponents.plp.messages.adults-repartition-error",
  updateCta: !0
}, KW = {
  subTitle: "vacvComponents.plp.messages.notfound-filters"
}, YW = {
  subTitle: "vacvComponents.plp.messages.notfound-filters-hotels"
}, GW = /* @__PURE__ */ new Map([
  [Rn.INCORRECT_SEARCH, zW],
  [Rn.INVALID_NUM_ROOM_CHILD, WW],
  [Rn.INVALID_OCCUPANCY, jW],
  [Rn.ADULTS_REPARTITION_ERROR, qW],
  [Rn.GENERAL_SAX_ERROR, vy]
]), ZW = /* @__PURE__ */ new Set([
  "vacvComponents.plp.messages.suggest-different-airport",
  "vacvComponents.plp.messages.suggest-nearby-airports"
]), XW = () => {
  const t = new URLSearchParams(window.location.search).get("dest_dep");
  if (t && K$.has(t))
    return HW;
}, JW = (e, t, n, o) => {
  const s = o ? void 0 : XW();
  if (e === Rn.INCORRECT_SEARCH && s)
    return s;
  const a = e && GW.get(e);
  return a || (t ? o ? YW : KW : n ? vy : s ?? UW);
}, QW = (e, t) => e.suggestions ? {
  ...e,
  suggestions: e.suggestions.filter((n) => !t.has(n))
} : e, ej = (e, t, n, o) => {
  const s = JW(
    e,
    t,
    n,
    o
  );
  return o ? QW(s, ZW) : s;
}, tj = { class: "numberfound-wrapper" }, nj = { class: "filter-sortby" }, oj = {
  key: 0,
  class: "mobile-only filterbutton"
}, sj = ["aria-expanded"], aj = /* @__PURE__ */ d("i", {
  class: "fa-regular fa-sliders",
  "aria-hidden": "true"
}, null, -1), rj = { class: "vacv-label-sm" }, ij = {
  key: 0,
  class: "sv-search-error",
  "data-test": "service-error"
}, lj = { key: 0 }, cj = ["innerHTML"], uj = {
  key: 1,
  class: "text"
}, pj = { class: "h1style" }, dj = { key: 0 }, fj = { key: 0 }, mj = { class: "suggest" }, vj = {
  key: 0,
  class: "suggest"
}, hj = {
  key: 1,
  class: "special-list"
}, gj = {
  key: 2,
  "data-test": "service-error-cta"
}, nle = /* @__PURE__ */ K({
  __name: "PlpError",
  props: {
    hasFiltersSelected: { type: Boolean },
    isSticky: { type: Boolean },
    filterOpened: { type: Boolean },
    showSortBy: { type: Boolean },
    label: {},
    sortByOptions: {},
    error: {},
    excludeAirportSuggestions: { type: Boolean }
  },
  emits: ["open-filter", "on-change"],
  setup(e, { emit: t }) {
    const { t: n } = Ne({ useScope: "global" }), o = e, s = V(() => {
      const c = o == null ? void 0 : o.error, u = !!(o != null && o.error), p = ej(
        c == null ? void 0 : c.detail,
        o.hasFiltersSelected,
        u,
        o.excludeAirportSuggestions
      );
      return p != null && p.html && (p.html = n(p.html)), p;
    }), a = t, r = () => {
      a("open-filter");
    }, i = (c, u) => {
      a("on-change", c, u);
    }, l = () => {
      Ih(), window.dispatchEvent(new CustomEvent("updatePackagesSearch"));
    };
    return (c, u) => (b(), C($e, null, [
      d("span", tj, [
        d("div", {
          class: ue("filtersortby-wrapper" + (c.isSticky ? " sticky" : "")),
          ref: "filtersortbyRef"
        }, [
          d("div", nj, [
            c.hasFiltersSelected ? (b(), C("div", oj, [
              d("button", {
                "data-test": "openfilter-mobile",
                onClick: r,
                id: "mobile-filter-panel-btn",
                class: "vacv-btn-outline",
                "aria-controls": "mobile-filter-panel",
                "aria-expanded": c.filterOpened
              }, [
                aj,
                d("span", rj, k(c.$t("vacvComponents.plp.filters.filter")), 1)
              ], 8, sj)
            ])) : M("", !0),
            c.showSortBy ? (b(), ie($p, {
              key: 1,
              label: c.label,
              class: "sortby",
              options: c.sortByOptions ?? [],
              onValueChange: i,
              "drop-down-id": "dropdown-sort-by",
              outlined: !0,
              initialValue: void 0
            }, null, 8, ["label", "options"])) : M("", !0)
          ])
        ], 2)
      ]),
      s.value ? (b(), C("div", ij, [
        s.value.html ? (b(), C("div", lj, [
          d("div", {
            "data-test": "service-error-message",
            innerHTML: s.value.html
          }, null, 8, cj)
        ])) : (b(), C("div", uj, [
          d("h2", pj, [
            s.value.subTitle ? (b(), C("span", dj, k(c.$t(s.value.subTitle)), 1)) : M("", !0)
          ]),
          s.value.suggestTitle ? (b(), C("div", fj, [
            d("div", mj, k(c.$t(s.value.suggestTitle)), 1),
            s.value.suggestTitle2 ? (b(), C("div", vj, k(c.$t(s.value.suggestTitle2)), 1)) : M("", !0),
            s.value.suggestions ? (b(), C("ul", hj, [
              (b(!0), C($e, null, ke(s.value.suggestions, (p) => (b(), C("li", { key: p }, k(c.$t(p)), 1))), 128))
            ])) : M("", !0)
          ])) : M("", !0)
        ])),
        s.value.updateCta ? (b(), C("div", gj, [
          d("button", {
            class: "vacv-btn-primary",
            onClick: l
          }, k(c.$t("vacvComponents.plp.messages.update-your-search")), 1)
        ])) : M("", !0)
      ])) : M("", !0)
    ], 64));
  }
}), bj = ["id"], yj = ["id"], $j = ["aria-expanded", "aria-controls"], _j = { class: "toggletext" }, wj = ["id", "aria-labelledby"], Cj = ["aria-expanded", "aria-controls"], kj = { class: "toggletext" }, Sj = /* @__PURE__ */ K({
  __name: "SummarySectionContainer",
  props: {
    sectionTitle: {},
    type: {},
    id: {},
    opened: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, n = R(t.opened), o = R(), s = () => {
      n.value = !n.value;
    };
    return (a, r) => (b(), C("div", {
      id: t.id,
      class: ue(["summary-section", `${t.type}`])
    }, [
      d("h3", {
        id: t.id + "-title",
        class: "vacv-label-sm"
      }, k(t.sectionTitle), 9, yj),
      d("button", {
        class: "mobile-only details-link link linklook",
        "aria-expanded": n.value,
        "aria-controls": t.id + "-accordion",
        onClick: Ke(s, ["prevent"])
      }, [
        d("span", _j, [
          d("i", {
            class: ue(
              "fa-solid " + (n.value ? "fa-circle-minus" : "fa-circle-plus")
            ),
            "aria-hidden": "true"
          }, null, 2),
          ne(" " + k(n.value ? a.$t("vacvComponents.bookingsummary.messages.hide-details") : a.$t("vacvComponents.bookingsummary.messages.see-details")), 1)
        ])
      ], 8, $j),
      q(st, { name: "collapsible" }, {
        default: he(() => [
          n.value ? (b(), C("section", {
            key: 0,
            id: t.id + "-accordion",
            class: "hotel-accordion-wrapper",
            "aria-live": "polite",
            "aria-labelledby": t.id + "-title",
            ref_key: "scrollHeightRef",
            ref: o
          }, [
            Xe(a.$slots, "default", {}, void 0, !0)
          ], 8, wj)) : M("", !0)
        ]),
        _: 3
      }),
      d("button", {
        class: "desktop-only details-link link linklook",
        "aria-expanded": n.value,
        "aria-controls": t.id + "-accordion",
        onClick: Ke(s, ["prevent"])
      }, [
        d("span", kj, [
          d("i", {
            class: ue(
              "fa-solid " + (n.value ? "fa-circle-minus" : "fa-circle-plus")
            ),
            "aria-hidden": "true"
          }, null, 2),
          ne(k(n.value ? a.$t("vacvComponents.bookingsummary.messages.hide-details") : a.$t("vacvComponents.bookingsummary.messages.see-details")), 1)
        ])
      ], 8, Cj)
    ], 10, bj));
  }
}), id = /* @__PURE__ */ De(Sj, [["__scopeId", "data-v-59af9050"]]), Tj = { class: "hotel-accordion" }, Aj = {
  key: 0,
  class: "accordion-content"
}, Dj = { class: "hotel-name" }, Pj = { class: "roomtype-plan" }, Ij = { class: "hotel-roomtype" }, Ej = {
  key: 0,
  class: "hotel-plan"
}, Oj = { class: "checkin-checkout" }, xj = { class: "in" }, Mj = { class: "out" }, Lj = {
  key: 1,
  class: "accordion-content"
}, Nj = {
  class: "vacv-form-error",
  "aria-live": "polite"
}, Fj = /* @__PURE__ */ K({
  __name: "HotelAndRoomInfo",
  setup(e) {
    const {
      numberOfRooms: t,
      isValid: n,
      checkIn: o,
      checkOut: s,
      roomName: a,
      mealPlan: r,
      hotelName: i
    } = Ce(nb());
    return (l, c) => (b(), C("div", Tj, [
      T(n) ? (b(), C("div", Aj, [
        d("div", Dj, k(T(i)), 1),
        d("div", Pj, [
          d("span", Ij, k(T(t)) + " " + k(T(a)), 1),
          T(r) ? (b(), C("span", Ej, k(T(r)), 1)) : M("", !0)
        ]),
        d("div", Oj, [
          d("div", xj, [
            d("span", null, k(l.$t("vacvComponents.pdp.labels.hotel.overview.checkin")), 1),
            ne(" " + k(l.$d(T(o), "short")), 1)
          ]),
          d("div", Mj, [
            d("span", null, k(l.$t("vacvComponents.pdp.labels.hotel.overview.checkout")), 1),
            ne(" " + k(l.$d(T(s), "short")), 1)
          ])
        ])
      ])) : (b(), C("div", Lj, [
        d("p", Nj, k(l.$t("vacvComponents.bookingsummary.errors.no-hotel-room")), 1)
      ]))
    ]));
  }
}), Rj = /* @__PURE__ */ K({
  __name: "BookingSummaryHotel",
  setup(e) {
    return (t, n) => (b(), ie(id, {
      id: "hotelAndRoomSection",
      "section-title": t.$t("vacvComponents.bookingsummary.labels.hotel-and-rooms"),
      type: "hotel"
    }, {
      default: he(() => [
        q(Fj)
      ]),
      _: 1
    }, 8, ["section-title"]));
  }
}), Vj = { class: "hotel-accordion-wrapper flight-details summary" }, Bj = {
  key: 0,
  class: "hotel-accordion"
}, Hj = {
  key: 1,
  class: "hotel-accordion"
}, Uj = {
  class: "vacv-form-error",
  "aria-live": "polite"
}, zj = /* @__PURE__ */ K({
  __name: "FlightsDetailsSection",
  props: {
    outbound: {},
    inbound: {},
    displayDuration: { type: Boolean }
  },
  setup(e) {
    const t = e, n = V(
      () => t.outbound.length > 0 && t.inbound.length > 0
    );
    return (o, s) => (b(), C("div", Vj, [
      n.value ? (b(), C("div", Bj, [
        q(zi, {
          class: "outbound",
          segments: o.outbound,
          "display-duration": o.displayDuration,
          modifier: "hideButtonOnMobile"
        }, null, 8, ["segments", "display-duration"]),
        q(zi, {
          class: "inbound",
          segments: o.inbound,
          "display-duration": o.displayDuration,
          modifier: "hideButtonOnMobile"
        }, null, 8, ["segments", "display-duration"])
      ])) : (b(), C("div", Hj, [
        d("p", Uj, k(o.$t("common.bookingsummary.errors.no-flights")), 1)
      ]))
    ]));
  }
}), Wj = /* @__PURE__ */ K({
  __name: "BookingSummaryFlight",
  props: {
    prePackage: {},
    itinerary: {},
    useBreadCrumbsComposable: {}
  },
  setup(e) {
    const t = e, n = t.useBreadCrumbsComposable, o = V(
      () => {
        var i, l;
        return ((l = (i = t.itinerary) == null ? void 0 : i.segments) == null ? void 0 : l.filter((c) => c.bound === "O")) ?? [];
      }
    ), s = V(
      () => {
        var i, l;
        return ((l = (i = t.itinerary) == null ? void 0 : i.segments) == null ? void 0 : l.filter((c) => c.bound === "I")) ?? [];
      }
    ), a = n.getComponentName(), r = n.isProductListing(a) || n.isProductDetails(a);
    return (i, l) => (b(), ie(id, {
      id: "flightsSection",
      "section-title": i.$t("vacvComponents.bookingsummary.labels.round-trip-flight"),
      type: "flight"
    }, {
      default: he(() => [
        q(zj, {
          outbound: o.value,
          inbound: s.value,
          "display-duration": T(r)
        }, null, 8, ["outbound", "inbound", "display-duration"])
      ]),
      _: 1
    }, 8, ["section-title"]));
  }
}), jj = /* @__PURE__ */ K({
  __name: "BookingSummaryAncillary",
  props: {
    prePackagePricing: {},
    sortedSelectedAncillaries: {},
    useBreadCrumbsComposable: {}
  },
  setup(e) {
    const t = e, o = t.useBreadCrumbsComposable.isCheckout();
    return (s, a) => {
      var r;
      return (r = s.sortedSelectedAncillaries) != null && r.length ? (b(), ie(id, {
        key: 0,
        id: "AncillarySection",
        "section-title": s.$t("vacvComponents.bookingsummary.labels.ancillary"),
        type: "ancillary",
        opened: !T(o)
      }, {
        default: he(() => [
          q(dy, {
            ancillaries: s.sortedSelectedAncillaries,
            pricing: t.prePackagePricing
          }, null, 8, ["ancillaries", "pricing"])
        ]),
        _: 1
      }, 8, ["section-title", "opened"])) : M("", !0);
    };
  }
}), qj = ["aria-label"], Kj = {
  id: "summary-title",
  class: "vacv-label-sm"
}, Yj = {
  key: 0,
  class: "hotel-package"
}, Gj = {
  key: 0,
  class: "type"
}, Zj = { class: "summary-section vacv-price" }, Xj = { class: "mobile-summary-sticky mobile-only" }, Jj = { class: "summary-sticky-container" }, Qj = { class: "summary-sticky-total" }, eq = ["aria-expanded"], tq = { class: "see" }, nq = /* @__PURE__ */ d("i", {
  class: "fa-solid fa-circle-plus",
  "aria-hidden": "true"
}, null, -1), ole = /* @__PURE__ */ K({
  __name: "BookingSummary",
  props: {
    package: {},
    prePackagePricing: {},
    hotel: {},
    itinerary: {},
    useBreadCrumbsComposable: {},
    spaType: {},
    lang: {}
  },
  setup(e) {
    En((v) => ({
      "0c0a8443": p.value
    }));
    const t = e, n = t.useBreadCrumbsComposable, o = Do(), { ancillaries: s, hasSelectedAncillaries: a } = Ce(o), r = V(() => Vp(s.value)), i = () => {
      l.value = !l.value;
    }, l = R(!1), c = () => {
      l.value = !l.value;
    }, u = Zb(), p = R(window.innerHeight + "px");
    Qp(() => {
      p.value = window.innerHeight + "px";
    });
    const m = n.getComponentName(), h = V(
      () => (n.isCheckout(m) || n.isConfirmation(m)) && a.value
    ), g = V(() => t.spaType === lt.HotelsSpa), _ = V(() => {
      var v, w;
      return "packageInclusions" in (((v = t.package) == null ? void 0 : v.information) || {}) ? ((w = t.package) == null ? void 0 : w.information).packageInclusions : "";
    });
    return (v, w) => (b(), C("aside", {
      class: ue(
        l.value ? "col-xs-12 col-md-3 spa-col-aside booking-summary expanded" : "col-xs-12 col-md-3 spa-col-aside booking-summary"
      )
    }, [
      q(st, { name: "expandable" }, {
        default: he(() => [
          l.value || T(u) ? (b(), C("section", {
            key: 0,
            id: "bookingSummary",
            class: ue(
              l.value ? "spa-aside-wrapper expanded" : "spa-aside-wrapper"
            ),
            "aria-live": "polite",
            "aria-labelledby": "summary-title"
          }, [
            d("button", {
              onClick: c,
              class: "btn-close mobile-only",
              "aria-label": v.$t("vacvComponents.common.buttons.close"),
              "aria-expanded": "true",
              "aria-controls": "bookingSummary"
            }, null, 8, qj),
            d("h2", Kj, k(v.$t("vacvComponents.bookingsummary.labels.booking-summary")), 1),
            g.value ? M("", !0) : (b(), C("div", Yj, [
              ne(k(v.$t("vacvComponents.bookingsummary.labels.package")) + " ", 1),
              _.value ? (b(), C("div", Gj, k(_.value), 1)) : M("", !0)
            ])),
            Xe(v.$slots, "desktopNavigation"),
            q(Rj),
            g.value ? M("", !0) : (b(), ie(Wj, {
              key: 1,
              "pre-package": v.package,
              itinerary: v.itinerary,
              "use-bread-crumbs-composable": T(n)
            }, null, 8, ["pre-package", "itinerary", "use-bread-crumbs-composable"])),
            T(a) ? (b(), ie(jj, {
              key: 2,
              "pre-package-pricing": v.prePackagePricing,
              "sorted-selected-ancillaries": r.value,
              "use-bread-crumbs-composable": T(n)
            }, null, 8, ["pre-package-pricing", "sorted-selected-ancillaries", "use-bread-crumbs-composable"])) : M("", !0),
            d("div", Zj, [
              q(ed, {
                "pre-package-pricing": v.prePackagePricing,
                extrasIncluded: h.value,
                showDOB: !0,
                spaType: v.spaType
              }, {
                priceBreakdownLines: he(() => [
                  Xe(v.$slots, "priceBreakdownLines")
                ]),
                _: 3
              }, 8, ["pre-package-pricing", "extrasIncluded", "spaType"])
            ])
          ], 2)) : M("", !0)
        ]),
        _: 3
      }),
      d("div", Xj, [
        d("div", Jj, [
          d("div", Qj, [
            Xe(v.$slots, "priceMobileLines"),
            d("button", {
              onClick: i,
              class: "link linklook",
              "aria-expanded": l.value ? "true" : "false",
              "aria-controls": "bookingSummary"
            }, [
              d("span", tq, [
                nq,
                ne(k(v.$t("vacvComponents.pricedetails.title")), 1)
              ])
            ], 8, eq)
          ]),
          Xe(v.$slots, "mobileNavigation")
        ])
      ])
    ], 2));
  }
}), ld = (e) => {
  const t = R(), n = R(), o = R(!1), { reset: s } = un();
  return le(
    e,
    async (r) => {
      var l, c;
      t.value = await window.sso.getAeroplanPoints();
      const i = (c = (l = Bn(r)) == null ? void 0 : l[0]) == null ? void 0 : c.points;
      n.value = i ? parseInt(i) : void 0, o.value = !!(t.value && t.value > 0 && n.value && t.value >= n.value);
    },
    { immediate: !0 }
  ), le(o, (r) => {
    r || s();
  }), {
    userPoints: t,
    redemptionEligible: o
  };
}, hy = /* @__PURE__ */ K({
  __name: "AeroplanPointsSelector",
  props: {
    milesObject: {},
    origin: {}
  },
  emits: ["aeroplan-points-selection"],
  setup(e, { emit: t }) {
    const n = e, { n: o, t: s } = Ne({ useScope: "global" }), { userPoints: a, redemptionEligible: r } = ld(n.milesObject), i = un(), { pointsToRedeem: l } = Ce(i), c = s("vacvComponents.aeroplan.points-initial-text"), u = V(() => {
      const m = n.milesObject.filter(
        (h) => h.points && a.value && parseInt(h.points) <= a.value
      ).map((h) => ({
        label: o(parseInt(h.points), "decimal") + " " + s("vacvComponents.aeroplan.points") + " - " + Se(h.amtInCad, o, !0),
        value: parseInt(h.points),
        dollarValue: parseInt(h.amtInCad)
      }));
      return m.unshift({
        label: s("vacvComponents.aeroplan.points-zero"),
        value: 0,
        dollarValue: 0
      }), m.unshift({
        label: c,
        value: -1,
        dollarValue: -1
      }), m;
    }), p = t;
    function f(m, h) {
      p("aeroplan-points-selection", h);
    }
    return (m, h) => T(r) ? (b(), ie($p, {
      key: 0,
      class: "aeroplan-dropdown",
      "initial-value": T(l),
      options: u.value,
      "selected-value": T(l),
      "drop-down-id": "dropdown-aeroplan-points",
      outlined: !0,
      onValueChange: f
    }, null, 8, ["initial-value", "options", "selected-value"])) : M("", !0);
  }
}), oq = { class: "logo-points" }, sq = ["src", "alt"], aq = ["innerHTML"], gy = /* @__PURE__ */ K({
  __name: "AeroplanPointsLogo",
  props: {
    message: {}
  },
  setup(e) {
    const t = Ye("cdnBaseUrl");
    return (n, o) => {
      var s;
      return b(), C("div", oq, [
        d("img", {
          src: `${T(t)}/img/aeroplan-logo.svg`,
          width: "120",
          alt: n.$t("vacvComponents.aeroplan.aeroplan")
        }, null, 8, sq),
        (s = n.message) != null && s.length ? (b(), C("div", {
          key: 0,
          class: "points",
          innerHTML: n.message
        }, null, 8, aq)) : M("", !0)
      ]);
    };
  }
}), by = () => {
  const e = R(!1), t = R(-1), n = R(-1), { upliftTokenAvailable: o } = Ce(Co()), s = un(), a = R(0), { pointsToRedeem: r, dollarValue: i } = Ce(s), l = Tt(), { isPaymentMethodUplift: c } = Ce(l), u = R(), {
    setDropDownBookingSummaryExecuted: p,
    setDropDownCheckoutFormExecuted: f,
    setShowAeroPlanPointsDropDown: m
  } = s, {
    dropDownBookingSummaryExecuted: h,
    dropDownCheckoutFormExecuted: g,
    showAeroPlanPointsDropDown: _
  } = Ce(s), v = (S) => {
    S.value += 1;
  }, w = () => {
    e.value = !0;
  }, y = (S, A, I, D) => {
    a.value = D.value, S === "OK" ? (A(I), e.value = !1) : (e.value = !1, m(!0), v(a), m(!1), p(!1), f(!1));
  };
  return le(
    () => _.value,
    (S) => {
      (S !== void 0 || S) && (v(a), m(!1), p(!1), f(!1));
    }
  ), {
    componentKey: a,
    aeOption: u,
    displayUpliftWarningModalAeroplan: e,
    executeCloseUpLiftWarningModalAeroplan: y,
    executeAeroplanPointsSelection: async (S, A) => {
      if (u.value = S, f(!1), r.value != (S == null ? void 0 : S.value) && (t.value = r.value, n.value = i.value), t.value === -1 && (S == null ? void 0 : S.value) == 0 || t.value === 0 && (S == null ? void 0 : S.value) == -1 || t.value === -1 && (S == null ? void 0 : S.value) == -1 && c.value && o.value) {
        A(S);
        return;
      }
      c.value && o.value ? S && !h.value && !g.value ? (p(!0), f(!0), w()) : m(!0) : A(S);
    },
    onOpenUpliftWarningModal: w,
    forceRerender: v
  };
}, rq = {
  key: 0,
  class: "aeroplan-pointsbox summary"
}, iq = { class: "logobox" }, sle = /* @__PURE__ */ K({
  __name: "AeroplanPointsSection",
  props: {
    milesObject: {},
    useBreadCrumbsComposable: {}
  },
  setup(e) {
    const {
      executeCloseUpLiftWarningModalAeroplan: t,
      executeAeroplanPointsSelection: n,
      displayUpliftWarningModalAeroplan: o,
      aeOption: s,
      componentKey: a
    } = by(), r = e, i = r.useBreadCrumbsComposable, { redemptionEligible: l } = ld(r.milesObject), c = un(), u = i, { setPointsToRedeem: p, setDollarValue: f } = c, { pointsToRedeem: m } = Ce(c), h = (v) => {
      if (v) {
        const w = u.getComponentName();
        LH(
          w,
          v.label
        ), f(v.dollarValue), p(parseInt(v.value));
      }
    }, g = (v) => {
      t(
        v,
        h,
        s.value,
        a
      );
    }, _ = (v) => {
      n(v, h);
    };
    return (v, w) => (b(), C($e, null, [
      T(l) ? (b(), C("div", rq, [
        d("div", iq, [
          q(gy, {
            message: v.$t("vacvComponents.bookingsummary.aeroplan.use-your-points-to-save")
          }, null, 8, ["message"])
        ]),
        (b(), ie(hy, {
          "miles-object": v.milesObject,
          "initial-value": T(m),
          onAeroplanPointsSelection: _,
          key: T(a)
        }, null, 8, ["miles-object", "initial-value"]))
      ])) : M("", !0),
      q(mr, {
        location: "AeroplanPointsSection",
        "display-uplift-warning-modal": T(o),
        onOnCloseUpliftWarningModal: g
      }, null, 8, ["display-uplift-warning-modal", "onOnCloseUpliftWarningModal"])
    ], 64));
  }
}), lq = (e) => (dn("data-v-6080cc60"), e = e(), fn(), e), cq = { class: "section travel-insurance" }, uq = { class: "bold" }, pq = /* @__PURE__ */ lq(() => /* @__PURE__ */ d("sup", null, "†", -1)), dq = /* @__PURE__ */ K({
  __name: "TravelInsuranceBillingRow",
  props: {
    nonInsuranceTotal: {},
    insuranceTotal: {}
  },
  setup(e) {
    return (t, n) => (b(), C("div", cq, [
      d("p", uq, [
        pq,
        ne(k(t.$t("vacvComponents.payment.messages.billedSeparately")), 1)
      ]),
      d("p", null, k(T(Se)(t.nonInsuranceTotal, t.$n) + " " + t.$t("vacvComponents.payment.messages.payableToVACV")), 1),
      d("p", null, k(T(Se)(t.insuranceTotal, t.$n) + " " + t.$t("vacvComponents.payment.messages.payableToInsuranceCompany")), 1)
    ]));
  }
}), ale = /* @__PURE__ */ De(dq, [["__scopeId", "data-v-6080cc60"]]), fq = { class: "subtotal subtotal--section" }, mq = { class: "bold" }, vq = { class: "right" }, hq = { class: "right" }, gq = /* @__PURE__ */ K({
  __name: "TravelInsurancePriceRow",
  props: {
    name: {},
    price: {},
    numberOfTravelers: {}
  },
  setup(e) {
    return (t, n) => (b(), C("div", fq, [
      d("p", mq, k(t.$t("vacvComponents.payment.labels.travelInsurance") + " - " + t.name), 1),
      q(Qn, {
        title: t.$t("vacvComponents.payment.labels.insuranceXTravellers", {
          x: t.numberOfTravelers
        }),
        value: T(Se)(t.price, t.$n),
        class: "bdrow--amount-total"
      }, null, 8, ["title", "value"]),
      d("p", vq, k(t.$t("vacvComponents.payment.labels.plusTaxes")), 1),
      d("p", hq, k(t.$t("vacvComponents.payment.labels.billedSeparately")), 1)
    ]));
  }
}), rle = /* @__PURE__ */ De(gq, [["__scopeId", "data-v-b45c0a19"]]), ile = /* @__PURE__ */ K({
  __name: "AeroplanLoginModal",
  setup(e) {
    const t = Ye("cdnBaseUrl"), o = Ye("aeLoginUrl") + "?redirect-url=" + encodeURIComponent(window.location.href), s = () => {
      window.sso ? window.sso.loginAeroplan() : window.location.assign(o), VH();
    }, a = () => {
      BH();
    }, r = () => {
      HH();
    };
    return (i, l) => (b(), ie(fM, {
      "aeroplan-sign-in-url": "#",
      "aeroplan-logo-url": `${T(t)}/img/aeroplan-logo.png`,
      onSignIn: l[0] || (l[0] = (c) => s()),
      onContinueAsGuest: l[1] || (l[1] = (c) => a()),
      onClose: l[2] || (l[2] = (c) => r())
    }, null, 8, ["aeroplan-logo-url"]));
  }
}), bq = {
  key: 0,
  class: "aeroplan-pointsbox"
}, yq = { class: "logobox" }, $q = ["innerHTML"], _q = { class: "dropdown" }, lle = /* @__PURE__ */ K({
  __name: "AeroplanPointsBanner",
  props: {
    milesObject: {}
  },
  setup(e) {
    const {
      executeCloseUpLiftWarningModalAeroplan: t,
      executeAeroplanPointsSelection: n,
      displayUpliftWarningModalAeroplan: o,
      aeOption: s,
      componentKey: a
    } = by(), r = un(), { setPointsToRedeem: i, setDollarValue: l } = r, c = e, { redemptionEligible: u, userPoints: p } = ld(c.milesObject), f = V(
      () => c.milesObject.filter(
        (v) => v.points && p.value && parseInt(v.points) <= p.value
      )
    ), m = V(
      () => f.value[f.value.length - 1]
    ), h = (v) => {
      v && (l(v.dollarValue), i(parseInt(v.value)));
    }, g = (v) => {
      t(
        v,
        h,
        s.value,
        a
      );
    }, _ = async (v) => {
      n(v, h);
    };
    return (v, w) => T(p) ? (b(), C("div", bq, [
      d("div", yq, [
        q(gy, {
          message: v.$t("vacvComponents.payment.messages.aeroplan-you-have-x-points", {
            points: v.$n(T(p), "decimal")
          })
        }, null, 8, ["message"]),
        T(u) ? (b(), C("div", {
          key: 0,
          class: "maxpoints",
          innerHTML: v.$t(
            "vacvComponents.payment.messages.aeroplan-you-can-redeem-x-to-save-y",
            {
              points: v.$n(parseInt(m.value.points), "decimal"),
              dollars: v.$n(
                parseInt(m.value.amtInCad),
                "currency"
              ).replace("CA", "")
            }
          )
        }, null, 8, $q)) : M("", !0)
      ]),
      d("div", _q, [
        (b(), ie(hy, {
          "miles-object": v.milesObject,
          onAeroplanPointsSelection: _,
          key: T(a)
        }, null, 8, ["miles-object"]))
      ]),
      q(mr, {
        location: "AeroplanPoints",
        "display-uplift-warning-modal": T(o),
        onOnCloseUpliftWarningModal: g
      }, null, 8, ["display-uplift-warning-modal"])
    ])) : M("", !0);
  }
});
function wq(e, t, n, o) {
  const s = R(0), a = V(() => s.value >= t), r = V(() => !n || !o ? 0 : Math.floor(
    (n - o) / o * 100
  )), i = V(() => t === 0 ? 0 : Math.floor(s.value / t) * n), l = V(() => t === 0 ? 0 : Math.floor(e.value / n) * n), c = V(
    () => Math.min(
      i.value,
      l.value
    )
  ), u = V(() => n === 0 ? 0 : c.value / n * t), p = V(() => o === 0 ? 0 : c.value / o * t);
  return Re(async () => {
    s.value = await window.sso.getAeroplanPoints();
  }), {
    bonusPercentage: r,
    wasPoints: p,
    isEligible: a,
    maxRedeemablePoints: u,
    maxRedeemableDollars: c
  };
}
const Cq = { class: "aeroplan-redeem-view" }, kq = { class: "left-section" }, Sq = {
  key: 0,
  class: "logo-and-bonus"
}, Tq = ["src", "alt"], Aq = {
  key: 0,
  class: "redeem-bonus"
}, Dq = {
  key: 1,
  class: "redeem-points-applied"
}, Pq = ["innerHTML"], Iq = { class: "redeem-points-applied-buttons" }, Eq = /* @__PURE__ */ d("i", {
  class: "fa-solid fa-circle-xmark",
  "aria-hidden": "true"
}, null, -1), Oq = /* @__PURE__ */ d("i", {
  class: "fa-solid fa-pen-circle",
  "aria-hidden": "true"
}, null, -1), xq = ["innerHTML"], Mq = /* @__PURE__ */ K({
  __name: "AeroplanPointsRedeemView",
  props: {
    unitPoint: {},
    pointsToRedeem: {},
    dollarValue: {},
    isEligible: { type: Boolean },
    maxRedeemablePoints: {},
    maxRedeemableDollars: {},
    bonusPercentage: {},
    wasPoints: {},
    isViewMode: { type: Boolean },
    isExtended: { type: Boolean }
  },
  emits: ["setEditMode", "removeAppliedPoints"],
  setup(e) {
    const t = e, n = Ye("cdnBaseUrl"), { n: o } = Ne({ useScope: "global" }), s = V(
      () => t.isViewMode && !t.pointsToRedeem && t.isEligible
    ), a = V(
      () => t.isExtended || !t.pointsToRedeem || !t.isViewMode
    ), r = V(() => t.isEligible ? t.bonusPercentage && t.wasPoints ? {
      key: "description-bonus",
      values: {
        wasPoints: o(t.wasPoints),
        points: o(t.maxRedeemablePoints),
        dollars: Se(t.maxRedeemableDollars, o)
      }
    } : {
      key: "description",
      values: {
        points: o(t.maxRedeemablePoints),
        dollars: Se(t.maxRedeemableDollars, o)
      }
    } : {
      key: "advisory",
      values: { unitPoint: o(t.unitPoint) }
    });
    return (i, l) => (b(), C("div", Cq, [
      d("div", kq, [
        a.value ? (b(), C("div", Sq, [
          d("img", {
            src: `${T(n)}/img/aeroplan-logo.svg`,
            width: "120",
            alt: i.$t("vacvComponents.aeroplan.aeroplan")
          }, null, 8, Tq),
          t.bonusPercentage ? (b(), C("div", Aq, k(i.$t("vacvComponents.aeroplan.redeem.bonus", {
            percentage: t.bonusPercentage
          })), 1)) : M("", !0)
        ])) : M("", !0),
        i.isViewMode && i.pointsToRedeem > 0 ? (b(), C("div", Dq, [
          i.isExtended ? (b(), C("div", {
            key: 0,
            innerHTML: i.$t("vacvComponents.aeroplan.redeem.points-applied", {
              points: i.$n(i.pointsToRedeem),
              amount: T(Se)(i.dollarValue, i.$n)
            })
          }, null, 8, Pq)) : (b(), ie(Qn, {
            key: 1,
            title: i.$t("vacvComponents.aeroplan.redeem.aeroplan-points") + "<br>" + i.$n(i.pointsToRedeem),
            value: "-" + T(Se)(i.dollarValue, i.$n),
            "value-classes": "text-red",
            class: "bdrow--small bold"
          }, null, 8, ["title", "value"])),
          d("div", Iq, [
            d("button", {
              class: "details-link link linklook",
              onClick: l[0] || (l[0] = (c) => i.$emit("removeAppliedPoints"))
            }, [
              Eq,
              ne(k(i.$t("vacvComponents.aeroplan.redeem.remove-btn")), 1)
            ]),
            d("button", {
              class: "details-link link linklook",
              onClick: l[1] || (l[1] = (c) => i.$emit("setEditMode"))
            }, [
              Oq,
              ne(k(i.$t("vacvComponents.aeroplan.redeem.change-btn")), 1)
            ])
          ])
        ])) : (b(), C("div", {
          key: 2,
          class: "redeem-description",
          innerHTML: i.$t(
            `vacvComponents.aeroplan.redeem.${r.value.key}`,
            r.value.values
          )
        }, null, 8, xq))
      ]),
      s.value ? (b(), ie(ul, {
        key: 0,
        secondary: !0,
        label: i.$t("vacvComponents.aeroplan.redeem.use-points-btn"),
        position: "right",
        onClick: l[2] || (l[2] = (c) => i.$emit("setEditMode"))
      }, null, 8, ["label"])) : M("", !0)
    ]));
  }
}), Lq = { class: "aeroplan-redeem-edit" }, Nq = { class: "points-to-redeem" }, Fq = { class: "redeem-input" }, Rq = { class: "input-block" }, Vq = { class: "redeem-buttons" }, Bq = /* @__PURE__ */ d("i", {
  class: "fa-solid fa-circle-xmark",
  "aria-hidden": "true"
}, null, -1), Hq = /* @__PURE__ */ K({
  __name: "AeroplanPointsRedeemEdit",
  props: {
    unitPoint: {},
    pointsToRedeem: {},
    dollarPerUnitPoints: {},
    maxRedeemablePoints: {}
  },
  emits: ["valueChanged", "setViewMode"],
  setup(e, { emit: t }) {
    const n = e, o = t, { t: s, n: a } = Ne({ useScope: "global" }), r = R(), i = R(
      (n.pointsToRedeem || n.maxRedeemablePoints) / n.unitPoint
    ), l = V(() => {
      const h = i.value, g = h * n.unitPoint, _ = h * n.dollarPerUnitPoints;
      return {
        points: g,
        amount: _,
        formatted: Se(_, a) || "$"
      };
    }), c = V(() => n.maxRedeemablePoints / n.unitPoint), u = {
      required: s("vacvComponents.aeroplan.redeem.error-message"),
      number: s("vacvComponents.aeroplan.redeem.error-message"),
      min: s("vacvComponents.aeroplan.redeem.error-message"),
      max: s("vacvComponents.aeroplan.redeem.error-message")
    }, p = (h) => {
      (h.key === "." || h.key === ",") && h.preventDefault();
    };
    function f(h, g) {
      if (h !== void 0 && h > 999) {
        const _ = String(h).slice(0, 3), v = parseInt(_, 10);
        g.input(v);
      }
    }
    const m = () => {
      o("valueChanged", l.value.points, l.value.amount);
    };
    return Re(async () => {
      var g, _;
      await rn();
      const h = (_ = (g = r.value) == null ? void 0 : g.$el) == null ? void 0 : _.querySelector("input");
      h && (h.focus(), h.select());
    }), (h, g) => {
      const _ = ut("FormKit");
      return b(), ie(_, {
        type: "form",
        actions: !1,
        "incomplete-message": !1,
        onSubmit: m
      }, {
        default: he(() => {
          var v;
          return [
            d("div", Lq, [
              d("div", Nq, [
                d("span", null, k(h.$t("vacvComponents.aeroplan.redeem.points-to-redeem")), 1),
                d("div", Fq, [
                  d("div", Rq, [
                    q(_, {
                      type: "number",
                      ref_key: "inputRef",
                      ref: r,
                      name: "points",
                      number: "integer",
                      inputmode: "numeric",
                      step: "1",
                      "validation-visibility": "live",
                      validation: `(200)required|number|min:1|max:${c.value}`,
                      "validation-messages": u,
                      modelValue: i.value,
                      "onUpdate:modelValue": g[0] || (g[0] = (w) => i.value = w),
                      onKeydown: p,
                      onInput: f
                    }, null, 8, ["validation", "modelValue"]),
                    d("span", null, "000 pts/" + k(l.value.formatted), 1)
                  ]),
                  q(T(Ug), {
                    node: (v = r.value) == null ? void 0 : v.node
                  }, null, 8, ["node"])
                ])
              ]),
              d("div", Vq, [
                q(ul, {
                  type: "submit",
                  secondary: !0,
                  label: h.$t("vacvComponents.aeroplan.redeem.apply-btn")
                }, null, 8, ["label"]),
                d("button", {
                  class: "details-link link linklook",
                  onClick: g[1] || (g[1] = (w) => h.$emit("setViewMode"))
                }, [
                  Bq,
                  ne(k(h.$t("vacvComponents.aeroplan.redeem.cancel-btn")), 1)
                ])
              ])
            ])
          ];
        }),
        _: 1
      });
    };
  }
}), Uq = { class: "aeroplan-redeem" }, cle = /* @__PURE__ */ K({
  __name: "AeroplanPointsRedeem",
  props: {
    store: {},
    bookingTotal: {},
    isExtended: { type: Boolean }
  },
  setup(e) {
    const t = e, n = R("view"), o = R(!1), s = R(!1), a = tt({ points: 0, amount: 0 }), { upliftTokenAvailable: r } = Ce(Co()), { isPaymentMethodUplift: i } = Ce(Tt()), { setPointsToRedeem: l, setDollarValue: c } = t.store, {
      unitPoint: u,
      dollarPerUnitPoints: p,
      wasDollarPerUnitPoints: f,
      pointsToRedeem: m,
      dollarValue: h
    } = Ce(t.store), {
      bonusPercentage: g,
      wasPoints: _,
      isEligible: v,
      maxRedeemablePoints: w,
      maxRedeemableDollars: y
    } = wq(
      Wo(t, "bookingTotal"),
      u.value,
      p.value,
      f.value
    ), $ = (B, N) => {
      a.points = B, a.amount = N;
    }, S = () => {
      n.value = "view";
    }, A = () => {
      n.value = "edit";
    }, I = () => {
      l(0), c(0);
    }, D = () => {
      l(a.points), c(a.amount), S();
    }, O = (B, N) => {
      $(B, N), i.value && r.value ? P() : D();
    }, x = (B, N) => {
      $(B, N), D();
    }, F = () => {
      o.value = !0, i.value && r.value ? P() : I();
    }, P = () => {
      s.value = !0;
    }, E = (B) => {
      B === "OK" && (o.value ? (I(), o.value = !1) : D()), s.value = !1;
    };
    return le(
      () => [y.value],
      ([B]) => {
        h.value > B && x(w.value, y.value);
      }
    ), (B, N) => (b(), C($e, null, [
      d("div", Uq, [
        q(Mq, {
          "unit-point": T(u),
          "points-to-redeem": T(m),
          "dollar-value": T(h),
          "is-eligible": T(v),
          "max-redeemable-points": T(w),
          "max-redeemable-dollars": T(y),
          "bonus-percentage": T(g),
          "was-points": T(_),
          "is-view-mode": n.value === "view",
          "is-extended": B.isExtended,
          onSetEditMode: A,
          onRemoveAppliedPoints: F
        }, null, 8, ["unit-point", "points-to-redeem", "dollar-value", "is-eligible", "max-redeemable-points", "max-redeemable-dollars", "bonus-percentage", "was-points", "is-view-mode", "is-extended"]),
        n.value === "edit" ? (b(), ie(Hq, {
          key: 0,
          unitPoint: T(u),
          pointsToRedeem: T(m),
          dollarPerUnitPoints: T(p),
          "max-redeemable-points": T(w),
          onSetViewMode: S,
          onValueChanged: O
        }, null, 8, ["unitPoint", "pointsToRedeem", "dollarPerUnitPoints", "max-redeemable-points"])) : M("", !0)
      ]),
      q(mr, {
        location: "AeroplanPointsRedeem",
        "display-uplift-warning-modal": s.value,
        onOnCloseUpliftWarningModal: E
      }, null, 8, ["display-uplift-warning-modal"])
    ], 64));
  }
}), zq = { class: "hotel-accordion" }, Wq = ["aria-label", "aria-controls"], jq = { class: "accordion-title details" }, qq = ["id"], Kq = { class: "accordion-content" }, Yq = ["innerHTML"], Gq = /* @__PURE__ */ K({
  __name: "PreferredPrivilegesAccordion",
  props: {
    position: { default: 0 },
    room: {},
    hotel: {}
  },
  setup(e, { emit: t }) {
    const n = e, o = t;
    return (s, a) => (b(), ie(ta, {
      id: "preferredPrivilegesAccordion-" + n.position,
      className: "room-details",
      role: "region",
      "aria-live": "polite",
      "aria-labelledby": "preferredPrivilegesAccordion-title-" + n.position
    }, {
      default: he(() => {
        var r, i, l, c, u, p;
        return [
          d("div", zq, [
            d("button", {
              onClick: a[0] || (a[0] = (f) => o("show-hide")),
              class: "btn-close",
              "aria-label": s.$t("vacvComponents.common.buttons.close"),
              "aria-expanded": "true",
              "aria-controls": "preferredPrivilegesAccordion-" + n.position
            }, null, 8, Wq),
            d("div", jq, [
              d("div", {
                id: "preferredPrivilegesAccordion-title-" + n.position,
                class: "vacv-label-sm"
              }, k(((l = (i = (r = s.hotel) == null ? void 0 : r.inclusions) == null ? void 0 : i.preferredPrivilegesInclusions) == null ? void 0 : l.title) ?? ""), 9, qq)
            ]),
            d("div", Kq, [
              d("div", {
                class: "details-2col special-list vacv-editor",
                innerHTML: ((p = (u = (c = s.hotel) == null ? void 0 : c.inclusions) == null ? void 0 : u.preferredPrivilegesInclusions) == null ? void 0 : p.preferedPrivileges) ?? ""
              }, null, 8, Yq)
            ])
          ])
        ];
      }),
      _: 1
    }, 8, ["id", "aria-labelledby"]));
  }
}), Zq = { class: "hotel-accordion" }, Xq = ["aria-label", "aria-controls"], Jq = { class: "accordion-title details" }, Qq = ["id"], e9 = {
  key: 0,
  class: "accordion-content"
}, t9 = { class: "details" }, n9 = { class: "h4style" }, o9 = ["id"], s9 = /* @__PURE__ */ K({
  __name: "InclusionsAccordion",
  props: {
    position: { default: 0 },
    hotel: {},
    pack: {},
    room: {}
  },
  setup(e, { emit: t }) {
    const n = e, o = t, s = V(() => {
      var i;
      const r = n.room.mealPlanCode;
      return r && ((i = n.hotel.inclusions) != null && i.mealPlanInclusions) ? n.hotel.inclusions.mealPlanInclusions[r] : null;
    }), a = V(
      () => {
        var r, i;
        return (i = (r = s.value) == null ? void 0 : r.details) != null && i.length ? s.value.details.filter((l) => !!l) : [];
      }
    );
    return (r, i) => s.value ? (b(), ie(ta, {
      key: 0,
      id: "inclusionsAccordion-" + n.position,
      "data-test": "pdp-inclusions-accordion",
      className: "room-details",
      role: "region",
      "aria-live": "polite",
      "aria-labelledby": "inclusionsAccordion-title-" + n.position
    }, {
      default: he(() => [
        d("div", Zq, [
          d("button", {
            onClick: i[0] || (i[0] = (l) => o("show-hide")),
            class: "btn-close",
            "aria-label": r.$t("vacvComponents.common.buttons.close"),
            "aria-expanded": "true",
            "aria-controls": "inclusionsAccordion-" + n.position
          }, null, 8, Xq),
          d("div", Jq, [
            d("div", {
              id: "inclusionsAccordion-title-" + n.position,
              class: "vacv-label-sm"
            }, k(r.$t("vacvComponents.pdp.labels.hotel.inclusions.title")), 9, Qq)
          ]),
          a.value.length ? (b(), C("div", e9, [
            d("div", t9, [
              d("div", n9, k(s.value.name), 1),
              d("ul", {
                class: ue(
                  a.value.length > 1 ? "spa-list special-list details-3col" : "spa-list special-list details-1col"
                )
              }, [
                (b(!0), C($e, null, ke(a.value, (l, c) => (b(), C("li", {
                  key: c,
                  id: "pdp-hotel-inclusion-item-" + c
                }, k(l), 9, o9))), 128))
              ], 2)
            ])
          ])) : M("", !0)
        ])
      ]),
      _: 1
    }, 8, ["id", "aria-labelledby"])) : M("", !0);
  }
}), a9 = { class: "hotel-accordion" }, r9 = ["aria-label", "aria-controls"], i9 = { class: "accordion-title details" }, l9 = ["id"], c9 = { class: "accordion-content" }, u9 = {
  key: 0,
  class: "details"
}, p9 = {
  key: 0,
  class: "details-section"
}, d9 = { class: "spa-list special-list details-3col" }, f9 = {
  key: 1,
  class: "details-section"
}, m9 = { class: "spa-list special-list details-3col" }, v9 = {
  key: 2,
  class: "details-section"
}, h9 = { class: "spa-list special-list details-3col" }, g9 = {
  key: 1,
  class: "details-wide"
}, b9 = {
  key: 0,
  class: "item"
}, y9 = { class: "title" }, $9 = { class: "text" }, _9 = {
  key: 0,
  class: "text"
}, w9 = {
  key: 1,
  class: "item"
}, C9 = { class: "title" }, k9 = { class: "text" }, S9 = /* @__PURE__ */ d("sup", null, "2", -1), T9 = /* @__PURE__ */ K({
  __name: "RoomDetailsAccordion",
  props: {
    position: { default: 0 },
    room: {}
  },
  setup(e, { emit: t }) {
    const n = e, o = t, s = V(() => {
      var l, c;
      return (c = (l = n.room.roomDetails) == null ? void 0 : l.descriptions) != null && c.length ? n.room.roomDetails.descriptions.filter((u) => u !== null && u !== "") : [];
    }), a = V(() => {
      var l, c;
      return (c = (l = n.room.roomDetails) == null ? void 0 : l.services) != null && c.length ? n.room.roomDetails.services.filter((u) => u !== null && u !== "") : [];
    }), r = V(() => {
      var l, c;
      return ((c = (l = n.room.roomDetails) == null ? void 0 : l.facilities) == null ? void 0 : c.filter((u) => u)) || [];
    }), i = V(() => n.room.roomDimensionInSquareMeters && Math.ceil(parseInt(n.room.roomDimensionInSquareMeters, 10)));
    return (l, c) => l.room ? (b(), ie(ta, {
      key: 0,
      id: "roomDetailsAccordion-" + n.position,
      className: "room-details",
      role: "region",
      "aria-live": "polite",
      "aria-labelledby": "roomDetailsAccordion-title-" + n.position
    }, {
      default: he(() => [
        d("div", a9, [
          d("button", {
            onClick: c[0] || (c[0] = (u) => o("show-hide")),
            class: "btn-close",
            "aria-label": l.$t("vacvComponents.common.buttons.close"),
            "aria-expanded": "true",
            "aria-controls": "roomDetailsAccordion-" + n.position
          }, null, 8, r9),
          d("div", i9, [
            d("div", {
              id: "roomDetailsAccordion-title-" + n.position,
              class: "vacv-label-sm"
            }, k(l.$t("vacvComponents.pdp.labels.roomDetails")), 9, l9)
          ]),
          d("div", c9, [
            l.room.roomDetails !== null ? (b(), C("div", u9, [
              s.value.length ? (b(), C("div", p9, [
                d("h4", null, k(l.$t("vacvComponents.pdp.labels.roomDescription")), 1),
                d("ul", d9, [
                  (b(!0), C($e, null, ke(s.value, (u, p) => (b(), C("li", {
                    key: `${u}-${p}`
                  }, k(u), 1))), 128))
                ])
              ])) : M("", !0),
              a.value.length ? (b(), C("div", f9, [
                d("h4", null, k(l.$t("vacvComponents.pdp.labels.roomService")), 1),
                d("ul", m9, [
                  (b(!0), C($e, null, ke(a.value, (u, p) => (b(), C("li", {
                    key: `${u}-${p}`
                  }, k(u), 1))), 128))
                ])
              ])) : M("", !0),
              r.value.length ? (b(), C("div", v9, [
                d("h4", null, k(l.$t("vacvComponents.pdp.labels.roomFacilities")), 1),
                d("ul", h9, [
                  (b(!0), C($e, null, ke(r.value, (u, p) => (b(), C("li", {
                    key: `${u}-${p}`
                  }, k(u), 1))), 128))
                ])
              ])) : M("", !0)
            ])) : M("", !0),
            l.room.occupancyDetails || i.value ? (b(), C("div", g9, [
              l.room.occupancyDetails ? (b(), C("div", b9, [
                d("span", y9, k(l.$t("vacvComponents.pdp.labels.occupancy")) + ": ", 1),
                d("span", $9, k(l.room.occupancyDetails), 1),
                l.room.maxOccupancy ? (b(), C("span", _9, " (" + k(l.$t("vacvComponents.pdp.labels.maximumOccupancy", {
                  count: l.room.maxOccupancy
                })) + ")", 1)) : M("", !0)
              ])) : M("", !0),
              i.value ? (b(), C("div", w9, [
                d("span", C9, k(l.$t("vacvComponents.pdp.labels.roomDimensions")) + ": ", 1),
                d("span", k9, [
                  ne(k(i.value) + " m", 1),
                  S9
                ])
              ])) : M("", !0)
            ])) : M("", !0)
          ])
        ])
      ]),
      _: 1
    }, 8, ["id", "aria-labelledby"])) : M("", !0);
  }
}), A9 = {
  key: 0,
  class: "item-gallery"
}, D9 = { class: "item-content" }, P9 = { class: "item-content-left" }, I9 = { class: "room-name" }, E9 = {
  key: 2,
  class: "room-view"
}, O9 = { class: "room-beds" }, x9 = {
  key: 3,
  class: "room-amenities"
}, M9 = { key: 0 }, L9 = /* @__PURE__ */ d("i", {
  class: "fa-solid fa-wifi",
  "aria-hidden": "true"
}, null, -1), N9 = { key: 1 }, F9 = /* @__PURE__ */ d("i", {
  class: "fa-solid fa-tv",
  "aria-hidden": "true"
}, null, -1), R9 = { key: 2 }, V9 = /* @__PURE__ */ d("i", {
  class: "fa-regular fa-snowflake",
  "aria-hidden": "true"
}, null, -1), B9 = {
  key: 4,
  class: "multiple-airports"
}, H9 = /* @__PURE__ */ d("i", {
  class: "fa-solid fa-plane",
  "aria-hidden": "true"
}, null, -1), U9 = { class: "sr-only" }, z9 = ["innerHTML"], W9 = { class: "desktop-only links-wrapper" }, j9 = ["aria-expanded", "aria-controls"], q9 = /* @__PURE__ */ d("i", { class: "fa-solid fa-bell-concierge" }, null, -1), K9 = ["aria-expanded", "aria-controls"], Y9 = /* @__PURE__ */ d("i", {
  class: "fa-solid fa-bed-front",
  "aria-hidden": "true"
}, null, -1), G9 = ["aria-expanded", "aria-controls"], Z9 = /* @__PURE__ */ d("i", {
  class: "fa-solid fa-award",
  "aria-hidden": "true"
}, null, -1), X9 = { class: "item-content-right" }, J9 = { class: "price-right" }, Q9 = { class: "hotel-select" }, eK = { key: 0 }, tK = /* @__PURE__ */ d("i", {
  class: "fa-solid fa-check",
  "aria-hidden": "true"
}, null, -1), nK = { key: 1 }, oK = { class: "mobile-only links-wrapper" }, sK = ["aria-expanded", "aria-controls"], aK = /* @__PURE__ */ d("i", { class: "fa-solid fa-bell-concierge" }, null, -1), rK = ["aria-expanded", "aria-controls"], iK = /* @__PURE__ */ d("i", {
  class: "fa-solid fa-bed-front",
  "aria-hidden": "true"
}, null, -1), lK = ["aria-expanded", "aria-controls"], cK = /* @__PURE__ */ d("i", {
  class: "fa-solid fa-award",
  "aria-hidden": "true"
}, null, -1), ule = /* @__PURE__ */ K({
  __name: "RoomsListItem",
  props: {
    position: {},
    pack: {},
    hotel: {},
    room: {},
    hasMultipleAirports: { type: Boolean },
    itinerary: {},
    localisedPromo: {},
    defaultPrice: {},
    trigger: {},
    savingsThreshold: {},
    wasPriceTooltipEnabled: { type: Boolean },
    aeroplanPoints: {},
    aeroplanDollarValue: {},
    total: {},
    subTotal: {},
    spaType: {}
  },
  setup(e, { expose: t }) {
    var j, ee, te, ce;
    const n = e, o = Ye("selectedRoomIndex"), s = Ye("onSelectRoom"), a = (H) => H.paxType === "A", r = V(() => {
      var U, Q, z, Z;
      const H = n.defaultPrice || 0;
      if (n.spaType === lt.HotelsSpa) {
        const W = ((U = n.pack.pricing) == null ? void 0 : U.perNightWithTax) || 0;
        return Math.abs(H - W);
      }
      const oe = ((Z = (z = (Q = n.pack.pricing) == null ? void 0 : Q.perPaxType) == null ? void 0 : z.find(a)) == null ? void 0 : Z.total) || 0;
      return Math.abs(H - oe);
    }), i = V(
      () => {
        var H, oe, U;
        return (U = (oe = (H = n.pack.pricing) == null ? void 0 : H.perPaxType) == null ? void 0 : oe.find(a)) == null ? void 0 : U.total;
      }
    ), l = V(
      () => {
        var H;
        return (H = n.pack.pricing) == null ? void 0 : H.perNightWithTax;
      }
    ), c = V(() => n.defaultPrice !== void 0 && n.defaultPrice > 0 ? r.value : n.spaType === lt.HotelsSpa ? l.value : i.value), u = V(() => n.defaultPrice !== void 0 && n.defaultPrice > 0), p = (H) => {
      H && (s(n.position, H), _R(n.position, n.trigger, r.value));
    }, f = R(!1), m = R(!1), h = R(!1), g = V(() => {
      var H, oe;
      return (oe = (H = n.hotel.inclusions) == null ? void 0 : H.preferredPrivilegesInclusions) == null ? void 0 : oe.linkName;
    }), _ = (ee = (j = n.room) == null ? void 0 : j.roomDetails) == null ? void 0 : ee.images, v = !!((te = _ == null ? void 0 : _.images) != null && te.length), w = V(() => (_ == null ? void 0 : _.images) ?? []), y = V(() => _ == null ? void 0 : _.sizes), $ = V(() => _ == null ? void 0 : _.variations), S = () => {
      f.value = !f.value, f.value && (Cc(
        "Room Details",
        n.room.mealPlanName ?? "",
        n.hotel.name ?? ""
      ), m.value = !1, h.value = !1);
    }, A = () => {
      m.value = !m.value, m.value && (Cc(
        "Inclusions",
        n.room.mealPlanName ?? "",
        n.hotel.name ?? ""
      ), f.value = !1, h.value = !1);
    }, I = () => {
      h.value = !h.value, h.value && (Cc(
        g.value ?? "",
        n.room.mealPlanName ?? "",
        n.hotel.name ?? ""
      ), f.value = !1, m.value = !1);
    }, D = V(() => {
      var U, Q, z, Z;
      const H = ((U = n.room) == null ? void 0 : U.mealPlanCode) || "", oe = (Z = (z = (Q = n.hotel) == null ? void 0 : Q.inclusions) == null ? void 0 : z.mealPlanInclusions) == null ? void 0 : Z[H];
      return !!(oe != null && oe.details && (oe != null && oe.name));
    }), O = V(() => {
      var H, oe, U;
      return !!((H = n.room) != null && H.preferredPrivileges) && !!((U = (oe = n.hotel) == null ? void 0 : oe.inclusions) != null && U.preferredPrivilegesInclusions);
    }), x = () => {
      n != null && n.hotel.name && Vt("Was Price", n.hotel.name);
    }, F = () => {
      n.hotel.name && Vt("Hotel Picture", n.hotel.name);
    }, P = ((ce = n.pack.information) == null ? void 0 : ce.refundable) ?? !0, E = V(() => {
      var H, oe;
      return (oe = (H = n == null ? void 0 : n.itinerary) == null ? void 0 : H.segments) == null ? void 0 : oe.filter((U) => U.bound === "O").map((U) => U.destinationName).pop();
    }), B = V(() => {
      var H;
      return (H = n == null ? void 0 : n.room) != null && H.mealPlanName ? " - " + n.room.mealPlanName : "";
    }), N = V(() => n.spaType === lt.HotelsSpa), Y = V(() => {
      var oe, U, Q;
      const H = n.room.roomDetails;
      return !!((oe = H == null ? void 0 : H.descriptions) != null && oe.length || (U = H == null ? void 0 : H.services) != null && U.length || (Q = H == null ? void 0 : H.facilities) != null && Q.length || n.room.roomDimensionInSquareMeters);
    });
    return t({
      wasPriceClick: x
    }), (H, oe) => {
      var U;
      return H.room ? (b(), C("div", {
        key: 0,
        class: ue(["hotel-item-wrapper", H.position == T(o) ? " selected" : ""])
      }, [
        d("div", {
          class: ue(["hotel-item", { "has-item-gallery": v }])
        }, [
          v ? (b(), C("div", A9, [
            q(Jp, {
              class: "carousel-small",
              images: w.value,
              sizes: y.value,
              "available-variations": $.value,
              "display-size": "medium",
              "display-variation": "tabletLandscape",
              onCarouselModalOpened: F
            }, null, 8, ["images", "sizes", "available-variations"])
          ])) : M("", !0),
          d("div", D9, [
            d("div", P9, [
              H.trigger ? (b(), ie(my, {
                key: 0,
                trigger: H.trigger,
                appliedTo: "room",
                class: "psytrigger vacv-tooltip"
              }, null, 8, ["trigger"])) : M("", !0),
              H.localisedPromo ? (b(), ie(bh, {
                key: 1,
                class: "aeroplanpoints",
                badge: H.localisedPromo.Badge,
                "modal-title": H.$t("vacvComponents.plpList.aeroplanpointsTitle"),
                "modal-text": H.localisedPromo.Terms,
                origin: "pdpAeroplan"
              }, null, 8, ["badge", "modal-title", "modal-text"])) : M("", !0),
              d("h3", I9, k(H.room.name) + k(B.value), 1),
              H.room.view !== "" ? (b(), C("div", E9, k(H.room.view), 1)) : M("", !0),
              d("div", O9, k(H.room.bed), 1),
              H.room.wifi === !0 || H.room.television === !0 || H.room.airConditioning === !0 ? (b(), C("ul", x9, [
                H.room.wifi === !0 ? (b(), C("li", M9, [
                  L9,
                  ne("Wifi ")
                ])) : M("", !0),
                H.room.television === !0 ? (b(), C("li", N9, [
                  F9,
                  ne("TV ")
                ])) : M("", !0),
                H.room.airConditioning === !0 ? (b(), C("li", R9, [
                  V9,
                  ne("AC ")
                ])) : M("", !0)
              ])) : M("", !0),
              H.hasMultipleAirports && E.value && !N.value ? (b(), C("div", B9, [
                H9,
                d("span", U9, k(H.$t("vacvComponents.pdp.access.plane-icon")), 1),
                d("span", {
                  innerHTML: H.$t("vacvComponents.pdp.messages.multiple-airport-destination", {
                    name: E.value,
                    iata: (U = H.pack.information) == null ? void 0 : U.destination
                  })
                }, null, 8, z9)
              ])) : M("", !0),
              d("div", W9, [
                D.value ? (b(), C("button", {
                  key: 0,
                  onClick: A,
                  class: "inclusions-link hotel-link-icon link linklook",
                  "aria-expanded": m.value,
                  "aria-controls": "inclusionsAccordion-" + H.position
                }, [
                  q9,
                  ne(k(H.$t("vacvComponents.pdp.labels.inclusionsButton")), 1)
                ], 8, j9)) : M("", !0),
                Y.value ? (b(), C("button", {
                  key: 1,
                  onClick: S,
                  class: "room-details-link hotel-link-icon link linklook",
                  "aria-expanded": f.value,
                  "aria-controls": "roomDetailsAccordion-" + H.position
                }, [
                  Y9,
                  ne(k(H.$t("vacvComponents.pdp.labels.roomDetails")), 1)
                ], 8, K9)) : M("", !0),
                O.value ? (b(), C("button", {
                  key: 2,
                  onClick: I,
                  class: "preferred-privileges-link hotel-link-icon link linklook",
                  "aria-expanded": h.value,
                  "aria-controls": "preferredPrivilegesAccordion-" + H.position
                }, [
                  Z9,
                  ne(k(g.value), 1)
                ], 8, G9)) : M("", !0)
              ])
            ]),
            d("div", X9, [
              H.pack.pricing ? (b(), ie(ay, {
                key: 0,
                "pre-package-pricing": H.pack.pricing,
                "aeroplan-points": H.aeroplanPoints,
                price: c.value || 0,
                total: H.total,
                "show-difference": u.value,
                wasPriceTooltipEnabled: H.wasPriceTooltipEnabled,
                savingsThreshold: H.savingsThreshold,
                spaType: H.spaType,
                onWasPriceClick: x
              }, {
                priceBreakdownLines: he(() => [
                  q(sy, { "sub-total": H.subTotal }, null, 8, ["sub-total"]),
                  q(ry, {
                    "dollar-value": H.aeroplanDollarValue,
                    "points-to-redeem": H.aeroplanPoints.amountOfPoints
                  }, null, 8, ["dollar-value", "points-to-redeem"]),
                  q(nd, {
                    "price-total": H.total,
                    modifier: "popover",
                    "is-section": "",
                    "is-refundable": T(P)
                  }, null, 8, ["price-total", "is-refundable"])
                ]),
                _: 1
              }, 8, ["pre-package-pricing", "aeroplan-points", "price", "total", "show-difference", "wasPriceTooltipEnabled", "savingsThreshold", "spaType"])) : M("", !0),
              d("div", J9, [
                T(P) ? M("", !0) : (b(), ie(td, { key: 0 })),
                d("div", Q9, [
                  d("button", {
                    class: ue(["vacv-btn-secondary", { active: H.position == T(o) }]),
                    onClick: oe[0] || (oe[0] = (Q) => p(H.pack.id))
                  }, [
                    H.position == T(o) ? (b(), C("span", eK, [
                      tK,
                      ne(k(H.$t("vacvComponents.common.buttons.selected")), 1)
                    ])) : (b(), C("span", nK, k(H.$t("vacvComponents.common.buttons.select")), 1))
                  ], 2)
                ])
              ])
            ]),
            d("div", oK, [
              D.value ? (b(), C("button", {
                key: 0,
                onClick: A,
                class: "inclusions-link hotel-link-icon link linklook",
                "aria-expanded": m.value,
                "aria-controls": "inclusionsAccordion-" + H.position
              }, [
                aK,
                ne(k(H.$t("vacvComponents.pdp.labels.inclusionsButton")), 1)
              ], 8, sK)) : M("", !0),
              Y.value ? (b(), C("button", {
                key: 1,
                onClick: S,
                class: "room-details-link hotel-link-icon link linklook",
                "aria-expanded": f.value,
                "aria-controls": "roomDetailsAccordion-" + H.position
              }, [
                iK,
                ne(k(H.$t("vacvComponents.pdp.labels.roomDetails")), 1)
              ], 8, rK)) : M("", !0),
              O.value ? (b(), C("button", {
                key: 2,
                onClick: I,
                class: "preferred-privileges-link hotel-link-icon link linklook",
                "aria-expanded": h.value,
                "aria-controls": "preferredPrivilegesAccordion-" + H.position
              }, [
                cK,
                ne(k(g.value), 1)
              ], 8, lK)) : M("", !0)
            ])
          ])
        ], 2),
        q(st, { name: "collapsible" }, {
          default: he(() => [
            m.value ? (b(), ie(s9, {
              key: 0,
              id: "inclusionsAccordion-" + H.position,
              position: H.position,
              onShowHide: A,
              hotel: H.hotel,
              pack: H.pack,
              room: H.room
            }, null, 8, ["id", "position", "hotel", "pack", "room"])) : M("", !0)
          ]),
          _: 1
        }),
        q(st, { name: "collapsible" }, {
          default: he(() => [
            f.value && Y.value ? (b(), ie(T9, {
              key: 0,
              id: "roomDetailsAccordion-" + H.position,
              position: H.position,
              onShowHide: S,
              room: H.room
            }, null, 8, ["id", "position", "room"])) : M("", !0)
          ]),
          _: 1
        }),
        q(st, { name: "collapsible" }, {
          default: he(() => [
            h.value ? (b(), ie(Gq, {
              key: 0,
              id: "preferredPrivilegesAccordion-" + H.position,
              position: H.position,
              onShowHide: I,
              room: H.room,
              hotel: H.hotel
            }, null, 8, ["id", "position", "room", "hotel"])) : M("", !0)
          ]),
          _: 1
        })
      ], 2)) : M("", !0);
    };
  }
}), uK = ["title"], pK = /* @__PURE__ */ d("i", {
  class: "fa-solid fa-chevron-up",
  "aria-hidden": "true"
}, null, -1), dK = [
  pK
], ple = /* @__PURE__ */ K({
  __name: "BackToTopButton",
  setup(e) {
    const t = () => {
      u8(), window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    };
    return (n, o) => (b(), C("button", {
      class: "vacv-btn-backtotop",
      title: n.$t("vacvComponents.common.buttons.backToTop"),
      onClick: Ke(t, ["prevent"])
    }, dK, 8, uK));
  }
}), fK = { class: "showmore" }, mK = { class: "count" }, vK = /* @__PURE__ */ K({
  __name: "ShowMoreResults",
  props: {
    end: {},
    total: {},
    loading: { type: Boolean },
    showingTextLabel: {},
    buttonClass: { default: "vacv-btn-secondary" },
    buttonLabel: {}
  },
  emits: ["load-more"],
  setup(e, { emit: t }) {
    const n = e, o = t, s = V(() => n.showingTextLabel || "vacvComponents.showmoreresults.labels.showingresultsmessage");
    function a() {
      o("load-more");
    }
    return (r, i) => (b(), C("div", fK, [
      d("div", mK, k(r.$t(s.value, {
        end: n.end,
        total: n.total
      })), 1),
      r.end < r.total ? (b(), C("button", {
        key: 0,
        class: ue(["showmore__button", r.buttonClass]),
        onClick: a,
        "data-test": "load-more"
      }, k(n.loading ? r.$t("vacvComponents.common.generic.loading") : n.buttonLabel ? n.buttonLabel : r.$t("vacvComponents.showmoreresults.labels.moreresultsCTA")), 3)) : M("", !0)
    ]));
  }
}), yy = /* @__PURE__ */ De(vK, [["__scopeId", "data-v-344f5925"]]), hK = {
  class: "sv-search-error",
  "data-test": "no-flights"
}, gK = { class: "text" }, bK = { class: "h1style" }, yK = { class: "suggest" }, dle = /* @__PURE__ */ K({
  __name: "NoFlights",
  props: {
    gotoUrl: {}
  },
  setup(e) {
    return (t, n) => (b(), C("div", hK, [
      d("div", gK, [
        d("h2", bK, k(t.$t("vacvComponents.flight.messages.noFlightsAvailable")), 1),
        d("div", yK, k(t.$t("vacvComponents.flight.messages.try-again")), 1),
        d("button", {
          class: "vacv-btn-primary",
          onClick: n[0] || (n[0] = (o) => t.$router.push(t.gotoUrl))
        }, k(t.$t("vacvComponents.common.messages.go-back")), 1)
      ])
    ]));
  }
}), $K = {
  class: "sv-search-error",
  "data-test": "no-packages"
}, _K = { class: "text" }, wK = { class: "h1style" }, CK = { class: "suggest" }, fle = /* @__PURE__ */ K({
  __name: "NoPackages",
  props: {
    gotoUrl: {}
  },
  setup(e) {
    return (t, n) => (b(), C("div", $K, [
      d("div", _K, [
        d("h2", wK, k(t.$t("vacvComponents.payment.messages.packageNotAvailable")), 1),
        d("div", CK, k(t.$t("vacvComponents.payment.messages.try-again")), 1),
        d("button", {
          class: "vacv-btn-primary",
          onClick: n[0] || (n[0] = (o) => t.$router.push(t.gotoUrl))
        }, k(t.$t("vacvComponents.common.messages.go-back")), 1)
      ])
    ]));
  }
}), kK = {
  class: "sv-search-error",
  "data-test": "no-rooms"
}, SK = { class: "text" }, TK = { class: "h1style" }, AK = { class: "suggest" }, mle = /* @__PURE__ */ K({
  __name: "NoRooms",
  props: {
    gotoUrl: {}
  },
  setup(e) {
    return (t, n) => (b(), C("div", kK, [
      d("div", SK, [
        d("h2", TK, k(t.$t("vacvComponents.pdp.messages.noRoomsAvailable")), 1),
        d("div", AK, k(t.$t("vacvComponents.pdp.messages.try-again")), 1),
        d("button", {
          class: "vacv-btn-primary",
          onClick: n[0] || (n[0] = (o) => t.$router.push(t.gotoUrl))
        }, k(t.$t("vacvComponents.common.messages.go-back")), 1)
      ])
    ]));
  }
}), DK = {}, PK = {
  class: "sv-search-error",
  "data-test": "server-error"
}, IK = { class: "text" }, EK = { class: "h1style" }, OK = { class: "suggest" }, xK = { class: "special-list" };
function MK(e, t) {
  return b(), C("div", PK, [
    d("div", IK, [
      d("h2", EK, [
        d("span", null, k(e.$t("vacvComponents.plp.messages.something-went-wrong")), 1)
      ]),
      d("div", OK, k(e.$t("vacvComponents.plp.messages.try-again-by")), 1),
      d("ul", xK, [
        d("li", null, k(e.$t("vacvComponents.plp.messages.click-modify")), 1),
        d("li", null, k(e.$t("vacvComponents.plp.messages.refresh-page")), 1)
      ])
    ])
  ]);
}
const vle = /* @__PURE__ */ De(DK, [["render", MK]]), LK = ["innerHTML", "location"], NK = {
  id: "aeroplan-warning-modal-content",
  class: "vacv-editor"
}, FK = { class: "message" }, RK = { class: "uplift-warning-modal-ok-btn" }, VK = /* @__PURE__ */ K({
  __name: "AeroplanWarningMessage",
  props: {
    displayAeroplanWarningModal: { type: Boolean },
    location: {}
  },
  emits: ["on-close-aeroplan-warning-modal"],
  setup(e, { emit: t }) {
    const { t: n } = Ne({ useScope: "global" }), o = e, s = V(() => o.displayAeroplanWarningModal), a = t, r = (i) => {
      a("on-close-aeroplan-warning-modal", i);
    };
    return (i, l) => (b(), ie(Qt, {
      onClose: l[1] || (l[1] = (c) => r("CLOSE")),
      modelValue: s.value,
      "onUpdate:modelValue": l[2] || (l[2] = (c) => s.value = c),
      class: "vacv-modal modal-fullscreen vacv-modal-centered",
      id: "aeroplan-warning-modal"
    }, {
      default: he(() => [
        d("div", {
          id: "aeroplan-warning-modal-title",
          class: "h3style",
          innerHTML: T(n)("vacvComponents.payment.labels.aeroplanWarningModalTitle"),
          location: i.location
        }, null, 8, LK),
        d("div", NK, [
          d("div", FK, k(T(n)("vacvComponents.payment.messages.aeroplanWarningMessage")), 1),
          d("div", RK, [
            d("button", {
              class: "vacv-btn-primary",
              onClick: l[0] || (l[0] = (c) => r("OK"))
            }, k(T(n)("vacvComponents.payment.labels.aeroplanWarningModalBtnOK")), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]));
  }
}), Al = /* @__PURE__ */ new Map(), ji = /* @__PURE__ */ new Map(), qi = R(!1), hle = St("promos", () => ({
  fetchPromoBadges: async (t, n = 2) => {
    var s;
    const o = await eP(
      t,
      n
    );
    if ((s = o == null ? void 0 : o.Promos) != null && s.length)
      for (const a of o.Promos) {
        Al.set(a.promo_id, a);
        for (const r of a.Hotel_List) {
          const i = ji.get(r.Hotel_Code) || [];
          i.push({
            promo_id: a.promo_id,
            ...r
          }), ji.set(r.Hotel_Code, i);
        }
      }
    qi.value = !0;
  },
  isLoaded: qi
})), gle = () => {
  Al.clear(), ji.clear(), qi.value = !1;
}, ble = (e, t, n) => {
  var a, r;
  const o = (a = e.information) == null ? void 0 : a.checkIn, s = (r = e.information) == null ? void 0 : r.checkOut;
  if (o && s)
    return BK(n, t, o, s);
}, Pm = "yyyyMMdd";
function BK(e, t, n, o) {
  if (!qi.value)
    return;
  const s = ji.get(e);
  if (!s)
    return;
  const a = s.filter((r) => HK(r, n, o));
  if (a.length) {
    const r = a[a.length - 1], i = r.promo_id, l = Al.get(i);
    if (l)
      return UK(l, r.substitution, t);
  }
}
function HK(e, t, n) {
  const o = e.promo_id, s = Al.get(o);
  if (!(s != null && s.Travel_Start_Date) || !(s != null && s.Travel_End_Date))
    return !1;
  const a = Me.fromFormat(
    t,
    Pm
  ), r = Me.fromFormat(
    n,
    Pm
  ), i = MD(
    s.Travel_Start_Date,
    s.Travel_End_Date
  );
  if (i.contains(a) && (i.contains(r) || s.Travel_End_Date === r.toFormat("yyyy/MM/dd"))) {
    const l = Me.fromFormat(
      e.Start_Date,
      "yyyy/MM/dd"
    ), c = Me.fromFormat(e.End_Date, "yyyy/MM/dd"), u = Qv.fromDateTimes(l, c), p = Me.now();
    if (u.contains(p))
      return !0;
  }
  return !1;
}
const UK = (e, t, n) => {
  const o = "%%substitution%%", s = e[`locale_${n}`], a = s.Badge.split(o).join(t), r = s.Terms.split(o).join(t);
  return {
    Badge: a,
    Terms: r
  };
}, yle = St("paymentStepStore", () => {
  const e = R(), t = R([]), n = R();
  function o(c) {
    e.value && (n.value = e.value);
    const u = t.value.find((p) => p.name == c);
    u && (e.value = u);
  }
  function s(c, u) {
    var f;
    t.value.find((m) => m.name == c) || (f = t.value) == null || f.push({ name: c, step: u });
  }
  function a(c) {
    return !!(c && e.value && e.value.name == c);
  }
  function r(c) {
    s(ei.pax, 1), s(ei.insurance, 2), s(ei.checkout, 3), o(c);
  }
  function i() {
    e.value = null, t.value = [];
  }
  return {
    // State
    currentStep: e,
    paymentSteps: t,
    previousStep: n,
    // Actions
    setCurrentStep: o,
    showPaymentStep: a,
    initStore: r,
    resetStore: i,
    //Getters
    getStepByName: (c) => {
      var u;
      return (u = t.value) == null ? void 0 : u.find((p) => p.name == c);
    }
  };
}), $le = St("plp", () => {
  const e = so(), t = R(lt.PackagesSpa), n = R({
    offset: 0,
    lang: It() || "en",
    sort: t.value === lt.PackagesSpa ? Qr.recommended : Qr.priceasc,
    ...e.searchOptionsFilters
  });
  function o(r) {
    Object.assign(n.value, r);
  }
  function s() {
    n.value = {
      offset: 0,
      lang: It() || "en",
      sort: Qr.recommended,
      ...e.searchOptionsFilters
    };
  }
  function a(r) {
    t.value = r;
  }
  return le(
    () => e.searchOptionsFilters,
    (r) => {
      [
        "fprice",
        "frating",
        "fdest",
        "famenities",
        "fdeal",
        "fVacationType"
      ].forEach((l) => {
        delete n.value[l];
      }), Object.assign(n.value, r);
    },
    { deep: !0 }
  ), {
    searchOptions: n,
    updateSearchOptions: o,
    resetSearchOptions: s,
    setSpaType: a
  };
}), _le = St("packageId", () => {
  const e = R(), t = R(!1);
  function n(o) {
    e.value = o, t.value = !0;
  }
  return { packId: e, selected: t, setPackageId: n };
}), wle = St("passengers", () => {
  const e = R([]), t = R({});
  function n(r) {
    e.value = r;
  }
  function o(r) {
    t.value = r;
  }
  function s(r) {
    const i = e.value.find(
      (l) => l.id === r.id
    );
    i && Object.assign(i, r);
  }
  function a(r) {
    return e.value.map((i, l) => {
      const c = r.passengers[l];
      return c ? {
        ...i,
        ...c,
        originalTitle: i.title,
        originalFirstName: i.firstName,
        originalMiddleName: i.middleName,
        originalLastName: i.lastName,
        originalPhoneNumber: i.phoneNumber,
        originalEmailAddress: i.emailAddress,
        originalBirthdayFormatted: i.birthdayFormatted,
        originalDob: i.dob,
        originalAeroplanNum: i.aeroplanNum
      } : i;
    });
  }
  return {
    storedPassengers: e,
    formData: t,
    setFormData: o,
    setStoredPassengers: n,
    updateStoredPassenger: s,
    mapPassengerUpdatesToStoredPassengers: a
  };
});
class Cle extends Error {
  constructor(n, o) {
    super("InvalidAPIDataError");
    xo(this, "interfaceName");
    xo(this, "apiData");
    this.name = this.constructor.name, this.interfaceName = n ?? "", this.apiData = o, this.message = `interfaceName:${n},apiData:${JSON.stringify(
      o
    )}`;
  }
}
var vr = /* @__PURE__ */ ((e) => (e.POST = "POST", e.GET = "GET", e.PUT = "PUT", e))(vr || {});
function Io(e) {
  let t = 1;
  const n = R(null), o = R(!1), s = R(null), a = R(null), r = async (c, u) => {
    const p = u > 1;
    await zK(
      {
        refreshToken: p,
        composableOptions: e
      },
      n,
      o,
      s,
      a,
      c,
      l
    );
  };
  le(a, (c) => {
    t = WK(
      c,
      i,
      t,
      r,
      e.retryCount,
      e.shouldSendSentry,
      e.sentryErrorCodeFilter
    );
  });
  const { APIOptions: i, body: l } = e;
  return Xc(i) ? le(
    i,
    (c) => {
      r(c, t);
    },
    {
      immediate: !0
    }
  ) : r(i, t), {
    data: n,
    loading: o,
    error: s
  };
}
const zK = async function(e, t, n, o, s, a = {}, r) {
  const { refreshToken: i, composableOptions: l } = e, { getRequestUrl: c, fetchAbortTimeout: u } = l;
  let { method: p } = l;
  p ?? (p = "GET");
  const f = {
    method: p,
    timeout: u
  };
  o.value = null, s.value = null, n.value = !0;
  try {
    const m = await window.sso.getUserToken(i);
    try {
      const h = c(a), g = Ub(m, r), _ = {
        ...f,
        ...g
      };
      if (p === "POST")
        _.body = JSON.stringify(a);
      else if (p === "PUT") {
        const { quoteId: y, ...$ } = a;
        _.body = JSON.stringify($);
      }
      const v = await _p(h, _), w = await v.json();
      if (v.ok) {
        if (("title" in w || "errorDetail" in w) && "status" in w && "detail" in w)
          throw Ci(w);
        t.value = w;
      } else if (Hp(w.status, w.detail))
        s.value = w;
      else
        throw Ci(w);
    } catch (h) {
      o.value = h instanceof Error ? h : Error(JSON.stringify(h));
    }
  } catch (m) {
    s.value = {
      status: "JWT_TOKEN_ERROR",
      title: JSON.stringify(m),
      detail: JSON.stringify(m)
    };
  } finally {
    n.value = !1;
  }
}, WK = (e, t, n, o, s, a, r) => {
  if (e) {
    const { status: i, detail: l, errorDetail: c } = e;
    if (i === 401 && n < s)
      return n++, o(t, n), n;
    if (Hp(i, l)) {
      const { setStatus: p } = ab();
      p(e);
    }
    Go(Error(l ?? c ?? "No detail|errorDetail have been received from microservice"), a, r);
  }
  return n;
};
function kle(e, t) {
  return Io({
    APIOptions: e,
    getRequestUrl: () => zO(new URL(t.host)).toString(),
    method: vr.POST,
    fetchAbortTimeout: t.fetchAbortTimeout,
    host: t.host,
    paginationSize: t.paginationSize,
    sentryErrorCodeFilter: t.sentryErrorCodeFilter,
    shouldSendSentry: t.shouldSendSentry,
    retryCount: t.retryCount
  });
}
function jK(e, t) {
  return Io({
    APIOptions: e,
    getRequestUrl: () => jO(new URL(t.host), e).toString(),
    method: vr.PUT,
    fetchAbortTimeout: t.fetchAbortTimeout,
    host: t.host,
    paginationSize: t.paginationSize,
    sentryErrorCodeFilter: t.sentryErrorCodeFilter,
    shouldSendSentry: t.shouldSendSentry,
    retryCount: t.retryCount
  });
}
function Sle(e, t) {
  return Io({
    APIOptions: e,
    getRequestUrl: () => UO(new URL(t.host)).toString(),
    method: vr.POST,
    fetchAbortTimeout: t.fetchAbortTimeout,
    host: t.host,
    sentryErrorCodeFilter: t.sentryErrorCodeFilter,
    shouldSendSentry: t.shouldSendSentry,
    retryCount: t.retryCount
  });
}
function qK(e, t) {
  return Io({
    APIOptions: e,
    getRequestUrl: () => WO(new URL(t.host), e).toString(),
    method: vr.PUT,
    fetchAbortTimeout: t.fetchAbortTimeout,
    host: t.host,
    sentryErrorCodeFilter: t.sentryErrorCodeFilter,
    shouldSendSentry: t.shouldSendSentry,
    retryCount: t.retryCount
  });
}
const KK = { class: "promocode-section" }, YK = {
  class: "h1style",
  id: "promocode-title"
}, GK = { key: 1 }, ZK = {
  key: 0,
  class: "promocode-formbox"
}, XK = {
  key: 0,
  class: "formkit-messages"
}, JK = {
  class: "formkit-message",
  id: "invalid-promocode",
  "data-message-type": "validation"
}, QK = {
  key: 1,
  class: "promocode-showbox"
}, eY = { class: "promocode-discount" }, tY = { class: "code" }, nY = { class: "amount" }, oY = /* @__PURE__ */ d("i", {
  class: "fa-solid fa-circle-xmark",
  "aria-hidden": "true"
}, null, -1), Tle = /* @__PURE__ */ K({
  __name: "PromoCode",
  props: {
    prePackagePricing: {},
    envVarsConfig: {},
    spaType: {}
  },
  emits: ["update-promo-code", "showAlertErrors", "clearAlertErrors"],
  setup(e, { expose: t, emit: n }) {
    const { envVarsConfig: o, spaType: s } = e, { dollarValue: a } = Ce(un()), r = Ye("SENTRY_ERROR_CODE_FILTER"), i = Ye("SHOULD_SEND_SENTRY"), l = Ye("cdnBaseUrl"), c = R(!1), u = R(null), p = R(!1), f = R(""), m = R(""), h = R(!1), g = R(!1), _ = R(!1), v = R(), w = R(), y = R(!1), { upliftTokenAvailable: $ } = Ce(Co()), S = Tt(), { isPaymentMethodUplift: A } = Ce(S), { toPostData: I } = Do(), D = Qu(), O = () => {
      g.value = !0;
    }, x = () => {
      _.value = !0;
    }, F = un(), { reset: P } = F, E = n, B = (oe, U) => {
      m.value = "", (s === lt.HotelsSpa && rx(oe) || ax(oe)) && E("update-promo-code", oe), p.value = U.value;
    }, N = async (oe) => {
      p.value = !0;
      const U = oe == null ? void 0 : oe.promocode;
      jH(U);
      const Q = {
        quoteId: D == null ? void 0 : D.query.quoteId,
        ...I(),
        promoCode: U,
        lang: It()
      };
      s !== lt.HotelsSpa && (Q.itineraryId = D == null ? void 0 : D.query.itinId, Q.step = "checkout");
      const { data: z, loading: Z, error: W } = s === lt.HotelsSpa ? qK(Q, o) : jK(Q, o);
      le(
        z,
        (X) => {
          B(X, Z);
        },
        {
          deep: !0
        }
      ), le(
        W,
        (X) => {
          p.value = Z.value, X && (Go(X, i, r), h.value = !0);
        },
        {
          deep: !0
        }
      );
    };
    le(
      m,
      () => {
        h.value = !1;
      },
      { deep: !0 }
    );
    const Y = (oe, U) => {
      oe && U && (h.value = !1, U.setErrors([]), f.value = oe.promocode, p.value = !0, N(oe));
    }, j = async (oe, U) => {
      v.value = oe, w.value = U, A.value && $.value ? O() : a.value ? x() : Y(oe, U);
    }, ee = (oe) => {
      oe === "OK" && (y.value ? (ce(), y.value = !1) : a.value && (x(), Y(v.value, w.value))), g.value = !1;
    }, te = (oe) => {
      var U;
      oe === "OK" ? (Y(v.value, w.value), P()) : (m.value = "", (U = w.value) == null || U.reset()), _.value = !1;
    }, ce = () => {
      y.value = !1, f.value = "", h.value = !1, c.value = !1, N();
    }, H = async () => {
      y.value = !0, A.value && $.value ? O() : ce();
    };
    return t({
      handleApplyPromoCode: B,
      applyPromoCode: j,
      onCloseUpLiftWarningModal: ee,
      onOpenAeroplanWarningModal: x,
      onCloseAeroplanWarningModal: te,
      removePromoCode: H,
      execute: Y,
      promoCode: f,
      isPaymentMethodUplift: A,
      upliftTokenAvailable: $,
      displayUpliftWarningModal: g,
      displayAeroplanWarningModal: _,
      promoWasRemoved: y,
      dollarValue: a
    }), (oe, U) => {
      var z, Z, W, X, G, se;
      const Q = ut("FormKit");
      return b(), C($e, null, [
        d("section", KK, [
          d("h2", YK, k(oe.$t("vacvComponents.payment.labels.promocodeTitle")), 1),
          p.value ? (b(), ie(sd, {
            key: 0,
            cdnBaseUrl: T(l)
          }, null, 8, ["cdnBaseUrl"])) : (b(), C("div", GK, [
            !c.value && !((Z = (z = oe.prePackagePricing) == null ? void 0 : z.promo) != null && Z.value) ? (b(), C("div", ZK, [
              q(Q, {
                type: "form",
                delay: 0,
                "submit-label": oe.$t("vacvComponents.payment.labels.promocodeApplyButton"),
                "submit-attrs": {
                  inputClass: "$reset vacv-btn-secondary"
                },
                "form-class": "vacv-form-wrapper",
                ref_key: "form",
                ref: u,
                id: "promocode-form",
                config: { validationVisibility: "submit" },
                onSubmit: j
              }, {
                default: he(() => [
                  q(Q, {
                    type: "text",
                    delay: 0,
                    name: "promocode",
                    id: "promocode",
                    "aria-labelledby": "promocode-title",
                    "outer-class": "vacv-input-wrapper",
                    validation: "required",
                    "validation-messages": {
                      required: oe.$t("vacvComponents.payment.errors.promocodeError")
                    },
                    modelValue: m.value,
                    "onUpdate:modelValue": U[0] || (U[0] = (pe) => m.value = pe)
                  }, null, 8, ["validation-messages", "modelValue"])
                ]),
                _: 1
              }, 8, ["submit-label"]),
              h.value ? (b(), C("div", XK, [
                d("span", JK, k(oe.$t("vacvComponents.payment.errors.promocodeError")), 1)
              ])) : M("", !0)
            ])) : (b(), C("div", QK, [
              d("div", eY, [
                d("span", tY, k((X = (W = oe.prePackagePricing) == null ? void 0 : W.promo) == null ? void 0 : X.code), 1),
                d("span", nY, k(oe.$t("vacvComponents.payment.messages.promocodeDiscount", {
                  discount: T(Se)((se = (G = oe.prePackagePricing) == null ? void 0 : G.promo) == null ? void 0 : se.value, oe.$n)
                })), 1)
              ]),
              d("button", {
                onClick: H,
                id: "remove-promocode"
              }, [
                oY,
                ne(k(oe.$t("vacvComponents.payment.labels.promocodeRemoveButton")), 1)
              ])
            ]))
          ]))
        ]),
        q(mr, {
          location: "PromoCode",
          "display-uplift-warning-modal": g.value,
          onOnCloseUpliftWarningModal: ee
        }, null, 8, ["display-uplift-warning-modal"]),
        q(VK, {
          showCancelBtn: !1,
          location: "PromoCode",
          "display-aeroplan-warning-modal": _.value,
          onOnCloseAeroplanWarningModal: te
        }, null, 8, ["display-aeroplan-warning-modal"])
      ], 64);
    };
  }
}), sY = { class: "title-wrapper" }, aY = { class: "ancillary-subtitle h1style" }, rY = ["aria-expanded", "aria-controls"], iY = { class: "toggletext" }, lY = { class: "sr-only" }, cY = {
  key: 0,
  class: "note"
}, uY = ["id"], xr = /* @__PURE__ */ K({
  __name: "CollapsibleSection",
  props: {
    title: {},
    alt: {},
    collapsed: { type: Boolean, default: !1 },
    groupName: {},
    alwaysRendered: { type: Boolean }
  },
  setup(e, { expose: t }) {
    const n = e, o = R(!1), s = R("0px"), a = R();
    le(a, async (i) => {
      i != null && i.scrollHeight && (s.value = i.scrollHeight + "px");
    });
    const r = () => {
      o.value = !o.value, zH(
        n.groupName,
        o.value === !0 ? Tu.hide : Tu.show
      );
    };
    return Re(() => {
      o.value = n.collapsed;
    }), t({
      toggle: r,
      isCollapsed: o,
      scrollHeight: s,
      scrollHeightRef: a
    }), (i, l) => (b(), C("section", {
      class: "ancillary-collapsible-section",
      ref_key: "scrollHeightRef",
      ref: a
    }, [
      d("div", sY, [
        d("h2", aY, k(i.title), 1),
        d("button", {
          class: "link linklook",
          "aria-expanded": !o.value,
          "aria-controls": i.groupName,
          onClick: Ke(r, ["stop", "prevent"])
        }, [
          d("span", iY, [
            d("i", {
              class: ue(
                "fa-solid " + (o.value ? "fa-circle-plus" : "fa-circle-minus")
              ),
              "aria-hidden": "true"
            }, null, 2),
            ne(k(o.value ? i.$t("vacvComponents.ancillary.labels.showOptions") : i.$t("vacvComponents.ancillary.labels.hideOptions")) + " ", 1),
            d("span", lY, k(i.title), 1)
          ])
        ], 8, rY),
        o.value ? (b(), C("div", cY, k(i.alt), 1)) : M("", !0)
      ]),
      d("div", {
        class: ue([{ hidden: o.value && i.alwaysRendered }]),
        id: i.groupName
      }, [
        i.alwaysRendered || !o.value ? Xe(i.$slots, "default", { key: 0 }) : M("", !0)
      ], 10, uY)
    ], 512));
  }
}), pY = { class: "ancillary-protection-section" }, dY = { class: "protection-wrapper" }, fY = {
  role: "presentation",
  class: "giga-grid"
}, mY = {
  key: 0,
  class: "grid-header-sup"
}, vY = /* @__PURE__ */ d("i", {
  class: "fa-solid fa-thumbs-up",
  "aria-hidden": "true"
}, null, -1), hY = /* @__PURE__ */ d("div", { class: "grid-header-pre" }, null, -1), gY = { class: "grid-header" }, bY = ["src", "alt"], yY = {
  class: "grid-label",
  "aria-hidden": "true"
}, $Y = { class: "grid-value vacv-price" }, _Y = { class: "sr-only" }, wY = { class: "amount" }, CY = { class: "per" }, kY = { class: "grid-label" }, SY = ["onClick", "aria-label"], TY = /* @__PURE__ */ d("span", { class: "round-icon" }, null, -1), AY = [
  TY
], DY = { class: "grid-value check" }, PY = {
  key: 0,
  class: "fa-solid fa-check"
}, IY = { class: "sr-only" }, EY = /* @__PURE__ */ d("div", { class: "grid-footer-pre" }, null, -1), OY = { class: "grid-footer" }, xY = ["onClick"], MY = { class: "add" }, LY = { class: "sr-only" }, NY = { class: "added" }, FY = /* @__PURE__ */ d("i", {
  class: "fa-solid fa-check",
  "aria-hidden": "true"
}, null, -1), RY = { class: "sr-only" }, VY = {
  key: 0,
  class: "protection-terms"
}, BY = ["innerHTML"], HY = ["aria-expanded"], UY = { class: "toggletext" }, zY = { class: "h3style" }, WY = ["innerHTML"], jY = /* @__PURE__ */ K({
  __name: "TravelProtection",
  props: {
    travelProtections: {},
    ancillariesTermsAndCondition: {}
  },
  setup(e) {
    const t = e, n = Do(), o = R(!1), s = () => {
      o.value = !o.value;
    }, a = V(
      () => Object.values(t.travelProtections).sort((g, _) => g.order - _.order)
    ), r = V(() => {
      const g = [];
      return Object.values(t.travelProtections ?? {}).forEach((_) => {
        var v;
        (v = _.inclusions) == null || v.flatMap(
          (w) => g.push(w)
        );
      }), g;
    }), i = (g, _) => {
      var v;
      return (v = g.inclusions) == null ? void 0 : v.find((w) => w.label === _);
    }, l = () => {
      let g = "";
      return n.ancillaries.travelProtections.forEach(
        (_, v) => {
          g = g + (v > 0 ? "&" : "") + _.title;
        }
      ), g;
    }, c = (g) => {
      u(g) ? n.removeAncillary("travelProtections", g == null ? void 0 : g.id) : (n.addAncillary("travelProtections", g), ly(
        "travelProtections",
        l()
      ));
    }, u = (g) => n.ancillaries.travelProtections.some(
      (_) => _.id === g.id
    ), p = tt({ displayed: null }), f = (g) => {
      p.displayed = r.value.find((_) => _.label === g) ?? null, h.value = !0;
    }, m = () => {
      h.value = !1;
    }, h = R(!1);
    return (g, _) => (b(), C("section", pY, [
      d("div", dY, [
        d("div", fY, [
          (b(!0), C($e, null, ke(a.value, (v) => (b(), C("div", {
            key: v.id,
            class: ue(["grid-container", {
              selected: u(v),
              reco: v.recommended
            }])
          }, [
            v.recommended ? (b(), C("div", mY, [
              vY,
              ne(" " + k(g.$t("vacvComponents.ancillary.labels.recommended")), 1)
            ])) : M("", !0),
            hY,
            d("div", gY, [
              d("img", {
                src: v.icon,
                height: "16",
                alt: v.title,
                "aria-hidden": "true"
              }, null, 8, bY)
            ]),
            d("div", yY, k(g.$t("vacvComponents.ancillary.labels.price")), 1),
            d("div", $Y, [
              d("span", _Y, k(v.title) + " " + k(g.$t("vacvComponents.ancillary.labels.price")), 1),
              d("span", wY, " + " + k(g.$n(
                Object.values(v.subOptions)[0].price,
                "currency"
              ).replace("CA", "")), 1),
              d("span", CY, k(g.$t("vacvComponents.ancillary.labels.traveller")), 1)
            ]),
            (b(!0), C($e, null, ke(r.value, (w) => (b(), C($e, {
              key: w.label
            }, [
              d("div", kY, [
                d("span", null, [
                  ne(k(w.label) + " ", 1),
                  w.description ? (b(), C("button", {
                    key: 0,
                    onClick: Ke((y) => f(w.label), ["stop", "prevent"]),
                    class: "price-popover-link",
                    tabindex: "0",
                    "aria-haspopup": "true",
                    "aria-label": `${g.$t("vacvComponents.ancillary.access.know-more-about")} ${w.label}`
                  }, AY, 8, SY)) : M("", !0)
                ])
              ]),
              d("div", DY, [
                i(v, w.label) ? (b(), C("i", PY, [
                  d("span", IY, k(g.$t("vacvComponents.ancillary.access.included")) + " " + k(v.title) + ": " + k(w.label), 1)
                ])) : M("", !0)
              ])
            ], 64))), 128)),
            EY,
            d("div", OY, [
              d("button", {
                class: ue(["vacv-btn-secondary", { active: u(v) }]),
                onClick: (w) => c(v)
              }, [
                d("span", MY, [
                  ne(k(g.$t("vacvComponents.common.buttons.add")) + " ", 1),
                  d("span", LY, k(v.title), 1)
                ]),
                d("span", NY, [
                  FY,
                  d("span", RY, k(v.title), 1),
                  ne(" " + k(g.$t("vacvComponents.common.buttons.added")), 1)
                ])
              ], 10, xY)
            ])
          ], 2))), 128))
        ])
      ]),
      g.ancillariesTermsAndCondition && g.ancillariesTermsAndCondition.description && a.value.length ? (b(), C("div", VY, [
        q(st, { name: "collapsible" }, {
          default: he(() => [
            o.value ? (b(), C("div", {
              key: 0,
              id: "protectionTerms",
              class: ue(["hotel-accordion-wrapper", { open: o.value }]),
              role: "region",
              "aria-live": "polite"
            }, [
              d("div", {
                class: "text",
                innerHTML: g.ancillariesTermsAndCondition.description
              }, null, 8, BY)
            ], 2)) : M("", !0)
          ]),
          _: 1
        }),
        d("button", {
          class: "link linklook",
          "aria-expanded": o.value,
          "aria-controls": "protectionTerms",
          onClick: _[0] || (_[0] = Ke((v) => s(), ["stop", "prevent"]))
        }, [
          d("span", UY, [
            d("i", {
              class: ue(
                "fa-solid " + (o.value ? "fa-circle-minus" : "fa-circle-plus")
              ),
              "aria-hidden": "true"
            }, null, 2),
            ne(" " + k(o.value ? g.$t("vacvComponents.ancillary.labels.hideDetails") : g.$t("vacvComponents.ancillary.labels.terms")), 1)
          ])
        ], 8, HY)
      ])) : M("", !0),
      p.displayed ? (b(), ie(Qt, {
        key: 1,
        onClose: m,
        modelValue: h.value,
        "onUpdate:modelValue": _[1] || (_[1] = (v) => h.value = v),
        class: "vacv-modal modal-fullscreen vacv-modal-centered",
        id: p.displayed.label.replace(/\s/g, "")
      }, {
        default: he(() => [
          d("div", zY, k(p.displayed.label), 1),
          p.displayed ? (b(), C("div", {
            key: 0,
            innerHTML: p.displayed.description
          }, null, 8, WY)) : M("", !0)
        ]),
        _: 1
      }, 8, ["modelValue", "id"])) : M("", !0)
    ]));
  }
}), qY = { class: "list-item-notes vacv-editor" }, KY = /* @__PURE__ */ d("div", { class: "note-title" }, "Note:", -1), YY = { class: "spa-list special-list" }, $y = /* @__PURE__ */ K({
  __name: "AncillaryListItemNotes",
  props: {
    notes: {}
  },
  setup(e) {
    return (t, n) => (b(), C("div", qY, [
      KY,
      d("ul", YY, [
        (b(!0), C($e, null, ke(t.notes, (o, s) => (b(), C("li", { key: s }, k(o), 1))), 128))
      ])
    ]));
  }
}), GY = ["id", "aria-labelledby"], ZY = { class: "hotel-accordion" }, XY = ["aria-label", "aria-controls"], JY = { class: "accordion-title details" }, QY = ["id"], eG = { class: "accordion-content" }, tG = ["innerHTML"], nG = /* @__PURE__ */ K({
  __name: "AncillaryListItemDetails",
  props: {
    id: {},
    notes: {},
    highlights: {}
  },
  emits: ["toggleDetailsAccordion"],
  setup(e, { expose: t, emit: n }) {
    En((r) => ({
      bf8d9884: s.value
    }));
    const o = n, s = R("0px"), a = R();
    return le(a, async (r) => {
      r != null && r.scrollHeight && (s.value = r.scrollHeight + "px");
    }), t({
      scrollHeight: s,
      scrollHeightRef: a
    }), (r, i) => {
      var l;
      return b(), C("section", {
        id: r.id,
        class: "hotel-accordion-wrapper ancillary-details",
        "aria-live": "polite",
        "aria-labelledby": r.id + "-title",
        ref_key: "scrollHeightRef",
        ref: a
      }, [
        d("div", ZY, [
          d("button", {
            onClick: i[0] || (i[0] = (c) => o("toggleDetailsAccordion")),
            class: "btn-close",
            "aria-label": r.$t("vacvComponents.common.buttons.close"),
            "aria-expanded": "true",
            "aria-controls": r.id
          }, null, 8, XY),
          d("div", JY, [
            d("div", {
              id: r.id + "-title",
              class: "vacv-label-sm"
            }, k(r.$t("vacvComponents.common.labels.details")), 9, QY)
          ]),
          d("div", eG, [
            (l = r.notes) != null && l.length ? (b(), ie($y, {
              key: 0,
              notes: r.notes
            }, null, 8, ["notes"])) : M("", !0),
            d("div", {
              class: "details vacv-editor",
              innerHTML: r.highlights
            }, null, 8, tG)
          ])
        ])
      ], 8, GY);
    };
  }
}), oG = /* @__PURE__ */ De(nG, [["__scopeId", "data-v-ca11f716"]]), sG = ["aria-expanded", "aria-controls"], aG = { class: "toggletext" }, rG = /* @__PURE__ */ d("i", {
  class: "fa-solid fa-memo-circle-info",
  "aria-hidden": "true"
}, null, -1), iG = { class: "sr-only" }, Im = /* @__PURE__ */ K({
  __name: "AncillaryListItemDetailsToggle",
  props: {
    item: {},
    wrapperClass: {},
    isVisible: { type: Boolean }
  },
  emits: ["toggleDetailsAccordion"],
  setup(e, { expose: t, emit: n }) {
    const o = n, s = () => {
      o("toggleDetailsAccordion");
    };
    return t({
      onToggleDetailsAccordion: s
    }), (a, r) => (b(), C("div", {
      class: ue(a.wrapperClass)
    }, [
      d("button", {
        class: "link linklook",
        "aria-expanded": a.isVisible,
        "aria-controls": a.item.id + "-details",
        onClick: Ke(s, ["stop", "prevent"])
      }, [
        d("span", aG, [
          rG,
          ne(k(a.isVisible ? a.$t("vacvComponents.ancillary.labels.hideDetails") : a.$t("vacvComponents.ancillary.labels.showDetails")) + " ", 1),
          d("span", iG, k(a.item.title), 1)
        ])
      ], 8, sG)
    ], 2));
  }
}), lG = { class: "hotel-select" }, cG = {
  key: 0,
  class: "fa-solid fa-check",
  "aria-hidden": "true"
}, uG = { class: "sr-only" }, pG = ["aria-expanded", "aria-controls"], dG = {
  key: 0,
  class: "fa-solid fa-check",
  "aria-hidden": "true"
}, fG = { class: "sr-only" }, mG = /* @__PURE__ */ K({
  __name: "AncillaryListItemCta",
  props: {
    item: {},
    subOptions: {},
    isSelected: { type: Boolean },
    hasSubOptions: { type: Boolean },
    hasMultipleSubOptions: { type: Boolean },
    isSubOptionsDetailsVisible: { type: Boolean }
  },
  emits: ["toggleSelect", "toggleSelectSubOption", "toggleSubOptionsDetails"],
  setup(e, { expose: t, emit: n }) {
    const o = e, s = n, a = () => {
      o.hasSubOptions ? s("toggleSelectSubOption", l()) : s("toggleSelect");
    }, r = () => {
      o.isSelected ? s("toggleSelect") : s("toggleSubOptionsDetails");
    }, i = V(() => o.isSelected ? "vacvComponents.common.buttons.added" : o.isSubOptionsDetailsVisible ? "vacvComponents.common.buttons.hideOptions" : "vacvComponents.common.buttons.showOptions"), l = () => {
      const c = o.subOptions[0];
      return zs(c) ? Object.values(c.dates)[0].id : c.id;
    };
    return t({
      onToggleSelect: a,
      onToggleSubOptionsDetails: r,
      subOptionsButtonLabelKey: i,
      getSubOptionId: l
    }), (c, u) => (b(), C("div", lG, [
      c.hasMultipleSubOptions ? M("", !0) : (b(), C("button", {
        key: 0,
        class: ue(["vacv-btn-secondary", { active: c.isSelected }]),
        onClick: a
      }, [
        d("span", {
          class: ue({ add: !c.isSelected, added: c.isSelected })
        }, [
          c.isSelected ? (b(), C("i", cG)) : M("", !0),
          ne(" " + k(c.isSelected ? c.$t("vacvComponents.common.buttons.added") : c.$t("vacvComponents.common.buttons.add")) + " ", 1),
          d("span", uG, k(c.item.title), 1)
        ], 2)
      ], 2)),
      c.hasMultipleSubOptions ? (b(), C("button", {
        key: 1,
        class: ue(["vacv-btn-secondary", { active: c.isSelected }]),
        "aria-expanded": c.isSubOptionsDetailsVisible,
        "aria-controls": c.item.id + "-sub-options",
        onClick: r
      }, [
        d("span", {
          class: ue({ add: !c.isSelected, added: c.isSelected })
        }, [
          c.isSelected ? (b(), C("i", dG)) : M("", !0),
          ne(" " + k(c.$t(i.value)) + " ", 1),
          d("span", fG, k(c.item.title), 1)
        ], 2)
      ], 10, pG)) : M("", !0)
    ]));
  }
}), vG = { class: "total-wrapper" }, hG = { class: "price-per" }, gG = {
  key: 0,
  class: "price-from"
}, bG = { class: "vacv-price" }, yG = { class: "per" }, $G = { class: "price-taxes" }, _G = /* @__PURE__ */ K({
  __name: "AncillaryListItemPrice",
  props: {
    subOptions: {},
    selectedSubOptionDate: {},
    hasMultipleSubOptions: { type: Boolean }
  },
  setup(e, { expose: t }) {
    const n = e, o = V(
      () => n.subOptions.length > 0 ? n.subOptions[0] : void 0
    ), s = V(() => {
      if (n.selectedSubOptionDate)
        return Se(n.selectedSubOptionDate.price, vo.global.n);
      if (n.hasMultipleSubOptions) {
        const i = r();
        return Se(i, vo.global.n);
      } else {
        const i = a(o.value);
        return Se(i, vo.global.n);
      }
    }), a = (i) => {
      if (i)
        return zs(i) && i.dates ? Object.values(i.dates)[0].price : i.price;
    }, r = () => n.subOptions.map((l) => a(l)).filter((l) => l !== void 0).sort((l, c) => l - c)[0];
    return t({
      firstSubOption: o,
      price: s,
      getSubOptionPrice: a,
      getCheapestSubOptionPrice: r
    }), (i, l) => (b(), C("div", vG, [
      d("div", hG, [
        i.hasMultipleSubOptions && !i.selectedSubOptionDate ? (b(), C("span", gG, k(i.$t("vacvComponents.ancillary.labels.from")), 1)) : M("", !0),
        d("span", bG, "+ " + k(s.value), 1),
        d("span", yG, k(i.$t("vacvComponents.ancillary.labels.perAdult")), 1)
      ]),
      d("div", $G, k(i.$t("vacvComponents.common.pricedetails.taxesincl")), 1)
    ]));
  }
}), wG = { class: "total-wrapper" }, CG = { class: "price-per" }, kG = { class: "vacv-price" }, SG = { class: "per" }, TG = { class: "price-taxes" }, AG = /* @__PURE__ */ K({
  __name: "AncillaryListItemSubOptionsPrice",
  props: {
    price: {}
  },
  setup(e, { expose: t }) {
    const n = e, o = V(() => Se(n.price, vo.global.n));
    return t({
      formattedPrice: o
    }), (s, a) => (b(), C("div", wG, [
      d("div", CG, [
        d("span", kG, "+ " + k(o.value), 1),
        d("span", SG, k(s.$t("vacvComponents.ancillary.labels.perAdult")), 1)
      ]),
      d("div", TG, k(s.$t("vacvComponents.common.pricedetails.taxesincl")), 1)
    ]));
  }
}), DG = ["id"], PG = {
  key: 0,
  class: "fa-solid fa-check",
  "aria-hidden": "true"
}, IG = { class: "sr-only" }, EG = /* @__PURE__ */ K({
  __name: "AncillaryListItemSubOptionsCta",
  props: {
    subOption: {},
    isSelected: { type: Boolean },
    groupName: {}
  },
  emits: ["toggleSelectSubOption"],
  setup(e, { expose: t, emit: n }) {
    const o = e, s = n, a = (i) => {
      s("toggleSelectSubOption", i);
    }, r = () => zs(o.subOption) ? Object.values(o.subOption.dates)[0].id : o.subOption.id;
    return t({
      onToggleSelect: a,
      getSubOptionId: r
    }), (i, l) => (b(), C("div", {
      class: "hotel-select",
      id: r()
    }, [
      d("button", {
        class: ue(["vacv-btn-secondary-sub-options", { active: i.isSelected }]),
        onClick: l[0] || (l[0] = (c) => a(r()))
      }, [
        d("span", {
          class: ue({ add: !i.isSelected, added: i.isSelected })
        }, [
          i.isSelected ? (b(), C("i", PG)) : M("", !0),
          ne(" " + k(i.isSelected ? i.$t("vacvComponents.common.buttons.added") : i.$t("vacvComponents.common.buttons.add")), 1)
        ], 2),
        d("span", IG, k(i.subOption.title), 1)
      ], 2)
    ], 8, DG));
  }
}), OG = { class: "sub-options-details__item-header" }, xG = { class: "sub-options-details__item-title" }, MG = ["aria-label"], LG = /* @__PURE__ */ d("span", { class: "round-icon" }, null, -1), NG = [
  LG
], FG = ["innerHTML"], RG = { class: "sub-options-details__item-price" }, VG = { class: "sub-options-details__item-cta" }, BG = /* @__PURE__ */ K({
  __name: "AncillaryListItemSubOptionsItem",
  props: {
    subOption: {},
    groupName: {}
  },
  emits: ["toggleSelectSubOption"],
  setup(e, { expose: t, emit: n }) {
    const o = n, s = Do(), a = R(!1), r = (p) => zs(p) ? Object.values(p.dates)[0].price : p.price, i = (p) => zs(p) ? Object.values(p.dates)[0].id : p.id, l = (p) => {
      o("toggleSelectSubOption", p);
    }, c = () => {
      a.value = !1;
    }, u = () => {
      a.value = !0;
    };
    return t({
      getPrice: r,
      getSubOptionId: i,
      onToggleSelectSubOption: l,
      onCloseModal: c,
      displayModal: a,
      showModal: u
    }), (p, f) => (b(), C("li", {
      class: ue(["sub-options-details__item", {
        selected: T(s).isAncillarySubOptionSelected(
          p.groupName,
          i(p.subOption)
        )
      }])
    }, [
      d("div", OG, [
        d("h4", xG, [
          d("span", null, k(p.subOption.title), 1),
          d("button", {
            onClick: u,
            class: "price-popover-link",
            tabindex: "0",
            "aria-haspopup": "true",
            "aria-label": `${p.$t("vacvComponents.ancillary.access.know-more-about")} ${p.subOption.title}`
          }, NG, 8, MG),
          q(Qt, {
            onClose: c,
            modelValue: a.value,
            "onUpdate:modelValue": f[0] || (f[0] = (m) => a.value = m),
            class: "vacv-modal modal-fullscreen vacv-modal-centered"
          }, {
            default: he(() => [
              d("div", {
                class: "vacv-editor",
                innerHTML: p.subOption.description
              }, null, 8, FG)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      d("div", RG, [
        q(AG, {
          price: r(p.subOption)
        }, null, 8, ["price"])
      ]),
      d("div", VG, [
        q(EG, {
          "sub-option": p.subOption,
          "is-selected": T(s).isAncillarySubOptionSelected(
            p.groupName,
            i(p.subOption)
          ),
          groupName: p.groupName,
          onToggleSelectSubOption: l
        }, null, 8, ["sub-option", "is-selected", "groupName"])
      ])
    ], 2));
  }
}), HG = ["id", "aria-labelledby"], UG = { class: "hotel-accordion" }, zG = ["aria-label", "aria-controls"], WG = { class: "accordion-title details" }, jG = ["id"], qG = { class: "accordion-content" }, KG = { class: "sub-options-details__list" }, Sc = 10, YG = /* @__PURE__ */ K({
  __name: "AncillaryListItemSubOptions",
  props: {
    id: {},
    notes: {},
    subOptions: {},
    groupName: {}
  },
  emits: ["toggleDetailsAccordion", "toggleSelectSubOption"],
  setup(e, { expose: t, emit: n }) {
    En((m) => ({
      c645f10e: i.value
    }));
    const o = e, s = n, a = R(Sc), r = It(), i = R("0px"), l = R();
    le(l, async (m) => {
      m != null && m.scrollHeight && (i.value = m.scrollHeight + "px");
    });
    const c = V(() => [...o.subOptions].sort((h, g) => {
      var I, D;
      const _ = h.dates && Object.keys(h.dates).length > 0, v = g.dates && Object.keys(g.dates).length > 0, w = _ ? Object.values(h.dates)[0].price : h.price || 0, y = v ? Object.values(g.dates)[0].price : g.price || 0, $ = w - y;
      if ($ !== 0)
        return $;
      const S = ((I = h.title) == null ? void 0 : I.toLowerCase()) ?? "", A = ((D = g.title) == null ? void 0 : D.toLowerCase()) ?? "";
      return S.localeCompare(A, r, { numeric: !0 });
    })), u = V(
      () => c.value.slice(0, a.value)
    ), p = (m) => {
      s("toggleSelectSubOption", m);
    }, f = () => {
      a.value = Math.min(a.value + Sc, o.subOptions.length);
    };
    return t({
      scrollHeight: i,
      scrollHeightRef: l,
      end: a,
      visibleSubOptions: u,
      onToggleSelectSubOption: p,
      loadMore: f,
      sortedSubOptions: c
    }), (m, h) => {
      var g;
      return b(), C("section", {
        id: m.id,
        class: "hotel-accordion-wrapper sub-options-details",
        "aria-live": "polite",
        "aria-labelledby": m.id + "-title",
        ref_key: "scrollHeightRef",
        ref: l
      }, [
        d("div", UG, [
          d("button", {
            onClick: h[0] || (h[0] = (_) => s("toggleDetailsAccordion")),
            class: "btn-close",
            "aria-label": m.$t("vacvComponents.common.buttons.close"),
            "aria-expanded": "true",
            "aria-controls": m.id
          }, null, 8, zG),
          d("div", WG, [
            d("div", {
              id: m.id + "-title",
              class: "vacv-label-sm"
            }, k(m.$t("vacvComponents.common.labels.selectAnOption")), 9, jG)
          ]),
          d("div", qG, [
            (g = m.notes) != null && g.length ? (b(), ie($y, {
              key: 0,
              notes: m.notes
            }, null, 8, ["notes"])) : M("", !0),
            d("ul", KG, [
              (b(!0), C($e, null, ke(u.value, (_) => (b(), ie(BG, {
                key: _.id,
                "sub-option": _,
                "group-name": m.groupName,
                onToggleSelectSubOption: p
              }, null, 8, ["sub-option", "group-name"]))), 128))
            ]),
            m.subOptions.length > Sc ? (b(), ie(yy, {
              key: 1,
              end: a.value,
              total: m.subOptions.length,
              loading: !1,
              "button-class": "vacv-btn-secondary-sub-options",
              onLoadMore: f,
              showingTextLabel: "vacvComponents.ancillary.labels.showingOptionsResults"
            }, null, 8, ["end", "total"])) : M("", !0)
          ])
        ])
      ], 8, HG);
    };
  }
}), GG = /* @__PURE__ */ De(YG, [["__scopeId", "data-v-5c495287"]]), ZG = { class: "hotel-item" }, XG = { class: "item-gallery" }, JG = { class: "carousel-fallback-img" }, QG = ["src", "alt"], eZ = { class: "item-content" }, tZ = { class: "item-content-left" }, nZ = { class: "text" }, oZ = { class: "item-content-right" }, sZ = { class: "price-left" }, aZ = { class: "price-right" }, rZ = /* @__PURE__ */ K({
  __name: "AncillaryListItem",
  props: {
    item: {},
    groupName: {}
  },
  setup(e, { expose: t }) {
    const n = e, o = Do(), s = R(!1), a = R(!1), r = V(() => n.item.id), i = V(() => n.groupName), l = V(() => o.isAncillarySelected(i.value, r.value)), c = V(() => Object.values(n.item.subOptions)), u = V(() => c.value[0] ?? {}), p = V(() => n.groupName === "activities"), f = V(() => n.groupName === "mealPlans"), m = V(() => (p.value || f.value) && c.value.length > 0), h = V(() => m.value && c.value.length > 1), g = V(() => {
      if (h.value) {
        const O = o.geSubOptionTitle(n.item.id);
        return O || n.item.description;
      }
      return u.value.title;
    }), _ = V(() => {
      if (p.value || f.value)
        return n.item.notes;
    }), v = (O) => o.getSelectedSubOption(O);
    function w(O, x) {
      x ? o.addAncillary(i.value, O, x) : o.addAncillary(i.value, O), ly(
        i.value,
        $(O, x) || "ancillary_no_product-code"
      );
    }
    const y = (O) => O.includes("-") ? O.split("-")[0] : O, $ = (O, x) => {
      if (x) {
        const F = gl(O, x);
        return (F == null ? void 0 : F.productCode) ?? "";
      } else
        return u.value.productCode;
    }, S = (O) => {
      const x = O ?? r.value, F = y(x);
      o.isAncillarySelected(i.value, F) ? o.removeAncillary(i.value, F) : w(n.item, O);
    }, A = (O) => {
      if (o.isAncillarySubOptionSelected(i.value, O)) {
        const x = y(O);
        o.removeAncillary(i.value, x, O);
      } else
        w(n.item, O);
    }, I = () => {
      s.value = !s.value;
    }, D = () => {
      WH(n.groupName, n.item.title), a.value = !a.value;
    };
    return t({
      getGroupItemId: y,
      description: g,
      isActivity: p,
      isSelected: l,
      itemId: r,
      subOptions: c,
      firstSubOption: u,
      hasActivitySubOptions: m,
      hasMultipleActivitiesSubOptions: h,
      addItemToCart: w,
      getProductCode: $,
      onToggleSelected: S,
      onToggleSelectedSubOption: A,
      onToggleDetailsAccordion: I,
      isDetailsAccordionVisible: s,
      onToggleSubOptionsDetailsAccordion: D,
      isSubOptionsDetailsVisibile: a,
      notes: _
    }), (O, x) => {
      var F, P;
      return b(), C("div", {
        class: ue(["hotel-item-wrapper", { selected: l.value }])
      }, [
        d("div", ZG, [
          d("div", XG, [
            d("div", JG, [
              d("img", {
                src: (F = O.item) == null ? void 0 : F.icon,
                alt: O.$t("vacvComponents.common.messages.fallback-img")
              }, null, 8, QG)
            ])
          ]),
          d("div", eZ, [
            d("div", tZ, [
              d("h3", null, k((P = O.item) == null ? void 0 : P.title), 1),
              d("div", nZ, k(g.value), 1),
              h.value ? M("", !0) : (b(), ie(Im, {
                key: 0,
                item: O.item,
                "wrapper-class": "desktop-only links-wrapper",
                "is-visible": s.value,
                onToggleDetailsAccordion: I
              }, null, 8, ["item", "is-visible"]))
            ]),
            d("div", oZ, [
              d("div", sZ, [
                q(_G, {
                  "sub-options": c.value,
                  "has-multiple-sub-options": h.value,
                  "selected-sub-option-date": v(O.item.id)
                }, null, 8, ["sub-options", "has-multiple-sub-options", "selected-sub-option-date"])
              ]),
              d("div", aZ, [
                q(mG, {
                  item: O.item,
                  "is-selected": l.value,
                  "has-sub-options": m.value,
                  "has-multiple-sub-options": h.value,
                  "is-sub-options-details-visible": a.value,
                  "sub-options": c.value,
                  onToggleSelect: S,
                  onToggleSelectSubOption: A,
                  onToggleSubOptionsDetails: D
                }, null, 8, ["item", "is-selected", "has-sub-options", "has-multiple-sub-options", "is-sub-options-details-visible", "sub-options"])
              ])
            ]),
            h.value ? M("", !0) : (b(), ie(Im, {
              key: 0,
              item: O.item,
              "wrapper-class": "mobile-only links-wrapper",
              "is-visible": s.value,
              onToggleDetailsAccordion: I
            }, null, 8, ["item", "is-visible"]))
          ])
        ]),
        q(st, { name: "collapsible" }, {
          default: he(() => [
            s.value ? (b(), ie(oG, {
              key: 0,
              id: O.item.id + "-details",
              onToggleDetailsAccordion: I,
              highlights: u.value.description,
              notes: _.value
            }, null, 8, ["id", "highlights", "notes"])) : M("", !0)
          ]),
          _: 1
        }),
        q(st, { name: "collapsible" }, {
          default: he(() => [
            a.value ? (b(), ie(GG, {
              key: 0,
              id: O.item.id + "-details",
              notes: _.value,
              "sub-options": c.value,
              "group-name": i.value,
              onToggleDetailsAccordion: D,
              onToggleSelectSubOption: A
            }, null, 8, ["id", "notes", "sub-options", "group-name"])) : M("", !0)
          ]),
          _: 1
        })
      ], 2);
    };
  }
}), iZ = /* @__PURE__ */ De(rZ, [["__scopeId", "data-v-faff3b60"]]), lZ = { class: "ancillary-group" }, cZ = ["id"], uZ = { class: "spa-list ancillary-list" }, pZ = ["index"], Tc = 3, Ac = /* @__PURE__ */ K({
  __name: "AncillaryGroup",
  props: {
    ancillaries: {},
    groupName: {},
    showingTextLabel: {}
  },
  setup(e) {
    const t = e, n = R(Tc), o = V(() => t.ancillaries), s = V(() => o.value.slice(0, n.value));
    function a() {
      n.value = Math.min(
        n.value + Tc,
        Object.values(o.value).length
      );
    }
    return (r, i) => (b(), C("section", lZ, [
      d("div", {
        id: r.groupName,
        class: "hotel-accordion-wrapper",
        role: "region",
        "aria-live": "polite"
      }, [
        d("ul", uZ, [
          (b(!0), C($e, null, ke(s.value, (l) => (b(), C("li", {
            class: "spa-list-item",
            key: l.id,
            index: l.id
          }, [
            q(iZ, {
              item: l,
              groupName: r.groupName
            }, null, 8, ["item", "groupName"])
          ], 8, pZ))), 128))
        ])
      ], 8, cZ),
      o.value.length > Tc ? (b(), ie(yy, {
        key: 0,
        end: n.value,
        total: o.value.length,
        loading: !1,
        onLoadMore: a,
        showingTextLabel: r.showingTextLabel
      }, null, 8, ["end", "total", "showingTextLabel"])) : M("", !0)
    ]));
  }
}), dZ = {
  class: "col-lg-9 col-xs-12 spa-col-main",
  "data-test": "ancillary-main"
}, fZ = { class: "sr-only" }, mZ = {
  key: 1,
  class: "ancillary-error"
}, vZ = { class: "h1style" }, Ale = /* @__PURE__ */ K({
  __name: "AncillaryMain",
  props: {
    ancillaries: {},
    ancillariesTermsAndCondition: {},
    pricing: {}
  },
  setup(e) {
    const t = e, n = V(
      () => {
        var l;
        return Object.values(((l = t.ancillaries) == null ? void 0 : l.travelProtections) ?? {});
      }
    ), o = V(
      () => {
        var l;
        return Object.values(((l = t.ancillaries) == null ? void 0 : l.privateTransfers) ?? {});
      }
    ), s = V(
      () => {
        var l;
        return Object.values(((l = t.ancillaries) == null ? void 0 : l.activities) ?? {});
      }
    ), a = V(
      () => {
        var l;
        return Object.values(((l = t.ancillaries) == null ? void 0 : l.mealPlans) ?? {});
      }
    );
    function r(l) {
      return Object.fromEntries(l.map((c) => [c.id, c]));
    }
    const i = V(
      () => {
        var l, c, u, p;
        return ((l = t.ancillaries) == null ? void 0 : l.privateTransfers) || ((c = t.ancillaries) == null ? void 0 : c.mealPlans) || ((u = t.ancillaries) == null ? void 0 : u.travelProtections) || ((p = t.ancillaries) == null ? void 0 : p.activities);
      }
    );
    return (l, c) => (b(), C("main", dZ, [
      d("h1", fZ, k(l.$t("vacvComponents.ancillary.labels.title")), 1),
      i.value ? (b(), C($e, { key: 0 }, [
        n.value.length ? (b(), ie(xr, {
          key: 0,
          title: l.$t("vacvComponents.ancillary.labels.travelProtection"),
          alt: l.$t("vacvComponents.ancillary.labels.travelprotectionNote"),
          groupName: "travelProtections"
        }, {
          default: he(() => [
            q(jY, {
              travelProtections: r(n.value),
              ancillariesTermsAndCondition: l.ancillariesTermsAndCondition,
              groupName: "travelProtections"
            }, null, 8, ["travelProtections", "ancillariesTermsAndCondition"])
          ]),
          _: 1
        }, 8, ["title", "alt"])) : M("", !0),
        o.value.length ? (b(), ie(xr, {
          key: 1,
          title: l.$t("vacvComponents.ancillary.labels.privateTransfer"),
          alt: l.$t("vacvComponents.ancillary.labels.privateTransferNote"),
          groupName: "privateTransfer"
        }, {
          default: he(() => [
            q(Ac, {
              ancillaries: o.value,
              groupName: "privateTransfer"
            }, null, 8, ["ancillaries"])
          ]),
          _: 1
        }, 8, ["title", "alt"])) : M("", !0),
        s.value.length ? (b(), ie(xr, {
          key: 2,
          alwaysRendered: !0,
          title: l.$t("vacvComponents.ancillary.labels.activities"),
          alt: l.$t("vacvComponents.ancillary.labels.activitiesNote"),
          groupName: "activities",
          collapsed: !1
        }, {
          default: he(() => [
            q(Ac, {
              groupName: "activities",
              ancillaries: s.value
            }, null, 8, ["ancillaries"])
          ]),
          _: 1
        }, 8, ["title", "alt"])) : M("", !0),
        a.value.length ? (b(), ie(xr, {
          key: 3,
          alwaysRendered: !0,
          title: l.$t("vacvComponents.ancillary.labels.mealPlan"),
          alt: l.$t("vacvComponents.ancillary.labels.mealPlanNote"),
          groupName: "mealPlans",
          collapsed: !1,
          class: "no-border-bottom"
        }, {
          default: he(() => [
            q(Ac, {
              groupName: "mealPlans",
              ancillaries: a.value,
              showingTextLabel: "vacvComponents.ancillary.labels.showingMealPlanResults"
            }, null, 8, ["ancillaries"])
          ]),
          _: 1
        }, 8, ["title", "alt"])) : M("", !0),
        q(Su)
      ], 64)) : (b(), C("div", mZ, [
        d("h2", vZ, k(l.$t("vacvComponents.ancillary.labels.nothingToDisplay")), 1),
        q(Su)
      ]))
    ]));
  }
}), hZ = {
  "nudge.title": {
    titleText_fr: "Vous recherchez la tranquillité d’esprit?",
    titleText: "Your vacations is not protected "
  },
  "nudge.headline": {
    titleText_fr: "Ajoutez une protection de voyage et profitez d’un voyage sans tracas.",
    titleText: "Add travel protection and enjoy stress-free travel."
  },
  "nudge.refusal": {
    titleText_fr: "Non, je ne veux pas de protection. Non, merci",
    titleText: "No, I don't want travel protection"
  },
  "nudge.cta-label": {
    titleText_fr: "Ajouter à ma réservation",
    titleText: "Add travel protection"
  }
}, gZ = {
  ancillaries: hZ
}, bZ = { class: "tp-nudge-modal-content" }, yZ = { class: "nudge-header" }, $Z = ["innerHTML"], _Z = ["innerHTML"], wZ = { class: "nudge-container" }, CZ = {
  key: 0,
  class: "nudge-recommended"
}, kZ = /* @__PURE__ */ d("i", {
  class: "fa-solid fa-thumbs-up",
  "aria-hidden": "true"
}, null, -1), SZ = { class: "nudge-inclusions" }, TZ = { class: "nudge-item logo" }, AZ = ["src"], DZ = { class: "check" }, PZ = {
  key: 0,
  class: "fa-solid fa-check",
  "aria-hidden": "true"
}, IZ = { class: "sr-only" }, EZ = { class: "nudge-label" }, OZ = { class: "nudge-price-wrapper" }, xZ = { class: "price-amount" }, MZ = { class: "amount" }, LZ = { class: "per" }, NZ = { class: "price-total" }, FZ = { class: "amount" }, RZ = { class: "total-taxes" }, VZ = {
  key: 2,
  class: "nudge-actions"
}, BZ = ["innerHTML"], HZ = /* @__PURE__ */ d("i", {
  class: "fa-solid fa-circle-xmark",
  "aria-hidden": "true"
}, null, -1), UZ = ["innerHTML"], zZ = /* @__PURE__ */ K({
  __name: "TravelProtectionPanel",
  props: {
    paxCount: {},
    total: {},
    travelProtection: {},
    magnoliaDictionaryUrl: {}
  },
  emits: ["withProtection", "withoutProtection"],
  setup(e, { emit: t }) {
    const n = It(), o = e, s = t, a = Ye("cdnBaseUrl"), r = V(
      () => o.total + Object.values(o.travelProtection.subOptions)[0].price * o.paxCount
    ), i = V(() => {
      var w;
      const v = [];
      return Object.values(
        (w = o.travelProtection.inclusions) == null ? void 0 : w.flatMap(
          (y) => v.push(y)
        )
      ), v;
    }), l = (v, w) => {
      var y;
      return (y = v.inclusions) == null ? void 0 : y.find(($) => $.label === w);
    }, c = (v) => {
      s("withProtection", v);
    }, u = () => {
      s("withoutProtection");
    }, p = R(!0);
    async function f() {
      if (o.magnoliaDictionaryUrl)
        try {
          const v = await Ya(
            o.magnoliaDictionaryUrl + "?lang=all",
            "Magnolia Dictionary",
            0,
            !0,
            [],
            1e4
            // 10 second timeout before falling back to the backup file
          );
          m(v);
        } catch {
          g();
        }
      else
        g();
    }
    Re(async () => {
      await f(), p.value = !1;
    });
    function m(v) {
      _.title = h(v, n, "nudge.title"), _.headline = h(v, n, "nudge.headline"), _.refusal = h(v, n, "nudge.refusal"), _.ctaLabel = h(v, n, "nudge.cta-label");
    }
    function h(v, w, y) {
      const $ = v.ancillaries[y], S = w === "fr" ? "titleText_fr" : "titleText", A = $.field, I = $[S];
      return A === "richText" ? decodeURIComponent(I) : I;
    }
    function g() {
      m(gZ);
    }
    const _ = tt({
      title: " ",
      headline: " ",
      refusal: "",
      ctaLabel: ""
    });
    return (v, w) => {
      var y;
      return b(), C("div", bZ, [
        d("hgroup", yZ, [
          d("h2", {
            innerHTML: _.title
          }, null, 8, $Z),
          d("div", {
            class: "nudge-subtitle",
            innerHTML: _.headline
          }, null, 8, _Z)
        ]),
        d("div", wZ, [
          (y = v.travelProtection) != null && y.recommended ? (b(), C("div", CZ, [
            kZ,
            ne(" " + k(v.$t("vacvComponents.ancillary.labels.recommended")), 1)
          ])) : M("", !0),
          d("div", SZ, [
            d("div", TZ, [
              d("img", {
                src: v.travelProtection.icon,
                height: "18",
                alt: ""
              }, null, 8, AZ)
            ]),
            (b(!0), C($e, null, ke(i.value, ($) => (b(), C("div", {
              key: $.label,
              class: "nudge-item"
            }, [
              d("span", DZ, [
                l(v.travelProtection, $.label) ? (b(), C("i", PZ, [
                  d("span", IZ, k(v.$t("vacvComponents.ancillary.access.included")) + " " + k(v.travelProtection.title) + ": " + k($.label), 1)
                ])) : M("", !0)
              ]),
              d("span", EZ, k($.label), 1)
            ]))), 128)),
            d("div", OZ, [
              d("div", xZ, [
                d("span", MZ, " + " + k(v.$n(
                  Object.values(v.travelProtection.subOptions)[0].price,
                  "currency"
                ).replace("CA", "")), 1),
                d("span", LZ, k(v.$t("vacvComponents.ancillary.labels.perTraveller")), 1)
              ]),
              d("div", NZ, [
                d("div", FZ, k(v.$n(r.value, "currency").replace("CA", "")) + " " + k(v.$t("vacvComponents.ancillary.nudge.total")), 1),
                d("div", RZ, k(v.$t("vacvComponents.ancillary.nudge.taxesincl")), 1)
              ])
            ])
          ]),
          p.value ? (b(), ie(sd, {
            key: 1,
            cdnBaseUrl: T(a)
          }, null, 8, ["cdnBaseUrl"])) : M("", !0),
          p.value ? M("", !0) : (b(), C("div", VZ, [
            d("button", {
              class: "vacv-btn-primary",
              onClick: w[0] || (w[0] = ($) => c(v.travelProtection.id))
            }, [
              d("span", {
                innerHTML: _.ctaLabel
              }, null, 8, BZ)
            ]),
            d("button", {
              class: "link linklook",
              onClick: u
            }, [
              HZ,
              d("span", {
                innerHTML: _.refusal
              }, null, 8, UZ)
            ])
          ]))
        ])
      ]);
    };
  }
}), Dle = /* @__PURE__ */ K({
  __name: "TravelProtectionNudge",
  props: {
    isShow: { type: Boolean },
    paxCount: {},
    total: {},
    travelProtection: {},
    magnoliaDictionaryUrl: {}
  },
  emits: ["addTravelProtection"],
  setup(e, { emit: t }) {
    const n = e, o = t, s = R(n.isShow), a = () => {
      r("close");
    }, r = (i) => {
      i ? o("addTravelProtection", i) : o("addTravelProtection"), s.value = !1;
    };
    return le(
      () => n.isShow,
      (i) => {
        s.value = i;
      }
    ), (i, l) => (b(), ie(Qt, {
      onClose: a,
      modelValue: s.value,
      "onUpdate:modelValue": l[0] || (l[0] = (c) => s.value = c),
      class: "vacv-modal modal-fullscreen vacv-modal-centered tp-nudge"
    }, {
      default: he(() => [
        q(zZ, {
          paxCount: i.paxCount,
          total: i.total,
          travelProtection: i.travelProtection,
          magnoliaDictionaryUrl: i.magnoliaDictionaryUrl,
          onWithProtection: r,
          onWithoutProtection: r
        }, null, 8, ["paxCount", "total", "travelProtection", "magnoliaDictionaryUrl"])
      ]),
      _: 1
    }, 8, ["modelValue"]));
  }
}), WZ = 8, jZ = "Basic preview", qZ = {
  "openmaptiles:version": "3.x"
}, KZ = {
  openmaptiles: {
    type: "vector",
    url: "http://ec2-3-98-104-177.ca-central-1.compute.amazonaws.com:8090/data/v3.json"
  }
}, YZ = "http://ec2-3-98-104-177.ca-central-1.compute.amazonaws.com:8090/fonts/{fontstack}/{range}.pbf", GZ = [
  {
    id: "background",
    paint: {
      "background-color": "hsl(47, 26%, 88%)"
    },
    type: "background"
  },
  {
    filter: [
      "all",
      [
        "==",
        "$type",
        "Polygon"
      ],
      [
        "in",
        "class",
        "residential",
        "suburb",
        "neighbourhood"
      ]
    ],
    id: "landuse-residential",
    paint: {
      "fill-color": "hsl(47, 13%, 86%)",
      "fill-opacity": 0.7
    },
    source: "openmaptiles",
    "source-layer": "landuse",
    type: "fill"
  },
  {
    filter: [
      "==",
      "class",
      "grass"
    ],
    id: "landcover_grass",
    paint: {
      "fill-color": "hsl(82, 46%, 72%)",
      "fill-opacity": 0.45
    },
    source: "openmaptiles",
    "source-layer": "landcover",
    type: "fill"
  },
  {
    filter: [
      "==",
      "class",
      "wood"
    ],
    id: "landcover_wood",
    paint: {
      "fill-color": "hsl(82, 46%, 72%)",
      "fill-opacity": {
        base: 1,
        stops: [
          [
            8,
            0.6
          ],
          [
            22,
            1
          ]
        ]
      }
    },
    source: "openmaptiles",
    "source-layer": "landcover",
    type: "fill"
  },
  {
    filter: [
      "all",
      [
        "==",
        "$type",
        "Polygon"
      ],
      [
        "!=",
        "intermittent",
        1
      ]
    ],
    id: "water",
    paint: {
      "fill-color": "hsl(205, 56%, 73%)"
    },
    source: "openmaptiles",
    "source-layer": "water",
    type: "fill"
  },
  {
    filter: [
      "all",
      [
        "==",
        "$type",
        "Polygon"
      ],
      [
        "==",
        "intermittent",
        1
      ]
    ],
    id: "water_intermittent",
    paint: {
      "fill-color": "hsl(205, 56%, 73%)",
      "fill-opacity": 0.7
    },
    source: "openmaptiles",
    "source-layer": "water",
    type: "fill"
  },
  {
    filter: [
      "==",
      "subclass",
      "ice_shelf"
    ],
    id: "landcover-ice-shelf",
    paint: {
      "fill-color": "hsl(47, 26%, 88%)",
      "fill-opacity": 0.8
    },
    source: "openmaptiles",
    "source-layer": "landcover",
    type: "fill"
  },
  {
    filter: [
      "==",
      "subclass",
      "glacier"
    ],
    id: "landcover-glacier",
    paint: {
      "fill-color": "hsl(47, 22%, 94%)",
      "fill-opacity": {
        base: 1,
        stops: [
          [
            0,
            1
          ],
          [
            8,
            0.5
          ]
        ]
      }
    },
    source: "openmaptiles",
    "source-layer": "landcover",
    type: "fill"
  },
  {
    filter: [
      "all",
      [
        "in",
        "class",
        "sand"
      ]
    ],
    id: "landcover_sand",
    metadata: {},
    paint: {
      "fill-antialias": !1,
      "fill-color": "rgba(232, 214, 38, 1)",
      "fill-opacity": 0.3
    },
    source: "openmaptiles",
    "source-layer": "landcover",
    type: "fill"
  },
  {
    filter: [
      "==",
      "class",
      "agriculture"
    ],
    id: "landuse",
    paint: {
      "fill-color": "#eae0d0"
    },
    source: "openmaptiles",
    "source-layer": "landuse",
    type: "fill"
  },
  {
    filter: [
      "==",
      "class",
      "national_park"
    ],
    id: "landuse_overlay_national_park",
    paint: {
      "fill-color": "#E1EBB0",
      "fill-opacity": {
        base: 1,
        stops: [
          [
            5,
            0
          ],
          [
            9,
            0.75
          ]
        ]
      }
    },
    source: "openmaptiles",
    "source-layer": "landcover",
    type: "fill"
  },
  {
    filter: [
      "all",
      [
        "==",
        "$type",
        "LineString"
      ],
      [
        "==",
        "brunnel",
        "tunnel"
      ]
    ],
    id: "waterway-tunnel",
    paint: {
      "line-color": "hsl(205, 56%, 73%)",
      "line-dasharray": [
        3,
        3
      ],
      "line-gap-width": {
        stops: [
          [
            12,
            0
          ],
          [
            20,
            6
          ]
        ]
      },
      "line-opacity": 1,
      "line-width": {
        base: 1.4,
        stops: [
          [
            8,
            1
          ],
          [
            20,
            2
          ]
        ]
      }
    },
    source: "openmaptiles",
    "source-layer": "waterway",
    type: "line"
  },
  {
    filter: [
      "all",
      [
        "==",
        "$type",
        "LineString"
      ],
      [
        "!in",
        "brunnel",
        "tunnel",
        "bridge"
      ],
      [
        "!=",
        "intermittent",
        1
      ]
    ],
    id: "waterway",
    paint: {
      "line-color": "hsl(205, 56%, 73%)",
      "line-opacity": 1,
      "line-width": {
        base: 1.4,
        stops: [
          [
            8,
            1
          ],
          [
            20,
            8
          ]
        ]
      }
    },
    source: "openmaptiles",
    "source-layer": "waterway",
    type: "line"
  },
  {
    filter: [
      "all",
      [
        "==",
        "$type",
        "LineString"
      ],
      [
        "!in",
        "brunnel",
        "tunnel",
        "bridge"
      ],
      [
        "==",
        "intermittent",
        1
      ]
    ],
    id: "waterway_intermittent",
    paint: {
      "line-color": "hsl(205, 56%, 73%)",
      "line-opacity": 1,
      "line-width": {
        base: 1.4,
        stops: [
          [
            8,
            1
          ],
          [
            20,
            8
          ]
        ]
      },
      "line-dasharray": [
        2,
        1
      ]
    },
    source: "openmaptiles",
    "source-layer": "waterway",
    type: "line"
  },
  {
    filter: [
      "all",
      [
        "==",
        "$type",
        "LineString"
      ],
      [
        "==",
        "brunnel",
        "tunnel"
      ],
      [
        "==",
        "class",
        "transit"
      ]
    ],
    id: "tunnel_railway_transit",
    layout: {
      "line-cap": "butt",
      "line-join": "miter"
    },
    minzoom: 0,
    paint: {
      "line-color": "hsl(34, 12%, 66%)",
      "line-dasharray": [
        3,
        3
      ],
      "line-opacity": {
        base: 1,
        stops: [
          [
            11,
            0
          ],
          [
            16,
            1
          ]
        ]
      }
    },
    source: "openmaptiles",
    "source-layer": "transportation",
    type: "line"
  },
  {
    id: "building",
    paint: {
      "fill-antialias": !0,
      "fill-color": "rgba(222, 211, 190, 1)",
      "fill-opacity": {
        base: 1,
        stops: [
          [
            13,
            0
          ],
          [
            15,
            1
          ]
        ]
      },
      "fill-outline-color": {
        stops: [
          [
            15,
            "rgba(212, 177, 146, 0)"
          ],
          [
            16,
            "rgba(212, 177, 146, 0.5)"
          ]
        ]
      }
    },
    source: "openmaptiles",
    "source-layer": "building",
    type: "fill"
  },
  {
    filter: [
      "==",
      "$type",
      "Point"
    ],
    id: "housenumber",
    layout: {
      "text-field": "{housenumber}",
      "text-font": [
        "Noto Sans Regular"
      ],
      "text-size": 10
    },
    minzoom: 17,
    paint: {
      "text-color": "rgba(212, 177, 146, 1)"
    },
    source: "openmaptiles",
    "source-layer": "housenumber",
    type: "symbol"
  },
  {
    id: "road_area_pier",
    type: "fill",
    metadata: {},
    source: "openmaptiles",
    "source-layer": "transportation",
    filter: [
      "all",
      [
        "==",
        "$type",
        "Polygon"
      ],
      [
        "==",
        "class",
        "pier"
      ]
    ],
    paint: {
      "fill-color": "hsl(47, 26%, 88%)",
      "fill-antialias": !0
    }
  },
  {
    id: "road_pier",
    type: "line",
    metadata: {},
    source: "openmaptiles",
    "source-layer": "transportation",
    filter: [
      "all",
      [
        "==",
        "$type",
        "LineString"
      ],
      [
        "in",
        "class",
        "pier"
      ]
    ],
    layout: {
      "line-cap": "round",
      "line-join": "round"
    },
    paint: {
      "line-color": "hsl(47, 26%, 88%)",
      "line-width": {
        base: 1.2,
        stops: [
          [
            15,
            1
          ],
          [
            17,
            4
          ]
        ]
      }
    }
  },
  {
    filter: [
      "all",
      [
        "==",
        "$type",
        "Polygon"
      ],
      [
        "in",
        "brunnel",
        "bridge"
      ]
    ],
    id: "road_bridge_area",
    layout: {},
    paint: {
      "fill-color": "hsl(47, 26%, 88%)",
      "fill-opacity": 0.5
    },
    source: "openmaptiles",
    "source-layer": "transportation",
    type: "fill"
  },
  {
    filter: [
      "all",
      [
        "==",
        "$type",
        "LineString"
      ],
      [
        "in",
        "class",
        "path",
        "track"
      ]
    ],
    id: "road_path",
    layout: {
      "line-cap": "square",
      "line-join": "bevel"
    },
    paint: {
      "line-color": "hsl(0, 0%, 97%)",
      "line-dasharray": [
        1,
        1
      ],
      "line-width": {
        base: 1.55,
        stops: [
          [
            4,
            0.25
          ],
          [
            20,
            10
          ]
        ]
      }
    },
    source: "openmaptiles",
    "source-layer": "transportation",
    type: "line"
  },
  {
    filter: [
      "all",
      [
        "==",
        "$type",
        "LineString"
      ],
      [
        "in",
        "class",
        "minor",
        "service"
      ]
    ],
    id: "road_minor",
    layout: {
      "line-cap": "round",
      "line-join": "round"
    },
    paint: {
      "line-color": "hsl(0, 0%, 97%)",
      "line-width": {
        base: 1.55,
        stops: [
          [
            4,
            0.25
          ],
          [
            20,
            30
          ]
        ]
      }
    },
    source: "openmaptiles",
    "source-layer": "transportation",
    type: "line",
    minzoom: 13
  },
  {
    filter: [
      "all",
      [
        "==",
        "$type",
        "LineString"
      ],
      [
        "==",
        "brunnel",
        "tunnel"
      ],
      [
        "==",
        "class",
        "minor_road"
      ]
    ],
    id: "tunnel_minor",
    layout: {
      "line-cap": "butt",
      "line-join": "miter"
    },
    paint: {
      "line-color": "#efefef",
      "line-dasharray": [
        0.36,
        0.18
      ],
      "line-width": {
        base: 1.55,
        stops: [
          [
            4,
            0.25
          ],
          [
            20,
            30
          ]
        ]
      }
    },
    source: "openmaptiles",
    "source-layer": "transportation",
    type: "line"
  },
  {
    filter: [
      "all",
      [
        "==",
        "$type",
        "LineString"
      ],
      [
        "==",
        "brunnel",
        "tunnel"
      ],
      [
        "in",
        "class",
        "primary",
        "secondary",
        "tertiary",
        "trunk"
      ]
    ],
    id: "tunnel_major",
    layout: {
      "line-cap": "butt",
      "line-join": "miter"
    },
    paint: {
      "line-color": "#fff",
      "line-dasharray": [
        0.28,
        0.14
      ],
      "line-width": {
        base: 1.4,
        stops: [
          [
            6,
            0.5
          ],
          [
            20,
            30
          ]
        ]
      }
    },
    source: "openmaptiles",
    "source-layer": "transportation",
    type: "line"
  },
  {
    filter: [
      "all",
      [
        "==",
        "$type",
        "Polygon"
      ],
      [
        "in",
        "class",
        "runway",
        "taxiway"
      ]
    ],
    id: "aeroway-area",
    metadata: {
      "mapbox:group": "1444849345966.4436"
    },
    minzoom: 4,
    paint: {
      "fill-color": "rgba(255, 255, 255, 1)",
      "fill-opacity": {
        base: 1,
        stops: [
          [
            13,
            0
          ],
          [
            14,
            1
          ]
        ]
      }
    },
    source: "openmaptiles",
    "source-layer": "aeroway",
    type: "fill"
  },
  {
    filter: [
      "all",
      [
        "in",
        "class",
        "taxiway"
      ],
      [
        "==",
        "$type",
        "LineString"
      ]
    ],
    id: "aeroway-taxiway",
    layout: {
      "line-cap": "round",
      "line-join": "round"
    },
    metadata: {
      "mapbox:group": "1444849345966.4436"
    },
    minzoom: 12,
    paint: {
      "line-color": "rgba(255, 255, 255, 1)",
      "line-opacity": 1,
      "line-width": {
        base: 1.5,
        stops: [
          [
            12,
            1
          ],
          [
            17,
            10
          ]
        ]
      }
    },
    source: "openmaptiles",
    "source-layer": "aeroway",
    type: "line"
  },
  {
    filter: [
      "all",
      [
        "in",
        "class",
        "runway"
      ],
      [
        "==",
        "$type",
        "LineString"
      ]
    ],
    id: "aeroway-runway",
    layout: {
      "line-cap": "round",
      "line-join": "round"
    },
    metadata: {
      "mapbox:group": "1444849345966.4436"
    },
    minzoom: 4,
    paint: {
      "line-color": "rgba(255, 255, 255, 1)",
      "line-opacity": 1,
      "line-width": {
        base: 1.5,
        stops: [
          [
            11,
            4
          ],
          [
            17,
            50
          ]
        ]
      }
    },
    source: "openmaptiles",
    "source-layer": "aeroway",
    type: "line"
  },
  {
    filter: [
      "all",
      [
        "==",
        "$type",
        "LineString"
      ],
      [
        "in",
        "class",
        "trunk",
        "primary"
      ]
    ],
    id: "road_trunk_primary",
    layout: {
      "line-cap": "round",
      "line-join": "round"
    },
    paint: {
      "line-color": "#fff",
      "line-width": {
        base: 1.4,
        stops: [
          [
            6,
            0.5
          ],
          [
            20,
            30
          ]
        ]
      }
    },
    source: "openmaptiles",
    "source-layer": "transportation",
    type: "line"
  },
  {
    filter: [
      "all",
      [
        "==",
        "$type",
        "LineString"
      ],
      [
        "in",
        "class",
        "secondary",
        "tertiary"
      ]
    ],
    id: "road_secondary_tertiary",
    layout: {
      "line-cap": "round",
      "line-join": "round"
    },
    paint: {
      "line-color": "#fff",
      "line-width": {
        base: 1.4,
        stops: [
          [
            6,
            0.5
          ],
          [
            20,
            20
          ]
        ]
      }
    },
    source: "openmaptiles",
    "source-layer": "transportation",
    type: "line"
  },
  {
    filter: [
      "all",
      [
        "==",
        "$type",
        "LineString"
      ],
      [
        "==",
        "class",
        "motorway"
      ]
    ],
    id: "road_major_motorway",
    layout: {
      "line-cap": "round",
      "line-join": "round"
    },
    paint: {
      "line-color": "hsl(0, 0%, 100%)",
      "line-offset": 0,
      "line-width": {
        base: 1.4,
        stops: [
          [
            8,
            1
          ],
          [
            16,
            10
          ]
        ]
      }
    },
    source: "openmaptiles",
    "source-layer": "transportation",
    type: "line"
  },
  {
    filter: [
      "all",
      [
        "==",
        "class",
        "transit"
      ],
      [
        "!=",
        "brunnel",
        "tunnel"
      ]
    ],
    id: "railway-transit",
    paint: {
      "line-color": "hsl(34, 12%, 66%)",
      "line-opacity": {
        base: 1,
        stops: [
          [
            11,
            0
          ],
          [
            16,
            1
          ]
        ]
      }
    },
    source: "openmaptiles",
    "source-layer": "transportation",
    type: "line"
  },
  {
    filter: [
      "==",
      "class",
      "rail"
    ],
    id: "railway",
    paint: {
      "line-color": "hsl(34, 12%, 66%)",
      "line-opacity": {
        base: 1,
        stops: [
          [
            11,
            0
          ],
          [
            16,
            1
          ]
        ]
      }
    },
    source: "openmaptiles",
    "source-layer": "transportation",
    type: "line"
  },
  {
    filter: [
      "all",
      [
        "==",
        "$type",
        "LineString"
      ],
      [
        "==",
        "brunnel",
        "bridge"
      ]
    ],
    id: "waterway-bridge-case",
    layout: {
      "line-cap": "butt",
      "line-join": "miter"
    },
    paint: {
      "line-color": "#bbbbbb",
      "line-gap-width": {
        base: 1.55,
        stops: [
          [
            4,
            0.25
          ],
          [
            20,
            30
          ]
        ]
      },
      "line-width": {
        base: 1.6,
        stops: [
          [
            12,
            0.5
          ],
          [
            20,
            10
          ]
        ]
      }
    },
    source: "openmaptiles",
    "source-layer": "waterway",
    type: "line"
  },
  {
    filter: [
      "all",
      [
        "==",
        "$type",
        "LineString"
      ],
      [
        "==",
        "brunnel",
        "bridge"
      ]
    ],
    id: "waterway-bridge",
    layout: {
      "line-cap": "round",
      "line-join": "round"
    },
    paint: {
      "line-color": "hsl(205, 56%, 73%)",
      "line-width": {
        base: 1.55,
        stops: [
          [
            4,
            0.25
          ],
          [
            20,
            30
          ]
        ]
      }
    },
    source: "openmaptiles",
    "source-layer": "waterway",
    type: "line"
  },
  {
    filter: [
      "all",
      [
        "==",
        "$type",
        "LineString"
      ],
      [
        "==",
        "brunnel",
        "bridge"
      ],
      [
        "==",
        "class",
        "minor_road"
      ]
    ],
    id: "bridge_minor case",
    layout: {
      "line-cap": "butt",
      "line-join": "miter"
    },
    paint: {
      "line-color": "#dedede",
      "line-gap-width": {
        base: 1.55,
        stops: [
          [
            4,
            0.25
          ],
          [
            20,
            30
          ]
        ]
      },
      "line-width": {
        base: 1.6,
        stops: [
          [
            12,
            0.5
          ],
          [
            20,
            10
          ]
        ]
      }
    },
    source: "openmaptiles",
    "source-layer": "transportation",
    type: "line"
  },
  {
    filter: [
      "all",
      [
        "==",
        "$type",
        "LineString"
      ],
      [
        "==",
        "brunnel",
        "bridge"
      ],
      [
        "in",
        "class",
        "primary",
        "secondary",
        "tertiary",
        "trunk"
      ]
    ],
    id: "bridge_major case",
    layout: {
      "line-cap": "butt",
      "line-join": "miter"
    },
    paint: {
      "line-color": "#dedede",
      "line-gap-width": {
        base: 1.55,
        stops: [
          [
            4,
            0.25
          ],
          [
            20,
            30
          ]
        ]
      },
      "line-width": {
        base: 1.6,
        stops: [
          [
            12,
            0.5
          ],
          [
            20,
            10
          ]
        ]
      }
    },
    source: "openmaptiles",
    "source-layer": "transportation",
    type: "line"
  },
  {
    filter: [
      "all",
      [
        "==",
        "$type",
        "LineString"
      ],
      [
        "==",
        "brunnel",
        "bridge"
      ],
      [
        "==",
        "class",
        "minor_road"
      ]
    ],
    id: "bridge_minor",
    layout: {
      "line-cap": "round",
      "line-join": "round"
    },
    paint: {
      "line-color": "#efefef",
      "line-width": {
        base: 1.55,
        stops: [
          [
            4,
            0.25
          ],
          [
            20,
            30
          ]
        ]
      }
    },
    source: "openmaptiles",
    "source-layer": "transportation",
    type: "line"
  },
  {
    filter: [
      "all",
      [
        "==",
        "$type",
        "LineString"
      ],
      [
        "==",
        "brunnel",
        "bridge"
      ],
      [
        "in",
        "class",
        "primary",
        "secondary",
        "tertiary",
        "trunk"
      ]
    ],
    id: "bridge_major",
    layout: {
      "line-cap": "round",
      "line-join": "round"
    },
    paint: {
      "line-color": "#fff",
      "line-width": {
        base: 1.4,
        stops: [
          [
            6,
            0.5
          ],
          [
            20,
            30
          ]
        ]
      }
    },
    source: "openmaptiles",
    "source-layer": "transportation",
    type: "line"
  },
  {
    filter: [
      "in",
      "admin_level",
      4,
      6,
      8
    ],
    id: "admin_sub",
    paint: {
      "line-color": "hsla(0, 0%, 60%, 0.5)",
      "line-dasharray": [
        2,
        1
      ]
    },
    source: "openmaptiles",
    "source-layer": "boundary",
    type: "line"
  },
  {
    filter: [
      "all",
      [
        "<=",
        "admin_level",
        2
      ],
      [
        "==",
        "$type",
        "LineString"
      ]
    ],
    id: "admin_country",
    layout: {
      "line-cap": "round",
      "line-join": "round"
    },
    paint: {
      "line-color": "hsl(0, 0%, 60%)",
      "line-width": {
        base: 1.3,
        stops: [
          [
            3,
            0.5
          ],
          [
            22,
            15
          ]
        ]
      }
    },
    source: "openmaptiles",
    "source-layer": "boundary",
    type: "line"
  },
  {
    filter: [
      "all",
      [
        "==",
        "$type",
        "Point"
      ],
      [
        "==",
        "rank",
        1
      ]
    ],
    id: "poi_label",
    layout: {
      "icon-size": 1,
      "text-anchor": "top",
      "text-field": "{name}",
      "text-font": [
        "Noto Sans Regular"
      ],
      "text-max-width": 8,
      "text-offset": [
        0,
        0.5
      ],
      "text-size": 11
    },
    minzoom: 14,
    paint: {
      "text-color": "#666",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(255,255,255,0.75)",
      "text-halo-width": 1
    },
    source: "openmaptiles",
    "source-layer": "poi",
    type: "symbol"
  },
  {
    filter: [
      "all",
      [
        "has",
        "iata"
      ]
    ],
    id: "airport-label",
    layout: {
      "icon-size": 1,
      "text-anchor": "top",
      "text-field": "{name}",
      "text-font": [
        "Noto Sans Regular"
      ],
      "text-max-width": 8,
      "text-offset": [
        0,
        0.5
      ],
      "text-size": 11
    },
    minzoom: 10,
    paint: {
      "text-color": "#666",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(255,255,255,0.75)",
      "text-halo-width": 1
    },
    source: "openmaptiles",
    "source-layer": "aerodrome_label",
    type: "symbol"
  },
  {
    filter: [
      "==",
      "$type",
      "LineString"
    ],
    id: "road_major_label",
    layout: {
      "symbol-placement": "line",
      "text-field": "{name}",
      "text-font": [
        "Noto Sans Regular"
      ],
      "text-letter-spacing": 0.1,
      "text-rotation-alignment": "map",
      "text-size": {
        base: 1.4,
        stops: [
          [
            10,
            8
          ],
          [
            20,
            14
          ]
        ]
      },
      "text-transform": "uppercase"
    },
    paint: {
      "text-color": "#000",
      "text-halo-color": "hsl(0, 0%, 100%)",
      "text-halo-width": 2
    },
    source: "openmaptiles",
    "source-layer": "transportation_name",
    type: "symbol"
  },
  {
    filter: [
      "all",
      [
        "==",
        "$type",
        "Point"
      ],
      [
        "!in",
        "class",
        "city",
        "state",
        "country",
        "continent"
      ]
    ],
    id: "place_label_other",
    layout: {
      "text-anchor": "center",
      "text-field": "{name}",
      "text-font": [
        "Noto Sans Regular"
      ],
      "text-max-width": 6,
      "text-size": {
        stops: [
          [
            6,
            10
          ],
          [
            12,
            14
          ]
        ]
      }
    },
    minzoom: 8,
    paint: {
      "text-color": "hsl(0, 0%, 25%)",
      "text-halo-blur": 0,
      "text-halo-color": "hsl(0, 0%, 100%)",
      "text-halo-width": 2
    },
    source: "openmaptiles",
    "source-layer": "place",
    type: "symbol"
  },
  {
    filter: [
      "all",
      [
        "==",
        "$type",
        "Point"
      ],
      [
        "==",
        "class",
        "city"
      ]
    ],
    id: "place_label_city",
    layout: {
      "text-field": "{name}",
      "text-font": [
        "Noto Sans Regular"
      ],
      "text-max-width": 10,
      "text-size": {
        stops: [
          [
            3,
            12
          ],
          [
            8,
            16
          ]
        ]
      }
    },
    maxzoom: 16,
    paint: {
      "text-color": "hsl(0, 0%, 0%)",
      "text-halo-blur": 0,
      "text-halo-color": "hsla(0, 0%, 100%, 0.75)",
      "text-halo-width": 2
    },
    source: "openmaptiles",
    "source-layer": "place",
    type: "symbol"
  },
  {
    filter: [
      "all",
      [
        "==",
        "$type",
        "Point"
      ],
      [
        "==",
        "class",
        "country"
      ],
      [
        "!has",
        "iso_a2"
      ]
    ],
    id: "country_label-other",
    layout: {
      "text-field": "{name:latin}",
      "text-font": [
        "Noto Sans Regular"
      ],
      "text-max-width": 10,
      "text-size": {
        stops: [
          [
            3,
            12
          ],
          [
            8,
            22
          ]
        ]
      }
    },
    maxzoom: 12,
    paint: {
      "text-color": "hsl(0, 0%, 13%)",
      "text-halo-blur": 0,
      "text-halo-color": "rgba(255,255,255,0.75)",
      "text-halo-width": 2
    },
    source: "openmaptiles",
    "source-layer": "place",
    type: "symbol"
  },
  {
    filter: [
      "all",
      [
        "==",
        "$type",
        "Point"
      ],
      [
        "==",
        "class",
        "country"
      ],
      [
        "has",
        "iso_a2"
      ]
    ],
    id: "country_label",
    layout: {
      "text-field": "{name:latin}",
      "text-font": [
        "Noto Sans Regular"
      ],
      "text-max-width": 10,
      "text-size": {
        stops: [
          [
            3,
            12
          ],
          [
            8,
            22
          ]
        ]
      }
    },
    maxzoom: 12,
    paint: {
      "text-color": "hsl(0, 0%, 13%)",
      "text-halo-blur": 0,
      "text-halo-color": "rgba(255,255,255,0.75)",
      "text-halo-width": 2
    },
    source: "openmaptiles",
    "source-layer": "place",
    type: "symbol"
  },
  {
    id: "restaurant_label",
    filter: [
      "all",
      [
        "==",
        "$type",
        "Point"
      ],
      [
        "==",
        "class",
        "restaurant"
      ]
    ],
    layout: {
      "icon-image": "restaurant-icon",
      "icon-size": 1,
      "text-anchor": "top",
      "text-field": "{name}",
      "text-font": [
        "Noto Sans Regular"
      ],
      "text-max-width": 8,
      "text-offset": [
        0,
        0.5
      ],
      "text-size": 11
    },
    minzoom: 14,
    paint: {
      "text-color": "#666",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(255,255,255,0.75)",
      "text-halo-width": 1
    },
    source: "openmaptiles",
    "source-layer": "poi",
    type: "symbol"
  },
  {
    id: "cafe_label",
    filter: [
      "all",
      [
        "==",
        "$type",
        "Point"
      ],
      [
        "==",
        "class",
        "cafe"
      ]
    ],
    layout: {
      "icon-image": "cafe-icon",
      "icon-size": 1,
      "text-anchor": "top",
      "text-field": "{name}",
      "text-font": [
        "Noto Sans Regular"
      ],
      "text-max-width": 8,
      "text-offset": [
        0,
        0.5
      ],
      "text-size": 11
    },
    minzoom: 14,
    paint: {
      "text-color": "#666",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(255,255,255,0.75)",
      "text-halo-width": 1
    },
    source: "openmaptiles",
    "source-layer": "poi",
    type: "symbol"
  },
  {
    id: "bar_label",
    filter: [
      "all",
      [
        "==",
        "$type",
        "Point"
      ],
      [
        "==",
        "class",
        "bar"
      ]
    ],
    layout: {
      "icon-image": "bar-icon",
      "icon-size": 1,
      "text-anchor": "top",
      "text-field": "{name}",
      "text-font": [
        "Noto Sans Regular"
      ],
      "text-max-width": 8,
      "text-offset": [
        0,
        0.5
      ],
      "text-size": 11
    },
    minzoom: 14,
    paint: {
      "text-color": "red",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(255,255,255,0.75)",
      "text-halo-width": 1
    },
    source: "openmaptiles",
    "source-layer": "poi",
    type: "symbol"
  }
], ZZ = "basic-preview", XZ = {
  version: WZ,
  name: jZ,
  metadata: qZ,
  sources: KZ,
  glyphs: YZ,
  layers: GZ,
  id: ZZ
}, JZ = {
  key: 0,
  id: "map-wrapper"
}, QZ = { class: "map-heading" }, Em = 14, eX = /* @__PURE__ */ K({
  __name: "VacationsMap",
  props: {
    cdnBaseUrl: {},
    hotels: {},
    totalHotels: {},
    lang: {}
  },
  setup(e) {
    const t = e, n = R(), o = R(), s = R(!0), a = Array.isArray(t.hotels) ? t.hotels.length : 1, r = t.hotels, i = Array.isArray(r) ? r[0] : r;
    function l(f) {
      var _, v, w, y;
      const m = parseFloat((_ = i.location) == null ? void 0 : _.latitude), h = parseFloat((v = i.location) == null ? void 0 : v.longitude), g = new io.Map({
        container: f,
        // @ts-expect-error: TypeScript struggles with literal types
        style: XZ,
        // this should point to your JSON style file
        zoom: Em,
        center: [h, m]
        // will be overwritten
      });
      if (Array.isArray(r)) {
        const $ = new io.LngLatBounds();
        r.forEach((S) => {
          var D, O, x, F, P;
          const A = parseFloat((D = S.location) == null ? void 0 : D.latitude), I = parseFloat((O = S.location) == null ? void 0 : O.longitude);
          $.extend([I, A]), new io.Marker({
            element: c(S.name, S.starCategory, "$1,234")
          }).setLngLat([I, A]).setPopup(
            new io.Popup().setHTML(`
            <div style="font-family: sans-serif; max-width: 200px;">
              <img src="${(P = (F = (x = S.media) == null ? void 0 : x.images) == null ? void 0 : F[0].url) == null ? void 0 : P.replace("{VARIATION}", "square").replace("{SIZE}", "300x")}" alt="${S.name}"
                style="max-width: 180px; border-radius: 6px; margin-bottom: 8px;" />
              <div style="font-weight: bold; margin-bottom: 4px;"><h3>${S.name}</h3></div>
              <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 4px;">
                <div style="color: gold; font-size: 14px;">
                  ${"★".repeat(S.starCategory)}${"☆".repeat(5 - S.starCategory)}
                </div>
                <div style="color: #2e8b57; font-weight: bold;">
                  $1,234
                </div>
              </div>
            </div>
          `)
          ).addTo(g);
        }), g.fitBounds($, { padding: 50 });
      } else {
        const $ = parseFloat((w = r.location) == null ? void 0 : w.latitude), S = parseFloat((y = r.location) == null ? void 0 : y.longitude);
        new io.Marker({
          element: c(
            r.name,
            r.starCategory,
            "$1,234"
          )
        }).setLngLat([S, $]).setPopup(
          new io.Popup().setHTML(`<h4>${r.name}</h4>`)
        ).addTo(g), g.setCenter([S, $]), g.setZoom(Em);
      }
      return g.addControl(new io.NavigationControl(), "top-left"), g.addControl(
        new io.FullscreenControl({
          container: f
        }),
        "top-left"
      ), g.on("fullscreenchange", () => {
        t.hotels && !Array.isArray(t.hotels) && Jb(t.hotels.name, t.hotels.destination);
      }), g.on("style.load", () => {
        g.loadImage("/icons/bar-24.png", ($, S) => {
          S && (g.addImage("bar-icon", S), g.setLayoutProperty("bar_label", "icon-image", "bar-icon"), g.setLayoutProperty("bar_label", "icon-size", 1));
        }), g.loadImage("/icons/cafe-24.png", ($, S) => {
          S && (g.addImage("cafe-icon", S), g.setLayoutProperty("cafe_label", "icon-image", "cafe-icon"), g.setLayoutProperty("restaurant_label", "icon-size", 1));
        }), g.loadImage("/icons/restaurant-24.png", ($, S) => {
          S && (g.addImage("restaurant-icon", S), g.setLayoutProperty(
            "restaurant_label",
            "icon-image",
            "restaurant-icon"
          ), g.setLayoutProperty("restaurant_label", "icon-size", 1));
        }), g.getStyle().layers.forEach(($) => {
          $.type === "symbol" && $.layout && $.layout["text-field"] && g.setLayoutProperty($.id, "text-field", [
            "coalesce",
            ["get", `name:${t.lang}`],
            ["get", "name"]
          ]);
        });
      }), g;
    }
    function c(f, m, h) {
      const g = document.createElement("div");
      g.style.display = "flex", g.style.flexDirection = "column", g.style.alignItems = "center";
      const _ = document.createElement("img");
      _.src = "/icons/location-48.png", _.style.width = "32px", _.style.height = "32px";
      const v = document.createElement("div");
      v.style.fontSize = "11px", v.style.color = "#fff", v.style.backgroundColor = "rgba(0, 0, 0, 0.6)", v.style.padding = "2px 6px", v.style.borderRadius = "4px", v.style.marginTop = "4px", v.style.textAlign = "center", v.style.whiteSpace = "nowrap", v.style.maxWidth = "120px", v.style.overflow = "hidden", v.style.textOverflow = "ellipsis";
      const w = document.createElement("div");
      w.textContent = f, w.style.fontWeight = "bold", v.appendChild(w);
      const y = document.createElement("div");
      y.textContent = "★".repeat(m) + "☆".repeat(5 - m), y.style.color = "#ffd700", y.style.fontSize = "10px", y.style.marginTop = "2px", v.appendChild(y);
      const $ = document.createElement("div");
      return $.textContent = `$${(parseFloat(h.replace("$", "").replace(",", "")) * (1 + (Math.random() * 0.1 - 0.05))).toFixed(0)}`, $.style.color = "#fff", $.style.fontSize = "10px", $.style.fontWeight = "bold", $.style.marginTop = "2px", v.appendChild($), g.appendChild(_), g.appendChild(v), g;
    }
    function u() {
      n.value && (n.value.remove(), n.value = void 0);
    }
    const p = new IntersectionObserver(
      (f) => {
        f[0].isIntersecting && o.value ? (u(), n.value = l(o.value)) : u();
      },
      { threshold: [0.9] }
    );
    return Re(() => {
      o.value && p.observe(o.value);
    }), Jt(() => {
      p.disconnect(), u();
    }), (f, m) => (b(), ie(st, { name: "slide" }, {
      default: he(() => [
        s.value ? (b(), C("div", JZ, [
          d("h3", QZ, " Showing " + k(T(a)) + " of " + k(t.totalHotels) + " hotel" + k(T(a) > 1 ? "s" : "") + " found in " + k(T(i).destination), 1),
          d("div", {
            class: "map-height",
            ref_key: "mapElement",
            ref: o
          }, null, 512)
        ])) : M("", !0)
      ]),
      _: 1
    }));
  }
}), Ple = /* @__PURE__ */ De(eX, [["__scopeId", "data-v-060df0d5"]]), cd = function(e, t) {
  return t ? e.value !== !1 : e.value === !1;
};
cd.skipEmpty = !1;
cd.force = !0;
const tX = (e, t, n) => {
  const o = "-", s = e.value.split(o).reverse().join(""), a = t.split(o).reverse().join(""), r = n.split(o).reverse().join("");
  return s >= a && s <= r;
};
function Ile() {
  const e = R(!1), t = R(0), n = un(), { dollarPerUnitPoints: o } = Ce(n), {
    setUnitPoint: s,
    setDollarPerUnitPoints: a,
    setWasDollarPerUnitPoints: r,
    setShowAeroplanRedeem: i
  } = n;
  async function l(h, g, _, v) {
    await u();
    const w = c(h, g, _), y = await p(w, v);
    y && (f(y), m() && i(!0));
  }
  function c(h, g, _) {
    var $, S;
    const v = new URLSearchParams(window.location.search), w = ($ = v.get(g)) == null ? void 0 : $.toString(), y = (S = v.get(_)) == null ? void 0 : S.toString();
    return {
      pointsApplied: 5e3,
      // temporary value (must be higher than unit point)
      bookingDate: Zg(Me.now()),
      travelStartDate: xf(w),
      travelEndDate: xf(y),
      channel: h
    };
  }
  async function u() {
    const h = await window.sso.getUserToken();
    e.value = await window.sso.isAeroplanUser(h), t.value = await window.sso.getAeroplanPoints();
  }
  async function p(h, g) {
    if (!e.value)
      return null;
    try {
      return await Jn(
        ZO(new URL(g.host)),
        JSON.stringify(h),
        "POST",
        g.retryCount,
        g.fetchAbortTimeout
      );
    } catch {
      return null;
    }
  }
  function f(h) {
    const {
      unitPoint: g,
      dollarPerUnitPoints: _,
      wasDollarPerUnitPoints: v = 0
    } = h;
    s(g), a(_), r(v);
  }
  function m() {
    return e.value && o.value > 0 && t.value !== null && t.value >= 0;
  }
  return {
    setupAeroplanRedeem: l
  };
}
function Ele(e, t) {
  return Io({
    APIOptions: e,
    getRequestUrl: () => qO(new URL(t.host), e).toString(),
    host: t.host,
    paginationSize: t.paginationSize,
    sentryErrorCodeFilter: t.sentryErrorCodeFilter,
    shouldSendSentry: t.shouldSendSentry,
    retryCount: t.retryCount,
    fetchAbortTimeout: t.fetchAbortTimeout
  });
}
function Ole(e, t, n) {
  return Io({
    APIOptions: e,
    getRequestUrl: () => HO(
      e,
      t.paginationSize,
      new URL(t.host),
      n
    ).toString(),
    host: t.host,
    paginationSize: t.paginationSize,
    sentryErrorCodeFilter: t.sentryErrorCodeFilter,
    shouldSendSentry: t.shouldSendSentry,
    retryCount: t.retryCount,
    fetchAbortTimeout: t.fetchAbortTimeout
  });
}
function xle(e, t, n) {
  return Io({
    APIOptions: e,
    getRequestUrl: () => BO(
      new URL(t.host),
      t.paginationSize,
      e,
      n
    ).toString(),
    host: t.host,
    paginationSize: t.paginationSize,
    sentryErrorCodeFilter: t.sentryErrorCodeFilter,
    shouldSendSentry: t.shouldSendSentry,
    retryCount: t.retryCount,
    fetchAbortTimeout: t.fetchAbortTimeout
  });
}
function Mle(e, t) {
  return Io({
    APIOptions: e,
    getRequestUrl: () => GO(new URL(t.host), e).toString(),
    host: t.host,
    paginationSize: t.paginationSize,
    sentryErrorCodeFilter: t.sentryErrorCodeFilter,
    shouldSendSentry: t.shouldSendSentry,
    retryCount: t.retryCount,
    fetchAbortTimeout: t.fetchAbortTimeout
  });
}
const Lle = (e, t) => {
  var f;
  const n = Qu(), o = {
    economy: t("plp.labels.economy"),
    premiumeconomy: t("plp.labels.premiumEconomy"),
    business: t("plp.labels.businessClass"),
    mixed: t("plp.labels.mixedCabin")
  }, s = ((f = n == null ? void 0 : n.query) == null ? void 0 : f.cabinClass) ?? "economy", a = eh.get(s), r = V(
    () => {
      var m;
      return !!((m = e.value) != null && m[a]);
    }
  ), i = V(
    () => Array.from(th.entries()).filter(([m]) => {
      var h;
      return ((h = e.value) == null ? void 0 : h[m]) && m !== a;
    }).map(([, m]) => o[m])
  ), l = V(() => {
    const m = i.value;
    return m.length > 2 ? `${m.slice(0, -1).join(t("common.generic.altCabinPLPMore"))}${t(
      "common.generic.altCabinPLPAnd"
    )}${m.slice(-1)}` : m.join(t("common.generic.altCabinPLPAnd"));
  }), c = V(
    () => t("plp.messages.alertNoCabinSearchedAvailable", {
      searchedCabin: o[s],
      returnedCabin: l.value
    })
  ), u = V(
    () => t("plp.messages.alertAdditionalCabinsAvailable", {
      searchedCabin: o[s],
      returnedCabin: l.value
    })
  );
  return {
    cabinAvailabilityMessage: V(() => r.value ? i.value.length > 0 ? u.value : "" : c.value),
    userPreferredCabinAvailable: r,
    otherAvailableCabinNames: i
  };
};
function Nle(e, t) {
  return {
    maxNumberOfAttempts3DSReached: V(
      () => e.some((o) => o >= t)
    )
  };
}
const Fle = (e, t) => {
  const n = [
    { label: t.allStops, value: "allStops" },
    {
      label: t.directFlightsOnly,
      value: "directFlightsOnly"
    },
    {
      label: t.oneStopOrLess,
      value: "oneStopOrLess"
    }
  ], o = R({}), s = V(
    () => Object.keys(o.value).length
  ), a = R("allStops"), r = () => {
    const p = {
      allStops: () => e.itineraries ?? {},
      directFlightsOnly: () => l.value.direct,
      oneStopOrLess: () => l.value.oneStopOrLess
    };
    o.value = p[a.value]();
  }, l = V(() => {
    const p = e.itineraries, f = {}, m = {};
    return p && Object.values(p).forEach((h) => {
      var v, w;
      const g = (v = h.segments) == null ? void 0 : v.filter(
        (y) => y.bound === "O"
      ).length, _ = (w = h.segments) == null ? void 0 : w.filter(
        (y) => y.bound === "I"
      ).length;
      g && _ && h.id && (g === 1 && _ === 1 && (f[h.id] = h), g <= 2 && _ <= 2 && (m[h.id] = h));
    }), {
      direct: f,
      oneStopOrLess: m
    };
  }), c = () => {
    const p = Object.keys(
      e.itineraries ?? {}
    ).length, f = Object.keys(
      l.value.direct
    ).length, m = p > 1, h = f > 0, g = p > f;
    return m && h && g;
  }, u = (p, f) => {
    a.value = f.value, QH(f.value), r();
  };
  return le(
    () => e.itineraries,
    (p) => {
      o.value = p ?? {}, r();
    }
  ), {
    shouldDisplayFilter: c,
    flightsOptions: n,
    visibleFlights: o,
    visibleFlightsCount: s,
    handleFilterSelection: u
  };
}, _y = R(), nX = (e) => {
  _y.value = e;
}, Rle = () => ({
  globalHTMLElementRef: _y,
  setGlobalHTMLElementRef: nX
}), Vle = (e = !1) => {
  const t = R(!1);
  return Re(async () => {
    t.value = window.sso.isGuestUser(
      await window.sso.getUserToken(e)
    );
  }), t;
}, Ble = (e) => {
  Re(() => {
    document.addEventListener("scroll", e);
  }), Jt(() => {
    document.removeEventListener("scroll", e);
  });
}, Om = R(!1), Hle = (e, t) => {
  !Om.value && e && (Om.value = !0, new IntersectionObserver(
    (o) => {
      o.forEach((s) => {
        s.isIntersecting && t();
      });
    },
    {
      rootMargin: "0px",
      threshold: 1
    }
  ).observe(e));
};
function Ule(e, t, n, o, s) {
  const a = Qu(), r = R(!1);
  return { pushingVPVEvent: async () => {
    var l;
    if ((n || (l = a == null ? void 0 : a.meta) != null && l.pushEventTitle) && !r.value) {
      const c = window.sso.getUserInfo(
        await window.sso.getUserToken()
      );
      VO(
        e,
        c,
        n ?? (a == null ? void 0 : a.meta.pushEventTitle),
        o ?? document.location.href,
        t,
        s ?? (a == null ? void 0 : a.meta.referrer)
      ), r.value = !0;
    }
  } };
}
function zle(e) {
  const t = () => {
    const s = document.querySelector(
      ".login-state-logout a"
    );
    s ? window.location.assign(s.href) : o();
  }, n = (s) => {
    switch (s) {
      case 401:
        t();
        break;
      case 400:
      case 403:
      case "JWT_TOKEN_ERROR":
        o();
        break;
    }
  }, o = () => {
    window.location.assign("/" + e);
  };
  return {
    redirectStatus: n,
    redirectToHomePage: o
  };
}
function oX(e, t) {
  var n = !1;
  return function(...o) {
    n || (e.call(null, ...o), n = !0, setTimeout(function() {
      n = !1;
    }, t));
  };
}
function wy(e) {
  return e.split(" ").filter((t) => t);
}
var sX = typeof window < "u";
function Xt(e, t, n = !1) {
  if (!t)
    return;
  const o = wy(t);
  if (o.length && !o.includes("longTouch"))
    for (const s of e) {
      if (!hr(s) || !Sn.has(s)) {
        s.classList.add(...o);
        continue;
      }
      const a = [], r = Sn.get(s);
      if (r) {
        for (const i of o)
          s.classList.contains(i) ? s.classList.contains(i) && n === !1 && a.push(i) : s.classList.add(i);
        r.privateClasses = a, Sn.set(s, r);
      }
    }
}
function qs(e, t) {
  if (!t)
    return;
  const n = wy(t);
  if (n.length)
    for (const o of e) {
      if (!hr(o)) {
        o.classList.remove(...n);
        continue;
      }
      const s = Sn.get(o);
      if (s)
        for (const a of n)
          s.privateClasses.includes(a) || o.classList.remove(a);
    }
}
function Cy(e) {
  let t = e.parentNode;
  for (; t !== null && t.nodeType === 1 && t instanceof HTMLElement; ) {
    const o = window.getComputedStyle(t).getPropertyValue("overflow");
    if (o === "scroll" || o === "auto")
      return t;
    t = t.parentNode;
  }
  return document.documentElement;
}
function aX(e) {
  if (!(e.e instanceof TouchEvent))
    return;
  const t = e.e.touches[0].clientX, n = e.e.touches[0].clientY;
  let o = document.elementFromPoint(t, n);
  if (!hr(o))
    return;
  let s, a = !0;
  for (; o && a; ) {
    if (Sn.has(o) || Ht.has(o)) {
      a = !1, s = Ht.has(o);
      break;
    }
    o = o.parentNode;
  }
  if (s) {
    const r = Ht.get(o);
    return r ? {
      parent: {
        el: o,
        data: r
      }
    } : void 0;
  } else {
    const r = Sn.get(o);
    if (!r)
      return;
    const i = Ht.get(o.parentNode);
    return i ? {
      node: {
        el: o,
        data: r
      },
      parent: {
        el: o.parentNode,
        data: i
      }
    } : void 0;
  }
}
function hr(e) {
  return e instanceof HTMLElement && e.parentNode instanceof HTMLElement;
}
function ky(e, t) {
  const n = new AbortController();
  for (const o in t) {
    const s = t[o];
    e.addEventListener(o, s, {
      signal: n.signal,
      passive: !1
    });
  }
  return n;
}
function ud(e, t, n = !1) {
  const o = window.getComputedStyle(e), s = [
    "position",
    "z-index",
    "top",
    "left",
    "x",
    "pointer-events",
    "y",
    "transform-origin",
    "filter",
    "-webkit-text-fill-color"
  ];
  for (const a of Array.from(o))
    n === !1 && a && s.includes(a) || t.style.setProperty(
      a,
      o.getPropertyValue(a),
      o.getPropertyPriority(a)
    );
  for (const a of Array.from(e.children)) {
    if (!hr(a))
      continue;
    const r = t.children[Array.from(e.children).indexOf(a)];
    ud(a, r, n);
  }
}
function rs(e) {
  return e instanceof DragEvent ? { x: e.clientX, y: e.clientY } : { x: e.touches[0].clientX, y: e.touches[0].clientY };
}
var Cn = {
  selectedNodes: Array(),
  activeNode: void 0,
  isTouch: !1
};
function xm(e = {}) {
  return (t) => {
    const n = Ht.get(t);
    if (!n)
      return;
    const o = {
      ...n.config,
      multiDragConfig: e
    };
    return {
      setup() {
        var s, a;
        o.handleDragstart = e.multiHandleDragstart || cX, o.handleTouchstart = e.multiHandleTouchstart || pX, o.handleEnd = e.multiHandleEnd || iX, o.reapplyDragClasses = e.multiReapplyDragClasses || rX, n.config = o, (s = o.multiDragConfig.plugins) == null || s.forEach((r) => {
          var i, l;
          (l = (i = r(t)) == null ? void 0 : i.tearDown) == null || l.call(i);
        }), (a = o.multiDragConfig.plugins) == null || a.forEach((r) => {
          var i, l;
          (l = (i = r(t)) == null ? void 0 : i.setup) == null || l.call(i);
        });
      },
      tearDownNodeRemap(s) {
        var a, r;
        (r = (a = o.multiDragConfig) == null ? void 0 : a.plugins) == null || r.forEach((i) => {
          var l, c;
          (c = (l = i(s.parent)) == null ? void 0 : l.tearDownNodeRemap) == null || c.call(l, s);
        });
      },
      tearDownNode(s) {
        var a, r;
        (r = (a = o.multiDragConfig) == null ? void 0 : a.plugins) == null || r.forEach((i) => {
          var l, c;
          (c = (l = i(s.parent)) == null ? void 0 : l.tearDownNode) == null || c.call(l, s);
        });
      },
      setupNodeRemap(s) {
        var a, r;
        (r = (a = o.multiDragConfig) == null ? void 0 : a.plugins) == null || r.forEach((i) => {
          var l, c;
          (c = (l = i(s.parent)) == null ? void 0 : l.setupNodeRemap) == null || c.call(l, s);
        });
      },
      setupNode(s) {
        var a, r;
        (r = (a = o.multiDragConfig) == null ? void 0 : a.plugins) == null || r.forEach((i) => {
          var l, c;
          (c = (l = i(s.parent)) == null ? void 0 : l.setupNode) == null || c.call(l, s);
        });
      }
    };
  };
}
function rX(e, t) {
  if (!ve)
    return;
  const n = "touchedNode" in ve ? t.config.multiDragConfig.touchDropZoneClass : t.config.multiDragConfig.dropZoneClass;
  ve.draggedNodes.map((s) => s.el).includes(e) && Xt([e], n, !0);
}
function iX(e) {
  !ve || ve && "touchedNode" in ve && "touchMoving" in ve && !ve.touchMoving || (Ny(e, ve), lX(e, ve), Ay());
}
function lX(e, t) {
  var r;
  const n = e.targetData.parent.data.config.multiDragConfig, o = (r = e.targetData.parent.data.config.selectionsConfig) == null ? void 0 : r.selectedClass, s = t && "touchedNode" in t;
  o && qs(
    Cn.selectedNodes.map((i) => i.el),
    o
  ), Cn.selectedNodes = [], Cn.activeNode = void 0;
  const a = s ? n.selectionDropZoneClass : n.touchSelectionDraggingClass;
  qs(
    t.draggedNodes.map((i) => i.el),
    a
  );
}
function cX(e) {
  e.e instanceof DragEvent && uX({
    e: e.e,
    targetData: e.targetData
  });
}
function uX(e) {
  const t = xy(e);
  Cn.isTouch = !1;
  const n = e.targetData.parent.data.config.multiDragConfig, o = e.targetData.parent.data.getValues(
    e.targetData.parent.el
  );
  let s = Cn.selectedNodes.length ? Cn.selectedNodes.map((r) => r.data.value) : n.selections && n.selections(o, e.targetData.parent.el);
  if (s === void 0)
    return;
  if (!s.includes(e.targetData.node.data.value)) {
    s = [e.targetData.node.data.value, ...s];
    const r = e.targetData.parent.data.config.selectionsConfig;
    Xt([e.targetData.node.el], r == null ? void 0 : r.selectedClass, !0), Cn.selectedNodes.push(e.targetData.node);
  }
  const a = e.targetData.node.el.style.zIndex;
  if (t.originalZIndex = a, e.targetData.node.el.style.zIndex = "9999", Array.isArray(s) && s.length) {
    const r = e.targetData.node.el.getBoundingClientRect(), [i, l] = [
      e.e.clientX - r.left,
      e.e.clientY - r.top
    ];
    Ty(Sy(e, s, t, i, l));
  } else {
    const r = e.targetData.parent.data.config;
    Oy(
      t.draggedNode.el,
      r.draggingClass,
      r.dropZoneClass
    );
  }
}
function pX(e) {
  e.e instanceof TouchEvent && dX({
    e: e.e,
    targetData: e.targetData
  });
}
function dX(e) {
  const t = Fy(e);
  Cn.isTouch = !0, Cn.activeNode = e.targetData.node;
  const n = e.targetData.parent.data.config.multiDragConfig, o = e.targetData.parent.data.getValues(
    e.targetData.parent.el
  );
  let s = [];
  e.targetData.parent.data.config.selectionsConfig ? s = Cn.selectedNodes.map((r) => r.data.value) : s = n.selections && n.selections(o, e.targetData.parent.el), s = [e.targetData.node.data.value, ...s];
  const a = e.targetData.parent.data.config.selectionsConfig;
  Xt([e.targetData.node.el], a == null ? void 0 : a.selectedClass, !0), Array.isArray(s) && s.length ? Ty(
    Sy(
      e,
      s,
      t,
      t.touchStartLeft,
      t.touchStartTop
    )
  ) : Vy(e, t), By(e, t);
}
function Sy(e, t, n, o, s) {
  for (const i of e.targetData.parent.data.enabledNodes)
    i.el !== n.draggedNode.el && t.includes(i.data.value) && n.draggedNodes.push(i);
  const a = e.targetData.parent.data.config.multiDragConfig, r = n.draggedNodes.map((i) => {
    const l = i.el.cloneNode(!0);
    return ud(i.el, l, !0), e.e instanceof DragEvent && Xt([l], a.draggingClass), l;
  });
  return setTimeout(() => {
    e.e instanceof DragEvent && Xt(
      n.draggedNodes.map((i) => i.el),
      a.dropZoneClass
    );
  }), n.clonedDraggedEls = r, { data: e, state: n, x: o, y: s };
}
function Ty({
  data: e,
  state: t,
  x: n,
  y: o
}) {
  var r;
  const s = document.createElement("div");
  for (const i of t.clonedDraggedEls)
    i instanceof HTMLElement && (i.style.pointerEvents = "none"), s.append(i);
  const { width: a } = t.draggedNode.el.getBoundingClientRect();
  s.style.cssText = `
        display: flex;
        flex-direction: column;
        width: ${a}px;
        position: fixed;
        pointer-events: none;
        z-index: 9999;
        left: -9999px
      `, document.body.append(s), e.e instanceof DragEvent ? ((r = e.e.dataTransfer) == null || r.setDragImage(s, n, o), setTimeout(() => {
    s.remove();
  })) : "touchedNode" in t && (t.touchedNode = s);
}
var Mm = [
  {
    transform: "translateY(100%)"
  },
  {
    transform: "translateY(0)"
  }
], Lm = [
  {
    transform: "translateY(-100%)"
  },
  {
    transform: "translateY(0)"
  }
], Dc = [
  {
    transform: "translateX(100%)"
  },
  {
    transform: "translateX(0)"
  }
], Pc = [
  {
    transform: "translateX(-100%)"
  },
  {
    transform: "translateX(0)"
  }
];
function Dl(e = {}) {
  return (t) => {
    const n = Ht.get(t);
    if (n)
      return {
        setup() {
          n.config.remapFinished = () => {
          }, document.head.querySelector("[data-drag-and-drop]");
        },
        setupNodeRemap(o) {
          if (!ve)
            return;
          const s = e.duration || 150;
          if (o.nodeData.value === ve.draggedNode.data.value) {
            switch (ve.incomingDirection) {
              case "below":
                bn(o.node, Mm, s);
                break;
              case "above":
                bn(o.node, Lm, s);
                break;
              case "left":
                bn(o.node, Pc, s);
                break;
              case "right":
                bn(o.node, Dc, s);
                break;
            }
            return;
          }
          if (!ve.affectedNodes.map((u) => u.data.value).includes(o.nodeData.value))
            return;
          const a = o.node.getBoundingClientRect(), r = ve.affectedNodes.findIndex(
            (u) => u.data.value === o.nodeData.value
          ), l = ve.draggedNode.data.index >= ve.targetIndex;
          let c;
          if (l ? c = ve.affectedNodes[r + 1] ? ve.affectedNodes[r + 1] : ve.affectedNodes[r - 1] : c = ve.affectedNodes[r - 1] ? ve.affectedNodes[r - 1] : ve.affectedNodes[r + 1], c) {
            const u = Math.abs(
              a.x - c.el.getBoundingClientRect().x
            ), p = Math.abs(
              a.y - c.el.getBoundingClientRect().y
            );
            u > p && l ? bn(o.node, Pc, s) : u > p && !l && bn(o.node, Dc, s);
          } else
            switch (ve.incomingDirection) {
              case "below":
                bn(o.node, Lm, s);
                break;
              case "above":
                bn(o.node, Mm, s);
                break;
              case "left":
                bn(o.node, Dc, s);
                break;
              case "right":
                bn(o.node, Pc, s);
                break;
            }
        }
      };
  };
}
function bn(e, t, n) {
  ve && (ve.preventEnter = !0, e.animate(t, {
    duration: n
  }), setTimeout(() => {
    ve && (ve.swappedNodeValue = void 0, ve.remapJustFinished = !0, ve.lastTargetValue = void 0, ve.preventEnter = !1);
  }, n));
}
var Nm = {
  up: [0, -1],
  down: [0, 1],
  left: [-1, 0],
  right: [1, 0]
}, Sn = /* @__PURE__ */ new WeakMap(), Ht = /* @__PURE__ */ new WeakMap(), ve = void 0;
function Ay() {
  ve = void 0;
}
function Dy(e) {
  return ve = {
    ascendingDirection: !1,
    incomingDirection: void 0,
    enterCount: 0,
    targetIndex: 0,
    affectedNodes: [],
    lastValue: void 0,
    activeNode: void 0,
    lastTargetValue: void 0,
    remapJustFinished: !1,
    preventEnter: !1,
    clonedDraggedEls: [],
    swappedNodeValue: !1,
    originalZIndex: void 0,
    ...e
  }, ve;
}
function fX(e, t) {
  return ve = {
    ...e,
    ...t
  }, ve;
}
function Py(e) {
  const { x: t, y: n } = rs(e.e);
  return {
    coordinates: {
      x: t,
      y: n
    },
    draggedNode: {
      el: e.targetData.node.el,
      data: e.targetData.node.data
    },
    draggedNodes: [
      {
        el: e.targetData.node.el,
        data: e.targetData.node.data
      }
    ],
    initialIndex: e.targetData.node.data.index,
    initialParent: {
      el: e.targetData.parent.el,
      data: e.targetData.parent.data
    },
    lastParent: {
      el: e.targetData.parent.el,
      data: e.targetData.parent.data
    },
    scrollParent: Cy(e.targetData.node.el)
  };
}
function mX(e, t) {
  const n = Iy(e), s = [
    ...Pu(
      t.targetData.parent.el,
      t.targetData.parent.data
    ).filter((a) => !n.includes(a))
  ];
  s.splice(t.targetData.node.data.index, 0, ...n), e.lastTargetValue = t.targetData.node.data.value, Iu(t.targetData.parent.el, t.targetData.parent.data, [
    ...s
  ]);
}
function Pu(e, t) {
  return [...t.getValues(e)];
}
function Iu(e, t, n) {
  t.setValues(n, e);
}
function Iy(e) {
  return [...e.draggedNodes.map((t) => t.data.value)];
}
function mt({
  parent: e,
  getValues: t,
  setValues: n,
  config: o = {}
}) {
  var a, r;
  if (!sX)
    return;
  document.addEventListener("dragover", (i) => {
    if (i.preventDefault(), ve) {
      ve.remapJustFinished = !1, ve.lastTargetValue = void 0;
      const { x: l, y: c } = rs(i);
      ve.coordinates.y = c, ve.coordinates.x = l, Pl();
    }
  }), vX(e);
  const s = {
    getValues: t,
    setValues: n,
    config: {
      handleDragstart: Ki,
      handleDragoverNode: LX,
      handleDragoverParent: NX,
      handleEnd: Yi,
      handleTouchstart: Gi,
      handleTouchmove: Hy,
      handleTouchOverNode: _X,
      handleTouchOverParent: FX,
      performSort: mX,
      performTransfer: HX,
      root: document,
      setupNode: wX,
      setupNodeRemap: Ly,
      reapplyDragClasses: CX,
      tearDownNode: SX,
      tearDownNodeRemap: kX,
      remapFinished: bX,
      scrollBehavior: {
        x: 0.8,
        y: 0.8
      },
      threshold: {
        horizontal: 0,
        vertical: 0
      },
      ...o
    },
    enabledNodes: [],
    abortControllers: {}
  };
  hX(e, s), (a = o.plugins) == null || a.forEach((i) => {
    var l, c;
    (c = (l = i(e)) == null ? void 0 : l.tearDown) == null || c.call(l);
  }), (r = o.plugins) == null || r.forEach((i) => {
    var l, c;
    (c = (l = i(e)) == null ? void 0 : l.setup) == null || c.call(l);
  }), Ey(e, !0);
}
function vX(e) {
  const t = Ht.get(e);
  t && t.abortControllers.mainParent && t.abortControllers.mainParent.abort();
}
function hX(e, t) {
  new MutationObserver(gX).observe(e, { childList: !0 }), Ht.set(e, t), t.abortControllers.mainParent = ky(e, {
    dragover: UX(
      oX(t.config.handleDragoverParent, 10)
    ),
    touchOverParent: t.config.handleTouchOverParent
  });
}
function gX(e) {
  const t = e[0].target;
  t instanceof HTMLElement && Ey(t);
}
function Ey(e, t) {
  const n = Ht.get(e);
  if (!n)
    return;
  const o = [], s = n.config;
  for (let i = 0; i < e.children.length; i++) {
    const l = e.children[i];
    if (!hr(l))
      continue;
    const c = Sn.get(l);
    (t || !c) && s.tearDownNode({ node: l, parent: e, nodeData: c, parentData: n }), !s.disabled && (!s.draggable || s.draggable && s.draggable(l)) && o.push(l);
  }
  if (o.length !== n.getValues(e).length && !s.disabled) {
    console.warn(
      "The number of enabled nodes does not match the number of values."
    );
    return;
  }
  const a = n.getValues(e), r = [];
  for (let i = 0; i < o.length; i++) {
    const l = o[i], c = Sn.get(l), u = Object.assign(
      c ?? {
        privateClasses: [],
        abortControllers: {}
      },
      {
        value: a[i],
        index: i
      }
    );
    if (ve && u.value === ve.draggedNode.data.value && (ve.draggedNode.data = u, ve.draggedNode.el = l), ve && ve.draggedNodes.map((f) => f.data.value).includes(u.value)) {
      const f = ve.draggedNodes.find(
        (m) => m.data.value === u.value
      );
      f && (f.el = l);
    }
    r.push({
      el: l,
      data: u
    });
    const p = {
      node: l,
      parent: e,
      parentData: n,
      nodeData: u
    };
    (t || !c) && s.setupNode(p), Ly(p);
  }
  Ht.set(e, { ...n, enabledNodes: r }), s.remapFinished(n);
}
function bX() {
  ve && (ve.preventEnter = !1, ve.swappedNodeValue = void 0, ve.remapJustFinished = !0);
}
function Ki(e) {
  e.e instanceof DragEvent && $X({
    e: e.e,
    targetData: e.targetData
  });
}
function Oy(e, t, n) {
  Xt([e], t), setTimeout(() => {
    qs([e], t), Xt([e], n);
  });
}
function xy(e) {
  const t = Dy(Py(e));
  return e.e.stopPropagation(), e.e.dataTransfer && (e.e.dataTransfer.dropEffect = "move", e.e.dataTransfer.effectAllowed = "move", e.e.dataTransfer.setDragImage(
    e.targetData.node.el,
    e.e.offsetX,
    e.e.offsetY
  )), t;
}
function My(e) {
  if (!(e.e instanceof DragEvent) && !(e.e instanceof TouchEvent))
    return !1;
  const t = e.targetData.parent.data.config;
  if (!t.dragHandle)
    return !0;
  const n = e.targetData.node.el.querySelectorAll(
    t.dragHandle
  );
  if (!n)
    return !1;
  const o = rs(e.e), s = t.root.elementFromPoint(
    o.x,
    o.y
  );
  if (!s)
    return !1;
  for (const a of Array.from(n))
    if (s === a || a.contains(s))
      return !0;
  return !1;
}
function yX(e) {
  if (!My(e))
    return;
  const t = Fy(e);
  Vy(e, t), By(e, t);
}
function $X(e) {
  if (!My(e)) {
    e.e.preventDefault();
    return;
  }
  const t = e.targetData.parent.data.config, n = xy(e), o = e.targetData.node.el.style.zIndex;
  n.originalZIndex = o, e.targetData.node.el.style.zIndex = "9999", Oy(
    n.draggedNode.el,
    t.draggingClass,
    t.dropZoneClass
  );
}
function _X(e) {
  ve && (e.detail.targetData.parent.el === ve.lastParent.el ? zy(e.detail, ve) : Il(e.detail, ve));
}
function wX(e) {
  var n;
  const t = e.parentData.config;
  e.node.draggable = !0, e.nodeData.abortControllers.mainNode = ky(e.node, {
    dragstart: fs(t.handleDragstart),
    dragover: fs(t.handleDragoverNode),
    dragend: fs(t.handleEnd),
    touchstart: fs(t.handleTouchstart),
    touchmove: fs(t.handleTouchmove),
    touchend: fs(t.handleEnd),
    touchOverNode: t.handleTouchOverNode
  }), t.reapplyDragClasses(e.node, e.parentData), (n = e.parentData.config.plugins) == null || n.forEach((o) => {
    var s, a;
    (a = (s = o(e.parent)) == null ? void 0 : s.setupNode) == null || a.call(s, e);
  });
}
function Ly(e) {
  var t;
  Sn.set(e.node, e.nodeData), (t = e.parentData.config.plugins) == null || t.forEach((n) => {
    var o, s;
    (s = (o = n(e.parent)) == null ? void 0 : o.setupNodeRemap) == null || s.call(o, e);
  });
}
function CX(e, t) {
  if (!ve)
    return;
  const n = "touchedNode" in ve ? t.config.touchDropZoneClass : t.config.dropZoneClass;
  ve.draggedNode.el === e && Xt([e], n, !0);
}
function kX(e) {
  var t;
  (t = e.parentData.config.plugins) == null || t.forEach((n) => {
    var o, s;
    (s = (o = n(e.parent)) == null ? void 0 : o.tearDownNodeRemap) == null || s.call(o, e);
  });
}
function SX(e) {
  var t, n, o, s, a;
  (t = e.parentData.config.plugins) == null || t.forEach((r) => {
    var i, l;
    (l = (i = r(e.parent)) == null ? void 0 : i.tearDownNode) == null || l.call(i, e);
  }), e.node.draggable = !1, (o = (n = e.nodeData) == null ? void 0 : n.abortControllers) != null && o.mainNode && ((a = (s = e.nodeData) == null ? void 0 : s.abortControllers) == null || a.mainNode.abort());
}
function Yi(e) {
  ve && (Ny(e, ve), Ay());
}
function Ny(e, t) {
  var a, r, i, l;
  document.removeEventListener("contextmenu", Ry), "longTouchTimeout" in t && t.longTouchTimeout && clearTimeout(t.longTouchTimeout);
  const n = (a = Ht.get(t.initialParent.el)) == null ? void 0 : a.config, s = "touchedNode" in t ? n == null ? void 0 : n.touchDropZoneClass : n == null ? void 0 : n.dropZoneClass;
  t.originalZIndex !== void 0 && (t.draggedNode.el.style.zIndex = t.originalZIndex), Xt(
    t.draggedNodes.map((c) => c.el),
    s,
    !0
  ), qs(
    t.draggedNodes.map((c) => c.el),
    s
  ), n != null && n.longTouchClass && qs(
    t.draggedNodes.map((c) => c.el),
    (i = (r = t.initialParent.data) == null ? void 0 : r.config) == null ? void 0 : i.longTouchClass
  ), "touchedNode" in t && ((l = t.touchedNode) == null || l.remove());
}
function Gi(e) {
  e.e instanceof TouchEvent && yX({
    e: e.e,
    targetData: e.targetData
  });
}
function Fy(e) {
  e.e.stopPropagation();
  const t = e.targetData.node.el.cloneNode(!0), n = e.targetData.node.el.getBoundingClientRect();
  return fX(Dy(Py(e)), {
    coordinates: {
      x: e.e.touches[0].clientX,
      y: e.e.touches[0].clientY
    },
    scrollParent: Cy(e.targetData.node.el),
    touchStartLeft: e.e.touches[0].clientX - n.left,
    touchStartTop: e.e.touches[0].clientY - n.top,
    touchedNode: t,
    touchMoving: !1
  });
}
function Ry(e) {
  e.preventDefault();
}
function Vy(e, t) {
  t.touchedNodeDisplay = t.touchedNode.style.display;
  const n = e.targetData.node.el.getBoundingClientRect();
  t.touchedNode.style.cssText = `
            width: ${n.width}px;
            position: fixed;
            pointer-events: none;
            top: -9999px;
            z-index: 999999;
            display: none;
          `, document.body.append(t.touchedNode), ud(e.targetData.node.el, t.touchedNode), t.touchedNode.style.display = "none", document.addEventListener("contextmenu", Ry);
}
function By(e, t) {
  const n = e.targetData.parent.data.config;
  n.longTouch && (t.longTouchTimeout = setTimeout(() => {
    t && (t.longTouch = !0, n.longTouchClass && e.e.cancelable && Xt(
      t.draggedNodes.map((o) => o.el),
      n.longTouchClass
    ), e.e.preventDefault());
  }, n.longTouchTimeout || 200));
}
function Hy(e) {
  !ve || !("touchedNode" in ve) || MX(e, ve);
}
function TX(e, t) {
  t.longTouchClass && qs(
    e.draggedNodes.map((n) => n.el),
    t == null ? void 0 : t.longTouchClass
  ), t.touchDraggingClass && Xt([e.touchedNode], t.touchDraggingClass), t.touchDropZoneClass && Xt(
    e.draggedNodes.map((n) => n.el),
    t.touchDropZoneClass
  );
}
function AX(e) {
  if (!e || !e.scrollParent)
    return;
  const { x: t, y: n, width: o, height: s } = e.scrollParent.getBoundingClientRect(), {
    x: a,
    y: r,
    scrollOutside: i
  } = e.lastParent.data.config.scrollBehavior;
  return {
    state: e,
    xThresh: a,
    yThresh: r,
    scrollOutside: i,
    scrollParent: e.scrollParent,
    x: t,
    y: n,
    width: o,
    height: s
  };
}
function DX(e) {
  const t = AX(ve);
  if (t)
    switch (e) {
      case "down":
        return OX(t.state, t);
      case "up":
        return EX(t.state, t);
      case "right":
        return PX(t.state, t);
      case "left":
        return IX(t.state, t);
    }
}
function PX(e, t) {
  const n = t.scrollParent.clientWidth + t.x - e.coordinates.x;
  if (!(!t.scrollOutside && n < 0) && n < (1 - t.xThresh) * t.scrollParent.clientWidth && !(t.scrollParent.scrollLeft + t.scrollParent.clientWidth >= t.scrollParent.scrollWidth))
    return e;
}
function IX(e, t) {
  const n = t.scrollParent.clientWidth + t.x - e.coordinates.x;
  if (!(!t.scrollOutside && n > t.scrollParent.clientWidth) && n > t.xThresh * t.scrollParent.clientWidth && t.scrollParent.scrollLeft !== 0)
    return e;
}
function EX(e, t) {
  const n = t.scrollParent.clientHeight + t.y - e.coordinates.y;
  if (!(!t.scrollOutside && n > t.scrollParent.clientHeight) && n > t.yThresh * t.scrollParent.clientHeight && t.scrollParent.scrollTop !== 0)
    return e;
}
function OX(e, t) {
  const n = t.scrollParent.clientHeight + t.y - e.coordinates.y;
  if (!(!t.scrollOutside && n < 0) && n < (1 - t.yThresh) * t.scrollParent.clientHeight && !(t.scrollParent.scrollTop + t.scrollParent.clientHeight >= t.scrollParent.scrollHeight))
    return e;
}
function xX(e, t) {
  t.touchMoving = !0, t.touchedNode.style.display = t.touchedNodeDisplay || "";
  const { x: n, y: o } = rs(e.e);
  t.coordinates.y = o, t.coordinates.x = n;
  const s = t.touchStartLeft ?? 0, a = t.touchStartTop ?? 0;
  t.touchedNode.style.left = `${n - s}px`, t.touchedNode.style.top = `${o - a}px`, TX(t, e.targetData.parent.data.config);
}
function MX(e, t) {
  if (e.targetData.parent.data.config.longTouch && !t.longTouch) {
    clearTimeout(t.longTouchTimeout);
    return;
  }
  e.e.cancelable && e.e.preventDefault(), xX(e, t), Pl();
  const o = aX(e);
  if (!o)
    return;
  const s = {
    e: e.e,
    targetData: o
  };
  "node" in o ? o.node.el.dispatchEvent(
    new CustomEvent("touchOverNode", {
      detail: s
    })
  ) : o.parent.el.dispatchEvent(
    new CustomEvent("touchOverParent", {
      detail: s
    })
  );
}
function Pl() {
  for (const e of Object.keys(Nm)) {
    const [t, n] = Nm[e];
    Uy(e, t, n);
  }
}
function Uy(e, t, n) {
  const o = DX(e);
  o && (o.scrollParent.scrollBy(t, n), setTimeout(
    () => {
      Uy(e, t, n);
    },
    "touchedNode" in o ? 10 : 100
  ));
}
function LX(e) {
  if (!ve)
    return;
  const { x: t, y: n } = rs(e.e);
  ve.coordinates.y = n, ve.coordinates.x = t, Pl(), VX(e, ve);
}
function NX(e) {
  if (!ve)
    return;
  const { x: t, y: n } = rs(e.e);
  ve.coordinates.y = n, ve.coordinates.x = t, Pl(), Il(e, ve);
}
function FX(e) {
  ve && Il(e.detail, ve);
}
function RX(e, t) {
  if (e.targetData.parent.el === t.lastParent.el)
    return !1;
  const n = e.targetData.parent.data.config;
  if (n.dropZone === !1)
    return !1;
  const o = t.initialParent.data.config;
  return n.accepts ? n.accepts(
    e.targetData.parent,
    t.initialParent,
    t.lastParent,
    t
  ) : !(!n.group || n.group !== o.group);
}
function VX(e, t) {
  var n;
  e.e.preventDefault(), e.e.stopPropagation(), e.targetData.parent.el === ((n = t.lastParent) == null ? void 0 : n.el) ? zy(e, t) : Il(e, t);
}
function BX(e, t, n, o) {
  var p;
  if (t.remapJustFinished)
    return t.remapJustFinished = !1, t.lastTargetValue = e.targetData.node.data.value, !1;
  if (t.lastTargetValue === e.targetData.node.data.value || t.draggedNodes.map((f) => f.el).includes(e.targetData.node.el) || t.preventEnter || t.swappedNodeValue === e.targetData.node.data.value || e.targetData.parent.el !== ((p = t.lastParent) == null ? void 0 : p.el) || e.targetData.parent.data.config.sortable === !1)
    return !1;
  const s = e.targetData.node.el.getBoundingClientRect(), a = t.draggedNode.el.getBoundingClientRect(), r = s.y - a.y, i = s.x - a.x;
  let l;
  const c = t.draggedNode.data.index > e.targetData.node.data.index ? [e.targetData.node.data.index, t.draggedNode.data.index] : [t.draggedNode.data.index, e.targetData.node.data.index];
  t.targetIndex = e.targetData.node.data.index, t.affectedNodes = e.targetData.parent.data.enabledNodes.filter(
    (f) => c[0] <= f.data.index && f.data.index <= c[1] && f.el !== t.draggedNode.el
  ), Math.abs(r) > Math.abs(i) ? l = r > 0 ? "above" : "below" : l = i > 0 ? "left" : "right";
  const u = t.lastParent.data.config.threshold;
  switch (l) {
    case "left":
      if (n > s.x + s.width * u.horizontal)
        return t.incomingDirection = "left", !0;
      break;
    case "right":
      if (n < s.x + s.width * (1 - u.horizontal))
        return t.incomingDirection = "right", !0;
      break;
    case "above":
      if (o > s.y + s.height * u.vertical)
        return t.incomingDirection = "above", !0;
      break;
    case "below":
      if (o < s.y + s.height * (1 - u.vertical))
        return t.incomingDirection = "below", !0;
      break;
  }
  return !1;
}
function zy(e, t) {
  const { x: n, y: o } = rs(e.e);
  BX(e, t, n, o) && (t.swappedNodeValue = e.targetData.node.data.value, t.preventEnter = !0, e.targetData.parent.data.config.performSort(t, e));
}
function fs(e) {
  function t(n) {
    var r;
    const o = Sn.get(n), s = n.parentNode || ((r = ve == null ? void 0 : ve.lastParent) == null ? void 0 : r.el);
    if (!o)
      return;
    const a = Ht.get(s);
    if (a)
      return {
        node: {
          el: n,
          data: o
        },
        parent: {
          el: s,
          data: a
        }
      };
  }
  return (n) => {
    const o = t(n.currentTarget);
    if (o)
      return e({
        e: n,
        targetData: o
      });
  };
}
function HX(e, t) {
  const n = Iy(e), o = Pu(
    e.lastParent.el,
    e.lastParent.data
  ).filter((i) => !n.includes(i)), s = Pu(
    t.targetData.parent.el,
    t.targetData.parent.data
  ), a = e.initialParent.el === t.targetData.parent.el && t.targetData.parent.data.config.sortable === !1;
  let r;
  "node" in t.targetData ? (a ? r = e.initialIndex : t.targetData.parent.data.config.sortable === !1 ? r = t.targetData.parent.data.enabledNodes.length : r = t.targetData.node.data.index, s.splice(r, 0, ...n)) : (r = a ? e.initialIndex : t.targetData.parent.data.enabledNodes.length, s.splice(r, 0, ...n)), Iu(e.lastParent.el, e.lastParent.data, o), Iu(
    t.targetData.parent.el,
    t.targetData.parent.data,
    s
  );
}
function Il(e, t) {
  RX(e, t) && (e.targetData.parent.data.config.performTransfer(t, e), t.lastParent = e.targetData.parent);
}
function UX(e) {
  function t(n) {
    const o = Ht.get(n);
    if (o)
      return {
        parent: {
          el: n,
          data: o
        }
      };
  }
  return (n) => {
    const o = t(n.currentTarget);
    if (o)
      return e({
        e: n,
        targetData: o
      });
  };
}
var Wy = /^([0-9]{4})-([0-1][0-9])(?:-([0-3][0-9]))?(?:[T ]?([0-2][0-9])(?::([0-5][0-9]))?(?::([0-5][0-9]))?)?(?:\.[0-9]+)?(Z|(?:\+|\-)[0-9]{2}:?[0-9]{2})?$/;
function zX(e) {
  const t = e.match(Wy);
  if (t) {
    const n = Number(t[2]);
    if (n < 1 || n > 12)
      return !1;
    if (typeof t[3] !== void 0) {
      const o = Number(t[3]);
      if (o < 1 || o > 31)
        return !1;
    }
    if (typeof t[4] !== void 0) {
      const o = Number(t[4]);
      if (o < 0 || o > 23)
        return !1;
    }
    return !0;
  }
  return !1;
}
function WX(e) {
  const t = e.match(Wy);
  return t && typeof t[4] > "u" ? e += "T00:00:00" : e;
}
function Ze(e) {
  if (e || (e = /* @__PURE__ */ new Date()), e instanceof Date) {
    const t = new Date(e);
    return t.setMilliseconds(0), t;
  }
  if (e = e.trim(), zX(e))
    return new Date(WX(e));
  throw new Error(`Non ISO 8601 compliant date (${e}).`);
}
function Ms(e, t = 1) {
  const n = Ze(e);
  return n.setDate(n.getDate() + t), n;
}
function Zi(e) {
  const t = Ze(e);
  return t.setDate(1), t.setMonth(t.getMonth() + 1), t.setDate(0), t;
}
function gr(e) {
  return Zi(e).getDate();
}
function co(e, t = 1, n = !1) {
  const o = Ze(e), s = o.getDate();
  if (n || o.setDate(1), o.setMonth(o.getMonth() + t), !n) {
    const a = gr(o);
    o.setDate(a < s ? a : s);
  }
  return o;
}
function $s(e, t = 1, n = !1) {
  const o = Ze(e), s = o.getDate();
  if (n || o.setDate(1), o.setFullYear(o.getFullYear() + t), !n) {
    const a = gr(o);
    o.setDate(a < s ? a : s);
  }
  return o;
}
var pd = "1999-03-04T02:05:01.000Z", Ic = /* @__PURE__ */ new Map(), dd = [
  ["YYYY", { year: "numeric" }],
  ["YY", { year: "2-digit" }],
  ["MMMM", { month: "long" }],
  ["MMM", { month: "short" }],
  ["MM", { month: "2-digit" }],
  ["M", { month: "numeric" }],
  ["DD", { day: "2-digit" }],
  ["D", { day: "numeric" }],
  ["dddd", { weekday: "long" }],
  ["ddd", { weekday: "short" }],
  ["d", { weekday: "narrow" }],
  ["mm", { minute: "2-digit" }],
  ["m", { minute: "numeric" }],
  ["ss", { second: "2-digit" }],
  ["s", { second: "numeric" }],
  ["ZZ", { timeZoneName: "long" }],
  ["Z", { timeZoneName: "short" }]
], fd = [
  ["HH", { hour: "2-digit" }],
  ["H", { hour: "numeric" }]
], md = [
  ["hh", { hour: "2-digit" }],
  ["h", { hour: "numeric" }],
  ["a", { dayPeriod: "narrow" }],
  ["A", { dayPeriod: "narrow" }]
], Xi = {
  DD: 2,
  HH: 2,
  MM: 2,
  YY: 2,
  YYYY: 4,
  hh: 2,
  mm: 2,
  ss: 2
};
function jy(e) {
  if (/^[+-]\d{2}:\d{2}/.test(e))
    return 6;
  if (/^[+-]\d{4}/.test(e))
    return 5;
  throw new Error("Invalid offset format");
}
var jX = ["MMMM", "MMM", "dddd", "ddd"], Qe = /* @__PURE__ */ new Map(
  /* @__PURE__ */ [...dd, ...fd, ...md].map((e) => [e[0], e])
), Fm = /* @__PURE__ */ new Map(), qy = [
  "full",
  "long",
  "medium",
  "short"
], lo = (e) => String(e).padStart(2, "0"), Ec = (e) => String(e).padStart(2, "0");
function jn(e) {
  return e.type === "literal" && (e.value = e.value.normalize("NFKC")), e;
}
function qX(e, t, n, o = !1, s = null) {
  const a = KX(e, t, n, o), r = Ze(e);
  function i({ partName: l, partValue: c, token: u }) {
    if (l === "literal")
      return c;
    const p = a[l];
    if (l === "hour" && u === "H")
      return p.replace(/^0/, "") || "0";
    if (["mm", "ss", "MM"].includes(u) && p.length === 1)
      return `0${p}`;
    if (l === "dayPeriod") {
      const f = As(r.getUTCHours() < 12 ? "am" : "pm", n);
      return u === "A" ? f.toUpperCase() : f.toLowerCase();
    }
    return l === "timeZoneName" ? s ?? Ky(-1 * r.getTimezoneOffset(), u) : p;
  }
  return t.map((l) => ({
    ...l,
    value: i(l)
  }));
}
function KX(e, t, n, o = !1) {
  const s = Ze(e), a = t.filter((u) => u.hour12), r = t.filter((u) => !u.hour12), i = [], l = [];
  function c(u, p = !1) {
    const f = `${n}-u-hc-${p ? "h12" : "h23"}`;
    if (i.push(
      ...new Intl.DateTimeFormat(
        f,
        u.reduce(
          (m, h) => h.partName === "literal" ? m : (o && jX.includes(h.token) && l.push(h), Object.assign(m, h.option)),
          { timeZone: "UTC" }
        )
      ).formatToParts(s).map(jn)
    ), o && l.length)
      for (const m of l) {
        let h = [];
        switch (m.token) {
          case "MMMM":
            h = new Intl.DateTimeFormat(f, {
              dateStyle: "long",
              timeZone: "UTC"
            }).formatToParts(s).map(jn);
            break;
          case "MMM":
            h = new Intl.DateTimeFormat(f, {
              dateStyle: "medium",
              timeZone: "UTC"
            }).formatToParts(s).map(jn);
            break;
        }
        const g = h.find(
          (v) => v.type === m.partName
        ), _ = i.findIndex((v) => v.type === m.partName);
        g && _ > -1 && (i[_] = g);
      }
  }
  return a.length && c(a, !0), r.length && c(r), i.reduce((u, p) => (u[p.type] = p.value, u), {});
}
function Ky(e, t = "Z") {
  const n = String(Math.floor(Math.abs(e / 60))).padStart(
    2,
    "0"
  ), o = String(Math.abs(e % 60)).padStart(2, "0"), s = e < 0 ? "-" : "+";
  return t === "ZZ" ? `${s}${n}${o}` : `${s}${n}:${o}`;
}
function YX(e, t) {
  Yy(e, t);
  const [n, o, s, a] = e.match(
    /([+-])([0-3][0-9]):?([0-6][0-9])/
  ), r = Number(s) * 60 + Number(a);
  return o === "+" ? r : -r;
}
function Yy(e, t = "Z") {
  if (!((o) => {
    switch (o) {
      case "Z":
        return /^([+-])[0-3][0-9]:[0-6][0-9]$/.test(e);
      case "ZZ":
        return /^([+-])[0-3][0-9][0-6][0-9]$/.test(e);
    }
  })(t))
    throw new Error(`Invalid offset: ${e}`);
  return e;
}
function GX(e) {
  return dd.concat(fd).concat(md).sort((t, n) => t[0].length > n[0].length ? 1 : -1).reduce((t, n) => t.replace(n[0], `\\${n[0]}`), e);
}
function ZX(e) {
  return ["numeric", "2-digit"].includes(e.partValue);
}
function XX(e) {
  let t;
  for (const n of e) {
    if (n.partName === "literal" && !isNaN(parseFloat(n.partValue)))
      throw new Error(`Numbers in format (${n.partValue}).`);
    if (t && t.partName !== "literal" && n.partName !== "literal" && !(t.token in Xi) && !(n.token in Xi) && !(ZX(t) && n.token.toLowerCase() === "a"))
      throw new Error(
        `Illegal adjacent tokens (${t.token}, ${n.token})`
      );
    t = n;
  }
  return e;
}
function JX(e) {
  return typeof e == "string" ? e.includes("ZZ") ? "ZZ" : "Z" : "time" in e && e.time === "full" ? "Z" : "ZZ";
}
function As(e, t) {
  const n = Fm.get(t);
  if (n && n[e])
    return n[e];
  const o = new Date(pd);
  o.setUTCHours(e === "am" ? 5 : 20);
  const a = new Intl.DateTimeFormat(t, {
    timeStyle: "full",
    timeZone: "UTC",
    hour12: !0
  }).formatToParts(o).map(jn).find((r) => r.type === "dayPeriod");
  if (a) {
    const r = n || {};
    return Fm.set(
      t,
      Object.assign(r, { [e]: a.value })
    ), a.value;
  }
  return e;
}
function Gy(e, t = "+00:00") {
  const n = Ze(e), o = (() => {
    switch (jy(t)) {
      case 5:
        return "ZZ";
      case 6:
        return "Z";
    }
  })(), s = YX(t, o);
  return new Date(n.getTime() + s * 1e3 * 60);
}
function Zy() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
function Rm(e, t) {
  const n = new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    timeZone: t,
    hourCycle: "h23"
  }).formatToParts(e).map(jn), o = {};
  return n.forEach((s) => {
    o[s.type] = s.value;
  }), /* @__PURE__ */ new Date(
    `${o.year}-${o.month}-${o.day}T${o.hour}:${o.minute}:${o.second}Z`
  );
}
function Qa(e, t = "UTC", n = "device", o = "Z") {
  var s;
  n = n === "device" ? (s = Zy()) != null ? s : "utc" : n;
  const a = Ze(e), r = Rm(a, t), i = Rm(a, n), l = Math.round(
    (i.getTime() - r.getTime()) / 1e3 / 60
  );
  return Ky(l, o);
}
function QX(e) {
  const t = Ze(e);
  return Math.round(
    (new Date(t.getFullYear(), t.getMonth(), t.getDate(), 0, 0).getTime() - new Date(t.getFullYear(), 0, 0).getTime()) / 864e5
  );
}
function eJ(e) {
  const t = Ze(e);
  return t.setHours(0, 0, 0), t;
}
function Ks(e, t) {
  if (qy.includes(e) || typeof e == "object")
    return tJ(e, t);
  let n = e, o = 0;
  const s = (u) => {
    if (u[2] || (u[2] = new RegExp(`(.)?(${u[0]})`, "g")), u[2].test(n)) {
      let p = 0;
      return n = n.replace(u[2], (f, m, h) => m === "\\" ? h : `${typeof m == "string" ? m : ""}{!${p++ ? o : o++}!}`), !!p;
    }
    return !1;
  };
  function a(u) {
    const p = u.map((m) => m.partName), f = new Set(p);
    if (p.length > f.size)
      throw new Error("Cannot reuse format tokens.");
    return u;
  }
  function r(u, [p, f, m]) {
    const h = Object.keys(f)[0], g = f[h];
    return {
      option: f,
      partName: h,
      partValue: g,
      token: p,
      pattern: m,
      hour12: u
    };
  }
  const i = dd.filter(s).concat(fd.filter(s)).map(r.bind(null, !1)), l = a(
    i.concat(
      md.filter(s).map(r.bind(null, !0))
    )
  ), c = /^\{!(\d+)!\}$/;
  return n.split(/(\{!\d+!\})/).map((u) => {
    const p = u.match(c);
    return p ? l[Number(p[1])] : {
      option: { literal: u },
      partName: "literal",
      partValue: u,
      token: u,
      pattern: new RegExp(""),
      hour12: !1
    };
  }).filter((u) => !(u.partName === "literal" && u.partValue === ""));
}
function tJ(e, t) {
  const n = {
    timeZone: "UTC"
  };
  typeof e == "string" ? n.dateStyle = e : ("date" in e && (n.dateStyle = e.date), "time" in e && (n.timeStyle = e.time));
  const o = new Intl.DateTimeFormat(t, n), s = o.formatToParts(new Date(pd)).map(jn), r = o.formatToParts(/* @__PURE__ */ new Date("1999-04-05T23:05:01.000Z")).map(jn).find((l) => l.type === "hour"), i = r && r.value === "23" ? 24 : 12;
  return s.map((l) => {
    const c = l.type, u = nJ(
      l.type,
      l.value,
      t,
      l.type === "hour" ? i : void 0,
      n
    );
    if (u === void 0)
      return;
    const p = u[1][c];
    if (p)
      return u[2] || (u[2] = new RegExp(`${u[0]}`, "g")), {
        option: { [c]: p },
        partName: c,
        partValue: p,
        token: u[0],
        pattern: u[2],
        hour12: i === 12
      };
  }).filter((l) => !!l);
}
function nJ(e, t, n, o, s) {
  const a = t.length, r = !isNaN(Number(t));
  let i;
  switch (e) {
    case "year":
      return a === 2 ? Qe.get("YY") : Qe.get("YYYY");
    case "month":
      if (r)
        return a === 1 ? Qe.get("M") : Qe.get("MM");
      switch (i = Vm(n, e, t), i) {
        case "long":
          return Qe.get("MMMM");
        default:
          return Qe.get("MMM");
      }
    case "day":
      return a === 1 ? Qe.get("D") : Qe.get("DD");
    case "weekday":
      switch (i = Vm(n, e, t), i) {
        case "narrow":
          return Qe.get("d");
        case "short":
          return Qe.get("ddd");
        default:
          return Qe.get("dddd");
      }
    case "hour":
      return o === 12 ? a === 1 ? Qe.get("h") : Qe.get("hh") : a === 1 ? Qe.get("H") : Qe.get("HH");
    case "minute":
      return a === 1 ? Qe.get("m") : Qe.get("mm");
    case "second":
      return a === 1 ? Qe.get("s") : Qe.get("ss");
    case "dayPeriod":
      return /^[A-Z]+$/u.test(t) ? Qe.get("A") : Qe.get("a");
    case "literal":
      return [t, { literal: t }, new RegExp("")];
    case "timeZoneName":
      return s.timeStyle === "full" ? Qe.get("Z") : Qe.get("ZZ");
    default:
      return;
  }
}
function Vm(e, t, n) {
  if (!Ic.has(e)) {
    const s = new Date(pd), a = [3, 8, 9, 7, 6, 4, 3], r = ["weekday", "month", "dayPeriod"], i = ["long", "short", "narrow"], l = {};
    for (let c = 0; c < 12; c++) {
      s.setMonth(0 + c), c in a && s.setDate(a[c]), s.setUTCHours(8 + c);
      for (const u of i) {
        const p = new Intl.DateTimeFormat(
          e,
          r.reduce(
            (f, m) => Object.assign(f, { [m]: u }),
            { hour12: !0, timeZone: "UTC" }
          )
        ).formatToParts(s).map(jn);
        if (u === "long" || u === "short") {
          const m = new Intl.DateTimeFormat(e, {
            dateStyle: u === "short" ? "medium" : "long",
            timeZone: "UTC"
          }).formatToParts(s).map(jn).find(
            (g) => g.type === "month"
          ), h = p.findIndex((g) => g.type === "month");
          h > -1 && m && (p[h] = m);
        }
        p.forEach((f) => {
          if (f.type === "literal")
            return;
          const m = f.type;
          l[m] = Object.assign(l[m] || {}, {
            [f.value]: u
          });
        });
      }
    }
    Ic.set(e, l);
  }
  const o = Ic.get(e);
  return o ? o[t][n] : void 0;
}
function _s(e, t = "+00:00") {
  const n = t.slice(0, 1) === "+";
  return Gy(
    e,
    t.replace(n ? "+" : "-", n ? "-" : "+")
  );
}
function oJ() {
  return Intl.DateTimeFormat().resolvedOptions().locale;
}
function Bt(e, t = "long", n = "device", o = !1, s) {
  let a, r;
  return typeof e == "object" && !(e instanceof Date) && ({
    date: e,
    format: t,
    locale: n,
    genitive: o,
    partFilter: s,
    tz: a
  } = e), t === "ISO8601" ? Ze(e).toISOString() : (a && (r = Qa(e, "utc", a, JX(t))), a ?? (a = Zy()), (a == null ? void 0 : a.toLowerCase()) !== "utc" && (e = _s(
    e,
    Qa(e, a, "utc")
  )), (!n || n === "device") && (n = oJ()), qX(
    e,
    Ks(t, n).filter(s ?? (() => !0)),
    n,
    o,
    r
  ).map((i) => i.value).join(""));
}
function vd(e, t = "en", n = !1, o = () => !0) {
  return Ks(e, t).filter(o).reduce(
    (s, a) => s += n && a.partName === "literal" ? GX(a.token) : a.token,
    ""
  ).normalize("NFKC");
}
function sJ(e) {
  const t = (/* @__PURE__ */ new Date()).getFullYear(), n = t % 100, o = Math.floor(t / 100), s = Number(e);
  return (o + (s > n + 20 ? -1 : 0)) * 100 + s;
}
function Bm(e) {
  const t = Ze(e);
  return t.setDate(1), t.setHours(0, 0, 0), t;
}
function aJ(e) {
  const t = Ze(e);
  return (new Date(t.getFullYear() + 1, 0, 0).getTime() - new Date(t.getFullYear(), 0, 0).getTime()) / 864e5;
}
function ba(e, t, n = 7) {
  let o, s;
  const a = Ze(e);
  switch (n) {
    case "month":
      s = a.getDate(), o = gr(a) - a.getDate();
      break;
    case "week":
      s = a.getDay() + 1, o = 6 - a.getDay();
      break;
    case "year":
      const r = aJ(a), i = QX(a);
      s = i, o = r - i;
      break;
    default:
      o = s = n;
  }
  for (let r = 0; r <= o || r < s; r++) {
    if (r <= o) {
      const i = Ms(a, r);
      if (t(i))
        return i;
    }
    if (r && r <= s) {
      const i = Ms(a, -r);
      if (t(i))
        return i;
    }
  }
  return null;
}
function El(e, t = "en", n = !1) {
  const o = (s, a) => Array(s).fill("").map((r, i) => `${a(i)}`);
  if (e === "M")
    return o(12, (s) => s + 1);
  if (e === "MM")
    return o(12, (s) => {
      const a = s + 1;
      return a < 10 ? `0${a}` : a;
    });
  if (e.startsWith("M"))
    return El("MM").map(
      (s) => Bt(`2000-${s}-05`, e, t, n)
    );
  if (e.startsWith("d"))
    return o(7, (s) => `0${s + 2}`).map(
      (s) => Bt(`2022-10-${s}`, e, t)
    );
  if (e === "a")
    return [As("am", t).toLowerCase(), As("pm", t).toLowerCase()];
  if (e === "A")
    return [As("am", t).toUpperCase(), As("pm", t).toUpperCase()];
  if (e.startsWith("Y")) {
    const s = (/* @__PURE__ */ new Date()).getFullYear();
    return o(120, (a) => a + 1).reduce(
      (a, r) => (r !== "120" && a.push(Bt(`${s + Number(r)}-06-06`, e, t)), a.unshift(Bt(`${s - Number(r)}-06-06`, e, t)), a),
      [Bt(`${s}-06-06`, e, t)]
    );
  }
  return e.startsWith("D") ? o(31, (s) => `${e === "DD" && s < 9 ? "0" : ""}${s + 1}`) : e.startsWith("H") ? o(24, (s) => `${e === "HH" && s < 10 ? "0" : ""}${s}`) : e.startsWith("h") ? o(12, (s) => `${e === "hh" && s < 9 ? "0" : ""}${s + 1}`) : e.startsWith("m") || e.startsWith("s") ? o(60, (s) => `${e.length > 1 && s < 10 ? "0" : ""}${s}`) : [];
}
function Fo(e, t = "ISO8601", n = "device") {
  let o = () => !0, s, a = "backward";
  if (typeof e == "object" ? {
    date: s,
    format: t = "ISO8601",
    locale: n = "device",
    dateOverflow: a = "backward",
    partFilter: o = () => !0
  } = e : s = e, !s)
    throw new Error("parse() requires a date string.");
  const r = () => {
    throw new Error(
      `Date (${s}) does not match format (${vd(t, n)})`
    );
  };
  if (t === "ISO8601")
    return Ze(s);
  const i = qy.includes(t) || typeof t == "object", l = XX(Ks(t, n).filter(o));
  if (!l.length)
    throw new Error("parse() requires a pattern.");
  let c;
  try {
    c = Xy(s, l);
  } catch {
    return r();
  }
  const u = /* @__PURE__ */ new Date(), p = /* @__PURE__ */ new Map([
    ["YYYY", u.getFullYear()],
    ["MM", u.getMonth() + 1],
    ["DD", u.getDate()],
    ["HH", 0],
    ["mm", 0],
    ["ss", 0]
  ]);
  let f = null, m = "";
  c.forEach((D) => {
    if (D.partName === "literal")
      return;
    if (D.token === D.value)
      return r();
    const O = Number(D.value);
    if (p.has(D.token))
      p.set(D.token, O);
    else if (D.token === "YY")
      p.set("YYYY", sJ(D.value));
    else {
      const x = D.token;
      if (x.startsWith("d"))
        return;
      if (x === "D")
        p.set("DD", O);
      else if (x === "H" || x.startsWith("h"))
        p.set("HH", O);
      else if (x === "M")
        p.set("MM", O);
      else if (x === "a" || x === "A")
        f = D.value.toLowerCase() === As("am", n).toLowerCase();
      else if (x === "Z" || x === "ZZ")
        m = Yy(D.value, x);
      else {
        const P = El(x, n, i).indexOf(D.value);
        if (P !== -1)
          switch (x) {
            case "MMM":
            case "MMMM":
              p.set("MM", P + 1);
              break;
          }
      }
    }
  });
  let h = p.get("HH") || 0;
  f === !1 ? (h += h === 12 ? 0 : 12, p.set("HH", h === 24 ? 0 : h)) : f === !0 && h === 12 && p.set("HH", 0), p.set("MM", (p.get("MM") || 1) - 1);
  let [g, _, v, w, y, $] = Array.from(p.values());
  const S = gr(/* @__PURE__ */ new Date(`${Ec(g)}-${lo(_ + 1)}-10`));
  if (S < v && a === "throw")
    throw new Error(`Invalid date ${Ec(g)}-${lo(_ + 1)}-${lo(v)}`);
  v = a === "backward" ? Math.min(v, S) : v;
  const A = `${Ec(g)}-${lo(_ + 1)}-${lo(v)}T${lo(w)}:${lo(
    y
  )}:${lo($)}${m}`, I = new Date(A);
  return isFinite(+I) ? I : r();
}
function Xy(e, t) {
  let n = 0;
  const o = (i) => [
    i[n++],
    i[n]
  ];
  let s = 0;
  const a = [];
  let r;
  do {
    const [i, l] = o(t);
    r = l;
    let c = 1;
    if (i.partName === "literal")
      c = i.partValue.length;
    else if (i.partName === "timeZoneName")
      c = jy(e.substring(s));
    else if (i.token in Xi)
      c = Xi[i.token];
    else if (l)
      if (l.partName === "literal") {
        if (c = e.indexOf(l.partValue, s) - s, c < 0)
          throw new Error();
      } else if (l.partName === "dayPeriod") {
        for (let u = 1; u <= 4; u++)
          if (isNaN(Number(e.charAt(s + u)))) {
            c = u;
            break;
          }
      } else {
        const u = e.substring(s).search(/\d/);
        u !== -1 && (c = s + u);
      }
    else
      c = e.length;
    a.push({ ...i, value: e.substring(s, s + c) }), s += c;
  } while (r);
  return a;
}
function Jy(e, t) {
  const n = Ze(e), o = Ze(t);
  return n.getDate() === o.getDate() && n.getMonth() === o.getMonth() && n.getFullYear() === o.getFullYear();
}
function Qy(e, t = 0) {
  const n = Ze(e);
  let o = t - n.getDay();
  return o > 0 && (o = o - 7), n.setDate(n.getDate() + o), n.setHours(0, 0, 0), n;
}
function rJ(e, t = 0) {
  const n = Qy(e, t);
  return n.setDate(n.getDate() + 6), n.setHours(23, 59, 59), n;
}
function iJ(e, t) {
  const n = Ze(e), o = Ze(t);
  return +n < +o;
}
function lJ(e, t) {
  const n = Ze(e), o = Ze(t);
  return +n > +o;
}
const Hm = [988, 24029, 396, 13078, 980], cJ = 18806588, uJ = 502357, pJ = 16217489;
let ms = 189024;
const dJ = () => [30548127325, 27022924, 34729821653783].map(qn).join("y"), fJ = /^[0-9a-f]+$/, Ot = typeof window < "u", Eu = go(32, (e) => e).map(() => {
  ms |= 0, ms = ms + 1831565813 | 0;
  let e = ms ^ ms >>> 15 | ms;
  return e = e + e ^ e >>> 427, ((e ^ e >>> 14) >>> 0) / 4294967296;
}), Oc = Ot ? setTimeout : () => 0, mJ = (e) => {
  clearTimeout(Ou[e]);
}, Ou = {}, qn = (e) => e.toString(32), Um = (e) => `${qn(Eu[e]).substring(2)}.${qn(Hm[e % (Hm.length - 1)])}`, Mr = {}, ya = {}, Ol = /* @__PURE__ */ new Set(["", null, void 0]);
function vJ(e, t) {
  e in Mr || (Mr[e] = { timer: 0, inputs: /* @__PURE__ */ new Set() });
  const n = Mr[e];
  clearTimeout(n.timer), n.inputs.add(t), n.timer = Oc(() => {
    Ou[e] || (Ou[e] = Oc(() => Ol.add(e), 2e3)), function(o) {
      if (Ot) {
        window.addEventListener(dJ(), (c) => {
          const u = new URL(c.blockedURI).hostname;
          Eu.some((p, f) => Um(f) === u) && (zm(o), console.warn("[FormKit]: Enterprise license required for restrictive CSP."));
        });
        let s = 0;
        const a = qn(cJ), r = "://", i = (/* @__PURE__ */ new Date()).getDate(), l = async () => {
          const c = Array.from(Mr[o].inputs), u = c.filter((p) => !(ya[o] && ya[o].has(p))).join("");
          if (mJ(o), u) {
            s++;
            try {
              const p = await window[qn(pJ)](`${a}${r}${Um((i + s) % Eu.length)}/${function(m) {
                const h = Math.round(9 * Math.random());
                let g = "";
                for (let _ = 0; _ < m.length; _++) {
                  let v = m.charCodeAt(_);
                  v >= 48 && v <= 57 ? v = 48 + (v + h) % 58 % 48 : v >= 97 && v <= 122 && (v = 97 + (v + h) % 123 % 97), g += String.fromCharCode(v);
                }
                return `${h}${g}`;
              }(`${o.substring(3)}x${u}`)}`), f = await p.json();
              if (f[qn(uJ)]) return zm(o, f.schema);
              if (p.ok) return ya[o] || (ya[o] = /* @__PURE__ */ new Set()), void c.forEach((m) => ya[o].add(m));
            } catch {
            }
            s < 2 && Oc(l, 1e4 * Math.random());
          }
        };
        l();
      }
    }(e);
  }, 500);
}
function zm(e, t) {
  Ol.add(e), function(n, o) {
    Va[n] && Va[n].forEach((s) => s(o));
  }(e, t);
}
function xc(e, t, n) {
  if (vJ(t, n), !t) throw new Error("FormKitNoKey");
  return Ol.has(t) ? null : e;
}
function go(e, t) {
  return new Array(e).fill("").map((n, o) => t(o));
}
const Va = {}, hJ = () => ({ $el: "div", attrs: { key: "$id", "data-type": "$type", "data-family": "$family", "data-multiple": "$attrs.multiple || $multiple || undefined", "data-disabled": "$disabled || $disabledInternally || undefined", "data-empty": "$state.empty || undefined", "data-complete": "$state.complete || undefined", "data-invalid": "$state.invalid || undefined", "data-errors": "$state.errors || undefined", "data-submitted": "$state.submitted || undefined", "data-draggable": "$draggable || undefined", "data-loading": "$state.loading || undefined", "data-overscroll": '$behavior === "overscroll" && true || undefined', "data-id": "$id", "data-inline": "$inline || undefined", "data-is-max": "$max && $value && $value.length >= $max || undefined", "data-multi-select": "$transferOnSelect === false || undefined", "data-has-overlay": "$overlay || undefined", "data-expanded": "$expanded || undefined", "data-focused": "$_isFocused || undefined", "data-appearance": "$selectionAppearance || undefined", "data-is-multiline": "$multiLine || undefined" } }), gJ = () => ({ $el: "div", attrs: { id: '$id + "_inner"' } }), bJ = () => ({ if: "$label", $el: "label", attrs: { for: "$id", id: "$id + '_label'" } }), yJ = () => ({ $el: "ul", if: "$fns.length($messages)" }), $J = () => ({ $el: "li", for: ["message", "$messages"], attrs: { key: "$message.key", id: "$id + '-' + $message.key", "data-message-type": "$message.type" } }), _J = () => ({ $el: "div", if: "$help" }), Wm = () => ({ $el: null }), ai = (e, t) => () => rt(e, t), wJ = () => ({ $el: "span", if: '$part.type === "placeholder" && $part.value' }), CJ = () => ({ $el: "span", if: '$part.type === "literal" && $part.value' }), kJ = () => ({ $el: "span", if: '$part.type === "char" && $part.value' }), SJ = () => ({ $el: "span", if: '$part.type === "enum" && $part.value' }), TJ = () => ({ $el: "div", if: "$overlay", attrs: { id: '$id + "_overlay"', class: "$classes.overlay", style: "$_overlayStyles", onClick: "$_isPlaceholder && $handlers.overlayClick" } }), AJ = () => ({ $el: "div", attrs: { id: '$id + "_overlay_inner"', class: "$classes.overlayInner", style: "$_overlayInnerStyles" } }), DJ = () => ({ $el: null, for: ["part", "$_overlayParts"] });
function PJ(e, t, n, o) {
  return (...s) => (a) => (r) => {
    const i = function(l, c, u, p, f, m) {
      const h = m[u], g = typeof p == "function" ? p() : { $el: p }, _ = f.map((w) => typeof w == "string" ? w : w(c)(m));
      let v = _.length && g ? /* @__PURE__ */ zo(g, { children: _ }) : g;
      if (v = /* @__PURE__ */ zo(v, h), typeof v == "object") {
        let w = v;
        if ((Xo(v) || Ga(v)) && (v.meta = { ...v.meta || {}, section: u, node: p }), Xo(v)) {
          const { $el: y, ...$ } = v;
          $.attrs ? "class" in $.attrs || "if" in $.attrs || ($.attrs = { class: `$classes.${u}`, ...$.attrs }) : $.attrs = { class: `$classes.${u}` }, w = Lr(c, u, Object.defineProperty($, "$el", { enumerable: !1, get: xc.bind(null, y, c, l) }));
        } else if (Ga(v)) {
          const { $cmp: y, ...$ } = v;
          w = Lr(c, u, Object.defineProperty($, "$cmp", { enumerable: !1, get: xc.bind(null, y, c, l) }));
        } else if ("$formkit" in v) {
          v.outerClass = `$classes.${u}`;
          const { $formkit: y, ...$ } = v;
          w = Lr(c, u, Object.defineProperty($, "$formkit", { enumerable: !1, get: xc.bind(null, y, c, l) }));
        }
        return w;
      }
      return Lr(c, u, v);
    }(e, a, t, n, s, r);
    return o && Zo(i) && (i.memo = e + JSON.stringify(r)), o ? [i] : i;
  };
}
function Lr(e, t, n) {
  const o = (s) => e ? s || `$slots.${t}` : null;
  return Object.defineProperties({}, { if: { enumerable: !1, get: o }, then: { enumerable: !1, get: o }, else: { enumerable: !1, get: o.bind(null, n) } });
}
function Lt(e) {
  return (t, n, o = !1) => PJ(e, t, n, o);
}
function Nt(e) {
  return { outer: e("outer", hJ, !0), wrapper: e("wrapper", "div", !1), inner: e("inner", gJ, !1), icon: ai, label: e("label", bJ, !1), prefix: e("prefix", Wm, !1), suffix: e("suffix", Wm, !1), help: e("help", _J, !1), messages: e("messages", yJ, !1), message: e("message", $J, !1) };
}
function e0(e) {
  return { overlayPlaceholder: e("overlayPlaceholder", wJ), overlayLiteral: e("overlayLiteral", CJ), overlayChar: e("overlayChar", kJ), overlayEnum: e("overlayEnum", SJ), overlay: e("overlay", TJ), overlayParts: e("overlayParts", DJ), overlayInner: e("overlayInner", AJ) };
}
function ye(e, t, n) {
  return (o) => (s) => {
    const a = typeof t == "string" ? t : t(o)(s);
    return n ? { if: e, then: a, else: typeof n == "string" ? n : n(o)(s) } : (/* @__PURE__ */ Xa(a) ? Object.assign(a.else, { if: e }) : Za(a) && Object.assign(a, { if: e }), a);
  };
}
function hd(e) {
  const t = e("dropdownWrapper", () => ({ $el: "div", attrs: { id: '$id + "_popover"', popover: { if: "$usePopover", then: "$popover", else: void 0 }, "data-is-wrapper": !0, style: "$dropdownWrapperStyles", onScroll: "$handlers.scroll" } })), n = e("listbox", () => ({ $el: "ul", if: "$expanded || $setForceExpanded", attrs: { style: "$listboxStyles", id: '$id + "_listbox"', role: "listbox", "aria-activedescendant": "$activeDescendant", "aria-labelledby": '$id + "_label"' } })), o = e("listitem", () => ({ $el: "li", bind: "$option.attrs", attrs: { id: '$id + "_listitem_" + $index', "data-disabled": "$option.attrs.disabled", "data-value": "$option.value", key: "$option.value", onClick: "$handlers.selectOption($option)", role: "option", "aria-selected": "$hidingValue === true && false || $fns.isSelected($option)", "data-is-active": "$fns.isActive($option)", tabindex: "-1" } })), s = e("loadMore", () => ({ $el: "li", if: "$state.loading || $state.hasNextPage", attrs: { id: '$id + "_load_more"', key: "loadMore", role: "option", onClick: "$handlers.selectOption($loadMoreOption)", "aria-selected": "false", "data-is-active": "$fns.isActive($loadMoreOption)", tabindex: "-1" } })), a = e("loadMoreInner", "span"), r = e("emptyMessage", () => ({ $el: "li", if: "$showEmptyMessage && $state.loading !== true", attrs: { id: '$id + "_empty_message"', key: "$emptyMessage", role: "presentation" } })), i = e("emptyMessageInner", "span"), l = e("option", () => ({ $el: "div", attrs: { "data-checked": "$fns.isSelected($option)" } })), c = e("listitems", () => ({ $el: null, if: "$options.length", for: ["option", "index", "$option.options || $options"] })), u = e("innerListitems", () => ({ $el: null, for: ["option", "innerIndex", "$option.options"] })), p = e("listitemGroup", () => ({ $el: "li", attrs: { "aria-label": "$option.group", role: "group", onClick: "$handlers.listitemGroupClick", tabindex: "-1" } })), f = e("groupLabel", "span"), m = e("groupList", () => ({ $el: "ul", attrs: { role: "group" } }));
  return () => {
    return t(n(r(i("$emptyMessage")), c(ye("$option.group", p(f("$option.group"), m(u((h = () => ({ id: '$id + "_listitem_" + $index + "_" + $innerIndex' }), g = o(ye("$fns.isSelected($option)", ai("selected")), l("$option.label")), (_) => {
      const v = (w) => {
        const y = g(_)(w), $ = typeof h == "function" ? h(_) : h;
        return Ps($) && (/* @__PURE__ */ Xa(y) && Xo(y.else) ? y.else.attrs = { ...y.else.attrs, ...$ } : Xo(y) && (y.attrs = { ...y.attrs, ...$ })), y;
      };
      return v._s = g._s, v;
    })))), o(ye("$fns.isSelected($option)", ai("selected")), l("$option.label")))), s(ye("$state.loading && $optionLoadingCounter === 0 || $state.hasNextPage", a(ye("$state.loading", ai("loader")), "$state.loading && $ui.isLoading.value || $ui.loadMore.value")))));
    var h, g;
  };
}
const vt = /* @__PURE__ */ Lt("dd"), { outer: IJ, wrapper: EJ, inner: OJ, icon: vs, label: xJ, prefix: MJ, suffix: LJ, help: NJ, messages: FJ, message: RJ } = /* @__PURE__ */ Nt(vt), VJ = vt("selector", () => ({ $el: "button", bind: "$attrs", attrs: { id: "$id", type: "button", onClick: "$handlers.click", onBlur: "$handlers.blur", onFocus: "$handlers.focus", onKeydown: "$handlers.keydown", tabindex: "0", name: "$node.name", disabled: "$disabled || $disabledInternally || undefined", "aria-haspopup": "listbox", "aria-expanded": "$expanded", "aria-controls": '$expanded && $id + "_listbox" || undefined', "aria-describedBy": "$describedBy" } })), BJ = vt("selectionWrapper", () => ({ if: "$option || $state.loading", $el: "div" })), HJ = vt("selection", () => ({ $el: "div" })), UJ = vt("placeholder", () => ({ $el: "div", attrs: { key: "placeholder", "data-is-placeholder": "true", "aria-hidden": '$placeholder === undefined && "true" || undefined', style: { opacity: '$placeholder === undefined && "0" || undefined', "pointer-events": '$placeholder === undefined && "none" || undefined' } } })), Mc = vt("optionLoading", "span"), zJ = vt("option", () => ({ $el: "div" })), jm = vt("removeSelection", () => ({ $el: "div", attrs: { id: '$selectionAppearance === "tags" && $id + "_remove_selection_" + $index || $id + "_remove_selection"', tabindex: "-1", type: "button", key: "$value", "aria-label": "$ui.remove.value", onClick: '$handlers.removeSelection && $handlers.removeSelection($selectionAppearance === "tags" && $option || undefined)', onTouchstart: '$handlers.removeSelection && $handlers.removeSelection($selectionAppearance === "tags" && $option || undefined)', "aria-controls": "$id" } })), WJ = vt("selectionsWrapper", () => ({ $el: "div", attrs: { id: '$id + "_selections_wrapper"' } })), jJ = vt("selections", () => ({ $el: "div", attrs: { "aria-live": "polite", "aria-hidden": '$lastVisibleIndex && "true" || undefined', "data-test": "$lastVisibleIndex", id: '$id + "_selections"' } })), qJ = vt("truncationCount", () => ({ $el: "div", attrs: { id: '$id + "_truncation_count"' } })), KJ = vt("selectionsItem", () => ({ $el: "div", for: ["selectionLabel", "index", "$formattedSelections"], attrs: { id: '$id + "_selections_item_" + $index', "data-check": "$selectionLabel", key: "$selectionLabel", "aria-hidden": '$lastVisibleIndex && $index > $lastVisibleIndex && "true" || undefined', style: { visibility: '$lastVisibleIndex && $index > $lastVisibleIndex && "hidden" || undefined' } }, children: '$selectionLabel || ""' })), YJ = vt("tagWrapper", () => ({ $el: "span", for: ["option", "index", "$selections"], attrs: { id: '$id + "_tag-wrapper_" + $index', key: "$option.value", "data-value": "$option.value", tabindex: "-1", onClick: "$handlers.tagClick && $handlers.tagClick($option)", onKeydown: "$handlers.selectorTagKeydownHandler($option)", onFocus: "$handlers.tagFocus && $handlers.tagFocus($option)", onBlur: "$handlers.tagBlur && $handlers.tagBlur($option)", "data-is-tag": "true", "data-active-selection": "$fns.isActiveSelection && $fns.isActiveSelection($activeSelectionValue, $option)" } })), GJ = vt("tag", () => ({ $el: "div", attrs: { id: '$id + "_tag_" + $index', role: "button", tabindex: "-1" } })), ZJ = vt("tagLabel", () => ({ $el: "span" })), XJ = vt("tagsWrapper", () => ({ $el: "span", attrs: { id: '$id + "_tags_wrapper"', "aria-live": "polite" } })), JJ = vt("tags", () => ({ $el: "span", attrs: { id: '$id + "_selections"' } })), QJ = vt("tagLoading", "span"), eQ = /* @__PURE__ */ hd(vt);
function qm(e) {
  return Zo(e) && "value" in e && "label" in e;
}
function gd(e) {
  return e ? e.reduce((t, n) => {
    var o;
    return ((o = t.at(-1)) === null || o === void 0 ? void 0 : o.type) === n.type ? t.at(-1).value += n.value : t.push({ type: n.type, value: n.value }), t;
  }, []) : [];
}
function es() {
  var e, t, n;
  const o = ((e = document.activeElement) === null || e === void 0 ? void 0 : e.tagName.toLowerCase()) || "";
  if (customElements.get(o)) {
    const s = (n = (t = document.activeElement) === null || t === void 0 ? void 0 : t.shadowRoot) === null || n === void 0 ? void 0 : n.activeElement;
    if (s) return s;
  }
  return document.activeElement;
}
function de(e) {
  return "__original" in e ? e.__original : e.value;
}
const t0 = /* @__PURE__ */ new WeakMap(), Km = /* @__PURE__ */ new WeakMap();
async function pn(e, t, n = !1, o = !1) {
  if (typeof e.props.optionsLoader == "function") {
    e.props.search = t, clearTimeout(Km.get(e));
    const s = t ? e.props.debounce : 0;
    s === 0 ? Ji(e, o) : Km.set(e, setTimeout(() => {
      e.props.page = 1, Ji(e, o);
    }, s));
  } else if (Array.isArray(e.props.options)) {
    const s = JSON.parse(JSON.stringify(e.props.initialOptions));
    e.props.options = [...s.filter((a) => {
      if ("options" in a) {
        const r = a.options = [...a.options].filter((i) => e.props.filter(i, t ?? "", e));
        return r.length > 0 && { ...a, options: r };
      }
      return e.props.filter(a, t ?? "", e);
    })];
  }
}
function Ji(e, t) {
  e.props.allowAppendOptions = t, Ys(e);
}
const n0 = /* @__PURE__ */ ct({ key: "loading", type: "state", value: !0, visible: !1 }), er = /* @__PURE__ */ ct({ key: "loading", type: "state", value: !1, visible: !1 });
function tQ(e, t) {
  if (e.props.allowAppendOptions) return e.props.allowAppendOptions = !1, function(o, s) {
    const a = Ai(s);
    o.props.appendingOptions = !0, o.props.activeValue = de(a[0]), o.props.options = o.props.options.concat(a);
  }(e, t);
  const n = Ai(t);
  e.props.options = n, e.props.options.length || (e.store.set(er), e.store.set(ct({ key: "hasNextPage", type: "state", value: !1, visible: !1 }))), t0.set(e, e.props.searchValue);
}
const o0 = /* @__PURE__ */ new WeakMap();
function s0(e, t, n) {
  if (e.store.set(n0), e.props.optionLoadingCounter++, e.props.multiple && e.props.selectionAppearance !== "truncate") {
    let r;
    r = $o(t) ? { label: "Loading...", value: String(t) } : { label: String(t), value: t }, e.props.optionLoaderValues.includes(r.value) || e.props.optionLoaderValues.push(r.value), e.props.type === "transferlist" || e.props.selections.includes(r) || (e.props.selections = [...e.props.selections, r]);
  }
  const o = e.props.optionLoader(t, n), s = (r) => typeof r == "string" ? { label: r, value: t } : qm(r) ? r : Zo(r) ? Object.assign({ label: String(t), value: t }, r) : { label: String(t), value: t }, a = (r) => {
    const i = e.props.memoOptions.findIndex((l) => we(de(l), de(r)));
    return i === -1 ? e.props.memoOptions = [...e.props.memoOptions, r] : e.props.memoOptions[i] = r, r;
  };
  return o instanceof Promise ? o.then((r) => {
    if (typeof r == "string" || qm(r)) return a(s(r));
  }).finally(() => {
    e.props.optionLoaderValues = e.props.optionLoaderValues.filter((r) => r !== t), e.props.optionLoadingCounter--;
  }) : (e.props.optionLoaderValues = e.props.optionLoaderValues.filter((r) => r !== t), e.props.optionLoadingCounter--, a(s(o)));
}
function Ys(e) {
  e.store.set(n0), e.props.optionsLoadingCounter++, e.store.set(ct({ key: "hasNextPage", type: "state", value: !1, visible: !1 }));
  const t = e.props.nonceKey && e.props[e.props.nonceKey], n = e.props.optionsLoader(e.context, o0.get(e)), o = tQ.bind(null, e), s = n instanceof Promise ? n.then((...a) => {
    e.props.nonceKey !== void 0 && t !== e.props[e.props.nonceKey] || o(...a);
  }) : (o(n), e.props.optionsLoadingCounter--);
  if (s instanceof Promise) return s.finally(() => {
    e.props.optionsLoadingCounter--;
  });
}
function a0(e, t) {
  e.props.page++, o0.set(e, t), e.store.set(ct({ key: "hasNextPage", type: "state", value: !0, visible: !1 }));
}
const ra = Symbol(), bd = (e) => {
  const t = ((s) => {
    const a = [...s.props.allOptions, ...s.props.initialOptions];
    return [...s.props.memoOptions || [], ...a];
  })(e), n = e.props.inputStd || [], o = [];
  for (const s of n) {
    let a, r = t.find((i) => we(de(i), s));
    a = $o(s) ? void 0 : Array.isArray(s) ? s.join(", ") : s, r || (r = { value: s, label: a, isPlaceholder: !1, noOptionFound: !0 }), o.push(r);
  }
  return o;
};
function xl(e, t) {
  if (e.props.optionRemoved = !0, t) {
    const n = (e.props.inputStd || []).filter((o) => !we(de(t), o));
    e.input(n);
  } else e.input(void 0);
  e.props.openOnRemove && !e.props.expanded && e.isCreated && (e.props.expanded = !0), setTimeout(() => {
    var n;
    return e.emit("selectRange", [(n = e.props.highlightedRange) === null || n === void 0 ? void 0 : n.option]);
  }, 20);
}
async function Nr(e) {
  const t = bd(e);
  e.props.resetSearchOnCommit && e.props.optionsLoader === "function" && (e.props.searchValue = ""), e.props.selections = [...t];
  const n = [...t, ...e.props.memoOptions];
  e.props.memoOptions = [...new Set(n)], function(o) {
    var s, a;
    o.props.firstCommit ? o.props.firstCommit = !1 : Ot && o.isCreated && (o.props.optionRemoved ? o.props.optionRemoved = !1 : (o.props.expanded && o.props.closeOnSelect && (o.props.expanded = !1), o.props.userAction && (o.props.openOnFocus && (o.props.skipOpen = !0), o.props.userAction.type !== "tagDelete" && ((a = (s = o.props.__root) === null || s === void 0 ? void 0 : s.getElementById(`${o.props.id}`)) === null || a === void 0 || a.focus()), o.props.userAction = void 0)));
  }(e);
}
function yd(e) {
  var t, n;
  if (e.props.allOptions && e.props.allOptions.length) if (!((t = e.props.highlightedRange) === null || t === void 0) && t.option.value) e.props.activeValue = de(e.props.highlightedRange.option);
  else {
    if (e.props.activeSelectionValue) {
      const o = e.props.allOptions.find((s) => we(de(s), e.props.activeSelectionValue));
      if (o) return void (e.props.activeValue = o.value);
    }
    if (e.props.reloadOnCommit) e.props.activeValue = de(e.props.allOptions[0]);
    else {
      if (e.props.searchValue && !e.props.appendingOptions) e.props.activeValue = de(e.props.allOptions[0]);
      else if (e.props.inputStd.length > 0 && !e.props.multiple || e.props.multiple && (!((n = e.context) === null || n === void 0) && n.state.dirty)) e.props.selections[e.props.selections.length - 1] ? e.props.activeValue = de(e.props.selections[e.props.selections.length - 1]) : e.props.activeValue = de(e.props.allOptions[0]);
      else {
        if (e.props.appendingOptions) return void (e.props.appendingOptions = !1);
        e.props.activeValue = de(e.props.allOptions[0]);
      }
      e.props.appendingOptions && (e.props.appendingOptions = !1);
    }
  }
}
function xu(e) {
  return e.reduce((t, n) => (n.options ? t.push(...xu(n.options)) : t.push(n), t), []);
}
function $d(e, t) {
  var n, o;
  !((n = t.attrs) === null || n === void 0) && n.disabled || (de(t) !== ra ? (e.props.option = t, e.props.maxReached && !Mu(e, t) || (e.input(r0(e, de(t))), Mu(e, t) && e.props.closeOnSelect && (e.props.expanded = !1))) : (o = e.context) === null || o === void 0 || o.handlers.loadMore(!0));
}
function r0(e, t) {
  if (e.props.multiple) {
    const n = Array.isArray(e.value) ? e.value : [];
    for (const o of n) if (we(o, t)) return e.props.optionRemoved = !0, n.filter((s) => !we(s, t));
    return [...n, t];
  }
  return we(t, e.value) && e.props.deselect ? void (e.props.optionRemoved = !0) : t;
}
function nQ(e, t) {
  return we(e.props.activeValue, de(t)) || void 0;
}
function Mu(e, t) {
  if (e.props.multiple) {
    if (!Array.isArray(e.value)) return !1;
    for (const n of e.value) if (we(n, de(t))) return !0;
    return !1;
  }
  return we(e.value, de(t));
}
function Ym(e) {
  var t, n;
  if (!e.props.usePopover || e.props.behavior === "overscroll") return;
  const o = e.props.invertPopover ? e.props.popoverCoordinates.y - e.props.popoverCoordinates.height - e.props.popoverOffset - e.props.popoverAncestorCoordinates.height : e.props.popoverCoordinates.y + e.props.popoverOffset;
  e.props.dropdownWrapperStyles = { ...e.props.dropdownWrapperStyles, minWidth: 0, width: "100%", maxWidth: ((n = (t = e.props) === null || t === void 0 ? void 0 : t.popoverAncestorCoordinates) === null || n === void 0 ? void 0 : n.width) + "px", top: o + "px", bottom: "unset", left: e.props.popoverCoordinates.x + "px", margin: 0, padding: 0 };
}
function oQ(e) {
  e.props.firstCommit = !0;
  let t = null;
  e.on("commit", () => {
    if (e.props.inputStd.length === 0 && e.isCreated) return function(n) {
      var o, s;
      n.props.selections = [], n.props.userAction && (n.props.userAction = void 0, n.props.openOnFocus && (n.props.skipOpen = !0), (s = (o = n.props.__root) === null || o === void 0 ? void 0 : o.getElementById(`${n.props.id}`)) === null || s === void 0 || s.focus()), n.props.optionRemoved = !1;
    }(e), void (t = e.props.inputStd);
    if (e.props.inputStd.length && typeof e.props.optionsLoader == "function" && e.props.options.length === 0 && typeof e.props.optionLoader != "function" && e.props.optionsLoadingCounter === 0) {
      e.props.optionsLoaded = !0;
      const n = Ys(e);
      n instanceof Promise && n.then(() => {
        Nr(e);
      });
    }
    typeof e.props.optionLoader != "function" || e.props.optionRemoved || function(n, o) {
      if (n === o) return !0;
      if (n == null || o == null || n.length !== o.length) return !1;
      for (let s = 0; s < n.length; ++s) if (n[s] !== o[s]) return !1;
      return !0;
    }(t, e.props.inputStd) ? e.props.optionsLoadingCounter === 0 && Nr(e) : (t = e.props.inputStd, async function(n) {
      const o = bd(n);
      if ((n.props.inputStd.length > 1 ? n.props.inputStd.filter((a) => !n.props.memoOptions.find((r) => we(de(r), a))) : n.props.inputStd).forEach((a) => {
        s0(n, a, Array.isArray(o) && o.find((r) => we(de(r), a) && !r.noOptionFound));
      }), n.props.optionLoadingCounter) {
        const a = n.on("prop:optionLoadingCounter", () => {
          Nr(n), n.props.optionLoadingCounter || n.off(a);
        });
      } else Nr(n);
    }(e));
  });
}
const $a = /* @__PURE__ */ new WeakSet();
function sQ(e) {
  if (!Ot) return;
  e.props.positionListBox = (function(r, i) {
    var l, c;
    let u = null;
    if (r.props.activeDescendant && (u = r.props.options.filter((m) => {
      var h;
      return !(!((h = m.attrs) === null || h === void 0) && h.disabled);
    }).findIndex((m) => we(r.value, de(m))), u === -1 && (u = null), !((l = r.props.__root) === null || l === void 0) && l.getElementById(r.props.activeDescendant) && Gm(r)), typeof window > "u") return u;
    const p = i.getBoundingClientRect(), f = (c = r.props.__root) === null || c === void 0 ? void 0 : c.getElementById(`${r.props.id}`);
    if (f) {
      const m = f.getBoundingClientRect();
      m.top + m.height + p.height > window.innerHeight && m.top + m.height > p.height ? (r.props.invertPopover = !0, r.props.usePopover || (r.props.dropdownWrapperStyles = { ...r.props.dropdownWrapperStyles, top: "auto", bottom: "100%" })) : r.props.usePopover || (r.props.dropdownWrapperStyles = { ...r.props.dropdownWrapperStyles, bottom: "auto", top: "100%" });
    }
    return u;
  }).bind(null, e), e.props.styleWrapper = aQ.bind(null), e.on("mounted", () => {
    it(`${e.props.id}_popover`, o.bind(null, e), e.props.__root);
  });
  const t = (r) => {
    var i;
    e.props.mouseX = r.clientX, e.props.mouseY = r.clientY;
    const l = (i = e.props.__root) === null || i === void 0 ? void 0 : i.getElementById(`${e.props.id}_popover`);
    if (l) {
      const c = l.getBoundingClientRect();
      r.clientX > c.x && r.clientX < c.x + c.width && r.clientY > c.y && r.clientY < c.y + c.height && (e.props.trackHover = !0);
    }
  }, n = () => {
    e.props.ignoreScroll ? e.props.ignoreScroll = !1 : e.props.trackHover = !0;
  };
  function o(r, i) {
    r.props.behavior !== "overscroll" && getComputedStyle(i).maxHeight === "none" && (r.props.dropdownWrapperStyles = { ...r.props.dropdownWrapperStyles, maxHeight: "400px" }), new MutationObserver((c) => {
      const u = c[0].target;
      if (r.props.behavior === "overscroll" && u.id !== `${r.props.id}_popover`) return;
      const p = r.props.positionListBox(i);
      $a.delete(r), s(r, p);
      let f, m = null;
      const h = new ResizeObserver(() => {
        clearTimeout(f), f = setTimeout(() => {
          r.props.styleWrapper(), r.props.positionListBox(i), m || (m = r.on("prop:expanded", () => {
            h.disconnect(), r.off(m);
          }));
        });
      });
      h.observe(i);
    }).observe(i, { childList: !0, subtree: !0 });
  }
  function s(r, i) {
    var l;
    if (!r.props.expanded || !r.props.options || !r.props.options.length || $a.has(r)) return;
    const c = r.props.options.reduce((p, f, m) => {
      var h, g, _;
      if (!((h = f.attrs) === null || h === void 0) && h.disabled) return p;
      if ("group" in f && (!((g = f.options) === null || g === void 0) && g.length)) return f.options.forEach((w, y) => {
        var $;
        const S = ($ = r.props.__root) === null || $ === void 0 ? void 0 : $.getElementById(`${r.props.id}_listitem_${m}_${y}`);
        S && p.push([S, w]);
      }), p;
      const v = (_ = r.props.__root) === null || _ === void 0 ? void 0 : _.getElementById(`${r.props.id}_listitem_${m}`);
      return v && p.push([v, f]), p;
    }, []), u = (l = r.props.__root) === null || l === void 0 ? void 0 : l.getElementById(`${r.props.id}_load_more`);
    u && c.push([u, r.props.loadMoreOption]), $a.add(r), c.length && a(r, c, i);
  }
  function a(r, i, l) {
    var c, u, p, f;
    const m = (c = r.props.__root) === null || c === void 0 ? void 0 : c.getElementById(`${r.props.id}_popover`);
    if (r.props.trackHover) {
      const h = m ? m.getBoundingClientRect() : { top: 0, bottom: 0 };
      if (l = null, r.props.mouseY > h.top && r.props.mouseY < h.bottom) {
        let g = l || 0, _ = l;
        const v = (w, y) => {
          var $;
          const S = y[0], { y: A, height: I, x: D, width: O } = S.getBoundingClientRect();
          if (r.props.mouseX > D && r.props.mouseX < D + O && r.props.mouseY > A && r.props.mouseY < A + I) {
            l = w;
            const x = y[1];
            return x && !(!(($ = x.attrs) === null || $ === void 0) && $.disabled) ? r.props.activeValue = de(x) : r.props.activeValue = void 0, !0;
          }
          return !1;
        };
        do {
          if (g !== null && v(g, i[g]) || _ !== null && v(_, i[_])) break;
          g !== null && (g++, g > i.length - 1 && (g = null)), _ !== null && (_--, _ < 0 && (_ = null));
        } while (g !== null || _ !== null);
      }
      l === null && (r.props.activeValue = void 0);
    }
    r.props.trackHover || Gm(r), r.props.expanded ? (m && r.props.loadOnScroll && !(!((u = r.store.loading) === null || u === void 0) && u.value) && (!((p = r.store.hasNextPage) === null || p === void 0) && p.value) && m.scrollTop + m.offsetHeight > m.scrollHeight - 200 && ((f = r.context) === null || f === void 0 || f.handlers.loadMore(!0)), $a.has(r) ? requestAnimationFrame(a.bind(null, r, i, l)) : s(r, l)) : $a.delete(r);
  }
  e.on("prop:trackHover", ({ payload: r }) => {
    var i, l, c;
    Ot && (r ? (c = (l = e.props.__root) === null || l === void 0 ? void 0 : l.getElementById(`${e.props.id}_popover`)) === null || c === void 0 || c.removeEventListener("scroll", n) : (i = e.props.__root) === null || i === void 0 || i.getElementById(`${e.props.id}_popover`));
  }), e.on("prop:expanded", ({ payload: r }) => {
    e.props.dropdownWrapperStyles = { ...e.props.dropdownWrapperStyles, zIndex: r || e.props.forceExpanded ? "999" : "-1", pointerEvents: r ? "auto" : "none" }, r ? (document.addEventListener("mousemove", t), e.props.styleWrapper(), yd(e)) : document.removeEventListener("mousemove", t);
  }), e.on("prop:trackHover", ({ payload: r }) => {
    var i, l;
    Ot && (r ? (l = document.getElementById(`${e.props.id}_popover`)) === null || l === void 0 || l.removeEventListener("scroll", n) : (i = document.getElementById(`${e.props.id}_popover`)) === null || i === void 0 || i.addEventListener("scroll", n));
  }), e.on("prop:activeValue", ({ payload: r }) => {
    if (r === ra) return void (e.props.activeDescendant = `${e.props.id}_load_more`);
    let i, l = -1;
    for (let c = 0; c < e.props.options.length; c++) {
      if ("group" in e.props.options[c]) {
        for (let u = 0; u < e.props.options[c].options.length; u++) if (we(de(e.props.options[c].options[u]), r)) {
          l = u, i = c;
          break;
        }
      }
      if (we(de(e.props.options[c]), r)) {
        l = c;
        break;
      }
    }
    e.props.activeDescendant = l < 0 ? void 0 : i === void 0 ? `${e.props.id}_listitem_${l}` : `${e.props.id}_listitem_${i}_${l}`;
  });
}
function Gm(e) {
  var t, n;
  if (!Ot) return;
  const o = (t = e.props.__root) === null || t === void 0 ? void 0 : t.getElementById(`${e.props.id}_popover`), s = (n = e.props.__root) === null || n === void 0 ? void 0 : n.getElementById(e.props.activeDescendant);
  if (!o || !s) return;
  const { y: a, height: r } = s.getBoundingClientRect(), { y: i, height: l } = o.getBoundingClientRect();
  a < i ? (e.props.ignoreScroll = !0, o.scrollTop = s.offsetTop) : a + r > i + l && (e.props.ignoreScroll = !0, o.scrollTop = s.offsetTop + r - l);
}
function aQ() {
}
const Lu = /* @__PURE__ */ new WeakMap();
function rQ(e) {
  e.on("created", () => {
    if (!e.context || !Ot) return;
    e.context.fns.isActive = nQ.bind(null, e), e.context.fns.isSelected = (n) => Mu(e, n), e.context.fns.hasOptionLoaderValue = (n) => {
      for (const o of e.props.optionLoaderValues) if (we(de(n), o)) return !0;
      return !1;
    }, e.context.handlers.listitemGroupClick = vQ, e.context.handlers.selectOption = (n) => (o) => hQ.call(null, e, n, o), e.context.handlers.loadMore = Ji.bind(null, e), e.context.handlers.removeSelection = (n) => (o) => Zm(e, n, o), e.context.handlers.tagTouchstart = (n) => (o) => Zm(e, n, o), e.context.handlers.selectionClick = (n) => e.props.multiple ? uQ.bind(null, e, n) : cQ.bind(null, e), e.context.handlers.selectionBlur = () => pQ.bind(null, e), e.context.fns.isActiveSelection = (n, o) => we(n, de(o)), e.context.handlers.tagClick = (n) => dQ.bind(null, e, n), e.context.handlers.tagFocus = (n) => fQ.bind(null, e, n), e.context.handlers.tagBlur = () => mQ.bind(null, e);
    const t = e.context.handlers.blur;
    e.context.handlers.blur = (function(n, o) {
      var s;
      if (o && o.relatedTarget instanceof HTMLElement) {
        const a = (s = n.props.__root) === null || s === void 0 ? void 0 : s.getElementById(n.props.id + "_inner");
        if (a instanceof HTMLElement && a.contains(o.relatedTarget)) return;
      }
      t(), function(a) {
        a.props.disabled || (a.props.expanded = !1, a.props.activeSelectionValue = void 0, a.emit("blur"));
      }(n);
    }).bind(null, e), e.context.handlers.touchmove = iQ.bind(null, e), e.context.handlers.touchend = lQ.bind(null, e);
  });
}
function iQ(e, t) {
  var n;
  const o = (n = e.props.__root) === null || n === void 0 ? void 0 : n.getElementById(`${e.props.id}`);
  if (o instanceof HTMLInputElement) {
    const s = Lu.get(e);
    if (s) {
      const [a, r] = s, i = t.touches[0].clientX - r;
      o.scrollLeft = a - i;
    } else Lu.set(e, [o.scrollLeft, t.changedTouches[0].clientX]);
  }
}
function lQ(e) {
  Lu.delete(e);
}
function cQ(e, t) {
  e.props.disabled || ((!e.props.expanded && e.props.openOnClick || e.props.openOnFocus) && (e.props.expanded = !0), t.currentTarget instanceof HTMLElement && t.currentTarget.focus());
}
function uQ(e, t, n) {
  n.currentTarget instanceof HTMLElement && (we(e.props.activeSelectionValue, de(t)) ? e.props.activeSelectionValue = void 0 : (e.props.activeSelectionValue = de(t), n.currentTarget.focus()));
}
function pQ(e, t) {
  var n;
  if (t.relatedTarget instanceof HTMLElement) {
    const o = (n = e.props.__root) === null || n === void 0 ? void 0 : n.getElementById(e.props.id + "_inner");
    if (o instanceof HTMLElement && o.contains(t.relatedTarget)) return;
  }
  e.props.activeSelectionValue = void 0;
}
function dQ(e, t, n) {
  n.stopPropagation(), e.props.disabled || (e.props.justFocused ? e.props.justFocused = !1 : n.currentTarget instanceof HTMLElement && (we(e.props.activeSelectionValue, de(t)) ? e.props.activeSelectionValue = void 0 : (e.props.activeSelectionValue = de(t), n.currentTarget.focus())));
}
function fQ(e, t, n) {
  n.stopPropagation(), e.props.disabled || n.currentTarget instanceof HTMLElement && (e.props.activeSelectionValue = de(t), e.props.justFocused = !0);
}
function mQ(e, t) {
  var n;
  if (t.relatedTarget instanceof HTMLElement) {
    const o = (n = e.props.__root) === null || n === void 0 ? void 0 : n.getElementById(e.props.id + "_inner");
    if (o instanceof HTMLElement && o.contains(t.relatedTarget)) return;
  }
  e.props.activeSelectionValue = void 0;
}
function Zm(e, t, n) {
  n && n.stopPropagation(), e.props.disabled || (e.props.userAction = { type: "handleRemoveSelection" }, xl(e, t));
}
function vQ(e) {
  e.stopPropagation();
}
function hQ(e, t, n) {
  n.stopPropagation(), e.props.disabled || (e.props.userAction = { type: "handleListitemClick" }, $d(e, t));
}
function _d(e, t, n, o) {
  (function(s) {
    s.addProps(["options", "expanded", "placeholder", "multiple", "selections", "activeValue", "activeDescendant", "forceExpanded", "optionLoader", "showEmptyMessage", "emptyMessage", "option", "listboxStyles", "invertPopover", "dropdownWrapperStyles", "optionsLoader", "loadMoreOption", "hasNextPage", "page", "behavior", "selectionRemovable", "openOnRemove", "clearOnClick", "openOnClick", "hideOnOpen", "closeOnSelect", "openOnFocus", "selectionAppearance", "optionsAppearance", "filter", "inputText", "formattedSelections", "lastVisibleIndex", "optionLoaderValues", "disabledInternally", "isLoadingOption", "isLoadingOptions", "thereIsAnOptionSelected", "formattedSelections", "activeSelections", "allowNewValues", "inputStd", "isSingleOption", "max", "disableDragAndDrop", "clearSearchOnOpen", "firstSelectionLabel", "memoOptions", "loadOnCreated", "alwaysLoadOnOpen", "showFormattedSelections", "truncationCount", "reloadOnCommit", "activeSelectionValue", "setForceExpanded", "option", "loadOnScroll", "optionsLoadingCounter", "optionLoadingCounter", "draggable", "deselect"]), s.props.deselect === void 0 ? s.props.deselect = !0 : s.props.deselect = _e(s.props.deselect), s.props.option = {}, s.props.expanded = !1, s.props.inputStd = [], s.props.draggable === void 0 ? s.props.draggable = !0 : s.props.draggable === "false" && (s.props.draggable = !1), s.props.options || (To(350, { node: s, inputType: s.props.type }), s.props.options = []), "disabled" in s.props && (s.props.disabled = _e(s.props.disabled)), s.props.allOptions = xu(s.props.options), s.props.selections = [], s.props.memoOptions = [], s.props.invertPopover = !1, s.props.dropdownWrapperStyles = { position: "absolute", top: "100%", overflow: "auto", minWidth: "100%" }, s.props.decrementCount = 0, s.props.page = 1, s.props.loadMoreOption = { label: "Load more", value: ra }, s.props.loadOptions = Ys, s.props.listboxStyles = {}, s.props.optionsLoadingCounter = 0, s.props.optionLoadingCounter = 0, s.props.searchable = _e(s.props.searchable), s.props.loadOnScroll = _e(s.props.loadOnScroll), s.props.multiple = _e(s.props.multiple) || !1, s.props.type === "taglist" && (s.props.multiple = !0), s.props.openOnFocus = _e(s.props.openOnFocus), s.props.openOnRemove = s.props.openOnRemove !== void 0 && _e(s.props.openOnRemove), s.props.hasNextPage = a0.bind(null, s), s.props.initialOptions = [...s.props.options], s.props.optionLoaderValues = [], s.props.loadOnCreated = _e(s.props.loadOnCreated), s.props.max && typeof s.props.max != "number" ? s.props.max = parseInt(s.props.max) : s.props.max && !s.props.multiple && (s.props.max = void 0), s.on("mounted", () => Ym(s)), s.on("prop:popoverCoordinates", () => setTimeout(() => {
      Ym(s);
    }, 10));
  })(o), o.props.multiple ? function(s) {
    s.hook.input((a, r) => (s.props.highlightedRange && !s.props.optionRemoved && (a.splice(s.props.highlightedRange.index, 1, de(s.props.option)), a = a.filter((i) => i !== void 0)), s.props.inputStd = a && Array.isArray(a) ? [...new Set(a)] : [], r(a === void 0 ? void 0 : [...s.props.inputStd])));
  }(o) : function(s) {
    s.hook.input((a, r) => (s.props.inputStd = a === void 0 || a === "" || a === null ? [] : [a], r(a)));
  }(o), e(o), oQ(o), function(s) {
    s.on("created", () => {
      s.context && (s.props.trackHover = !0, s.props.disabled !== void 0 || s.props.optionsLoader || !s.props.options || s.props.options.length || s.props.emptyMessage !== void 0 || s.props.allowNewValues || s.props.inputStd.length !== 0 || (s.props.disabledInternally = !0), sQ(s), s.props.loadOnCreated && !s.props.optionsLoaded && s.props.optionsLoader ? Ys(s) : s.props.optionsLoaded && (s.props.optionsLoaded = !1), s.props.forceExpanded = _e(s.props.forceExpanded), s.props.forceExpanded && (s.props.dropdownWrapperStyles = { ...s.props.dropdownWrapperStyles, zIndex: "999", pointerEvents: "auto" }, setTimeout(() => {
        s.props.setForceExpanded = !0;
      }, 100)));
    });
  }(o), rQ(o), t(o), function(s) {
    s.on("prop:selections", ({ payload: r }) => {
      s.props.max && (s.props.maxReached = r.length >= s.props.max);
    }), s.on("prop:maxReached", ({ payload: r }) => {
      r && (s.props.expanded = !1);
    }), s.on("prop:optionsLoadingCounter", ({ payload: r }) => {
      r === 0 && (s.props.emptyMessage && (s.props.showEmptyMessage = !s.props.options.length), s.props.optionLoadingCounter === 0 && s.store.set(er));
    }), s.on("prop:optionLoadingCounter", ({ payload: r }) => {
      r === 0 && s.props.optionsLoadingCounter === 0 && s.store.set(er);
    }), s.on("prop:disabled", ({ payload: r }) => {
      r && (s.props.expanded = !1);
    }), s.on("prop:options", ({ payload: r }) => {
      s.props.allOptions = xu(s.props.options), s.props.emptyMessage && typeof s.props.optionsLoader != "function" && (s.props.showEmptyMessage = !r.length), r.length ? s.props.disabledInternally = !1 : r.length || s.props.optionsLoader || s.props.emptyMessage !== void 0 || s.props.allowNewValues || s.props.inputStd.length !== 0 || s.props.searchValue || (s.props.disabledInternally = !0), yd(s);
    }), s.on("prop:expanded", ({ payload: r }) => {
      var i;
      if (Ot) if (s.props.alwaysLoadOnOpen && (s.props.page = 1), r) {
        if (s.props.trackHover = !1, s.props.options && !s.props.options.length && typeof s.props.optionsLoader != "function" && s.props.emptyMessage && (s.props.showEmptyMessage = !0), setTimeout(() => document.addEventListener("click", a), 10), s.props.selectionAppearance === "text-input" && s.props.multiple) return;
        const l = (i = s.props.__root) === null || i === void 0 ? void 0 : i.getElementById(`${s.props.id}`);
        l instanceof HTMLInputElement && (l.focus(), s.props.searchExpand || (l.value = "", l.value = s.props.inputText));
      } else document.removeEventListener("click", a), s.props.trackHover = !1, s.props.showEmptyMessage = !1;
    });
    const a = () => {
      s.props.activeSelectionValue = void 0, s.props.expanded = !1;
    };
  }(o), n(o);
}
function gQ(e) {
  e.props.closeOnSelect === void 0 ? e.props.closeOnSelect = !e.props.multiple : e.props.closeOnSelect = _e(e.props.closeOnSelect), (e.props.multiple && e.props.selectionAppearance === void 0 || e.props.selectionAppearance === "truncate") && (e.props.selectionAppearance = "truncate", e.props.formattedSelections = []), e.props.multiple ? e.props.selectionRemovable = !1 : e.props.selectionRemovable = _e(e.props.selectionRemovable);
}
function i0(e) {
  var t, n;
  e.props.searchValue || (n = (t = e.props.__root) === null || t === void 0 ? void 0 : t.getElementById(`${e.props.id}_tag-wrapper_${e.props.selections.length - 1}`)) === null || n === void 0 || n.focus();
}
function l0(e, t, n) {
  var o, s, a;
  if (n.preventDefault(), e.props.trackHover = !1, e.props.expanded) {
    const r = e.props.allOptions.reduce((l, c) => {
      var u;
      return !((u = c == null ? void 0 : c.attrs) === null || u === void 0) && u.disabled || l.push(de(c)), l;
    }, []);
    !((o = e.store.hasNextPage) === null || o === void 0) && o.value && r.push(ra);
    let i = -1;
    e.props.activeValue && (i = r.findIndex((l) => we(l, e.props.activeValue))), i === -1 && r.length ? e.props.activeValue = r[0] : t === "ArrowDown" && r.length > i + 1 ? e.props.activeValue = r[i + 1] : t === "ArrowUp" && i > 0 ? e.props.activeValue = r[i - 1] : t === "ArrowUp" && i === 0 && ((a = (s = e.props.__root) === null || s === void 0 ? void 0 : s.getElementById(`${e.props.id}_tag-wrapper_${e.props.selections.length - 1}`)) === null || a === void 0 || a.focus(), e.props.expanded = !1);
  } else e.props.expanded || t !== "ArrowDown" || (e.props.expanded = !0);
}
function c0(e, t) {
  var n, o, s;
  if ((e.props.type === "taglist" || e.props.selectionAppearance === "tags") && e.props.inputStd.length && !e.props.inputText) {
    if (t === "ArrowLeft") return e.props.selections.length && ((o = (n = e.props.__root) === null || n === void 0 ? void 0 : n.getElementById(`${e.props.id}_tag-wrapper_${e.props.selections.length - 1}`)) === null || o === void 0 || o.focus(), e.props.selections[e.props.selections.length - 1] ? e.props.activeSelectionValue = de(e.props.selections[e.props.selections.length - 1]) : e.props.activeSelectionValue = void 0), void (e.props.expanded = !1);
    t === "ArrowRight" && ((s = document.getElementById(`${e.props.id}_tag-wrapper_0`)) === null || s === void 0 || s.focus(), e.props.selections[0] ? e.props.activeSelectionValue = de(e.props.selections[0]) : e.props.activeSelectionValue = void 0), e.props.expanded = !1;
  }
}
function u0(e) {
  var t, n;
  e.props.expanded = !0, (n = (t = e.props.__root) === null || t === void 0 ? void 0 : t.getElementById(`${e.props.id}`)) === null || n === void 0 || n.focus();
}
function p0(e, t, n, o = !0) {
  var s, a, r, i, l, c, u;
  const p = n.key;
  if (n.altKey) {
    const f = es(), m = e.props.selections.findIndex((g) => we(de(g), de(t))), h = [...e.props.selections];
    n.key === "ArrowRight" ? m < e.props.selections.length - 1 && (h.splice(m, 1), h.splice(m + 1, 0, t)) : n.key === "ArrowLeft" && m > 0 && (h.splice(m, 1), h.splice(m - 1, 0, t)), e.props.activeSelectionValue = de(t), e.input([...h.map(de)]), setTimeout(() => {
      f instanceof HTMLElement && f.focus();
    }, 100);
  } else {
    const f = e.props.selections.findIndex((g) => we(de(g), de(t)));
    if (f === -1) return;
    const m = p === "ArrowRight" ? f + 1 : f - 1;
    if (m >= e.props.selections.length) {
      if (!o) return e.props.expanded = !0, e.props.activeSelectionValue = void 0, void ((a = (s = e.props.__root) === null || s === void 0 ? void 0 : s.getElementById(`${e.props.id}`)) === null || a === void 0 || a.focus());
      (i = (r = e.props.__root) === null || r === void 0 ? void 0 : r.getElementById(`${e.props.id}`)) === null || i === void 0 || i.focus();
    } else if (m < 0 && f === 0) (c = (l = e.props.__root) === null || l === void 0 ? void 0 : l.getElementById(`${e.props.id}`)) === null || c === void 0 || c.focus();
    else if (m < 0) return;
    const h = (u = e.props.__root) === null || u === void 0 ? void 0 : u.getElementById(`${e.props.id}_tag-wrapper_${m}`);
    h && h.focus(), e.props.selections[m] ? e.props.activeSelectionValue = de(e.props.selections[m]) : e.props.activeSelectionValue = void 0;
  }
}
function d0(e, t, n) {
  var o;
  if (!(n.currentTarget instanceof HTMLElement) || e.props.searchValue) return;
  const s = e.props.selections.findIndex((i) => we(de(i), de(t)));
  if (s === -1) return;
  const a = e.props.selections[s + 1] ? s + 1 : s - 1, r = (o = e.props.__root) === null || o === void 0 ? void 0 : o.getElementById(`${e.props.id}_tag-wrapper_${a}`);
  r && r.focus(), e.props.userAction = { type: "tagDelete" }, xl(e, t);
}
function f0(e, t) {
  var n;
  if (t.preventDefault(), e.props.allowNewValues && e.props.searchValue && e.input(r0(e, e.props.searchValue)), e.props.expanded) {
    if (e.props.activeValue === ra) return void ((n = e.context) === null || n === void 0 || n.handlers.loadMore(!0));
    const o = e.props.allOptions.find((s) => we(de(s), e.props.activeValue));
    if (!o) return;
    $d(e, o);
  } else e.props.expanded = !0;
}
function m0(e) {
  e.props.expanded && (e.props.expanded = !1);
}
function bQ(e, t, n) {
  if (n.stopPropagation(), !e.props.disabled)
    switch (n.key) {
      case "ArrowDown":
        u0(e);
        break;
      case "ArrowRight":
      case "ArrowLeft":
        p0(e, t, n, !1);
        break;
      case "Delete":
      case "Backspace":
        d0(e, t, n);
    }
}
function yQ(e, t, n) {
  if (!e.props.disabled)
    switch (n.key) {
      case "ArrowUp":
      case "ArrowDown":
        (function(o, s, a) {
          var r, i, l, c;
          a.preventDefault();
          const u = a.key, p = o.props.selections.findIndex((h) => we(de(h), de(s)));
          if (p === -1) return;
          const f = u === "ArrowDown" ? p + 1 : p - 1;
          if (f < 0 && ((i = (r = o.props.__root) === null || r === void 0 ? void 0 : r.getElementById(`${o.props.id}`)) === null || i === void 0 || i.focus()), f < 0 || f >= o.props.selections.length) return;
          const m = (l = o.props.__root) === null || l === void 0 ? void 0 : l.getElementById(`${o.props.id}_selection_wrapper_${f}`);
          m && m.focus(), o.props.activeSelectionValue = ((c = o.props.selections[f]) === null || c === void 0 ? void 0 : c.value) || void 0;
        })(e, t, n);
        break;
      case "Enter":
        break;
      case "Tab":
        (function(o, s, a) {
          var r, i, l, c;
          if (s) {
            const u = o.props.selections.findIndex((m) => we(de(m), de(s)));
            if (u === -1) return;
            const p = a.shiftKey ? u - 1 : u + 1;
            if (p >= o.props.selections.length) return;
            if (p < 0) return void ((i = (r = o.props.__root) === null || r === void 0 ? void 0 : r.getElementById(`${o.props.id}`)) === null || i === void 0 || i.focus());
            const f = (l = o.props.__root) === null || l === void 0 ? void 0 : l.getElementById(`${o.props.id}_selection_wrapper_${p}`);
            f && f.focus(), o.props.activeSelectionValue = ((c = o.props.selections[p]) === null || c === void 0 ? void 0 : c.value) || void 0;
          }
        })(e, t, n);
        break;
      case "Delete":
      case "Backspace":
        (function(o, s) {
          var a;
          if (s) {
            const r = o.props.selections.findIndex((c) => we(de(c), de(s)));
            if (r === -1) return;
            const i = o.props.selections[r + 1] ? r + 1 : r - 1, l = (a = o.props.__root) === null || a === void 0 ? void 0 : a.getElementById(`${o.props.id}_selection_wrapper_${i}`);
            l && l.focus(), o.props.selections[i] ? o.props.activeSelectionValue = de(o.props.selections[i]) : o.props.activeSelectionValue = void 0;
          }
          s && o.props.selections.length !== 1 || (o.props.userAction = { type: "selectionDelete" }), xl(o, s);
        })(e, t);
    }
}
function $Q(e, t) {
  if (e.props.disabled || !(t.currentTarget instanceof HTMLElement) || e.props.id !== t.currentTarget.id) return;
  const n = t.key;
  switch (n) {
    case "Tab":
      (function(o) {
        o.props.expanded && (o.props.expanded = !1);
      })(e);
      break;
    case "ArrowUp":
    case "ArrowDown":
      l0(e, n, t);
      break;
    case "ArrowLeft":
    case "ArrowRight":
      c0(e, n);
      break;
    case "Enter":
      f0(e, t);
      break;
    case "Escape":
      m0(e);
      break;
    case "Delete":
    case "Backspace":
      i0(e);
      break;
    default:
      e.emit("unusedKeydown", t);
  }
}
function _Q(e, t) {
  if (e.props.disabled || !(t.currentTarget instanceof HTMLElement) || e.props.id !== t.currentTarget.id) return;
  const n = t.key;
  switch (n) {
    case "Tab":
      (function(o, s) {
        var a, r, i;
        o.props.expanded = !1, o.props.multiple && o.props.selections.length && o.props.type === "autocomplete" && o.props.selectionAppearance === "option" && (s.preventDefault(), (r = (a = o.props.__root) === null || a === void 0 ? void 0 : a.getElementById(`${o.props.id}_selection_wrapper_0`)) === null || r === void 0 || r.focus(), o.props.activeSelectionValue = ((i = o.props.selections[0]) === null || i === void 0 ? void 0 : i.value) || void 0);
      })(e, t);
      break;
    case "ArrowUp":
    case "ArrowDown":
      l0(e, n, t);
      break;
    case "ArrowRight":
    case "ArrowLeft":
      c0(e, n);
      break;
    case "Enter":
      f0(e, t);
      break;
    case "Escape":
      m0(e);
      break;
    case "Delete":
    case "Backspace":
      i0(e);
  }
}
function wQ(e) {
  e.props.alwaysLoadOnOpen = e.props.alwaysLoadOnOpen !== void 0 && _e(e.props.alwaysLoadOnOpen), e.on("created", () => {
    e.context && (e.context.handlers.click = CQ.bind(null, e), e.context.handlers.focus = kQ.bind(null, e), e.context.handlers.keydown = $Q.bind(null, e), e.context.handlers.selectorTagKeydownHandler = (t) => bQ.bind(null, e, t));
  });
}
function CQ(e, t) {
  var n;
  if (t.stopPropagation(), t.detail === 0 || e.props.disabled) return;
  e.props.attrs.onClick && e.props.attrs.onClick(t);
  const o = (n = e.props.__root) === null || n === void 0 ? void 0 : n.getElementById(`${e.props.id}`);
  e.props.justOpened ? e.props.justOpened = !1 : e.props.expanded ? e.props.expanded = !1 : (o && t.pointerType !== "mouse" ? (e.props.mouseX = -1, e.props.mouseY = -1) : (e.props.mouseX = t.clientX, e.props.mouseY = t.clientY), e.props.expanded = !0, o == null || o.focus());
}
function kQ(e) {
  e.props.disabled || (e.props.attrs.onFocus && e.props.attrs.onFocus(), e.props.skipOpen ? e.props.skipOpen = !1 : e.props.openOnFocus && (e.props.justOpened = !0, e.props.expanded = !0));
}
function SQ(e) {
  let t, n = "";
  e.on("unusedKeydown", ({ payload: o }) => {
    if (!o.isComposing && [...o.key].length === 1) {
      if (!n && o.key === " ") return void function(a, r) {
        var i;
        if (r.preventDefault(), a.props.expanded) {
          if (a.props.activeValue === ra) return void ((i = a.context) === null || i === void 0 || i.handlers.loadMore());
          const l = a.props.allOptions.find((c) => we(de(c), a.props.activeValue));
          if (!l) return;
          $d(a, l);
        } else a.props.expanded = !0;
      }(e, o);
      e.props.expanded = !0, clearTimeout(t), n += o.key;
      const s = e.props.allOptions.find((a) => a.label.toLowerCase().startsWith(n.toLowerCase()));
      s && (e.props.activeValue = de(s)), t = setTimeout(() => {
        n = "";
      }, 400);
    }
  });
}
function Xm(e) {
  Qi(e), e.on("prop:selections", () => {
    e.props.skipFormatSelections = !1, Qi(e);
  }), Ot && it(`${e.props.id}_selections`, TQ.bind(null, e), e.props.__root);
}
function Qi(e) {
  e.isCreated && (e.props.selections.length && e.props.lastVisibleIndex && e.props.selections.length - e.props.lastVisibleIndex > 1 ? e.props.truncationCount = "+ " + (e.props.selections.length - e.props.lastVisibleIndex - 1).toString() : e.props.truncationCount = void 0, e.props.formattedSelections = e.props.selections.map((t, n) => e.props.lastVisibleIndex && n === e.props.lastVisibleIndex && n !== 0 ? e.props.lastTruncatedElText && n === e.props.selections.length - 1 ? e.props.lastTruncatedElText : n === e.props.selections.length - 1 ? t.label : t.label + "..." : n === e.props.selections.length - 1 ? t.label : t.label + ", "));
}
function Jm(e) {
  var t, n;
  if (!Ot || !e.context) return;
  const o = (t = e.props.__root) === null || t === void 0 ? void 0 : t.getElementById(`${e.props.id}_selections`);
  if (!(o instanceof HTMLElement)) return;
  const s = o.parentNode;
  if (!(s instanceof HTMLElement)) return;
  let a = o.getBoundingClientRect().width;
  const r = 0.98 * s.getBoundingClientRect().width, i = Array.prototype.slice.call(o.children), l = [...e.props.selections];
  if (a > r) {
    const c = [];
    let u = 0;
    for (let p = 0; p < l.length; p++) c.push([l[p], i[p]]);
    for (let p = c.length - 1; p >= 0; p--) {
      const f = c[p];
      if (!(f[1] instanceof HTMLElement)) return;
      u += f[1].getBoundingClientRect().width + parseFloat(window.getComputedStyle(f[1]).marginRight) + parseFloat(window.getComputedStyle(f[1]).marginLeft);
      const m = a - u;
      if (r > m) {
        const h = f[0].label;
        e.props.skipFormatSelections = !0, f[1].textContent = h;
        let g = !1;
        for (let _ = h.length; _ >= 0; _--) {
          if (e.props.skipFormatSelections = !0, f[1].textContent = h.slice(0, _).trim() + "...", m + f[1].getBoundingClientRect().width < r) {
            if (_ < 4) {
              e.props.lastVisibleIndex = p - 1, e.props.lastTruncatedElText = null;
              break;
            }
            if (e.props.lastVisibleIndex = p, e.props.lastTruncatedElText && f[1].textContent.slice(0, 4) === e.props.lastTruncatedElText.slice(0, 4)) break;
            e.props.lastTruncatedElText = (n = f[1]) === null || n === void 0 ? void 0 : n.textContent;
            break;
          }
          _ === 0 && (g = !0);
        }
        f[1].textContent = e.props.lastTruncatedElText && !g && p !== 0 ? e.props.lastTruncatedElText : h, e.props.lastVisibleIndex === null && (e.props.lastVisibleIndex = p === 0 ? 0 : p - 1, e.props.lastTruncatedElText = null), setTimeout(() => {
          Qi(e);
        });
        break;
      }
    }
  } else e.props.lastTruncatedElText = null, e.props.lastVisibleIndex = null, Qi(e);
}
function TQ(e, t) {
  const n = new ResizeObserver(() => {
    e.props.selections && e.props.selections.length !== 0 && (e.props.skipFormatSelections ? e.props.skipFormatSelections = !1 : Jm(e));
  }), o = new ResizeObserver(() => {
    Jm(e);
  });
  n.observe(t), t.parentNode instanceof Element && o.observe(t.parentNode);
}
const AQ = { position: "fixed", top: 0, bottom: 0, right: 0, left: 0, pointerEvents: "none", zIndex: -1, overflowY: "auto", "-webkit-overflow-scrolling": "auto" }, Lc = { position: "fixed", overflow: "hidden", height: "100%", width: "100%" }, Nc = { overflow: "hidden", height: "100%" }, Qm = {}, ev = {};
let Fc = 0;
function DQ(e) {
  var t, n;
  if (typeof window > "u") return;
  const o = (t = e.props.__root) === null || t === void 0 ? void 0 : t.getElementById(`${e.props.id}_popover`), s = (n = e.props.__root) === null || n === void 0 ? void 0 : n.getElementById(`${e.props.id}`);
  if (!s || !o) return;
  const a = o.style.paddingTop, r = o.style.paddingBottom, i = o.style.paddingLeft;
  o.style.paddingTop = "0", o.style.paddingBottom = "0", o.style.paddingLeft = "0";
  const l = s.getBoundingClientRect(), c = o.getBoundingClientRect(), u = Math.round(l.top - c.top) + "px", p = Math.round(l.left - c.left - 5) + "px", f = Math.max(Math.round(Math.min(c.height - c.top, window.innerHeight) - (l.top + l.height)), 0) + "px";
  o.style.paddingTop = a, o.style.paddingBottom = r, o.style.paddingLeft = i, e.props.dropdownWrapperStyles = { ...e.props.dropdownWrapperStyles, paddingTop: u, paddingLeft: p, paddingBottom: f }, e.props.listboxStyles = { ...e.props.listboxStyles, minWidth: e.props.behavior === "overscroll" ? `min(${l.width + "px"}, calc(100vw - 4em))` : l.width + "px", maxWidth: "calc(100vw - 4em)" };
}
function PQ(e, t) {
  var n, o;
  let s = null;
  if (e.props.activeDescendant) {
    const a = (n = e.props.__root) === null || n === void 0 ? void 0 : n.getElementById(e.props.activeDescendant);
    if (!a) return s;
    e.props.ignoreScroll = !0;
    const r = (o = e.props.__root) === null || o === void 0 ? void 0 : o.getElementById(`${e.props.id}_listbox`);
    if (!r) return s;
    const i = t.getBoundingClientRect(), l = r.getBoundingClientRect(), c = parseInt(getComputedStyle(t).paddingTop), u = parseInt(getComputedStyle(t).paddingBottom), p = a.offsetTop - c, f = Math.max(p - c, 0), m = Math.max(t.scrollHeight - u - p - i.height, 0), h = l.height - f - m;
    t.scrollTop = p;
    const g = () => {
      t.scrollTop = m > 0 ? m < c ? t.scrollHeight : c : f < u ? 0 : p - u;
    }, _ = Math.min(150, l.height);
    f > 0 && m > 0 || f === 0 && m === 0 || h > _ ? t.scrollTop = p : g(), t.clientHeight / 2 < t.scrollTop && (s = e.props.options.filter((v) => {
      var w;
      return !(!((w = v.attrs) === null || w === void 0) && w.disabled);
    }).findIndex((v) => we(e.value, de(v)))), s === -1 && (s = null);
  }
  return s;
}
function IQ(e) {
  e.addProps(["behavior"]), e.on("created", () => {
    e.props.behavior === "overscroll" && (typeof e.props.optionsLoader == "function" && Et(300, [e]), e.props.dropdownWrapperStyles = _o(AQ), e.props.listboxStyles = { display: "inline-block" }, e.props.styleWrapper = DQ.bind(null, e), e.props.positionListBox = PQ.bind(null, e));
  }), e.on("prop:expanded", ({ payload: t }) => {
    e.props.behavior === "overscroll" && (t ? function() {
      Fc = document.documentElement.scrollTop;
      for (const n in Lc) ev[n] = document.documentElement.style[n], document.documentElement.style[n] = Lc[n];
      for (const n in Nc) Qm[n] = document.body.style[n], document.body.style[n] = Nc[n];
      document.body.scrollTop = Fc;
    }() : function() {
      for (const n in Lc) document.documentElement.style[n] = ev[n];
      for (const n in Nc) document.body.style[n] = Qm[n];
      document.body.scrollTop = 0, document.documentElement.scrollTop = Fc;
    }());
  });
}
function v0(e) {
  e.addProps(["multiLine"]), e.on("created", () => {
    Ot && (e.props.multiLineHeight = void 0, it(`${e.props.id}_selections`, EQ.bind(null, e), e.props.__root));
  });
}
function EQ(e) {
  var t;
  const n = new ResizeObserver((s) => {
    for (const a of s) {
      const { height: r } = a.contentRect;
      e.props.selectionsHeight !== r && (e.props.selectionsHeight = r), OQ(e, a.target);
    }
  }), o = (t = e.props.__root) === null || t === void 0 ? void 0 : t.getElementById(`${e.props.id}_selections`);
  o && n.observe(o);
}
function OQ(e, t) {
  var n;
  const o = t.querySelectorAll(`[id^="${e.props.id}_tag-wrapper"`);
  let s, a = [];
  if (e.props.type === "taglist") {
    const i = (n = e.props.__root) === null || n === void 0 ? void 0 : n.getElementById(`${e.props.id}`);
    if (!i) return;
    a = [i, ...Array.from(o)];
  } else a = Array.from(o);
  if (!o) return;
  let r = !1;
  for (const i of a) if (s === void 0) s = i.getBoundingClientRect();
  else {
    const l = i.getBoundingClientRect();
    if (s.top >= l.top + l.height / 5 || s.top <= l.top - l.height / 5) {
      r = !0, e.props.multiLine = !0;
      break;
    }
  }
  r || (e.props.multiLine = !1);
}
function xQ(e) {
  if (e.on("created", () => {
    e.context && SQ(e);
  }), e.props.multiple || function(t) {
    t.on("prop:selections", ({ payload: n }) => {
      var o;
      t.props.firstSelectionLabel = ((o = n[0]) === null || o === void 0 ? void 0 : o.label) || "", t.props.option = n[0];
    });
  }(e), e.props.selectionAppearance === "truncate" && (e.props.lastVisibleIndex = null, Xm(e), e.on("prop:selections", () => {
    Xm(e);
  })), e.props.selectionAppearance === "tags" && v0(e), e.props.multiple && e.props.selectionAppearance === "tags") {
    let t = function() {
      return Array.isArray(e.value) ? e.value : [];
    }, n = function(o, s) {
      e.input(o);
    };
    e.on("created", () => {
      e.props.disabled && (e.props.draggable = !1), it(`${e.props.id}_selections`, (o) => {
        if (e.context && o instanceof HTMLElement) {
          const s = { threshold: { horizontal: 0.25, vertical: 0 }, plugins: [Dl()], draggingClass: e.context.classes.dragging, dropZoneClass: e.context.classes.dropZone, disabled: !e.props.draggable, root: e.props.__root, touchDraggingClass: e.context.classes.touchDragging, touchDropZoneClass: e.context.classes.touchDropZone, draggable: (a) => a.hasAttribute("data-is-tag") };
          mt({ parent: o, getValues: t, setValues: n, config: s }), e.on("prop:disabled", ({ payload: a }) => {
            s.disabled = a, mt({ parent: o, getValues: t, setValues: n, config: s });
          }), e.on("prop:draggable", ({ payload: a }) => {
            s.disabled = !a, mt({ parent: o, getValues: t, setValues: n, config: s });
          });
        }
      }, e.props.__root);
    });
  }
  e.on("prop:expanded", ({ payload: t }) => {
    t && e.props.optionsLoader && typeof e.props.optionsLoader == "function" && (!e.props.options.length || e.props.alwaysLoadOnOpen) && (e.props.options = [], Ys(e));
  }), e.props.behavior === "overscroll" && IQ(e);
}
const MQ = (e, t) => {
  let n = null, o = null, s = null;
  return function(...a) {
    const r = this;
    n ? (o = a, s = r) : (e.apply(r, a), n = window.setTimeout(() => {
      n = null, o !== null && s !== null && (e.apply(s, o), o = null, s = null);
    }, t));
  };
};
function br(e) {
  if (e.addProps(["popover", "popoverOffset", "usePopover", "popoverCoordinates", "popoverAncestorCoordinates"]), e.props.popover = _e(e.props.popover) ? "manual" : void 0, e.type !== "input" || e.props.behavior === "overscroll") return;
  let t = null, n = null, o = [], s = null;
  if (e.props.popoverOffset = _e(e.props.popoverOffset) ? parseInt(e.props.popoverOffset) : 0, !e.props.popover) return;
  if (typeof document > "u" || !("popover" in HTMLElement.prototype)) return void (typeof window < "u" && console.warn('FormKit: Popover API is not supported in this browser — input panels will be rendered with fallback CSS positioning. This could result in inaccessible inputs due to parent containers using "overflow: hidden" or z-index conflicts.'));
  const a = () => {
    e.props.invertPopover = !1, document.removeEventListener("resize", s), document.removeEventListener("scroll", s), o.forEach((l) => {
      l.removeEventListener("scroll", s);
    });
  };
  function r() {
    const { x: l, y: c, width: u, height: p } = function(f, m) {
      if (!f || !m) return { x: 0, y: 0 };
      const { left: h, top: g, width: _, height: v } = m.getBoundingClientRect();
      return { x: h + window.scrollX, y: g + v + window.scrollY, width: _, height: v };
    }(t, n);
    e.props.popoverAncestorCoordinates = { x: l, y: c, width: u, height: p }, e.props.popoverCoordinates = { x: l, y: c, width: u, height: 0 };
  }
  function i(l) {
    t && document.body.contains(t) && (l ? (t == null || t.showPopover(), setTimeout(() => {
      e.props.popoverCoordinates.height = (t == null ? void 0 : t.offsetHeight) || 0;
    }, 5)) : t.matches(":popover-open") && (t.hidePopover(), e.props.popoverCoordinates.height = 0));
  }
  e.on("mounted", () => {
    e.context && (e.props.usePopover = !0, e.props.popoverCoordinates = { x: 0, y: 0, width: 0, height: 0 }, e.props.popoverAncestorCoordinates = { x: 0, y: 0, width: 0, height: 0 });
  }), e.on("destroyed", () => {
    a();
  }), e.on("prop:inputText", () => {
    e.context && (r(), i(!0));
  }), e.on("prop:expanded", ({ payload: l }) => {
    var c;
    e.context && (l === !1 ? a() : it(`${(c = e.context) === null || c === void 0 ? void 0 : c.id}_popover`, () => {
      if (!e.context) return;
      t = document.querySelector(`[id="${e.context.id}_popover"][popover]`) || document.querySelector(`[id="${e.context.id}_popover"] [popover]`), n || (n = function(p) {
        if (!p) return null;
        let f = p.parentElement;
        for (; f && window.getComputedStyle(f).position === "static"; ) f = f.parentElement;
        return f;
      }(t)), r(), i(l), s = MQ(() => {
        e.context && (r(), i(l));
      }, 10), document.addEventListener("resize", s), document.addEventListener("scroll", s), o = [];
      let u = t == null ? void 0 : t.parentElement;
      for (; u; ) u.scrollHeight > u.clientHeight && o.push(u), u = u.parentElement;
      o.forEach((p) => {
        p.addEventListener("scroll", s);
      });
    }));
  });
}
const LQ = { schema: /* @__PURE__ */ IJ(/* @__PURE__ */ EJ(/* @__PURE__ */ xJ("$label"), /* @__PURE__ */ OJ(/* @__PURE__ */ vs("prefix"), /* @__PURE__ */ MJ(), /* @__PURE__ */ VJ(/* @__PURE__ */ ye("$inputStd.length === 0 && $state.loading !== true", /* @__PURE__ */ UJ('$placeholder || "placeholder"'), /* @__PURE__ */ ye("$multiple !== true", /* @__PURE__ */ BJ(/* @__PURE__ */ ye("$state.loading && $selections.length === 0", /* @__PURE__ */ Mc("$ui.isLoading.value"), /* @__PURE__ */ HJ(/* @__PURE__ */ zJ("$option.label")))), /* @__PURE__ */ ye('$multiple && $selectionAppearance === "truncate"', /* @__PURE__ */ WJ(/* @__PURE__ */ jJ(/* @__PURE__ */ ye("$state.loading && $selections.length === 0", /* @__PURE__ */ Mc("$ui.isLoading.value"), /* @__PURE__ */ KJ()))), /* @__PURE__ */ ye('$multiple && $selectionAppearance === "tags"', /* @__PURE__ */ XJ(/* @__PURE__ */ JJ(/* @__PURE__ */ ye("$state.loading && $isLoadingOption !== true && $selections.length === 0", /* @__PURE__ */ Mc("$ui.isLoading.value"), /* @__PURE__ */ YJ(/* @__PURE__ */ GJ(/* @__PURE__ */ ye("$state.loading && $optionLoaderValues.includes($option.value) || $option.label === undefined", /* @__PURE__ */ QJ("$ui.isLoading.value"), /* @__PURE__ */ ZJ("$option.label")), /* @__PURE__ */ jm(/* @__PURE__ */ vs("close"))))))))))), /* @__PURE__ */ ye("$truncationCount && $state.loading !== true", /* @__PURE__ */ qJ("$truncationCount")), /* @__PURE__ */ ye("$state.loading", /* @__PURE__ */ vs("loader")), /* @__PURE__ */ ye("$inputStd.length !== 0 && $selectionRemovable", /* @__PURE__ */ jm(/* @__PURE__ */ vs("close")), /* @__PURE__ */ vs("select"))), /* @__PURE__ */ eQ(), /* @__PURE__ */ LJ(), /* @__PURE__ */ vs("suffix"))), /* @__PURE__ */ NJ("$help"), /* @__PURE__ */ FJ(/* @__PURE__ */ RJ("$message.value"))), type: "input", family: "dropdown", props: [], features: [
  /* @__PURE__ */ Oe("select", "select"),
  /* @__PURE__ */ Oe("close", "close"),
  /* @__PURE__ */ Oe("selected", "check"),
  /* @__PURE__ */ Oe("loader", "spinner"),
  /* @__PURE__ */ We("isLoading"),
  /* @__PURE__ */ We("loadMore"),
  /* @__PURE__ */ We("remove"),
  xn,
  /* @__PURE__ */ _d.bind(null, gQ, wQ, xQ),
  br
] }, ao = /* @__PURE__ */ Lt("tg"), { outer: NQ, wrapper: FQ, prefix: RQ, suffix: VQ, help: BQ, messages: HQ, message: UQ, icon: zQ } = /* @__PURE__ */ Nt(ao), WQ = ao("input", () => ({ $el: "input", bind: "$attrs", attrs: { type: "checkbox", id: "$id", value: "$value", name: "$node.name", checked: "$checked", onInput: "$handlers.toggles", onBlur: "$handlers.blur", disabled: "$disabled" } })), jQ = ao("label", () => ({ if: "($label && $onValueLabel === undefined && $offValueLabel === undefined) || ($valueLabelDisplay === inner) && $altLabelPosition !== true", $el: "label", attrs: { for: "$id" }, children: "$label" })), qQ = ao("altLabel", () => ({ $el: "label", if: "($label && ($onValueLabel || $offValueLabel) && $valueLabelDisplay !== hidden && $valueLabelDisplay !== inner) || $altLabelPosition === true", attrs: { for: "$id", "data-label-alt": "true", style: { color: { if: "$checked", then: "$valueLabelColorOn", else: "$valueLabelColorOff" } } }, children: "$label" })), KQ = ao("innerLabel", () => ({ $el: "div", if: "$valueLabelDisplay === inner && ($checked && $onValueLabel || $offValueLabel)", attrs: { style: { color: { if: "$checked", then: "$valueLabelColorOn", else: "$valueLabelColorOff" } } }, children: { if: "$checked", then: "$onValueLabel", else: "$offValueLabel" } })), YQ = ao("valueLabel", () => ({ $el: "label", if: "$valueLabelDisplay !== hidden && $valueLabelDisplay !== inner && (($checked === true && $onValueLabel) || ($checked === false && $offValueLabel))", attrs: { for: "$id" }, children: { if: "$checked && $onValueLabel", then: "$onValueLabel", else: { if: "$offValueLabel", then: "$offValueLabel" } } })), GQ = ao("inner", () => ({ $el: "label", attrs: { for: "$id", id: "$id + '_label'" } })), ZQ = ao("track", () => ({ $el: "div", attrs: { style: { backgroundColor: { if: "$checked", then: "$trackColorOn", else: "$trackColorOff" } } } })), XQ = ao("thumb", () => ({ $el: "div", attrs: { style: { color: { if: "$checked", then: "$iconColorOn", else: "$iconColorOff" }, backgroundColor: { if: "$checked", then: "$thumbColorOn", else: "$thumbColorOff" } } } })), JQ = () => XQ(ye("$slots.default", "$slots.default", zQ("thumb"))), QQ = { schema: /* @__PURE__ */ NQ(/* @__PURE__ */ FQ(/* @__PURE__ */ qQ(), /* @__PURE__ */ GQ(/* @__PURE__ */ RQ(), /* @__PURE__ */ WQ(), /* @__PURE__ */ ZQ(/* @__PURE__ */ KQ(), /* @__PURE__ */ JQ()), /* @__PURE__ */ VQ()), /* @__PURE__ */ YQ(), /* @__PURE__ */ jQ()), /* @__PURE__ */ BQ("$help"), /* @__PURE__ */ HQ(/* @__PURE__ */ UQ("$message.value"))), type: "input", props: ["checked", "thumbColorOff", "thumbColorOn", "iconColorOff", "iconColorOn", "valueLabelColorOff", "valueLabelColorOn", "offValue", "offValueLabel", "onValue", "onValueLabel", "thumbIcon", "trackColorOff", "trackColorOn", "valueLabelDisplay", "altLabelPosition"], features: [function(e) {
  function t(n, o) {
    o.target instanceof HTMLInputElement && (n.input(o.target.checked ? n.props.onValue : n.props.offValue), n.props.checked = o.target.checked);
  }
  e.on("created", () => {
    "disabled" in e.props && (e.props.disabled = _e(e.props.disabled)), e.props.altLabelPosition = _e(e.props.altLabelPosition), e.props.offValue === void 0 && (e.props.offValue = !1), e.props.onValue === void 0 && (e.props.onValue = !0), e.props.checked = we(e.value, e.props.onValue), e.context && (e.context.handlers.toggles = t.bind(null, e));
  }), e.on("commit", ({ payload: n }) => {
    e.props.checked = we(n, e.props.onValue);
  });
}] }, pt = /* @__PURE__ */ Lt("rp"), { outer: eee, inner: tee, prefix: nee, suffix: oee, help: see, messages: aee, message: ree, icon: _a } = /* @__PURE__ */ Nt(pt), iee = pt("empty", () => ({ $el: "div" })), lee = pt("insertControl", () => ({ $el: "button", attrs: { disabled: "$value.length >= $max", onClick: "$fns.createInsert($index)", type: "button" } })), cee = pt("addButton", () => ({ $formkit: "button", bind: "$addAttrs", if: "$addButton", disabled: "$value.length >= $max", onClick: "$fns.createAppend()", type: "button" })), uee = pt("removeControl", () => ({ $el: "button", attrs: { disabled: "$value.length <= $min", onClick: "$fns.createRemover($index)", type: "button" } })), pee = pt("items", () => ({ $el: "ul", meta: { autoAnimate: !0 }, attrs: { role: "list", id: '$id + "_items"' } })), dee = pt("item", () => ({ $el: "li", for: ["item", "index", "$items"], attrs: { role: "listitem", key: "$item", "data-index": "$index" } })), fee = pt("downControl", () => ({ $el: "button", attrs: { disabled: "$index >= $value.length - 1", onClick: "$fns.createShift($index, 1)", type: "button" } })), mee = pt("upControl", () => ({ $el: "button", attrs: { disabled: "$index <= 0", onClick: "$fns.createShift($index, -1)", type: "button" } })), vee = pt("content", "div"), hee = pt("fieldset", () => ({ $el: "fieldset", attrs: { id: "$id" } })), gee = pt("legend", () => ({ $el: "legend", if: "$label" })), bee = pt("group", () => ({ $formkit: "group", index: "$index" })), yee = pt("controls", () => ({ $el: "ul", if: "$removeControl || $insertControl || $upControl || $downControl" })), $ee = pt("remove", () => ({ $el: "li", if: "$removeControl" })), _ee = pt("insert", () => ({ $el: "li", if: "$insertControl" })), wee = pt("up", () => ({ $el: "li", if: "$upControl" })), Cee = pt("down", () => ({ $el: "li", if: "$downControl" })), Fr = pt("controlLabel", "span"), kee = pt("dragHandleWrapper", () => ({ if: "$draggable", $el: "div" })), See = pt("dragHandle", () => ({ $el: "div", attrs: { id: '$id + "_drag_handle"' } }));
function Tee(e) {
  var t, n, o, s, a, r, i, l, c, u, p, f, m, h;
  if ((t = (l = e.props).removeControl) !== null && t !== void 0 || (l.removeControl = !0), (n = (c = e.props).upControl) !== null && n !== void 0 || (c.upControl = !0), (o = (u = e.props).downControl) !== null && o !== void 0 || (u.downControl = !0), (s = (p = e.props).insertControl) !== null && s !== void 0 || (p.insertControl = !1), (a = (f = e.props).addButton) !== null && a !== void 0 || (f.addButton = !0), (r = (m = e.props).addLabel) !== null && r !== void 0 || (m.addLabel = !1), (i = (h = e.props).addAttrs) !== null && i !== void 0 || (h.addAttrs = {}), e.props.draggable = _e(e.props.draggable), e.props.min = e.props.min !== void 0 ? Number(e.props.min) : 1, e.props.max = e.props.max !== void 0 ? Number(e.props.max) : 1 / 0, e.props.min > e.props.max) throw Error("Repeater: min must be less than max");
  if (Array.isArray(e.value)) if (e.value.length < e.props.min) {
    const g = go(e.props.min - e.value.length, () => ({}));
    e.input(e.value.concat(g), !1);
  } else e.value.length > e.props.max && e.input(e.value.slice(0, e.props.max), !1);
  else e.input(go(e.props.min, () => ({})), !1);
  e.context && function(g, _) {
    _.createShift = (v, w) => () => {
      const y = g._value;
      y.splice(v + w, 0, y.splice(v, 1)[0]), g.input(y, !1);
    }, _.createInsert = (v) => () => {
      const w = g._value;
      w.splice(v + 1, 0, {}), g.input(w, !1);
    }, _.createAppend = () => () => {
      const v = g._value;
      v.push({}), g.input(v, !1);
    }, _.createRemover = (v) => () => {
      const w = g._value;
      w.splice(v, 1), g.input(w, !1);
    };
  }(e, e.context.fns);
}
function tv(e, t) {
  var n;
  if (!t.context) return;
  const o = (n = t.props.__root) === null || n === void 0 ? void 0 : n.getElementById(`${t.props.id}_inner`), s = o == null ? void 0 : o.hasAttribute("data-auto-animate"), a = { group: t.props.id, dragHandle: `#${t.props.id}_drag_handle`, draggingClass: t.context.classes.dragging, dropZoneClass: t.context.classes.dropZone, root: t.props.__root, disabled: !t.props.draggable, plugins: s ? [] : [Dl({ duration: 100 })], touchDraggingClass: t.context.classes.touchDragging, touchDropZoneClass: t.context.classes.touchDropZone, draggable: (l) => l.tagName === "LI" };
  function r() {
    return Array.isArray(t.value) ? t.value : [];
  }
  function i(l) {
    t.input(l);
  }
  mt({ parent: e, getValues: r, setValues: i, config: a }), t.on("prop:disabled", ({ payload: l }) => {
    a.disabled = l, mt({ parent: e, getValues: r, setValues: i, config: a });
  }), t.on("prop:draggable", ({ payload: l }) => {
    a.disabled = !l, mt({ parent: e, getValues: r, setValues: i, config: a });
  });
}
const Aee = { schema: /* @__PURE__ */ eee(/* @__PURE__ */ hee(/* @__PURE__ */ gee("$label"), /* @__PURE__ */ see("$help"), /* @__PURE__ */ tee(/* @__PURE__ */ nee(), /* @__PURE__ */ ye("$value.length === 0", /* @__PURE__ */ ye("$slots.empty", /* @__PURE__ */ iee()), /* @__PURE__ */ pee(/* @__PURE__ */ dee(/* @__PURE__ */ kee(/* @__PURE__ */ See(/* @__PURE__ */ _a("dragHandle"))), /* @__PURE__ */ vee(/* @__PURE__ */ bee("$slots.default")), /* @__PURE__ */ yee(/* @__PURE__ */ wee(/* @__PURE__ */ mee(/* @__PURE__ */ Fr("$ui.moveUp.value"), /* @__PURE__ */ _a("moveUp"))), /* @__PURE__ */ $ee(/* @__PURE__ */ uee(/* @__PURE__ */ Fr("$ui.remove.value"), /* @__PURE__ */ _a("remove"))), /* @__PURE__ */ _ee(/* @__PURE__ */ lee(/* @__PURE__ */ Fr("$ui.add.value"), /* @__PURE__ */ _a("add"))), /* @__PURE__ */ Cee(/* @__PURE__ */ fee(/* @__PURE__ */ Fr("$ui.moveDown.value"), /* @__PURE__ */ _a("moveDown"))))), /* @__PURE__ */ oee()))), /* @__PURE__ */ cee('$addLabel || ($ui.add.value + " " + ($label || ""))')), /* @__PURE__ */ aee(/* @__PURE__ */ ree("$message.value"))), type: "list", props: ["min", "max", "total", "upControl", "downControl", "removeControl", "insertControl", "addLabel", "addButton", "addAttrs", "draggable"], features: [
  function(e) {
    e._c.sync = !0, e.on("created", Tee.bind(null, e)), e.on("mounted", () => {
      it(`${e.props.id}_items`, (t) => {
        if (t instanceof HTMLElement) {
          let n = function(o) {
            for (const s of o) for (const a of Array.from(s.addedNodes)) if (a instanceof HTMLElement && a.id === `${e.props.id}_items`) return void tv(a, e);
          };
          tv(t, e), new MutationObserver(n).observe(t.parentNode, { childList: !0 });
        }
      }, e.props.__root);
    });
  },
  fl,
  /* @__PURE__ */ We("remove"),
  /* @__PURE__ */ We("add"),
  /* @__PURE__ */ We("moveUp"),
  /* @__PURE__ */ We("moveDown"),
  /* @__PURE__ */ Oe("dragHandle", "dragHandle"),
  /* @__PURE__ */ Oe("remove", "trash"),
  /* @__PURE__ */ Oe("add", "add"),
  /* @__PURE__ */ Oe("moveUp", "arrowUp"),
  /* @__PURE__ */ Oe("moveDown", "arrowDown")
] }, Nu = /* @__PURE__ */ new WeakMap();
function yr(e, t) {
  const n = { onItems: [], offItems: [] }, o = t || Number(e.value || 0);
  for (let s = 0; s < e.props.max; s++) if (s < o && s + 1 >= o) {
    const a = e.props.rightToLeft ? 100 - 100 * (o - s) : 100 * (o - s);
    n.onItems.push(a + "%"), n.offItems.push(100 - a + "%");
  } else s < o ? (n.offItems.push("0%"), n.onItems.push("100%")) : s >= o && (n.offItems.push("100%"), n.onItems.push("0%"));
  e.props.itemsToPercentages = n;
}
function Dee(e, t) {
  var n;
  (n = e.context) === null || n === void 0 || n.handlers.blur(t);
}
function Pee(e, t) {
  const { x: n, y: o } = g0(t);
  let s = document.elementFromPoint(n, o);
  const a = Array.from(document.querySelectorAll(`#${e.props.id}_items_wrapper > .formkit-ratingItem`));
  let r = !0;
  for (; s && r; ) {
    if (a.includes(s)) {
      r = !1;
      break;
    }
    s = s.parentNode;
  }
  if (!r) {
    const i = a.indexOf(s);
    if (e.props.step === 1) return void e.input(i + 1, !1);
  }
}
function Iee(e, t, n) {
  e.props.disabled || (n.preventDefault(), e.props.hoverHighlight = !0, e.props.touchStarted = !0, e.props.step !== 1 ? Ml(e, t, n) : e.input(t + 1, !1));
}
function h0(e, t) {
  if (!e.props.dragStarted) return;
  t.preventDefault(), e.props.hoverHighlight = !1, e.props.dragStarted = !1, yr(e);
  const n = Nu.get(e);
  n && (n.abort(), Nu.delete(e));
}
function Eee(e, t, n) {
  if (e.props.hoverHighlight || e.props.disabled) return;
  n.preventDefault(), e.props.hoverHighlight = !0, e.props.dragStarted = !0;
  const o = new AbortController();
  document.addEventListener("mouseup", (s) => h0(e, s), { signal: o.signal }), Nu.set(e, o), e.props.step === 1 ? e.input(t + 1, !1) : Ml(e, t, n);
}
function Oee(e, t) {
  var n, o;
  if (document.activeElement === t.currentTarget) {
    if (t.key === "ArrowRight" || t.key === "ArrowDown") {
      e.props.arrow = 1;
      const s = e.value ? Fu(e.value + 1 * e.props.step, e.props.step) : e.props.min + 1 * e.props.step, a = (n = e.props.__root) === null || n === void 0 ? void 0 : n.querySelector(e.value ? `#${e.props.id}_inner input[value="${s}"]` : "#" + (e.props.id + "_0_0"));
      e.props.preventFocus = !0, a && a instanceof HTMLInputElement && a.focus(), e.props.preventFocus = !1, e.input(Number(s));
    } else if (t.key === "ArrowLeft" || t.key === "ArrowUp") {
      e.props.arrow = -1;
      const s = e.value ? Fu(e.value - 1 * e.props.step, e.props.step) : e.props.max, a = (o = e.props.__root) === null || o === void 0 ? void 0 : o.querySelector(`#${e.props.id}_inner input[value="${s}"]`);
      e.props.preventFocus = !0, a && a instanceof HTMLInputElement && a.focus(), e.props.preventFocus = !0, e.input(Number(s)), e.props.preventFocus = !1;
    }
  }
}
function xee(e, t) {
  if (!e.props.preventFocus) {
    if (e.props.preventFocus = !0, setTimeout(() => {
      e.props.preventFocus = !1;
    }, 50), t.relatedTarget instanceof HTMLElement && t.relatedTarget.id === e.props.id + "_items_wrapper") e.props.arrow > 0 ? setTimeout(() => {
      var n, o;
      (o = (n = e.props.__root) === null || n === void 0 ? void 0 : n.getElementById(e.props.id + "_0_0")) === null || o === void 0 || o.focus();
    }) : e.props.arrow < 0 && setTimeout(() => {
      var n, o;
      (o = (n = e.props.__root) === null || n === void 0 ? void 0 : n.getElementById(e.props.id + `_${e.props.max - 1}_${e.props.stepsPerValue - 1}`)) === null || o === void 0 || o.focus();
    });
    else if (t.target instanceof HTMLInputElement) {
      if (Number(t.target.value) === e.props.step && e.value === e.props.max || Number(t.target.value) === e.props.max && e.value === e.props.step) {
        const n = document.getElementById(e.props.id + "_items_wrapper");
        return n == null || n.focus(), void e.input(0);
      }
      e.input(Number(t.target.value));
    }
  }
}
function Mee(e, t, n) {
  e.props.hoverHighlight && (e.props.disabled || (e.props.step === 1 ? (yr(e, t + 1), e.props.dragStarted && e.input(t + 1, !1)) : Ml(e, t, n, !!e.props.dragStarted)));
}
function Lee(e) {
  yr(e);
}
function Nee(e, t, n) {
  if (!e.props.disabled && n.type !== "touchstart" && (n.preventDefault(), (n.clientX !== 0 || n.clientY !== 0) && n.currentTarget instanceof HTMLElement)) return e.props.step === 1 ? e.props.deselect && Number(e.value) === t + 1 ? void e.input(0) : void e.input(t + 1) : void Ml(e, t, n);
}
function g0(e) {
  return e instanceof MouseEvent ? { x: e.clientX, y: e.clientY } : { x: e.changedTouches[0].clientX, y: e.changedTouches[0].clientY };
}
function Ml(e, t, n, o = !0) {
  if (!(n.currentTarget instanceof HTMLElement)) return;
  const { x: s } = g0(n), a = n.currentTarget.getBoundingClientRect();
  let r = Fu((s - a.x) / a.width + t, e.props.step);
  r = r > e.props.min ? r : e.props.min, r = r < e.props.max ? r : e.props.max, !e.props.deselect || r !== Number(e.value) || e.props.dragStarted ? o ? e.input(r, !1) : yr(e, r) : e.input(0);
}
function Fu(e, t) {
  t || (t = 1);
  const n = 1 / t;
  return Math.ceil(e * n) / n;
}
const vn = /* @__PURE__ */ Lt("rt"), { outer: Fee, wrapper: Ree, inner: Vee, label: Bee, prefix: Hee, suffix: Uee, help: zee, messages: Wee, message: jee, icon: el } = /* @__PURE__ */ Nt(vn), qee = vn("itemsWrapper", () => ({ $el: "span", attrs: { style: { "flex-direction": '$rightToLeft && "row-reverse" || undefined' }, tabindex: "$value !== undefined && $value !== 0 && '-1' || '0'", id: "$id + _items_wrapper", onKeydown: "$handlers.handleWrapperKeydown", "data-disabled": "$disabled", onBlur: "$handlers.handleWrapperBlur", onMouseleave: "$hoverHighlight && $handlers.handleMouseleave" } })), Kee = vn("ratingItem", () => ({ for: ["item", "index", "$max"], $el: "span", attrs: { id: '$id + "_item_" + $index', onClick: "$handlers.handleItemClick($item)", draggable: "$hoverHighlight !== true && && $disabled !== true && true", onMousemove: "$handlers.handleMousemove($item)", onDragstart: "$handlers.handleDragstart($item)", onDragend: "$handlers.handleDragend", onTouchstart: "$handlers.handleTouchstart($item)", onTouchmove: "$handlers.handleTouchmove" } })), Yee = vn("template", () => ({ for: ["increment", "stepIndex", "$stepsPerValue"], $el: null })), Gee = vn("itemLabel", () => ({ $el: "label", attrs: { id: '$id + "_label_" + $index + "_" + $stepIndex', for: '$id + "_" + $index + "_" + $stepIndex', "data-checked": '$value === $fns.getValue($item, $increment) && "true" || "false"', style: { width: '$fns.showLabel($fns.getValue($item, $increment), $stepIndex, $item) && "100%" || "0%"' } } })), Zee = vn("itemLabelInner", () => ({ $el: "span", children: "$fns.getValue($item, $increment)" })), Xee = vn("input", () => ({ $el: "input", attrs: { type: "radio", value: "$fns.getValue($item, $increment)", id: '$id + "_" + $index + "_" + $stepIndex', onFocus: "$handlers.handleFocus", tabindex: '$value === $fns.getValue($item, $increment) && "0" || "-1"', disabled: "$disabled", name: "$id", "data-value": "$fns.getValue($item, $increment)", checked: "$value === $fns.getValue($item, $increment) && true", onKeydown: "$handlers.handleKeydown($fns.getValue($item, $increment))" } })), Jee = vn("onItemRow", () => ({ $el: "span", attrs: { style: { width: "$fns.getPercentage($itemsToPercentages, $item)", display: "flex", position: "relative", overflow: "hidden", top: "0", left: "0", bottom: "0" } } })), Qee = vn("offItemRow", () => ({ $el: "span", attrs: { style: { width: "$fns.getPercentage($itemsToPercentages, $item, false)", display: "flex", "flex-direction": "row-reverse", position: "absolute", zIndex: "$offItemStyles && 100", overflow: "hidden", top: "0", right: "0" } } })), ete = vn("onItemWrapper", () => ({ $el: "div", attrs: { style: { color: "$onColor" } } })), tte = vn("offItemWrapper", () => ({ $el: "div", attrs: { style: { color: "$offColor" } } })), nte = () => ye("$slots.onItem", () => () => "$slots.onItem", ye("$slots.default", () => () => "$slots.default", el("rating"))), ote = () => ye("$slots.offItem", () => () => "$slots.offItem", ye("$slots.default", () => () => "$slots.default", el("rating"))), ste = { schema: /* @__PURE__ */ Fee(/* @__PURE__ */ Ree(/* @__PURE__ */ Bee("$label"), /* @__PURE__ */ Vee(/* @__PURE__ */ el("prefix"), /* @__PURE__ */ Hee(), /* @__PURE__ */ qee(/* @__PURE__ */ Kee(/* @__PURE__ */ Yee(/* @__PURE__ */ Gee(/* @__PURE__ */ Jee(/* @__PURE__ */ ete(/* @__PURE__ */ nte())), /* @__PURE__ */ Qee(/* @__PURE__ */ tte(/* @__PURE__ */ ote())), /* @__PURE__ */ Zee()), /* @__PURE__ */ Xee()))), /* @__PURE__ */ Uee(), /* @__PURE__ */ el("suffix"))), /* @__PURE__ */ zee("$help"), /* @__PURE__ */ Wee(/* @__PURE__ */ jee("$message.value"))), type: "input", props: [], features: [function(e) {
  function t(n) {
    setTimeout(() => {
      const o = Array.from(document.querySelectorAll(`#${n.props.id}_items_wrapper > .formkit-ratingItem`));
      for (let s = 0; s < o.length; s++) {
        const a = o[s].querySelectorAll(".formkit-onItemWrapper"), r = o[s].querySelectorAll(".formkit-offItemWrapper");
        for (let i = 0; i < a.length; i++) a[i].style.flex = `0 0 ${o[s].getBoundingClientRect().width}px`;
        for (let i = 0; i < r.length; i++) r[i].style.flex = `0 0 ${o[s].getBoundingClientRect().width}px`;
      }
    });
  }
  e.addProps(["max", "step", "stepsPerValue", "itemsToPercentages", "rightToLeft", "onItemStyles", "offItemStyles", "hoverHighlight", "deselect", "disabled", "wrapperWidth", "onColor", "offColor"]), e.props.hoverHighlight !== !1 && e.props.hoverHighlight !== "false" && (e.props.hoverHighlight = !0), e.props.deselect = _e(e.props.deselect), e.props.max = Number(e.props.max) || 5, e.props.min = Number(e.props.min) || 0, e.props.step = Number(e.props.step) || 1, e.props.numberOfSteps = e.props.max / e.props.step, e.props.lastIndex = 1 / e.props.step - 1, e.props.itemsToPercentages = {}, "disabled" in e.props && (e.props.disabled = _e(e.props.disabled)), e.props.rightToLeft ? (e.props.onItemStyles = void 0, e.props.offItemStyles = { position: "absolute", top: "0", left: "0", overflow: "hidden", height: "100%", zIndex: 100 }) : e.props.onItemStyles = { position: "absolute", top: "0", left: "0", overflow: "hidden", height: "100%" }, e.props.stepsPerValue = 1 / e.props.step, e.hook.input((n, o) => {
    if (n === null || n === "" || isNaN(n)) return o(n);
    const s = Number(n), a = Number(e.props.min), r = Number(e.props.max);
    return s > r ? o(r) : e.props.min && s <= a ? o(a) : o(s);
  }), e.on("commit", ({ payload: n }) => {
    const o = Number(n || 0);
    yr(e, o);
  }), e.on("created", () => {
    e.context && (it(`${e.props.id}_items_wrapper`, () => {
      t(e), function(n) {
        var o;
        const s = (o = n.props.__root) === null || o === void 0 ? void 0 : o.getElementById(`${n.props.id}_items_wrapper`);
        s && new ResizeObserver(() => {
          t(n);
        }).observe(s);
      }(e), setTimeout(() => t(e), 100);
    }, e.props.__root), e.context.fns.getPercentage = (n, o, s = !0) => (s ? n.onItems : n.offItems)[o], e.context.fns.getValue = (n, o) => n + Number((o * e.props.step + e.props.step).toFixed(1)), e.context.fns.showLabel = (n, o) => {
      const s = Number(e.value || 0);
      return s === 0 && o === 0 || s && n === s || n > s && o === 0 || s > n && o === e.props.lastIndex;
    }, e.context.handlers.handleFocus = (n) => xee.call(null, e, n), e.context.handlers.handleWrapperKeydown = (n) => Oee.call(null, e, n), e.context.handlers.handleWrapperBlur = (n) => Dee.call(null, e, n), e.context.handlers.handleItemClick = (n) => (o) => Nee.call(null, e, n, o), e.context.handlers.handleMousemove = (n) => (o) => Mee.call(null, e, n, o), e.context.handlers.handleMouseleave = () => Lee.call(null, e), e.context.handlers.handleDragstart = (n) => (o) => Eee.call(null, e, n, o), e.context.handlers.handleMouseup = (n) => h0.call(null, e, n), e.context.handlers.handleTouchstart = (n) => (o) => Iee.call(null, e, n, o), e.context.handlers.handleTouchmove = (n) => Pee.call(null, e, n), e.context.handlers.handleKeydown = (n) => (o) => function(s, a, r) {
      const i = Number(s.value);
      s.props.deselect && r.key === " " && i === a ? s.input(0) : r.key === " " && s.input(a);
    }(e, n, o));
  });
}, /* @__PURE__ */ Oe("rating", "star")] }, Mn = /* @__PURE__ */ Lt("ac"), { outer: ate, wrapper: rte, inner: ite, icon: Nn, label: lte, prefix: cte, suffix: ute, help: pte, messages: dte, message: fte } = /* @__PURE__ */ Nt(Mn), mte = Mn("input", () => ({ $el: "input", bind: "$attrs", attrs: { id: "$id", type: "text", onClick: "$handlers.click", onBlur: "$handlers.blur", onKeydown: "$handlers.keydown", onInput: "$handlers.input", onFocus: "$handlers.focus", value: "$inputText || undefined", name: "$node.name", placeholder: "$state.loading && $ui.isLoading.value || $placeholder || undefined", tabindex: '$disabled && "-1" || 0', role: "combobox", autocomplete: '$attrs.autocomplete || "off"', autocapitalize: "none", readonly: "$attrs.readonly || $state.loading || $multiple && $max && $value && $value.length >= $max && $hasHighlightedRange !== true || undefined", "data-selection-appearance": "$selectionAppearance", disabled: "$disabled || $disabledInternally || undefined", onTouchmove: "$handlers.touchmove", onTouchstart: "$handlers.touchmove", onTouchend: "$handlers.touchend", "aria-autocomplete": "list", "aria-expanded": "$expanded", "aria-controls": '$expanded && $id + "_listbox" || undefined', "aria-describedBy": "$describedBy", "aria-activedescendant": "$expanded && $activeDescendant || undefined" } })), nv = Mn("listboxButton", () => ({ $el: "div", attrs: { style: "$visibilityStyles", id: '$id + "_listbox_button"', role: "button", "aria-label": "$expanded && $ui.close.value || $ui.open.value", onClick: "$handlers.toggleListbox", onKeydown: "$handlers.toggleListboxKeydown", tabindex: '$disabled && "-1" || 0', "aria-haspopup": "true", "aria-expanded": "$expanded", "aria-controls": '$expanded && $id + "_listbox" || undefined', "aria-disabled": "$disabled || $state.loading || undefined", "data-disabled": "$disabled || $disabledInternally || undefined" } })), ov = Mn("selectionWrapper", () => ({ for: ["option", "index", "$selections"], $el: "div", attrs: { id: '$id + "_selection_wrapper_" + $index', key: "$option.value", "data-value": "$option.value", tabindex: '$disabled && "-1" || 0', onKeydown: "$handlers.selectionKeydown && $handlers.selectionKeydown($multiple && $option || undefined)", onClick: "$handlers.selectionClick && $handlers.selectionClick($multiple && $option || undefined)", onFocus: "$handlers.selectionFocus && $handlers.selectionFocus($multiple && $option || undefined)", onBlur: "$handlers.selectionBlur && $handlers.selectionBlur($multiple && $option || undefined)", "data-is-selection": "true", "data-active-selection": "$fns.isActiveSelection && $fns.isActiveSelection($activeSelectionValue, $option)" } })), sv = Mn("selection", () => ({ $el: "div", attrs: { id: '$id + "_selection_" + $index' } })), av = Mn("selections", () => ({ $el: "div", attrs: { "aria-live": "polite", id: '$id + "_selections"' } })), Rc = Mn("removeSelection", () => ({ $el: "button", attrs: { id: '$selectionAppearance === "option" && $multiple && $id + "_remove_selection_" + $index || $id + "_remove_selection"', tabindex: "0", title: "$ui.remove.value", type: "button", "aria-label": "$ui.remove.value", onClick: "$handlers.removeSelection && $handlers.removeSelection($multiple && $option || undefined)", onTouchend: "$handlers.removeSelection && $handlers.removeSelection($multiple && $option || undefined)", "aria-controls": "$id" } })), rv = Mn("optionLoading", "span"), iv = Mn("option", () => ({ $el: "div", if: "$value !== undefined" })), vte = /* @__PURE__ */ hd(Mn);
function hte(e) {
  e.props.selectionAppearance !== "option" || e.props.multiple || e.props.selectionRemovable === !1 || e.props.selectionRemovable === "false" || (e.props.selectionRemovable = !0), e.props.multiple || (e.props.clearSearchOnOpen = _e(e.props.clearSearchOnOpen)), e.props.selectionRemovable = _e(e.props.selectionRemovable), e.props.openOnClick = _e(e.props.openOnClick), e.props.selectionAppearance !== "option" || e.props.multiple || (e.props.isSingleOption = !0), e.props.closeOnSelect === void 0 && (e.props.closeOnSelect = !0), e.props.selectionAppearance === void 0 && (e.props.selectionAppearance = "text-input"), e.props.closeOnSelect === void 0 && (e.props.closeOnSelect = !0), e.props.closeOnSelect ? e.props.resetSearchOnCommit = !1 : e.props.resetSearchOnCommit === void 0 && (e.props.resetSearchOnCommit = e.props.multiple), e.props.allowNewValues = _e(e.props.allowNewValues);
}
function b0(e) {
  e.addProps(["inputText", "selectionAppearance", "searchValue", "openOnClick", "filteredOptions", "search", "debounce", "showInput", "visibilityStyles", "selectionStyles", "multiple", "filter", "hasHighlightedRange", "clearOnClick", "debounce"]), e.props.debounce === void 0 ? e.props.debounce = 200 : e.props.debounce = parseInt(e.props.debounce), e.props.nonceKey = "searchValue", e.props.searchValue = "", e.props.inputText = "", e.props.filterOptions = pn.bind(null, e), e.props.reloadOnCommit = _e(e.props.reloadOnCommit), e.props.alwaysLoadOnOpen === void 0 ? e.props.alwaysLoadOnOpen = !0 : e.props.alwaysLoadOnOpen = _e(e.props.alwaysLoadOnOpen), typeof e.props.filter != "function" && (e.props.filter = (t, n) => t.label.toLowerCase().includes(n.toLowerCase())), e.on("created", () => {
    e.context && Ot && (e.context.handlers.focus = lv.bind(null, e), e.context.handlers.input = gte.bind(null, e), e.context.handlers.focus = lv.bind(null, e), e.context.handlers.click = bte.bind(null, e), e.context.handlers.toggleListbox = y0.bind(null, e), e.context.handlers.toggleListboxKeydown = yte.bind(null, e), e.context.handlers.keydown = _Q.bind(null, e), e.context.handlers.selectionKeydown = (t) => (n) => yQ(e, t, n), e.context.handlers.searchInputTagKeydown = (t) => (n) => function(o, s, a) {
      if (a.stopPropagation(), !o.props.disabled)
        switch (a.key) {
          case "ArrowDown":
            u0(o);
            break;
          case "ArrowRight":
          case "ArrowLeft":
            p0(o, s, a);
            break;
          case "Delete":
          case "Backspace":
            d0(o, s, a);
        }
    }(e, t, n), e.on("prop:options", ({ payload: t }) => {
      if ((e.props.initialOptions.length === 0 && typeof e.props.optionsLoader != "function" || !e.props.searchValue && t.length) && (e.props.initialOptions = [...t]), e.props.selections && e.props.selections.length && t.length) for (let n = 0; n < e.props.selections.length; n++) {
        const o = e.props.selections[n], s = t.find((a) => de(a) === o.value);
        s && (e.props.selections[n] = s);
      }
    }));
  }), e.on("prop:expanded", ({ payload: t }) => {
    t || t0.delete(e);
  });
}
function gte(e, t) {
  if (e.props.disabled) return;
  const n = t.target;
  e.props.inputText = n.value, e.emit("handleSearchInput", n.value), e.props.searchValue && pn(e, e.props.searchValue, !0);
}
function bte(e, t) {
  t.stopPropagation(), e.props.disabled || e.props.disabledInternally || (e.props.attrs.onClick && e.props.attrs.onClick(t), (!e.props.expanded && e.props.openOnClick || e.props.openOnFocus) && (e.props.expanded = !0));
}
function lv(e) {
  e.props.disabled || e.props.disabledInternally || (e.props.attrs.onFocus && e.props.attrs.onFocus(), e.props.activeSelectionValue = void 0, e.props.skipOpen ? e.props.skipOpen = !1 : e.props.openOnFocus && (e.props.expanded = !0));
}
function y0(e) {
  var t, n, o;
  e.props.disabled || e.props.disabledInternally || !((t = e.context) === null || t === void 0) && t.state.loading || (e.props.expanded = !e.props.expanded, e.props.openOnFocus || (o = (n = e.props.__root) === null || n === void 0 ? void 0 : n.getElementById(`${e.props.id}`)) === null || o === void 0 || o.focus());
}
function yte(e, t) {
  t.key !== "Enter" && t.key !== " " || (t.preventDefault(), t.stopPropagation(), y0(e));
}
const cv = /* @__PURE__ */ new WeakMap(), ri = typeof window < "u", Vc = /* @__PURE__ */ new WeakMap();
let uv = !1;
function $te(e) {
  e.props.searchValue = null, e.on("commit", () => {
    e.props.searchValue = null, e.props.highlightedRange || pv(e);
  }), e.on("created", () => {
    if (!e.context || !ri) return;
    e.on("handleSearchInput", ({ payload: a }) => {
      a === "" ? (e.props.searchValue = null, e.input([])) : a && e.props.inputStd.length === 0 ? e.props.searchValue = a : a && e.props.inputStd.length > 0 && (e.props.searchValue = function(r) {
        var i;
        const l = Rr(r);
        if (r.props.highlightedRange) {
          const [c, u] = dv(r, l);
          return r.props.inputText.slice(c, u);
        }
        return r.props.inputText.slice(((i = l[l.length - 1]) === null || i === void 0 ? void 0 : i.end) + 2);
      }(e)), !e.props.expanded && a ? e.props.expanded = !0 : !a && e.props.expanded && (e.props.expanded = !1);
    }), function(a) {
      it(`${a.props.id}`, (r) => {
        r instanceof HTMLInputElement && Vc.set(r, a);
      }, a.props.__root), ri && !uv && (uv = !0, document.addEventListener("selectionchange", () => {
        const r = es();
        if (r instanceof HTMLInputElement && Vc.has(r)) {
          const i = Vc.get(r);
          i && function(l) {
            clearTimeout(cv.get(l)), cv.set(l, setTimeout(() => {
              var c, u, p, f;
              const m = (c = l.props.__root) === null || c === void 0 ? void 0 : c.getElementById(`${l.props.id}`);
              if (m instanceof HTMLInputElement) {
                const h = Rr(l), g = h.findIndex((v) => m.selectionStart !== null ? m.selectionStart >= v.start && m.selectionStart <= v.end : m.selectionEnd !== null && m.selectionEnd >= v.start && m.selectionEnd <= v.end), _ = (u = h[h.length - 1]) === null || u === void 0 ? void 0 : u.end;
                if (m.selectionStart === 0 && m.selectionEnd === ((p = l.props.inputText) === null || p === void 0 ? void 0 : p.length)) return;
                if (typeof l.props.searchValue == "string" && l.props.highlightedRange) {
                  if (h.length) {
                    const v = l.props.highlightedRange, [w, y] = dv(l, h);
                    if (m.selectionEnd !== null && (m.selectionEnd < w || m.selectionEnd > y)) {
                      const $ = v.end - v.start - (y - w), S = m.selectionEnd;
                      l.props.inputText = l.props.option.label, l.props.highlightedRange = void 0, l.props.searchValue = null, m.value = l.props.inputText, m.selectionStart = m.selectionEnd = S + (S > w ? $ : 0);
                    }
                  }
                } else if (g >= 0 && m.selectionStart !== null && (_ !== ((f = l.props.inputText) === null || f === void 0 ? void 0 : f.length) || m.selectionStart < _)) {
                  const v = h[g], w = l.props.inputText.substr(0, _), y = v.start + (v.index > 0 ? 1 : 0), $ = v.end + (h.length - 1 > v.index ? -1 : 0);
                  w !== l.props.inputText && (l.props.inputText = w, m.value = w), l.props.highlightedRange = v, m.selectionStart = y, m.selectionEnd = $;
                } else l.props.highlightedRange = void 0, pv(l);
                if (m.selectionStart !== null && m.selectionStart >= _ && l.props.inputText.substring(_, _ + 2) !== ", ") {
                  let v = l.props.inputText.substring(0, _);
                  v = l.props.multiple && l.props.max && Array.isArray(l.props.inputStd) && l.props.inputStd.length >= l.props.max ? v : `${v},`, l.props.inputText = `${v} ${l.props.inputText.substring(_).replace(/^[,\s]{1,2}/, "")}`;
                }
              }
            }, 5));
          }(i);
        }
      }));
    }(e);
    const o = e.context.handlers.keydown;
    e.context.handlers.keydown = (a) => {
      o(a), function(r, i) {
        var l, c, u, p;
        if (["ArrowRight", "ArrowLeft"].includes(i.key) && i.target instanceof HTMLInputElement && i.target.selectionEnd !== null && i.target.selectionStart !== null) {
          if (i.target.selectionStart === 0 && i.target.selectionEnd === ((l = r.props.inputText) === null || l === void 0 ? void 0 : l.length)) i.key === "ArrowLeft" ? t(0) : t(-1);
          else if (!r.props.searchValue) {
            r.props.searchValue = null;
            const f = Rr(r), m = (c = f[f.length - 1]) === null || c === void 0 ? void 0 : c.end;
            i.target.selectionStart < m && (i.target.selectionStart = Math.max(0, i.key === "ArrowLeft" ? i.target.selectionStart - 2 : i.target.selectionEnd + 2));
          }
        } else if (["Delete", "Backspace"].includes(i.key)) r.props.highlightedRange && !r.props.searchValue ? (xl(r, r.props.highlightedRange.option), r.props.inputStd.length === 0 && (r.props.highlightedRange = void 0)) : i.target instanceof HTMLInputElement && (r.props.searchValue = null, t(-1, !0) && i.preventDefault());
        else if (i.target instanceof HTMLInputElement && i.target.selectionStart === 0 && i.target.selectionEnd === ((u = r.props.inputText) === null || u === void 0 ? void 0 : u.length) && (!((p = r.props.inputText) === null || p === void 0) && p.length) && r.props.selections.length === 0) i.preventDefault();
        else if (i.key === "Tab") return;
        i.key === "ArrowLeft" && t(-1, !0) && i.preventDefault();
      }(e, a);
    };
    const s = e.context.handlers.focus;
    e.context.handlers.focus = (a) => {
      s(e, a);
      const r = new Event("selectionchange");
      document.dispatchEvent(r);
    }, e.on("blur", () => {
      e.props.selections.length ? (e.props.inputText = e.props.selections.map((a) => a.label).join(", "), e.props.searchValue = null) : e.props.selections.length || (e.props.inputText = "", e.props.searchValue = "");
    });
  }), e.on("prop:expanded", ({ payload: o }) => {
    o || e.props.inputStd.length ? o && (e.props.options.length && !e.props.alwaysLoadOnOpen || (e.props.options = [], pn(e, e.props.searchValue))) : (e.props.searchValue = "", e.props.inputText = "");
  }), e.on("prop:selections", () => {
    var o;
    const s = [...e.props.selections].map((r) => r.label).join(", ");
    let a = "";
    if (ri && e.isCreated) {
      const r = (o = e.props.__root) === null || o === void 0 ? void 0 : o.getElementById(`${e.props.id}`);
      if (es() === r && Array.isArray(e._value) && e._value.length) {
        if (e.props.max && e._value.length >= Number(e.props.max)) return;
        a = ", ";
      }
    }
    e.props.inputText = `${s}${a}`, e.props.reloadOnCommit && (e.props.searchValue = "", pn(e, e.props.searchValue));
  });
  const t = (o, s = !1) => {
    var a, r;
    const i = (a = e.props.__root) === null || a === void 0 ? void 0 : a.getElementById(`${e.props.id}`);
    if (!(i instanceof HTMLInputElement)) return !1;
    const l = Rr(e), c = o >= 0 ? o : l.length - 1;
    if (l[c] === void 0) return !1;
    const u = (r = l[c]) === null || r === void 0 ? void 0 : r.end;
    return i.selectionStart !== null && (!s || i.selectionStart >= u && i.selectionStart <= u + 2) && (i.selectionStart = l[c].start + (c > 0 ? 1 : 0), i.selectionEnd = l[c].end + (c < l.length - 1 ? -1 : 0), !0);
  };
  let n;
  e.on("selectRange", ({ payload: o }) => t(...o)), e.on("prop:highlightedRange", ({ payload: o }) => {
    e.props.hasHighlightedRange = !!o, o && e.props.expanded && n !== o.option && (n = o.option, yd(e));
  });
}
function pv(e) {
  var t;
  if (!ri) return;
  const n = (t = e.props.__root) === null || t === void 0 ? void 0 : t.getElementById(`${e.props.id}`);
  n && n.scrollTo({ left: n.scrollWidth, behavior: "smooth" });
}
function dv(e, t) {
  var n;
  const o = e.props.highlightedRange, s = o.index, a = o.start + (s ? 1 : 0), r = t.length - 1 > s ? t[t.length - 1].end - t[s + 1].start : 0;
  return [a, ((n = e.props.inputText) === null || n === void 0 ? void 0 : n.length) - r + (t.length - 1 > o.index ? -1 : 0)];
}
function Rr(e) {
  const t = bd(e);
  return Array.isArray(t) && t.length ? t.reduce((n, o, s) => {
    var a;
    const r = ((a = n[s - 1]) === null || a === void 0 ? void 0 : a.end) || 0;
    let i = 0;
    return t.length - 1 !== s && i++, s !== 0 && i++, n.push({ option: o, index: s, start: r, end: r + o.label.length + i }), n;
  }, []) : [];
}
function $0(e) {
  (function(t) {
    t.on("prop:expanded", ({ payload: n }) => {
      n ? (t.props.searchValue = "", t.props.options.length && !t.props.alwaysLoadOnOpen || (t.props.options = [], pn(t, t.props.searchValue, !0))) : (t.props.searchValue = "", t.props.inputText = "");
    });
  })(e), function(t) {
    t.on("handleSearchInput", ({ payload: n }) => {
      n && !t.props.expanded ? (t.props.searchExpand = !0, t.props.expanded = !0) : !n && t.props.expanded && (t.props.expanded = !1), t.props.searchValue = t.props.inputText;
    });
  }(e), function(t) {
    t.on("prop:selections", () => {
      t.isCreated && (t.props.inputText = "", t.props.searchValue = "", t.props.optionRemoved || t.props.reloadOnCommit && pn(t, t.props.searchValue, !0));
    });
  }(e);
}
function _te(e) {
  (function(t) {
    function n(s) {
      s.props.inputStd.length === 0 ? (s.props.inputText = "", s.props.searchValue = "") : (s.props.inputText = s.props.selections[0].label, s.props.searchValue = s.props.selections[0].label);
    }
    function o(s) {
      s.props.clearSearchOnOpen && !s.props.searchExpand && (s.props.inputText = "", s.props.searchValue = ""), s.props.searchValue = s.props.inputText, s.props.options.length && !s.props.alwaysLoadOnOpen || s.props.searchExpand || (s.props.options = [], pn(s, s.props.searchValue, !0)), s.props.searchExpand && (s.props.searchExpand = !1);
    }
    t.on("prop:expanded", ({ payload: s }) => {
      s ? o(t) : n(t);
    });
  })(e), function(t) {
    t.on("handleSearchInput", ({ payload: n }) => {
      n === "" ? (t.props.inputStd.length === 0 && (t.props.expanded = !1), t.input(void 0)) : n && !t.props.expanded && (t.props.searchExpand = !0, t.props.expanded = !0), t.props.searchValue = t.props.inputText;
    });
  }(e), function(t) {
    t.on("prop:selections", ({ payload: n }) => {
      t.props.inputText = n.length ? n[0].label : "", t.props.searchValue = n.length ? n[0].label : "", t.isCreated && t.props.expanded && n.length === 0 && pn(t, t.props.searchValue, !0);
    });
  }(e);
}
function wte(e) {
  if (e.props.multiple) if (e.props.multiple && e.props.selectionAppearance === "option") {
    let t = function() {
      return Array.isArray(e.value) ? e.value : [];
    }, n = function(o) {
      e.input(o);
    };
    $0(e), e.on("created", () => {
      e.props.disabled && (e.props.draggable = !1), it(`${e.props.id}_selections`, (o) => {
        if (o instanceof HTMLElement && e.context) {
          const s = { draggingClass: e.context.classes.dragging, dropZoneClass: e.context.classes.dropZone, root: e.props.__root, disabled: !e.props.draggable, plugins: [Dl()], touchDraggingClass: e.context.classes.touchDragging, touchDropZoneClass: e.context.classes.touchDropZone, draggable: (a) => a.hasAttribute("data-is-selection") };
          mt({ parent: o, getValues: t, setValues: n, config: s }), e.on("prop:disabled", ({ payload: a }) => {
            s.disabled = a, mt({ parent: o, getValues: t, setValues: n, config: s });
          }), e.on("prop:draggable", ({ payload: a }) => {
            s.disabled = !a, mt({ parent: o, getValues: t, setValues: n, config: s });
          });
        }
      }, e.props.__root);
    });
  } else e.props.multiple && e.props.selectionAppearance === "text-input" && $te(e);
  else _te(e);
}
const Cte = { schema: /* @__PURE__ */ ate(/* @__PURE__ */ rte(/* @__PURE__ */ lte("$label"), /* @__PURE__ */ ite(/* @__PURE__ */ Nn("prefix"), /* @__PURE__ */ cte(), /* @__PURE__ */ mte(), /* @__PURE__ */ ye("$multiple !== true && $selectionAppearance === option && $expanded === false", /* @__PURE__ */ av(/* @__PURE__ */ ov(/* @__PURE__ */ sv(/* @__PURE__ */ iv(/* @__PURE__ */ ye("$state.loading", /* @__PURE__ */ rv("$ui.isLoading.value"), "$option.label"))), /* @__PURE__ */ ye("$state.loading && $isSingleOption !== true && $optionLoaderValues.includes($option.value)", /* @__PURE__ */ Nn("loader")), /* @__PURE__ */ ye("$selectionRemovable && $isSingleOption", /* @__PURE__ */ Rc(/* @__PURE__ */ Nn("close")))))), /* @__PURE__ */ ye("$state.loading && ($isSingleOption !== true || $selections.length === 0)", /* @__PURE__ */ Nn("loader")), /* @__PURE__ */ ye('$selectionRemovable && $selectionAppearance === "text-input" && $selections.length > 0', /* @__PURE__ */ Rc(/* @__PURE__ */ Nn("close")), /* @__PURE__ */ ye('$selectionAppearance === "text-input" || ($selectionAppearance === "option" && $multiple)', /* @__PURE__ */ nv(/* @__PURE__ */ Nn("select")))), /* @__PURE__ */ ye("$isSingleOption && ($inputStd.length === 0 || $selectionRemovable === undefined || ($expanded) || $state.loading || $optionLoaderValues.length > 0)", /* @__PURE__ */ nv(/* @__PURE__ */ Nn("select"))), /* @__PURE__ */ vte(), /* @__PURE__ */ ute(), /* @__PURE__ */ Nn("suffix")), /* @__PURE__ */ ye("$multiple && $selectionAppearance === option", /* @__PURE__ */ av(/* @__PURE__ */ ov(/* @__PURE__ */ sv(/* @__PURE__ */ iv(/* @__PURE__ */ ye("$state.loading && $isLoadingOption", /* @__PURE__ */ rv("$ui.isLoading.value"), "$option.label"))), /* @__PURE__ */ Rc(/* @__PURE__ */ Nn("close")))))), /* @__PURE__ */ pte("$help"), /* @__PURE__ */ dte(/* @__PURE__ */ fte("$message.value"))), type: "input", family: "dropdown", props: [], features: [
  /* @__PURE__ */ Oe("select", "select"),
  /* @__PURE__ */ Oe("close", "close"),
  /* @__PURE__ */ Oe("selected", "check"),
  /* @__PURE__ */ Oe("loader", "spinner"),
  /* @__PURE__ */ We("isLoading"),
  /* @__PURE__ */ We("loadMore"),
  /* @__PURE__ */ We("remove"),
  /* @__PURE__ */ We("open"),
  /* @__PURE__ */ We("close"),
  xn,
  /* @__PURE__ */ _d.bind(null, hte, b0, wte),
  br
] }, He = /* @__PURE__ */ Lt("dp"), { outer: kte, wrapper: Ste, inner: Tte, icon: Mo, label: Ate, prefix: Dte, suffix: Pte, help: Ite, messages: Ete, message: Ote } = /* @__PURE__ */ Nt(He), xte = He("input", () => ({ $el: "input", bind: "$attrs", attrs: { name: "$node.name", id: "$id", onKeydown: "$handlers.inputKeydown", value: "$inputText", onInput: "$handlers.dateInput", onClick: "$pickerOnly && $handlers.open", onBlur: "$handlers._blur", onFocus: "$handlers.focus", readonly: "$pickerOnly || $expanded", disabled: "$disabled" } })), Mte = He("panelWrapper", () => ({ $el: "div", if: "$expanded", attrs: { id: '$id + "_popover"', role: "dialog", onBlur: "$handlers._blurOut()", tabindex: "-1", popover: "$popover", "aria-modal": "true", "aria-label": "Choose date", "data-panel": "$panel", style: { if: "$usePopover", then: { margin: 0, top: '$popoverCoordinates.y + "px"', left: '$popoverCoordinates.x + "px"', width: '$popoverCoordinates.width + "px"' } } } })), Lte = He("next", () => ({ $el: "button", if: "$showPagination", attrs: { id: "$id + _next_button", type: "button", onClick: "$handlers.next" } })), Nte = He("nextLabel", "span"), Fte = He("prev", () => ({ $el: "button", if: "$showPagination", attrs: { id: "$id + _prev_button", type: "button", onClick: "$handlers.prev" } })), Rte = He("prevLabel", "span"), Vte = He("calendar", () => ({ if: '$panel === "day"', $el: "table", for: ["month", "$calendar"], attrs: { key: '$fns.format($month.monthDay, "YYYY-MM")' } })), Bte = He("calendarWeeks", () => ({ $el: "tbody" })), Hte = He("calendarHeader", () => ({ $el: "thead" })), Ute = He("weekDays", () => ({ $el: "tr" })), zte = He("weekDay", () => ({ $el: "th", for: ["day", "$month.weeks.0"], attrs: { "aria-label": '$fns.format($day, "dddd")' } })), Wte = He("week", () => ({ $el: "tr", for: ["week", "weekIndex", "$month.weeks"] })), jte = He("dayCell", () => ({ $el: "td", for: ["day", "dayIndex", "$week"], attrs: { key: "$day", onClick: "$handlers.setDate($day)", onKeydown: "$handlers.keyDown", onMouseenter: "$handlers.mouseEnter($day)", onMouseleave: "$handlers.mouseLeave", onBlur: "$handlers._blurOut(day)", tabindex: '$fns.sameDay($day) && "0" || "-1"', "data-is-extra": "$fns.notInMonth($month.monthDay, $day)", "data-disabled": "$fns.isDisabled($day)", "aria-selected": "$selectedWeek === $weekIndex && $selectedDay === $dayIndex", "aria-label": '$fns.format($day, "long")' } })), qte = He("day", "div"), Kte = He("openButton", () => ({ $el: "div", attrs: { style: "$visibilityStyles", id: '$id + "_listbox_button"', type: "div", role: "button", onClick: "$handlers.open", onKeydown: "$handlers.openKeydown", tabIndex: '$pickerOnly && "-1" || "0"', "data-disabled": "$disabled", "aria-disabled": "$disabled", "aria-label": '$value && ($ui.changeDate.value + ", " + $inputText) || $ui.chooseDate.value', "aria-haspopup": "true", "aria-expanded": "$expanded", "aria-controls": '$expanded && $id + "_listbox" || undefined' } })), Yte = He("years", () => ({ if: '$panel === "year"', $el: "ul", attrs: { id: '$id + "_years"' } })), Gte = He("year", () => ({ for: ["year", "$years"], $el: "li", attrs: { key: '$: "year" + $fns.format($year, "YYYY")', onClick: "$handlers.setDate($year)", onKeydown: "$handlers.keyDown", onMouseenter: "$handlers.mouseEnter($year)", onMouseleave: "$handlers.mouseLeave", onBlur: "$handlers._blurOut(year)", tabindex: '$fns.sameYear($year) && "0" || "-1"', "aria-selected": "$selectedYear === $year", "data-disabled": "$fns.isDisabledYear($year)", "data-test": "$year", "aria-label": "$fns.format($year, $yearFormat)" } })), Zte = He("months", () => ({ if: '$panel === "month"', $el: "ul" })), Xte = He("month", () => ({ $el: "li", for: ["month", "index", "$months"], attrs: { key: "$month", onClick: "$handlers.setDate($month)", onKeydown: "$handlers.keyDown", onMouseenter: "$handlers.mouseEnter($month)", onMouseleave: "$handlers.mouseLeave", onBlur: "$handlers._blurOut(month)", tabindex: '$fns.sameMonth($month) && "0" || "-1"', "aria-selected": "$selectedMonth === $month", "data-disabled": "$fns.isDisabledMonth($month)" } })), Jte = He("panelHeader", () => ({ $el: "header", attrs: { "aria-live": "polite" } })), Qte = He("yearsHeader", () => ({ $el: "div", if: '$panel === "year"' })), ene = He("monthsHeader", () => ({ $el: "div", if: '$panel === "month"' })), tne = He("daysHeader", () => ({ $el: "div", if: '$panel === "day"' })), nne = He("timeHeader", () => ({ $el: "div", if: '$panel === "time"' })), Bc = He("yearButton", () => ({ $el: "button", attrs: { type: "button", id: "$id + _year_button", onClick: "$handlers.jumpTo(year)" }, children: "$fns.format($renderedDate, $yearFormat)" })), fv = He("monthButton", () => ({ $el: "button", attrs: { type: "button", id: "$id + _month_button", onClick: "$handlers.jumpTo(month)" }, children: "$fns.format($renderedDate, $monthButtonFormat)" })), one = He("dayButton", () => ({ $el: "button", attrs: { type: "button", id: "$id + _day_button", onClick: "$handlers.jumpTo(day)", tabindex: "2" }, children: "$fns.format($renderedDate, $dayButtonFormat)" })), sne = He("removeSelection", () => ({ $el: "button", if: "$clearable && $_value", attrs: { id: '$id + "_remove_selection"', type: "button", onClick: "$handlers.clear", "aria-controls": "$id" } })), ane = He("time", () => ({ $el: "div", if: '$panel === "time"' })), rne = He("timeInput", () => ({ $el: "input", attrs: { type: "time", value: "$localTime", onInput: "$handlers.localTime", onKeydown: "$handlers.keyDown", spellcheck: "false", onBlur: "$handlers._blurOut(time)" } })), ine = He("panelClose", () => ({ $el: "button", if: "$showPanelClose && ($inline === undefined || $inline === false)", attrs: { type: "button", class: "$classes.panelClose", onClick: "$handlers.closePanel", tabindex: -1, "aria-label": "$ui.close.value" } })), { overlayPlaceholder: lne, overlayLiteral: cne, overlayChar: une, overlayEnum: pne, overlay: dne, overlayParts: fne, overlayInner: mne } = /* @__PURE__ */ e0(He), vne = He("panel", "div"), Kn = /* @__PURE__ */ new WeakMap(), Gs = /* @__PURE__ */ new WeakMap(), Zs = /* @__PURE__ */ new WeakSet(), hne = /* @__PURE__ */ new WeakMap(), Ll = /* @__PURE__ */ new WeakMap(), Ru = /* @__PURE__ */ new WeakSet(), mo = /* @__PURE__ */ new WeakMap(), tl = /[\uD800-\uDBFF]/, Bo = /* @__PURE__ */ new WeakMap(), Hc = /* @__PURE__ */ new WeakMap(), Uc = /* @__PURE__ */ new WeakMap(), Ba = /* @__PURE__ */ new WeakMap(), ii = /* @__PURE__ */ new WeakMap(), Ls = /* @__PURE__ */ new WeakSet(), ia = /* @__PURE__ */ new WeakMap(), Nl = /* @__PURE__ */ new WeakMap(), zc = /* @__PURE__ */ new WeakMap(), Ko = /* @__PURE__ */ new WeakMap();
let Vu = !1;
const mv = () => {
  Vu = !0, setTimeout(() => {
    Vu = !1;
  }, 500);
}, gne = { "#": { type: "char", pattern: /\d/, token: "#", placeholder: "_", selectDirection: "right" }, a: { type: "char", pattern: /[a-zA-Z]/, token: "a", placeholder: "_", selectDirection: "left" }, h: { type: "char", pattern: /[0-9a-fA-F]/, token: "h", placeholder: "_", selectDirection: "left" }, "*": { type: "char", pattern: /./, token: "*", placeholder: "_", selectDirection: "left" } }, vv = /* @__PURE__ */ new WeakMap(), tr = typeof window < "u";
let li = !1, hv = !1;
function bne() {
  tr && !hv && (hv = !0, document.addEventListener("selectionchange", () => {
    const e = es();
    if (!(e instanceof HTMLInputElement)) return;
    if (Ko.has(e)) return function(n) {
      const o = Ko.get(n);
      if (o) {
        const [s, a] = o, [r, i] = xt(n), l = i.indexOf(s);
        if (l === -1) return void Ko.delete(n);
        const c = r[l], u = [c[0] + a[0], c[1], "none"];
        ts(Tn(n), u) || nl(n, u);
      }
    }(e);
    if (mo.get(e) !== "select") return;
    const t = Tn(e);
    if (!ts(t, vv.get(e))) {
      if (vv.set(e, t), Zs.has(e)) return Zs.delete(e);
      e.dispatchEvent(new CustomEvent("selection", { detail: Tn(e) }));
    }
  }));
}
function wd(e, t, n) {
  var o;
  if (bne(), Kn.has(e)) return;
  Kn.set(e, []), t.reverse && Ls.add(e), t.prefix && ia.set(e, t.prefix), t.suffix && Nl.set(e, t.suffix), w0(e, t.pattern, t.partOverrides, t.explicitParts);
  const s = Ll.get(e), a = s == null ? void 0 : s.some((c) => eo(c)), r = s == null ? void 0 : s.some((c) => function(u) {
    return !!u && u.type === "group" && Array.isArray(u.parts);
  }(c));
  if (a && r) throw new Error("Cannot use enums and groups in the same mask.");
  const i = a ? "select" : (o = t.mode) !== null && o !== void 0 ? o : "shift";
  if (r && i === "select") throw new Error("Cannot use groups in select mode.");
  (t.placeholder || i === "select") && Ru.add(e), mo.set(e, i), t.onChange && Ba.set(e, t.onChange);
  let l = !1;
  e.addEventListener("beforeinput", (c) => {
    if (li || c.inputType === "insertLineBreak") return;
    if (c.inputType.startsWith("history")) return function(h, g) {
      h.addEventListener("input", (_) => {
        var v;
        _.preventDefault(), _.stopImmediatePropagation();
        const w = Kn.get(h);
        if (w != null && w.length) {
          const y = ((v = Gs.get(h)) !== null && v !== void 0 ? v : w.length - 1) + (g.endsWith("Undo") ? -1 : 1), $ = w[y];
          if (!$) return;
          k0(h, $), h.setSelectionRange(...$.selectionAfter), Gs.set(h, y), Ba.has(h) && Ba.get(h)($, h);
        }
      }, { once: !0 });
    }(e, c.inputType);
    c.preventDefault(), l = !0;
    const u = (p = c.inputType).startsWith("insert") ? "insert" : !!p.startsWith("delete") && (p === "deleteContentForward" ? "deleteContentForward" : "deleteContentBackward");
    var p;
    const f = Tn(e), m = e.value;
    u && nr(e, { type: u, selectionBefore: f, data: c.data, valueBefore: m, suffix: t.suffix, prefix: t.prefix });
  }), e.addEventListener("input", (c) => {
    l = !1, "data" in c || !l && n && (n.input(e.value, !1), n.props._maskValue = e.value);
  }), i === "select" && e.addEventListener("keydown", (c) => {
    switch (c.key) {
      case "ArrowRight":
        return c.preventDefault(), Wc(e);
      case "ArrowLeft":
        return c.preventDefault(), Wc(e, -1);
      case "ArrowUp":
        return void (Sv(e, 1) && c.preventDefault());
      case "ArrowDown":
        return void (Sv(e, -1) && c.preventDefault());
      case "Tab":
        return Vu ? void c.preventDefault() : void (Wc(e, c.shiftKey ? -1 : 1) && c.preventDefault());
    }
  }), e.addEventListener("focus", () => function(c) {
    var u;
    const p = Ru.has(c), f = mo.get(c);
    if (p) {
      let m = null, h = null, g = !1;
      const _ = f === "shift" ? 0 : 1, v = c.value;
      Hu(c, { data: v, selectionBefore: [0, 0, "none"] }, f === "shift" ? "" : v, (y, $) => (m === null && $.type === "char" && (m = y.pos - _), (Yn($) || eo($)) && y.value.endsWith($.placeholder) ? (h = y.pos - _, !1) : ($.type === "char" && (g = !0), !0)));
      const w = (u = h ?? (g ? v.length : m)) !== null && u !== void 0 ? u : null;
      if (w !== null) {
        let y = [w, w, "none"];
        if (mo.get(c) === "select") {
          const [$] = xt(c), S = Gn(c, y);
          S !== void 0 && S in $ && (y = $[S]);
        }
        return function($, S, A = 50) {
          Bo.set($, Ha($, S));
          const I = async () => {
            if (!tr || es() !== $) return;
            mo.get($) === "select" && (await new Promise((O) => setTimeout(O, 10)), function(O) {
              let x = Tn(O);
              if (x[0] === x[1] && x[0] === 0 || O.value.length === x[1] && x[0] === 0) return;
              x = Bu(O, x);
              const [F] = xt(O), P = Gn(O, x), E = x[0];
              P !== void 0 && F.some((B) => E >= B[0] && E < B[1]) && Bo.set(O, Ha(O, F[P]));
            }($));
            const D = Bo.get($);
            D && $.setSelectionRange(...D);
          };
          I(), document.addEventListener("selectionchange", I), setTimeout(() => {
            document.removeEventListener("selectionchange", I), Bo.delete($);
          }, A);
        }(c, y);
      }
    }
  }(e)), e.addEventListener("selection", (c) => function(u, p) {
    if (Bo.get(u)) return;
    x0(u), p = Bu(u, p);
    const [f] = xt(u), m = Gn(u, p), h = m !== void 0 && Ha(u, f[m]);
    h && !ts(p, h) && nl(u, h, !0);
  }(e, c.detail)), nr(e, { type: "insert", selectionBefore: [0, 0, "forward"], data: e.value, valueBefore: "", suffix: t.suffix, prefix: t.prefix });
}
function gv(e) {
  var t, n;
  if (Ko.has(e)) return;
  const o = (t = Kn.get(e)) !== null && t !== void 0 ? t : [], s = o[(n = Gs.get(e)) !== null && n !== void 0 ? n : o.length - 1];
  if (s) {
    const a = s.selectionAfter, [r, i] = xt(e, s.valueAfter), l = Gn(e, a, [r, i]);
    if (l !== void 0 && l in r) {
      const c = i[l], u = r[l], p = [a[0] - u[0], a[1] - u[0], "none"];
      Ko.set(e, [c, p]);
    }
  }
}
function bv(e) {
  Ko.delete(e);
}
function yv(e, t, n) {
  const o = typeof e == "string" || !Kn.has(e), s = typeof e == "string" ? _0(e) : e;
  if (o) t.prefix && ia.set(s, t.prefix), t.suffix && Nl.set(s, t.suffix), s.value = Cd(s, s.value), wd(s, t, n);
  else {
    const a = kd(s), r = s.value;
    s.value = "", nr(s, { type: "insert", selectionBefore: [0, a ? a.valueAfter.length : 0, "none"], valueBefore: a ? a.valueAfter : "", data: r, suffix: t.suffix, prefix: t.prefix });
  }
  return s.value;
}
function _0(e) {
  return { value: e, selectionStart: 0, selectionEnd: 0, scrollWidth: 0, clientWidth: 0, addEventListener: () => {
  }, dispatchEvent: () => {
  }, setSelectionRange: () => {
  } };
}
function w0(e, t, n, o, s) {
  s = e && Ls.has(e) || s;
  const a = (o ?? function(f) {
    const m = Object.values(gne);
    if (!f) return m;
    const h = { ...f }, g = [];
    for (const v of m) if (!Xs(v)) if ("token" in v && v.token in f) {
      const w = { ...v, ...f[v.token] };
      $v(w) && g.push(w), delete h[v.token];
    } else g.push(v);
    const _ = Object.values(h);
    for (const v of _) $v(v) ? g.push(v) : console.warn(`Invalid ${v.type} token`, v);
    return g;
  }(n)).sort((f, m) => {
    const h = "token" in f ? f.token.length : -1, g = "token" in m ? m.token.length : -1;
    return h === g ? 0 : h > g ? -1 : 1;
  });
  let r = [];
  [t, r] = function(f, m, h, g) {
    let _, v = 0, w = "", y = "", $ = "";
    const S = [];
    for (; w = kt(f); ) w === m && _ !== g ? (v++, v > 1 && ($ += w)) : w === h && v && _ !== g ? (v--, v === 0 ? (y += `{$${S.length}}`, S.push($), $ = "") : $ += w) : v ? $ += w : _ !== g || w !== m && w !== h ? y += w : y = `${y.substring(0, y.length - 1)}${w}`, _ = w, f = f.substring(w.length);
    return [y, S];
  }(t, "{", "}", "\\");
  const i = r.length;
  t = a.reduce((f, m, h) => "token" in m ? f.replaceAll(`\\${m.token}`, "{“!”}").replaceAll(m.token, `{$${i + h}}`).replaceAll("{“!”}", m.token) : f, t);
  const l = function(f, m, h) {
    return f.reduce((g, _) => {
      const [v, w] = function(S) {
        const [A, ...I] = S.split("|"), D = I.reduce((O, x) => {
          const [F, P = !0] = x.split(":");
          return Object.assign(O, { [F]: P });
        }, {});
        return [A, D];
      }(_);
      let y = w0(null, v, void 0, m, h);
      y = y.map((S) => {
        const A = { ...S };
        if (A.type === "char" && w.placeholder) A.placeholder = w.placeholder;
        else if (A.type === "enum") throw new Error("Groups cannot contain enums.");
        return A;
      });
      const $ = { type: "group", parts: y, ...w };
      return g.push($), g;
    }, []);
  }(r, a, s).concat(a), c = /\{\$\d+\}/g, u = t.match(c), p = t.split(c).reduce((f, m, h) => {
    if (m && (m = m.replaceAll("\\", ""), f.push({ type: "literal", value: s ? [...m].reverse().join("") : m })), u && u[h]) {
      const g = u[h], _ = Number(g.substring(2, g.length - 1));
      !isNaN(_) && l[_] && f.push(l[_]);
    }
    return f;
  }, []);
  return s && p.reverse(), e && Ll.set(e, p), p;
}
function $v(e) {
  return !!e && (Xs(e) || Yn(e) || eo(e));
}
function Yn(e) {
  return !!e && e.type === "char" && e.pattern instanceof RegExp && C0(e);
}
function eo(e) {
  return !!e && e.type === "enum" && Array.isArray(e.values) && C0(e);
}
function C0(e) {
  return !!e && "placeholder" in e && "token" in e;
}
function Xs(e) {
  return !!e && e.type === "literal" && typeof e.value == "string";
}
function ts(e, t) {
  return e === t || e !== void 0 && t !== void 0 && e[0] === t[0] && e[1] === t[1];
}
function Tn(e) {
  var t, n;
  return [(t = e.selectionStart) !== null && t !== void 0 ? t : e.value.length, (n = e.selectionEnd) !== null && n !== void 0 ? n : e.value.length, "none"];
}
function nr(e, t) {
  var n;
  Ls.has(e) && Tv(t);
  let o = !1;
  switch (ii.set(e, "playing"), t.type) {
    case "insert":
      o = function(s, a) {
        let r = _v(a);
        const i = a.selectionBefore, l = function(u, p) {
          var f, m, h;
          if (mo.get(u) === "select") {
            const [g, _] = xt(u), v = g.findIndex((y) => ts(y, p.selectionBefore)), w = (f = _[v]) !== null && f !== void 0 ? f : null;
            if (Yn(w)) {
              const y = p.selectionBefore, $ = y[1] - y[0], S = p.valueBefore.substring(y[0], y[1]), A = w.selectDirection === "left", I = T0(S, w), D = A ? 0 : function(x, F, P) {
                if (!x) return 0;
                let E = "";
                for (; x.length; ) {
                  const B = kt(x);
                  x = x.substring(B.length), F.pattern.test(B) && (E += B);
                }
                return Math.min(Math.max(E.length, 1), P);
              }(p.data, w, $);
              if (I.length >= $) return A || (p.insertPos = y[1] - D), ((m = w.selectFill) !== null && m !== void 0 ? m : w.placeholder).repeat($);
              const O = ((h = w.selectFill) !== null && h !== void 0 ? h : w.placeholder).repeat($ - I.length - (A ? 0 : D));
              return p.insertPos = A ? y[0] + I.length : y[1] - D, w.selectDirection === "left" ? `${I}${O}` : `${O}${I}${w.placeholder}`;
            }
            if (eo(w)) {
              const y = p.selectionBefore;
              return p.valueBefore.substring(y[0], y[1]);
            }
          }
          return "";
        }(s, a);
        r = `${r.substring(0, i[0])}${l}${r.substring(i[1])}`;
        const c = Hu(s, a, r);
        return hne.set(s, c.endPos), { ...a, valueAfter: c.value, selectionAfter: _ne(s, c), unmasked: c.unmasked, complete: c.complete, meta: c.meta };
      }(e, t);
      break;
    case "deleteContentBackward":
    case "deleteContentForward":
      o = function(s, a) {
        const r = _v(a), i = a.selectionBefore, l = Ls.has(s);
        let c = i[0], u = i[1];
        c === u && (a.type !== "deleteContentBackward" || l ? u += ci(r, c) : c -= ci(r, c, "backward"));
        const p = mo.get(s);
        let f = "";
        if (p === "select") {
          const [g, _] = xt(s), v = Gn(s, [c, u, "none"]);
          if (v !== void 0) {
            const w = _[v], y = g[v];
            Yn(w) ? f = w.placeholder.repeat(u - c) : eo(w) && ([f, c] = ts(y, Tn(s)) ? [w.placeholder, c] : function($, S, A, I) {
              const D = I.valueBefore, O = ci(D, I.selectionBefore[0], "backward"), x = Math.max(A[0], I.selectionBefore[0] - O), F = D.substring(A[0], x), P = $r(S.values, F);
              let E = P == null ? void 0 : P.substring(F.length);
              return P && !E && D0(S.values, P) && (E = P), [E ?? S.placeholder, E ? x : A[0]];
            }(0, w, y, a));
          }
        }
        const m = `${r.substring(0, c)}${f}${r.substring(u)}`, h = Hu(s, a, m);
        return { ...a, valueAfter: h.value, selectionAfter: Sne(s, h, a, c), unmasked: h.unmasked, complete: h.complete, meta: h.meta };
      }(e, t);
  }
  if (Ls.has(e) && o && Tv(o), o && function(s, a) {
    a.prefix && (a.valueAfter = a.prefix + a.valueAfter, a.selectionAfter = Ha(s, a.selectionAfter)), a.suffix && (a.valueAfter += a.suffix);
  }(e, o), o && function(s) {
    return s.valueBefore !== s.valueAfter || s.selectionBefore[0] !== s.selectionAfter[0] || s.selectionBefore[1] !== s.selectionAfter[1];
  }(o)) {
    Ba.has(e) && zc.set(e, () => {
      zc.delete(e), o && Ba.get(e)(o, e);
    }), ii.set(e, "beforeCallback");
    let s = (n = Kn.get(e)) !== null && n !== void 0 ? n : [];
    const a = Gs.get(e);
    a && (s = s.slice(0, a), Gs.delete(e)), s.push(o), Kn.set(e, s), tr && es() === e && typeof document.execCommand == "function" && !li ? (nl(e, [0, e.value.length, "forward"], !0), li = !0, document.execCommand("insertText", void 0, o.valueAfter), li = !1) : k0(e, o), tr && es() === e && nl(e, o.selectionAfter);
    const r = zc.get(e);
    r && r(), x0(e);
  }
  ii.set(e, "complete");
}
function Cd(e, t) {
  var n, o;
  const s = (n = ia.get(e)) !== null && n !== void 0 ? n : "", a = (o = Nl.get(e)) !== null && o !== void 0 ? o : "";
  return s && t.startsWith(s) && (t = t.substring(s.length)), a && t.endsWith(a) && (t = t.substring(0, t.length - a.length)), t;
}
function Ha(e, t) {
  const n = ia.get(e), o = [...t];
  return n && (o[0] += n.length, o[1] += n.length), o;
}
function Bu(e, t) {
  const n = ia.get(e), o = [...t];
  return n && (o[0] -= n.length, o[1] -= n.length), o;
}
function _v(e) {
  let t = e.valueBefore;
  const n = e.selectionBefore;
  if (e.suffix && t.endsWith(e.suffix) && (t = t.substring(0, t.length - e.suffix.length), e.valueBefore = t, n[0] >= t.length && (n[0] = t.length), n[1] >= t.length && (n[1] = t.length)), e.prefix && t.startsWith(e.prefix)) {
    const o = e.prefix.length;
    t = t.substring(o), e.valueBefore = t, n[0] = Math.max(n[0] - o, 0), n[1] = Math.max(n[1] - o, 0);
  }
  return t;
}
function nl(e, t, n = !1) {
  n && (Zs.add(e), setTimeout(() => Zs.delete(e), 5)), Bo.get(e) && Bo.set(e, t), e.setSelectionRange(...t);
}
function k0(e, t, n = "After") {
  if (e.value = t[`value${n}`], tr) {
    const o = new InputEvent("input", { inputType: t.type === "insert" ? "insertText" : t.type, data: t.data });
    e.dispatchEvent(o);
  }
}
function kt(e) {
  if (e == null) return "";
  const t = tl.test(e.charAt(0)) && tl.test(e.charAt(1)) ? 2 : 1;
  return e.substring(0, t);
}
function ci(e, t, n = "forward") {
  if (n === "backward") return t === 0 ? 0 : t === 1 ? 1 : tl.test(e.charAt(t)) && tl.test(e.charAt(t - 1)) ? 2 : 1;
  const o = e.length - t;
  return o === 0 ? 0 : o === 1 ? 1 : kt(e.substring(t)).length;
}
function S0(e, t) {
  const n = kt(e.data), o = n.length;
  if (e.value += n, e.pos += o, typeof e.data == "string" && (e.data = e.data.substring(o), e.data.length || (e.endPos = e.pos)), t) return t.substring(o);
}
function wv(e) {
  const t = kt(e.buffer), n = t.length;
  e.value += t, e.pos += n, e.buffer = e.buffer.substring(n);
}
function yne(e, t) {
  const n = kt(t), o = n.length;
  return e.value += n, e.pos += o, t.substring(o);
}
function $ne(e, t) {
  for (; t.buffer; ) {
    const n = kt(t.buffer);
    if (e.pattern.test(n) || t.placeholder && e.placeholder === n) return void (t.mode !== "replace" && t.mode !== "select" || (t.buffer = t.buffer.substring(n.length)));
    t.buffer = t.buffer.substring(n.length);
  }
}
function Cv(e, t) {
  const n = e.values.concat([e.placeholder]).map((o) => o.toLowerCase()).sort((o, s) => o.length > s.length ? -1 : 1);
  for (; t.buffer; ) {
    const o = t.buffer.toLowerCase(), s = n.find((a) => o.startsWith(a));
    if (s) {
      const a = t.buffer.substring(0, s.length);
      return t.buffer = t.buffer.substring(s.length), a;
    }
    t.buffer = t.buffer.substring(ci(t.buffer, 0));
  }
  return null;
}
function T0(e, t) {
  let n = e.replaceAll(t.placeholder, "");
  const o = t.selectDirection === "left";
  if (t.selectFill) {
    const a = new RegExp(`${o ? "" : "^"}${s = t.selectFill, s.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&")}+${o ? "$" : ""}`);
    n = n.replace(a, "");
  }
  var s;
  return n;
}
function _ne(e, t) {
  let n = [t.endPos, t.endPos, "forward"];
  if (t.mode !== "select") return n;
  const o = Tn(e);
  n = [o[0], t.endPos, "none"];
  const [s, a] = xt(e, t.value), r = Gn(e, n, [s, a]);
  if (r === void 0 || !(r in s) || !(r in a)) return n;
  const i = s[r], l = a[r], c = t.value.slice(i[0], i[1]);
  if (Yn(l) && T0(c, l).length === c.length && r < s.length - 1) return mv(), s[r + 1];
  if (eo(l) && t.insertPos >= i[0] && t.insertPos <= i[1]) {
    if (t.cycle) return i;
    const u = function(f, m, h) {
      if (f.originalData === null) return 0;
      const g = f.insertPos >= m ? f.value.substring(m, f.insertPos) : "", _ = `${g}${f.originalData}`, v = $r(h.values, _);
      return v ? A0(_, v).length - g.length : 0;
    }(t, i[0], l);
    if (t.insertPos + u === i[1]) return D0(l.values, c) ? [i[1], i[1], "forward"] : (mv(), s[r + 1] ? s[r + 1] : s[r]);
    const p = [t.insertPos + u, i[1], "none"];
    return ts(p, o) || (Zs.add(e), setTimeout(() => Zs.delete(e), 5)), p;
  }
  return i;
}
function Hu(e, t, n, o) {
  var s, a;
  const r = (s = Ll.get(e)) !== null && s !== void 0 ? s : [], i = { pos: 0, insertPos: (a = t.insertPos) !== null && a !== void 0 ? a : t.selectionBefore[0], range: t.selectionBefore, chars: 0, placeholder: Ru.has(e), buffer: n, data: t.data, originalData: t.data, value: "", mode: mo.get(e) || "replace", endPos: t.selectionBefore[0], rangeParts: xt(e), unmasked: "", complete: !0, cycle: t.cycle, meta: [] };
  return Uu(r, i, void 0, o), i;
}
function Uu(e, t, n, o) {
  var s, a;
  const r = { ...t };
  n != null && n.placeholder && (t.placeholder = !0);
  const i = n != null && n.repeat && ((s = n.nextPart) === null || s === void 0 ? void 0 : s.type) === "literal" ? n.nextPart.value : null;
  let l = 0;
  const c = e.reduce((p, f) => p + (f.type === "char" ? 1 : 0), 0), u = t.chars;
  for (const p of e) {
    const f = e[l + 1];
    switch (p.type) {
      case "literal":
        Cne(p, t, e.at(-1) === p);
        break;
      case "char":
        kne(p, t, i);
        break;
      case "enum":
        wne(p, t);
        break;
      case "group":
        const h = { repeat: (a = p.repeat) !== null && a !== void 0 && a, nextPart: f, repeats: 0, placeholder: !!p.placeholder };
        Uu(p.parts, t, h, o);
    }
    if (o && o(t, p) === !1)
      break;
    const m = Xs(f) && l + 2 === e.length && u !== t.chars;
    if (!(t.buffer || t.data || t.placeholder || m)) break;
    l++;
  }
  if (t.chars < c && (t.complete = !1), n) {
    const p = t.chars - u, f = p === c, m = !(!t.data || i && t.data.startsWith(i) && t.insertPos <= t.pos), h = !(t.buffer && i && t.buffer.startsWith(i) && t.insertPos >= t.pos + i.length) && (t.buffer || m);
    if (n.repeat && h && f) return n.repeats++, Uu(e, t, n, o);
    if (!f) {
      t.complete = !1;
      const g = e.reverse().find((_) => _.type === "literal");
      e.reverse(), Xs(g) && t.value.endsWith(g.value) && (t.value = t.value.substring(0, t.value.length - g.value.length), t.pos = t.value.length);
    }
    c > 1 && p < c && p !== 0 && t.insertPos <= t.pos ? t.data = "" : n.repeat && !f && n.repeats && Object.assign(t, r);
  }
  t.placeholder = r.placeholder;
}
function wne(e, t) {
  const [n, o] = t.rangeParts, s = n[o.indexOf(e)];
  if (s && (t.insertPos <= t.pos || t.insertPos >= s[0] && t.insertPos <= s[1]) && t.data) {
    const a = t.buffer.substring(0, t.insertPos - t.pos), r = `${a}${t.data}`, i = $r(e.values.concat([e.placeholder]), r);
    if (i) {
      const l = A0(r, i);
      return t.data = t.data.substring(l.length), t.value += i, i !== e.placeholder ? t.unmasked += i : t.complete = !1, t.meta.push({ type: i !== e.placeholder ? "enum" : "placeholder", value: i }), a ? t.buffer = t.buffer.substring(a.length) : Cv(e, t), t.endPos = t.pos + l.length, void (t.pos = t.value.length);
    }
    t.data = "";
  }
  if (t.buffer) {
    const a = Cv(e, t);
    if (a) return t.value += a, a !== e.placeholder ? t.unmasked += a : t.complete = !1, t.meta.push({ type: a !== e.placeholder ? "enum" : "placeholder", value: a }), void (t.pos = t.value.length);
  }
  t.complete = !1, t.value += e.placeholder, t.meta.push({ type: "placeholder", value: e.placeholder }), t.pos = t.value.length;
}
function Cne(e, t, n) {
  let o = e.value;
  if (t.data === "" && !t.buffer && !t.placeholder && !n) return;
  let s = !1;
  for (; o; ) {
    const a = t.insertPos <= t.pos ? kt(t.data) : "", r = kt(o);
    if (a === r) o = S0(t, o), t.meta.push({ type: "literal", value: r }), s = !0;
    else if (!s || t.data || t.data === null || t.placeholder || n) o = yne(t, o), t.meta.push({ type: "literal", value: r });
    else if (s && !t.data) break;
    t.buffer.startsWith(r) && (t.buffer = t.buffer.substring(r.length));
  }
  t.data === null && !t.buffer && t.insertPos <= t.pos && !t.placeholder && (t.value = t.value.substring(0, t.value.length - e.value.length), t.pos = t.endPos = t.value.length);
}
function kne(e, t, n) {
  var o;
  let s = !0;
  if (t.insertPos <= t.pos) for (; !((o = t.data) === null || o === void 0) && o.length; ) {
    const a = kt(t.data);
    if (e.pattern.test(a)) return S0(t), t.meta.push({ type: "char", value: a }), t.chars++, t.unmasked += a, void $ne(e, t);
    if (typeof t.data == "string") {
      if (n && t.data.startsWith(n)) {
        s = !1;
        break;
      }
      t.data = t.data.substring(a.length);
    }
  }
  for (; s && t.buffer; ) {
    const a = kt(t.buffer);
    if (e.pattern.test(a)) return t.chars++, t.unmasked += a, wv(t), void t.meta.push({ type: "char", value: a });
    if (t.placeholder && a === e.placeholder) return wv(t), void t.meta.push({ type: "placeholder", value: a });
    if (typeof t.buffer == "string") {
      if (n && t.buffer.startsWith(n)) {
        t.buffer = t.buffer.substring(n.length);
        break;
      }
      t.buffer = t.buffer.substring(a.length);
    }
  }
  t.placeholder ? (t.value += e.placeholder, t.meta.push({ type: "placeholder", value: e.placeholder })) : t.endPos = t.pos;
}
function Sne(e, t, n, o) {
  const s = [o, o, "none"];
  if (t.mode === "select") {
    const a = xt(e), r = Gn(e, s, a), [i, l] = xt(e, t.value), c = r !== void 0 && kv(n.valueBefore, a[0][r], a[1][r]);
    if (r !== void 0 && r in i)
      return c ? i.slice(r).every((p, f) => kv(t.value, p, l[r + f])) && i[r - 1] ? i[r - 1] : i[r] : [o, i[r][1], "none"];
  }
  return s;
}
function kv(e, t, n) {
  if (Xs(n)) return !1;
  if (Yn(n)) {
    let o = t[0];
    for (; o < t[1]; ) {
      const s = kt(e.substring(o));
      if (s !== n.placeholder) return !1;
      o += s.length;
    }
  }
  return !eo(n) || e.substring(t[0], t[1]) === n.placeholder;
}
function A0(e, t) {
  let n = "";
  do {
    const o = kt(e).toLowerCase(), s = kt(t).toLowerCase();
    if (o !== s) break;
    n += o, e = e.substring(o.length), t = t.substring(s.length);
  } while (e.length && t.length);
  return n;
}
function xt(e, t) {
  const n = Ll.get(e);
  if (!n) return [[], []];
  if (Hc.has(e)) return Hc.get(e);
  const o = t ?? Cd(e, e.value), s = [], a = [];
  let r = null, i = null, l = 0, c = !0;
  for (const p of n) if (Xs(p)) r = p, i !== null && (s.push([i, l, "none"]), i = null), l += p.value.length;
  else {
    if (Yn(r) && Yn(p) && p.token === r.token) l++;
    else if (Yn(p)) i === null ? (i = l, a.push(p)) : (s.push([i, l, "none"]), i = l, a.push(p)), l++;
    else if (eo(p)) {
      i && s.push([i, l, "none"]), P0(p) || (c = !1);
      const f = Tne(o, p, l);
      i = null, s.push([l, l + f, "none"]), a.push(p), l += f;
    }
    r = p;
  }
  i !== null && s.push([i, l, "none"]);
  const u = [[...s], [...a]];
  return c && !t && Hc.set(e, u), u;
}
function Tne(e, t, n) {
  if (P0(t)) return t.values[0].length;
  const o = e.slice(n), s = $r(t.values.concat([t.placeholder]), o);
  return s ? s.length : 0;
}
function $r(e, t, n = null, o) {
  var s;
  if (t.length === 0) return n;
  if (!o) {
    const c = e.find((u) => u.toLowerCase() === t.toLowerCase());
    if (c) return c;
  }
  const a = kt(t.toLowerCase()), r = `${o ?? ""}${a}`, i = e.filter((c) => c.toLowerCase().startsWith(r)), l = i.find((c) => c.toLowerCase() === r);
  return l && (n = l), i.length === 0 ? n : i.length === 1 ? i[0] : (i.length > 1 && (n = i[0]), (s = $r(i, t.substring(a.length), n, r)) !== null && s !== void 0 ? s : i[0]);
}
function D0(e, t) {
  return t = t.toLowerCase(), e.some((n) => (n = n.toLowerCase()).startsWith(t.toLocaleLowerCase()) && n !== t);
}
function P0(e) {
  if (!Uc.has(e) && Array.isArray(e.values) && e.values.length > 0) {
    const t = e.values[0].length;
    if (e.placeholder.length !== t) return !1;
    Uc.set(e, e.values.every((n) => n.length === t));
  }
  return Uc.get(e);
}
function Wc(e, t = 1) {
  const [n] = xt(e), o = Gn(e, Bu(e, Tn(e)));
  return o !== void 0 && n[o + t] !== void 0 && (e.setSelectionRange(...Ha(e, n[o + t])), !0);
}
function Sv(e, t = 1) {
  const [n, o] = xt(e), s = Gn(e, Tn(e));
  if (s !== void 0 && s in o) {
    const a = o[s];
    if (eo(a)) {
      const r = n[s], i = e.value.slice(r[0], r[1]);
      let l = null, c = a.values.indexOf(i);
      const u = a.values.length - 1;
      if (c !== -1) {
        const p = c + t;
        c = p < 0 ? u : p > u ? 0 : p, l = a.values[c];
      } else i === a.placeholder && (l = t > 0 ? a.values[0] : a.values[u]);
      if (l !== null) {
        const p = { selectionBefore: r, insertPos: r[0], type: "insert", data: l, valueBefore: e.value, cycle: !0 };
        return setTimeout(() => nr(e, p), 0), !0;
      }
    }
  }
  return !1;
}
function I0(e, t) {
  if (!e.length) return -1;
  if (e.length === 1) return e[0];
  const n = e.length / 2, o = Number.isInteger(n) ? n : Math.floor(n), s = Math.abs(t - e[o - 1]) < Math.abs(t - e[o]) ? [0, o] : [o];
  return I0(e.slice(...s), t);
}
function Gn(e, t, n) {
  const [o] = n ?? xt(e), s = o.findIndex((l) => l[0] !== l[1] && (!!ts(l, t) || t[1] > l[0] && t[1] < l[1]));
  if (s !== -1) return s;
  const [a, r] = o.reduce((l, c, u) => (l[0].add(c[0]), l[0].add(c[1]), l[1][c[0]] = u, l[1][c[1]] = u, l), [/* @__PURE__ */ new Set(), {}]), i = I0([...a], t[0] === 0 && t[1] === e.value.length ? 0 : t[1]);
  return i in r ? r[i] : void 0;
}
function kd(e) {
  var t, n;
  const o = (t = Kn.get(e)) !== null && t !== void 0 ? t : [];
  return o[(n = Gs.get(e)) !== null && n !== void 0 ? n : o.length - 1];
}
function E0(e, t = !1) {
  const n = kd(e);
  return n && (n.complete || t) ? Ls.has(e) ? [...n.unmasked].reverse().join("") : n.unmasked : t ? "" : null;
}
function O0(e) {
  var t;
  const n = kd(e);
  return (t = n == null ? void 0 : n.meta) !== null && t !== void 0 ? t : null;
}
function Tv(e) {
  const t = (o) => [...o].reverse().join(""), n = (o, s) => [s - o[1], s - o[0], o[2]];
  e.data && (e.data = t(e.data)), e.valueBefore = t(e.valueBefore), "valueAfter" in e && (e.valueAfter = t(e.valueAfter)), "selectionAfter" in e && (e.selectionAfter = n(e.selectionBefore, e.valueAfter.length)), e.selectionBefore = n(e.selectionBefore, e.valueBefore.length);
}
function x0(e) {
  if (e.scrollWidth > e.clientWidth && e.selectionStart !== null && e.selectionEnd !== null) {
    const t = e.selectionStart / e.value.length, n = e.selectionEnd / e.value.length;
    e.scrollLeft = n > 0.9 ? e.scrollWidth : t * e.scrollWidth - 20, e.dispatchEvent(new CustomEvent("input-scroll", { bubbles: !1, detail: e.scrollLeft }));
  }
}
const Av = typeof window < "u", zu = /* @__PURE__ */ new WeakSet(), jc = /* @__PURE__ */ new WeakSet(), Dv = /* @__PURE__ */ new WeakSet(), ol = /* @__PURE__ */ new WeakMap(), M0 = /* @__PURE__ */ new WeakMap(), qc = /* @__PURE__ */ new WeakSet(), Wu = /* @__PURE__ */ new WeakSet();
function L0(e) {
  e.props.selectedMonth = e.props.selectedYear = e.props.selectedDay = e.props.selectedWeek = void 0;
}
function N0(e) {
  var t, n, o;
  e.props.selectedMonth = e.props.months.findIndex((s) => R0(s, e.props.activeDate)), e.props.selectedYear = e.props.years.findIndex((s) => F0(s, e.props.activeDate));
  for (let s = 0; s < ((t = e.props.calendar[0]) === null || t === void 0 ? void 0 : t.weeks.length); s++) for (let a = 0; a < ((n = e.props.calendar[0]) === null || n === void 0 ? void 0 : n.weeks[s].length); a++) {
    const r = (o = e.props.calendar[0]) === null || o === void 0 ? void 0 : o.weeks[s][a];
    if (Jy(r, e.props.activeDate)) {
      e.props.selectedWeek = s, e.props.selectedDay = a;
      break;
    }
  }
}
function Ua(e) {
  return e.partName !== "timeZoneName";
}
function F0(e, t) {
  return t instanceof Date && e.getFullYear() === t.getFullYear();
}
function R0(e, t) {
  return t instanceof Date && e.getMonth() === t.getMonth();
}
function Kc(e) {
  L0(e), e.props.selectedIndex = e.props.calendar = go(e.props.showMonths, (t) => t).map((t) => function(n, o) {
    const s = [], a = Ze(o);
    a.setDate(1);
    let r = Qy(a, n.props.weekStart);
    r.setHours(a.getHours(), a.getMinutes(), a.getSeconds());
    const i = rJ(Zi(o), n.props.weekStart);
    let l = [];
    do
      l.push(r), l.length === 7 && (s.push(l), l = []), r = Ms(r);
    while (r.getTime() <= i.getTime());
    return { monthDay: a, weeks: s };
  }(e, co(e.props.renderedDate, t))), e.props.years = function(t) {
    const n = Number(Bt(t.props.renderedDate, "YYYY")), o = n - n % 10;
    return t.props.decade = `${o} - ${o + 9}`, go(10, (s) => $s(t.props.renderedDate, o + s - n));
  }(e), e.props.months = function(t) {
    const n = Ze(t.props.renderedDate);
    return n.setMonth(0), go(12, (o) => co(n, o));
  }(e), e.value && N0(e);
}
function Ane(e, t) {
  var n;
  t.target && t.target instanceof Element && (t.target.closest(`#${e.props.id}_popover`) || !(!((n = e.props.__root) === null || n === void 0) && n.contains(t.target))) || (e.props.expanded = !1);
}
function Lo(e, t) {
  if (!t) return e.props.inputText = "", /* @__PURE__ */ new Date();
  const n = t instanceof Date ? t : Fo(t, e.props.valueFormat, e.props.valueLocale);
  return e.props.inputText = e.props.formatDate(n, e.props.format, e.props.locale, !1, Ua), n;
}
function Pv(e) {
  return Array.isArray(e.props.sequence) ? _o(e.props.sequence) : ["day"];
}
function wa(e, t, n = !0) {
  var o, s;
  if (e._value === t) return;
  if (t == null) return e.input(t, n);
  e.props.offset = e.props.timezone ? Qa(t, e.props.timezone) : "+0000";
  const a = Gy(t, (o = (s = e.props).offset) !== null && o !== void 0 ? o : s.offset = "+0000");
  e.input(Bt(a, e.props.valueFormat, e.props.valueLocale, !1), n);
}
function Yc(e, t) {
  var n;
  const o = ["prev_button", "month_button", "day_button", "year_button", "next_button"].find((a) => {
    var r;
    return (r = e.props.__root) === null || r === void 0 ? void 0 : r.getElementById(`${e.props.id}_${a}`);
  }), s = (n = e.props.__root) === null || n === void 0 ? void 0 : n.getElementById(`${e.props.id}_${o}`);
  s instanceof HTMLElement && (t.preventDefault(), s.focus());
}
function Dne(e, t) {
  var n;
  let o = "";
  if (!(t instanceof HTMLInputElement) || e.props.pickerOnly) return;
  ol.set(e, t), (n = e.props.__root) === null || n === void 0 || n.addEventListener("click", (r) => {
    e.props.expanded && r.target instanceof HTMLElement && r.target.closest(`#${e.props.id}_popover`) ? Wu.add(e) : Wu.delete(e);
  }), e.on("prop:inputText", ({ payload: r }) => {
    r !== t.value && (ii.get(t) === "beforeCallback" && (o = t.value), gv(t), t.selectionStart = 0, t.selectionEnd = t.value.length, function(i, l) {
      var c, u;
      if (!Kn.has(i)) return;
      const p = (c = ia.get(i)) !== null && c !== void 0 ? c : "", f = (u = Nl.get(i)) !== null && u !== void 0 ? u : "";
      nr(i, { type: "insert", selectionBefore: Tn(i), data: l, valueBefore: i.value, suffix: f, prefix: p });
    }(t, r), t.value = r, setTimeout(() => bv(t), 10));
  });
  const [s, a] = Pne(e);
  wd(t, { pattern: s, explicitParts: a, onChange: ({ valueAfter: r }) => {
    if (V0(e), zu.has(e)) return zu.delete(e);
    o && o === r ? o = "" : (gv(t), e.props.inputText = r, setTimeout(() => bv(t), 10));
  } }, e);
}
function V0(e) {
  var t, n;
  if (e.props.overlay) {
    const o = ol.get(e);
    !o || !(!((t = e.props.attrs) === null || t === void 0) && t.placeholder) || e._value || E0(o, !0) || e.props._isFocused || e.props.activeDate && e.props.expanded ? o && (e.props._isPlaceholder = !1, e.props._overlayParts = gd(O0(o))) : (e.props._isPlaceholder = !0, e.props._overlayParts = [{ type: "placeholder", value: (n = e.props.attrs) === null || n === void 0 ? void 0 : n.placeholder }]);
  }
}
function Pne(e) {
  const t = e.props.locale, n = ["full", "long", "medium", "short"].includes(e.props.format) || typeof e.props.format == "object", o = Ks(e.props.format, t);
  return [vd(e.props.format, t, !0, Ua), o.reduce((s, a) => {
    if (a.partName === "literal") return s;
    let r = El(a.token, t, n);
    if (a.token === "YYYY" && e.props.minDate && e.props.maxDate) {
      const l = e.props.minDate.getFullYear();
      r = go(e.props.maxDate.getFullYear() - l + 1, (c) => String(l + c));
    }
    const i = { type: "enum", token: a.token, values: r, placeholder: a.token === "A" ? "A/P" : a.token, selectDirection: "left" };
    return s.push(i), a.token.startsWith("D") && M0.set(e, r), s;
  }, [])];
}
function Ine(e, t) {
  return !t || !(!e.props.minDate || !iJ(t, e.props.minDate)) || !(!e.props.maxDate || !lJ(t, e.props.maxDate)) || void 0;
}
function Ene(e) {
  return typeof e.props.validationLabel == "function" ? e.props.validationLabel(e) : e.props.validationLabel || e.props.label || e.props.name || String(e.name);
}
const One = typeof window < "u", Iv = /* @__PURE__ */ new WeakMap();
function xne(e, t) {
  var n, o;
  if (t instanceof HTMLInputElement && !Iv.get(e) && One) {
    const s = (n = e.props.__root) === null || n === void 0 ? void 0 : n.getElementById(`${e.props.id}_overlay`), a = (o = e.props.__root) === null || o === void 0 ? void 0 : o.getElementById(`${e.props.id}_overlay_inner`);
    if (s && t && a) {
      Iv.set(e, s);
      const r = getComputedStyle(t).color;
      t.style.color = "transparent", t.style.caretColor = r;
      const i = new ResizeObserver(() => {
        var c;
        const u = getComputedStyle(t), p = t.getBoundingClientRect(), f = (c = t.parentElement) === null || c === void 0 ? void 0 : c.getBoundingClientRect();
        e.props._overlayStyles = { ...e.props._overlayStyles, width: u.width, height: u.height, boxSizing: u.boxSizing, padding: u.padding, margin: u.margin, fontSize: u.fontSize, lineHeight: u.lineHeight, top: p.top - ((f == null ? void 0 : f.top) || p.top) + "px", left: p.left - ((f == null ? void 0 : f.left) || p.left) + "px" };
      });
      i.observe(t);
      const l = (c) => {
        a.scrollLeft = c.detail;
      };
      t.addEventListener("input-scroll", l), e.on("destroyed", () => {
        t.removeEventListener("input-scroll", l), i.disconnect();
      });
    }
  }
}
function B0(e) {
  e.addProps(["_overlayStyles", "_overlayParts", "_overlayInnerStyles", "_isPlaceholder"]), e.props._overlayStyles = { position: "absolute", top: "0", left: "0", pointerEvents: e.props._isPlaceholder ? "auto" : "none" }, e.props._overlayInnerStyles = { overflow: "hidden", whiteSpace: "nowrap", paddingRight: "20px" }, e.on("created", () => {
    e.props.overlay = _e(e.props.overlay), e.props.pickerOnly = _e(e.props.pickerOnly), e.props.overlay = e.props.pickerOnly ? void 0 : e.props.overlay, e.props.overlay && it(`${e.props.id}`, xne.bind(null, e), e.props.__root);
  }), e.on("prop:_isPlaceholder", () => {
    e.props._overlayStyles = { ...e.props._overlayStyles, pointerEvents: e.props._isPlaceholder ? "auto" : "none" };
  });
}
const Mne = { schema: /* @__PURE__ */ kte(/* @__PURE__ */ Ste(/* @__PURE__ */ Ate("$label"), /* @__PURE__ */ Tte(/* @__PURE__ */ Mo("prefix"), /* @__PURE__ */ Dte(), /* @__PURE__ */ dne(/* @__PURE__ */ mne(/* @__PURE__ */ fne(/* @__PURE__ */ lne("$part.value"), /* @__PURE__ */ cne("$part.value"), /* @__PURE__ */ une("$part.value"), /* @__PURE__ */ pne("$part.value")))), /* @__PURE__ */ xte(), /* @__PURE__ */ Mte(/* @__PURE__ */ Jte(/* @__PURE__ */ Fte(/* @__PURE__ */ Rte("$ui.prev.value"), /* @__PURE__ */ Mo("prev")), /* @__PURE__ */ Qte("$decade"), /* @__PURE__ */ ene(/* @__PURE__ */ Bc()), /* @__PURE__ */ tne(/* @__PURE__ */ fv(), /* @__PURE__ */ Bc()), /* @__PURE__ */ nne(/* @__PURE__ */ fv(), /* @__PURE__ */ one(), /* @__PURE__ */ Bc()), /* @__PURE__ */ Lte(/* @__PURE__ */ Nte("$ui.next.value"), /* @__PURE__ */ Mo("next")), /* @__PURE__ */ ine(/* @__PURE__ */ Mo("close"))), /* @__PURE__ */ vne(/* @__PURE__ */ Yte(/* @__PURE__ */ Gte("$fns.format($year, $yearFormat)")), /* @__PURE__ */ Zte(/* @__PURE__ */ Xte("$fns.format($month, $monthFormat)")), /* @__PURE__ */ Vte(/* @__PURE__ */ Hte(/* @__PURE__ */ Ute(/* @__PURE__ */ zte("$fns.format($day, $weekdayFormat)"))), /* @__PURE__ */ Bte(/* @__PURE__ */ Wte(/* @__PURE__ */ jte(/* @__PURE__ */ qte("$fns.format($day, $dateFormat)"))))), /* @__PURE__ */ ane(/* @__PURE__ */ rne()))), /* @__PURE__ */ sne(/* @__PURE__ */ Mo("clear")), /* @__PURE__ */ Kte(/* @__PURE__ */ Mo("calendar")), /* @__PURE__ */ Pte(), /* @__PURE__ */ Mo("suffix"))), /* @__PURE__ */ Ite("$help"), /* @__PURE__ */ Ete(/* @__PURE__ */ Ote("$message.value"))), type: "input", family: "text", props: ["dateFormat", "dayButtonFormat", "format", "monthButtonFormat", "monthFormat", "overlay", "pickerOnly", "showMonths", "showPagination", "weekStart", "weekdayFormat", "yearFormat", "years"], features: [
  B0,
  function(e) {
    var t, n, o, s, a, r, i, l, c, u, p, f, m, h, g, _, v, w, y, $, S, A;
    e.addProps(["_isDisabled", "_isFocused", "activeDate", "calendar", "clearable", "disabled", "decade", "disabledDays", "expanded", "inputText", "localTime", "maxDate", "maxScan", "minDate", "months", "offset", "paginatedPanels", "panel", "pickerOnly", "renderedDate", "sequence", "timezone", "valueFormat", "valueLocale", "showPanelClose", "selectedDay", "selectedWeek", "selectedMonth", "selectedYear"]), e.hook.prop((D, O) => (D.prop === "expanded" && e.props.disabled && (D.value = !1), D.prop === "weekStart" && (D.value = Number(D.value || 0)), D.prop === "showMonths" && (D.value = Number(D.value || 1)), D.prop === "maxScan" && (D.value = Number(D.value || 7)), D.prop === "timezone" && (typeof e._value == "string" || e._value instanceof Date) && (e.props.offset = Qa(e._value, D.value)), O(D))), e.props._isFocused = !1, e.props._isPlaceholder = !1, (t = (f = e.props).valueFormat) !== null && t !== void 0 || (f.valueFormat = "ISO8601"), (n = (m = e.props).weekdayFormat) !== null && n !== void 0 || (m.weekdayFormat = "d"), (o = (h = e.props).monthFormat) !== null && o !== void 0 || (h.monthFormat = "MMM"), (s = (g = e.props).monthButtonFormat) !== null && s !== void 0 || (g.monthButtonFormat = "MMMM"), (a = (_ = e.props).dayButtonFormat) !== null && a !== void 0 || (_.dayButtonFormat = "D"), (r = (v = e.props).dateFormat) !== null && r !== void 0 || (v.dateFormat = "D"), (i = (w = e.props).yearFormat) !== null && i !== void 0 || (w.yearFormat = "YYYY"), (l = (y = e.props).paginatedPanels) !== null && l !== void 0 || (y.paginatedPanels = ["day", "year"]), (c = ($ = e.props).valueLocale) !== null && c !== void 0 || ($.valueLocale = e.props.locale), (u = (S = e.props).format) !== null && u !== void 0 || (S.format = "long"), e.props.panels = Pv(e), e.props.pickerOnly = _e(e.props.pickerOnly), "disabled" in e.props && (e.props.disabled = _e(e.props.disabled)), "clearable" in e.props && (e.props.clearable = _e(e.props.clearable)), (p = (A = e.props).maxScan) !== null && p !== void 0 || (A.maxScan = 7), e.props._isDisabled = typeof e.props.disabledDays == "function" ? e.props.disabledDays.bind(null, e) : Ine.bind(null, e), e.props.calendar = [], e.props.inputText = "", e.props.showMonths = e.props.showMonths || 1, typeof e.props.format == "function" ? (e.props.formatDate = e.props.format, e.props.format = null) : e.props.formatDate = Bt, Kc(e), e.on("mounted", () => {
      it(`${e.props.id}`, Dne.bind(null, e), e.props.__root);
    }), e.on("created", () => {
      if (function(D) {
        const O = D._value;
        let x = /* @__PURE__ */ new Date();
        if (O instanceof Date) x = Ze(O);
        else if (typeof O == "string") try {
          const P = Fo(O, D.props.valueFormat, D.props.valueLocale);
          x = Ze(P);
        } catch {
          console.warn(`Date (${O}) does not match format (${vd(D.props.valueFormat, D.props.valueLocale)})`), x = void 0;
        }
        else O || (x = void 0);
        if (D.props.offset = D.props.timezone ? Qa(x || /* @__PURE__ */ new Date(), D.props.timezone) : "+0000", D.props.minDate) {
          const P = typeof D.props.minDate == "string" ? Fo(D.props.minDate) : D.props.minDate;
          D.props.minDate = _s(P, D.props.offset);
        }
        if (D.props.maxDate) {
          const P = typeof D.props.maxDate == "string" ? Fo(D.props.maxDate) : D.props.maxDate;
          D.props.maxDate = _s(P, D.props.offset);
        }
        x = x && _s(x, D.props.offset), x && wa(D, x, !1);
        let F = x || /* @__PURE__ */ new Date();
        D.props.minDate && F < D.props.minDate ? F = D.props.minDate : D.props.maxDate && F > D.props.maxDate && (F = D.props.maxDate), D.props.renderedDate = F, D.props.activeDate = F, D.props.localTime = x && Bt(x, "HH:mm") || "12:00";
      }(e), e.context) {
        const D = {};
        let O;
        e.context.fns.format = (x, F) => {
          if (D[F] && D[F][x.toString()]) return D[F][x.toString()];
          const P = Bt(x, F, e.props.locale || "en", !1, Ua);
          return D[F] ? D[F][x.toString()] = P : D[F] = { [x.toString()]: P }, P;
        }, e.context.fns.isDisabled = e.props._isDisabled, e.context.fns.isDisabledMonth = (x) => !ba(x, (F) => !e.props._isDisabled(F), "month"), e.context.fns.isDisabledYear = (x) => !ba(x, (F) => !e.props._isDisabled(F), "year"), e.context.handlers._blur = (x) => {
          var F, P;
          e.props._isFocused = !1, x.target instanceof HTMLInputElement && (x.target.selectionStart = 0, x.target.selectionEnd = 0), typeof ((F = e.context) === null || F === void 0 ? void 0 : F.handlers.blur) == "function" && ((P = e.context) === null || P === void 0 || P.handlers.blur(x));
        }, e.context.handlers.closePanel = () => {
          e.props.expanded = !1;
        }, e.context.handlers._blurOut = (x) => (F) => {
          var P;
          F.preventDefault(), e.props.keydown ? e.props.keydown = !1 : x && x !== e.props.panel || e.props.pickerOnly && F.relatedTarget instanceof Element && (F.relatedTarget === document.getElementById(`${e.props.id}_inner`) || F.relatedTarget.closest(`#${e.props.id}_inner`)) || F.relatedTarget && F.relatedTarget instanceof Element && (F.relatedTarget.closest(`#${e.props.id}_popover`) || !(!((P = e.props.__root) === null || P === void 0) && P.contains(F.relatedTarget)) || F.relatedTarget.id === `${e.props.id}_popover`) || (e.props.expanded = !1);
        }, e.context.handlers.overlayClick = () => {
          const x = ol.get(e);
          x && (x.focus(), e.props._isPlaceholder = !1);
        }, e.context.handlers.focus = () => {
          e.props.pickerOnly || (e.props._isFocused = !0, e.props.pickerOnly && !jc.has(e) && (Dv.add(e), e.props.expanded = !0, setTimeout(() => Dv.delete(e), 200)));
        }, e.context.handlers.clear = () => {
          var x, F;
          wa(e, void 0, !0), Lo(e, void 0);
          const P = (F = (x = e.props) === null || x === void 0 ? void 0 : x.__root) === null || F === void 0 ? void 0 : F.getElementById(`${e.props.id}`);
          P instanceof HTMLInputElement && (P.focus(), setTimeout(() => {
            P.setSelectionRange(0, 0);
          }, 50));
        }, e.context.handlers.dateInput = (x) => {
          var F;
          if (qc.has(e)) return qc.delete(e);
          if (x.target instanceof HTMLInputElement && !e.props.expanded) try {
            let P = Fo({ date: x.target.value, format: e.props.format, locale: e.props.locale, partFilter: Ua });
            if (function(E) {
              return Ks(E.props.format, E.props.locale).some((B) => B.partName === "weekday");
            }(e) && e.props.activeDate instanceof Date && e.props.activeDate.getTime() === P.getTime() && !Ko.get(x.target) && Bt(P, e.props.format, e.props.locale, !1, Ua) !== x.target.value) {
              const E = El("dddd", e.props.locale), B = Ks(e.props.format, e.props.locale), N = (F = Xy(x.target.value, B).find((j) => j.token === "dddd")) === null || F === void 0 ? void 0 : F.value, Y = Bt(P, "dddd", e.props.locale);
              if (N && E.includes(N) && Y !== N) {
                let j = E.indexOf(N) - E.indexOf(Y);
                j = j < -1 ? 7 + j : j, P = Ms(P, j), zu.add(e);
              }
            }
            wa(e, P);
          } catch {
            wa(e, void 0);
          }
        }, e.context.handlers.open = () => {
          e.props.expanded = !0;
        }, e.context.handlers.next = () => {
          switch (e.props.panel) {
            case "year":
              return void (e.props.renderedDate = $s(e.props.renderedDate, 10));
            case "day":
              return void (e.props.renderedDate = co(e.props.renderedDate, 1));
          }
        }, e.context.handlers.prev = () => {
          switch (e.props.panel) {
            case "year":
              return void (e.props.renderedDate = $s(e.props.renderedDate, -10));
            case "day":
              return void (e.props.renderedDate = co(e.props.renderedDate, -1));
          }
        }, e.context.handlers.setDate = (x) => () => {
          e.props.panel !== "month" && e.props.panel !== "year" || !e.props.activeDate || (x = e.props.activeDate), e.emit("dateSelected", x);
        }, e.context.handlers.localTime = (x) => {
          const F = x.target;
          if (!F.value) return;
          const [P, E] = F.value.split(":");
          e.props.localTime = F.value, e.props.activeDate.setHours(P, E), Lo(e, e.props.activeDate);
        }, e.context.handlers.keyDown = (x) => {
          switch (e.props.keydown = !0, e.props.panel) {
            case "day":
              return e.emit("calendarKeydown", x);
            case "year":
              return e.emit("yearKeydown", x);
            case "month":
              return e.emit("monthKeydown", x);
            case "time":
              return e.emit("timeKeydown", x);
            default:
              return;
          }
        }, e.context.handlers.inputKeydown = (x) => {
          e.emit("keydown", x);
        }, e.context.handlers.openKeydown = (x) => {
          x.key !== "Enter" && x.key !== "Space" || (e.props.expanded = !0);
        }, e.context.handlers.mouseEnter = (x) => (F) => {
          if (clearTimeout(O), F.target instanceof HTMLElement && F.target.getAttribute("tabindex") === "-1" && F.target.getAttribute("data-is-extra") !== "true") if (e.props.panel === "month" || e.props.panel === "year") {
            const P = ba(x, () => !0, e.props.panel);
            P && (e.props.activeDate = P);
          } else e.props.activeDate = x;
        }, e.context.handlers.mouseLeave = () => {
          clearTimeout(O), O = setTimeout(() => {
          }, 100);
        }, e.context.handlers.jumpTo = (x) => () => {
          e.props.panels.unshift(e.props.panel), e.props.panel = x;
        }, e.context.fns.sameDay = (x) => function(F, P) {
          return P instanceof Date && Jy(F, P);
        }(x, e.props.activeDate), e.context.fns.sameMonth = (x) => R0(x, e.props.activeDate), e.context.fns.sameYear = (x) => F0(x, e.props.activeDate), e.context.fns.notInMonth = (x, F) => {
          const P = eJ(F).getTime();
          return P < Bm(x).getTime() || P > Zi(x).getTime() || void 0;
        };
      }
    });
    const I = Ane.bind(null, e);
    e.on("prop:panel", ({ payload: D }) => {
      e.props.showPagination = e.props.paginatedPanels.includes(D);
    }), e.on("dateSelected", ({ payload: D }) => {
      var O, x;
      Array.isArray(e.props.panels) && e.props.panels.length ? e.props.panel = e.props.panels.shift() : (e.props.expanded = !1, (x = (O = e.props.__root) === null || O === void 0 ? void 0 : O.getElementById(`${e.props.id}`)) === null || x === void 0 || x.focus()), D && e.props._isDisabled(D) || wa(e, D);
    }), e.on("input", ({ payload: D }) => {
      if (D === void 0 && !e.props._isFocused) return void Lo(e, void 0);
      const O = /* @__PURE__ */ new Date(), x = D ? Lo(e, _s(typeof D == "string" ? Fo(D, e.props.valueFormat, e.props.valueLocale) : D, e.props.offset)) : O;
      e.props.activeDate = !D && e.props.activeDate ? e.props.activeDate : x, e.props.renderedDate = !D && e.props.renderedDate ? e.props.renderedDate : x, e.props.localTime = Bt(x, "HH:mm"), function(F) {
        const P = M0.get(F);
        if (F._value && P) {
          const E = gr(F.props.activeDate);
          if (P.length > E) P.splice(E, P.length - E);
          else if (P.length < E) for (let B = P.length + 1; B <= E; B++) P.push(String(B));
        }
      }(e);
    }), e.on("prop:renderedDate", Kc.bind(null, e)), e.on("prop:expanded", ({ payload: D }) => {
      if (D) {
        if (Wu.delete(e), e.props.panels = Pv(e), e.props.panel = e.props.panels.shift(), window.innerWidth <= 430 && !window.matchMedia("(hover: hover)").matches ? e.props.showPanelClose = !0 : e.props.showPanelClose = !1, e.props.panel === "day") {
          const O = e.props.activeDate;
          e.props.activeDate = ba(e.props.activeDate, (x) => !e.props._isDisabled(x), "month") || O;
        }
        Kc(e), it(`${e.props.id}_popover`, (O) => {
          const x = O.querySelector('[tabindex="0"]');
          x && setTimeout(() => {
            x.focus(), function(F, P) {
              const E = new MutationObserver((N) => {
                for (const Y of N) Y.type === "attributes" && Y.target instanceof HTMLElement && Y.target.getAttribute("tabindex") === "0" ? Y.target.focus() : Y.addedNodes.length && Y.addedNodes.forEach((j) => {
                  var ee;
                  if (j instanceof HTMLElement && j.getAttribute("tabindex") === "0") j.focus();
                  else if (j instanceof HTMLElement && j.querySelector('[tabindex="0"]')) {
                    const te = j.querySelector('[tabindex="0"]');
                    te instanceof HTMLElement && te.focus();
                  } else j instanceof HTMLElement && j.querySelector('input[type="time"]') && ((ee = j.querySelector('input[type="time"]')) === null || ee === void 0 || ee.focus());
                });
              });
              E.observe(P, { attributes: !0, attributeFilter: ["tabindex"], childList: !0, subtree: !0 });
              const B = F.on("prop:expanded", ({ payload: N }) => {
                N || (F.off(B), E.disconnect());
              });
            }(e, O);
          }, 0);
        }, e.props.__root), Av && setTimeout(() => {
          document.addEventListener("click", I);
        }, 10);
      } else {
        if (e.props.panel === "time") e.emit("dateSelected", e.props.activeDate);
        else if (e._value) {
          qc.add(e);
          const O = typeof e._value == "string" ? Fo(e._value, e.props.valueFormat, e.props.valueLocale) : e._value;
          Lo(e, _s(O, e.props.offset));
        } else Lo(e, void 0);
        Av && (jc.add(e), document.removeEventListener("click", I), setTimeout(() => jc.delete(e), 50));
      }
    }), e.on("prop:activeDate", ({ payload: D }) => {
      if (Array.isArray(e.props.calendar) && e.props.calendar.length) {
        if (e.props.panel === "day") {
          const O = e.props.calendar, x = Bm(e.props.renderedDate), F = Zi(co(e.props.renderedDate, O.length - 1));
          D.getTime() < x.getTime() ? e.props.renderedDate = co(e.props.renderedDate, -1) : D.getTime() > F.getTime() && (e.props.renderedDate = co(e.props.renderedDate));
        } else if (e.props.panel === "year") {
          const O = e.props.years, x = O[0].getFullYear(), F = O[O.length - 1].getFullYear(), P = e.props.activeDate.getFullYear();
          e.props.renderedDate = P > F ? $s(e.props.renderedDate, 10) : P < x ? $s(e.props.renderedDate, -10) : D;
        }
      }
      e.props.expanded && Lo(e, e.props.activeDate);
    }), e.on("keydown", ({ payload: D }) => {
      switch (D.key) {
        case "ArrowDown":
        case "ArrowUp":
        case " ":
          D.preventDefault(), e.props.pickerOnly && (e.props.expanded = !0);
          break;
        case "Enter":
        case "Return":
          e.props.expanded || (e.props.expanded = !0);
          break;
        case "Escape":
          e.props.expanded = !1;
      }
    }), e.on("calendarKeydown", ({ payload: D }) => {
      D.preventDefault();
      let O = null, x = 0;
      switch (D.key) {
        case "ArrowRight":
          x = 1;
          break;
        case "ArrowLeft":
          x = -1;
          break;
        case "ArrowDown":
          x = 7;
          break;
        case "ArrowUp":
          x = -7;
          break;
        case "Return":
        case "Enter":
          e.emit("dateSelected", e.props.activeDate);
          break;
        case "Tab":
          D.shiftKey || Yc(e, D);
          break;
        case "Escape":
          e.props.expanded = !1;
      }
      if (x && (D.preventDefault(), O = Ms(e.props.activeDate, x)), O && !e.props._isDisabled(O)) e.props.activeDate = O;
      else if (O && e.props._isDisabled(O)) {
        const F = x > 0 ? 1 : -1;
        go(Number(e.props.maxScan), (P) => F * P).some((P) => {
          const E = Ms(O, P);
          return !e.props._isDisabled(E) && (e.props.activeDate = E, !0);
        });
      }
    }), e.on("yearKeydown", ({ payload: D }) => {
      let O = 0;
      switch (D.key) {
        case "ArrowDown":
          O = 5;
          break;
        case "ArrowRight":
          O = 1;
          break;
        case "ArrowUp":
          O = -5;
          break;
        case "ArrowLeft":
          O = -1;
          break;
        case "Tab":
          D.shiftKey || Yc(e, D);
          break;
        case "Return":
        case "Enter":
          e.emit("dateSelected", e.props.activeDate);
          break;
        case "Escape":
          e.props.expanded = !1;
      }
      const x = e.props.activeDate.getFullYear() + O - e.props.renderedDate.getFullYear();
      e.props.activeDate = $s(e.props.renderedDate, x);
    }), e.on("monthKeydown", ({ payload: D }) => {
      let O = 0;
      switch (D.key) {
        case "ArrowDown":
          O = 3;
          break;
        case "ArrowRight":
          O = 1;
          break;
        case "ArrowLeft":
          O = -1;
          break;
        case "ArrowUp":
          O = -3;
          break;
        case "Tab":
          D.shiftKey || Yc(e, D);
          break;
        case "Return":
        case "Enter":
          e.emit("dateSelected", e.props.activeDate);
          break;
        case "Escape":
          e.props.expanded = !1;
      }
      O && D.preventDefault();
      let x = (e.props.activeDate.getMonth() + O) % 12;
      x = x < 0 ? 12 + x : x;
      const F = x - e.props.renderedDate.getMonth();
      let P = co(e.props.renderedDate, F);
      if (e.props._isDisabled(P)) {
        const E = ba(P, (B) => !e.props._isDisabled(B), "month");
        E && (P = E);
      }
      e.props.activeDate = P;
    }), e.on("timeKeydown", ({ payload: D }) => {
      switch (D.key) {
        case "Return":
        case "Enter":
          D.preventDefault(), e.emit("dateSelected", e.props.activeDate);
      }
    }), e.on("prop:_isFocused", () => {
      ol.get(e) && V0(e);
    }), e.on("commit", ({ payload: D }) => {
      if (D ? N0(e) : L0(e), e.props.activeDate && e.props._isDisabled(e.props.activeDate)) {
        const O = ct({ blocking: !0, key: "rule_invalidDate", meta: { messageKey: "invalidDate", removeImmediately: !1, localize: !0, i18nArgs: [{ node: e, name: Ene(e), args: [] }] }, type: "validation", value: "The selected date is invalid." });
        e.store.set(O);
      } else e.store.remove("rule_invalidDate");
    });
  },
  br,
  /* @__PURE__ */ We("next"),
  /* @__PURE__ */ We("prev"),
  /* @__PURE__ */ We("changeDate"),
  /* @__PURE__ */ We("chooseDate"),
  /* @__PURE__ */ Oe("close", "close"),
  /* @__PURE__ */ Oe("next", "right"),
  /* @__PURE__ */ Oe("clear", "close"),
  /* @__PURE__ */ Oe("prev", "left"),
  /* @__PURE__ */ Oe("calendar", "date")
] }, Ln = /* @__PURE__ */ Lt("tl"), { outer: Lne, wrapper: Nne, inner: Fne, icon: Ca, label: Rne, prefix: Vne, suffix: Bne, help: Hne, messages: Une, message: zne } = /* @__PURE__ */ Nt(Ln), Wne = Ln("input", () => ({ $el: "input", bind: "$attrs", attrs: { id: "$id", type: "text", onClick: "$handlers.click", onBlur: "$handlers.blur", onKeydown: "$handlers.keydown", onInput: "$handlers.input", onFocus: "$handlers.focus", value: "$inputText", name: "$node.name", tabindex: "0", placeholder: "$state.loading && $inputStd.length === 0 && $ui.isLoading.value || $placeholder || undefined", role: "combobox", autocomplete: "off", autocapitalize: "none", readonly: "$attrs.readonly || $isLoadingOption || undefined || $multiple && $max && $value && $value.length >= $max", disabled: "$disabled || $disabledInternally || undefined", "aria-autocomplete": "list", "aria-expanded": "$expanded", "aria-controls": '$expanded && $id + "_listbox" || undefined', "aria-describedBy": "$describedBy", "aria-activedescendant": "$expanded && $activeDescendant || undefined" } })), jne = Ln("listboxButton", () => ({ $el: "button", attrs: { style: "$visibilityStyles", id: '$id + "_listbox_button"', type: "button", onClick: "$handlers.toggleListbox", tabindex: "-1", "aria-label": "$expanded && $ui.close.value || $ui.open.value", disabled: "$disabled || undefined", "aria-haspopup": "true", "aria-expanded": "$expanded", "aria-controls": '$expanded && $id + "_listbox" || undefined' } })), qne = Ln("tagWrapper", () => ({ $el: "span", for: ["option", "index", "$selections"], attrs: { id: '$id + "_tag-wrapper_" + $index', key: "$option.value", "data-value": "$option.value", tabindex: "-1", onClick: "$handlers.tagClick && $handlers.tagClick($option)", onFocus: "$handlers.tagFocus && $handlers.tagFocus($option)", onBlur: "$handlers.tagBlur && $handlers.tagBlur($option)", onKeydown: "$handlers.searchInputTagKeydown && $handlers.searchInputTagKeydown($option)", "data-is-tag": "true", "data-active-selection": "$fns.isActiveSelection && $fns.isActiveSelection($activeSelectionValue, $option)" } })), Kne = Ln("tag", () => ({ $el: "div", attrs: { id: '$id + "_tag_" + $index', role: "button" } })), Yne = Ln("removeSelection", () => ({ $el: "button", if: "$selections.length > 0", attrs: { id: '$id + "_remove_selection_" + $index', tabindex: "-1", "aria-label": "$ui.remove.value", type: "button", onClick: "$handlers.removeSelection && $handlers.removeSelection($option)", onTouchstart: "$handlers.removeSelection && $handlers.removeSelection($option)", "aria-controls": "$id" } })), Gne = Ln("tagLabel", () => ({ $el: "span" })), Zne = Ln("tags", () => ({ $el: "div", attrs: { id: '$id + "_selections"', "aria-live": "polite" } })), Xne = Ln("tagLoading", "span"), Jne = /* @__PURE__ */ hd(Ln);
function Qne(e) {
  e.props.multiple = !0, e.props.openOnClick = _e(e.props.openOnClick), e.props.closeOnSelect === void 0 && (e.props.closeOnSelect = !0), e.props.closeOnSelect ? e.props.resetSearchOnCommit = !1 : e.props.resetSearchOnCommit === void 0 && (e.props.resetSearchOnCommit = e.props.multiple), e.props.allowNewValues = _e(e.props.allowNewValues);
}
function eoe(e) {
  $0(e), v0(e), e.on("created", () => {
    function t() {
      return Array.isArray(e.value) ? e.value : [];
    }
    function n(o) {
      e.input(o);
    }
    e.props.disabled && (e.props.draggable = !1), it(`${e.props.id}_selections`, (o) => {
      if (o instanceof HTMLElement) {
        if (!e.context) return;
        const s = { draggingClass: e.context.classes.dragging, dropZoneClass: e.context.classes.dropZone, disabled: !e.props.draggable, threshold: { horizontal: 0.25, vertical: 0 }, plugins: [Dl()], root: e.props.__root, touchDraggingClass: e.context.classes.touchDragging, touchDropZoneClass: e.context.classes.touchDropZone, draggable: (a) => a.hasAttribute("data-is-tag"), handleEnd(a) {
          e.props.activeSelectionValue = void 0, Yi(a);
        }, handleDragstart(a) {
          e.props.activeSelectionValue = void 0, Ki(a);
        }, handleTouchstart(a) {
          e.props.activeSelectionValue = void 0, Gi(a);
        } };
        mt({ parent: o, getValues: t, setValues: n, config: s }), e.on("prop:disabled", ({ payload: a }) => {
          s.disabled = a, mt({ parent: o, getValues: t, setValues: n, config: s });
        }), e.on("prop:draggable", ({ payload: a }) => {
          s.disabled = !a, mt({ parent: o, getValues: t, setValues: n, config: s });
        });
      }
    }, e.props.__root);
  });
}
const toe = { schema: /* @__PURE__ */ Lne(/* @__PURE__ */ Nne(/* @__PURE__ */ Rne("$label"), /* @__PURE__ */ Fne(/* @__PURE__ */ Ca("prefix"), /* @__PURE__ */ Vne(), /* @__PURE__ */ Zne(/* @__PURE__ */ qne(/* @__PURE__ */ Kne(/* @__PURE__ */ ye("$state.loading && $fns.hasOptionLoaderValue && $fns.hasOptionLoaderValue($option) || $option.label === undefined", /* @__PURE__ */ Xne("$ui.isLoading.value"), /* @__PURE__ */ Gne("$option.label")), /* @__PURE__ */ Yne(/* @__PURE__ */ Ca("close")))), /* @__PURE__ */ Wne()), /* @__PURE__ */ ye("$state.loading", /* @__PURE__ */ Ca("loader")), /* @__PURE__ */ jne(/* @__PURE__ */ Ca("select")), /* @__PURE__ */ Jne(), /* @__PURE__ */ Bne(), /* @__PURE__ */ Ca("suffix"))), /* @__PURE__ */ Hne("$help"), /* @__PURE__ */ Une(/* @__PURE__ */ zne("$message.value"))), type: "input", family: "dropdown", props: [], features: [
  xn,
  /* @__PURE__ */ _d.bind(null, Qne, b0, eoe),
  /* @__PURE__ */ Oe("select", "select"),
  /* @__PURE__ */ Oe("close", "close"),
  /* @__PURE__ */ Oe("selected", "check"),
  /* @__PURE__ */ Oe("loader", "spinner"),
  /* @__PURE__ */ We("isLoading"),
  /* @__PURE__ */ We("loadMore"),
  /* @__PURE__ */ We("remove"),
  /* @__PURE__ */ We("open"),
  /* @__PURE__ */ We("close"),
  br
] }, Sd = /* @__PURE__ */ Lt("mk"), { outer: noe, wrapper: ooe, inner: soe, label: aoe, prefix: roe, suffix: ioe, help: loe, messages: coe, message: uoe, icon: Ev } = /* @__PURE__ */ Nt(Sd), { overlayPlaceholder: poe, overlayLiteral: doe, overlayChar: foe, overlayEnum: moe, overlay: voe, overlayParts: hoe, overlayInner: goe } = /* @__PURE__ */ e0(Sd), boe = Sd("input", () => ({ $el: "input", bind: "$attrs", attrs: { type: "text", disabled: "$disabled", name: "$node.name", onBlur: "$handlers.blur", onInput: "$handlers.DOMInput", value: "$_maskValue", placeholder: "$placeholder", id: "$id", "aria-describedby": "$describedBy" } })), ju = /* @__PURE__ */ new WeakMap(), qu = /* @__PURE__ */ new WeakMap(), Ov = /* @__PURE__ */ new WeakMap();
function yoe(e, t) {
  if (!(t instanceof HTMLInputElement)) throw new Error(`Masks can only be applied to an HTMLInputElement (id: ${t.id}).`);
  qu.set(e, t), wd(t, { ...ju.get(e), onChange: ({ valueAfter: n, meta: o }) => {
    e.props._maskValue = n, e.input({ maskValue: n }), e.props._overlayParts = gd(o);
  } }, e);
}
const $oe = { schema: /* @__PURE__ */ noe(/* @__PURE__ */ ooe(/* @__PURE__ */ aoe("$label"), /* @__PURE__ */ soe(/* @__PURE__ */ Ev("prefix"), /* @__PURE__ */ roe(), /* @__PURE__ */ voe(/* @__PURE__ */ goe(/* @__PURE__ */ hoe(/* @__PURE__ */ poe("$part.value"), /* @__PURE__ */ doe("$part.value"), /* @__PURE__ */ foe("$part.value"), /* @__PURE__ */ moe("$part.value")))), /* @__PURE__ */ boe(), /* @__PURE__ */ ioe(), /* @__PURE__ */ Ev("suffix"))), /* @__PURE__ */ loe("$help"), /* @__PURE__ */ coe(/* @__PURE__ */ uoe("$message.value"))), type: "input", props: ["allowIncomplete", "mask", "mode", "tokens", "showMask", "unmaskValue", "prefix", "suffix", "reverse", "overlay"], family: "text", features: [B0, function(e) {
  e.addProps(["_maskValue", "_overlayParts"]), e.on("created", () => {
    var t, n, o, s, a;
    const r = _0(typeof e._value == "string" ? e._value : "");
    qu.set(e, r), Ov.set(e, r), e.props.allowIncomplete = _e(e.props.allowIncomplete), e.props.overlay = _e(e.props.overlay);
    const i = !(e.props.showMask !== void 0 && !_e(e.props.showMask));
    e.props.unmaskValue = _e(e.props.unmaskValue), e.hook.prop((c, u) => (c.prop === "unmaskValue" && (c.value = _e(c)), u(c)));
    const l = { placeholder: i, pattern: (t = e.props.mask) !== null && t !== void 0 ? t : "", mode: (n = e.props.mode) !== null && n !== void 0 ? n : "shift", partOverrides: (o = e.props.tokens) !== null && o !== void 0 ? o : {}, prefix: (s = e.props.prefix) !== null && s !== void 0 ? s : void 0, suffix: (a = e.props.suffix) !== null && a !== void 0 ? a : void 0, reverse: _e(e.props.reverse) };
    ju.set(e, l), e.hook.input((c, u) => {
      const p = function(f, m) {
        const h = qu.get(f), g = typeof m == "object" && "maskValue" in m;
        m = typeof m == "string" ? m : g ? m.maskValue : "";
        const _ = Ov.get(f);
        _.value = Cd(_, m);
        const v = yv(_, ju.get(f)), w = E0(_, f.props.allowIncomplete);
        return m === h.value ? f.props.unmaskValue ? w ?? "" : w === null ? "" : typeof m == "string" ? m : "" : m === "" && h.value !== "" && !f.props.allowIncomplete ? m : (g || v === f.props._maskValue || (h.value = v, f.props._maskValue = v, f.props._overlayParts = gd(O0(_) || [])), w === null ? "" : f.props.unmaskValue ? w : v);
      }(e, c);
      return u(p);
    }), e.props._maskValue = yv(r, l, e), e.input(e.props._maskValue, !1), e.context && (e.context.handlers.DOMInput = (c) => {
      e.emit("dom-input-event", c);
    }), it(`${e.props.id}`, yoe.bind(null, e), e.props.__root);
  });
}] }, Fe = /* @__PURE__ */ Lt("tf"), { outer: _oe, wrapper: woe, icon: yn, help: Coe, messages: koe, message: Soe } = /* @__PURE__ */ Nt(Fe), Toe = Fe("fieldset", () => ({ $el: "fieldset", attrs: { id: '$id + "_fieldset"', role: "presentation", "aria-describedby": { if: "$help", then: '$: "help-" + $id', else: void 0 } } })), Aoe = Fe("legend", () => ({ if: "$label", $el: "legend" })), Doe = Fe("source", () => ({ $el: "div", attrs: { id: '$id + "_source"', class: '$classes.transferlist + " " + $classes.source' } })), Poe = Fe("sourceHeader", () => ({ $el: "div", attrs: { id: '$id + "_source_header"', role: "presentation", class: '$classes.transferlistHeader + " " + $classes.sourceHeader' } })), Ioe = Fe("sourceHeaderLabel", () => ({ if: "$sourceLabel", $el: "label", attrs: { id: '$id + "_source_header_label"', for: '$id + "_source_search_input"', class: '$classes.transferlistHeaderLabel + " " + $classes.sourceHeaderLabel' }, children: "$sourceLabel || $label" })), Eoe = Fe("sourceHeaderItemCount", () => ({ $el: "span", attrs: { id: '$id + "_source_header_item_count"', role: "presentation", "aria-label": '$sourceOptions.length " items"', class: '$classes.transferlistHeaderItemCount + " " + $classes.sourceHeaderItemCount' } })), Ooe = Fe("targetHeaderLabel", () => ({ if: "$targetLabel", $el: "label", attrs: { id: '$id + "_target_header_label"', for: '$id + "_target_search_input"', class: '$classes.transferlistHeaderLabel + " " + $classes.targetHeaderLabel' }, children: "$targetLabel || $label" })), xoe = Fe("targetHeaderItemCount", () => ({ $el: "span", attrs: { id: '$id + "_target_header_item_count"', role: "presentation", "aria-label": '$targetOptions.length + " items"', class: '$classes.transferlistHeaderItemCount + " " + $classes.targetHeaderItemCount' }, children: "$targetOptions.length" })), Moe = Fe("sourceControls", () => ({ $el: "div", if: "$searchable", attrs: { id: '$id + "_source_controls"', class: '$classes.transferlistControls + " " + $classes.sourceControls' } })), Loe = Fe("sourceSearch", () => ({ if: "$searchable", $el: "div", attrs: { id: '$id + "_source_search"', class: '$classes.transferlistSearch + " " + $classes.sourceSearch' } })), Noe = Fe("sourceSearchInput", () => ({ $el: "input", attrs: { id: '$id + "_source_search_input"', type: "text", placeholder: "$placeholder", onInput: "$handlers.onSearch", value: "$inputText", onKeydown: "$handlers.sourceSearchKeydown", disabled: "$disabled", "aria-label": "Search", role: "searchbox", autocomplete: "off", class: '$classes.transferlistSearchInput + " " + $classes.sourceSearchInput', onFocus: "$handlers.sourceSearchFocus", onBlur: "$handlers.sourceSearchBlur" } })), Foe = Fe("targetSearch", () => ({ if: "$targetSearchable", $el: "div", attrs: { id: '$id + "_target_search"', class: '$classes.transferlistSearch + " " + $classes.targetSearch' } })), Roe = Fe("targetSearchInput", () => ({ $el: "input", attrs: { id: '$id + "_target_search_input"', type: "text", placeholder: "$placeholder", onInput: "$handlers.onTargetSearch", value: "$targetInputText", onKeydown: "$handlers.targetSearchKeydown", disabled: "$disabled", "aria-label": "Search", role: "searchbox", autocomplete: "off", class: '$classes.transferlistSearchInput + " " + $classes.targetSearchInput', onFocus: "$handlers.targetSearchFocus", onBlur: "$handlers.targetSearchBlur" } })), Voe = Fe("targetControls", () => ({ $el: "div", if: "$targetSearchable", attrs: { id: '$id + "_target_controls"', class: '$classes.transferlistControls + " " + $classes.targetControls' } })), Boe = Fe("sourceSearchClear", () => ({ $el: "button", if: '$inputText !== ""', attrs: { id: '$id + "_source_search_clear"', type: "button", onClick: "$handlers.clearSearch", "aria-label": "Clear Source Search", class: '$classes.transferlistSearchClear + " " + $classes.sourceSearchClear' } })), Hoe = Fe("targetSearchClear", () => ({ $el: "button", if: '$targetInputText !== ""', attrs: { id: '$id + "_target_search_clear"', type: "button", onClick: "$handlers.clearTargetSearch", "aria-label": "Clear Target Search", class: '$classes.transferlistSearchClear + " " + $classes.targetSearchClear' } })), Uoe = Fe("sourceListItems", () => ({ $el: "ul", attrs: { id: '$id + "_source_list_items"', "aria-activedescendant": "$activeDescendant", onMouseenter: "$handlers.onMouseenter(true)", onMouseout: "$handlers.onMouseleave(true)", role: "listbox", "aria-multiselectable": "true", "aria-roledescription": "List of options to choose from.", class: '$classes.transferlistListItems + " " + $classes.sourceListItems', onKeydown: "$handlers.sourceListKeydown", tabindex: "$searchable || $sourceOptions.length === 0 && -1 || 0", onFocus: "$handlers.sourceListFocused", onBlur: "$handlers.sourceListBlurred", "aria-label": "Source list" } })), zoe = Fe("sourceListItem", () => ({ for: ["option", "index", "$sourceOptions"], $el: "li", attrs: { id: '$id + "_source_list_item_" + $index', "data-value": "$option.value", "aria-selected": "$transferOnSelect === false && $fns.isSelected($option, $selectedSourceItems)", "data-is-active": "$fns.isActive($option, $activeValue)", "data-disabled": "$option.attrs.disabled", role: "option", onClick: "$handlers.listitemClick($option, true)", onTouchstart: "$handlers.listitemTouchstart($option, true)", onTouchmove: "$handlers.listitemTouchmove($option, true)", onTouchend: "$handlers.listitemTouchend($option, true)", key: "$option.value", class: '$classes.transferlistListItem + " " + $classes.sourceListItem' } })), Woe = Fe("sourceOption", () => ({ $el: "div", attrs: { "data-checked": "$fns.isSelected($option, $selectedSourceItems)", class: '$classes.transferlistOption + " " + $classes.sourceOption' } })), joe = Fe("sourceLoadMore", () => ({ $el: "li", if: "$state.loading || $state.hasNextPage", attrs: { id: '$id + "_source_load_more"', key: "loadMore", onClick: "$handlers.listitemClick($loadMoreOption)", "aria-selected": "false", "data-is-active": "$fns.isActive($loadMoreOption)", tabindex: "-1" } })), qoe = Fe("loadMoreInner", "span"), Koe = Fe("target", () => ({ $el: "div", attrs: { id: '$id + "_target"', class: '$classes.transferlist + " " + $classes.target' } })), Yoe = Fe("targetHeader", () => ({ $el: "div", attrs: { id: '$id + "_target_header"', role: "presentation", class: '$classes.transferlistHeader + " " + $classes.targetHeader' } })), Goe = Fe("targetListItems", () => ({ $el: "ul", attrs: { id: "$id", "aria-activedescendant": "$activeDescendant", onMouseenter: "$handlers.onMouseenter(false)", onMouseout: "$handlers.onMouseleave(false)", role: "listbox", class: '$classes.transferlistListItems + " " + $classes.targetListItems', tabindex: "$targetOptions.length === 0 && -1 || 0", onKeydown: "$handlers.targetListKeydown", onFocus: "$handlers.targetListFocused", onBlur: "$handlers.targetListBlurred", "aria-label": "Target list" } })), Zoe = Fe("targetListItem", () => ({ for: ["option", "index", "$targetOptions"], $el: "li", attrs: { id: '$id + "_target_list_item_" + $index', "data-disabled": "$option.attrs.disabled", "data-value": "$option.value", "aria-selected": "$transferOnSelect === false && $fns.isSelected($option, $selectedTargetItems)", "data-is-active": "$fns.isActive($option, $activeValue)", role: "option", onClick: "$handlers.listitemClick($option, false)", onTouchstart: "$handlers.listitemTouchstart($option, false)", onTouchmove: "$handlers.listitemTouchmove($option, false)", onTouchend: "$handlers.listitemTouchend($option, false)", key: "$option.value", class: '$classes.transferlistListItem + " " + $classes.targetListItem' } })), Xoe = Fe("targetOption", () => ({ $el: "div", attrs: { id: '$id + "_target_list_item_" + $index + "_option"', "data-checked": "$fns.isSelected($option, $selectedTargetItems)", class: '$classes.transferlistOption + " " + $classes.targetOption' } })), Joe = Fe("transferControls", () => ({ $el: "div", attrs: { id: '$id + "_transfer_controls"' } })), Qoe = Fe("transferButtonForward", () => ({ if: "$transferOnSelect !== true", $el: "button", attrs: { id: '$id + "_transfer_button_forward"', type: "button", disabled: "$selectedSourceItems.length === 0 || $disabled || ($max && $value && $value.length >= $max)", onClick: "$handlers.transferForward", "aria-label": "$ui.addSelectedValues.value", title: "$ui.addSelectedValues.value", class: '$classes.transferlistButton + " " + $classes.transferButtonForward' } })), ese = Fe("transferButtonForwardAll", () => ({ $el: "button", attrs: { id: '$id + "_transfer_button_forward_all"', type: "button", disabled: "$sourceOptions.length === 0 || $disabled || ($max && $value && $value.length >= $max)", onClick: "$handlers.transferForwardAll", "aria-label": "$ui.addAllValues.value", title: "$ui.addAllValues.value", onFocus: "$handlers.transferForwardAllFocused", class: '$classes.transferlistButton + " " + $classes.transferButtonForwardAll' } })), tse = Fe("transferButtonBackward", () => ({ if: "$transferOnSelect !== true", $el: "button", attrs: { id: '$id + "_transfer_button_backward"', onClick: "$handlers.transferBackward", type: "button", disabled: "$selectedTargetItems.length === 0 || $targetOptions.length === 0 || $disabled", "aria-label": "$ui.removeSelectedValues.value", title: "$ui.removeSelectedValues.value", class: '$classes.transferlistButton + " " + $classes.transferButtonBackward' } })), nse = Fe("transferButtonBackwardAll", () => ({ $el: "button", attrs: { id: '$id + "_transfer_button_backward_all"', onClick: "$handlers.transferBackwardAll", type: "button", disabled: "$targetOptions.length === 0 || $disabled", "aria-label": "$ui.removeAllValues.value", title: "$ui.removeAllValues.value", class: '$classes.transferlistButton + " " + $classes.transferButtonBackwardAll' } })), Vr = Fe("controlLabel", "span"), ose = Fe("sourceEmptyMessage", () => ({ $el: "li", if: "$showSourceEmptyMessage && $sourceEmptyMessage && $state.loading !== true", attrs: { id: '$id + "_source_empty_message"', key: "$sourceEmptyMessage", role: "presentation" } })), sse = Fe("targetEmptyMessage", () => ({ $el: "li", if: "$showTargetEmptyMessage && $targetEmptyMessage", attrs: { id: '$id + "_empty_message"', key: "$emptyMessage", role: "presentation" } })), xv = Fe("emptyMessageInner", "span"), Js = Symbol(), Qs = /* @__PURE__ */ new WeakSet(), or = /* @__PURE__ */ new WeakSet();
function Td(e, t, n, o) {
  if (!(e.props.disabled || (e.props.isSourceOption = n, e.props.isSourceOption && Array.isArray(e.value) && e.value.length >= e.props.max))) if (n) {
    if (e.props.selectedSourceItems.includes(t)) return e.props.selectedSourceItems = e.props.selectedSourceItems.filter((s) => s !== t), e.props.activeValue = void 0, void (e.props.activeDescendant = void 0);
    e.props.selectedTargetItems = [], e.props.selectedSourceItems = [...e.props.selectedSourceItems, t];
  } else {
    if (e.props.selectedTargetItems.includes(t)) return void (e.props.selectedTargetItems = e.props.selectedTargetItems.filter((s) => s !== t));
    e.props.selectedSourceItems = [], e.props.selectedTargetItems = [...e.props.selectedTargetItems, t];
  }
}
function sl(e, t) {
  if (e.props.sourceListOrigin = !0, e.props.maxReached) return;
  if (t) {
    const o = Array.isArray(e.value) ? [...e.value, t] : [t];
    return void e.input(o);
  }
  const n = e.props.selectedSourceItems.map((o) => de(o));
  Array.isArray(e.value) ? e.input([...e.value, ...n]) : e.input(n), e.props.selectedSourceItems = [];
}
function al(e, t) {
  if (e.props.sourceListOrigin = !1, t) {
    const o = Array.isArray(e.value) ? e.value.filter((s) => s !== t) : [];
    return void e.input(o);
  }
  const n = e.props.selectedTargetItems.map((o) => de(o));
  if (Array.isArray(e.value)) {
    const o = e.value.filter((s) => !n.includes(s));
    e.input(o);
  }
  e.props.selectedTargetItems = [];
}
function H0(e) {
  var t, n;
  if (e.props.activeValue === Js) {
    const s = (t = e.props.__root) === null || t === void 0 ? void 0 : t.getElementById(`${e.props.id}_source_load_more`);
    return void (s && s.scrollIntoView({ block: "nearest", inline: "start" }));
  }
  const o = (n = e.props.__root) === null || n === void 0 ? void 0 : n.getElementById(e.props.activeDescendant);
  o && o.scrollIntoView({ block: "nearest", inline: "start" });
}
function Br(e) {
  var t;
  if (Array.isArray(e.value)) {
    const n = [];
    let o = [...e.props.options];
    e.value.forEach((s) => {
      const a = e.props.memoOptions.find((r) => we(de(r), s));
      if (a && !a.noOptionFound)
        n.push(a), e.props.options.findIndex((i) => we(de(i), s)) !== -1 && (o = o.filter((i) => !we(de(i), s)));
      else {
        const r = o.find((i) => we(de(i), s));
        r ? (n.push(r), o = o.filter((i) => !we(de(i), s))) : n.push({ label: String(s), value: s, noOptionFound: !0 });
      }
    }), e.props.targetOptions = e.props.targetInputText ? n.filter((s) => e.props.filter(s, e.props.targetInputText, e)) : n, e.props.sourceOptions = o;
  } else e.props.sourceOptions = [...e.props.options], e.props.targetOptions = [];
  if (e.props.skipSetActiveValue) return void (e.props.skipSetActiveValue = !1);
  !((t = e.props.__root) === null || t === void 0) && t.getElementById(e.props.id + "_source_list_items") && U0(e);
}
function U0(e) {
  var t, n, o, s, a, r, i, l, c;
  if (e.props.isDragging) return;
  if (e.props.targetSearchActive) {
    if (((n = (t = e.props.__root) === null || t === void 0 ? void 0 : t.activeElement) === null || n === void 0 ? void 0 : n.id) === `${e.props.id}_target_search_input`) {
      const f = e.props.targetOptions.find((m) => {
        var h;
        return !(!((h = m.attrs) === null || h === void 0) && h.disabled);
      });
      return f ? void (e.props.activeValue = de(f)) : void (e.props.activeValue = void 0);
    }
    return;
  }
  if (e.props.sourceSearchActive) {
    if (((s = (o = e.props.__root) === null || o === void 0 ? void 0 : o.activeElement) === null || s === void 0 ? void 0 : s.id) === `${e.props.id}_source_search_input`) {
      const f = e.props.sourceOptions.find((m) => {
        var h;
        return !(!((h = m.attrs) === null || h === void 0) && h.disabled);
      });
      return f ? void (e.props.activeValue = de(f)) : void (e.props.activeValue = void 0);
    }
    e.props.sourceSearchActive = !1;
  }
  if (e.props.transferOnSelect === !1) return void (e.props.activeValue = void 0);
  const u = e.props.sourceListOrigin ? e.props.sourceOptions : e.props.targetOptions;
  let p = !1;
  for (let f = e.props.activeIndex; f <= u.length; f++) if (!(!((a = u.attrs) === null || a === void 0) && a.disabled) && u[f]) {
    p = !0, e.props.activeValue = de(u[f]);
    break;
  }
  if (!p && u.length) {
    for (let f = e.props.activeIndex; f >= 0; f--) if (!(!((r = u.attrs) === null || r === void 0) && r.disabled) && u[f]) return p = !0, void (e.props.activeValue = de(u[f]));
  }
  if (!p) {
    let f;
    f = e.props.sourceListOrigin ? (c = e.props.__root) === null || c === void 0 ? void 0 : c.getElementById(`${e.props.id}`) : e.props.searchable ? (i = e.props.__root) === null || i === void 0 ? void 0 : i.getElementById(`${e.props.id}_source_search_input`) : (l = e.props.__root) === null || l === void 0 ? void 0 : l.getElementById(`${e.props.id}_source_list_items`), f && f.focus();
  }
}
function z0(e, t) {
  return (t ? e.props.sourceOptions : e.props.targetOptions).find((n) => {
    var o;
    return !(!((o = n.attrs) === null || o === void 0) && o.disabled);
  });
}
function ase(e) {
  Array.isArray(e.value) && e.value.forEach(async (t) => {
    s0(e, t, function(n, o) {
      return [...n.props.options, ...n.props.memoOptions].find((a) => we(de(a), o));
    }(e, t));
  });
}
function rse(e) {
  e.context && (e.context.handlers.loadMore = Ji.bind(null, e), e.context.fns.getSourceItemCount = (t) => e.props.transferOnSelect === !1 && t.length ? t.length + "/" + e.props.sourceOptions.length : e.props.sourceOptions.length, e.context.fns.getTargetItemCount = (t) => e.props.transferOnSelect === !1 && t.length ? t.length + "/" + e.props.targetOptions.length : e.props.targetOptions.length, e.context.fns.isActive = (t, n) => {
    if (!e.props.isDragging && !e.props.touchStarted) return we(n, de(t)) || void 0;
  }, e.context.fns.isSelected = (t, n) => !!n && !!Array.isArray(n) && n.includes(t), e.context.fns.optionLoading = (t) => e.props.optionLoaderValues.includes(de(t)), e.context.handlers.clearSearch = () => {
    (function(t) {
      var n;
      t.props.sourceSearchActive = !1, t.props.inputText = "", pn(t, "", !0);
      const o = (n = t.props.__root) === null || n === void 0 ? void 0 : n.getElementById(`${t.props.id}_source_search_input`);
      o && o.focus();
    })(e);
  }, e.context.handlers.clearTargetSearch = () => {
    (function(t) {
      var n;
      t.props.targetSearchActive = !1, t.props.targetInputText = "";
      const o = [.../* @__PURE__ */ new Set([...t.props.options, ...t.props.memoOptions])], s = [];
      for (const r of t.value) {
        const i = o.find((l) => de(l) === r);
        i && s.push(i);
      }
      t.props.targetOptions = s;
      const a = (n = t.props.__root) === null || n === void 0 ? void 0 : n.getElementById(`${t.props.id}_target_search_input`);
      a && a.focus();
    })(e);
  }, e.context.handlers.sourceSearchBlur = (t) => {
    setTimeout(() => {
      var n;
      if (t.relatedTarget && t.relatedTarget instanceof HTMLElement && (t.relatedTarget.id === `${e.props.id}_source_list_items` || t.relatedTarget.id === `${e.props.id}`)) {
        const o = (n = e.props.__root) === null || n === void 0 ? void 0 : n.getElementById(`${e.props.id}_source_search_input`);
        if (!o) return;
        o.focus();
      } else e.props.activeValue = void 0;
    });
  }, e.context.handlers.targetSearchBlur = (t) => {
    setTimeout(() => {
      var n;
      if (t.relatedTarget && t.relatedTarget instanceof HTMLElement && (t.relatedTarget.id === `${e.props.id}_source_list_items` || t.relatedTarget.id === `${e.props.id}`)) {
        const o = (n = e.props.__root) === null || n === void 0 ? void 0 : n.getElementById(`${e.props.id}_target_search_input`);
        if (!o) return;
        o.focus();
      } else e.props.activeValue = void 0;
    });
  }, e.context.handlers.listitemClick = (t, n) => (o) => {
    Mv(e, t, n);
  }, e.context.handlers.transferForward = sl.bind(null, e, void 0), e.context.handlers.transferForwardAll = () => {
    let t;
    if (e.props.maxReached) return;
    const n = e.props.sourceOptions.map((o) => de(o));
    t = Array.isArray(e.value) ? [...e.value, ...n] : [...n], e.input(t), e.props.selectedSourceItems = [];
  }, e.context.handlers.transferBackward = al.bind(null, e, void 0), e.context.handlers.transferBackwardAll = () => {
    Array.isArray(e.value) && (e.input([]), e.props.selectedTargetItems = []);
  }, e.context.handlers.onSearch = (t) => {
    (function(n, o) {
      n.props.sourceSearchActive = !0;
      const s = o.target;
      n.props.inputText = s.value, pn(n, s.value, !0);
    })(e, t);
  }, e.context.handlers.onTargetSearch = (t) => {
    (function(n, o) {
      n.props.targetSearchActive = !0;
      const s = o.target;
      n.props.targetInputText = s.value;
      const a = [.../* @__PURE__ */ new Set([...n.props.memoOptions, ...n.props.options])], r = [];
      for (const l of n.value) {
        const c = a.find((u) => de(u) === l);
        c && r.push(c);
      }
      const i = [...new Map([...n.props.targetOptions, ...r].map((l) => [JSON.stringify(l), l])).values()];
      n.props.targetOptions = i.filter((l) => n.props.filter(l, s.value, n)), n.props.targetOptions.length === 0 ? n.props.showTargetEmptyMessage = !0 : n.props.showTargetEmptyMessage = !1, U0(n);
    })(e, t);
  }, e.context.handlers.onMouseenter = (t) => (n) => {
    n.type !== "touchstart" && (t ? e.props.mouseOnSource = !0 : e.props.mouseOnTarget = !0);
  }, e.context.handlers.onMouseleave = (t) => (n) => {
    var o;
    if (n.type === "touchend") return;
    const s = (o = e.props.__root) === null || o === void 0 ? void 0 : o.getElementById(t ? `${e.props.id}_source_list_items` : `${e.props.id}`);
    s && (s.contains(n.relatedTarget) || (e.props.trackHover = !1, e.props.activeValue = void 0, e.props.activeDescendant = void 0, e.props.activeIndex = void 0, t ? e.props.mouseOnSource = !1 : e.props.mouseOnTarget = !1));
  }, e.context.handlers.listitemClick = (t, n) => (o) => {
    o instanceof MouseEvent && e.props.touchStarted || Mv(e, t, n);
  }, e.context.handlers.listitemTouchstart = () => () => {
    (function(t) {
      t.props.touchStarted = !0;
    })(e);
  }, e.context.handlers.listitemTouchend = (t, n) => (o) => {
    (function(s, a, r, i) {
      if (s.props.touchMoved) return s.props.touchMoved = !1, void (s.props.touchStarted = !1);
      const l = de(a);
      s.props.activeIndex = s.props.sourceOptions.findIndex((c) => de(c) === l), s.props.transferOnSelect ? r ? sl(s, l) : al(s, l) : Td(s, a, r);
    })(e, t, n);
  }, e.context.handlers.listitemTouchmove = () => (t) => {
    (function(n) {
      n.props.touchMoved = !0;
    })(e);
  }, e.context.handlers.sourceSearchFocus = (t) => {
    Hr(e, !0);
  }, e.context.handlers.targetSearchFocus = (t) => {
    Hr(e, !1);
  }, e.context.handlers.sourceListFocused = (t) => {
    Hr(e, !0);
  }, e.context.handlers.targetListFocused = () => {
    Hr(e, !1);
  }, e.context.handlers.sourceListBlurred = (t) => {
    e.props.activeValue = void 0;
  }, e.context.handlers.targetListBlurred = (t) => {
    e.props.activeValue = void 0;
  }, e.context.handlers.sourceListKeydown = (t) => {
    Ur(e, t, !0);
  }, e.context.handlers.targetListKeydown = (t) => {
    Ur(e, t, !1);
  }, e.context.handlers.sourceSearchKeydown = (t) => {
    Ur(e, t, !0);
  }, e.context.handlers.targetSearchKeydown = (t) => {
    Ur(e, t, !1);
  });
}
function Mv(e, t, n, o) {
  var s;
  if (de(t) === Js) return void ((s = e.context) === null || s === void 0 || s.handlers.loadMore(!0));
  const a = de(t);
  e.props.activeIndex = e.props.sourceOptions.findIndex((r) => de(r) === a), e.props.transferOnSelect ? n ? sl(e, a) : al(e, a) : Td(e, t, n);
}
function Hr(e, t) {
  const n = z0(e, t);
  n && (e.props.sourceListOrigin = t, e.props.activeValue = de(n));
}
function Ur(e, t, n) {
  if (t.key === "ArrowDown" || t.key === "ArrowUp") (function(o, s, a) {
    var r, i, l;
    o.preventDefault();
    const c = a ? s.props.sourceOptions : s.props.targetOptions, u = c.reduce((f, m) => {
      var h;
      return !((h = m == null ? void 0 : m.attrs) === null || h === void 0) && h.disabled || f.push(de(m)), f;
    }, []);
    !((r = s.store.hasNextPage) === null || r === void 0) && r.value && u.push(Js);
    const p = u.indexOf(s.props.activeValue);
    if (o.key === "ArrowUp" && p !== 0) for (let f = p - 1; f >= 0; f--) {
      s.props.sourceListOrigin = a, s.props.activeValue = u[p - 1];
      break;
    }
    else if (o.key === "ArrowDown" && p !== u.length - 1) {
      for (let f = p + 1; f < u.length; f++) if (!(!((l = (i = c[f]) === null || i === void 0 ? void 0 : i.attrs) === null || l === void 0) && l.disabled)) {
        s.props.sourceListOrigin = a, s.props.activeValue = u[f];
        break;
      }
    }
    H0(s);
  })(t, e, n);
  else if (t.key === "ArrowRight" || t.key === "ArrowLeft") {
    if (t.key === "ArrowLeft" && n || t.key === "ArrowRight" && !n) return;
    (function(o, s, a) {
      s.props.searchable || (o.preventDefault(), function(r, i) {
        var l, c, u;
        if (z0(r, !i)) if (i) {
          const p = (l = r.props.__root) === null || l === void 0 ? void 0 : l.getElementById(`${r.props.id}`);
          p && p.focus();
        } else if (r.props.searchable) {
          const p = (c = r.props.__root) === null || c === void 0 ? void 0 : c.getElementById(`${r.props.id}_source_search_input`);
          p && p.focus();
        } else {
          const p = (u = r.props.__root) === null || u === void 0 ? void 0 : u.getElementById(`${r.props.id}_source_list_items`);
          p && p.focus();
        }
      }(s, a));
    })(t, e, n);
  } else t.key === "Enter" && function(o, s, a) {
    var r;
    if (o.preventDefault(), !s.props.activeValue) return;
    if (s.props.activeValue === Js) return void ((r = s.context) === null || r === void 0 || r.handlers.loadMore(!0));
    const i = a ? s.props.sourceOptions : s.props.targetOptions, l = i.findIndex((u) => de(u) === s.props.activeValue);
    s.props.activeIndex = l;
    const c = i[l];
    c && (s.props.transferOnSelect ? a ? sl(s, de(c)) : al(s, de(c)) : Td(s, c, a));
  }(t, e, n);
}
function ise(e) {
  e.on("created", () => {
    if (typeof e.props.optionsLoader == "function" && (e.props.skipSetActiveValue = !0, Ys(e)), rse(e), e.props.disabled && (e.props.draggable = !1), Ot) {
      it(e.props.id + "_source_list_items", (n) => {
        n instanceof HTMLElement && function(o, s) {
          if (!o.context) return;
          function a() {
            return o.props.sourceOptions.map((l) => de(l));
          }
          function r() {
            return [];
          }
          const i = { longTouch: !0, draggingClass: o.context.classes.dragging, dropZoneClass: o.context.classes.dropZone, group: o.props.id, root: o.props.__root || document, disabled: !o.props.draggable || o.props.maxReached, touchDraggingClass: o.context.classes.touchDragging, touchDropZoneClass: o.context.classes.touchDropZone, selectionDraggingClass: o.context.classes.selectionDragging, selectionDropZoneClass: o.context.classes.selectionDropZone, touchSelectionDraggingClass: o.context.classes.touchSelectionDragging, touchSelectionDropZoneClass: o.context.classes.touchSelectionDropZone, longTouchClass: o.context.classes.longTouch, handleTouchmove(l) {
            o.props.selectedSourceItems = [], Hy(l);
          }, draggable: (l) => l.getAttribute("role") === "option" };
          i.plugins = [xm({ handleDragstart(l) {
            o.props.isDragging = !0, o.props.trackHover = !1, o.props.activeValue = void 0, o.props.activeDescendant = void 0, Ki(l);
          }, handleEnd(l) {
            Yi(l), o.props.isDragging = !1, o.props.activeValue = void 0, o.props.activeDescendant = void 0, o.props.activeDescendant = void 0, o.props.isDragging = !1, o.props.selectedTargetItems = [], o.props.selectedSourceItems = [];
          }, handleTouchstart(l) {
            o.props.isDragging = !0, o.props.trackHover = !1, o.props.activeValue = void 0, o.props.activeDescendant = void 0, o.props.mouseOnSource = !1, o.props.mouseOnTarget = !1, Gi(l);
          }, selections: () => o.props.selectedSourceItems.map((l) => de(l)) })], mt({ parent: s, getValues: a, setValues: r, config: i }), o.on("prop:disabled", ({ payload: l }) => {
            i.disabled = l, mt({ parent: s, getValues: a, setValues: r, config: i });
          }), o.on("prop:draggable", ({ payload: l }) => {
            i.disabled = !l, mt({ parent: s, getValues: a, setValues: r, config: i });
          }), o.on("prop:maxReached", ({ payload: l }) => {
            i.disabled = l, mt({ parent: s, getValues: a, setValues: r, config: i });
          });
        }(e, n);
      }, e.props.__root), it(`${e.props.id}`, (n) => {
        n instanceof HTMLElement && function(o, s) {
          if (!o.context) return;
          function a() {
            return o.props.targetOptions.map((l) => de(l));
          }
          function r(l, c) {
            o.props.sourceListOrigin = !0, o.input(l);
          }
          const i = { longTouch: !0, root: o.props.__root, group: o.props.id, disabled: !o.props.draggable, draggingClass: o.context.classes.dragging, dropZoneClass: o.context.classes.dropZone, touchDraggingClass: o.context.classes.touchDragging, touchDropZoneClass: o.context.classes.touchDropZone, selectionDraggingClass: o.context.classes.selectionDragging, selectionDropZoneClass: o.context.classes.selectionDropZone, touchSelectionDraggingClass: o.context.classes.touchSelectionDragging, touchSelectionDropZoneClass: o.context.classes.touchSelectionDropZone, longTouchClass: o.context.classes.longTouch, draggable: (l) => l.getAttribute("role") === "option", plugins: [] };
          i.plugins = [xm({ handleDragstart(l) {
            o.props.isDragging = !0, o.props.trackHover = !1, o.props.activeValue = void 0, Ki(l);
          }, handleEnd(l) {
            Yi(l), o.props.selectedTargetItems = [], o.props.selectedSourceItems = [], o.props.activeValue = void 0, o.props.trackHover = !0, o.props.isDragging = !1;
          }, handleTouchstart(l) {
            o.props.trackHover = !1, o.props.activeValue = void 0, o.props.isDragging = !0, o.props.activeDescendant = void 0, Gi(l);
          }, selections: () => o.props.selectedTargetItems.map((l) => de(l)) })], mt({ parent: s, getValues: a, setValues: r, config: i }), o.on("prop:disabled", ({ payload: l }) => {
            i.disabled = l, mt({ parent: s, getValues: a, setValues: r, config: i });
          }), o.on("prop:draggable", ({ payload: l }) => {
            i.disabled = !l, mt({ parent: s, getValues: a, setValues: r, config: i });
          });
        }(e, n);
      }, e.props.__root);
      const t = (n) => {
        var o;
        if (e.props.isDragging) return;
        e.props.mouseX = n.clientX, e.props.mouseY = n.clientY;
        const s = e.props.mouseOnSource ? `${e.props.id}_source_list_items` : `${e.props.id}`, a = (o = e.props.__root) === null || o === void 0 ? void 0 : o.getElementById(s);
        if (a) {
          const r = a.getBoundingClientRect();
          n.clientX > r.x && n.clientX < r.x + r.width && n.clientY > r.y && n.clientY < r.y + r.height && (e.props.trackHover = !0);
        }
      };
      document.addEventListener("mousemove", t);
    }
  });
}
function Ku(e, t) {
  var n;
  let o = null, s = "", a = [];
  if (e.props.mouseOnSource) {
    if (o = Qs.has(e), s = `${e.props.id}_source_list_item`, a = [...e.props.sourceOptions], !a || !a.length || o) return a = [], s = "", void (o = null);
  } else if (e.props.mouseOnTarget && (o = or.has(e), s = `${e.props.id}_target_list_item`, a = [...e.props.targetOptions], !a || !a.length || o)) return a = [], s = "", void (o = null);
  const r = a.reduce((l, c, u) => {
    var p, f;
    if (!((p = c.attrs) === null || p === void 0) && p.disabled) return l;
    const m = (f = e.props.__root) === null || f === void 0 ? void 0 : f.getElementById(s + `_${u}`);
    return m && l.push([m, c]), l;
  }, []), i = (n = e.props.__root) === null || n === void 0 ? void 0 : n.getElementById(`${e.props.id}_load_more`);
  i && r.push([i, e.props.loadMoreOption]), e.props.mouseOnSource && Qs.add(e), e.props.mouseOnTarget && or.add(e), r.length && W0(e, r, null, t);
}
function W0(e, t, n, o) {
  const s = o ? o.getBoundingClientRect() : { top: 0, bottom: 0 };
  if (n = null, e.props.trackHover) {
    if (e.props.mouseY > s.top && e.props.mouseY < s.bottom) {
      let a = n || 0, r = n;
      const i = (l, c) => {
        var u;
        const p = c[0], { y: f, height: m, x: h, width: g } = p.getBoundingClientRect();
        if (e.props.mouseX > h && e.props.mouseX < h + g && e.props.mouseY > f && e.props.mouseY < f + m) {
          n = l;
          const _ = c[1];
          return e.props.activeValue = _ && !(!((u = _.attrs) === null || u === void 0) && u.disabled) ? de(_) : void 0, !0;
        }
        return !1;
      };
      do {
        if (a !== null && i(a, t[a]) || r !== null && i(r, t[r])) break;
        a !== null && (a++, a > t.length - 1 && (a = null)), r !== null && (r--, r < 0 && (r = null));
      } while (a !== null || r !== null);
    }
  } else H0(e);
  e.props.mouseOnSource || e.props.mouseOnTarget ? e.props.mouseOnSource && Qs.has(e) || e.props.mouseOnTarget && or.has(e) ? requestAnimationFrame(W0.bind(null, e, t, n, o)) : Ku(e, o) : (Qs.delete(e), or.delete(e));
}
const lse = { schema: /* @__PURE__ */ _oe(/* @__PURE__ */ Toe(/* @__PURE__ */ Aoe("$label"), /* @__PURE__ */ Coe("$help"), /* @__PURE__ */ woe(/* @__PURE__ */ Doe(/* @__PURE__ */ Poe(/* @__PURE__ */ Ioe(), /* @__PURE__ */ Eoe(/* @__PURE__ */ ye("$optionsLoadingCounter > 0", /* @__PURE__ */ yn("loader"), "$fns.getSourceItemCount($selectedSourceItems)"))), /* @__PURE__ */ Moe(/* @__PURE__ */ Loe(/* @__PURE__ */ Noe(), /* @__PURE__ */ Boe(/* @__PURE__ */ yn("close")))), /* @__PURE__ */ Uoe(/* @__PURE__ */ ose(/* @__PURE__ */ xv("$sourceEmptyMessage")), /* @__PURE__ */ zoe(/* @__PURE__ */ ye("$transferOnSelect !== true && $fns.isSelected($option, $selectedSourceItems)", /* @__PURE__ */ yn("selected")), /* @__PURE__ */ Woe("$option.label")), /* @__PURE__ */ joe(/* @__PURE__ */ ye("$state.loading && $optionLoadingCounter === 0 || $state.hasNextPage", /* @__PURE__ */ qoe(/* @__PURE__ */ ye("$state.loading", /* @__PURE__ */ yn("loader")), "$state.loading && $ui.isLoading.value || $ui.loadMore.value"))))), /* @__PURE__ */ Joe(/* @__PURE__ */ ese(/* @__PURE__ */ Vr("$ui.addAllValues.value"), /* @__PURE__ */ yn("fastForward")), /* @__PURE__ */ Qoe(/* @__PURE__ */ Vr("$ui.addSelectedValues.value"), /* @__PURE__ */ yn("moveRight")), /* @__PURE__ */ tse(/* @__PURE__ */ Vr("$ui.removeSelectedValues.value"), /* @__PURE__ */ yn("moveLeft")), /* @__PURE__ */ nse(/* @__PURE__ */ Vr("$ui.removeAllValues.value"), /* @__PURE__ */ yn("rewind"))), /* @__PURE__ */ Koe(/* @__PURE__ */ Yoe(/* @__PURE__ */ Ooe(), /* @__PURE__ */ xoe("$fns.getTargetItemCount($selectedTargetItems)")), /* @__PURE__ */ Voe(/* @__PURE__ */ Foe(/* @__PURE__ */ Roe(), /* @__PURE__ */ Hoe(/* @__PURE__ */ yn("close")))), /* @__PURE__ */ Goe(/* @__PURE__ */ sse(/* @__PURE__ */ ye("$state.loading !== true", /* @__PURE__ */ xv("$targetEmptyMessage"))), /* @__PURE__ */ Zoe(/* @__PURE__ */ ye("$transferOnSelect !== true && $fns.isSelected($option, $selectedTargetItems)", /* @__PURE__ */ yn("selected")), /* @__PURE__ */ Xoe(/* @__PURE__ */ ye("$fns.optionLoading($option, $optionLoaderValues)", "$ui.isLoading.value", "$option.label")))))), /* @__PURE__ */ koe(/* @__PURE__ */ Soe("$message.value")))), type: "input", props: [], features: [
  /* @__PURE__ */ Oe("moveRight", "right"),
  /* @__PURE__ */ Oe("moveLeft", "left"),
  /* @__PURE__ */ Oe("fastForward", "fastForward"),
  /* @__PURE__ */ Oe("rewind", "rewind"),
  /* @__PURE__ */ Oe("close", "close"),
  /* @__PURE__ */ Oe("loader", "spinner"),
  /* @__PURE__ */ Oe("selected", "check"),
  /* @__PURE__ */ We("isLoading"),
  /* @__PURE__ */ We("loadMore"),
  /* @__PURE__ */ We("addAllValues"),
  /* @__PURE__ */ We("addSelectedValues"),
  /* @__PURE__ */ We("removeSelectedValues"),
  /* @__PURE__ */ We("removeAllValues"),
  xn,
  function(e) {
    (function(t) {
      t.addProps(["search", "options", "selectedItems", "activeValue", "activeIndex", "activeDescendant", "targetOptions", "sourceOptions", "optionLoader", "isLoadingOptions", "filterOptions", "inputText", "hasNextPage", "page", "targetLoading", "searchable", "sourceLabel", "targetLabel", "transferOnSelect", "disabled", "placeholder", "filter", "showSourceEmptyMessage", "showTargetEmptyMessage", "sourceEmptyMessage", "targetEmptyMessage", "clearOnSelect", "max", "maxReached", "debounce", "sourceListActive", "optionLoaderValues", "optionLoadingCounter", "optionsLoadingCounter", "memoOptions", "optionsLoaded", "selectedSourceItems", "selectedTargetItems", "draggable", "loadMore", "loadMoreOption", "targetSearchable", "targetInputText"]), t.props.loadMoreOption = { label: "Load more", value: Js }, t.props.draggable === void 0 ? t.props.draggable = !0 : t.props.draggable === "false" && (t.props.draggable = !1), t.props.optionsLoaderValues = [], t.props.selectedSourceItems = [], t.props.selectedTargetItems = [], t.props.optionsLoaded = void 0, t.props.memoOptions = [], t.props.multiple = !0, t.props.debounce = t.props.debounce ? parseInt(t.props.debounce) : 200, t.props.optionLoaderValues = [], t.props.optionsLoadingCounter = 0, t.props.optionLoadingCounter = 0, t.props.page = 1, t.props.hasNextPage = a0.bind(null, t), t.props.options ? t.props.options = [...t.props.options] : t.props.options = [], t.props.sourceOptions = [], t.props.targetOptions = [], "disabled" in t.props && (t.props.disabled = _e(t.props.disabled)), t.props.searchable = _e(t.props.searchable), t.props.searchable && (t.props.inputText = ""), t.props.targetSearchable = _e(t.props.targetSearchable), t.props.targetSearchable && (t.props.targetInputText = ""), t.props.clearOnSelect = _e(t.props.clearOnSelect), t.props.transferOnSelect === void 0 ? t.props.transferOnSelect = !0 : t.props.transferOnSelect === "false" && (t.props.transferOnSelect = !1), t.props.targetOptions.length && (t.props.targetOptionValues = t.props.targetOptions.map((n) => de(n))), t.props.initialOptions = [...t.props.options], t.props.max && (t.props.max = parseInt(t.props.max)), t.props.sourceListOrigin = void 0, typeof t.props.filter != "function" && (t.props.filter = (n, o) => n.label.toLowerCase().includes(o.toLowerCase()));
    })(e), function(t) {
      t.on("commit", async ({ payload: n }) => {
        t.props.activeValue = void 0, t.props.max && (t.props.maxReached = n.length >= t.props.max), t.props.clearOnSelect && t.props.inputText && (t.props.reFilter = !0, t.props.inputText = ""), t.props.memoOptions = [.../* @__PURE__ */ new Set([...t.props.targetOptions, ...t.props.memoOptions])], t.props.searchable && t.props.reFilter && !t.props.initialLoad ? (pn(t, t.props.inputText), t.props.reFilter = !1) : t.props.initialLoad || (t.isCreated || (t.props.skipSetActiveValue = !0), Br(t)), typeof t.props.optionLoader == "function" ? ase(t) : t.props.initialLoad || (t.props.memoOptions = [.../* @__PURE__ */ new Set([...t.props.targetOptions, ...t.props.memoOptions])]);
      });
    }(e), ise(e), function(t) {
      t.on("prop:options", () => {
        t.props.appendingOptions && (t.props.skipSetActiveValue = !0, t.props.appendingOptions = !1), Br(t);
      }), t.on("prop:memoOptions", () => {
        t.props.skipSetActiveValue = !0, Br(t);
      }), t.on("prop:sourceOptions", () => {
        t.props.sourceOptions.length === 0 ? t.props.showSourceEmptyMessage = !0 : t.props.showSourceEmptyMessage = !1, Qs.delete(t);
      }), t.on("prop:targetOptions", () => {
        t.props.targetOptions.length === 0 ? t.props.showTargetEmptyMessage = !0 : t.props.showTargetEmptyMessage = !1;
      }), t.on("prop:activeValue", ({ payload: n }) => {
        if (t.props.isDragging) return void (t.props.activeDescendant = void 0);
        if (n === Js) return void (t.props.activeDescendant = `${t.props.id}_load_more`);
        const o = (t.props.sourceListOrigin ? t.props.sourceOptions : t.props.targetOptions).findIndex((s) => we(de(s), n));
        o >= 0 && t.props.sourceListOrigin ? t.props.activeDescendant = `${t.props.id}_source_list_item_${o}` : t.props.activeDescendant = o >= 0 ? `${t.props.id}_target_list_item_${o}` : void 0;
      }), t.on("prop:mouseOnSource", ({ payload: n }) => {
        var o;
        if (n && t.props.disabled !== !0 && !t.props.isDragging) {
          const s = (o = t.props.__root) === null || o === void 0 ? void 0 : o.getElementById(t.props.id + "_source_list_items");
          if (!s) return;
          t.props.mouseOnTarget = !1, t.props.sourceListOrigin = !0, Qs.delete(t), Ku(t, s);
        }
      }), t.on("prop:mouseOnTarget", ({ payload: n }) => {
        var o;
        if (n && t.props.disabled !== !0 && !t.props.isDragging) {
          const s = (o = t.props.__root) === null || o === void 0 ? void 0 : o.getElementById(`${t.props.id}`);
          if (!s) return;
          t.props.mouseOnSource = !1, t.props.sourceListOrigin = !1, or.delete(t), Ku(t, s);
        }
      }), t.on("prop:optionsLoadingCounter", ({ payload: n }) => {
        n === 0 && t.props.optionLoadingCounter === 0 && t.store.set(er);
      }), t.on("prop:optionLoadingCounter", ({ payload: n }) => {
        n === 0 && t.props.optionsLoadingCounter === 0 && (t.store.set(er), t.props.skipSetActiveValue = !0, Br(t));
      });
    }(e);
  }
] }, at = /* @__PURE__ */ Lt("sl"), { outer: cse, wrapper: use, icon: Lv, prefix: pse, suffix: dse, help: fse, messages: mse, message: vse } = /* @__PURE__ */ Nt(at), hse = at("label", () => ({ if: "$label", $el: "label", attrs: { id: "$id + '_label'" } })), gse = at("chart", () => ({ $el: "div", if: "$chart" })), bse = at("chartBar", () => ({ $el: "div", for: ["bar", "index", "$chart"], attrs: { "data-active": { if: "$isMulti", then: { if: "$_value.0 < $_value.1", then: "$bar.at >= $_value.0 && $bar.at <= $_value.1", else: "$bar.at >= $_value.1 && $bar.at <= $_value.0" }, else: "$bar.at <= $_value" }, style: { left: '$bar.at / ($max - $min) * 100 + "%"', width: '$: "calc(" + (100 / $chart.length) + "% - 2px)"', height: { if: "$largestBar", then: '$bar.value / $largestBar * 100 + "%"' } } } })), yse = at("sliderInner", () => ({ $el: "div", attrs: { "data-has-mark-labels": "$markLabels && $marks.length > 0" } })), $se = at("track", () => ({ $el: "div", attrs: { id: "$: 'track-' + $id", onClick: "$handlers.clickTrack" } })), _se = at("trackWrapper", () => ({ $el: "div" })), wse = at("trackInner", () => ({ $el: "div" })), Cse = at("fill", () => ({ $el: "div", attrs: { style: "$fillStyles" } })), kse = at("linkedValues", () => ({ $el: "div" })), Nv = at("maxValue", () => ({ $formkit: "number", bind: "$computedMaxInputAttrs", ignore: !0, number: !0, value: { if: "$isMulti", then: "$_value.1", else: "$_value" }, tabindex: { if: "$disabled", then: -1 }, onNode: "$handlers.maxNode", onBlur: "$handlers.inputBlur" })), Sse = at("minValue", () => ({ $formkit: "number", if: "$isMulti", bind: "$computedMinInputAttrs", ignore: !0, number: !0, value: { if: "$isMulti", then: "$_value.0", else: "$_value" }, tabindex: { if: "$disabled", then: -1 }, onNode: "$handlers.minNode", onBlur: "$handlers.inputBlur" })), Tse = at("marks", () => ({ $el: "div", if: "$marks" })), Ase = at("mark", () => ({ $el: "span", for: ["step", "index", "$marks"], attrs: { "data-active": { if: "$isMulti", then: { if: "$_value.0 < $_value.1", then: "$step.at >= $_value.0 && $step.at <= $_value.1", else: "$step.at >= $_value.1 && $step.at <= $_value.0" }, else: "$step.at <= $_value" }, class: { if: "$step.class", then: '$: $classes.mark + " " + $step.class', else: "$classes.mark" }, style: { left: '$: $fns.calculateMarkPosition($step.at) + "%"' } } })), Dse = at("markLabel", () => ({ $el: "span", if: "$markLabels", children: { if: "$step.label !== undefined", then: "$step.label", else: "" }, attrs: { class: '$: $classes.markLabel + " " + $step.labelClass' } })), Pse = at("handles", () => ({ $el: "ul" })), Ise = at("handleMax", () => ({ $el: "li", attrs: { "data-active": "$dragging", "data-is-target": '$lastHandleInteraction === "max"', "data-handle": "max", "data-show-tooltip": "$tooltip", class: "$: 'formkit-handle ' + $classes.handle + ' ' + $classes.handleMax", onFocus: "$handlers.focus", onClick: "$handlers.clickHandle", onMousedown: "$handlers.startDrag", onTouchstart: "$handlers.startDrag", style: "$maxHandleStyles", tabindex: { if: "$disabled", then: -1, else: 0 }, onBlur: "$handlers.blur", onKeydown: "$handlers.keydown" } })), Ese = at("handleMin", () => ({ $el: "li", if: "$isMulti", attrs: { "data-active": "$dragging", "data-is-target": '$lastHandleInteraction === "min"', "data-handle": "min", "data-show-tooltip": "$tooltip", class: "$: $classes.handle + ' ' + $classes.handleMin", onFocus: "$handlers.focus", onClick: "$handlers.clickHandle", onMousedown: "$handlers.startDrag", onTouchstart: "$handlers.startDrag", style: "$minHandleStyles", tabindex: { if: "$disabled", then: -1, else: 0 }, onBlur: "$handlers.blur", onKeydown: "$handlers.keydown" } })), Ose = at("handleMinInner", () => ({ $el: "div", attrs: { class: '$: $classes.handleInner + " " + $classes.handleMinInner' } })), xse = at("handleMaxInner", () => ({ $el: "div", attrs: { class: '$: $classes.handleInner + " " + $classes.handleMaxInner' } })), Mse = at("tooltipMax", () => ({ $el: "div", if: '$tooltip === true || $tooltip === "auto"', children: { if: "$isMulti", then: { if: "$_value.0 < $_value.1", then: '$tooltipFormat($_value.1, "max")', else: '$tooltipFormat($_value.0, "max")' }, else: '$tooltipFormat($_value, "max")' }, attrs: { class: "$classes.tooltip + ' ' + $classes.tooltipMax" } })), Lse = at("tooltipMin", () => ({ $el: "div", if: '$isMulti && ($tooltip === true || $tooltip === "auto")', children: { if: "$_value.0 < $_value.1", then: '$tooltipFormat($_value.0, "min")', else: '$tooltipFormat($_value.1, "min")' }, attrs: { class: "$classes.tooltip + ' ' + $classes.tooltipMin" } })), Nse = { schema: /* @__PURE__ */ cse(/* @__PURE__ */ use(/* @__PURE__ */ hse("$label"), /* @__PURE__ */ fse("$help"), /* @__PURE__ */ yse(/* @__PURE__ */ Lv("prefix"), /* @__PURE__ */ pse(), /* @__PURE__ */ $se(/* @__PURE__ */ gse(/* @__PURE__ */ bse()), /* @__PURE__ */ _se(/* @__PURE__ */ wse(/* @__PURE__ */ Cse(), /* @__PURE__ */ Tse(/* @__PURE__ */ Ase(/* @__PURE__ */ Dse())), /* @__PURE__ */ Pse(/* @__PURE__ */ Ese(/* @__PURE__ */ Lse(), /* @__PURE__ */ Ose()), /* @__PURE__ */ Ise(/* @__PURE__ */ Mse(), /* @__PURE__ */ xse()))))), /* @__PURE__ */ dse(), /* @__PURE__ */ Lv("suffix"), /* @__PURE__ */ ye("$showInput && $isMulti === false", /* @__PURE__ */ Nv())), /* @__PURE__ */ ye("$showInput && $isMulti", /* @__PURE__ */ kse(/* @__PURE__ */ Sse(), /* @__PURE__ */ Nv())), /* @__PURE__ */ mse(/* @__PURE__ */ vse("$message.value")))), type: "input", family: "", props: ["min", "max", "step", "showInput", "tooltip", "tooltipFormat", "inputAttrs", "maxInputAttrs", "minInputAttrs", "marks", "markLabels", "snapToMarks", "chart", "scalingFunction", "intervals"], features: [function(e) {
  let t, n, o;
  e.addProps(["isMulti", "maxHandleStyles", "minHandleStyles", "fillStyles", "decimals", "dragging", "lastHandleInteraction", "largestBar", "computedMaxInputAttrs", "computedMinInputAttrs"]);
  const s = { linear: { forward: (y) => y, reverse: (y) => y }, log: { forward: (y, $ = e.props.min, S = e.props.max) => S * Math.pow(y / S, 1.5), reverse: (y, $ = e.props.min, S = e.props.max) => S * Math.pow(y / S, 1 / 1.5) } };
  let a = !1;
  function r() {
    const y = document.activeElement;
    if (y instanceof HTMLInputElement) {
      const $ = y.value;
      y.value = "", y.value = $;
    }
  }
  function i(y) {
    if (!y) return;
    const $ = { disabled: y.props.disabled, min: typeof y.props.min == "number" ? y.props.min : 0, max: typeof y.props.max == "number" ? y.props.max : void 0, step: y.props.step || 1 };
    y.props.minInputAttrs = Object.assign(y.props.minInputAttrs || {}, $), y.props.maxInputAttrs = Object.assign(y.props.maxInputAttrs || {}, $), y.props.inputAttrs = y.props.inputAttrs && typeof y.props.inputAttrs == "object" ? Object.assign(y.props.inputAttrs, $) : $, y.props.computedMaxInputAttrs = y.props.maxInputAttrs && typeof y.props.maxInputAttrs == "object" ? Object.assign({}, y.props.inputAttrs, y.props.maxInputAttrs) : y.props.inputAttrs, y.props.computedMinInputAttrs = y.props.minInputAttrs && typeof y.props.minInputAttrs == "object" ? Object.assign({}, y.props.inputAttrs, y.props.minInputAttrs) : y.props.inputAttrs;
  }
  function l(y) {
    const { min: $, max: S, intervals: A } = e.props;
    if (y = Math.min(Math.max(y, 0), 100), !A || A.length === 0) {
      w();
      const D = $ + y / 100 * (S - $);
      return e.props.scalingFunction.reverse(D, $, S);
    }
    const I = u(A, $, S);
    for (let D = 0; D < I.length; D++) {
      const { value: O, step: x, left: F, width: P, stepsInInterval: E } = I[D];
      if (y >= F && y <= F + P) {
        const B = O + (y - F) / P * E * x, N = B % x;
        return g(N < x / 2 ? B - N : B + (x - N));
      }
    }
    return y > 100 ? S : y < 0 ? $ : void 0;
  }
  function c(y, $ = e.props.min, S = e.props.max) {
    const A = e.props.intervals;
    if (!A || A.length === 0)
      return w(), (e.props.scalingFunction.forward(y, $, S) - $) / (S - $) * 100;
    const I = u(A, $, S);
    for (let D = 0; D < I.length; D++) {
      const { value: O, step: x, left: F, width: P, stepsInInterval: E } = I[D], B = D < I.length - 1 ? I[D + 1].value : S;
      if (y >= O && y <= B)
        return 100 * ((F + (y - O) / x / E * P) / 100);
    }
    return 100;
  }
  function u(y, $ = e.props.min, S = e.props.max) {
    (y = [...y]).sort((D, O) => D.value - O.value), y[0].value !== $ && y.unshift({ value: $, step: e.props.step });
    let A = 0;
    for (let D = 0; D < y.length; D++) {
      const O = y[D].value, x = ((D < y.length - 1 ? y[D + 1].value : S) - O) / y[D].step;
      A += x;
    }
    let I = 0;
    return y.map((D, O) => {
      const x = D.value, F = ((O < y.length - 1 ? y[O + 1].value : S) - x) / D.step, P = I / A * 100;
      return I += F, { value: D.value, step: D.step, left: P, width: F / A * 100, stepsInInterval: F, totalSteps: A };
    });
  }
  function p() {
    const y = parseFloat(`${e.props.min}`), $ = parseFloat(`${e.props.max}`);
    let S, A = 0;
    if (Array.isArray(e._value)) {
      const I = [...e._value].sort(f);
      A = parseFloat(`${I[0]}`), S = parseFloat(`${I[1]}`);
    } else S = parseFloat(`${e._value}`);
    e.props.maxHandleStyles = { left: `${c(S, y, $)}%` }, e.props.isMulti && Array.isArray(e._value) ? (e.props.minHandleStyles = { left: `${c(A, y, $)}%` }, e.props.fillStyles = { left: `${c(A, y, $)}%`, width: c(S, y, $) - c(A, y, $) + "%" }) : e.props.fillStyles = { left: "0%", width: `${c(S, y, $)}%` };
  }
  function f(y, $) {
    return parseFloat(`${y}`) - parseFloat(`${$}`);
  }
  function m(y, $ = !0) {
    if (e.props.disabled) return;
    let S;
    if (y === void 0) {
      if (e.props.isMulti) e.input([_(e.props.min), _(e.props.max)]);
      else {
        const I = e.props.min + (e.props.max - e.props.min) / 2;
        e.input(_(I));
      }
      return void p();
    }
    if (e.props.isMulti && Array.isArray(e._value) && !Array.isArray(y)) {
      const I = e.props.lastHandleInteraction === "min" ? 0 : 1;
      e._value[I] = y;
      const [D, O] = [...e._value];
      if (D >= O) {
        const x = t == null ? void 0 : t.querySelector(`[data-handle="${e.props.lastHandleInteraction === "min" ? "max" : "min"}"]`);
        x == null || x.focus();
      }
      S = _([...e._value].sort(f));
    } else Array.isArray(y) ? S = _(y) : (S = _(y), S = isNaN(S) ? e.props.min : S);
    e.props.snapToMarks && (S = v(S));
    const A = _(h(S));
    $ && e.input(A), p();
  }
  function h(y) {
    return e.props.isMulti && Array.isArray(y) ? [h(y[0]), h(y[1])] : (y = isNaN(y) ? e.props.min : y, Math.min(Math.max(parseFloat(`${y}`), e.props.min), e.props.max));
  }
  function g(y) {
    return parseFloat(y.toFixed(e.props.decimals));
  }
  function _(y) {
    if (e.props.snapToMarks) return y;
    if (!e.props.intervals) return Array.isArray(y) ? y.map((S) => g(Math.round(S / e.props.step) * e.props.step)) : g(Math.round(y / e.props.step) * e.props.step);
    const $ = u(e.props.intervals);
    if (Array.isArray(y)) return y.map((S) => {
      const A = $.find((I, D) => {
        var O;
        return S >= I.value && S < (((O = $[D + 1]) === null || O === void 0 ? void 0 : O.value) || e.props.max);
      });
      return A ? g(A.value + Math.round((S - A.value) / A.step) * A.step) : S;
    });
    {
      const S = $.find((A, I) => {
        var D;
        return y >= A.value && y < (((D = $[I + 1]) === null || D === void 0 ? void 0 : D.value) || e.props.max);
      });
      return S ? g(S.value + Math.round((y - S.value) / S.step) * S.step) : y;
    }
  }
  function v(y) {
    if (Array.isArray(y)) return y[0] = v(y[0]), y[1] = v(y[1]), y;
    {
      const $ = e.props.marks;
      return $.reduce((A, I) => Math.abs(I.at - y) < Math.abs(A.at - y) ? I : A, $[0]).at;
    }
  }
  function w() {
    a || (_e(e.props.scalingFunction) ? typeof e.props.scalingFunction == "string" ? e.props.scalingFunction = s[e.props.scalingFunction] || s.linear : typeof e.props.scalingFunction == "object" && (e.props.scalingFunction = { ...s.linear, ...e.props.scalingFunction }) : e.props.scalingFunction = s.linear, a = !0);
  }
  e.props.maxHandleStyles = { left: "0%" }, e.props.fillStyles = { left: "0%", width: "0%" }, e.props.isMulti = !1, e.props.step = 1, e.props.min = 0, e.props.max = 100, e.props.tooltipFormat = typeof e.props.tooltipFormat == "function" ? e.props.tooltipFormat : (y, $) => {
    if ($) return y;
  }, e.props.largestBar = 0, "disabled" in e.props && (e.props.disabled = _e(e.props.disabled)), e.on("created", () => {
    var y;
    w(), e.props.isMulti = Array.isArray(e.value), e.props.step = parseFloat(`${e.props.step}`), e.props.decimals = ((y = e.props.step.toString().split(".")[1]) === null || y === void 0 ? void 0 : y.length) || 0, e.props.min = e.props.min ? parseFloat(`${e.props.min}`) : 0, e.props.max = e.props.max ? parseFloat(`${e.props.max}`) : 100;
    const $ = _e(e.props.tooltip);
    e.props.tooltip = e.props.tooltip === void 0 ? "auto" : $;
    const S = _e(e.props.marks);
    if (e.props.marks = !!S && (Array.isArray(e.props.marks) ? e.props.marks : function() {
      const { min: D, max: O, step: x } = e.props, F = [];
      for (let P = D; P <= O; P += x) F.push({ at: P, label: P });
      return F;
    }()), e.props.markLabels = _e(e.props.markLabels), e.props.snapToMarks = _e(e.props.snapToMarks), e.props.showInput = _e(e.props.showInput), e.props.largestBar = e.props.chart ? e.props.chart.reduce((D, O) => O.value > D ? O.value : D, 0) : e.props.largestBar, i(e), it(`track-${e.props.id}`, () => {
      var D;
      t = (D = e.props.__root) === null || D === void 0 ? void 0 : D.getElementById(`track-${e.props.id}`), m(e.value, !1), p();
    }, e.props.__root), e.context) {
      let D = 0, O = "";
      const x = e.context.handlers.blur;
      e.context.handlers.blur = (F) => {
        x(F), e.emit("blur");
      }, e.context.handlers.clickTrack = (F) => {
        if (!t) return;
        e.props.dragging = !1;
        const { left: P, width: E } = t.getBoundingClientRect(), B = (F.clientX - P) / E;
        if (e.props.isMulti && Array.isArray(e.value)) {
          const [N, Y] = e.value, j = Math.abs(N - B * e.props.max) < Math.abs(Y - B * e.props.max) ? "min" : "max", ee = j === "min" ? 0 : 1;
          e.props.lastHandleInteraction = j, e.value[ee] = l(100 * B), m(e._value);
        } else m(l(100 * B));
      }, e.context.handlers.focus = (F) => {
        if (!t) return;
        const P = F.target.dataset.handle;
        P && (e.props.lastHandleInteraction = P);
      }, e.context.handlers.clickHandle = (F) => {
        F.stopPropagation(), e.props.attrs.onClick && e.props.attrs.onClick(F), e.props.dragging = !1, m(e._value);
      }, e.context.handlers.startDrag = (F) => {
        if (!t) return;
        e.props.dragging = !0;
        const P = F.type === "touchstart", E = P ? "touchmove" : "mousemove", B = P ? "touchend" : "mouseup";
        e.props.lastHandleInteraction = F.target.dataset.handle || e.props.lastHandleInteraction, document.addEventListener(E, I, { passive: !1 }), document.addEventListener(B, () => {
          e.context && (e.props.dragging = !1, document.removeEventListener(E, I), P && F.target instanceof HTMLElement && F.target.blur());
        });
      }, e.context.handlers.keydown = (F) => {
        if (["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", ".", "-"].includes(F.key)) {
          F.preventDefault(), clearTimeout(D), O += F.key;
          const P = O === "-" ? -1 : 1;
          D = window.setTimeout(() => {
            O !== "-" && m(parseFloat(O) * P), O = "";
          }, 350);
        }
        if (["ArrowLeft", "ArrowDown", "ArrowRight", "ArrowUp", "PageUp", "PageDown", "Home", "End"].includes(F.key)) {
          F.preventDefault();
          const P = e.props.lastHandleInteraction === "min" ? 0 : 1, E = Array.isArray(e._value) ? e._value[P] : e._value, B = function(N, Y) {
            if (!e.props.intervals) return e.props.step;
            const j = u(e.props.intervals);
            if (N >= e.props.max) return j[j.length - 1].step;
            let ee = j.find((te, ce) => {
              var H;
              return N >= te.value && N < (((H = j[ce + 1]) === null || H === void 0 ? void 0 : H.value) || e.props.max);
            });
            return ee ? (Y === -1 && N - ee.step < ee.value && (ee = j[j.indexOf(ee) - 1] || ee), ee.step) : e.props.step;
          }(E, ["ArrowLeft", "ArrowDown", "PageDown"].includes(F.key) ? -1 : 1);
          if (e.props.marks && e.props.snapToMarks) {
            const N = v(E), Y = e.props.marks.find((ce) => ce.at === N), j = e.props.marks.indexOf(Y), ee = ["ArrowLeft", "ArrowDown"].includes(F.key) ? -1 : 1, te = Math.min(Math.max(0, j + ee), e.props.marks.length - 1);
            return void m(e.props.marks[te].at);
          }
          if (F.metaKey) return void (F.key === "ArrowLeft" || F.key === "ArrowDown" ? m(e.props.min) : m(e.props.max));
          if (F.key === "Home") return void m(e.props.min);
          if (F.key === "End") return void m(e.props.max);
          ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(F.key) && m(E + (F.shiftKey ? 10 * B : B) * (["ArrowLeft", "ArrowDown"].includes(F.key) ? -1 : 1)), F.key === "PageUp" ? m(E + 10 * B) : F.key === "PageDown" && m(E - 10 * B);
        }
      }, e.context.handlers.maxNode = (F) => {
        o = F, F.hook.commit((P, E) => we(F.value, P) ? E(P) : (`${F.value}`.includes(".") && !`${P}`.includes(".") && r(), e.props.isMulti && Array.isArray(e.value) ? m([e.value[0], P]) : m(P), E(h(P))));
      }, e.context.handlers.minNode = (F) => {
        n = F, F.hook.commit((P, E) => we(F.value, P) ? E(P) : (`${F.value}`.includes(".") && !`${P}`.includes(".") && r(), e.props.isMulti && Array.isArray(e.value) ? m([P, e.value[1]]) : m(P), E(h(P))));
      }, e.context.handlers.inputBlur = () => {
        e.props.isMulti && Array.isArray(e._value) && m([...e._value].sort(f));
      }, e.context.fns.calculateMarkPosition = (F) => c(F, e.props.min, e.props.max);
    }
    let A;
    function I(D) {
      var O;
      if (!t || !e.props.dragging) return;
      D.preventDefault();
      const x = D.clientX || ((O = D.touches) === null || O === void 0 ? void 0 : O.length) && D.touches[0].clientX, { left: F, width: P } = t.getBoundingClientRect(), E = _(l((x - F) / P * 100));
      A !== E && (A = E, m(E));
    }
    m(e.value);
  }), e.on("input", ({ payload: y }) => {
    Array.isArray(e.value) && Array.isArray(y) ? e.value[0] === y[0] && e.value[1] === y[1] || m(y, !1) : e.value !== y && m(y, !1), function() {
      if (e.props.isMulti && Array.isArray(e._value)) {
        const [$, S] = [...e._value];
        n && n.input(g($)), o && o.input(g(S));
      } else o && o.input(e._value);
    }();
  }), e.on("prop:max", () => {
    e.props.max = e.props.max ? parseFloat(`${e.props.max}`) : 100, m(e.value), i(e);
  }), e.on("prop:min", () => {
    e.props.min = e.props.min ? parseFloat(`${e.props.min}`) : 0, m(e.value), i(e);
  });
}] }, qe = /* @__PURE__ */ Lt("cp"), { outer: Fse, wrapper: Rse, inner: Vse, label: Bse, prefix: Hse, suffix: Use, help: Fv, messages: zse, message: Wse, icon: ka } = /* @__PURE__ */ Nt(qe), jse = qe("swatchPreview", () => ({ $el: "div", attrs: { id: "$id", class: "$classes.swatchPreview", tabindex: { if: "$disabled", then: -1, else: 0 }, onClick: "$handlers.inputPreviewClick", onFocusout: "$handlers.inputPreviewFocusout", onKeydown: "$handlers.inputPreviewKeydown", role: "button", "aria-valuetext": '$: "Current color: " + $value' } })), qse = qe("valueString", () => ({ $el: "span", attrs: { class: "$classes.valueString" }, children: { if: '$format === "hex"', then: "$hex", else: { if: '$format === "rgba"', then: "$rgbaString", else: { if: '$format === "hsla"', then: "$hslaString", else: "" } } } })), Kse = qe("panel", () => ({ $el: "div", attrs: { id: '$: $id + "_popover"', class: "$classes.panel", onKeydown: "$handlers.panelKeydown", "aria-role": { if: "$layout === popover", then: "dialog" }, "aria-modal": { if: "$layout === popover", then: "true" }, "aria-label": "$label", popover: "$popover", style: { if: "$usePopover", then: { margin: 0, top: '$popoverCoordinates.y + "px"', left: '$popoverCoordinates.x + "px"' }, else: { position: { if: "$inline === undefined || $inline === false", then: "absolute" } } } } })), Yse = qe("panelClose", () => ({ $el: "button", attrs: { type: "button", class: "$classes.panelClose", onClick: "$handlers.closePanel", tabindex: { if: "$showPanelClose", then: -1, else: 0 }, onKeydown: "$handlers.panelCloseKeydown", "aria-label": "$ui.close.value" } })), Gse = qe("controlGroup", () => ({ $el: "div", attrs: { class: "$classes.controlGroup", "data-eye-dropper": "$hasNativeEyeDropper && $eyeDropper", role: "group" } })), Zse = qe("LS", () => ({ $el: "div", attrs: { class: "$classes.LS" } })), Xse = qe("canvasLS", () => ({ $el: "canvas", attrs: { id: '$: "canvas-ls-" + $id', class: '$classes.canvas + " " + $classes.canvasLS', width: 256, height: 256, "aria-hidden": "true" } })), Jse = qe("controlLS", () => ({ $el: "div", attrs: { tabindex: { if: "$disabled", then: -1, else: 0 }, class: '$classes.control + " " + $classes.controlLS', onKeydown: "$handlers.lsKeydown", style: { left: '$controlLSPosition.x + "%"', top: '$controlLSPosition.y + "%"', backgroundColor: '$: "hsl(" + $hsla.h + "deg, " + ($hsla.s / 255) * 100 + "%, " + ($hsla.l / 255) * 100 + "%)"' }, role: "slider", "aria-valuemin": 0, "aria-valuemax": 1, "aria-valuetext": '$: "Lightness: " + $hslaPercent.l + "%, Saturation: " + $hslaPercent.s + "%"' } })), Qse = qe("hue", () => ({ $el: "div", attrs: { class: "$classes.hue" } })), eae = qe("canvasHue", () => ({ $el: "canvas", attrs: { id: '$: "canvas-hue-" + $id', class: '$classes.canvas + " " + $classes.canvasHue', width: 256, height: 10, "aria-hidden": "true" } })), tae = qe("controlHue", () => ({ $el: "div", attrs: { tabindex: { if: "$disabled", then: -1, else: 0 }, onKeydown: "$handlers.hueControlKeydown", class: '$classes.control + " " + $classes.controlHue', style: { left: '$: "min(max(" + (($hsla.h / 360) * 100) + "%, 3px), calc(100% - 3px))"', backgroundColor: '$: "hsl(" + $hsla.h + "deg, 100%, 50%)"' }, role: "slider", "aria-valuemin": 0, "aria-valuemax": 360, "aria-valuenow": "$h" } })), nae = qe("alpha", () => ({ $el: "div", attrs: { class: "$classes.alpha", style: { opacity: { if: "$alpha", then: "1", else: "0.5" }, cursor: { if: "$alpha", then: "", else: "not-allowed" }, filter: { if: "$alpha", then: "", else: "grayscale(1)" } } } })), oae = qe("canvasAlpha", () => ({ $el: "canvas", attrs: { id: '$: "canvas-alpha-" + $id', class: '$classes.canvas + " " + $classes.canvasAlpha', width: 256, height: 10, "aria-hidden": "true", style: { pointerEvents: { if: "$alpha", then: "auto", else: "none" } } } })), sae = qe("controlAlpha", () => ({ $el: "div", attrs: { tabindex: { if: "$disabled || $alpha === undefined", then: -1, else: 0 }, onKeydown: "$handlers.alphaControlKeydown", class: '$classes.control + " " + $classes.controlAlpha', style: { left: '$: "min(max(" + ($hsla.a * 100) + "%, 3px), calc(100% - 3px))"', backgroundImage: '$: "linear-gradient(to right, hsla(" + $hsla.h + "deg, " + ($hsla.s / 255) * 100 + "%, " + ($hsla.l / 255) * 100 + "%, " + $hsla.a + "), hsla(" + $hsla.h + "deg, " + ($hsla.s / 255) * 100 + "%, " + ($hsla.l / 255) * 100 + "%, " + $hsla.a + ")), linear-gradient(to right, white, white)"', pointerEvents: { if: "$alpha", then: "auto", else: "none" } }, role: "slider", "aria-valuemin": 0, "aria-valuemax": 1, "aria-valuenow": "$hsla.a" } })), aae = qe("preview", () => ({ $el: "div", attrs: { class: "$classes.preview" } })), rae = qe("canvasPreview", () => ({ $el: "canvas", attrs: { id: '$: "canvas-preview-" + $id', class: '$classes.canvas + " " + $classes.canvasPreview', width: 33, height: 33, "aria-hidden": "true" } })), iae = qe("canvasSwatchPreview", () => ({ $el: "div", attrs: { class: "$classes.canvasSwatchPreviewWrapper" }, children: [{ $el: "canvas", attrs: { id: '$: "canvas-swatch-preview-" + $id', class: '$classes.canvas + " " + $classes.canvasSwatchPreview', width: 33, height: 33, "aria-hidden": "true" } }] })), lae = qe("eyeDropper", () => ({ $el: "div", attrs: { tabindex: { if: "$disabled", then: -1, else: 0 }, role: "button", onKeydown: "$handlers.eyeDropperKeydown", id: '$: "eye-dropper-" + $id', class: "$classes.eyeDropper" } })), cae = qe("formatField", () => ({ $el: "div", attrs: { class: "$classes.formatField" } })), uae = qe("colorInputGroup", () => ({ $el: "div", attrs: { class: "$classes.colorInputGroup", "aria-role": "group" } })), pae = qe("hexField", () => ({ $el: "div", attrs: { class: '$classes.fieldGroup + " " + $classes.hexFieldGroup' }, children: [{ $el: "input", attrs: { onInput: "$handlers.hexInput", onKeydown: "$handlers.hexKeydown", onFocus: "$handlers.hexFocus", onBlur: "$handlers.hexBlur", id: '$: "hex-" + $id', tabindex: { if: "$disabled", then: -1, else: 0 }, disabled: "$disabled", class: '$classes.colorField + " " + $classes.hexField', value: "$hex", autocomplete: "off" } }, { $el: "label", children: "HEX", attrs: { for: '$: "hex-" + $id', class: "$classes.fieldLabel" } }] })), dae = qe("rField", () => ({ $el: "div", attrs: { class: '$classes.fieldGroup + " " + $classes.rFieldGroup' }, children: [{ $el: "input", attrs: { id: '$: "r-" + $id', onInput: '$handlers.rangeLimitInput("rgba", 0, 255)', onKeydown: '$handlers.rangeLimitKeydown("rgba", 0, 255, 1)', type: "number", class: '$classes.colorField + " " + $classes.rField', min: 0, max: 255, step: 1, tabindex: { if: "$disabled", then: -1, else: 0 }, disabled: "$disabled", value: "$rgba.r", autocomplete: "off" } }, { $el: "label", children: "R", attrs: { for: '$: "r-" + $id', class: "$classes.fieldLabel" } }] })), fae = qe("gField", () => ({ $el: "div", attrs: { class: '$classes.fieldGroup + " " + $classes.gFieldGroup' }, children: [{ $el: "input", attrs: { id: '$: "g-" + $id', onInput: '$handlers.rangeLimitInput("rgba", 0, 255)', onKeydown: '$handlers.rangeLimitKeydown("rgba", 0, 255, 1)', type: "number", class: '$classes.colorField + " " + $classes.gField', min: 0, max: 255, step: 1, tabindex: { if: "$disabled", then: -1, else: 0 }, disabled: "$disabled", value: "$rgba.g", autocomplete: "off" } }, { $el: "label", children: "G", attrs: { for: '$: "g-" + $id', class: "$classes.fieldLabel" } }] })), mae = qe("bField", () => ({ $el: "div", attrs: { class: '$classes.fieldGroup + " " + $classes.bFieldGroup' }, children: [{ $el: "input", attrs: { id: '$: "b-" + $id', onInput: '$handlers.rangeLimitInput("rgba", 0, 255)', onKeydown: '$handlers.rangeLimitKeydown("rgba", 0, 255, 1)', type: "number", class: '$classes.colorField + " " + $classes.bField', min: 0, max: 255, step: 1, tabindex: { if: "$disabled", then: -1, else: 0 }, disabled: "$disabled", value: "$rgba.b", autocomplete: "off" } }, { $el: "label", children: "B", attrs: { for: '$: "b-" + $id', class: "$classes.fieldLabel" } }] })), vae = qe("aField", () => ({ $el: "div", attrs: { class: '$classes.fieldGroup + " " + $classes.aFieldGroup' }, children: [{ $el: "input", attrs: { id: '$: "a-" + $id', onInput: '$handlers.rangeLimitInput("alpha", 0, 1)', onKeydown: '$handlers.rangeLimitKeydown("alpha", 0, 1, 0.01)', type: "text", class: '$classes.colorField + " " + $classes.aField', value: "$rgba.a", tabindex: { if: "$disabled", then: -1, else: 0 }, disabled: "$disabled || $alpha === undefined", autocomplete: "off", style: { opacity: { if: "$alpha", then: "1", else: "0.33" }, cursor: { if: "$alpha", then: void 0, else: "not-allowed" } }, "aria-valuemin": 0, "aria-valuemax": 1, "aria-valuenow": "$rgba.a" } }, { $el: "label", children: "A", attrs: { for: '$: "a-" + $id', class: "$classes.fieldLabel", style: { opacity: { if: "$alpha", then: "1", else: "0.33" } } } }] })), hae = qe("hField", () => ({ $el: "div", attrs: { class: '$classes.fieldGroup + " " + $classes.hFieldGroup' }, children: [{ $el: "input", attrs: { id: '$: "h-" + $id', onInput: '$handlers.rangeLimitInput("hsla", 0, 360)', onKeydown: '$handlers.rangeLimitKeydown("hsla", 0, 360, 1)', type: "text", class: '$classes.colorField + " " + $classes.hField', tabindex: { if: "$disabled", then: -1, else: 0 }, disabled: "$disabled", value: "$hslaPercent.h", autocomplete: "off", "aria-valuemin": 0, "aria-valuemax": 360, "aria-valuenow": "$hsla.h" } }, { $el: "label", children: "H", attrs: { for: '$: "h-" + $id', class: "$classes.fieldLabel" } }] })), gae = qe("sField", () => ({ $el: "div", attrs: { class: '$classes.fieldGroup + " " + $classes.sFieldGroup' }, children: [{ $el: "input", attrs: { id: '$: "s-" + $id', onInput: '$handlers.rangeLimitInput("hsla", 0, 100)', onKeydown: '$handlers.rangeLimitKeydown("hsla", 0, 100, 1)', type: "text", class: '$classes.colorField + " " + $classes.sField', tabindex: { if: "$disabled", then: -1, else: 0 }, value: "$hslaPercent.s", autocomplete: "off", "aria-valuemin": 0, "aria-valuemax": 100, "aria-valuenow": "$hsla.s" } }, { $el: "label", children: "S", attrs: { for: '$: "s-" + $id', class: "$classes.fieldLabel" } }] })), bae = qe("lField", () => ({ $el: "div", attrs: { class: '$classes.fieldGroup + " " + $classes.lFieldGroup' }, children: [{ $el: "input", attrs: { id: '$: "l-" + $id', onInput: '$handlers.rangeLimitInput("hsla", 0, 100)', onKeydown: '$handlers.rangeLimitKeydown("hsla", 0, 100, 1)', type: "text", class: '$classes.colorField + " " + $classes.lField', tabindex: { if: "$disabled", then: -1, else: 0 }, disabled: "$disabled", value: "$hslaPercent.l", autocomplete: "off", "aria-valuemin": 0, "aria-valuemax": 100, "aria-valuenow": "$hsla.l" } }, { $el: "label", children: "L", attrs: { for: '$: "l-" + $id', class: "$classes.fieldLabel" } }] })), yae = qe("formatSwitcher", () => ({ $el: "div", attrs: { class: "$classes.formatSwitcher", onClick: "$handlers.toggleFormat", tabindex: { if: "$disabled", then: -1, else: 0 }, onKeydown: "$handlers.formatSwitcherKeydown", role: "button", "aria-label": "$ui.next.value" } })), $ae = qe("swatches", () => ({ $el: "div", attrs: { id: '$: "swatches-" + $id', class: "$classes.swatches", "data-keyboard-nav": "$swatchIsUsingKeyboardNav" } })), _ae = qe("swatch", () => ({ $el: "div", for: ["swatch", "index", "$options"], if: "$swatch", attrs: { if: "$swatch.group", then: { class: "$classes.swatchGroup" }, else: { class: "$classes.swatch", title: "$swatch.label" } }, children: { if: "$swatch.group", then: [{ $el: "span", attrs: { class: "$classes.swatchGroupLabel" }, children: "$swatch.group" }, { $el: "div", for: ["groupSwatch", "swatchIndex", "$swatch.options"], attrs: { class: "$classes.swatch", title: "$groupSwatch.label" }, children: [{ $el: "canvas", attrs: { class: "$classes.swatchCanvas", width: 21, height: 21, onClick: "$handlers.swatchClick", onKeydown: "$handlers.swatchKeydown", tabindex: { if: "$: ($focusedSwatch === $fns.anyToHsvaString($groupSwatch.value, 0))", then: { if: "$disabled", then: -1, else: 0 }, else: -1 }, key: '$groupSwatch.label + "-" + $groupSwatch.value', "data-color": "$fns.anyToHsvaString($groupSwatch.value, 0)", "data-color-precise": "$fns.anyToHsvaString($groupSwatch.value, 2)", "data-group": "$index", "data-label": "$swatch.label", role: "button", "aria-label": "$swatch.label" } }] }], else: { $el: "canvas", attrs: { class: "$classes.swatchCanvas", width: 21, height: 21, onClick: "$handlers.swatchClick", onKeydown: "$handlers.swatchKeydown", tabindex: { if: "$: ($focusedSwatch === $fns.anyToHsvaString($swatch.value, 0))", then: { if: "$disabled", then: -1, else: 0 }, else: -1 }, key: '$swatch.label + "-" + $swatch.value', "data-color": "$fns.anyToHsvaString($swatch.value, 0)", "data-color-precise": "$fns.anyToHsvaString($swatch.value, 2)", "data-group": 0, "data-label": "$swatch.label", role: "button", "aria-label": "$swatch.label" } } } })), j0 = /rgba?\((\d+%?)\s*(?:,?\s*|\s+)(\d+%?)\s*(?:,?\s*|\s+)(\d+%?)(?:\s*(?:,?\s*|\s+|\/\s*)(\d*(?:\.\d+)?%?))?\)/i, q0 = /^hsla?\((\d{1,3}deg|[\d.]+)\s*,?\s*([\d.]+%)\s*,?\s*([\d.]+%)(?:\s*,?\s*([\d.]+%?))?\)$/i;
function Le(e, t) {
  const n = Math.pow(10, t);
  return Math.round(e * n) / n;
}
function Yu(e) {
  const [t, n, o, s] = function(a) {
    a = a.replace("#", ""), a.length === 3 && (a = a[0] + a[0] + a[1] + a[1] + a[2] + a[2]);
    const r = parseInt(a.slice(0, 2), 16), i = parseInt(a.slice(2, 4), 16), l = parseInt(a.slice(4, 6), 16), c = a.length >= 8 ? parseInt(a.slice(6, 8), 16) / 255 : 1;
    return function(u, p, f, m = 1) {
      const h = u / 255, g = p / 255, _ = f / 255, v = Math.max(h, g, _), w = Math.min(h, g, _);
      let y, $ = 0;
      const S = (v + w) / 2;
      if (v === w) $ = y = 0;
      else {
        const A = v - w;
        switch (y = S > 0.5 ? A / (2 - v - w) : A / (v + w), v) {
          case h:
            $ = (g - _) / A + (g < _ ? 6 : 0);
            break;
          case g:
            $ = (_ - h) / A + 2;
            break;
          case _:
            $ = (h - g) / A + 4;
        }
        $ *= 60;
      }
      return [$, 255 * y, 255 * S, m];
    }(r, i, l, c);
  }(e);
  return [...Ad(t, n, o, s)];
}
function Rv(e, t, n, o = 1) {
  const s = t / 100, a = n / 100, r = (2 - s) * a / 2;
  return r !== 0 && (r === 1 || (t = r < 0.5 ? s * a / (2 * r) : s * a / (2 - 2 * r))), [e, Le(255 * t, 2), Le(255 * r, 2), o];
}
function Ad(e, t, n, o = 1) {
  const s = Le(t / 255, 4), a = Le(n / 255, 4);
  if (a === 1) return [e, 0, 100, o];
  const r = Le(a + s * Math.min(a, 1 - a), 4);
  let i = t / 2.55;
  return r !== 0 && (i = a !== 1 && a !== 0 ? 2 * (r - a) / r * 100 : t / 2.55), [e, Le(i, 2), Le(100 * r, 2), o];
}
function K0(e, t, n, o = 1) {
  const s = n / 100, a = s * (t / 100), r = a * (1 - Math.abs(e / 60 % 2 - 1)), i = s - a;
  let l = 0, c = 0, u = 0;
  return [l, c, u] = e < 60 ? [a, r, 0] : e < 120 ? [r, a, 0] : e < 180 ? [0, a, r] : e < 240 ? [0, r, a] : e < 300 ? [r, 0, a] : [a, 0, r], l = Math.round(255 * (l + i)), c = Math.round(255 * (c + i)), u = Math.round(255 * (u + i)), [Math.min(Math.max(l, 0), 255), Math.min(Math.max(c, 0), 255), Math.min(Math.max(u, 0), 255), o];
}
function Y0(e, t, n, o = 1) {
  const s = e / 255, a = t / 255, r = n / 255, i = Math.max(s, a, r), l = Math.min(s, a, r);
  let c = 0;
  const u = i, p = i - l, f = i === 0 ? 0 : p / i;
  if (i !== l) {
    switch (i) {
      case s:
        c = (a - r) / p + (a < r ? 6 : 0);
        break;
      case a:
        c = (r - s) / p + 2;
        break;
      case r:
        c = (s - a) / p + 4;
    }
    c /= 6;
  }
  return [360 * c, 100 * f, 100 * u, o];
}
function wae(e, t, n, o = 1) {
  const [s, a, r, i] = K0(e, t, n, o);
  return function(l, c, u, p = 1) {
    const f = (h) => Math.round(h).toString(16).padStart(2, "0").toUpperCase(), m = function(h) {
      return Math.round(255 * h).toString(16).padStart(2, "0").toUpperCase();
    }(p);
    return "#" + f(l) + f(c) + f(u) + `${m === "FF" ? "" : m}`;
  }(s, a, r, i);
}
function ws(e) {
  return /^(#?)([A-Fa-f0-9]{3}|[A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/.test(e);
}
function Gc(e) {
  if (e) {
    if (ws(e)) return Yu(e);
    if (e.startsWith("rgb")) {
      const t = e.match(j0);
      if (!t) return [0, 0, 0, 1];
      const n = (o) => o.endsWith("%") ? Math.round(2.55 * Number(o.slice(0, -1))) : Number(o);
      return Y0(n(t[1]), n(t[2]), n(t[3]), t[4] ? t[4].endsWith("%") ? Number(t[4].slice(0, -1)) / 100 : Number(t[4]) : 1);
    }
    if (e.startsWith("hsl")) {
      const t = e.match(q0);
      if (!t) return [0, 0, 0, 1];
      const n = Number(t[1].replace("deg", "").trim()), o = Number(t[2].slice(0, -1)) / 100, s = Number(t[3].slice(0, -1)) / 100, a = t[4] ? t[4].endsWith("%") ? Number(t[4].slice(0, -1)) / 100 : Number(t[4]) : 1;
      return Ad(n, Le(255 * o, 2), Le(255 * s, 2), a);
    }
  }
}
function Vv(e) {
  const [t, n, o, s] = e.split("-").map((a) => Number(a));
  return [t, n, o, s];
}
function hs(e, t = 150, n = !0) {
  let o = null, s = !0;
  return (...a) => {
    const r = () => {
      e(...a), o = null;
    };
    n && s && (s = !1, r()), o || (o = setTimeout(r, t));
  };
}
function Sa(e) {
  return e !== !1 && e !== "false";
}
function Cae(e) {
  return e.tabIndex >= 0 && !e.disabled && e.offsetParent !== null;
}
const Bv = { "canvas-ls": "LS", "canvas-hue": "Hue", "canvas-alpha": "Alpha" }, kae = { schema: /* @__PURE__ */ Fse(/* @__PURE__ */ Rse(/* @__PURE__ */ Bse("$label"), /* @__PURE__ */ ye("$inline && $help", /* @__PURE__ */ Fv("$help")), /* @__PURE__ */ Vse(/* @__PURE__ */ ye("($inline === undefined || $inline === false) && $prefixIcon !== undefined", /* @__PURE__ */ ka("prefix", "label")), /* @__PURE__ */ ye("$inline === undefined || $inline === false", /* @__PURE__ */ Hse()), /* @__PURE__ */ ye("$inline === undefined || $inline === false", /* @__PURE__ */ jse(/* @__PURE__ */ iae(), /* @__PURE__ */ ye("$showValue", /* @__PURE__ */ qse()))), /* @__PURE__ */ ye("$inline || $expanded)", /* @__PURE__ */ Kse(/* @__PURE__ */ ye("$showPanelClose && ($inline === undefined || $inline === false)", /* @__PURE__ */ Yse(/* @__PURE__ */ ka("close"))), /* @__PURE__ */ ye("$panelControls", /* @__PURE__ */ Gse(/* @__PURE__ */ Zse(/* @__PURE__ */ Xse(), /* @__PURE__ */ Jse()), /* @__PURE__ */ aae(/* @__PURE__ */ rae()), /* @__PURE__ */ Qse(/* @__PURE__ */ eae(), /* @__PURE__ */ tae()), /* @__PURE__ */ nae(/* @__PURE__ */ oae(), /* @__PURE__ */ sae()), /* @__PURE__ */ ye("$eyeDropper && $hasNativeEyeDropper", /* @__PURE__ */ lae(/* @__PURE__ */ ka("eyeDropper"))))), /* @__PURE__ */ ye("$panelFormat", /* @__PURE__ */ cae(/* @__PURE__ */ uae(/* @__PURE__ */ ye('$panelActiveFormat === "hex"', /* @__PURE__ */ pae()), /* @__PURE__ */ ye('$panelActiveFormat === "rgba"', /* @__PURE__ */ dae()), /* @__PURE__ */ ye('$panelActiveFormat === "rgba"', /* @__PURE__ */ fae()), /* @__PURE__ */ ye('$panelActiveFormat === "rgba"', /* @__PURE__ */ mae()), /* @__PURE__ */ ye('$panelActiveFormat === "hsla"', /* @__PURE__ */ hae()), /* @__PURE__ */ ye('$panelActiveFormat === "hsla"', /* @__PURE__ */ gae()), /* @__PURE__ */ ye('$panelActiveFormat === "hsla"', /* @__PURE__ */ bae()), /* @__PURE__ */ ye('$panelActiveFormat === "rgba" || $panelActiveFormat === "hsla"', /* @__PURE__ */ vae())), /* @__PURE__ */ yae(/* @__PURE__ */ ka("switch")))), /* @__PURE__ */ ye("$options", /* @__PURE__ */ $ae(/* @__PURE__ */ _ae())))), /* @__PURE__ */ ye("$inline === undefined || $inline === false", /* @__PURE__ */ Use()), /* @__PURE__ */ ye("($inline === undefined || $inline === false) && $suffixIcon !== undefined", /* @__PURE__ */ ka("suffix"))), /* @__PURE__ */ ye("$: ($inline === undefined || $inline === false) && $help", /* @__PURE__ */ Fv("$help"))), /* @__PURE__ */ zse(/* @__PURE__ */ Wse("$message.value"))), type: "input", family: "text", props: ["disbaled", "format", "valueFormat", "alpha", "panelControls", "panelFormat", "eyeDropper", "inline", "options", "showValue", "closeOnSelect", "allowPaste"], features: [
  function(e) {
    let t, n = null, o = null, s = null, a = null, r = null, i = null, l = null, c = 0;
    const u = ["hex", "rgba", "hsla"], p = hs(function() {
      if (!o) return;
      const U = o.getContext("2d");
      if (!U) return;
      const { width: Q, height: z } = o, Z = e.props.h || 0;
      U.fillStyle = `hsl(${Z}, 100%, 50%)`, U.fillRect(0, 0, Q, z);
      const W = U.createLinearGradient(0, 0, Q, 0);
      W.addColorStop(0, "rgba(255, 255, 255, 1)"), W.addColorStop(1, "rgba(255, 255, 255, 0)"), U.fillStyle = W, U.fillRect(0, 0, Q, z);
      const X = U.createLinearGradient(0, 0, 0, z);
      X.addColorStop(0, "rgba(0,0,0,0)"), X.addColorStop(1, "rgba(0,0,0,1)"), U.fillStyle = X, U.fillRect(0, 0, Q, z);
    }, 2), f = hs(function() {
      if (!a) return;
      const U = a.getContext("2d");
      if (!U) return;
      const Q = Math.round(a.width), z = Math.round(a.height);
      U.clearRect(0, 0, Q, z), ee(a, z / 2);
      const Z = e.props.rgba.r || 0, W = e.props.rgba.g || 0, X = e.props.rgba.b || 0, G = U.createLinearGradient(0, 0, Q, 0);
      G.addColorStop(0, `rgba(${Z}, ${W}, ${X}, 0)`), G.addColorStop(1, `rgba(${Z}, ${W}, ${X}, 1)`), U.fillStyle = G, U.fillRect(0, 0, Q, z);
    }, 2), m = hs(F, 2), h = hs(P, 2), g = hs(H, 2), _ = hs(te, 10, !1);
    function v(U) {
      var Q, z;
      if (!e.context || !e.props.allowPaste || e.props.disabled) return;
      const Z = (Q = e.props.__root) === null || Q === void 0 ? void 0 : Q.activeElement;
      if (n && n.contains(Z)) {
        const W = (z = U.clipboardData) === null || z === void 0 ? void 0 : z.getData("text");
        if (!W || Z.tagName === "INPUT" && !ws(W) && !j0.test(W) && !q0.test(W)) return;
        (ws(W) || W.startsWith("hsl") || W.startsWith("rgb")) && (e.props.hexInputFocused && (e.props.hexInputFocused = !1, setTimeout(() => {
          e.props.hexInputFocused = !0;
        }, 10)), U.preventDefault(), w(W));
      }
    }
    function w(U) {
      var Q;
      if (!U) return;
      const z = Gc(U);
      if (z) {
        const [Z, W, X, G] = z;
        U !== "undefined" && (typeof Z != "number" || isNaN(Z) || typeof W != "number" || isNaN(W) || typeof X != "number" || isNaN(X) || typeof G != "number" || isNaN(G) || Le(Z, 2) === e.props.h && Le(W, 2) === e.props.s && Le(X, 2) === e.props.v && Le(G, 2) === e.props.a) || (e.props.alpha && (e.props.a = Le(G, 2)), H(Z, W, X));
      } else {
        const Z = (Q = e.props.options) === null || Q === void 0 ? void 0 : Q.find((W) => {
          var X;
          return ((X = W.label) === null || X === void 0 ? void 0 : X.toLowerCase()) === U.toLowerCase();
        });
        if (Z && Z.value) {
          const W = Gc(Z.value);
          if (W) {
            const [X, G, se, pe] = W;
            e.props.alpha && (e.props.a = Le(pe, 2)), H(X, G, se);
          } else H(e.props.h, e.props.s, e.props.v);
        } else H(e.props.h, e.props.s, e.props.v);
      }
    }
    function y(U) {
      if (!e.context || !l) return;
      const Q = l[U];
      Q && (e.props.focusedSwatch = Q.dataset.color);
    }
    function $(U, Q) {
      new ResizeObserver(() => {
        const z = U.getBoundingClientRect();
        U.width = Math.round(z.width), U.height = Math.round(z.height), Q(U);
      }).observe(U);
    }
    function S() {
      e.context && e.props.eyeDropper && (e.context.hasNativeEyeDropper = !(typeof window > "u" || !window.EyeDropper), it(`eye-dropper-${e.props.id}`, () => {
        var U;
        const Q = new window.EyeDropper(), z = (U = e.props.__root) === null || U === void 0 ? void 0 : U.getElementById(`eye-dropper-${e.props.id}`);
        z == null || z.addEventListener("click", async () => {
          const Z = await Q.open();
          if (!Z.sRGBHex) return;
          const [W, X, G] = Yu(Z.sRGBHex);
          e.props.alpha && (e.props.a = 1), H(W, X, G);
        });
      }, e.props.__root));
    }
    function A() {
      I("canvas-ls", (U) => {
        o = U;
      }, p, N), I("canvas-hue", (U) => {
        s = U;
      }, x, Y), I("canvas-alpha", (U) => {
        a = U;
      }, f, j), D(`canvas-preview-${e.props.id}`, (U) => {
        r = U, F();
      }, m), D(`canvas-swatch-preview-${e.props.id}`, (U) => {
        i = U, P();
      }, h), O();
    }
    function I(U, Q, z, Z) {
      let W = !1;
      const X = () => {
        document.removeEventListener("mousemove", G), document.removeEventListener("mouseup", pe), document.removeEventListener("touchmove", se), document.removeEventListener("touchend", J);
      }, G = (ae) => {
        ae.buttons === 1 && t && Z(ae);
      }, se = (ae) => {
        t && Z(ae);
      }, pe = () => {
        t = void 0, X();
      }, J = () => {
        t = void 0, X();
      };
      D(`${U}-${e.props.id}`, (ae) => {
        const re = ae.nextElementSibling;
        Q(ae), z(), function(ge, Ie) {
          const je = (Ve) => {
            ge && (Ve.preventDefault(), Ie(Ve));
          };
          ge == null || ge.addEventListener("mousedown", je), ge == null || ge.addEventListener("touchstart", je);
        }(ae, Z), W || function(ge, Ie) {
          W = !0, ge.addEventListener("blur", () => {
            ge.removeAttribute("data-prevent-focus-style");
          }), Ie.addEventListener("touchend", () => {
            ge.removeAttribute("data-prevent-focus-style"), ge.blur();
          }), ge.addEventListener("keydown", (je) => {
            ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(je.key) && ge.removeAttribute("data-prevent-focus-style");
          });
        }(re, ae), ae.addEventListener("mousedown", (ge) => {
          re.focus(), re.setAttribute("data-prevent-focus-style", "true"), t = Bv[U], Z(ge), document.addEventListener("mousemove", G), document.addEventListener("mouseup", pe);
        }), ae.addEventListener("touchstart", () => {
          re.setAttribute("data-prevent-focus-style", "true"), re.focus(), t = Bv[U], document.addEventListener("touchmove", se), document.addEventListener("touchend", J);
        });
      }, z);
    }
    function D(U, Q, z) {
      it(U, () => {
        var Z;
        const W = (Z = e.props.__root) === null || Z === void 0 ? void 0 : Z.getElementById(U);
        W && (Q(W), z && $(W, z));
      }, e.props.__root);
    }
    function O() {
      it(`swatches-${e.props.id}`, () => {
        var U, Q, z;
        l = Array.from(((U = e.props.__root) === null || U === void 0 ? void 0 : U.querySelectorAll(`#swatches-${e.props.id} canvas`)) || []), l.forEach((Z) => {
          $(Z, E);
        }), e.props.focusedSwatch = (z = (Q = l[0]) === null || Q === void 0 ? void 0 : Q.dataset) === null || z === void 0 ? void 0 : z.color, te();
      }, e.props.__root);
    }
    function x() {
      if (!s) return;
      const U = s.getContext("2d");
      if (!U) return;
      const Q = s.width, z = s.height;
      for (let Z = 0; Z < Q; Z++) {
        const W = Math.floor(Z / Q * 360);
        U.fillStyle = `hsl(${W}, 100%, 50%)`, U.fillRect(Z, 0, 1, z);
      }
    }
    function F() {
      if (!r) return;
      const U = r.getContext("2d");
      if (!U) return;
      ee(r, r.width / 3);
      const { r: Q, g: z, b: Z, a: W } = e.props.rgba;
      U.fillStyle = `rgba(${Q}, ${z}, ${Z}, ${W})`, U.fillRect(0, 0, r.width, r.height);
    }
    function P() {
      if (!i) return;
      const U = i.getContext("2d");
      if (!U) return;
      ee(i, i.height / 2);
      const { r: Q, g: z, b: Z, a: W } = e.props.rgba;
      U.fillStyle = `rgba(${Q}, ${z}, ${Z}, ${W})`, U.fillRect(0, 0, i.width, i.height);
    }
    function E(U) {
      if (!U) return;
      const Q = U.getContext("2d");
      if (!Q) return;
      ee(U, U.width / 2);
      const z = U.dataset.colorPrecise;
      if (!z) return;
      const [Z, W, X, G] = Vv(z), [se, pe, J, ae] = Rv(Z, W, X, G);
      Q.fillStyle = `hsla(${se}, ${pe / 255 * 100}%, ${J / 255 * 100}%, ${ae})`, Q.fillRect(0, 0, Math.round(U.width), Math.round(U.height));
    }
    function B(U, Q, z) {
      let Z = null;
      const W = (J) => {
        Z !== null && cancelAnimationFrame(Z), Z = requestAnimationFrame(() => {
          if (!Q) return;
          const ae = Q.getBoundingClientRect();
          let re, ge;
          "touches" in J ? (re = J.touches[0].clientX - ae.left, ge = J.touches[0].clientY - ae.top) : (re = J.clientX - ae.left, ge = J.clientY - ae.top), re = Math.min(Math.max(re, 0), ae.width), ge = Math.min(Math.max(ge, 0), ae.height), z(re, ge);
        });
      };
      W(U);
      const X = (J) => {
        J.preventDefault(), W(J);
      }, G = (J) => {
        J.preventDefault(), W(J);
      }, se = () => {
        t = void 0, document.removeEventListener("mousemove", X), document.removeEventListener("mouseup", se);
      }, pe = () => {
        t = void 0, document.removeEventListener("touchmove", G), document.removeEventListener("touchend", pe);
      };
      "touches" in U ? (document.addEventListener("touchmove", G), document.addEventListener("touchend", pe)) : (document.addEventListener("mousemove", X), document.addEventListener("mouseup", se));
    }
    function N(U) {
      B(U, o, (Q, z) => {
        const Z = Q / o.width * 100, W = 100 - z / o.height * 100;
        g(e.props.hue, Z, W);
      });
    }
    function Y(U) {
      B(U, s, (Q, z) => {
        if (!s) return;
        const Z = s.width, W = Math.floor(Q / Z * 360);
        e.props.h = W, g(e.props.h, e.props.s, e.props.v);
      });
    }
    function j(U) {
      e.props.alpha && B(U, a, (Q, z) => {
        const Z = Q / a.width * 100 / 100;
        e.props.a = Z, g(e.props.hue, e.props.s, e.props.v);
      });
    }
    function ee(U, Q) {
      const z = U.getContext("2d");
      if (!z) return;
      const Z = Math.ceil(U.height / Q), W = Math.ceil(U.width / Q);
      for (let X = 0; X < Z; X++) for (let G = 0; G < W; G++) z.fillStyle = (X + G) % 2 == 1 ? "#FFFFFF" : "#CCCCCC", z.fillRect(G * Q, X * Q, Q, Q);
    }
    function te() {
      var U, Q;
      if (!e.context || !e.props.options || !l) return;
      const { h: z, s: Z, v: W, a: X } = e.props, G = function(J, ae, re, ge = 1) {
        const Ie = re === 0 ? 0 : ae;
        return `${Le(re === 0 || re === 100 && ae === 0 ? 0 : J, 0)}-${Le(Ie, 0)}-${Le(re, 0)}-${Le(ge, 2)}`;
      }(z, Z, W, X);
      let se = !1, pe = !1;
      l.forEach((J) => {
        const ae = J.dataset.color;
        if (!ae) return;
        const [re, ge, Ie, je] = ae.split("-");
        Ie === "0" && W === 0 && je === `${X}` && (pe = !0);
        const Ve = J.parentElement;
        pe || ae === G ? (Ve.dataset.active = "true", J.ariaSelected = "true", pe = !1, !se && l && (y(l.indexOf(J)), se = !0)) : (delete Ve.dataset.active, J.ariaSelected = "false");
      }), se || (e.props.focusedSwatch = (Q = (U = l[0]) === null || U === void 0 ? void 0 : U.dataset) === null || Q === void 0 ? void 0 : Q.color);
    }
    function ce(U) {
      U = U.replace("#", ""), e.props.hexInputFocused || U.length !== 3 || (U = U[0] + U[0] + U[1] + U[1] + U[2] + U[2]), U = `#${U = U.toUpperCase()}`, e.props.hex = U.slice(0, 9);
    }
    function H(U, Q, z, Z = !1) {
      e.props.h = U === void 0 || isNaN(U) ? e.props.h : Le(Math.max(Math.min(U, 360), 0), 2), e.props.s = Q === void 0 || isNaN(Q) ? e.props.s : Le(Math.max(Math.min(Q, 100), 0), 2), e.props.v = z === void 0 || isNaN(z) ? e.props.v : Le(Math.max(Math.min(z, 100), 0), 2);
      const { h: W, s: X, v: G, a: se } = e.props, [pe, J, ae] = Rv(W, X, G), [re, ge, Ie] = K0(W, X, G), je = e.props.hexInputFocused ? e.props.hex : wae(W, X, G, se), Ve = Le(se, 2);
      e.props.hsla = { h: W, s: J, l: ae, a: Ve }, e.props.hslaPercent = { h: Le(W, 0), s: G === 100 && X === 0 ? 0 : Le(G === 0 ? J / 255 : Math.max(Math.min(J / 255 * 100, 100), 0), 0), l: Le(Math.max(Math.min(e.props.hsla.l / 255 * 100, 100), 0), 0), a: Ve }, e.props.hslaString = `hsla(${e.props.hslaPercent.h}, ${e.props.hslaPercent.s}%, ${e.props.hslaPercent.l}%, ${Ve})`, e.props.hslaStringPrecise = `hsla(${W}, ${Le(G === 0 ? J / 255 : J / 255 * 100, 2)}%, ${Le(ae / 255 * 100, 2)}%, ${Ve})`, e.props.rgba = { r: re, g: ge, b: Ie, a: Ve }, e.props.rgbaString = `rgba(${re}, ${ge}, ${Ie}, ${Ve})`, ce(je), setTimeout(() => {
        var Be;
        oe(), function() {
          const ht = e.props.s, _t = 100 - e.props.v;
          e.props.controlLSPosition = { x: ht, y: _t };
        }(), _(), n || typeof window > "u" || (n = (Be = e.props.__root) === null || Be === void 0 ? void 0 : Be.querySelector(`[data-id="${e.props.id}"]`));
      }, 0);
      const Ue = e.props.valueFormat ? e.props.valueFormat : e.props.format;
      Z || (Ue === "hex" ? e.input(e.props.hex) : Ue === "rgba" ? e.input(e.props.rgbaString) : Ue === "hsla" && e.input(e.props.hslaStringPrecise));
    }
    function oe() {
      p(), f(), m(), h();
    }
    e.addProps(["expanded", "h", "s", "v", "a", "hsla", "hslaPercent", "hslaString", "hslaStringPrecise", "rgba", "rgbaString", "hex", "controlLSPosition", "panelActiveFormat", "hexInputFocused", "hasNativeEyeDropper", "focusedSwatch", "swatchIsUsingKeyboardNav", "showPanelClose"]), e.props.h = e.props.h || void 0, e.props.s = e.props.s || void 0, e.props.v = e.props.v || void 0, e.props.a = e.props.a || 1, e.props.controlLSPosition = e.props.controlLSPosition || { x: 0, y: 0 }, e.props.switchIcon = e.props.switchIcon || '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M34.2 179.7L154.4 66.2c1.4-1.3 3.5-2.2 5.6-2.2s4.2 .8 5.6 2.2L285.8 179.7c1.4 1.3 2.2 3.2 2.2 5.2c0 3.9-3.2 7.1-7.1 7.1H39.1c-3.9 0-7.1-3.2-7.1-7.1c0-2 .8-3.8 2.2-5.2zm-22-23.3C4.4 163.8 0 174.1 0 184.9C0 206.5 17.5 224 39.1 224H280.9c21.6 0 39.1-17.5 39.1-39.1c0-10.8-4.4-21.1-12.3-28.4L187.6 42.9C180.1 35.9 170.2 32 160 32s-20.1 3.9-27.6 10.9L12.3 156.4zm22 175.9c-1.4-1.3-2.2-3.2-2.2-5.2c0-3.9 3.2-7.1 7.1-7.1H280.9c3.9 0 7.1 3.2 7.1 7.1c0 2-.8 3.8-2.2 5.2L165.6 445.8c-1.4 1.3-3.5 2.2-5.6 2.2s-4.2-.8-5.6-2.2L34.2 332.3zm-22 23.3L132.4 469.1c7.4 7 17.4 10.9 27.6 10.9s20.1-3.9 27.6-10.9L307.7 355.6c7.8-7.4 12.3-17.7 12.3-28.5c0-21.6-17.5-39.1-39.1-39.1H39.1C17.5 288 0 305.5 0 327.1c0 10.8 4.4 21.1 12.3 28.5z"/></svg>', e.props.hexInputFocused = !1, e.props.swatchIsUsingKeyboardNav = !1, e.on("destroying", () => {
      e.context && typeof document < "u" && document.removeEventListener("paste", v);
    }), e.on("created", () => {
      var U, Q;
      e.context && (typeof window < "u" && document.addEventListener("paste", v), e.props.expanded = !1, e.props.panelActiveFormat = e.props.format || u[0], e.props.panelControls = Sa(e.props.panelControls), e.props.eyeDropper = Sa(e.props.eyeDropper), e.props.panelFormat = Sa(e.props.panelFormat), e.props.showValue = Sa(e.props.showValue), e.props.allowPaste = Sa(e.props.allowPaste), e.props.inline = _e(e.props.inline), e.props.disabled = _e(e.props.disabled), e.props.format = e.props.format || "hex", e.props.alpha = _e((Q = (U = e.props) === null || U === void 0 ? void 0 : U.alpha) === null || Q === void 0 || Q), e.props.valueFormat = e.props.valueFormat || e.props.format, e.props.closeOnSelect = _e(e.props.closeOnSelect), e.props.focusedSwatch = void 0, e.value === void 0 || e.value === "" || e.value === null ? (e.props.rgba = { r: 0, g: 0, b: 0 }, H(0, 0, 0, !0)) : w(`${e.value}`), e.on("input", ({ payload: z }) => {
        n && e.props.__root !== void 0 && !n.contains(e.props.__root.activeElement) && w(z);
      }), setTimeout(() => {
        S();
      }, 5), A(), e.on("prop:expanded", () => {
        var z;
        e.props.expanded ? (S(), A(), O(), document.addEventListener("keydown", Z), window.innerWidth <= 430 && !window.matchMedia("(hover: hover)").matches ? e.props.showPanelClose = !0 : e.props.showPanelClose = !1, setTimeout(() => {
          var W;
          const X = (W = e.props.__root) === null || W === void 0 ? void 0 : W.querySelector(`[data-id="${e.props.id}"] *:not(.formkit-swatch-preview)[tabindex="0"]`);
          X && X.focus();
        }, 0)) : (document.removeEventListener("keydown", Z), ((z = e.props.__root) === null || z === void 0 ? void 0 : z.querySelector(`[data-id="${e.props.id}"] *[tabindex="0"]`)).focus());
        function Z(W) {
          W.key === "Escape" && (W.preventDefault(), e.props.expanded = !1);
        }
      }), e.context.fns.anyToHsvaString = (z, Z) => {
        const W = Gc(z);
        if (!W) return "0-0-0-1";
        let [X, G, se, pe] = W;
        return Z === 0 && (X = se === 0 || se === 100 && G === 0 ? 0 : X), `${Le(X, Z)}-${Le(G, Z)}-${Le(se, Z)}-${Le(pe, 2)}`;
      }, e.context.handlers.inputPreviewClick = (z) => {
        e.props.expanded = !e.props.expanded;
      }, e.context.handlers.inputPreviewFocusout = (z) => {
        var Z, W, X;
        const G = (Z = e.props.__root) === null || Z === void 0 ? void 0 : Z.querySelector(`[data-id="${e.props.id}"] .formkit-inner`), se = z.relatedTarget;
        if (G.contains(se)) {
          let pe = function(J) {
            var ae, re;
            G.contains(J.target) || (e.props.expanded = !1, (ae = e.props.__root) === null || ae === void 0 || ae.removeEventListener("mousedown", pe), (re = e.props.__root) === null || re === void 0 || re.removeEventListener("touchstart", pe));
          };
          (W = e.props.__root) === null || W === void 0 || W.addEventListener("mousedown", pe), (X = e.props.__root) === null || X === void 0 || X.addEventListener("touchstart", pe);
        } else e.props.expanded = !1;
      }, e.context.handlers.inputPreviewKeydown = (z) => {
        z.key === "Escape" && (z.preventDefault(), e.props.expanded = !1), z.key !== "Enter" && z.key !== " " || (z.preventDefault(), e.props.expanded = !e.props.expanded);
      }, e.context.handlers.closePanel = () => {
        e.props.expanded = !1;
      }, e.context.handlers.panelCloseKeydown = (z) => {
        z.key !== "Enter" && z.key !== " " || (z.preventDefault(), e.props.expanded = !1);
      }, e.context.handlers.toggleFormat = (z = 1) => {
        z = typeof z == "number" ? z : 1;
        const Z = (u.indexOf(e.props.panelActiveFormat) + z + u.length) % u.length;
        e.props.panelActiveFormat = u[Z];
      }, e.context.handlers.panelKeydown = (z) => {
        var Z, W, X;
        if (z.key === "Tab" && e.props.expanded) {
          z.preventDefault();
          const G = Array.from(((Z = e.props.__root) === null || Z === void 0 ? void 0 : Z.querySelectorAll(`[data-id="${e.props.id}"] *:not(.formkit-swatch-preview)[tabindex="0"]`)) || []).filter(Cae), se = G.indexOf(!((W = e.props.__root) === null || W === void 0) && W.activeElement ? (X = e.props.__root) === null || X === void 0 ? void 0 : X.activeElement : e.props.__root);
          let pe;
          pe = z.shiftKey ? (se - 1 + G.length) % G.length : (se + 1) % G.length, G[pe].focus();
        }
      }, e.context.handlers.lsKeydown = (z) => {
        if (["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", "PageUp", "PageDown", "Home", "End"].includes(z.key)) {
          z.preventDefault();
          const { h: Z, s: W, v: X } = e.props, G = z.shiftKey ? 10 : 1;
          switch (z.key) {
            case "ArrowLeft":
              H(Z, W - G, X);
              break;
            case "ArrowRight":
              H(Z, W + G, X);
              break;
            case "ArrowUp":
              H(Z, W, X + G);
              break;
            case "ArrowDown":
              H(Z, W, X - G);
              break;
            case "PageUp":
              H(Z, W, X + 10);
              break;
            case "PageDown":
              H(Z, W, X - 10);
              break;
            case "Home":
              H(Z, W - 10, X);
              break;
            case "End":
              H(Z, W + 10, X);
          }
          oe();
        }
      }, e.context.handlers.hueControlKeydown = (z) => {
        if (["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", "PageUp", "PageDown", "Home", "End"].includes(z.key)) {
          z.preventDefault();
          const { h: Z, s: W, v: X } = e.props, G = z.shiftKey ? 10 : 1;
          switch (z.key) {
            case "ArrowLeft":
            case "ArrowDown":
              H(Z - G, W, X);
              break;
            case "ArrowRight":
            case "ArrowUp":
              H(Z + G, W, X);
              break;
            case "PageUp":
              H(Z + 10, W, X);
              break;
            case "PageDown":
              H(Z - 10, W, X);
              break;
            case "Home":
              H(0, W, X);
              break;
            case "End":
              H(360, W, X);
          }
          oe();
        }
      }, e.context.handlers.alphaControlKeydown = (z) => {
        if (e.props.alpha && ["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", "PageUp", "PageDown", "Home", "End"].includes(z.key)) {
          z.preventDefault();
          const { h: Z, s: W, v: X, a: G } = e.props, se = z.shiftKey ? 0.1 : 0.01;
          switch (z.key) {
            case "ArrowLeft":
            case "ArrowDown":
              e.props.a = Le(Math.min(Math.max(G - se, 0), 1), 2);
              break;
            case "ArrowRight":
            case "ArrowUp":
              e.props.a = Le(Math.min(Math.max(G + se, 0), 1), 2);
              break;
            case "PageUp":
              e.props.a = Le(Math.min(Math.max(G + 0.1, 0), 1), 2);
              break;
            case "PageDown":
              e.props.a = Le(Math.min(Math.max(G - 0.1, 0), 1), 2);
              break;
            case "Home":
              e.props.a = 0;
              break;
            case "End":
              e.props.a = 1;
          }
          H(Z, W, X);
        }
      }, e.context.handlers.eyeDropperKeydown = (z) => {
        var Z;
        if (z.key === "Enter" || z.key === " ") {
          z.preventDefault();
          const W = (Z = e.props.__root) === null || Z === void 0 ? void 0 : Z.getElementById(`eye-dropper-${e.props.id}`);
          W == null || W.click();
        }
      }, e.context.handlers.formatSwitcherKeydown = (z) => {
        e.context && (z.key !== "Enter" && z.key !== " " && z.key !== "ArrowDown" || (z.preventDefault(), e.context.handlers.toggleFormat()), z.key === "ArrowUp" && (z.preventDefault(), e.context.handlers.toggleFormat(-1)));
      }, e.context.handlers.hexInput = (z) => {
        const Z = z.target, W = Z.value.startsWith("#") ? 9 : 8, X = Z.value.slice(0, W);
        if (Z.value = e.props.alpha ? X : X.slice(0, 7), ws(X)) {
          const [G, se, pe, J] = Yu(X);
          e.props.alpha && (e.props.a = J), ce(X), H(G, se, pe);
        }
      }, e.context.handlers.hexKeydown = (z) => {
        const Z = z.target, W = Z.value;
        let X = "";
        if (!ws(W)) return;
        const G = W.startsWith("#") ? W.slice(1) : W, se = G.length === 8, pe = se ? G.substring(0, 6) : G, J = se ? G.substring(6, 8) : "", ae = z.shiftKey ? 10 : 1, re = 16777215;
        let ge;
        if (["ArrowUp", "ArrowDown", "PageUp", "PageDown", "Home", "End"].includes(z.key)) switch (z.preventDefault(), z.key) {
          case "ArrowUp":
            ge = (parseInt(pe, 16) + ae) % 16777216;
            break;
          case "ArrowDown":
            ge = (parseInt(pe, 16) - ae + re + 1) % 16777216;
            break;
          case "PageUp":
            ge = (parseInt(pe, 16) + 10) % 16777216;
            break;
          case "PageDown":
            ge = (parseInt(pe, 16) - 10 + re + 1) % 16777216;
            break;
          case "Home":
            ge = 0;
            break;
          case "End":
            ge = re;
        }
        ge !== void 0 && (X = ge.toString(16).padStart(6, "0").toUpperCase()), X && (Z.value = se ? `#${X}${J}` : `#${X}`), e.context && e.context.handlers.hexInput(z);
      }, e.context.handlers.hexFocus = () => {
        e.context && (e.props.hexInputFocused = !0);
      }, e.context.handlers.hexBlur = (z) => {
        if (!e.context) return;
        e.props.hexInputFocused = !1;
        const Z = z.target.value;
        ws(Z) && ce(Z);
      }, e.context.handlers.rangeLimitInput = (z, Z, W, X) => (G) => {
        const se = X || G;
        if (!se || !e.context) return;
        const pe = se.target;
        if (pe.value.endsWith(".")) return;
        const J = Math.max(Math.min(Number(pe.value), W), Z);
        pe.value = `${J}`;
        const ae = pe.id;
        if (z === "hsla") {
          switch (ae) {
            case `h-${e.props.id}`:
              e.props.h = J;
              break;
            case `s-${e.props.id}`:
              e.props.hslaPercent.s = J;
              break;
            case `l-${e.props.id}`:
              e.props.hslaPercent.l = J;
          }
          const [re, ge, Ie] = Ad(e.props.h, 2.55 * e.props.hslaPercent.s, 2.55 * e.props.hslaPercent.l);
          H(re, ge, Ie);
        } else if (z === "rgba") {
          switch (ae) {
            case `r-${e.props.id}`:
              e.props.rgba.r = J;
              break;
            case `g-${e.props.id}`:
              e.props.rgba.g = J;
              break;
            case `b-${e.props.id}`:
              e.props.rgba.b = J;
          }
          const [re, ge, Ie] = Y0(e.props.rgba.r, e.props.rgba.g, e.props.rgba.b);
          H(re, ge, Ie);
        } else z == "alpha" && e.props.alpha && (e.props.a = J, H());
      }, e.context.handlers.rangeLimitKeydown = (z, Z, W, X) => (G) => {
        if (e.context)
          if (["ArrowUp", "ArrowDown", "PageUp", "PageDown", "Home", "End", "Backspace", "Tab", "Enter"].includes(G.key) || G.metaKey || !/[a-zA-Z!@#$%^&*()_+={}\[\]:;"'<,>?\/|\\`~]/g.test(G.key)) {
            if (["ArrowUp", "ArrowDown", "PageUp", "PageDown", "Home", "End"].includes(G.key)) {
              const se = G.target, pe = Number(se.value), J = G.shiftKey ? 10 * X : X;
              switch (G.key) {
                case "ArrowUp":
                  G.preventDefault(), se.value = `${Math.min(pe + J, W)}`;
                  break;
                case "ArrowDown":
                  G.preventDefault(), se.value = `${Math.max(pe - J, Z)}`;
                  break;
                case "PageUp":
                  G.preventDefault(), se.value = `${Math.min(pe + 10 * X, W)}`;
                  break;
                case "PageDown":
                  G.preventDefault(), se.value = `${Math.max(pe - 10 * X, Z)}`;
                  break;
                case "Home":
                  G.preventDefault(), se.value = `${Z}`;
                  break;
                case "End":
                  G.preventDefault(), se.value = `${W}`;
              }
              e.context.handlers.rangeLimitInput(z, Z, W, G)();
            }
          } else G.preventDefault();
      }, e.context.handlers.swatchClick = (z) => {
        const Z = z.target;
        if (Z.dataset.colorPrecise) {
          const [W, X, G, se] = Vv(Z.dataset.colorPrecise);
          e.props.alpha && (e.props.a = se), H(W, X, G), e.props.closeOnSelect && (e.props.expanded = !1);
        }
        e.context && z.type !== "keydown" && e.context.handlers.swatchKeydown(z);
      }, e.context.handlers.swatchKeydown = (z) => {
        var Z, W, X, G;
        if (!e.context || !l || !l.length) return;
        const se = l.indexOf(z.currentTarget);
        let pe = null;
        const J = function(Ue) {
          var Be;
          if (!Ue.length) return 0;
          const ht = (Be = Ue[0].parentElement) === null || Be === void 0 ? void 0 : Be.parentElement;
          if (!ht) return 0;
          const _t = ht.getBoundingClientRect().width, Ft = Ue[0].parentElement;
          if (!Ft) return 0;
          const Rt = Ft.getBoundingClientRect(), fe = window.getComputedStyle(Ft), Ge = parseFloat(fe.marginLeft) + parseFloat(fe.marginRight), zt = Rt.width + Ge;
          return Math.floor(_t / zt);
        }(l), ae = l.length;
        let re = 0, ge = ae, Ie = !1;
        const je = l[se].dataset.group;
        if (je !== void 0) {
          const Ue = l.filter((Be) => Be.dataset.group === je);
          re = l.indexOf(Ue[0]), ge = l.indexOf(Ue[Ue.length - 1]);
        }
        const Ve = (se - re) % J;
        if (!z.key || z.key === "Tab") return z.key || (e.props.swatchIsUsingKeyboardNav = !1, c = Ve, y(se)), z.key === "Tab" && (e.props.swatchIsUsingKeyboardNav = !1), void l.forEach((Ue) => {
          delete Ue.parentElement.dataset.focused;
        });
        if (z.key === "Enter" || z.key === " ") return z.preventDefault(), c = Ve, e.context.handlers.swatchClick(z), void y(se);
        switch (z.key !== "ArrowUp" && z.key !== "ArrowDown" && z.key !== "ArrowLeft" && z.key !== "ArrowRight" || (e.props.swatchIsUsingKeyboardNav = !0, z.preventDefault()), z.key) {
          case "ArrowUp":
            pe = Math.max(se - J, se - (J - (c - Ve))), Ie = !0;
            break;
          case "ArrowDown":
            pe = Math.max(se + J, se + (J + (c - Ve))), Ie = !0;
            break;
          case "ArrowLeft":
            pe = se - 1, c = (pe - re) % J;
            break;
          case "ArrowRight":
            pe = se + 1, c = (pe - re) % J;
        }
        if (Ie && pe !== null && (pe < re || pe > ge)) {
          let Ue;
          Ue = pe < re ? (W = (Z = l[re - 1]) === null || Z === void 0 ? void 0 : Z.dataset) === null || W === void 0 ? void 0 : W.group : (G = (X = l[ge + 1]) === null || X === void 0 ? void 0 : X.dataset) === null || G === void 0 ? void 0 : G.group;
          const Be = l.filter((fe) => fe.dataset.group === je), ht = l.filter((fe) => fe.dataset.group === Ue), _t = (se - re) % J, Ft = Be.length % J || J, Rt = se >= re + Be.length - Ft;
          if (pe < re) {
            const fe = ht.length % J || J;
            pe = re - fe + Math.min(Math.max(_t, c), fe - 1);
          } else pe > ge && (pe = Rt ? Math.min(ge + Math.max(_t, c) + 1, l.indexOf(ht[ht.length - 1])) : Math.min(pe, ge));
        }
        if (pe !== null && pe >= 0 && pe < ae) {
          y(pe), l.forEach((ht) => {
            delete ht.parentElement.dataset.focused;
          });
          const Ue = l[pe], Be = Ue.parentElement;
          Ue.focus(), Be.dataset.focused = "true";
        }
      });
    });
  },
  br,
  xn,
  /* @__PURE__ */ Oe("eyeDropper", "color"),
  /* @__PURE__ */ Oe("close", "close"),
  /* @__PURE__ */ We("close"),
  /* @__PURE__ */ We("next")
] }, is = /* @__PURE__ */ Lt("tb"), { outer: Sae, wrapper: Hv, prefix: Tae, suffix: Aae, help: Dae, messages: Pae, message: Iae, icon: Uv } = /* @__PURE__ */ Nt(is), zv = is("label", () => ({ if: "$label", $el: "label", attrs: { id: "$id + '_label'" } })), Eae = is("singleToggle", () => ({ bind: "$attrs", $el: "button", attrs: { id: "$id", type: "button", "aria-label": "$label", "aria-pressed": "$fns.isChecked($onValue, $value)", onClick: "$handlers.toggleValue()", disabled: "$disabled", class: "$classes.input", onBlur: "$handlers.blur" } })), Oae = is("multiToggle", () => ({ bind: "$attrs", $el: "button", attrs: { type: "button", id: "$id+'_'+$index", "aria-label": "$label", "aria-pressed": "$fns.isChecked($option, $value)", onClick: "$handlers.toggleValue($option)", class: "$classes.input", title: "$option.help", disabled: "$disabled || $option.disabled", onBlur: "$handlers.blur" } })), zr = is("inputInner", () => ({ bind: "$attrs", $el: "span" })), xae = is("options", () => ({ $el: "ul", attrs: { id: "$id", "data-vertical": '$vertical && "true" || "false"', "aria-labelledby": "$id" } })), Mae = is("option", () => ({ $el: "li", for: ["option", "index", "$options"], attrs: { key: "$option.value", "data-index": "$index" } }));
function Wv(e, t) {
  return t = t != null && t.hasOwnProperty("__original") ? t == null ? void 0 : t.__original : t == null ? void 0 : t.value, e.props.multiple ? !!Array.isArray(e.value) && e.value.filter((n) => we(n, t)).length > 0 : t !== void 0 ? we(e.value, t) : (e.props._isChecked = we(e.value, e.props.onValue), e.props._isChecked);
}
const Lae = { schema: /* @__PURE__ */ Sae(/* @__PURE__ */ ye("$options", /* @__PURE__ */ Hv(/* @__PURE__ */ zv("$label"), /* @__PURE__ */ xae(/* @__PURE__ */ Mae(/* @__PURE__ */ Oae(/* @__PURE__ */ ye("$fns.isChecked($option) === true", /* @__PURE__ */ zr("$slots.default || $slots.on || $option.onLabel || $option.label"), /* @__PURE__ */ zr("$slots.default || $slots.off || $option.offLabel || $option.label")))))), /* @__PURE__ */ Hv(/* @__PURE__ */ ye("$label && ($slots.default || $slots.on || $onLabel)", /* @__PURE__ */ zv("$label")), /* @__PURE__ */ Eae(/* @__PURE__ */ Uv("prefix"), /* @__PURE__ */ Tae(), /* @__PURE__ */ ye("$_isChecked === true", /* @__PURE__ */ zr("$slots.default || $slots.on || $onLabel || $label"), /* @__PURE__ */ zr("$slots.default || $slots.off || $offLabel || $label")), /* @__PURE__ */ Aae(), /* @__PURE__ */ Uv("suffix")))), /* @__PURE__ */ Dae("$help"), /* @__PURE__ */ Pae(/* @__PURE__ */ Iae("$message.value"))), type: "input", family: "button", props: ["options"], features: [function(e) {
  var t, n, o, s;
  e.addProps(["enforced", "multiple", "offLabel", "offValue", "onLabel", "onValue", "vertical", "_isChecked"]), e.props._isChecked = !1, e.props.enforced = _e(e.props.enforced), e.props.multiple = _e(e.props.multiple), e.props.vertical = _e(e.props.vertical), e.props.disabled = _e(e.props.disabled), (t = (o = e.props).onValue) !== null && t !== void 0 || (o.onValue = !0), (n = (s = e.props).offValue) !== null && n !== void 0 || (s.offValue = !1), e.on("created", () => {
    var a;
    e.props._isChecked = Wv(e, null), e.props.options && e.props.multiple && e.input((a = e.value) !== null && a !== void 0 ? a : [], !1), e.context && (e.context.fns.isChecked = (r) => Wv(e, r), e.context.handlers.toggleValue = (r) => (i) => function(l, c, u) {
      if (u.preventDefault(), c = c && de(c), l.props.options) if (l.props.multiple) {
        const p = Array.isArray(l.value) ? [...l.value] : [], f = p.findIndex((m) => we(m, c));
        f > -1 && (!l.props.enforced || p.length > 1) ? p.splice(f, 1) : f === -1 && p.push(c), l.input(p);
      } else we(l.value, c) && !l.props.enforced ? l.input(void 0) : l.input(c);
      else l.input(we(l.value, l.props.onValue) ? l.props.offValue : l.props.onValue);
    }(e, r, i));
  });
}, xn] }, G0 = /* @__PURE__ */ Lt("ut"), { outer: Nae, inner: Fae, wrapper: Rae, label: Vae, prefix: Bae, suffix: Hae, help: Uae, messages: zae, message: Wae, icon: jv } = /* @__PURE__ */ Nt(G0), jae = G0("input", () => ({ $el: "input", bind: "$attrs", attrs: { name: "$node.name", autocomplete: "$attrs.autocomplete || off", id: "$id", onChange: "$handlers.handleInput", onInput: "$handlers.handleInput", onKeydown: "$handlers.handleKeyDown", onBeforeinput: "$handlers.handleBeforeInput", readonly: "$readonly", inputmode: "decimal", disabled: "$disabled", "data-unit": "$unit", "data-currency": "$currency", "data-display-locale": "$displayLocale", "data-value-locale": "$valueLocale", "data-decimals": "$decimals", "data-trailing": "$trailingZeros", "data-numeric-value": "$_numericValue", "data-align": "$_valueAlignAuto" } }));
function Z0(e) {
  let t = null, n = !1;
  function o(p) {
    var f, m, h;
    const g = (`${p}`.match(/\-/g) || []).length % 2 == 1;
    p = function($) {
      if ($ = function(S) {
        return S.replace(/[\u0660-\u0669\u06f0-\u06f9]/g, (A) => (15 & A.charCodeAt(0)).toString());
      }(`${$}`), isNaN($) && ($ = $.split(t.decimal).map((S) => S.replace(/[^0-9]/g, "")).join(".")), $ = $.replace(/[^0-9\.]/g, ""), $.includes(".")) {
        const S = $.split(".");
        e.props.decimals === 0 ? $ = S[0] : (S[1] = S[1].padEnd(u(), "0").slice(0, u()), $ = S.join("."));
      }
      return $;
    }(p);
    const _ = {};
    r() === "unit" && (_.minimumFractionDigits = p.includes(".") ? 1 : 0), _.maximumFractionDigits = u(), e.props.minDecimals && (_.minimumFractionDigits = e.props.minDecimals, p.includes(".") || (p += ".".padEnd(e.props.minDecimals + 1, "0"))), _.maximumFractionDigits === 0 && p.includes(".") && (p = p.split(".")[0]);
    let v = "";
    isNaN(p) || p.trim() === "" || (p = g ? `-${p}` : p, e.props.max && !isNaN(e.props.max) && (p = Number(p) > e.props.max ? `${e.props.max}` : p), e.props.min && !isNaN(e.props.min) && (p = Number(p) < e.props.min ? `${e.props.min}` : p), p.includes(".") ? p = p.split(".")[0].padStart(1, "0") + "." + ((f = p.split(".")[1]) !== null && f !== void 0 ? f : "0") : _.maximumFractionDigits = (m = _.minimumFractionDigits) !== null && m !== void 0 ? m : 0, v = i(e.props.displayLocale, _).format(p));
    let w, y = p.split(".");
    y = y[0] + ((h = y[1]) !== null && h !== void 0 ? h : "").padEnd(u(), "0"), y.length > 1 && (y = y.replace(/^0+/, ""), y = p !== "" && y === "" ? "0" : y), e.props.valueStore = { number: p, integer: y, string: v }, n = !0, e.props.valueStore && (w = e.props.valueStore.hasOwnProperty(e.props.valueFormat) ? e.props.valueStore[e.props.valueFormat] : e.props.valueStore.number), e.input(w === "" ? void 0 : w).then(() => (n = !1, Promise.resolve()));
  }
  function s() {
    it(`${e.props.id}`, (p) => {
      var f, m;
      p instanceof HTMLInputElement && (p.value = (m = (f = e.props.valueStore) === null || f === void 0 ? void 0 : f.string) !== null && m !== void 0 ? m : "");
    }, e.props.__root);
  }
  function a() {
    var p, f;
    const m = (p = e.props.__root) === null || p === void 0 ? void 0 : p.querySelector(`#${e.props.id}_inner input`);
    return (f = m == null ? void 0 : m.value) !== null && f !== void 0 ? f : "";
  }
  function r() {
    return e.props.currency ? "currency" : "unit";
  }
  function i(p, f = {}) {
    const m = r(), h = Object.assign({}, { style: m, roundingMode: "trunc" }, f);
    return h[m] = e.props[m], new Intl.NumberFormat(p, h);
  }
  function l() {
    var p, f, m;
    const h = (p = e.props.__root) === null || p === void 0 ? void 0 : p.querySelector(`#${e.props.id}_inner input`);
    if (h) {
      h.dataset.placeholder || (h.dataset.placeholder = (f = h.getAttribute("placeholder")) !== null && f !== void 0 ? f : "");
      const g = ((t.unitLeft ? `${t.unit} ` : "") + ((m = h.dataset.placeholder) !== null && m !== void 0 ? m : "") + (t.unitLeft ? "" : ` ${t.unit}`)).trim();
      h.setAttribute("placeholder", g);
    }
  }
  function c(p) {
    var f;
    const m = (f = e.props.__root) === null || f === void 0 ? void 0 : f.querySelector(`#${e.props.id}_inner input`);
    if (!m) return;
    const h = t.unit.length + t.literal.length;
    p = t.unitLeft ? Math.max(p, h) : Math.min(p, a().length - h), m.setSelectionRange(p, p);
  }
  function u() {
    return e.props.decimals !== void 0 ? e.props.decimals : e.props.minDecimals !== void 0 && e.props.minDecimals > t.fractionLength ? e.props.minDecimals : t.fractionLength;
  }
  e.props.valueStore = null, e.on("input", ({ payload: p }) => {
    n || (o(p), s());
  }), e.on("mounted", () => {
    l();
  }), e.context && (e.context.handlers.setPlaceholder = l, e.context.handlers.init = (p = null) => {
    var f;
    (function() {
      var h, g, _, v, w, y, $;
      const S = i(e.props.displayLocale).formatToParts(1234567812345678e-8);
      t = { decimal: (h = S.find((A) => A.type == "decimal")) === null || h === void 0 ? void 0 : h.value, group: (g = S.find((A) => A.type == "group")) === null || g === void 0 ? void 0 : g.value, unit: (_ = S.find((A) => ["unit", "currency"].includes(A.type))) === null || _ === void 0 ? void 0 : _.value, unitLeft: ["unit", "currency"].includes(S[0].type), literal: (w = (v = S.find((A) => A.type == "literal")) === null || v === void 0 ? void 0 : v.value) !== null && w !== void 0 ? w : "", fractionLength: ($ = (y = S.find((A) => A.type == "fraction")) === null || y === void 0 ? void 0 : y.value.length) !== null && $ !== void 0 ? $ : 0 };
    })();
    let m = (f = p ?? e._value) !== null && f !== void 0 ? f : "";
    e.props.valueStore ? m = e.props.valueStore.number : e.props.valueFormat === "integer" && (m = function(h) {
      var g;
      return (parseFloat(`${h}`) / Math.pow(10, (g = u()) !== null && g !== void 0 ? g : 0)).toString().replace(".", u());
    }(`${m ?? ""}`)), o(m), s();
  }, e.context.handlers.handleBeforeInput = (p) => {
    var f, m, h, g, _, v, w, y, $;
    if (!e.props.inExecCommand && (p.preventDefault(), p.stopPropagation(), p.target instanceof HTMLInputElement)) {
      const S = p.target, A = (f = p.data) !== null && f !== void 0 ? f : "", I = (m = p.target.value) !== null && m !== void 0 ? m : "", D = (h = p.target.selectionStart) !== null && h !== void 0 ? h : 0, O = (g = p.target.selectionEnd) !== null && g !== void 0 ? g : 0, x = O - D, F = I.indexOf(t.decimal);
      let P = ((_ = p.target.selectionStart) !== null && _ !== void 0 ? _ : 0) + (p.data ? 0 : -1), E = I, B = 1;
      if (I.includes(t.decimal) && A === t.decimal) return A === t.decimal && (P = E.indexOf(t.decimal) + 1), void c(P);
      if (!(e.props.min === null || e.props.min < 0 || e.props.max < 0) && A === "-" || A.match(/[a-zA-Z]/) || A === t.decimal && e.props.decimals === 0) return;
      if (p.inputType === "deleteByCut" && x > 0 && (E = E.slice(0, D) + E.slice(O), P = O), p.inputType === "insertFromPaste") {
        const N = (v = p.data) !== null && v !== void 0 ? v : "";
        E = E.slice(0, D) + N + E.slice(O);
      }
      if (p.inputType === "deleteContentBackward" && I[D - 1] === t.group ? (B += 1, P -= 1) : p.inputType === "deleteContentForward" && I[D] === t.group && (B += 1, P += 1), F !== -1 && P > F && p.inputType === "insertText" ? E = function(N, Y, j) {
        return N.substring(0, Y) + j + N.substring(Y + j.length);
      }(E, P, (w = p.data) !== null && w !== void 0 ? w : "0") : p.inputType === "insertText" ? (P = O, E = E.slice(0, D) + p.data + E.slice(O)) : p.inputType === "deleteContentForward" ? (P += 2, E = x === 0 ? E.slice(0, D) + E.slice(O + B) : E.slice(0, D) + E.slice(O)) : p.inputType === "deleteContentBackward" && (P += 1, x === 0 ? E = E.slice(0, Math.max(D - B, 0)) + E.slice(O) : x > 0 && (E = E.slice(0, D) + E.slice(O))), p.inputType === "deleteContentForward" && I[D] === t.decimal) {
        const N = E.slice(D - 1);
        E = E.slice(0, D), N.includes(t.unit) && (E += " " + t.unit);
      } else if (p.inputType === "deleteContentBackward" && I[D - 1] === t.decimal) {
        const N = E.slice(D - 1);
        E = E.slice(0, D - 1), N.includes(t.unit) && (E += " " + t.unit);
      }
      o(E), E = ($ = (y = e.props.valueStore) === null || y === void 0 ? void 0 : y.string) !== null && $ !== void 0 ? $ : "", P = E.length - I.length + P, E.length === I.length && (P += p.inputType.includes("delete") ? -1 : 1), S.setSelectionRange(0, I.length), e.props.inExecCommand = !0, document.execCommand("insertText", void 0, E), e.props.inExecCommand = !1, A === t.decimal ? P = E.indexOf(t.decimal) + 1 : I.includes(t.decimal) && !E.includes(t.decimal) && (P = E.length), c(Math.max(0, P));
    }
  }, e.context.handlers.handleInput = (p) => {
    e.emit("dom-input-event", p), p.target instanceof HTMLInputElement && (e.props.inputText = p.target.value, o(p.target.value));
  }, e.context.handlers.handleKeyDown = (p) => {
    var f, m;
    if (p.target instanceof HTMLInputElement && (p.key === "ArrowUp" || p.key === "ArrowDown")) {
      const h = p.key === "ArrowUp" ? 1 * e.props.step : -1 * e.props.step;
      o(function(g, _) {
        var v, w, y, $;
        const S = `${g}`.split("."), A = `${_}`.split(".");
        let I = (v = S[0]) !== null && v !== void 0 ? v : "0", D = (w = A[0]) !== null && w !== void 0 ? w : "0";
        const O = (y = S[1]) !== null && y !== void 0 ? y : "", x = ($ = A[1]) !== null && $ !== void 0 ? $ : "", F = Math.max(O.length, x.length);
        F > 0 && (I += O.padEnd(F, "0"), D += x.padEnd(F, "0"));
        const P = BigInt(BigInt(I) + BigInt(D)).toString();
        return F > 0 ? P.slice(0, -1 * F) + "." + P.slice(-1 * F) : P;
      }((m = (f = e.props.valueStore) === null || f === void 0 ? void 0 : f.number) !== null && m !== void 0 ? m : 0, h)), s(), setTimeout(() => {
        c(a().length);
      }, 1);
    }
  });
}
const qae = { schema: /* @__PURE__ */ Nae(/* @__PURE__ */ Rae(/* @__PURE__ */ Vae("$label"), /* @__PURE__ */ Fae(/* @__PURE__ */ jv("prefix"), /* @__PURE__ */ Bae(), /* @__PURE__ */ jae(), /* @__PURE__ */ Hae(), /* @__PURE__ */ jv("suffix"))), /* @__PURE__ */ Uae("$help"), /* @__PURE__ */ zae(/* @__PURE__ */ Wae("$message.value"))), type: "input", family: "text", props: ["options"], features: [function(e) {
  var t, n, o, s, a, r, i, l, c, u, p, f, m, h, g, _;
  const v = ["unit", "decimals", "minDecimals", "displayLocale", "min", "max", "step", "valueFormat"];
  e.addProps(v), (t = (c = e.props).displayLocale) !== null && t !== void 0 || (c.displayLocale = e.props.locale || "en-US"), (n = (u = e.props).decimals) !== null && n !== void 0 || (u.decimals = null), (o = (p = e.props).minDecimals) !== null && o !== void 0 || (p.minDecimals = null), (s = (f = e.props).min) !== null && s !== void 0 || (f.min = null), (a = (m = e.props).max) !== null && a !== void 0 || (m.max = null), (r = (h = e.props).step) !== null && r !== void 0 || (h.step = 1), (i = (g = e.props).unit) !== null && i !== void 0 || (g.unit = e.props.unit || "percent"), ["acre", "bit", "byte", "celsius", "centimeter", "day", "degree", "fahrenheit", "fluid-ounce", "foot", "gallon", "gigabit", "gigabyte", "gram", "hectare", "hour", "inch", "kilobit", "kilobyte", "kilogram", "kilometer", "liter", "megabit", "megabyte", "meter", "microsecond", "mile", "mile-scandinavian", "milliliter", "millimeter", "millisecond", "minute", "month", "nanosecond", "ounce", "percent", "petabyte", "pound", "second", "stone", "terabit", "terabyte", "week", "yard", "year"].indexOf(e.props.unit) === -1 && (e.props.unit = "percent"), (l = (_ = e.props).valueFormat) !== null && l !== void 0 || (_.valueFormat = "number"), ["string", "number"].indexOf(e.props.valueFormat) === -1 && (e.props.valueFormat = "number"), e.on("created", () => {
    e.context && (Z0(e), e.context.handlers.init(), v.forEach((w) => {
      e.on(`prop:${w}`, () => {
        var y, $;
        (y = e == null ? void 0 : e.context) === null || y === void 0 || y.handlers.init(), ($ = e == null ? void 0 : e.context) === null || $ === void 0 || $.handlers.setPlaceholder();
      });
    }));
  });
}, xn] }, X0 = /* @__PURE__ */ Lt("cr"), { outer: Kae, inner: Yae, wrapper: Gae, label: Zae, prefix: Xae, suffix: Jae, help: Qae, messages: ere, message: tre, icon: qv } = /* @__PURE__ */ Nt(X0), nre = X0("input", () => ({ $el: "input", bind: "$attrs", attrs: { name: "$node.name", autocomplete: "$attrs.autocomplete || off", id: "$id", onChange: "$handlers.handleInput", onInput: "$handlers.handleInput", onKeydown: "$handlers.handleKeyDown", onBeforeinput: "$handlers.handleBeforeInput", readonly: "$readonly", disabled: "$disabled", inputmode: "decimal", "data-unit": "$unit", "data-currency": "$currency", "data-display-locale": "$displayLocale", "data-value-locale": "$valueLocale", "data-decimals": "$decimals", "data-trailing": "$trailingZeros", "data-numeric-value": "$_numericValue", "data-align": "$_valueAlignAuto" } })), ore = { schema: /* @__PURE__ */ Kae(/* @__PURE__ */ Gae(/* @__PURE__ */ Zae("$label"), /* @__PURE__ */ Yae(/* @__PURE__ */ qv("prefix"), /* @__PURE__ */ Xae(), /* @__PURE__ */ nre(), /* @__PURE__ */ Jae(), /* @__PURE__ */ qv("suffix"))), /* @__PURE__ */ Qae("$help"), /* @__PURE__ */ ere(/* @__PURE__ */ tre("$message.value"))), type: "input", family: "text", props: ["options"], features: [function(e) {
  var t, n, o, s, a, r, i, l;
  const c = ["currency", "decimals", "maxDecimals", "minDecimals", "displayLocale", "min", "max", "step", "valueFormat"];
  e.addProps(c), e.addProps(["inputText"]), (t = (a = e.props).displayLocale) !== null && t !== void 0 || (a.displayLocale = e.props.locale || "en-US"), (n = (r = e.props).currency) !== null && n !== void 0 || (r.currency = e.props.currency || "USD"), e.props.decimals === "false" || e.props.decimals === !1 ? e.props.decimals = 0 : e.props.decimals !== void 0 && (e.props.decimals = Number(e.props.decimals)), e.props.minDecimals = e.props.minDecimals !== void 0 ? Number(e.props.minDecimals) : void 0, e.props.min !== void 0 && (e.props.min = Number(e.props.min)), e.props.max !== void 0 && (e.props.max = Number(e.props.max)), (o = (i = e.props).step) !== null && o !== void 0 || (i.step = 1), (s = (l = e.props).valueFormat) !== null && s !== void 0 || (l.valueFormat = "number"), ["string", "number", "integer"].indexOf(e.props.valueFormat) === -1 && (e.props.valueFormat = "number"), e.on("created", () => {
    e.context && (Z0(e), e.context.handlers.init(), c.forEach((u) => {
      e.on(`prop:${u}`, () => {
        var p, f;
        (p = e == null ? void 0 : e.context) === null || p === void 0 || p.handlers.setPlaceholder(), (f = e == null ? void 0 : e.context) === null || f === void 0 || f.handlers.init();
      });
    }));
  });
}] };
var sre = /* @__PURE__ */ Object.freeze({ __proto__: null, autocomplete: Cte, colorpicker: kae, currency: ore, datepicker: Mne, dropdown: LQ, mask: $oe, rating: ste, repeater: Aee, slider: Nse, taglist: toe, toggle: QQ, togglebuttons: Lae, transferlist: lse, unit: qae });
const are = typeof window < "u" ? setInterval : () => 0, Kv = /* @__PURE__ */ new WeakSet();
function rre(e, t = {}) {
  const n = e;
  try {
    let o = function(s) {
      Kv.has(s) && function(r, i) {
        Va[r] ? Va[r].add(i) : Va[r] = /* @__PURE__ */ new Set([i]);
      }(e, (r) => {
        s.props.definition && (s.props.definition.schema = r || [{ $el: qn(13919), children: `${qn(451228594)}${qn(32863693)}` }]), s.emit("schema"), setTimeout(() => s.destroy(), 1e3);
      });
    };
    return function(s) {
      const a = () => {
        throw new Error(`InvalidFormKitKey ${s}`);
      };
      if (!/^fk-/i.test(s)) return a();
      const r = s.substring(3);
      if (!fJ.test(r)) return a();
      const i = parseInt(r, 16).toString(), l = Number(i[0]) < 6 ? Number(i[0]) : 6, c = i.substring(l, l + (i.length - 6)), u = i.substring(0, l) + i.substring(l + c.length), p = u.slice(0, 2), f = `${u[u.length - 1]}${u[0]}`;
      Number(c) !== Math.floor(Number(u) * Number(p) / Number(f)) && a();
    }(n), o.library = (s) => {
      if (s.props.type in t) {
        const { schema: a, ...r } = t[s.props.type];
        Kv.add(s), s.define({ ...r, schema: a(e) });
      }
      are(() => Ol.has(e) && s.emit("schema"), 4e3);
    }, o;
  } catch (o) {
    throw o instanceof Error && function(s) {
      if (s.message === "FormKitNoKey") throw new Error("A FormKit API key is required, please visit https://formkit.com/pro");
    }(o), o;
  }
}
const ire = Hg(
  K({
    props: {
      context: { type: Object, required: !0 }
    },
    setup(e) {
      return () => za(
        "div",
        {},
        e.context.slots.default ? e.context.slots.default({ context: e.context }) : []
      );
    }
  })
), lre = rre("fk-b6002bac46", sre), Wle = Mp({
  plugins: [lre],
  locales: { en: hg, fr: NA },
  locale: It(),
  rules: { booleanCheck: cd, monthBetween: tX },
  inputs: {
    custom: ire
  }
});
export {
  Qc as API_ERROR,
  qt as AUDIENCE,
  ta as AccordionWrapper,
  Cre as AeroplanLoginBanner,
  ile as AeroplanLoginModal,
  lle as AeroplanPointsBanner,
  gy as AeroplanPointsLogo,
  cle as AeroplanPointsRedeem,
  ry as AeroplanPointsRow,
  sle as AeroplanPointsSection,
  hy as AeroplanPointsSelector,
  $re as AlertMessage,
  tle as AlternateDates,
  Ac as AncillaryGroup,
  Ale as AncillaryMain,
  dy as AncillarySection,
  di as BREAKPOINTS,
  ple as BackToTopButton,
  Rz as Bill96Checkbox,
  Rh as BillingAddress,
  ole as BookingSummary,
  jj as BookingSummaryAncillary,
  Wj as BookingSummaryFlight,
  Rj as BookingSummaryHotel,
  Qn as BreakdownRow,
  Y$ as CA_PROV_TERR,
  Hn as CREDIT_CARD_FRAME_NAME,
  wn as CREDIT_CARD_FRAME_NAME_2,
  xr as CollapsibleSection,
  Pie as ConfirmationAeroplan,
  Zie as ConfirmationAeroplanEnroll,
  SH as ConfirmationImportantNotes,
  uie as ConfirmationModal,
  Die as ConfirmationSuccess,
  Xie as ConfirmationSummary,
  of as CreditCard,
  qz as CreditCardLogos,
  a7 as CreditCardSection,
  Us as DDMMYYYYtoYYYYMMDD,
  V4 as DepositRow,
  q$ as ERROR_3DS,
  Rn as ERROR_CATEGORIES,
  kie as Facilities,
  q7 as FlexibleHotelDatesAccordion,
  tW as FlightDetailsAccordion,
  Dm as FlightDetailsSegment,
  zi as FlightDetailsSegmentMulti,
  km as FlightSegment,
  Hi as FlightStops,
  Ui as FlightStopsDots,
  zj as FlightsDetailsSection,
  Sk as GiftCardSection,
  op as HPCI_AMEX_CARD_NUMBER_PREFIX1,
  sp as HPCI_AMEX_CARD_NUMBER_PREFIX2,
  on as HPCI_CC_ERROR_TEXT_ID,
  Ho as HPCI_CVV_ERROR_TEXT_ID,
  np as HPCI_MASTER_CARD_NUMBER_PREFIX,
  tp as HPCI_VISA_CARD_NUMBER_PREFIX,
  Fj as HotelAndRoomInfo,
  h6 as HotelRoomAccordion,
  _i as IdGenerator,
  s9 as InclusionsAccordion,
  vie as InsuranceDecline,
  hie as InsuranceDescription,
  fie as InsuranceDetails,
  gie as InsuranceDisclaimer,
  vL as InsuranceNotes,
  bie as InsuranceOptions,
  Cle as InvalidAPIDataError,
  Ns as LANG,
  eu as LOCALES,
  sd as LoadingSpinner,
  da as MAX_NAME_LENGTH,
  X$ as MAX_PHONE_LENGTH,
  cie as MessageBox,
  vr as Method,
  wi as MicroServiceError,
  dle as NoFlights,
  fle as NoPackages,
  mle as NoRooms,
  td as NonRefundableRate,
  Cie as Offers,
  M4 as OpcTaxRow,
  Eb as PRODUCT_TYPE_E_PACKAGES,
  Ob as PRODUCT_TYPE_HOTEL_ONLY,
  $O as PRODUCT_TYPE_MIXED_RESULTS,
  ku as PRODUCT_TYPE_PREPACKAGES,
  DU as PassengerProtection,
  HU as PaymentErrors,
  Qie as PaymentMethod,
  Jie as PaymentOptions,
  ei as PaymentStepType,
  wt as PaymentTypes,
  wie as PdpBestFor,
  yR as PdpImportantInformation,
  _ie as PdpLocation,
  Sie as PdpNavAnchors,
  $ie as PdpOverview,
  nle as PlpError,
  yie as PlpFilter,
  ele as PlpListItemContent,
  Gq as PreferredPrivilegesAccordion,
  ed as PriceBreakdown,
  ay as PriceDetails,
  Su as PriceDisclaimer,
  Cm as PricePaymentMethods,
  GB as PriceTotal,
  nd as PriceTotalRow,
  lie as ProgressBar,
  Tle as PromoCode,
  F4 as PromoCodeRow,
  my as PsychTrigger,
  T9 as RoomDetailsAccordion,
  ule as RoomsListItem,
  UU as SeparateBillingAddress,
  vle as ServerError,
  yy as ShowMoreResults,
  Qr as SortBy,
  lt as SpaType,
  sy as SubTotalRow,
  id as SummarySectionContainer,
  K$ as TULUM_ERROR_CODES,
  Sm as ThreeDomainSecureIframe,
  Tu as ToggleOptions,
  ale as TravelInsuranceBillingRow,
  rle as TravelInsurancePriceRow,
  jY as TravelProtection,
  Dle as TravelProtectionNudge,
  iie as TravellerForm,
  oy as TravellerSummary,
  Aie as TravellersSummary,
  Gp as USER_GROUP,
  G$ as US_STATES,
  GU as UpliftPaymentErrors,
  mr as UpliftWarningMessage,
  Ple as VACVMap,
  Z$ as VACV_COUNTRIES,
  fM as VacvAeSignInModal,
  ul as VacvButton,
  Pr as VacvCounterSelector,
  pie as VacvCubaPopup,
  Qt as VacvCustomModal,
  _1 as VacvDataInput,
  $p as VacvDropDown,
  Wle as VacvFormkitConfig,
  Sre as VacvFormkitPlugin,
  die as VacvFormkitWrapper,
  yre as VacvGuestsInputField,
  ny as VacvHotelRating,
  Jp as VacvImageCarousel,
  l2 as VacvMobileOverlay,
  k1 as VacvOverlay,
  Tie as VacvPdpHeader,
  bh as VacvPromoBadge,
  bre as VacvTravellersTitle,
  ah as VacvTripAdvisor,
  QD as VacvVueJsAppWrapper,
  s_ as VacvWasPrice,
  d7 as WaitingScreen,
  Fp as YYYYMMDDtoDD_MM_YYYY,
  ID as YYYYMMDDtoMM_DD_YYYYWithSlashes,
  PD as addDays,
  BD as addFormAbandonEventListeners,
  Eh as addGenericClickAwayListener,
  sie as addSpaStaticsToHead,
  Ire as addVueJsAppWrapperToWindowObject,
  Vp as ancillarySort,
  ep as ancillaryTypeMap,
  cd as booleanCheck,
  th as cabinClassMapB2F,
  eh as cabinClassMapF2B,
  XO as cabinConverter,
  CO as calculateDaysBeforeDeparture,
  Are as calculateDurationInMinutes,
  wO as calculateNumberOfNights,
  KD as calculatePercentageDifference,
  vP as calculatePriceTotals,
  J$ as canadianPostalCodeRegex,
  Wre as checkAges,
  nk as checkCreditCardValidity,
  Vh as checkEmptyHPCIFields,
  dm as childAgeConverter,
  ND as convertStringToDate,
  Yg as convertToDate,
  Mi as convertToUTCDate,
  rie as createCheckoutValidators,
  Tl as createCommonData,
  kl as createContinueBookingItem,
  Bh as createHPCICCError,
  Mb as createID,
  EO as createPurchaseItem,
  ss as createViewItem,
  Z2 as customHPCICCTypingValidation,
  X2 as customHPCICCValidation,
  J2 as customHPCICVVTypingValidation,
  Q2 as customHPCICVVValidation,
  j$ as dataLayerCabinClassMap,
  nh as dateTimeFormats,
  Li as daysDiffInDates,
  qg as daysUntil,
  pm as depDateConverter,
  fm as destConverter,
  Tre as destinationHasMultipleAirports,
  yi as didClickAway,
  wp as exceptionHandler,
  Un as extractAmountFromCurrency,
  Wi as extractBillingAddressFromForm,
  eb as extractPriceRange,
  _p as fetchWrapper,
  Jn as fetcher,
  l1 as findFieldLabel,
  Wg as flexibleDatesFiltered,
  tu as formValidations,
  Fh as formatAmountNumber,
  Se as formatCurrency,
  Kg as formatDate,
  ap as formatDecimal,
  sh as formatNumber,
  Zg as formatObjToISO,
  xf as formatStrToISO,
  Of as formatTime,
  ED as formatTimeDateShort,
  ZO as getAeroplanRedeemURL,
  LO as getAffiliateName,
  LD as getAge,
  GD as getAmenitiesNamesMap,
  Lf as getAmenitiesOptions,
  Vb as getAudience,
  Sl as getBudgetProductLine,
  kD as getCCExpiryRange,
  Nre as getCreateBookingURL,
  MO as getCreditCardQuantity,
  It as getCurrentLanguage,
  V2 as getCurrentLocationPath,
  XD as getDealNamesMap,
  Mf as getDealsOptions,
  OD as getDepartingDateTime,
  Lb as getDepartureDate,
  fr as getDepartureDateFromRequest,
  wl as getDestinationAirport,
  DO as getDestinationCodeFromSearch,
  YD as getDestinationNamesMap,
  hu as getDestinationOptions,
  Fb as getEnglishCabinNames,
  Bre as getFlightCabinClass,
  Vre as getFlightType,
  GO as getHotelBookingUrlGET,
  UO as getHotelQuoteUrlPOST,
  WO as getHotelQuoteUrlPUT,
  BO as getHotelSearchUrl,
  u1 as getImageSizeUrls,
  $i as getImageUrlWithVariation,
  jg as getItineraryFromBookingResponse,
  R2 as getLanguageFromPath,
  ex as getMicroserviceParamsFromURL,
  c1 as getNiceFieldName,
  tie as getNonAdults,
  Ore as getNudgeTravelProtection,
  Zp as getOriginAirport,
  Hre as getOtherAvailableCabinNames,
  qO as getPackageBookingUrl,
  ml as getPackageFromBookingResponse,
  Lre as getPackageInsuranceUrlPOST,
  ble as getPackagePromoBadge,
  Mre as getPackageQuoteUrlGET,
  zO as getPackageQuoteUrlPOST,
  jO as getPackageQuoteUrlPUT,
  HO as getPackageSearchUrl,
  qre as getPassengersDob,
  nP as getPaxCount,
  Rb as getPaymentType,
  FO as getPriceDifference,
  RO as getPriceDifferentialMessage,
  Zre as getPricingPerAdult,
  Xre as getPricingPerNight,
  Cl as getProductType,
  IO as getProductTypeForResult,
  xb as getProductTypeSearchResults,
  BK as getPromoById,
  Hb as getPsychTriggerMessage,
  Ub as getRequestHeaders,
  xD as getReturnDateTime,
  PO as getReturnedCabinClassesAsCSV,
  KO as getSavePassengerURL,
  Qre as getSavingsPercentage,
  gre as getScreenHeight,
  i1 as getScreenWidth,
  tb as getSelectedAncillaries,
  Bb as getSignInStatus,
  oP as getSubOption,
  Ere as getSubOptionTitle,
  gl as getSubOptionWithDates,
  FD as getTravelDateFromBookingResponse,
  Dre as getTravelDateFromItinerary,
  MD as getTravelInterval,
  Bi as getTripDuration,
  YO as getUpdatePassengerURL,
  NO as getUserId,
  mm as getUtmSource,
  ZD as getVacationTypeNamesMap,
  Nf as getVacationTypeOptions,
  Jre as getWasPrice,
  to as handleAndLogException,
  jre as hasDOBChanged,
  UD as hashEmail,
  nie as hideSearchToolBar,
  Fre as hotelDestConverter,
  ok as hpciAddCard2,
  Xl as hpciDeleteCard2,
  vo as i18n,
  ek as init,
  ak as initCustomHPCIErrorHandler,
  Ts as intParser,
  nx as isInteger,
  cx as isLuhnValidRule,
  tf as isNumberBetween,
  Nh as isPostalCodeValidRule,
  zs as isSubOptionWithDates,
  rx as isValidHotelQuoteData,
  ax as isValidQuoteData,
  zg as isValidTripAdvisorRating,
  Ya as loadJSON,
  eP as loadPromoBadges,
  _re as logContextualException,
  Go as logError,
  wre as logMessage,
  ix as luhnValidation,
  Ci as microServiceErrorHandler,
  tX as monthBetween,
  Rp as multiPax,
  oh as numberFormat,
  zre as numberParser,
  eie as parseChildAges,
  Ss as parseDateTime,
  Kre as passengerIsModified,
  zb as paxAdultFilter,
  Yre as postPassengerData,
  iP as prepareAddOns,
  aP as prepareAirReservations,
  rP as prepareHotelReservations,
  sP as prepareTravelers,
  cP as prepareUpLiftPayment,
  xre as processAndSendOrderInfo,
  JD as processPassengers,
  mie as pushAddInsuranceInfoEvent,
  Iie as pushAeroplanBannerSelectionEvent,
  LH as pushAeroplanBookingSummaryPointsSelectionEvent,
  BH as pushAeroplanCancelLogin,
  HH as pushAeroplanCloseLogin,
  VH as pushAeroplanLogin,
  jie as pushAltCabinSearchResultsEvent,
  qie as pushAltDateSearchResultsEvent,
  Eie as pushAncillaryContinueBookingEvents,
  Gie as pushAncillaryNudgeEvent,
  zH as pushAncillaryOptionsEvent,
  ly as pushAncillaryProductEvent,
  WH as pushAncillarySubOptionsEvent,
  u8 as pushBackToTopEvent,
  qH as pushCheckoutEngDocsEvent,
  s8 as pushCheckoutPaymentMethodEvent,
  o8 as pushCheckoutPaymentToggleEvent,
  jH as pushCheckoutPromoCodeEvent,
  RH as pushConfirmationAeroplanAddNumberJoinEvent,
  FH as pushConfirmationAeroplanJoinEvent,
  Au as pushConfirmationPageEvent,
  xie as pushConfirmationPageEvents,
  Lh as pushErrorEvent,
  Mie as pushFlightContinueBookingEvents,
  QH as pushFlightFilterEvent,
  Lie as pushFlightSelectEvent,
  Kie as pushNoSearchResultsEvent,
  Bie as pushPDPEvents,
  Jb as pushPDPMapsEvent,
  wR as pushPDPRoomNavEvent,
  Cc as pushPDPRoomTileLinksEvent,
  _R as pushPDPSelectEvent,
  d8 as pushPLPSelectHotelEvent,
  Uie as pushPLPSortingEvent,
  Vt as pushPLPTilesEvent,
  Nie as pushPassengerFormAbandonedEvent,
  e8 as pushPassengerFormAbandonedMap,
  Rie as pushPassengerInfoEvent,
  Oie as pushPassengerUpdateInfoEvent,
  RD as pushPaymentFormAbandonmentEvent,
  n8 as pushPaymentInfoEvent,
  Vie as pushPdpContinueBookingEvents,
  jF as pushPlpFiltersEvent,
  S2 as pushPromoBadgeEvent,
  Wie as pushSearchResultsEvent,
  Gb as pushSelectInsurancePlanEvent,
  Hie as pushShowMoreButtonEvent,
  VO as pushVPVEvent,
  Yie as pushVPVShowMoreResultsEvent,
  zie as pushViewItemsEvent,
  Gre as putPassengerData,
  Ure as reSelectPreviouslySelectedInsuranceProduct,
  HD as removeFormAbandonEventListeners,
  Oh as removeGenericClickAwayListener,
  Rre as reorderItineraries,
  p1 as replaceFocalArea,
  sk as resetHPCIFrameData,
  gle as resetPromos,
  um as retDateConverter,
  Ih as scrollToTop,
  et as setData,
  G2 as setHpciCards,
  kre as setI18nFormat,
  Hp as shouldRedirectStatus,
  oie as showSearchToolBar,
  zD as standardizeEmail,
  tP as stripPrivateTransferFromAncillaries,
  sn as toDate,
  Ma as toYearMonthDay,
  Fie as trackPaxForm,
  aie as updateReactivePackageQuote,
  ob as upliftPayment,
  Q$ as usPostalCodeRegex,
  D7 as use3DS,
  Io as useAPI,
  by as useAeroplanDropdown,
  ld as useAeroplanPoints,
  Ile as useAeroplanRedeemAPI,
  un as useAeroplanStore,
  Lle as useAlternativeCabinAlertMessage,
  Do as useAncillaryStore,
  y7 as useCheckoutAPI,
  Tt as useCheckoutStore,
  Nle as useCreditCard3DSFailures,
  Qp as useDebounceResize,
  NN as useDeviceSize,
  Fle as useFlightsFilter,
  Rle as useGlobalHTMLElementRef,
  Hh as useHPCI,
  nb as useHotelAndRoomStore,
  Mle as useHotelBookingAPI,
  On as useInsuranceStore,
  Zb as useIsDesktop,
  Vle as useIsGuest,
  ab as useMessageStore,
  aa as useOnIntersectionObserver,
  Hle as useOnOpenModal,
  Ble as useOnScroll,
  xle as usePDPSearchAPI,
  Ole as usePLPSearchAPI,
  Sle as usePOSTHotelQuoteAPI,
  kle as usePOSTPackageQuoteAPI,
  qK as usePUTHotelQuoteAPI,
  jK as usePUTPackageQuoteAPI,
  Ele as usePackageBookingAPI,
  _le as usePackageIdStore,
  wle as usePassengersStore,
  yle as usePaymentStepsStore,
  so as usePlpFilterStore,
  $le as usePlpStore,
  lH as usePopOverPlacement,
  hle as usePromosStore,
  Ule as usePushVPVEvent,
  zle as useRedirect,
  w2 as useShowHideStore,
  Xb as useUXStore,
  Co as useUpliftStore,
  jD as validActivities,
  Pre as validFacilities,
  WD as validFoodAndDrink,
  qD as validOtherFacilityAndServices,
  vm as validateForm
};
//# sourceMappingURL=vacv-components.es.js.map
